[
  {
    "ID":1,
    "nom_corrige2":"Valérie Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Mairesse",
    "remuneration":"132841",
    "allocation":"19265",
    "remuneration2":"69193",
    "allocation2":"0",
    "total":"221299",
    "ville":"Montréal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":2,
    "nom_corrige2":"Catherine Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Mairesse",
    "remuneration":"118817",
    "allocation":"19422",
    "remuneration2":"72186",
    "allocation2":"0",
    "total":"210425",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":3,
    "nom_corrige2":"Stéphane Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Maire",
    "remuneration":"126976",
    "allocation":"19422",
    "remuneration2":"63862",
    "allocation2":"0",
    "total":"210260",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":4,
    "nom_corrige2":"Michel Angers",
    "nom_famille":"Angers",
    "titre_genre2":"Maire",
    "remuneration":"127740",
    "allocation":"19399",
    "remuneration2":"62178",
    "allocation2":"0",
    "total":"209317",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":5,
    "nom_corrige2":"Sylvain Joly",
    "nom_famille":"Joly",
    "titre_genre2":"Conseiller",
    "remuneration":"171302",
    "allocation":"19422",
    "remuneration2":"16225",
    "allocation2":"0",
    "total":"206949",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":6,
    "nom_corrige2":"Luc Rabouin",
    "nom_famille":"Rabouin",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"150586",
    "allocation":"19265",
    "remuneration2":"35000",
    "allocation2":"0",
    "total":"204851",
    "ville":"Montréal",
    "arrondissement":"Plateau-Mont-Royal",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":7,
    "nom_corrige2":"Doreen Assaad",
    "nom_famille":"Assaad",
    "titre_genre2":"Mairesse",
    "remuneration":"114172",
    "allocation":"19422",
    "remuneration2":"70808",
    "allocation2":"0",
    "total":"204402",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":8,
    "nom_corrige2":"Benoit Dorais",
    "nom_famille":"Dorais",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"177486",
    "allocation":"19265",
    "remuneration2":"4000",
    "allocation2":"0",
    "total":"200751",
    "ville":"Montréal",
    "arrondissement":"Sud-Ouest",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":9,
    "nom_corrige2":"Évelyne Beaudin",
    "nom_famille":"Beaudin",
    "titre_genre2":"Mairesse",
    "remuneration":"180918",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"200340",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":10,
    "nom_corrige2":"Jonathan Tabarah",
    "nom_famille":"Tabarah",
    "titre_genre2":"Conseiller",
    "remuneration":"180775",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"200197",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":11,
    "nom_corrige2":"Bruno Marchand",
    "nom_famille":"Marchand",
    "titre_genre2":"Maire",
    "remuneration":"180571",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"199993",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":12,
    "nom_corrige2":"Pierre Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Maire",
    "remuneration":"112047",
    "allocation":"19525",
    "remuneration2":"62169",
    "allocation2":"0",
    "total":"193741",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":13,
    "nom_corrige2":"Caroline Bourgeois",
    "nom_famille":"Bourgeois",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"173855",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"193120",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":14,
    "nom_corrige2":"Gilles Lehouillier",
    "nom_famille":"Lehouillier",
    "titre_genre2":"Maire",
    "remuneration":"171962",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"191384",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":15,
    "nom_corrige2":"Éric Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Maire",
    "remuneration":"127768",
    "allocation":"19855",
    "remuneration2":"42133",
    "allocation2":"0",
    "total":"189756",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":16,
    "nom_corrige2":"François Limoges",
    "nom_famille":"Limoges",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"158224",
    "allocation":"19265",
    "remuneration2":"10366",
    "allocation2":"0",
    "total":"187855",
    "ville":"Montréal",
    "arrondissement":"Rosemont-La Petite-Patrie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":17,
    "nom_corrige2":"Mathieu Traversy",
    "nom_famille":"Traversy",
    "titre_genre2":"Maire",
    "remuneration":"126780",
    "allocation":"18207",
    "remuneration2":"41632",
    "allocation2":"0",
    "total":"186619",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":18,
    "nom_corrige2":"Julie Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Mairesse",
    "remuneration":"166630",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"186049",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":19,
    "nom_corrige2":"Émilie Thuillier",
    "nom_famille":"Thuillier",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"166436",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"185701",
    "ville":"Montréal",
    "arrondissement":"Ahuntsic-Cartierville",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":20,
    "nom_corrige2":"Liza Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Mairesse",
    "remuneration":"109260",
    "allocation":"19321",
    "remuneration2":"54747",
    "allocation2":"2354",
    "total":"185682",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":21,
    "nom_corrige2":"Jean Lamarche",
    "nom_famille":"Lamarche",
    "titre_genre2":"Maire",
    "remuneration":"165941",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"185363",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":22,
    "nom_corrige2":"Martin Damphousse",
    "nom_famille":"Damphousse",
    "titre_genre2":"Maire",
    "remuneration":"105649",
    "allocation":"19394",
    "remuneration2":"56572",
    "allocation2":"0",
    "total":"181615",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":23,
    "nom_corrige2":"Mario Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Maire",
    "remuneration":"102387",
    "allocation":"19422",
    "remuneration2":"58854",
    "allocation2":"0",
    "total":"180663",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":24,
    "nom_corrige2":"Guillaume Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Maire",
    "remuneration":"98091",
    "allocation":"19422",
    "remuneration2":"63066",
    "allocation2":"0",
    "total":"180579",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":25,
    "nom_corrige2":"Jean Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Maire",
    "remuneration":"122581",
    "allocation":"19422",
    "remuneration2":"35597",
    "allocation2":"0",
    "total":"177600",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":26,
    "nom_corrige2":"Denis Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Maire",
    "remuneration":"90202",
    "allocation":"19339",
    "remuneration2":"64478",
    "allocation2":"0",
    "total":"174019",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":27,
    "nom_corrige2":"Gracia Kasoki Katahwa",
    "nom_famille":"Kasoki Katahwa",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"146278",
    "allocation":"19265",
    "remuneration2":"6205",
    "allocation2":"0",
    "total":"171748",
    "ville":"Montréal",
    "arrondissement":"Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":28,
    "nom_corrige2":"Julie Bourdon",
    "nom_famille":"Bourdon",
    "titre_genre2":"Mairesse",
    "remuneration":"125858",
    "allocation":"19395",
    "remuneration2":"26139",
    "allocation2":"0",
    "total":"171392",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":29,
    "nom_corrige2":"Laurence Lavigne Lalonde",
    "nom_famille":"Lavigne Lalonde",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"148025",
    "allocation":"19265",
    "remuneration2":"3374",
    "allocation2":"0",
    "total":"170664",
    "ville":"Montréal",
    "arrondissement":"Villeray - Saint-Michel - Parc-Extension",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":30,
    "nom_corrige2":"Sylvain Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"87087",
    "allocation":"19265",
    "remuneration2":"63943",
    "allocation2":"0",
    "total":"170295",
    "ville":"Montréal",
    "arrondissement":"Villeray - Saint-Michel - Parc-Extension",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":31,
    "nom_corrige2":"Stéphanie Lacoste",
    "nom_famille":"Lacoste",
    "titre_genre2":"Mairesse",
    "remuneration":"134355",
    "allocation":"19422",
    "remuneration2":"16248",
    "allocation2":"0",
    "total":"170025",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":32,
    "nom_corrige2":"Andrée Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Mairesse",
    "remuneration":"131055",
    "allocation":"19422",
    "remuneration2":"19487",
    "allocation2":"0",
    "total":"169964",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":33,
    "nom_corrige2":"Éric Westram",
    "nom_famille":"Westram",
    "titre_genre2":"Maire",
    "remuneration":"74031",
    "allocation":"19422",
    "remuneration2":"76129",
    "allocation2":"0",
    "total":"169582",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":34,
    "nom_corrige2":"Nathalie Delisle",
    "nom_famille":"Delisle",
    "titre_genre2":"Conseillère",
    "remuneration":"125796",
    "allocation":"19422",
    "remuneration2":"23975",
    "allocation2":"0",
    "total":"169193",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":35,
    "nom_corrige2":"Maja Vodanovic",
    "nom_famille":"Vodanovic",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"147758",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"167023",
    "ville":"Montréal",
    "arrondissement":"Lachine",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":36,
    "nom_corrige2":"Christine Beaudette",
    "nom_famille":"Beaudette",
    "titre_genre2":"Mairesse",
    "remuneration":"119260",
    "allocation":"19373",
    "remuneration2":"27814",
    "allocation2":"0",
    "total":"166447",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":37,
    "nom_corrige2":"Affine Lwalalika",
    "nom_famille":"Lwalalika",
    "titre_genre2":"Conseillère",
    "remuneration":"128057",
    "allocation":"19422",
    "remuneration2":"18650",
    "allocation2":"0",
    "total":"166129",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":38,
    "nom_corrige2":"Marie-Andrée Mauger",
    "nom_famille":"Mauger",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"143625",
    "allocation":"19265",
    "remuneration2":"2500",
    "allocation2":"0",
    "total":"165390",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":39,
    "nom_corrige2":"Robert Beaudry",
    "nom_famille":"Beaudry",
    "titre_genre2":"Conseiller",
    "remuneration":"141933",
    "allocation":"19265",
    "remuneration2":"3000",
    "allocation2":"0",
    "total":"164198",
    "ville":"Montréal",
    "arrondissement":"Ville-Marie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":40,
    "nom_corrige2":"Céline Brindamour",
    "nom_famille":"Brindamour",
    "titre_genre2":"Mairesse",
    "remuneration":"122031",
    "allocation":"19422",
    "remuneration2":"21312",
    "allocation2":"0",
    "total":"162765",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":41,
    "nom_corrige2":"Alvaro Cueto",
    "nom_famille":"Cueto",
    "titre_genre2":"Conseiller",
    "remuneration":"143275",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"162697",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":42,
    "nom_corrige2":"Magda Popeanu",
    "nom_famille":"Popeanu",
    "titre_genre2":"Conseillère",
    "remuneration":"143078",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"162343",
    "ville":"Montréal",
    "arrondissement":"Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":43,
    "nom_corrige2":"Nicolas Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Maire",
    "remuneration":"115460",
    "allocation":"19422",
    "remuneration2":"26500",
    "allocation2":"0",
    "total":"161382",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":44,
    "nom_corrige2":"Pierre Lessard-Blais",
    "nom_famille":"Lessard-Blais",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"139596",
    "allocation":"19265",
    "remuneration2":"2507",
    "allocation2":"0",
    "total":"161368",
    "ville":"Montréal",
    "arrondissement":"Mercier - Hochelaga-Maisonneuve",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":45,
    "nom_corrige2":"Marc Bourcier",
    "nom_famille":"Bourcier",
    "titre_genre2":"Maire",
    "remuneration":"142085",
    "allocation":"19235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"161320",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":46,
    "nom_corrige2":"Sophie Mauzerolle",
    "nom_famille":"Mauzerolle",
    "titre_genre2":"Conseillère",
    "remuneration":"138741",
    "allocation":"19265",
    "remuneration2":"3000",
    "allocation2":"0",
    "total":"161006",
    "ville":"Montréal",
    "arrondissement":"Ville-Marie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":47,
    "nom_corrige2":"Sylvain Juneau",
    "nom_famille":"Juneau",
    "titre_genre2":"Maire",
    "remuneration":"129578",
    "allocation":"19422",
    "remuneration2":"10174",
    "allocation2":"0",
    "total":"159174",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":48,
    "nom_corrige2":"Marjolaine Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseillère",
    "remuneration":"130597",
    "allocation":"19422",
    "remuneration2":"8500",
    "allocation2":"0",
    "total":"158519",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":49,
    "nom_corrige2":"Pierre Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Maire",
    "remuneration":"70374",
    "allocation":"19692",
    "remuneration2":"67354",
    "allocation2":"0",
    "total":"157420",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":50,
    "nom_corrige2":"Alex Bottausci",
    "nom_famille":"Bottausci",
    "titre_genre2":"Maire",
    "remuneration":"97191",
    "allocation":"20122",
    "remuneration2":"39959",
    "allocation2":"0",
    "total":"157272",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":51,
    "nom_corrige2":"Guy Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Maire",
    "remuneration":"134243",
    "allocation":"19342",
    "remuneration2":"3421",
    "allocation2":"0",
    "total":"157006",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":52,
    "nom_corrige2":"Marie-Josée Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseillère",
    "remuneration":"136599",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"156021",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":53,
    "nom_corrige2":"Pierre-Luc Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"136599",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"156021",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":54,
    "nom_corrige2":"Lise Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Mairesse",
    "remuneration":"58693",
    "allocation":"19372",
    "remuneration2":"77746",
    "allocation2":"0",
    "total":"155811",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":55,
    "nom_corrige2":"Éric Alan Caldwell",
    "nom_famille":"Alan Caldwell",
    "titre_genre2":"Conseiller",
    "remuneration":"79459",
    "allocation":"19265",
    "remuneration2":"56266",
    "allocation2":"0",
    "total":"154990",
    "ville":"Montréal",
    "arrondissement":"Mercier - Hochelaga-Maisonneuve",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":56,
    "nom_corrige2":"Christian Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Maire",
    "remuneration":"83331",
    "allocation":"19422",
    "remuneration2":"51819",
    "allocation2":"0",
    "total":"154572",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":57,
    "nom_corrige2":"Alain Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"134410",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"153675",
    "ville":"Montréal",
    "arrondissement":"Sud-Ouest",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":58,
    "nom_corrige2":"Alan DeSousa",
    "nom_famille":"DeSousa",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"106665",
    "allocation":"19265",
    "remuneration2":"27543",
    "allocation2":"0",
    "total":"153473",
    "ville":"Montréal",
    "arrondissement":"Saint-Laurent",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":59,
    "nom_corrige2":"Gaétan Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Maire",
    "remuneration":"73000",
    "allocation":"19422",
    "remuneration2":"60156",
    "allocation2":"0",
    "total":"152578",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":60,
    "nom_corrige2":"Normand Dyotte",
    "nom_famille":"Dyotte",
    "titre_genre2":"Maire",
    "remuneration":"100276",
    "allocation":"19422",
    "remuneration2":"31735",
    "allocation2":"0",
    "total":"151433",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":61,
    "nom_corrige2":"Denis Miousse",
    "nom_famille":"Miousse",
    "titre_genre2":"Maire",
    "remuneration":"113229",
    "allocation":"19572",
    "remuneration2":"18503",
    "allocation2":"0",
    "total":"151304",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":62,
    "nom_corrige2":"Frédéric Broué",
    "nom_famille":"Broué",
    "titre_genre2":"Maire",
    "remuneration":"104834",
    "allocation":"19395",
    "remuneration2":"26651",
    "allocation2":"0",
    "total":"150880",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":63,
    "nom_corrige2":"Christian Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Maire",
    "remuneration":"98496",
    "allocation":"19422",
    "remuneration2":"31616",
    "allocation2":"0",
    "total":"149534",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":64,
    "nom_corrige2":"Paul Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Maire",
    "remuneration":"104647",
    "allocation":"19375",
    "remuneration2":"24161",
    "allocation2":"0",
    "total":"148183",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":65,
    "nom_corrige2":"Martine Musau Muele",
    "nom_famille":"Musau Muele",
    "titre_genre2":"Conseillère",
    "remuneration":"128493",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"147758",
    "ville":"Montréal",
    "arrondissement":"Villeray - Saint-Michel - Parc-Extension",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":66,
    "nom_corrige2":"Luc Brisebois",
    "nom_famille":"Brisebois",
    "titre_genre2":"Maire",
    "remuneration":"118318",
    "allocation":"19422",
    "remuneration2":"8548",
    "allocation2":"0",
    "total":"146288",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":67,
    "nom_corrige2":"Ray Khalil",
    "nom_famille":"Khalil",
    "titre_genre2":"Maire suppléant",
    "remuneration":"125760",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"145182",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":68,
    "nom_corrige2":"Daniel Bourdon",
    "nom_famille":"Bourdon",
    "titre_genre2":"Maire",
    "remuneration":"78342",
    "allocation":"19422",
    "remuneration2":"47052",
    "allocation2":"0",
    "total":"144816",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":69,
    "nom_corrige2":"Alexandra Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Mairesse",
    "remuneration":"89906",
    "allocation":"19422",
    "remuneration2":"35317",
    "allocation2":"0",
    "total":"144645",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":70,
    "nom_corrige2":"Nathalie Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Mairesse",
    "remuneration":"107156",
    "allocation":"19595",
    "remuneration2":"17888",
    "allocation2":"0",
    "total":"144639",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":71,
    "nom_corrige2":"Diane Dallaire",
    "nom_famille":"Dallaire",
    "titre_genre2":"Mairesse",
    "remuneration":"124363",
    "allocation":"19520",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"143883",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":72,
    "nom_corrige2":"Dimitrios (jim) Beis",
    "nom_famille":"Beis",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"124524",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"143789",
    "ville":"Montréal",
    "arrondissement":"Pierrefonds-Roxboro",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":73,
    "nom_corrige2":"Ericka Alneus",
    "nom_famille":"Alneus",
    "titre_genre2":"Conseillère",
    "remuneration":"120962",
    "allocation":"19265",
    "remuneration2":"3500",
    "allocation2":"0",
    "total":"143727",
    "ville":"Montréal",
    "arrondissement":"Rosemont-La Petite-Patrie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":74,
    "nom_corrige2":"Antoine Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Maire",
    "remuneration":"118204",
    "allocation":"18600",
    "remuneration2":"6788",
    "allocation2":"0",
    "total":"143592",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":75,
    "nom_corrige2":"Jacques Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Conseiller",
    "remuneration":"123967",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"143389",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":76,
    "nom_corrige2":"Sébastien D'Astous",
    "nom_famille":"D'Astous",
    "titre_genre2":"Maire",
    "remuneration":"95358",
    "allocation":"19352",
    "remuneration2":"28307",
    "allocation2":"0",
    "total":"143017",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":77,
    "nom_corrige2":"Julie Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Mairesse",
    "remuneration":"80358",
    "allocation":"19422",
    "remuneration2":"42564",
    "allocation2":"0",
    "total":"142344",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":78,
    "nom_corrige2":"Aref Salem",
    "nom_famille":"Salem",
    "titre_genre2":"Conseiller",
    "remuneration":"122048",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"141313",
    "ville":"Montréal",
    "arrondissement":"Saint-Laurent",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":79,
    "nom_corrige2":"Pierre-Luc Bellerose",
    "nom_famille":"Bellerose",
    "titre_genre2":"Maire",
    "remuneration":"73436",
    "allocation":"19422",
    "remuneration2":"48403",
    "allocation2":"0",
    "total":"141261",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":80,
    "nom_corrige2":"Josefina Blanco",
    "nom_famille":"Blanco",
    "titre_genre2":"Conseillère",
    "remuneration":"121723",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"140988",
    "ville":"Montréal",
    "arrondissement":"Rosemont-La Petite-Patrie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":81,
    "nom_corrige2":"VickI Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Conseiller",
    "remuneration":"120649",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"139914",
    "ville":"Montréal",
    "arrondissement":"Lachine",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":82,
    "nom_corrige2":"Marie Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseillère",
    "remuneration":"99550",
    "allocation":"19265",
    "remuneration2":"21000",
    "allocation2":"0",
    "total":"139815",
    "ville":"Montréal",
    "arrondissement":"Plateau-Mont-Royal",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":83,
    "nom_corrige2":"Sylvie Beaumont",
    "nom_famille":"Beaumont",
    "titre_genre2":"Mairesse",
    "remuneration":"108830",
    "allocation":"19422",
    "remuneration2":"11529",
    "allocation2":"0",
    "total":"139781",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":84,
    "nom_corrige2":"Alex Norris",
    "nom_famille":"Norris",
    "titre_genre2":"Conseiller",
    "remuneration":"116697",
    "allocation":"19265",
    "remuneration2":"3500",
    "allocation2":"0",
    "total":"139462",
    "ville":"Montréal",
    "arrondissement":"Plateau-Mont-Royal",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":85,
    "nom_corrige2":"Jocelyn Pauzé",
    "nom_famille":"Pauzé",
    "titre_genre2":"Conseiller",
    "remuneration":"109773",
    "allocation":"19265",
    "remuneration2":"10000",
    "allocation2":"0",
    "total":"139038",
    "ville":"Montréal",
    "arrondissement":"Rosemont-La Petite-Patrie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":86,
    "nom_corrige2":"Jocelyne Bates",
    "nom_famille":"Bates",
    "titre_genre2":"Mairesse",
    "remuneration":"110251",
    "allocation":"",
    "remuneration2":"28274",
    "allocation2":"0",
    "total":"138525",
    "ville":"Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17661"
  },
  {
    "ID":87,
    "nom_corrige2":"Patrick Péloquin",
    "nom_famille":"Péloquin",
    "titre_genre2":"Maire",
    "remuneration":"108429",
    "allocation":"19422",
    "remuneration2":"9921",
    "allocation2":"0",
    "total":"137772",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":88,
    "nom_corrige2":"André Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Maire",
    "remuneration":"108424",
    "allocation":"19422",
    "remuneration2":"9803",
    "allocation2":"0",
    "total":"137649",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":89,
    "nom_corrige2":"Alia Hassan-Cournol",
    "nom_famille":"Hassan-Cournol",
    "titre_genre2":"Conseillère",
    "remuneration":"118381",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"137646",
    "ville":"Montréal",
    "arrondissement":"Mercier - Hochelaga-Maisonneuve",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":90,
    "nom_corrige2":"Anne St-Laurent",
    "nom_famille":"St-Laurent",
    "titre_genre2":"Mairesse",
    "remuneration":"97886",
    "allocation":"19422",
    "remuneration2":"20257",
    "allocation2":"0",
    "total":"137565",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":91,
    "nom_corrige2":"Nathalie Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseillère",
    "remuneration":"99472",
    "allocation":"19265",
    "remuneration2":"18500",
    "allocation2":"0",
    "total":"137237",
    "ville":"Montréal",
    "arrondissement":"Ahuntsic-Cartierville",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":92,
    "nom_corrige2":"Jean-François Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":93,
    "nom_corrige2":"Catherine Vallières-Roland",
    "nom_famille":"Vallières-Roland",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":94,
    "nom_corrige2":"Steeve Verret",
    "nom_famille":"Verret",
    "titre_genre2":"Conseiller",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":95,
    "nom_corrige2":"David Weiser",
    "nom_famille":"Weiser",
    "titre_genre2":"Conseiller",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":96,
    "nom_corrige2":"Alicia Despins",
    "nom_famille":"Despins",
    "titre_genre2":"Conseillère",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":97,
    "nom_corrige2":"Bianca Dussault",
    "nom_famille":"Dussault",
    "titre_genre2":"Conseillère",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":98,
    "nom_corrige2":"Claude Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":99,
    "nom_corrige2":"Claude Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseiller",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":100,
    "nom_corrige2":"Marie-Pierre Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseillère",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":101,
    "nom_corrige2":"Maude Mercier Larouche",
    "nom_famille":"Mercier Larouche",
    "titre_genre2":"Conseillère",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":102,
    "nom_corrige2":"Mélissa Coulombe-Leduc",
    "nom_famille":"Coulombe-Leduc",
    "titre_genre2":"Conseillère",
    "remuneration":"117210",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136632",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":103,
    "nom_corrige2":"Isabelle Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"117092",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"136514",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":104,
    "nom_corrige2":"Stéphane Williams",
    "nom_famille":"Williams",
    "titre_genre2":"Maire",
    "remuneration":"88114",
    "allocation":"19422",
    "remuneration2":"28354",
    "allocation2":"0",
    "total":"135890",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":105,
    "nom_corrige2":"Jerôme Normand",
    "nom_famille":"Normand",
    "titre_genre2":"Conseiller",
    "remuneration":"97279",
    "allocation":"19265",
    "remuneration2":"17500",
    "allocation2":"0",
    "total":"134044",
    "ville":"Montréal",
    "arrondissement":"Ahuntsic-Cartierville",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":106,
    "nom_corrige2":"Daniel Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"114655",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"134007",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":107,
    "nom_corrige2":"Laurence Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseillère",
    "remuneration":"79422",
    "allocation":"19265",
    "remuneration2":"33822",
    "allocation2":"0",
    "total":"132509",
    "ville":"Montréal",
    "arrondissement":"Rosemont-La Petite-Patrie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":108,
    "nom_corrige2":"Dominique Ollivier",
    "nom_famille":"Ollivier",
    "titre_genre2":"Conseillère",
    "remuneration":"79107",
    "allocation":"19265",
    "remuneration2":"34000",
    "allocation2":"0",
    "total":"132372",
    "ville":"Montréal",
    "arrondissement":"Rosemont-La Petite-Patrie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":109,
    "nom_corrige2":"Nancy Blanchet",
    "nom_famille":"Blanchet",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"113044",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"132309",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":110,
    "nom_corrige2":"Guy Dumoulin",
    "nom_famille":"Dumoulin",
    "titre_genre2":"Conseiller",
    "remuneration":"112700",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"132122",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":111,
    "nom_corrige2":"Marc Doret",
    "nom_famille":"Doret",
    "titre_genre2":"Maire",
    "remuneration":"88015",
    "allocation":"19422",
    "remuneration2":"24617",
    "allocation2":"0",
    "total":"132054",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":112,
    "nom_corrige2":"Nadine Viau",
    "nom_famille":"Viau",
    "titre_genre2":"Mairesse",
    "remuneration":"89714",
    "allocation":"19422",
    "remuneration2":"22119",
    "allocation2":"109,00$",
    "total":"131364",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":113,
    "nom_corrige2":"Christina Smith",
    "nom_famille":"Smith",
    "titre_genre2":"Mairesse",
    "remuneration":"111428",
    "allocation":"19588",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"131016",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":114,
    "nom_corrige2":"Louis Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Maire",
    "remuneration":"98300",
    "allocation":"19422",
    "remuneration2":"12951",
    "allocation2":"0",
    "total":"130673",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":115,
    "nom_corrige2":"Michel Bissonnet",
    "nom_famille":"Bissonnet",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"111313",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"130578",
    "ville":"Montréal",
    "arrondissement":"Saint-Léonard",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":116,
    "nom_corrige2":"Frédéric Galantai",
    "nom_famille":"Galantai",
    "titre_genre2":"Maire",
    "remuneration":"75849",
    "allocation":"19422",
    "remuneration2":"23501",
    "allocation2":"11751",
    "total":"130523",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":117,
    "nom_corrige2":"Peter McQueen",
    "nom_famille":"McQueen",
    "titre_genre2":"Conseiller",
    "remuneration":"90801",
    "allocation":"19265",
    "remuneration2":"19000",
    "allocation2":"0",
    "total":"129066",
    "ville":"Montréal",
    "arrondissement":"Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":118,
    "nom_corrige2":"Aline Dib",
    "nom_famille":"Dib",
    "titre_genre2":"Conseillère",
    "remuneration":"87300",
    "allocation":"19422",
    "remuneration2":"21927",
    "allocation2":"0",
    "total":"128649",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":119,
    "nom_corrige2":"Sandra Desmeules",
    "nom_famille":"Desmeules",
    "titre_genre2":"Conseillère",
    "remuneration":"109079",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"128501",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":120,
    "nom_corrige2":"Christine Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"103619",
    "allocation":"19422",
    "remuneration2":"5000",
    "allocation2":"0",
    "total":"128041",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":121,
    "nom_corrige2":"Marilyn Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Mairesse",
    "remuneration":"27506",
    "allocation":"13753",
    "remuneration2":"63768",
    "allocation2":"22185",
    "total":"127212",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":122,
    "nom_corrige2":"Jean Comptois",
    "nom_famille":"Comptois",
    "titre_genre2":"Maire",
    "remuneration":"79022",
    "allocation":"19442",
    "remuneration2":"28324",
    "allocation2":"0",
    "total":"126788",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":123,
    "nom_corrige2":"Yannick Langlois",
    "nom_famille":"Langlois",
    "titre_genre2":"Conseiller",
    "remuneration":"100950",
    "allocation":"19422",
    "remuneration2":"5145",
    "allocation2":"0",
    "total":"125517",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":124,
    "nom_corrige2":"Christine Black",
    "nom_famille":"Black",
    "titre_genre2":"Mairesse d'arrondissement",
    "remuneration":"105925",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"125190",
    "ville":"Montréal",
    "arrondissement":"Montréal-Nord",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":125,
    "nom_corrige2":"Nicholas Borne",
    "nom_famille":"Borne",
    "titre_genre2":"Conseiller",
    "remuneration":"105509",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"124931",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":126,
    "nom_corrige2":"André Guy",
    "nom_famille":"Guy",
    "titre_genre2":"Maire",
    "remuneration":"89125",
    "allocation":"19422",
    "remuneration2":"15997",
    "allocation2":"0",
    "total":"124544",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":127,
    "nom_corrige2":"Claude Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire",
    "remuneration":"100979",
    "allocation":"19422",
    "remuneration2":"3562",
    "allocation2":"0",
    "total":"123963",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":128,
    "nom_corrige2":"Raymond Rougeau",
    "nom_famille":"Rougeau",
    "titre_genre2":"Maire",
    "remuneration":"85551",
    "allocation":"19375",
    "remuneration2":"18995",
    "allocation2":"0",
    "total":"123921",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":129,
    "nom_corrige2":"Patrick Melchior",
    "nom_famille":"Melchior",
    "titre_genre2":"Maire",
    "remuneration":"52678",
    "allocation":"19422",
    "remuneration2":"51143",
    "allocation2":"0",
    "total":"123243",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":130,
    "nom_corrige2":"Pierre Brabant",
    "nom_famille":"Brabant",
    "titre_genre2":"Conseiller",
    "remuneration":"83380",
    "allocation":"19422",
    "remuneration2":"20427",
    "allocation2":"0",
    "total":"123229",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":131,
    "nom_corrige2":"Marc-André Guertin",
    "nom_famille":"Guertin",
    "titre_genre2":"Maire",
    "remuneration":"79180",
    "allocation":"19398",
    "remuneration2":"24035",
    "allocation2":"0",
    "total":"122613",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":132,
    "nom_corrige2":"Timothy L. Thomas",
    "nom_famille":"L. Thomas",
    "titre_genre2":"Maire",
    "remuneration":"89492",
    "allocation":"19422",
    "remuneration2":"13369",
    "allocation2":"0",
    "total":"122283",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":133,
    "nom_corrige2":"Ludovic Grisé Farand",
    "nom_famille":"Grisé Farand",
    "titre_genre2":"Maire",
    "remuneration":"75268",
    "allocation":"19422",
    "remuneration2":"27537",
    "allocation2":"0",
    "total":"122227",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":134,
    "nom_corrige2":"Sylvie Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Mairesse",
    "remuneration":"72500",
    "allocation":"19422",
    "remuneration2":"29878",
    "allocation2":"0",
    "total":"121800",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":135,
    "nom_corrige2":"Marianne Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseillère",
    "remuneration":"98308",
    "allocation":"19265",
    "remuneration2":"3500",
    "allocation2":"0",
    "total":"121073",
    "ville":"Montréal",
    "arrondissement":"Plateau-Mont-Royal",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":136,
    "nom_corrige2":"Despina Sourias",
    "nom_famille":"Sourias",
    "titre_genre2":"Conseillère",
    "remuneration":"97708",
    "allocation":"19265",
    "remuneration2":"4000",
    "allocation2":"0",
    "total":"120973",
    "ville":"Montréal",
    "arrondissement":"Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":137,
    "nom_corrige2":"Marie-Claude Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"81928",
    "allocation":"19265",
    "remuneration2":"19648",
    "allocation2":"0",
    "total":"120841",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":138,
    "nom_corrige2":"Gaétan Pageau",
    "nom_famille":"Pageau",
    "titre_genre2":"Maire",
    "remuneration":"101334",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"120756",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":139,
    "nom_corrige2":"Jocelyne Frédéric-Gauthier",
    "nom_famille":"Frédéric-Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"56710",
    "allocation":"19422",
    "remuneration2":"44609",
    "allocation2":"0",
    "total":"120741",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":140,
    "nom_corrige2":"Geneviève Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Mairesse",
    "remuneration":"63090",
    "allocation":"18368",
    "remuneration2":"39098",
    "allocation2":"0",
    "total":"120556",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":141,
    "nom_corrige2":"Isabelle Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"100954",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"120376",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":142,
    "nom_corrige2":"Amélie Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseillère",
    "remuneration":"100954",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"120376",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":143,
    "nom_corrige2":"Serge Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"100954",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"120376",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":144,
    "nom_corrige2":"Brigitte Duchesneau",
    "nom_famille":"Duchesneau",
    "titre_genre2":"Conseillère",
    "remuneration":"100954",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"120376",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":145,
    "nom_corrige2":"Reine Bombo-Allara",
    "nom_famille":"Bombo-Allara",
    "titre_genre2":"Conseillère",
    "remuneration":"100572",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"119994",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":146,
    "nom_corrige2":"Michel Gibson",
    "nom_famille":"Gibson",
    "titre_genre2":"Maire",
    "remuneration":"72240",
    "allocation":"19422",
    "remuneration2":"27945",
    "allocation2":"0",
    "total":"119607",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":147,
    "nom_corrige2":"Luc Gibbons",
    "nom_famille":"Gibbons",
    "titre_genre2":"Maire",
    "remuneration":"93066",
    "allocation":"19571",
    "remuneration2":"6466",
    "allocation2":"0",
    "total":"119103",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":148,
    "nom_corrige2":"Bernard Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Maire",
    "remuneration":"26628",
    "allocation":"13314",
    "remuneration2":"72989",
    "allocation2":"6055",
    "total":"118986",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":149,
    "nom_corrige2":"Joé Deslauriers",
    "nom_famille":"Deslauriers",
    "titre_genre2":"Maire",
    "remuneration":"78381",
    "allocation":"19422",
    "remuneration2":"21034",
    "allocation2":"0",
    "total":"118837",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":150,
    "nom_corrige2":"Fernanda Luz",
    "nom_famille":"Luz",
    "titre_genre2":"Conseillère",
    "remuneration":"99015",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"118437",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":151,
    "nom_corrige2":"Daniel Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire",
    "remuneration":"98508",
    "allocation":"19468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"117976",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":152,
    "nom_corrige2":"Georges Bourelle",
    "nom_famille":"Bourelle",
    "titre_genre2":"Maire",
    "remuneration":"73807",
    "allocation":"18541",
    "remuneration2":"25505",
    "allocation2":"0",
    "total":"117853",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":153,
    "nom_corrige2":"Alexandre Warnet",
    "nom_famille":"Warnet",
    "titre_genre2":"Conseiller",
    "remuneration":"82890",
    "allocation":"19422",
    "remuneration2":"15000",
    "allocation2":"0",
    "total":"117312",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":154,
    "nom_corrige2":"Chantal Rossi",
    "nom_famille":"Rossi",
    "titre_genre2":"Conseillère",
    "remuneration":"97826",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"117091",
    "ville":"Montréal",
    "arrondissement":"Montréal-Nord",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":155,
    "nom_corrige2":"Sterling Downey",
    "nom_famille":"Downey",
    "titre_genre2":"Conseiller",
    "remuneration":"88144",
    "allocation":"19265",
    "remuneration2":"9660",
    "allocation2":"0",
    "total":"117069",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":156,
    "nom_corrige2":"Laurent Desbois",
    "nom_famille":"Desbois",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"97247",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"116512",
    "ville":"Montréal",
    "arrondissement":"Outremont",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":157,
    "nom_corrige2":"Mario Bastille",
    "nom_famille":"Bastille",
    "titre_genre2":"Maire",
    "remuneration":"83665",
    "allocation":"19422",
    "remuneration2":"12977",
    "allocation2":"0",
    "total":"116064",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":158,
    "nom_corrige2":"Louis Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"96180",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"115602",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":159,
    "nom_corrige2":"Lucie Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Mairesse",
    "remuneration":"84407",
    "allocation":"19422",
    "remuneration2":"7688",
    "allocation2":"3844",
    "total":"115361",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":160,
    "nom_corrige2":"Geneviève Héon",
    "nom_famille":"Héon",
    "titre_genre2":"Conseillère",
    "remuneration":"56634",
    "allocation":"19422",
    "remuneration2":"38900",
    "allocation2":"0",
    "total":"114956",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":161,
    "nom_corrige2":"Véronique Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"91183",
    "allocation":"19265",
    "remuneration2":"4500",
    "allocation2":"0",
    "total":"114948",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":162,
    "nom_corrige2":"Dominic Perri",
    "nom_famille":"Perri",
    "titre_genre2":"Conseiller",
    "remuneration":"95615",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"114880",
    "ville":"Montréal",
    "arrondissement":"Saint-Léonard",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":163,
    "nom_corrige2":"Lisa Christensen",
    "nom_famille":"Christensen",
    "titre_genre2":"Conseillère",
    "remuneration":"95397",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"114662",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":164,
    "nom_corrige2":"Sandra El-Helou",
    "nom_famille":"El-Helou",
    "titre_genre2":"Conseillère",
    "remuneration":"85200",
    "allocation":"19422",
    "remuneration2":"10000",
    "allocation2":"0",
    "total":"114622",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":165,
    "nom_corrige2":"Carl Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"94710",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"114132",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":166,
    "nom_corrige2":"Raïs Kibonge",
    "nom_famille":"Kibonge",
    "titre_genre2":"Maire suppléant",
    "remuneration":"94549",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"113971",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":167,
    "nom_corrige2":"Julie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"91183",
    "allocation":"19265",
    "remuneration2":"3500",
    "allocation2":"0",
    "total":"113948",
    "ville":"Montréal",
    "arrondissement":"Ahuntsic-Cartierville",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":168,
    "nom_corrige2":"Geneviève Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Mairesse",
    "remuneration":"74597",
    "allocation":"20169",
    "remuneration2":"19037",
    "allocation2":"0",
    "total":"113803",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":169,
    "nom_corrige2":"Pierre Guénard",
    "nom_famille":"Guénard",
    "titre_genre2":"Maire",
    "remuneration":"65421",
    "allocation":"19422",
    "remuneration2":"28944",
    "allocation2":"0",
    "total":"113787",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":170,
    "nom_corrige2":"Jacques Gariépy",
    "nom_famille":"Gariépy",
    "titre_genre2":"Maire",
    "remuneration":"79067",
    "allocation":"19422",
    "remuneration2":"14400",
    "allocation2":"0",
    "total":"112889",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":171,
    "nom_corrige2":"Lysa Bélaïcha",
    "nom_famille":"Bélaïcha",
    "titre_genre2":"Conseillère",
    "remuneration":"93052",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"112474",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":172,
    "nom_corrige2":"Yves Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Maire",
    "remuneration":"76071",
    "allocation":"18615",
    "remuneration2":"17589",
    "allocation2":"0",
    "total":"112275",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":173,
    "nom_corrige2":"Virginie Journeau",
    "nom_famille":"Journeau",
    "titre_genre2":"Conseillère",
    "remuneration":"90204",
    "allocation":"19265",
    "remuneration2":"2500",
    "allocation2":"0",
    "total":"111969",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":174,
    "nom_corrige2":"Serge Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Maire",
    "remuneration":"85729",
    "allocation":"19422",
    "remuneration2":"6466",
    "allocation2":"0",
    "total":"111617",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":175,
    "nom_corrige2":"Laure Letarte-Lavoie",
    "nom_famille":"Letarte-Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"76965",
    "allocation":"19422",
    "remuneration2":"14458",
    "allocation2":"0",
    "total":"110845",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":176,
    "nom_corrige2":"Scott Pearce",
    "nom_famille":"Pearce",
    "titre_genre2":"Maire",
    "remuneration":"36797",
    "allocation":"17601",
    "remuneration2":"55305",
    "allocation2":"1024",
    "total":"110727",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":177,
    "nom_corrige2":"Sébastien Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Maire",
    "remuneration":"48957",
    "allocation":"19422",
    "remuneration2":"41533",
    "allocation2":"0",
    "total":"109912",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":178,
    "nom_corrige2":"Martin Ferron",
    "nom_famille":"Ferron",
    "titre_genre2":"Maire",
    "remuneration":"84768",
    "allocation":"19422",
    "remuneration2":"5115",
    "allocation2":"0",
    "total":"109305",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":179,
    "nom_corrige2":"Richard Deschamps",
    "nom_famille":"Deschamps",
    "titre_genre2":"Conseiller",
    "remuneration":"75247",
    "allocation":"19265",
    "remuneration2":"14500",
    "allocation2":"0",
    "total":"109012",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":180,
    "nom_corrige2":"Abdelhaq Sari",
    "nom_famille":"Sari",
    "titre_genre2":"Conseiller",
    "remuneration":"89677",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"108942",
    "ville":"Montréal",
    "arrondissement":"Montréal-Nord",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":181,
    "nom_corrige2":"Benoit Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Conseiller",
    "remuneration":"88386",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"107651",
    "ville":"Montréal",
    "arrondissement":"Pierrefonds-Roxboro",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":182,
    "nom_corrige2":"Mitchell Brownstein",
    "nom_famille":"Brownstein",
    "titre_genre2":"Maire",
    "remuneration":"75044",
    "allocation":"19422",
    "remuneration2":"13041",
    "allocation2":"0",
    "total":"107507",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":183,
    "nom_corrige2":"Michèle Lalonde",
    "nom_famille":"Lalonde",
    "titre_genre2":"Mairesse",
    "remuneration":"73062",
    "allocation":"18580",
    "remuneration2":"15722",
    "allocation2":"0",
    "total":"107364",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":184,
    "nom_corrige2":"Steve Dorval",
    "nom_famille":"Dorval",
    "titre_genre2":"Conseiller",
    "remuneration":"38965",
    "allocation":"19422",
    "remuneration2":"48878",
    "allocation2":"0",
    "total":"107265",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":185,
    "nom_corrige2":"Danie Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Mairesse",
    "remuneration":"70738",
    "allocation":"19321",
    "remuneration2":"16983",
    "allocation2":"0",
    "total":"107042",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":186,
    "nom_corrige2":"Mary Deros",
    "nom_famille":"Deros",
    "titre_genre2":"Conseillère",
    "remuneration":"87543",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"106808",
    "ville":"Montréal",
    "arrondissement":"Villeray - Saint-Michel - Parc-Extension",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":187,
    "nom_corrige2":"Tiffany-Lee Norris Parent",
    "nom_famille":"Norris Parent",
    "titre_genre2":"Conseillère",
    "remuneration":"87390",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"106742",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":188,
    "nom_corrige2":"Michel Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Maire suppléant",
    "remuneration":"71517",
    "allocation":"19422",
    "remuneration2":"15606",
    "allocation2":"0",
    "total":"106545",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":189,
    "nom_corrige2":"Isabelle N. Miron",
    "nom_famille":"N. Miron",
    "titre_genre2":"Conseillère",
    "remuneration":"87122",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"106474",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":190,
    "nom_corrige2":"Luis Miranda",
    "nom_famille":"Miranda",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"87146",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"106411",
    "ville":"Montréal",
    "arrondissement":"Anjou",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":191,
    "nom_corrige2":"Jacques Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Maire",
    "remuneration":"47097",
    "allocation":"19422",
    "remuneration2":"39822",
    "allocation2":"0",
    "total":"106341",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":192,
    "nom_corrige2":"Pascale Mongrain",
    "nom_famille":"Mongrain",
    "titre_genre2":"Mairesse",
    "remuneration":"48883",
    "allocation":"19422",
    "remuneration2":"37795",
    "allocation2":"0",
    "total":"106100",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":193,
    "nom_corrige2":"Bernard Bigras-Denis",
    "nom_famille":"Bigras-Denis",
    "titre_genre2":"Maire",
    "remuneration":"62824",
    "allocation":"19422",
    "remuneration2":"23438",
    "allocation2":"0",
    "total":"105684",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":194,
    "nom_corrige2":"Maeva Vilain",
    "nom_famille":"Vilain",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"86279",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"105544",
    "ville":"Montréal",
    "arrondissement":"Plateau-Mont-Royal",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":195,
    "nom_corrige2":"Edmond Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"83574",
    "allocation":"19352",
    "remuneration2":"2550",
    "allocation2":"0",
    "total":"105476",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":196,
    "nom_corrige2":"Xavier-Antoine Lalande",
    "nom_famille":"Lalande",
    "titre_genre2":"Maire",
    "remuneration":"53460",
    "allocation":"19375",
    "remuneration2":"32523",
    "allocation2":"0",
    "total":"105358",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":197,
    "nom_corrige2":"Suzanne Dauphin",
    "nom_famille":"Dauphin",
    "titre_genre2":"Mairesse",
    "remuneration":"59205",
    "allocation":"19422",
    "remuneration2":"26443",
    "allocation2":"0",
    "total":"105070",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":198,
    "nom_corrige2":"Alain Dubuc",
    "nom_famille":"Dubuc",
    "titre_genre2":"Maire",
    "remuneration":"71702",
    "allocation":"19422",
    "remuneration2":"13374",
    "allocation2":"0",
    "total":"104498",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":199,
    "nom_corrige2":"Julien Hénault-Ratelle",
    "nom_famille":"Hénault-Ratelle",
    "titre_genre2":"Conseiller",
    "remuneration":"85009",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"104274",
    "ville":"Montréal",
    "arrondissement":"Mercier - Hochelaga-Maisonneuve",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":200,
    "nom_corrige2":"Audrey Boisjoly",
    "nom_famille":"Boisjoly",
    "titre_genre2":"Mairesse",
    "remuneration":"63181",
    "allocation":"19422",
    "remuneration2":"14324",
    "allocation2":"7162",
    "total":"104089",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":201,
    "nom_corrige2":"Vasilios Karidogiannis",
    "nom_famille":"Karidogiannis",
    "titre_genre2":"Conseiller",
    "remuneration":"57970",
    "allocation":"19422",
    "remuneration2":"26463",
    "allocation2":"0",
    "total":"103855",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":202,
    "nom_corrige2":"Marc-Antoine Azouz",
    "nom_famille":"Azouz",
    "titre_genre2":"Conseiller",
    "remuneration":"67961",
    "allocation":"19422",
    "remuneration2":"16325",
    "allocation2":"0",
    "total":"103708",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":203,
    "nom_corrige2":"Daphney Colin",
    "nom_famille":"Colin",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"84313",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"103578",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":204,
    "nom_corrige2":"Effie Giannou",
    "nom_famille":"Giannou",
    "titre_genre2":"Conseillère",
    "remuneration":"84192",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"103457",
    "ville":"Montréal",
    "arrondissement":"Ahuntsic-Cartierville",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":205,
    "nom_corrige2":"Joanie Bellerose",
    "nom_famille":"Bellerose",
    "titre_genre2":"Conseillère",
    "remuneration":"78077",
    "allocation":"19422",
    "remuneration2":"5828",
    "allocation2":"0",
    "total":"103327",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":206,
    "nom_corrige2":"Yvon Chiasson",
    "nom_famille":"Chiasson",
    "titre_genre2":"Maire",
    "remuneration":"65868",
    "allocation":"19422",
    "remuneration2":"17889",
    "allocation2":"0",
    "total":"103179",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":207,
    "nom_corrige2":"Mario Aubé",
    "nom_famille":"Aubé",
    "titre_genre2":"Conseiller",
    "remuneration":"82867",
    "allocation":"19352",
    "remuneration2":"800,00$",
    "allocation2":"0",
    "total":"103019",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":208,
    "nom_corrige2":"Stephanie Valenzuela",
    "nom_famille":"Valenzuela",
    "titre_genre2":"Conseillère",
    "remuneration":"83213",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"102478",
    "ville":"Montréal",
    "arrondissement":"Côte-des-Neiges–Notre-Dame-de-Grâce",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":209,
    "nom_corrige2":"Alba Zuniga Ramos",
    "nom_famille":"Zuniga Ramos",
    "titre_genre2":"Conseillère",
    "remuneration":"83123",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"102388",
    "ville":"Montréal",
    "arrondissement":"Mercier - Hochelaga-Maisonneuve",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":210,
    "nom_corrige2":"Cecilia Macedo",
    "nom_famille":"Macedo",
    "titre_genre2":"Conseillère",
    "remuneration":"82470",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"101892",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":211,
    "nom_corrige2":"Benoît Ladouceur",
    "nom_famille":"Ladouceur",
    "titre_genre2":"Conseiller",
    "remuneration":"44550",
    "allocation":"18207",
    "remuneration2":"38929",
    "allocation2":"0",
    "total":"101686",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":212,
    "nom_corrige2":"Anne-Marie Sigouin",
    "nom_famille":"Sigouin",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"82379",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"101644",
    "ville":"Montréal",
    "arrondissement":"Sud-Ouest",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":213,
    "nom_corrige2":"Manon Cyr",
    "nom_famille":"Cyr",
    "titre_genre2":"Mairesse",
    "remuneration":"81577",
    "allocation":"19398",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"100975",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":214,
    "nom_corrige2":"Jean-Pierre Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Maire",
    "remuneration":"53448",
    "allocation":"17757",
    "remuneration2":"29554",
    "allocation2":"208,00$",
    "total":"100967",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":215,
    "nom_corrige2":"Gilles Chagnon",
    "nom_famille":"Chagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"79578",
    "allocation":"19352",
    "remuneration2":"1600",
    "allocation2":"0",
    "total":"100530",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":216,
    "nom_corrige2":"Seta Topouzian",
    "nom_famille":"Topouzian",
    "titre_genre2":"Conseillère",
    "remuneration":"60910",
    "allocation":"19422",
    "remuneration2":"19927",
    "allocation2":"0",
    "total":"100259",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":217,
    "nom_corrige2":"Guy Lamothe",
    "nom_famille":"Lamothe",
    "titre_genre2":"Maire",
    "remuneration":"59065",
    "allocation":"19422",
    "remuneration2":"21576",
    "allocation2":"0",
    "total":"100063",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":218,
    "nom_corrige2":"Michel Jasmin",
    "nom_famille":"Jasmin",
    "titre_genre2":"Maire",
    "remuneration":"50556",
    "allocation":"19422",
    "remuneration2":"30023",
    "allocation2":"0",
    "total":"100001",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":219,
    "nom_corrige2":"Steve Moran",
    "nom_famille":"Moran",
    "titre_genre2":"Conseiller",
    "remuneration":"78888",
    "allocation":"19352",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"99740",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":220,
    "nom_corrige2":"Caroline Murray",
    "nom_famille":"Murray",
    "titre_genre2":"Conseillère",
    "remuneration":"78343",
    "allocation":"19352",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"99195",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":221,
    "nom_corrige2":"Douglas Hurley",
    "nom_famille":"Hurley",
    "titre_genre2":"Maire d'arrondissement",
    "remuneration":"79878",
    "allocation":"18966",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"98844",
    "ville":"Montréal",
    "arrondissement":"L'Île-Bizard–Sainte-Geneviève",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":222,
    "nom_corrige2":"Jean Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"75727",
    "allocation":"19352",
    "remuneration2":"3300",
    "allocation2":"0",
    "total":"98379",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":223,
    "nom_corrige2":"Mike Duggan",
    "nom_famille":"Duggan",
    "titre_genre2":"Conseiller",
    "remuneration":"78974",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"98326",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":224,
    "nom_corrige2":"Vana Nazarian",
    "nom_famille":"Nazarian",
    "titre_genre2":"Conseillère",
    "remuneration":"78783",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"98048",
    "ville":"Montréal",
    "arrondissement":"Saint-Laurent",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":225,
    "nom_corrige2":"Louis Sabourin",
    "nom_famille":"Sabourin",
    "titre_genre2":"Conseiller",
    "remuneration":"78423",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"97775",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":226,
    "nom_corrige2":"Anik Des Marais",
    "nom_famille":"Des Marais",
    "titre_genre2":"Conseillère",
    "remuneration":"78419",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"97771",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":227,
    "nom_corrige2":"Alicia Lacasse-Brunet",
    "nom_famille":"Lacasse-Brunet",
    "titre_genre2":"Conseillère",
    "remuneration":"78394",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"97746",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":228,
    "nom_corrige2":"Robert Bibeau",
    "nom_famille":"Bibeau",
    "titre_genre2":"Maire",
    "remuneration":"51859",
    "allocation":"19422",
    "remuneration2":"26362",
    "allocation2":"0",
    "total":"97643",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":229,
    "nom_corrige2":"Anne Corriveau",
    "nom_famille":"Corriveau",
    "titre_genre2":"Conseillère",
    "remuneration":"77935",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"97357",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":230,
    "nom_corrige2":"Lisette Maillé",
    "nom_famille":"Maillé",
    "titre_genre2":"Mairesse",
    "remuneration":"43883",
    "allocation":"19422",
    "remuneration2":"34038",
    "allocation2":"0",
    "total":"97343",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":231,
    "nom_corrige2":"Craig Sauvé",
    "nom_famille":"Sauvé",
    "titre_genre2":"Conseiller",
    "remuneration":"78005",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"97270",
    "ville":"Montréal",
    "arrondissement":"Sud-Ouest",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":232,
    "nom_corrige2":"Peter J. Malouf",
    "nom_famille":"J. Malouf",
    "titre_genre2":"Maire",
    "remuneration":"77499",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96921",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":233,
    "nom_corrige2":"Gilles Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Maire",
    "remuneration":"53105",
    "allocation":"19422",
    "remuneration2":"24314",
    "allocation2":"0",
    "total":"96841",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":234,
    "nom_corrige2":"Catherine Boileau",
    "nom_famille":"Boileau",
    "titre_genre2":"Conseillère",
    "remuneration":"66904",
    "allocation":"19422",
    "remuneration2":"10454",
    "allocation2":"0",
    "total":"96780",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":235,
    "nom_corrige2":"Stevens Mélançon",
    "nom_famille":"Mélançon",
    "titre_genre2":"Conseiller",
    "remuneration":"77161",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96583",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":236,
    "nom_corrige2":"Éric Ralph Mercier",
    "nom_famille":"Ralph Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"77007",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96429",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":237,
    "nom_corrige2":"Jackie Smith",
    "nom_famille":"Smith",
    "titre_genre2":"Conseillère",
    "remuneration":"77007",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96429",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":238,
    "nom_corrige2":"Patricia Boudreault-Bruyère",
    "nom_famille":"Boudreault-Bruyère",
    "titre_genre2":"Conseillère",
    "remuneration":"77007",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96429",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":239,
    "nom_corrige2":"Véronique Dallaire",
    "nom_famille":"Dallaire",
    "titre_genre2":"Conseillère",
    "remuneration":"77007",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96429",
    "ville":"Québec",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"594443"
  },
  {
    "ID":240,
    "nom_corrige2":"Benoit Gratton",
    "nom_famille":"Gratton",
    "titre_genre2":"Conseiller",
    "remuneration":"77103",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96368",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":241,
    "nom_corrige2":"Steven Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"77010",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96362",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":242,
    "nom_corrige2":"Marc Bureau",
    "nom_famille":"Bureau",
    "titre_genre2":"Conseiller",
    "remuneration":"76997",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"96349",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":243,
    "nom_corrige2":"Rolande Balma",
    "nom_famille":"Balma",
    "titre_genre2":"Conseillère",
    "remuneration":"61704",
    "allocation":"19422",
    "remuneration2":"14975",
    "allocation2":"0",
    "total":"96101",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":244,
    "nom_corrige2":"Francine Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Mairesse",
    "remuneration":"58146",
    "allocation":"19422",
    "remuneration2":"18390",
    "allocation2":"0",
    "total":"95958",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":245,
    "nom_corrige2":"Maude Marquis-Bissonnette",
    "nom_famille":"Marquis-Bissonnette",
    "titre_genre2":"Mairesse",
    "remuneration":"86662",
    "allocation":"9263",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"95925",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":246,
    "nom_corrige2":"Eddy Métivier",
    "nom_famille":"Métivier",
    "titre_genre2":"Maire",
    "remuneration":"72678",
    "allocation":"19446",
    "remuneration2":"3637",
    "allocation2":"0",
    "total":"95761",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":247,
    "nom_corrige2":"Sonny Moroz",
    "nom_famille":"Moroz",
    "titre_genre2":"Conseiller",
    "remuneration":"76282",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"95547",
    "ville":"Montréal",
    "arrondissement":"Côte-des-Neiges - Notre-Dame-de-Grâce",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":248,
    "nom_corrige2":"Giovanni Rapanà",
    "nom_famille":"Rapana",
    "titre_genre2":"Conseiller",
    "remuneration":"76221",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"95486",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies–Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":249,
    "nom_corrige2":"Josué Corvil",
    "nom_famille":"Corvil",
    "titre_genre2":"Conseiller",
    "remuneration":"76195",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"95460",
    "ville":"Montréal",
    "arrondissement":"Villeray - Saint-Michel - Parc-Extension",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":250,
    "nom_corrige2":"Pierre Lefrancois",
    "nom_famille":"Lefrancois",
    "titre_genre2":"Maire",
    "remuneration":"33000",
    "allocation":"16500",
    "remuneration2":"43016",
    "allocation2":"2922",
    "total":"95438",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":251,
    "nom_corrige2":"Andrée Hénault",
    "nom_famille":"Hénault",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"75825",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"95090",
    "ville":"Montréal",
    "arrondissement":"Anjou",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":252,
    "nom_corrige2":"Catherine Clément-Talbot",
    "nom_famille":"Clément-Talbot",
    "titre_genre2":"Conseillère",
    "remuneration":"75777",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"95042",
    "ville":"Montréal",
    "arrondissement":"Pierrefonds-Roxboro",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":253,
    "nom_corrige2":"Danielle Berthold",
    "nom_famille":"Berthold",
    "titre_genre2":"Conseillère",
    "remuneration":"75537",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"94959",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":254,
    "nom_corrige2":"Jocelyn Blondin",
    "nom_famille":"Blondin",
    "titre_genre2":"Conseiller",
    "remuneration":"67386",
    "allocation":"19352",
    "remuneration2":"8100",
    "allocation2":"0",
    "total":"94838",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":255,
    "nom_corrige2":"Luc Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Maire",
    "remuneration":"75406",
    "allocation":"19423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"94829",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":256,
    "nom_corrige2":"Michel Couturier",
    "nom_famille":"Couturier",
    "titre_genre2":"Maire",
    "remuneration":"60000",
    "allocation":"19422",
    "remuneration2":"15232",
    "allocation2":"0",
    "total":"94654",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":257,
    "nom_corrige2":"François Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Maire",
    "remuneration":"68945",
    "allocation":"19422",
    "remuneration2":"6272",
    "allocation2":"0",
    "total":"94639",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":258,
    "nom_corrige2":"Laura-Ann Palestini",
    "nom_famille":"Palestini",
    "titre_genre2":"Conseillère",
    "remuneration":"75221",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"94486",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":259,
    "nom_corrige2":"Ann Jeffrey",
    "nom_famille":"Jeffrey",
    "titre_genre2":"Conseillère",
    "remuneration":"74787",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"94209",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":260,
    "nom_corrige2":"Réjean Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Conseiller",
    "remuneration":"74787",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"94209",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":261,
    "nom_corrige2":"Michel Turner",
    "nom_famille":"Turner",
    "titre_genre2":"Conseiller",
    "remuneration":"74787",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"94209",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":262,
    "nom_corrige2":"Bettyna Belizaire",
    "nom_famille":"Belizaire",
    "titre_genre2":"Conseillère",
    "remuneration":"73805",
    "allocation":"19352",
    "remuneration2":"800,00$",
    "allocation2":"0",
    "total":"93957",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":263,
    "nom_corrige2":"Denis Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Maire",
    "remuneration":"14132",
    "allocation":"7066",
    "remuneration2":"59980",
    "allocation2":"12356",
    "total":"93534",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":264,
    "nom_corrige2":"Christelle Lefèvre",
    "nom_famille":"Lefèvre",
    "titre_genre2":"Conseillère",
    "remuneration":"66904",
    "allocation":"19422",
    "remuneration2":"7074",
    "allocation2":"0",
    "total":"93400",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":265,
    "nom_corrige2":"Kaila Amaya Munro",
    "nom_famille":"Amaya Munro",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"74083",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"93348",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":266,
    "nom_corrige2":"Serge Sasseville",
    "nom_famille":"Sasseville",
    "titre_genre2":"Conseiller",
    "remuneration":"73989",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"93254",
    "ville":"Montréal",
    "arrondissement":"Ville-Marie",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":267,
    "nom_corrige2":"Nathalie-Ann Pelchat",
    "nom_famille":"Pelchat",
    "titre_genre2":"Mairesse",
    "remuneration":"70802",
    "allocation":"19375",
    "remuneration2":"3069",
    "allocation2":"0",
    "total":"93246",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":268,
    "nom_corrige2":"Enrique Machado",
    "nom_famille":"Machado",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"73596",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"92861",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":269,
    "nom_corrige2":"Sylvie Gagnon-Breton",
    "nom_famille":"Gagnon-Breton",
    "titre_genre2":"Mairesse",
    "remuneration":"57750",
    "allocation":"19422",
    "remuneration2":"15251",
    "allocation2":"0",
    "total":"92423",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":270,
    "nom_corrige2":"Daniel Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Maire",
    "remuneration":"13729",
    "allocation":"6864",
    "remuneration2":"58875",
    "allocation2":"12819",
    "total":"92287",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":271,
    "nom_corrige2":"Flavia Alexandra Novac",
    "nom_famille":"Alexandra Novac",
    "titre_genre2":"Conseillère",
    "remuneration":"59230",
    "allocation":"19422",
    "remuneration2":"13382",
    "allocation2":"0",
    "total":"92034",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":272,
    "nom_corrige2":"Michael Pilote",
    "nom_famille":"Pilote",
    "titre_genre2":"Maire",
    "remuneration":"60990",
    "allocation":"19394",
    "remuneration2":"7582",
    "allocation2":"3791",
    "total":"91757",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":273,
    "nom_corrige2":"Robert Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"60198",
    "allocation":"18207",
    "remuneration2":"13012",
    "allocation2":"0",
    "total":"91417",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":274,
    "nom_corrige2":"François Robillard",
    "nom_famille":"Robillard",
    "titre_genre2":"Maire",
    "remuneration":"71495",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"90917",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":275,
    "nom_corrige2":"Geneviève Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseillère",
    "remuneration":"64661",
    "allocation":"19422",
    "remuneration2":"6428",
    "allocation2":"0",
    "total":"90511",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":276,
    "nom_corrige2":"Michèle Flannery",
    "nom_famille":"Flannery",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"71210",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"90475",
    "ville":"Montréal",
    "arrondissement":"Lachine",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":277,
    "nom_corrige2":"Claude Duplain",
    "nom_famille":"Duplain",
    "titre_genre2":"Maire",
    "remuneration":"61800",
    "allocation":"19422",
    "remuneration2":"6148",
    "allocation2":"3073",
    "total":"90443",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":278,
    "nom_corrige2":"Michel Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseiller",
    "remuneration":"69249",
    "allocation":"19419",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"90168",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":279,
    "nom_corrige2":"Patrick Marques",
    "nom_famille":"Marques",
    "titre_genre2":"Maire",
    "remuneration":"56830",
    "allocation":"19422",
    "remuneration2":"13735",
    "allocation2":"0",
    "total":"89987",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":280,
    "nom_corrige2":"Denis Girouard",
    "nom_famille":"Girouard",
    "titre_genre2":"Conseiller",
    "remuneration":"70591",
    "allocation":"19352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"89943",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":281,
    "nom_corrige2":"Angela Gentile",
    "nom_famille":"Gentile",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"70640",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"89905",
    "ville":"Montréal",
    "arrondissement":"Saint-Léonard",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":282,
    "nom_corrige2":"Younes Boukala",
    "nom_famille":"Boukala",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"70585",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"89850",
    "ville":"Montréal",
    "arrondissement":"Lachine",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":283,
    "nom_corrige2":"Raymond Berthiaume",
    "nom_famille":"Berthiaume",
    "titre_genre2":"Conseiller",
    "remuneration":"64170",
    "allocation":"18207",
    "remuneration2":"7363",
    "allocation2":"0",
    "total":"89740",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":284,
    "nom_corrige2":"Pierre Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Maire",
    "remuneration":"57832",
    "allocation":"19422",
    "remuneration2":"12252",
    "allocation2":"0",
    "total":"89506",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":285,
    "nom_corrige2":"Marie-Ève Couturier",
    "nom_famille":"Couturier",
    "titre_genre2":"Conseillère",
    "remuneration":"56740",
    "allocation":"18207",
    "remuneration2":"13994",
    "allocation2":"0",
    "total":"88941",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":286,
    "nom_corrige2":"Claude Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Conseiller",
    "remuneration":"62921",
    "allocation":"19422",
    "remuneration2":"6581",
    "allocation2":"0",
    "total":"88924",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":287,
    "nom_corrige2":"Kevin Armstrong",
    "nom_famille":"Armstrong",
    "titre_genre2":"Conseiller",
    "remuneration":"69255",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"88674",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":288,
    "nom_corrige2":"Martin Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"69249",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"88668",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":289,
    "nom_corrige2":"Vincent Deguise",
    "nom_famille":"Deguise",
    "titre_genre2":"Maire",
    "remuneration":"41810",
    "allocation":"19422",
    "remuneration2":"27268",
    "allocation2":"0",
    "total":"88500",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":290,
    "nom_corrige2":"Claude Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Conseiller",
    "remuneration":"60490",
    "allocation":"19422",
    "remuneration2":"8500",
    "allocation2":"0",
    "total":"88412",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":291,
    "nom_corrige2":"Hugues Grimard",
    "nom_famille":"Grimard",
    "titre_genre2":"Maire",
    "remuneration":"44283",
    "allocation":"19816",
    "remuneration2":"23500",
    "allocation2":"650,00$",
    "total":"88249",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":292,
    "nom_corrige2":"Robert Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseiller",
    "remuneration":"59410",
    "allocation":"18207",
    "remuneration2":"10277",
    "allocation2":"0",
    "total":"87894",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":293,
    "nom_corrige2":"Martin Dulac",
    "nom_famille":"Dulac",
    "titre_genre2":"Maire",
    "remuneration":"34790",
    "allocation":"17395",
    "remuneration2":"33433",
    "allocation2":"2027",
    "total":"87645",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":294,
    "nom_corrige2":"Patricia Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseillère",
    "remuneration":"43198",
    "allocation":"19422",
    "remuneration2":"25002",
    "allocation2":"0",
    "total":"87622",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":295,
    "nom_corrige2":"Suzanne De Larochellière",
    "nom_famille":"De Larochellière",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"68044",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"87309",
    "ville":"Montréal",
    "arrondissement":"Saint-Léonard",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":296,
    "nom_corrige2":"Claude Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Maire",
    "remuneration":"54304",
    "allocation":"19422",
    "remuneration2":"13269",
    "allocation2":"0",
    "total":"86995",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":297,
    "nom_corrige2":"Benoit Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Maire",
    "remuneration":"55167",
    "allocation":"19422",
    "remuneration2":"12252",
    "allocation2":"0",
    "total":"86841",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":298,
    "nom_corrige2":"Jean Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"65677",
    "allocation":"19419",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"86596",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":299,
    "nom_corrige2":"Éric Chagnon",
    "nom_famille":"Chagnon",
    "titre_genre2":"Maire",
    "remuneration":"41005",
    "allocation":"19422",
    "remuneration2":"26139",
    "allocation2":"0",
    "total":"86566",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":300,
    "nom_corrige2":"Pierre Dolbec",
    "nom_famille":"Dolbec",
    "titre_genre2":"Maire",
    "remuneration":"53329",
    "allocation":"19422",
    "remuneration2":"13671",
    "allocation2":"0",
    "total":"86422",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":301,
    "nom_corrige2":"Nathalie Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Conseillère",
    "remuneration":"46680",
    "allocation":"18207",
    "remuneration2":"20722",
    "allocation2":"0",
    "total":"85609",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":302,
    "nom_corrige2":"Normand Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Maire",
    "remuneration":"54449",
    "allocation":"19422",
    "remuneration2":"11553",
    "allocation2":"0",
    "total":"85424",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":303,
    "nom_corrige2":"Carl Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"65677",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"85096",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":304,
    "nom_corrige2":"Jacques Cleary",
    "nom_famille":"Cleary",
    "titre_genre2":"Conseiller",
    "remuneration":"65677",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"85096",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":305,
    "nom_corrige2":"Raynald Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"65677",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"85096",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":306,
    "nom_corrige2":"Simon Madore",
    "nom_famille":"Madore",
    "titre_genre2":"Maire",
    "remuneration":"53137",
    "allocation":"19442",
    "remuneration2":"12141",
    "allocation2":"0",
    "total":"84720",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":307,
    "nom_corrige2":"Marie Sterlin",
    "nom_famille":"Sterlin",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"64296",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"83561",
    "ville":"Montréal",
    "arrondissement":"Plateau-Mont-Royal",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":308,
    "nom_corrige2":"Mindy Pollak",
    "nom_famille":"Pollak",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"64293",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"83558",
    "ville":"Montréal",
    "arrondissement":"Outremont",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":309,
    "nom_corrige2":"Sylvain Payant",
    "nom_famille":"Payant",
    "titre_genre2":"Maire",
    "remuneration":"27080",
    "allocation":"11630",
    "remuneration2":"35125",
    "allocation2":"9703",
    "total":"83538",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":310,
    "nom_corrige2":"Jean Marc Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"64261",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"83526",
    "ville":"Montréal",
    "arrondissement":"Montréal-Nord",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":311,
    "nom_corrige2":"Julie Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Mairesse",
    "remuneration":"59627",
    "allocation":"19422",
    "remuneration2":"4469",
    "allocation2":"0",
    "total":"83518",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":312,
    "nom_corrige2":"Josée Troilo",
    "nom_famille":"Troilo",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"64058",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"83323",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":313,
    "nom_corrige2":"Valérie Patreau",
    "nom_famille":"Patreau",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"64057",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"83322",
    "ville":"Montréal",
    "arrondissement":"Outremont",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":314,
    "nom_corrige2":"Vicky Mokas",
    "nom_famille":"Mokas",
    "titre_genre2":"Conseillère",
    "remuneration":"41897",
    "allocation":"18207",
    "remuneration2":"23203",
    "allocation2":"0",
    "total":"83307",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":315,
    "nom_corrige2":"Gilles Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Maire",
    "remuneration":"36601",
    "allocation":"18300",
    "remuneration2":"27058",
    "allocation2":"1122",
    "total":"83081",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":316,
    "nom_corrige2":"Olivier Dumais",
    "nom_famille":"Dumais",
    "titre_genre2":"Maire",
    "remuneration":"54282",
    "allocation":"19772",
    "remuneration2":"8473",
    "allocation2":"0",
    "total":"82527",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":317,
    "nom_corrige2":"Aglaia Revelakis",
    "nom_famille":"Revelakis",
    "titre_genre2":"Conseillère",
    "remuneration":"63010",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"82432",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":318,
    "nom_corrige2":"Arij El Korbi",
    "nom_famille":"El Korbi",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"63046",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"82311",
    "ville":"Montréal",
    "arrondissement":"Saint-Léonard",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":319,
    "nom_corrige2":"Micheline Rouleau",
    "nom_famille":"Rouleau",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"62891",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"82156",
    "ville":"Montréal",
    "arrondissement":"Lachine",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":320,
    "nom_corrige2":"Jonathan V. Bolduc",
    "nom_famille":"V. Bolduc",
    "titre_genre2":"Maire",
    "remuneration":"28411",
    "allocation":"14206",
    "remuneration2":"34035",
    "allocation2":"5216",
    "total":"81868",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":321,
    "nom_corrige2":"Nancy Robichaud",
    "nom_famille":"Robichaud",
    "titre_genre2":"Conseillère",
    "remuneration":"62407",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"81829",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":322,
    "nom_corrige2":"Marc L'Heureux",
    "nom_famille":"L'Heureux",
    "titre_genre2":"Maire",
    "remuneration":"13434",
    "allocation":"6717",
    "remuneration2":"48605",
    "allocation2":"13067",
    "total":"81823",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":323,
    "nom_corrige2":"Alain Bellemare",
    "nom_famille":"Bellemare",
    "titre_genre2":"Maire",
    "remuneration":"35548",
    "allocation":"17774",
    "remuneration2":"26362",
    "allocation2":"1648",
    "total":"81332",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":324,
    "nom_corrige2":"Bertrand Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseiller",
    "remuneration":"49700",
    "allocation":"19422",
    "remuneration2":"12195",
    "allocation2":"0",
    "total":"81317",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":325,
    "nom_corrige2":"Annie Gagnier",
    "nom_famille":"Gagnier",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"61924",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"81189",
    "ville":"Montréal",
    "arrondissement":"Saint-Laurent",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":326,
    "nom_corrige2":"Benoit Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"61912",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"81177",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":327,
    "nom_corrige2":"Claude Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"58514",
    "allocation":"19419",
    "remuneration2":"3209",
    "allocation2":"0",
    "total":"81142",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":328,
    "nom_corrige2":"Christian Marin",
    "nom_famille":"Marin",
    "titre_genre2":"Maire",
    "remuneration":"44043",
    "allocation":"14833",
    "remuneration2":"17962",
    "allocation2":"4069",
    "total":"80907",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":329,
    "nom_corrige2":"Claudia Abaunza",
    "nom_famille":"Abaunza",
    "titre_genre2":"Conseillère",
    "remuneration":"62590",
    "allocation":"18207",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"80797",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":330,
    "nom_corrige2":"Pascal Quevillon",
    "nom_famille":"Quevillon",
    "titre_genre2":"Maire",
    "remuneration":"46583",
    "allocation":"19422",
    "remuneration2":"14768",
    "allocation2":"0",
    "total":"80773",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":331,
    "nom_corrige2":"Marc Denault",
    "nom_famille":"Denault",
    "titre_genre2":"Conseiller",
    "remuneration":"60154",
    "allocation":"19422",
    "remuneration2":"1112",
    "allocation2":"0",
    "total":"80688",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":332,
    "nom_corrige2":"Martin Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Maire",
    "remuneration":"49427",
    "allocation":"18548",
    "remuneration2":"12416",
    "allocation2":"0",
    "total":"80391",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":333,
    "nom_corrige2":"Sonia Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Mairesse",
    "remuneration":"50915",
    "allocation":"20122",
    "remuneration2":"9292",
    "allocation2":"0",
    "total":"80329",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":334,
    "nom_corrige2":"Michel Lagacé",
    "nom_famille":"Lagacé",
    "titre_genre2":"Maire",
    "remuneration":"7460",
    "allocation":"3730",
    "remuneration2":"53629",
    "allocation2":"15439",
    "total":"80258",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":335,
    "nom_corrige2":"Marc-André Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"39250",
    "allocation":"18207",
    "remuneration2":"22795",
    "allocation2":"0",
    "total":"80252",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":336,
    "nom_corrige2":"Denis Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Maire",
    "remuneration":"62401",
    "allocation":"17401",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"79802",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":337,
    "nom_corrige2":"Louise Lortie",
    "nom_famille":"Lortie",
    "titre_genre2":"Conseillère",
    "remuneration":"60070",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"79492",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":338,
    "nom_corrige2":"Mario Dupont",
    "nom_famille":"Dupont",
    "titre_genre2":"Maire",
    "remuneration":"44551",
    "allocation":"19422",
    "remuneration2":"10327",
    "allocation2":"5163",
    "total":"79463",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":339,
    "nom_corrige2":"Jimmy Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"58514",
    "allocation":"19419",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"79433",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":340,
    "nom_corrige2":"Réjean Goui",
    "nom_famille":"Goui",
    "titre_genre2":"Maire",
    "remuneration":"39540",
    "allocation":"19769",
    "remuneration2":"12506",
    "allocation2":"7519",
    "total":"79334",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":341,
    "nom_corrige2":"Simon Deschenes",
    "nom_famille":"Deschenes",
    "titre_genre2":"Maire",
    "remuneration":"57052",
    "allocation":"18907",
    "remuneration2":"3238",
    "allocation2":"0",
    "total":"79197",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":342,
    "nom_corrige2":"Martin Héroux",
    "nom_famille":"Héroux",
    "titre_genre2":"Maire",
    "remuneration":"41988",
    "allocation":"18207",
    "remuneration2":"18985",
    "allocation2":"0",
    "total":"79180",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":343,
    "nom_corrige2":"Luc Dostaler",
    "nom_famille":"Dostaler",
    "titre_genre2":"Maire",
    "remuneration":"28120",
    "allocation":"14060",
    "remuneration2":"32392",
    "allocation2":"4263",
    "total":"78835",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":344,
    "nom_corrige2":"Jean-Claude Léveillée",
    "nom_famille":"Léveillée",
    "titre_genre2":"Maire",
    "remuneration":"47793",
    "allocation":"19422",
    "remuneration2":"7643",
    "allocation2":"3822",
    "total":"78680",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":345,
    "nom_corrige2":"Bernard Landreville",
    "nom_famille":"Landreville",
    "titre_genre2":"Conseiller",
    "remuneration":"49270",
    "allocation":"19422",
    "remuneration2":"9729",
    "allocation2":"0",
    "total":"78421",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":346,
    "nom_corrige2":"Bruno Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire",
    "remuneration":"56415",
    "allocation":"18579",
    "remuneration2":"3201",
    "allocation2":"0",
    "total":"78195",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":347,
    "nom_corrige2":"Mathieu Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Maire",
    "remuneration":"47433",
    "allocation":"17401",
    "remuneration2":"7032",
    "allocation2":"6226",
    "total":"78092",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":348,
    "nom_corrige2":"Tan Shan Li",
    "nom_famille":"Shan Li",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"58519",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"77784",
    "ville":"Montréal",
    "arrondissement":"Sud-Ouest",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":349,
    "nom_corrige2":"Lise Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"43299",
    "allocation":"19422",
    "remuneration2":"15046",
    "allocation2":"0",
    "total":"77767",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":350,
    "nom_corrige2":"Jonathan Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Maire",
    "remuneration":"44100",
    "allocation":"22050",
    "remuneration2":"11265",
    "allocation2":"0",
    "total":"77415",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":351,
    "nom_corrige2":"Annie Godbout",
    "nom_famille":"Godbout",
    "titre_genre2":"Conseillère",
    "remuneration":"57848",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"77270",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":352,
    "nom_corrige2":"Marc Louis-Seize",
    "nom_famille":"Louis-Seize",
    "titre_genre2":"Maire",
    "remuneration":"29220",
    "allocation":"14610",
    "remuneration2":"33386",
    "allocation2":"0",
    "total":"77216",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":353,
    "nom_corrige2":"Beny Masella",
    "nom_famille":"Masella",
    "titre_genre2":"Maire",
    "remuneration":"35478",
    "allocation":"17739",
    "remuneration2":"22291",
    "allocation2":"1650",
    "total":"77158",
    "ville":"Montréal-Ouest",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5372"
  },
  {
    "ID":354,
    "nom_corrige2":"Steve Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Maire",
    "remuneration":"57583",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"77005",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":355,
    "nom_corrige2":"Dominique Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Mairesse",
    "remuneration":"44396",
    "allocation":"22198",
    "remuneration2":"10304",
    "allocation2":"0",
    "total":"76898",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":356,
    "nom_corrige2":"Michel Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Maire",
    "remuneration":"26630",
    "allocation":"13315",
    "remuneration2":"30023",
    "allocation2":"6887",
    "total":"76855",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":357,
    "nom_corrige2":"André Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"58340",
    "allocation":"18207",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76547",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":358,
    "nom_corrige2":"Jacques Cohen",
    "nom_famille":"Cohen",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"57140",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76405",
    "ville":"Montréal",
    "arrondissement":"Saint-Laurent",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":359,
    "nom_corrige2":"Chahi Tarakjian",
    "nom_famille":"Tarakjian",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"57129",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76394",
    "ville":"Montréal",
    "arrondissement":"Pierrefonds-Roxboro",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":360,
    "nom_corrige2":"Isabelle Piché",
    "nom_famille":"Piché",
    "titre_genre2":"Conseillère",
    "remuneration":"56920",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76342",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":361,
    "nom_corrige2":"Céline-Audrey Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"57074",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76339",
    "ville":"Montréal",
    "arrondissement":"Verdun",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":362,
    "nom_corrige2":"Germain Majeau",
    "nom_famille":"Majeau",
    "titre_genre2":"Maire",
    "remuneration":"29540",
    "allocation":"14770",
    "remuneration2":"27371",
    "allocation2":"4652",
    "total":"76333",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":363,
    "nom_corrige2":"Sylvain Larocque",
    "nom_famille":"Larocque",
    "titre_genre2":"Conseiller",
    "remuneration":"56634",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76056",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":364,
    "nom_corrige2":"Yvon Dehaies",
    "nom_famille":"Dehaies",
    "titre_genre2":"Maire",
    "remuneration":"47987",
    "allocation":"19422",
    "remuneration2":"8605",
    "allocation2":"0",
    "total":"76014",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":365,
    "nom_corrige2":"Marc Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"54942",
    "allocation":"19419",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"75861",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":366,
    "nom_corrige2":"Philippe Thermidor",
    "nom_famille":"Thermidor",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"56588",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75853",
    "ville":"Montréal",
    "arrondissement":"Montréal-Nord",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":367,
    "nom_corrige2":"Michel Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"56529",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75794",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":368,
    "nom_corrige2":"Nathalie Pierre-Antoine",
    "nom_famille":"Pierre-Antoine",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"56529",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75794",
    "ville":"Montréal",
    "arrondissement":"Rivière-des-Prairies - Pointe-aux-Trembles",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":369,
    "nom_corrige2":"Daniela Romano",
    "nom_famille":"Romano",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"56529",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75794",
    "ville":"Montréal",
    "arrondissement":"LaSalle",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":370,
    "nom_corrige2":"Valérie Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Conseillère",
    "remuneration":"57550",
    "allocation":"18207",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75757",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":371,
    "nom_corrige2":"Achille Cifelli",
    "nom_famille":"Cifelli",
    "titre_genre2":"Conseiller",
    "remuneration":"56290",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75712",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":372,
    "nom_corrige2":"David De Cotis",
    "nom_famille":"De Cotis",
    "titre_genre2":"Conseiller",
    "remuneration":"56290",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75712",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":373,
    "nom_corrige2":"Paolo Galati",
    "nom_famille":"Galati",
    "titre_genre2":"Conseiller",
    "remuneration":"56290",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75712",
    "ville":"Laval",
    "arrondissement":"",
    "region_adm":"Laval",
    "population":"458981"
  },
  {
    "ID":374,
    "nom_corrige2":"Kévin Maurice",
    "nom_famille":"Maurice",
    "titre_genre2":"Maire",
    "remuneration":"31502",
    "allocation":"15751",
    "remuneration2":"24471",
    "allocation2":"3908",
    "total":"75632",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":375,
    "nom_corrige2":"Marcel Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Maire",
    "remuneration":"34383",
    "allocation":"14950",
    "remuneration2":"21667",
    "allocation2":"4472",
    "total":"75472",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":376,
    "nom_corrige2":"Sophie Giard-Allard",
    "nom_famille":"Giard-Allard",
    "titre_genre2":"Conseillère",
    "remuneration":"53757",
    "allocation":"19422",
    "remuneration2":"2200",
    "allocation2":"0",
    "total":"75379",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":377,
    "nom_corrige2":"Éric Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Maire",
    "remuneration":"55863",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75285",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":378,
    "nom_corrige2":"Paul Gingues",
    "nom_famille":"Gingues",
    "titre_genre2":"Conseiller",
    "remuneration":"55668",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"75090",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":379,
    "nom_corrige2":"Carl Miguel Maldonado",
    "nom_famille":"Miguel Maldonado",
    "titre_genre2":"Conseiller",
    "remuneration":"43218",
    "allocation":"18207",
    "remuneration2":"13420",
    "allocation2":"0",
    "total":"74845",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":380,
    "nom_corrige2":"Karl Ferraro",
    "nom_famille":"Ferraro",
    "titre_genre2":"Conseiller",
    "remuneration":"55404",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"74826",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":381,
    "nom_corrige2":"Louise Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"55511",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"74776",
    "ville":"Montréal",
    "arrondissement":"Pierrefonds-Roxboro",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":382,
    "nom_corrige2":"Alain Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Maire",
    "remuneration":"55276",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"74698",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":383,
    "nom_corrige2":"Anny Mailloux",
    "nom_famille":"Mailloux",
    "titre_genre2":"Conseillère",
    "remuneration":"41864",
    "allocation":"19422",
    "remuneration2":"13216",
    "allocation2":"0",
    "total":"74502",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":384,
    "nom_corrige2":"Tina Del Vecchio",
    "nom_famille":"Del Vecchio",
    "titre_genre2":"Conseillère",
    "remuneration":"54156",
    "allocation":"19422",
    "remuneration2":"880,00$",
    "allocation2":"0",
    "total":"74458",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":385,
    "nom_corrige2":"Camil Turmel",
    "nom_famille":"Turmel",
    "titre_genre2":"Maire",
    "remuneration":"24547",
    "allocation":"12274",
    "remuneration2":"25089",
    "allocation2":"12544",
    "total":"74454",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":386,
    "nom_corrige2":"Michel Thiffault",
    "nom_famille":"Thiffault",
    "titre_genre2":"Conseiller",
    "remuneration":"54942",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"74361",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":387,
    "nom_corrige2":"Mireille Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseillère",
    "remuneration":"54942",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"74361",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":388,
    "nom_corrige2":"Michel Milette",
    "nom_famille":"Milette",
    "titre_genre2":"Conseiller",
    "remuneration":"50566",
    "allocation":"19422",
    "remuneration2":"4236",
    "allocation2":"0",
    "total":"74224",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":389,
    "nom_corrige2":"Alexandre Fallu",
    "nom_famille":"Fallu",
    "titre_genre2":"Conseiller",
    "remuneration":"54571",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"73993",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":390,
    "nom_corrige2":"Serge Bonin",
    "nom_famille":"Bonin",
    "titre_genre2":"Conseiller",
    "remuneration":"54571",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"73993",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":391,
    "nom_corrige2":"Jeannot Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseiller",
    "remuneration":"54571",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"73993",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":392,
    "nom_corrige2":"Karine Lavertu",
    "nom_famille":"Lavertu",
    "titre_genre2":"Conseillère",
    "remuneration":"54571",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"73993",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":393,
    "nom_corrige2":"Fleur Paradis",
    "nom_famille":"Paradis",
    "titre_genre2":"Conseillère",
    "remuneration":"54571",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"73993",
    "ville":"Lévis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"159049"
  },
  {
    "ID":394,
    "nom_corrige2":"Julie Brisebois",
    "nom_famille":"Brisebois",
    "titre_genre2":"Mairesse",
    "remuneration":"23707",
    "allocation":"11853",
    "remuneration2":"30189",
    "allocation2":"7645",
    "total":"73394",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":395,
    "nom_corrige2":"Isabelle Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Mairesse",
    "remuneration":"55000",
    "allocation":"18227",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"73227",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":396,
    "nom_corrige2":"Lise Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"39159",
    "allocation":"19422",
    "remuneration2":"14516",
    "allocation2":"0",
    "total":"73097",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":397,
    "nom_corrige2":"Josyanne Forest",
    "nom_famille":"Forest",
    "titre_genre2":"Mairesse",
    "remuneration":"30317",
    "allocation":"15156",
    "remuneration2":"22942",
    "allocation2":"4266",
    "total":"72681",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":398,
    "nom_corrige2":"Philippe Magnenat",
    "nom_famille":"Magnenat",
    "titre_genre2":"Conseiller",
    "remuneration":"53399",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"72639",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":399,
    "nom_corrige2":"Marie Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"53325",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"72590",
    "ville":"Montréal",
    "arrondissement":"Outremont",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":400,
    "nom_corrige2":"Yves Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Maire suppléant",
    "remuneration":"50857",
    "allocation":"19422",
    "remuneration2":"2070",
    "allocation2":"0",
    "total":"72349",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":401,
    "nom_corrige2":"Hélène Dauphinais",
    "nom_famille":"Dauphinais",
    "titre_genre2":"Conseillère",
    "remuneration":"46675",
    "allocation":"19422",
    "remuneration2":"6224",
    "allocation2":"0",
    "total":"72321",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":402,
    "nom_corrige2":"Brent Montgomery",
    "nom_famille":"Montgomery",
    "titre_genre2":"Maire",
    "remuneration":"47832",
    "allocation":"19422",
    "remuneration2":"4931",
    "allocation2":"0",
    "total":"72185",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":403,
    "nom_corrige2":"France Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Mairesse",
    "remuneration":"47573",
    "allocation":"18207",
    "remuneration2":"5017",
    "allocation2":"1215",
    "total":"72012",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":404,
    "nom_corrige2":"Heidi Ektvedt",
    "nom_famille":"Ektvedt",
    "titre_genre2":"Mairesse",
    "remuneration":"34932",
    "allocation":"17466",
    "remuneration2":"17633",
    "allocation2":"1925",
    "total":"71956",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":405,
    "nom_corrige2":"Lori Doucet",
    "nom_famille":"Doucet",
    "titre_genre2":"Conseillère",
    "remuneration":"46712",
    "allocation":"19373",
    "remuneration2":"5736",
    "allocation2":"0",
    "total":"71821",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":406,
    "nom_corrige2":"Samuelle Ramsay-Houle",
    "nom_famille":"Ramsay-Houle",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"54322",
    "allocation":"17210",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71532",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":407,
    "nom_corrige2":"Jean Morency",
    "nom_famille":"Morency",
    "titre_genre2":"Maire",
    "remuneration":"43951",
    "allocation":"19335",
    "remuneration2":"8245",
    "allocation2":"0",
    "total":"71531",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":408,
    "nom_corrige2":"Caroline Braun",
    "nom_famille":"Braun",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"52069",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71334",
    "ville":"Montréal",
    "arrondissement":"Outremont",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":409,
    "nom_corrige2":"Alain Lafontaine",
    "nom_famille":"Lafontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":410,
    "nom_corrige2":"Dany Carpentier",
    "nom_famille":"Carpentier",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":411,
    "nom_corrige2":"François Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":412,
    "nom_corrige2":"Geneviève Auclair",
    "nom_famille":"Auclair",
    "titre_genre2":"Conseillère",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":413,
    "nom_corrige2":"Jonathan Bradley",
    "nom_famille":"Bradley",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":414,
    "nom_corrige2":"Maryse Bellemare",
    "nom_famille":"Bellemare",
    "titre_genre2":"Conseillère",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":415,
    "nom_corrige2":"Pascale Albernhe-Lahaie",
    "nom_famille":"Albernhe-Lahaie",
    "titre_genre2":"Conseillère",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":416,
    "nom_corrige2":"Pierre Montreuil",
    "nom_famille":"Montreuil",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":417,
    "nom_corrige2":"Pierre-Luc Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":418,
    "nom_corrige2":"René Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":419,
    "nom_corrige2":"Sabrina Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":420,
    "nom_corrige2":"Richard W. Dober",
    "nom_famille":"W. Dober",
    "titre_genre2":"Conseiller",
    "remuneration":"51730",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":421,
    "nom_corrige2":"Daniel Cournoyer",
    "nom_famille":"Cournoyer",
    "titre_genre2":"Conseiller",
    "remuneration":"39033",
    "allocation":"19422",
    "remuneration2":"12697",
    "allocation2":"0",
    "total":"71152",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":422,
    "nom_corrige2":"Serge Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"51370",
    "allocation":"19419",
    "remuneration2":"250,00$",
    "allocation2":"0",
    "total":"71039",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":423,
    "nom_corrige2":"Luc Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Maire",
    "remuneration":"6794",
    "allocation":"3397",
    "remuneration2":"40401",
    "allocation2":"20201",
    "total":"70793",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":424,
    "nom_corrige2":"Jean-Marc Crevier",
    "nom_famille":"Crevier",
    "titre_genre2":"Conseiller",
    "remuneration":"51370",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"70789",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":425,
    "nom_corrige2":"Michel Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"51370",
    "allocation":"19419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"70789",
    "ville":"Saguenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"151972"
  },
  {
    "ID":426,
    "nom_corrige2":"Michael C. Turcot",
    "nom_famille":"C Turcot",
    "titre_genre2":"Maire",
    "remuneration":"44247",
    "allocation":"13899",
    "remuneration2":"7939",
    "allocation2":"3970",
    "total":"70055",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":427,
    "nom_corrige2":"Isabelle Bleau",
    "nom_famille":"Bleau",
    "titre_genre2":"Conseillère",
    "remuneration":"50170",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"69592",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":428,
    "nom_corrige2":"Timothy Watchorn",
    "nom_famille":"Watchorn",
    "titre_genre2":"Maire",
    "remuneration":"30716",
    "allocation":"15359",
    "remuneration2":"19455",
    "allocation2":"4062",
    "total":"69592",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":429,
    "nom_corrige2":"Daniel Lucier",
    "nom_famille":"Lucier",
    "titre_genre2":"Conseiller",
    "remuneration":"44751",
    "allocation":"19422",
    "remuneration2":"5280",
    "allocation2":"0",
    "total":"69453",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":430,
    "nom_corrige2":"René Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Maire",
    "remuneration":"16667",
    "allocation":"8333",
    "remuneration2":"33358",
    "allocation2":"11088",
    "total":"69446",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":431,
    "nom_corrige2":"Frank Pappas",
    "nom_famille":"Pappas",
    "titre_genre2":"Maire",
    "remuneration":"33840",
    "allocation":"16920",
    "remuneration2":"16173",
    "allocation2":"2502",
    "total":"69435",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":432,
    "nom_corrige2":"Sylvie Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Mairesse",
    "remuneration":"49968",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"69390",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":433,
    "nom_corrige2":"Marc-Antoine Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"51791",
    "allocation":"17582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"69373",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":434,
    "nom_corrige2":"Andre Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Maire",
    "remuneration":"42174",
    "allocation":"14058",
    "remuneration2":"8629",
    "allocation2":"4314",
    "total":"69175",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":435,
    "nom_corrige2":"René Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseiller",
    "remuneration":"28946",
    "allocation":"14453",
    "remuneration2":"20677",
    "allocation2":"4969",
    "total":"69045",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":436,
    "nom_corrige2":"Suzanne Marceau",
    "nom_famille":"Marceau",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"49627",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"68892",
    "ville":"Montréal",
    "arrondissement":"Ile-Bizard - Sainte-Geneviève",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":437,
    "nom_corrige2":"Kristine Marsolais",
    "nom_famille":"Marsolais",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"49576",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"68841",
    "ville":"Montréal",
    "arrondissement":"Anjou",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":438,
    "nom_corrige2":"Richard Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"49467",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"68732",
    "ville":"Montréal",
    "arrondissement":"Anjou",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":439,
    "nom_corrige2":"Raymond Masse",
    "nom_famille":"Masse",
    "titre_genre2":"Conseiller",
    "remuneration":"49279",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"68701",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":440,
    "nom_corrige2":"Jean-Marie Laplante",
    "nom_famille":"Laplante",
    "titre_genre2":"Maire",
    "remuneration":"17637",
    "allocation":"8819",
    "remuneration2":"31182",
    "allocation2":"10603",
    "total":"68241",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":441,
    "nom_corrige2":"Christian Gaudette",
    "nom_famille":"Gaudette",
    "titre_genre2":"Conseiller",
    "remuneration":"45163",
    "allocation":"19422",
    "remuneration2":"3500",
    "allocation2":"0",
    "total":"68085",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":442,
    "nom_corrige2":"Sonia Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"49850",
    "allocation":"18207",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"68057",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":443,
    "nom_corrige2":"Michel Corbeil",
    "nom_famille":"Corbeil",
    "titre_genre2":"Conseiller",
    "remuneration":"49850",
    "allocation":"18207",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"68057",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":444,
    "nom_corrige2":"Martine Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseillère",
    "remuneration":"48568",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"67990",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":445,
    "nom_corrige2":"Marie Josée Dubé",
    "nom_famille":"Josée Dubé",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"48500",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"67765",
    "ville":"Montréal",
    "arrondissement":"Anjou",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":446,
    "nom_corrige2":"Jean-Guy Hamelin",
    "nom_famille":"Hamelin",
    "titre_genre2":"Maire",
    "remuneration":"32530",
    "allocation":"16265",
    "remuneration2":"12626",
    "allocation2":"6313",
    "total":"67734",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":447,
    "nom_corrige2":"Johane Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"46631",
    "allocation":"19422",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"67553",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":448,
    "nom_corrige2":"Ghislaine Pomerleau",
    "nom_famille":"Pomerleau",
    "titre_genre2":"Mairesse",
    "remuneration":"18054",
    "allocation":"9027",
    "remuneration2":"30023",
    "allocation2":"10395",
    "total":"67499",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":449,
    "nom_corrige2":"Lise Poissant",
    "nom_famille":"Poissant",
    "titre_genre2":"Mairesse",
    "remuneration":"22462",
    "allocation":"8374",
    "remuneration2":"26230",
    "allocation2":"10200",
    "total":"67266",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":450,
    "nom_corrige2":"Jacynthe Prince",
    "nom_famille":"Prince",
    "titre_genre2":"Conseillère",
    "remuneration":"46517",
    "allocation":"19422",
    "remuneration2":"1250",
    "allocation2":"0",
    "total":"67189",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":451,
    "nom_corrige2":"Kevin Buteau",
    "nom_famille":"Buteau",
    "titre_genre2":"Conseiller",
    "remuneration":"47658",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"67080",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":452,
    "nom_corrige2":"Alexandre Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Maire",
    "remuneration":"25807",
    "allocation":"12904",
    "remuneration2":"21574",
    "allocation2":"6518",
    "total":"66803",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":453,
    "nom_corrige2":"Daniel Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"46008",
    "allocation":"19422",
    "remuneration2":"910,00$",
    "allocation2":"0",
    "total":"66340",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":454,
    "nom_corrige2":"Michel Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"46899",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66321",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":455,
    "nom_corrige2":"Darllie Pierre-Louis",
    "nom_famille":"Pierre-Louis",
    "titre_genre2":"Conseillère",
    "remuneration":"35899",
    "allocation":"17949",
    "remuneration2":"12399",
    "allocation2":"0",
    "total":"66247",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":456,
    "nom_corrige2":"Jacques Prescott",
    "nom_famille":"Prescott",
    "titre_genre2":"Conseiller",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":457,
    "nom_corrige2":"Jennifer Robillard",
    "nom_famille":"Robillard",
    "titre_genre2":"Conseillère",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":458,
    "nom_corrige2":"Martine Roux",
    "nom_famille":"Roux",
    "titre_genre2":"Conseillère",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":459,
    "nom_corrige2":"Normand Urbain",
    "nom_famille":"Urbain",
    "titre_genre2":"Conseiller",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":460,
    "nom_corrige2":"Chantal Routhier",
    "nom_famille":"Routhier",
    "titre_genre2":"Conseillère",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":461,
    "nom_corrige2":"Luc Rhéaume",
    "nom_famille":"Rhéaume",
    "titre_genre2":"Conseiller",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":462,
    "nom_corrige2":"Simon Joubert",
    "nom_famille":"Joubert",
    "titre_genre2":"Conseiller",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":463,
    "nom_corrige2":"Karine Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseillère",
    "remuneration":"46751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66173",
    "ville":"Repentigny",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"89857"
  },
  {
    "ID":464,
    "nom_corrige2":"Daniel Kaeser",
    "nom_famille":"Kaeser",
    "titre_genre2":"Conseiller",
    "remuneration":"46711",
    "allocation":"19373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"66084",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":465,
    "nom_corrige2":"Éric Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Maire",
    "remuneration":"42066",
    "allocation":"18531",
    "remuneration2":"4533",
    "allocation2":"891,00$",
    "total":"66021",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":466,
    "nom_corrige2":"Guy Adam",
    "nom_famille":"Adam",
    "titre_genre2":"Maire",
    "remuneration":"23779",
    "allocation":"18890",
    "remuneration2":"15521",
    "allocation2":"7760",
    "total":"65950",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":467,
    "nom_corrige2":"Anne Barabé",
    "nom_famille":"Barabé",
    "titre_genre2":"Conseillère",
    "remuneration":"42147",
    "allocation":"19422",
    "remuneration2":"4260",
    "allocation2":"0",
    "total":"65829",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":468,
    "nom_corrige2":"Alain Wilson",
    "nom_famille":"Wilson",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"46421",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"65686",
    "ville":"Montréal",
    "arrondissement":"Ile-Bizard - Sainte-Geneviève",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":469,
    "nom_corrige2":"Danielle Myrand",
    "nom_famille":"Myrand",
    "titre_genre2":"Conseillère d'arrondissement",
    "remuneration":"46391",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"65656",
    "ville":"Montréal",
    "arrondissement":"Ile-Bizard - Sainte-Geneviève",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":470,
    "nom_corrige2":"Gino Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Maire",
    "remuneration":"33892",
    "allocation":"16946",
    "remuneration2":"12252",
    "allocation2":"2496",
    "total":"65586",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":471,
    "nom_corrige2":"Josée Bissonnette",
    "nom_famille":"Bissonnette",
    "titre_genre2":"Conseillère",
    "remuneration":"46126",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"65548",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":472,
    "nom_corrige2":"Raymond Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Maire",
    "remuneration":"29170",
    "allocation":"14585",
    "remuneration2":"20590",
    "allocation2":"1104",
    "total":"65449",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":473,
    "nom_corrige2":"Sébastien Gaudette",
    "nom_famille":"Gaudette",
    "titre_genre2":"Conseiller",
    "remuneration":"45832",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"65254",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":474,
    "nom_corrige2":"Isabelle Duchesne",
    "nom_famille":"Duchesne",
    "titre_genre2":"Conseillère",
    "remuneration":"45167",
    "allocation":"19422",
    "remuneration2":"607,00$",
    "allocation2":"0",
    "total":"65196",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":475,
    "nom_corrige2":"Stéphanie Quintal",
    "nom_famille":"Quintal",
    "titre_genre2":"Conseillère",
    "remuneration":"45660",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"65082",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":476,
    "nom_corrige2":"Patrick Langlois",
    "nom_famille":"Langlois",
    "titre_genre2":"Conseiller",
    "remuneration":"45535",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"64957",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":477,
    "nom_corrige2":"Véronique Venne",
    "nom_famille":"Venne",
    "titre_genre2":"Mairesse",
    "remuneration":"16397",
    "allocation":"8199",
    "remuneration2":"29139",
    "allocation2":"11222",
    "total":"64957",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":478,
    "nom_corrige2":"Anna Guarnieri",
    "nom_famille":"Guarnieri",
    "titre_genre2":"Conseillère",
    "remuneration":"41370",
    "allocation":"18207",
    "remuneration2":"5375",
    "allocation2":"0",
    "total":"64952",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":479,
    "nom_corrige2":"François Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Conseiller",
    "remuneration":"45469",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"64891",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":480,
    "nom_corrige2":"Jean-Simon Levert",
    "nom_famille":"Levert",
    "titre_genre2":"Maire",
    "remuneration":"36268",
    "allocation":"18134",
    "remuneration2":"6978",
    "allocation2":"3489",
    "total":"64869",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":481,
    "nom_corrige2":"Claude Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Maire",
    "remuneration":"28714",
    "allocation":"14357",
    "remuneration2":"15563",
    "allocation2":"6167",
    "total":"64801",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":482,
    "nom_corrige2":"Éric Ladouceur",
    "nom_famille":"Ladouceur",
    "titre_genre2":"Conseiller",
    "remuneration":"43198",
    "allocation":"19422",
    "remuneration2":"2146",
    "allocation2":"0",
    "total":"64766",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":483,
    "nom_corrige2":"Sylvain Brazeau",
    "nom_famille":"Brazeau",
    "titre_genre2":"Maire",
    "remuneration":"36534",
    "allocation":"18267",
    "remuneration2":"8497",
    "allocation2":"1289",
    "total":"64587",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":484,
    "nom_corrige2":"Louise Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseillère",
    "remuneration":"28832",
    "allocation":"14417",
    "remuneration2":"16100",
    "allocation2":"5005",
    "total":"64354",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":485,
    "nom_corrige2":"Sarah Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Mairesse",
    "remuneration":"39150",
    "allocation":"19321",
    "remuneration2":"5795",
    "allocation2":"0",
    "total":"64266",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":486,
    "nom_corrige2":"Antoine Assaf",
    "nom_famille":"Assaf",
    "titre_genre2":"Conseiller",
    "remuneration":"44751",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"64173",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":487,
    "nom_corrige2":"Mario Frigon",
    "nom_famille":"Frigon",
    "titre_genre2":"Maire",
    "remuneration":"32774",
    "allocation":"16387",
    "remuneration2":"9905",
    "allocation2":"4952",
    "total":"64018",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":488,
    "nom_corrige2":"Héloïse Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"44549",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63971",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":489,
    "nom_corrige2":"Mylène Morissette",
    "nom_famille":"Morissette",
    "titre_genre2":"Conseillère",
    "remuneration":"44549",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63971",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":490,
    "nom_corrige2":"Cathy Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseillère",
    "remuneration":"44470",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63892",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":491,
    "nom_corrige2":"Stéphane Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":492,
    "nom_corrige2":"David Malenfant",
    "nom_famille":"Malenfant",
    "titre_genre2":"Conseiller",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":493,
    "nom_corrige2":"Marie-Claude Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseillère",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":494,
    "nom_corrige2":"Patrick Marineau",
    "nom_famille":"Marineau",
    "titre_genre2":"Conseiller",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":495,
    "nom_corrige2":"Serge Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":496,
    "nom_corrige2":"Marie-Claude Collin",
    "nom_famille":"Collin",
    "titre_genre2":"Conseillère",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":497,
    "nom_corrige2":"Nicole Ruel",
    "nom_famille":"Ruel",
    "titre_genre2":"Conseillère",
    "remuneration":"44590",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63830",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":498,
    "nom_corrige2":"Jean-François Pinard",
    "nom_famille":"Pinard",
    "titre_genre2":"Conseiller",
    "remuneration":"44498",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63738",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":499,
    "nom_corrige2":"Pierre Lahaie",
    "nom_famille":"Lahaie",
    "titre_genre2":"Maire",
    "remuneration":"33943",
    "allocation":"16233",
    "remuneration2":"8951",
    "allocation2":"4475",
    "total":"63602",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":500,
    "nom_corrige2":"Émilie Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Mairesse",
    "remuneration":"28000",
    "allocation":"14000",
    "remuneration2":"14324",
    "allocation2":"7162",
    "total":"63486",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":501,
    "nom_corrige2":"Sarah Saint-Cyr Lanoie",
    "nom_famille":"Saint-Cyr Lanoie",
    "titre_genre2":"Conseillère",
    "remuneration":"44060",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63482",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":502,
    "nom_corrige2":"Catherine Lassonde",
    "nom_famille":"Lassonde",
    "titre_genre2":"Conseillère",
    "remuneration":"43955",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63377",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":503,
    "nom_corrige2":"Sylvie Bureau",
    "nom_famille":"Bureau",
    "titre_genre2":"Mairesse",
    "remuneration":"35088",
    "allocation":"17544",
    "remuneration2":"7157",
    "allocation2":"3579",
    "total":"63368",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":504,
    "nom_corrige2":"Francis Allaire",
    "nom_famille":"Allaire",
    "titre_genre2":"Conseiller",
    "remuneration":"44083",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63323",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":505,
    "nom_corrige2":"Michèle Murray",
    "nom_famille":"Murray",
    "titre_genre2":"Conseillère",
    "remuneration":"44070",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63310",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":506,
    "nom_corrige2":"Richard Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller d'arrondissement",
    "remuneration":"44029",
    "allocation":"19265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63294",
    "ville":"Montréal",
    "arrondissement":"Ile-Bizard - Sainte-Geneviève",
    "region_adm":"Montréal",
    "population":"1948747"
  },
  {
    "ID":507,
    "nom_corrige2":"Marc-André Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Conseiller",
    "remuneration":"43872",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63294",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":508,
    "nom_corrige2":"Stéphane Bertrand",
    "nom_famille":"Bertrand",
    "titre_genre2":"Conseiller",
    "remuneration":"44013",
    "allocation":"19240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63253",
    "ville":"Blainville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"61617"
  },
  {
    "ID":509,
    "nom_corrige2":"Christine McAleer",
    "nom_famille":"McAleer",
    "titre_genre2":"Mairesse",
    "remuneration":"37648",
    "allocation":"16352",
    "remuneration2":"6140",
    "allocation2":"3070",
    "total":"63210",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":510,
    "nom_corrige2":"Jacques Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"42856",
    "allocation":"20203",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63059",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":511,
    "nom_corrige2":"Raouf Absi",
    "nom_famille":"Absi",
    "titre_genre2":"Conseiller",
    "remuneration":"43625",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"63047",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":512,
    "nom_corrige2":"Odile Comeau",
    "nom_famille":"Comeau",
    "titre_genre2":"Mairesse",
    "remuneration":"12894",
    "allocation":"4190",
    "remuneration2":"30463",
    "allocation2":"15232",
    "total":"62779",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":513,
    "nom_corrige2":"Carole Léger",
    "nom_famille":"Léger",
    "titre_genre2":"Conseillère",
    "remuneration":"42271",
    "allocation":"19422",
    "remuneration2":"910,00$",
    "allocation2":"0",
    "total":"62603",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":514,
    "nom_corrige2":"André Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Maire",
    "remuneration":"25000",
    "allocation":"12500",
    "remuneration2":"18738",
    "allocation2":"6246",
    "total":"62484",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":515,
    "nom_corrige2":"Pascal Théroux",
    "nom_famille":"Théroux",
    "titre_genre2":"Maire",
    "remuneration":"27467",
    "allocation":"13734",
    "remuneration2":"16617",
    "allocation2":"4646",
    "total":"62464",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":516,
    "nom_corrige2":"Line Fréchette",
    "nom_famille":"Fréchette",
    "titre_genre2":"Mairesse",
    "remuneration":"14421",
    "allocation":"7211",
    "remuneration2":"27219",
    "allocation2":"13610",
    "total":"62461",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":517,
    "nom_corrige2":"Julie Létourneau",
    "nom_famille":"Létourneau",
    "titre_genre2":"Conseillère",
    "remuneration":"42968",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"62390",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":518,
    "nom_corrige2":"Yves Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Maire",
    "remuneration":"19891",
    "allocation":"9945",
    "remuneration2":"23028",
    "allocation2":"9476",
    "total":"62340",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":519,
    "nom_corrige2":"Nancy Mignault",
    "nom_famille":"Mignault",
    "titre_genre2":"Mairesse",
    "remuneration":"22882",
    "allocation":"11441",
    "remuneration2":"20055",
    "allocation2":"7813",
    "total":"62191",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":520,
    "nom_corrige2":"claire Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseillère",
    "remuneration":"42592",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"62014",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":521,
    "nom_corrige2":"Armando Melo",
    "nom_famille":"Melo",
    "titre_genre2":"Conseiller",
    "remuneration":"42581",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"62003",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":522,
    "nom_corrige2":"Barbara Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"42581",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"62003",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":523,
    "nom_corrige2":"Luc Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"42581",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"62003",
    "ville":"Sainte-Thérèse",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"27288"
  },
  {
    "ID":524,
    "nom_corrige2":"Isabelle Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Mairesse",
    "remuneration":"30343",
    "allocation":"15209",
    "remuneration2":"10741",
    "allocation2":"5640",
    "total":"61933",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":525,
    "nom_corrige2":"Mélanie Dufresne",
    "nom_famille":"Dufresne",
    "titre_genre2":"Conseillère",
    "remuneration":"40612",
    "allocation":"19422",
    "remuneration2":"1864",
    "allocation2":"0",
    "total":"61898",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":526,
    "nom_corrige2":"Steve Mador",
    "nom_famille":"Mador",
    "titre_genre2":"Maire",
    "remuneration":"28978",
    "allocation":"14186",
    "remuneration2":"13377",
    "allocation2":"5236",
    "total":"61777",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":527,
    "nom_corrige2":"Karine Laramée",
    "nom_famille":"Laramée",
    "titre_genre2":"Conseillère",
    "remuneration":"40893",
    "allocation":"19373",
    "remuneration2":"1500",
    "allocation2":"0",
    "total":"61766",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":528,
    "nom_corrige2":"Michel Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Maire",
    "remuneration":"28668",
    "allocation":"14340",
    "remuneration2":"12411",
    "allocation2":"6206",
    "total":"61625",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":529,
    "nom_corrige2":"Jonathan Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"42086",
    "allocation":"19373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"61459",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":530,
    "nom_corrige2":"Maude Whittom",
    "nom_famille":"Whittom",
    "titre_genre2":"Conseillère",
    "remuneration":"41940",
    "allocation":"19373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"61313",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":531,
    "nom_corrige2":"Normand Teasdale",
    "nom_famille":"Teasdale",
    "titre_genre2":"Maire",
    "remuneration":"32334",
    "allocation":"1300",
    "remuneration2":"21878",
    "allocation2":"5724",
    "total":"61236",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":532,
    "nom_corrige2":"Dany Quirion",
    "nom_famille":"Quirion",
    "titre_genre2":"Maire",
    "remuneration":"13701",
    "allocation":"26915",
    "remuneration2":"6888",
    "allocation2":"13548",
    "total":"61052",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":533,
    "nom_corrige2":"Mario Sévigny",
    "nom_famille":"Sévigny",
    "titre_genre2":"Conseiller",
    "remuneration":"41470",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60892",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":534,
    "nom_corrige2":"Jean-Philippe Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"41470",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60892",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":535,
    "nom_corrige2":"Sylvain Casavant",
    "nom_famille":"Casavant",
    "titre_genre2":"Maire",
    "remuneration":"22776",
    "allocation":"11992",
    "remuneration2":"17390",
    "allocation2":"8695",
    "total":"60853",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":536,
    "nom_corrige2":"Alexandre Desbiens",
    "nom_famille":"Desbiens",
    "titre_genre2":"Conseiller",
    "remuneration":"41370",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60792",
    "ville":"Drummondville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"84866"
  },
  {
    "ID":537,
    "nom_corrige2":"Marco Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"41333",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60755",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":538,
    "nom_corrige2":"Jacqueline Boubane",
    "nom_famille":"Boubane",
    "titre_genre2":"Conseillère",
    "remuneration":"40626",
    "allocation":"19422",
    "remuneration2":"440,00$",
    "allocation2":"0",
    "total":"60488",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":539,
    "nom_corrige2":"Patrick Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Maire",
    "remuneration":"20600",
    "allocation":"10300",
    "remuneration2":"19624",
    "allocation2":"9812",
    "total":"60336",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":540,
    "nom_corrige2":"Paola L. Hawa",
    "nom_famille":"L. Hawa",
    "titre_genre2":"Mairesse",
    "remuneration":"40913",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60335",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":541,
    "nom_corrige2":"Simon Sesto Cifola",
    "nom_famille":"Sesto Cifola",
    "titre_genre2":"Conseiller",
    "remuneration":"40893",
    "allocation":"19373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60266",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":542,
    "nom_corrige2":"Jean-François Hecq",
    "nom_famille":"Hecq",
    "titre_genre2":"Conseiller",
    "remuneration":"40893",
    "allocation":"19373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60266",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":543,
    "nom_corrige2":"Jacques Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Maire",
    "remuneration":"28566",
    "allocation":"14283",
    "remuneration2":"12252",
    "allocation2":"5159",
    "total":"60260",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":544,
    "nom_corrige2":"Nathalie Lasalle",
    "nom_famille":"Lasalle",
    "titre_genre2":"Conseillère",
    "remuneration":"40584",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"60006",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":545,
    "nom_corrige2":"Ronald Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseiller",
    "remuneration":"42016",
    "allocation":"17844",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59860",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":546,
    "nom_corrige2":"Guy Veillette",
    "nom_famille":"Veillette",
    "titre_genre2":"Maire",
    "remuneration":"14279",
    "allocation":"7140",
    "remuneration2":"25592",
    "allocation2":"12796",
    "total":"59807",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":547,
    "nom_corrige2":"Paul Barriault",
    "nom_famille":"Barriault",
    "titre_genre2":"Maire",
    "remuneration":"40275",
    "allocation":"19423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59698",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":548,
    "nom_corrige2":"Jacques Lemaistre-Caron",
    "nom_famille":"Lemaistre-Caron",
    "titre_genre2":"Maire",
    "remuneration":"34581",
    "allocation":"17290",
    "remuneration2":"5083",
    "allocation2":"2551",
    "total":"59505",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":549,
    "nom_corrige2":"Luc Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"43250",
    "allocation":"16238",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59488",
    "ville":"Trois-Rivières",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"148469"
  },
  {
    "ID":550,
    "nom_corrige2":"Jacques Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Maire",
    "remuneration":"43717",
    "allocation":"15552",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59269",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":551,
    "nom_corrige2":"Camille Joli-Coeur",
    "nom_famille":"Joli-Coeur",
    "titre_genre2":"Conseillère",
    "remuneration":"39804",
    "allocation":"19373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59177",
    "ville":"Boisbriand",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"29530"
  },
  {
    "ID":552,
    "nom_corrige2":"Annie Surprenant",
    "nom_famille":"Surprenant",
    "titre_genre2":"Conseillère",
    "remuneration":"39748",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59170",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":553,
    "nom_corrige2":"Lyne Poitras",
    "nom_famille":"Poitras",
    "titre_genre2":"Conseillère",
    "remuneration":"39748",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59170",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":554,
    "nom_corrige2":"Stéphane Joyal",
    "nom_famille":"Joyal",
    "titre_genre2":"Conseiller",
    "remuneration":"41240",
    "allocation":"17844",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59084",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":555,
    "nom_corrige2":"Jean-François Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Maire",
    "remuneration":"30347",
    "allocation":"15174",
    "remuneration2":"9006",
    "allocation2":"4503",
    "total":"59030",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":556,
    "nom_corrige2":"Jessica Racine-Lehoux",
    "nom_famille":"Racine-Lehoux",
    "titre_genre2":"Conseillère",
    "remuneration":"39604",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"59026",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":557,
    "nom_corrige2":"François Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"39316",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"58738",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":558,
    "nom_corrige2":"Jean Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"39316",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"58738",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":559,
    "nom_corrige2":"Jérémie Meunier",
    "nom_famille":"Meunier",
    "titre_genre2":"Conseiller",
    "remuneration":"39316",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"58738",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":560,
    "nom_corrige2":"Marianne Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseillère",
    "remuneration":"39316",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"58738",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":561,
    "nom_corrige2":"Patricia Poissant",
    "nom_famille":"Poissant",
    "titre_genre2":"Conseillère",
    "remuneration":"39316",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"58738",
    "ville":"Saint-Jean-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"100396"
  },
  {
    "ID":562,
    "nom_corrige2":"Stephen Matthews",
    "nom_famille":"Matthews",
    "titre_genre2":"Maire",
    "remuneration":"21980",
    "allocation":"10991",
    "remuneration2":"17254",
    "allocation2":"8452",
    "total":"58677",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":563,
    "nom_corrige2":"Michèle Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"33923",
    "allocation":"17332",
    "remuneration2":"7403",
    "allocation2":"0",
    "total":"58658",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":564,
    "nom_corrige2":"Dominic Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseiller",
    "remuneration":"39870",
    "allocation":"18671",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"58541",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":565,
    "nom_corrige2":"Pascal Binet",
    "nom_famille":"Binet",
    "titre_genre2":"Maire",
    "remuneration":"34202",
    "allocation":"16386",
    "remuneration2":"5172",
    "allocation2":"2586",
    "total":"58346",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":566,
    "nom_corrige2":"Simon Giard",
    "nom_famille":"Giard",
    "titre_genre2":"Maire",
    "remuneration":"15400",
    "allocation":"7700",
    "remuneration2":"23350",
    "allocation2":"11675",
    "total":"58125",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":567,
    "nom_corrige2":"Jean Junior Désormeaux",
    "nom_famille":"Junior Désormeaux",
    "titre_genre2":"Conseiller",
    "remuneration":"40400",
    "allocation":"17582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"57982",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":568,
    "nom_corrige2":"André Marion",
    "nom_famille":"Marion",
    "titre_genre2":"Conseiller",
    "remuneration":"37607",
    "allocation":"20364",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"57971",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":569,
    "nom_corrige2":"Henri Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Maire",
    "remuneration":"38444",
    "allocation":"19222",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"57666",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":570,
    "nom_corrige2":"Carl Talbot",
    "nom_famille":"Talbot",
    "titre_genre2":"Maire suppléant",
    "remuneration":"41665",
    "allocation":"15829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"57494",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":571,
    "nom_corrige2":"Nathacha Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Mairesse",
    "remuneration":"27417",
    "allocation":"13709",
    "remuneration2":"10868",
    "allocation2":"5434",
    "total":"57428",
    "ville":"Saint-Germain-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"5075"
  },
  {
    "ID":572,
    "nom_corrige2":"Carla Pierre-Paul",
    "nom_famille":"Pierre-Paul",
    "titre_genre2":"Conseillère",
    "remuneration":"39612",
    "allocation":"17582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"57194",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":573,
    "nom_corrige2":"Luc Cayer",
    "nom_famille":"Cayer",
    "titre_genre2":"Maire",
    "remuneration":"22711",
    "allocation":"11355",
    "remuneration2":"15278",
    "allocation2":"7645",
    "total":"56989",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":574,
    "nom_corrige2":"René Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Maire",
    "remuneration":"37992",
    "allocation":"18996",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"56988",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":575,
    "nom_corrige2":"Jean-François Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Maire",
    "remuneration":"24281",
    "allocation":"12140",
    "remuneration2":"13656",
    "allocation2":"6828",
    "total":"56905",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":576,
    "nom_corrige2":"Eugène Jolicoeur",
    "nom_famille":"Jolicoeur",
    "titre_genre2":"Conseiller",
    "remuneration":"37864",
    "allocation":"18932",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"56796",
    "ville":"Mascouche",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"56045"
  },
  {
    "ID":577,
    "nom_corrige2":"Martin Pigeon",
    "nom_famille":"Pigeon",
    "titre_genre2":"Conseiller",
    "remuneration":"39190",
    "allocation":"17582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"56772",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":578,
    "nom_corrige2":"Gabrielle Parr",
    "nom_famille":"Parr",
    "titre_genre2":"Mairesse",
    "remuneration":"27580",
    "allocation":"13790",
    "remuneration2":"9893",
    "allocation2":"4946",
    "total":"56209",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":579,
    "nom_corrige2":"Claude Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Maire",
    "remuneration":"24260",
    "allocation":"11567",
    "remuneration2":"13567",
    "allocation2":"6784",
    "total":"56178",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":580,
    "nom_corrige2":"Pierre Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Maire",
    "remuneration":"8153",
    "allocation":"4077",
    "remuneration2":"29139",
    "allocation2":"14570",
    "total":"55939",
    "ville":"Saint-Roch-Ouest",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"289"
  },
  {
    "ID":581,
    "nom_corrige2":"Chantale Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Mairesse",
    "remuneration":"27640",
    "allocation":"13820",
    "remuneration2":"9766",
    "allocation2":"4633",
    "total":"55859",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":582,
    "nom_corrige2":"Karl Lacouvée",
    "nom_famille":"Lacouvée",
    "titre_genre2":"Maire",
    "remuneration":"24375",
    "allocation":"12187",
    "remuneration2":"10851",
    "allocation2":"8135",
    "total":"55548",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":583,
    "nom_corrige2":"Mario Fauteux",
    "nom_famille":"Fauteux",
    "titre_genre2":"Conseiller",
    "remuneration":"37773",
    "allocation":"17582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"55355",
    "ville":"Saint-Jérôme",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84403"
  },
  {
    "ID":584,
    "nom_corrige2":"Cheryl Sage Christensen",
    "nom_famille":"Sage Christensen",
    "titre_genre2":"Mairesse",
    "remuneration":"23572",
    "allocation":"11786",
    "remuneration2":"19885",
    "allocation2":"0",
    "total":"55243",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":585,
    "nom_corrige2":"Mario Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Maire",
    "remuneration":"34566",
    "allocation":"17283",
    "remuneration2":"2114",
    "allocation2":"1057",
    "total":"55020",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":586,
    "nom_corrige2":"Magalie Queval",
    "nom_famille":"Queval",
    "titre_genre2":"Conseillère",
    "remuneration":"35514",
    "allocation":"19422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"54936",
    "ville":"Boucherville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"41840"
  },
  {
    "ID":587,
    "nom_corrige2":"Pierre Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Maire",
    "remuneration":"33025",
    "allocation":"16513",
    "remuneration2":"3315",
    "allocation2":"1657",
    "total":"54510",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":588,
    "nom_corrige2":"Xixi Li",
    "nom_famille":"Li",
    "titre_genre2":"Conseillère",
    "remuneration":"36200",
    "allocation":"18100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"54300",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":589,
    "nom_corrige2":"Claudio Benedetti",
    "nom_famille":"Benedetti",
    "titre_genre2":"Conseiller",
    "remuneration":"36200",
    "allocation":"18100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"54300",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":590,
    "nom_corrige2":"Michelle Hui",
    "nom_famille":"Hui",
    "titre_genre2":"Conseillère",
    "remuneration":"36200",
    "allocation":"18100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"54300",
    "ville":"Brossard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"97292"
  },
  {
    "ID":591,
    "nom_corrige2":"Michel Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Maire",
    "remuneration":"28877",
    "allocation":"14436",
    "remuneration2":"7154",
    "allocation2":"3179",
    "total":"53646",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":592,
    "nom_corrige2":"Christian Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire",
    "remuneration":"11097",
    "allocation":"4856",
    "remuneration2":"25087",
    "allocation2":"12543",
    "total":"53583",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":593,
    "nom_corrige2":"Vincent Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Maire",
    "remuneration":"32597",
    "allocation":"16298",
    "remuneration2":"3013",
    "allocation2":"1607",
    "total":"53515",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":594,
    "nom_corrige2":"Julie Carré",
    "nom_famille":"Carré",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"36694",
    "allocation":"16767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53461",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":595,
    "nom_corrige2":"Guy Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":596,
    "nom_corrige2":"Jacynthe Campagna",
    "nom_famille":"Campagna",
    "titre_genre2":"Conseillère",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":597,
    "nom_corrige2":"Josette Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseillère",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":598,
    "nom_corrige2":"Lucie Debons",
    "nom_famille":"Debons",
    "titre_genre2":"Conseillère",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":599,
    "nom_corrige2":"Christian Hould",
    "nom_famille":"Hould",
    "titre_genre2":"Conseiller",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":600,
    "nom_corrige2":"Jean-Yves Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":601,
    "nom_corrige2":"Louis-Jean Garceau",
    "nom_famille":"Garceau",
    "titre_genre2":"Conseiller",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":602,
    "nom_corrige2":"Nancy Déziel",
    "nom_famille":"Déziel",
    "titre_genre2":"Conseillère",
    "remuneration":"35538",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53307",
    "ville":"Shawinigan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"51561"
  },
  {
    "ID":603,
    "nom_corrige2":"Bruno Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Maire",
    "remuneration":"35537",
    "allocation":"17769",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"53306",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":604,
    "nom_corrige2":"Robert Vyncke",
    "nom_famille":"Vyncke",
    "titre_genre2":"Maire",
    "remuneration":"17156",
    "allocation":"8578",
    "remuneration2":"18367",
    "allocation2":"9183",
    "total":"53284",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":605,
    "nom_corrige2":"Jean René Carrière",
    "nom_famille":"René Carrière",
    "titre_genre2":"Maire",
    "remuneration":"27432",
    "allocation":"13716",
    "remuneration2":"8044",
    "allocation2":"4022",
    "total":"53214",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":606,
    "nom_corrige2":"Jocelyn Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Maire",
    "remuneration":"23436",
    "allocation":"11718",
    "remuneration2":"12009",
    "allocation2":"6004",
    "total":"53167",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":607,
    "nom_corrige2":"Jean-Luc Barthe",
    "nom_famille":"Barthe",
    "titre_genre2":"Maire",
    "remuneration":"24660",
    "allocation":"12335",
    "remuneration2":"10657",
    "allocation2":"5328",
    "total":"52980",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":608,
    "nom_corrige2":"Jacques Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Maire",
    "remuneration":"30305",
    "allocation":"15153",
    "remuneration2":"5190",
    "allocation2":"2295",
    "total":"52943",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":609,
    "nom_corrige2":"Denis Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"36952",
    "allocation":"15837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52789",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":610,
    "nom_corrige2":"Philippe Guilbert",
    "nom_famille":"Guilbert",
    "titre_genre2":"Maire",
    "remuneration":"29311",
    "allocation":"14656",
    "remuneration2":"5681",
    "allocation2":"2838",
    "total":"52486",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":611,
    "nom_corrige2":"Bernard Marion",
    "nom_famille":"Marion",
    "titre_genre2":"Maire",
    "remuneration":"7601",
    "allocation":"3801",
    "remuneration2":"27379",
    "allocation2":"13690",
    "total":"52471",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":612,
    "nom_corrige2":"Germain Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Maire",
    "remuneration":"27264",
    "allocation":"13632",
    "remuneration2":"7600",
    "allocation2":"3800",
    "total":"52296",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":613,
    "nom_corrige2":"Lyne Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Mairesse",
    "remuneration":"32896",
    "allocation":"15962",
    "remuneration2":"2286",
    "allocation2":"1143",
    "total":"52287",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":614,
    "nom_corrige2":"Daniel Tétreault",
    "nom_famille":"Tétreault",
    "titre_genre2":"Maire",
    "remuneration":"11634",
    "allocation":"5817",
    "remuneration2":"23182",
    "allocation2":"11591",
    "total":"52224",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":615,
    "nom_corrige2":"Colette Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Conseillère",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"3744",
    "allocation2":"1872",
    "total":"52056",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":616,
    "nom_corrige2":"Alain Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":617,
    "nom_corrige2":"Catherine Baudin",
    "nom_famille":"Baudin",
    "titre_genre2":"Conseillère",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":618,
    "nom_corrige2":"Denyse Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":619,
    "nom_corrige2":"Félix Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":620,
    "nom_corrige2":"François Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":621,
    "nom_corrige2":"Geneviève Rheault",
    "nom_famille":"Rheault",
    "titre_genre2":"Conseillère",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":622,
    "nom_corrige2":"Paul Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":623,
    "nom_corrige2":"Robert Riel",
    "nom_famille":"Riel",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":624,
    "nom_corrige2":"Robert Vincent",
    "nom_famille":"Vincent",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":625,
    "nom_corrige2":"Stéphane Giard",
    "nom_famille":"Giard",
    "titre_genre2":"Conseiller",
    "remuneration":"34684",
    "allocation":"17342",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"52026",
    "ville":"Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"71572"
  },
  {
    "ID":626,
    "nom_corrige2":"Jason Morrison",
    "nom_famille":"Morrison",
    "titre_genre2":"Maire",
    "remuneration":"24744",
    "allocation":"12372",
    "remuneration2":"9892",
    "allocation2":"4946",
    "total":"51954",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":627,
    "nom_corrige2":"Réjean Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"35208",
    "allocation":"16632",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"51840",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":628,
    "nom_corrige2":"Alain Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"7686",
    "allocation2":"3843",
    "total":"51696",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":629,
    "nom_corrige2":"Anastasia Assimakopoulos",
    "nom_famille":"Assimakopoulos",
    "titre_genre2":"Conseillère",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"6020",
    "allocation2":"2538",
    "total":"51607",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":630,
    "nom_corrige2":"Suzanne Boulais",
    "nom_famille":"Boulais",
    "titre_genre2":"Mairesse",
    "remuneration":"23791",
    "allocation":"11174",
    "remuneration2":"11019",
    "allocation2":"5529",
    "total":"51513",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":631,
    "nom_corrige2":"Vicki Emard",
    "nom_famille":"Emard",
    "titre_genre2":"Mairesse",
    "remuneration":"29345",
    "allocation":"14673",
    "remuneration2":"4897",
    "allocation2":"2448",
    "total":"51363",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":632,
    "nom_corrige2":"Nathalie Lemaire",
    "nom_famille":"Lemaire",
    "titre_genre2":"Mairesse",
    "remuneration":"28529",
    "allocation":"14265",
    "remuneration2":"5693",
    "allocation2":"2846",
    "total":"51333",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":633,
    "nom_corrige2":"Gaëtan Castilloux",
    "nom_famille":"Castilloux",
    "titre_genre2":"Maire",
    "remuneration":"24574",
    "allocation":"12287",
    "remuneration2":"9648",
    "allocation2":"4824",
    "total":"51333",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":634,
    "nom_corrige2":"Olivier Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"34127",
    "allocation":"17063",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"51190",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":635,
    "nom_corrige2":"Andrée Brosseau",
    "nom_famille":"Brosseau",
    "titre_genre2":"Mairesse",
    "remuneration":"26618",
    "allocation":"14209",
    "remuneration2":"9375",
    "allocation2":"900,00$",
    "total":"51102",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":636,
    "nom_corrige2":"Jean-Pierre Charuest",
    "nom_famille":"Charuest",
    "titre_genre2":"Maire",
    "remuneration":"27529",
    "allocation":"13764",
    "remuneration2":"0",
    "allocation2":"9696",
    "total":"50989",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":637,
    "nom_corrige2":"Claude Dalpé",
    "nom_famille":"Dalpé",
    "titre_genre2":"Conseiller",
    "remuneration":"31516",
    "allocation":"15758",
    "remuneration2":"2387",
    "allocation2":"1194",
    "total":"50855",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":638,
    "nom_corrige2":"Sylvie Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"31516",
    "allocation":"15758",
    "remuneration2":"2387",
    "allocation2":"1194",
    "total":"50855",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":639,
    "nom_corrige2":"Serge Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Maire",
    "remuneration":"27595",
    "allocation":"13798",
    "remuneration2":"6272",
    "allocation2":"3136",
    "total":"50801",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":640,
    "nom_corrige2":"Sébastien Hallé",
    "nom_famille":"Hallé",
    "titre_genre2":"Conseiller",
    "remuneration":"22294",
    "allocation":"11147",
    "remuneration2":"17352",
    "allocation2":"0",
    "total":"50793",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":641,
    "nom_corrige2":"Amélie Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"31516",
    "allocation":"15758",
    "remuneration2":"2303",
    "allocation2":"1151",
    "total":"50728",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":642,
    "nom_corrige2":"Dominique Laverdure",
    "nom_famille":"Laverdure",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"33782",
    "allocation":"16891",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"50673",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":643,
    "nom_corrige2":"Dominique Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"32627",
    "allocation":"18013",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"50640",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":644,
    "nom_corrige2":"Julie Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"32862",
    "allocation":"16202",
    "remuneration2":"1248",
    "allocation2":"208,00$",
    "total":"50520",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":645,
    "nom_corrige2":"Jean Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"22313",
    "allocation":"11156",
    "remuneration2":"17025",
    "allocation2":"0",
    "total":"50494",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":646,
    "nom_corrige2":"Marie Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Mairesse",
    "remuneration":"28410",
    "allocation":"14205",
    "remuneration2":"5208",
    "allocation2":"2604",
    "total":"50427",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":647,
    "nom_corrige2":"Karim-André Laz",
    "nom_famille":"Laz",
    "titre_genre2":"Conseiller",
    "remuneration":"33781",
    "allocation":"16202",
    "remuneration2":"245,00$",
    "allocation2":"123,00$",
    "total":"50351",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":648,
    "nom_corrige2":"Daniel Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseiller",
    "remuneration":"33466",
    "allocation":"16733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"50199",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":649,
    "nom_corrige2":"Johnny Salera",
    "nom_famille":"Salera",
    "titre_genre2":"Maire",
    "remuneration":"33450",
    "allocation":"16725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"50175",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":650,
    "nom_corrige2":"Vincent Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseiller",
    "remuneration":"34131",
    "allocation":"16042",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"50173",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":651,
    "nom_corrige2":"Charlotte Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"33245",
    "allocation":"16622",
    "remuneration2":"202,00$",
    "allocation2":"101,00$",
    "total":"50170",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":652,
    "nom_corrige2":"Louise Allie",
    "nom_famille":"Allie",
    "titre_genre2":"Conseillère",
    "remuneration":"32495",
    "allocation":"16202",
    "remuneration2":"937,00$",
    "allocation2":"468,00$",
    "total":"50102",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":653,
    "nom_corrige2":"Guy Lafrenière",
    "nom_famille":"Lafrenière",
    "titre_genre2":"Maire",
    "remuneration":"33400",
    "allocation":"16700",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"50100",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":654,
    "nom_corrige2":"Martin Dubreuil",
    "nom_famille":"Dubreuil",
    "titre_genre2":"Conseiller",
    "remuneration":"32403",
    "allocation":"16202",
    "remuneration2":"932,00$",
    "allocation2":"466,00$",
    "total":"50003",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":655,
    "nom_corrige2":"Stéphane Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Conseiller",
    "remuneration":"33781",
    "allocation":"16202",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49983",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":656,
    "nom_corrige2":"Vincent Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Conseiller",
    "remuneration":"33689",
    "allocation":"16202",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49891",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":657,
    "nom_corrige2":"Benoît Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"1486",
    "allocation2":"743,00$",
    "total":"49856",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":658,
    "nom_corrige2":"Corina Lupu",
    "nom_famille":"Lupu",
    "titre_genre2":"Mairesse",
    "remuneration":"19377",
    "allocation":"9688",
    "remuneration2":"13858",
    "allocation2":"6932",
    "total":"49855",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":659,
    "nom_corrige2":"Michel Péloquin",
    "nom_famille":"Péloquin",
    "titre_genre2":"Maire",
    "remuneration":"23957",
    "allocation":"11978",
    "remuneration2":"9921",
    "allocation2":"3909",
    "total":"49765",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":660,
    "nom_corrige2":"Stéphane Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Maire",
    "remuneration":"25377",
    "allocation":"12688",
    "remuneration2":"7796",
    "allocation2":"3898",
    "total":"49759",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":661,
    "nom_corrige2":"Jocelyn Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"29883",
    "allocation":"14908",
    "remuneration2":"3290",
    "allocation2":"1645",
    "total":"49726",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":662,
    "nom_corrige2":"Bernard Barré",
    "nom_famille":"Barré",
    "titre_genre2":"Conseiller",
    "remuneration":"30977",
    "allocation":"16159",
    "remuneration2":"1715",
    "allocation2":"857,00$",
    "total":"49708",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":663,
    "nom_corrige2":"Pierre Désaulniers",
    "nom_famille":"Désaulniers",
    "titre_genre2":"Maire",
    "remuneration":"25955",
    "allocation":"12977",
    "remuneration2":"7163",
    "allocation2":"3581",
    "total":"49676",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":664,
    "nom_corrige2":"Pierre Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"30977",
    "allocation":"16159",
    "remuneration2":"1687",
    "allocation2":"843,00$",
    "total":"49666",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":665,
    "nom_corrige2":"Mario Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Maire",
    "remuneration":"20856",
    "allocation":"10428",
    "remuneration2":"12252",
    "allocation2":"6126",
    "total":"49662",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":666,
    "nom_corrige2":"Renée Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Conseillère",
    "remuneration":"33322",
    "allocation":"16202",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49524",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":667,
    "nom_corrige2":"Arlene Vassan Bryant",
    "nom_famille":"Vassan Bryant",
    "titre_genre2":"Conseillère",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":668,
    "nom_corrige2":"Marie-Louise Kerneis Gentric",
    "nom_famille":"Kerneis Gentric",
    "titre_genre2":"Conseillère",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":669,
    "nom_corrige2":"Michel J. Gendron",
    "nom_famille":"J. Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":670,
    "nom_corrige2":"Barry Doyle",
    "nom_famille":"Doyle",
    "titre_genre2":"Conseiller",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":671,
    "nom_corrige2":"Éric Corbeil",
    "nom_famille":"Corbeil",
    "titre_genre2":"Conseiller",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":672,
    "nom_corrige2":"Luc Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Conseiller",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":673,
    "nom_corrige2":"Lucie Laberge",
    "nom_famille":"Laberge",
    "titre_genre2":"Conseillère",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":674,
    "nom_corrige2":"François Le Borgne",
    "nom_famille":"Le Borgne",
    "titre_genre2":"Conseiller",
    "remuneration":"32993",
    "allocation":"16497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49490",
    "ville":"Châteauguay",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"53030"
  },
  {
    "ID":675,
    "nom_corrige2":"Patrick Paulin",
    "nom_famille":"Paulin",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"1081",
    "allocation2":"540,00$",
    "total":"49248",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":676,
    "nom_corrige2":"Frédéric Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"6050",
    "allocation2":"3025",
    "total":"49242",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":677,
    "nom_corrige2":"Cynthia Homan",
    "nom_famille":"Homan",
    "titre_genre2":"Conseillère",
    "remuneration":"32797",
    "allocation":"16398",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49195",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":678,
    "nom_corrige2":"Kelly Thorstad-Cullen",
    "nom_famille":"Thorstad-Cullen",
    "titre_genre2":"Conseillère",
    "remuneration":"32797",
    "allocation":"16398",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49195",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":679,
    "nom_corrige2":"Bruno Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"32797",
    "allocation":"16398",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"49195",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":680,
    "nom_corrige2":"Tanya Rutman",
    "nom_famille":"Rutman",
    "titre_genre2":"Conseillère",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"3018",
    "allocation2":"3009",
    "total":"49076",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":681,
    "nom_corrige2":"Louis Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"5920",
    "allocation2":"2960",
    "total":"49047",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":682,
    "nom_corrige2":"Yves Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Maire",
    "remuneration":"31909",
    "allocation":"15954",
    "remuneration2":"765,00$",
    "allocation2":"382,00$",
    "total":"49010",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":683,
    "nom_corrige2":"Cecilia Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":684,
    "nom_corrige2":"Philippe Cousineau-Morin",
    "nom_famille":"Cousineau-Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":685,
    "nom_corrige2":"Dave Dumas",
    "nom_famille":"Dumas",
    "titre_genre2":"Conseiller",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":686,
    "nom_corrige2":"Grégory Thorez",
    "nom_famille":"Thorez",
    "titre_genre2":"Conseiller",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":687,
    "nom_corrige2":"Jocelyn Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":688,
    "nom_corrige2":"Mélanie Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":689,
    "nom_corrige2":"Mélanie Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseillère",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":690,
    "nom_corrige2":"Sébastien Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseiller",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":691,
    "nom_corrige2":"Rodrigue Joncas",
    "nom_famille":"Joncas",
    "titre_genre2":"Conseiller",
    "remuneration":"33150",
    "allocation":"15763",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48913",
    "ville":"Rimouski",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"51188"
  },
  {
    "ID":692,
    "nom_corrige2":"Audrée Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseillère",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"5791",
    "allocation2":"2896",
    "total":"48854",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":693,
    "nom_corrige2":"Huguette Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Mairesse",
    "remuneration":"25950",
    "allocation":"12975",
    "remuneration2":"6616",
    "allocation2":"3308",
    "total":"48849",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":694,
    "nom_corrige2":"Yannick Fréchette",
    "nom_famille":"Fréchette",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"743,00$",
    "allocation2":"372,00$",
    "total":"48742",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":695,
    "nom_corrige2":"Anne Scott",
    "nom_famille":"Scott",
    "titre_genre2":"Conseillère",
    "remuneration":"32418",
    "allocation":"16207",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48625",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":696,
    "nom_corrige2":"Martin Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseiller",
    "remuneration":"32403",
    "allocation":"16202",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48605",
    "ville":"Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"25149"
  },
  {
    "ID":697,
    "nom_corrige2":"Marc Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"608,00$",
    "allocation2":"304,00$",
    "total":"48539",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":698,
    "nom_corrige2":"Pierre Janecek",
    "nom_famille":"Janecek",
    "titre_genre2":"Maire",
    "remuneration":"23144",
    "allocation":"11572",
    "remuneration2":"9182",
    "allocation2":"4591",
    "total":"48489",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":699,
    "nom_corrige2":"Robert Le Sage",
    "nom_famille":"Le Sage",
    "titre_genre2":"Conseiller",
    "remuneration":"33888",
    "allocation":"14448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48336",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":700,
    "nom_corrige2":"Alexandre Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"405,00$",
    "allocation2":"203,00$",
    "total":"48235",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":701,
    "nom_corrige2":"Tara Stainforth",
    "nom_famille":"Stainforth",
    "titre_genre2":"Conseillère",
    "remuneration":"32146",
    "allocation":"16073",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"48219",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":702,
    "nom_corrige2":"Bernard Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Maire",
    "remuneration":"19832",
    "allocation":"9791",
    "remuneration2":"12374",
    "allocation2":"6187",
    "total":"48184",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":703,
    "nom_corrige2":"Yanick Poisson",
    "nom_famille":"Poisson",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"338,00$",
    "allocation2":"169,00$",
    "total":"48134",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":704,
    "nom_corrige2":"Patrick Archambeault",
    "nom_famille":"Archambeault",
    "titre_genre2":"Conseiller",
    "remuneration":"28895",
    "allocation":"14431",
    "remuneration2":"3177",
    "allocation2":"1588",
    "total":"48091",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":705,
    "nom_corrige2":"Julie Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Mairesse",
    "remuneration":"20800",
    "allocation":"12933",
    "remuneration2":"14308",
    "allocation2":"0",
    "total":"48041",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":706,
    "nom_corrige2":"Sylvie Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"31127",
    "allocation":"15563",
    "remuneration2":"881,00$",
    "allocation2":"440,00$",
    "total":"48011",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":707,
    "nom_corrige2":"André Arpin",
    "nom_famille":"Arpin",
    "titre_genre2":"Conseiller",
    "remuneration":"31827",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47986",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":708,
    "nom_corrige2":"Claire Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseillère",
    "remuneration":"31827",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47986",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":709,
    "nom_corrige2":"Michael Provencher",
    "nom_famille":"Provencher",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"135,00$",
    "allocation2":"68,00$",
    "total":"47830",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":710,
    "nom_corrige2":"Marie-Elaine Pitre",
    "nom_famille":"Pitre",
    "titre_genre2":"Conseillère",
    "remuneration":"31821",
    "allocation":"15910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47731",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":711,
    "nom_corrige2":"James Casey",
    "nom_famille":"Casey",
    "titre_genre2":"Conseiller",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"68,00$",
    "allocation2":"34,00$",
    "total":"47729",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":712,
    "nom_corrige2":"Susan Rasmussen",
    "nom_famille":"Rasmussen",
    "titre_genre2":"Conseillère",
    "remuneration":"31752",
    "allocation":"15877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47629",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":713,
    "nom_corrige2":"Caroline Pilon",
    "nom_famille":"Pilon",
    "titre_genre2":"Conseillère",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47627",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":714,
    "nom_corrige2":"Chantal Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Conseillère",
    "remuneration":"31751",
    "allocation":"15876",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47627",
    "ville":"Victoriaville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"49750"
  },
  {
    "ID":715,
    "nom_corrige2":"Patrick Bouillé",
    "nom_famille":"Bouillé",
    "titre_genre2":"Maire",
    "remuneration":"27122",
    "allocation":"13561",
    "remuneration2":"4652",
    "allocation2":"2231",
    "total":"47566",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":716,
    "nom_corrige2":"David Bousquet",
    "nom_famille":"Bousquet",
    "titre_genre2":"Conseiller",
    "remuneration":"31327",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47486",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":717,
    "nom_corrige2":"Stéphanie Nantel",
    "nom_famille":"Nantel",
    "titre_genre2":"Conseillère",
    "remuneration":"31601",
    "allocation":"15800",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47401",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":718,
    "nom_corrige2":"Mélanie Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"31227",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47386",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":719,
    "nom_corrige2":"Annie Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"30977",
    "allocation":"16159",
    "remuneration2":"161,00$",
    "allocation2":"80,00$",
    "total":"47377",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":720,
    "nom_corrige2":"Donald Coté",
    "nom_famille":"Coté",
    "titre_genre2":"Conseiller",
    "remuneration":"31177",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47336",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":721,
    "nom_corrige2":"Guylain Coulombe",
    "nom_famille":"Coulombe",
    "titre_genre2":"Conseiller",
    "remuneration":"30977",
    "allocation":"16159",
    "remuneration2":"80,00$",
    "allocation2":"40,00$",
    "total":"47256",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":722,
    "nom_corrige2":"Eric Stork",
    "nom_famille":"Stork",
    "titre_genre2":"Conseiller",
    "remuneration":"31495",
    "allocation":"15747",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47242",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":723,
    "nom_corrige2":"David Olivier Huard",
    "nom_famille":"Olivier Huard",
    "titre_genre2":"Conseiller",
    "remuneration":"31077",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47236",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":724,
    "nom_corrige2":"Jeannot Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"30977",
    "allocation":"16159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47136",
    "ville":"Saint-Hyacinthe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"60847"
  },
  {
    "ID":725,
    "nom_corrige2":"Jean-Michel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"31370",
    "allocation":"15681",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"47051",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":726,
    "nom_corrige2":"André Descôteaux",
    "nom_famille":"Descôteaux",
    "titre_genre2":"Maire",
    "remuneration":"25113",
    "allocation":"12556",
    "remuneration2":"8224",
    "allocation2":"1107",
    "total":"47000",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":727,
    "nom_corrige2":"Joël Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"30831",
    "allocation":"15416",
    "remuneration2":"421,00$",
    "allocation2":"210,00$",
    "total":"46878",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":728,
    "nom_corrige2":"Denis Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Conseiller",
    "remuneration":"21813",
    "allocation":"10907",
    "remuneration2":"9431",
    "allocation2":"4716",
    "total":"46867",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":729,
    "nom_corrige2":"Martine Guilbault",
    "nom_famille":"Guilbault",
    "titre_genre2":"Conseiller",
    "remuneration":"29883",
    "allocation":"14908",
    "remuneration2":"1292",
    "allocation2":"646,00$",
    "total":"46729",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":730,
    "nom_corrige2":"Mathieu Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"31127",
    "allocation":"15563",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46690",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":731,
    "nom_corrige2":"Stéphane Béland",
    "nom_famille":"Béland",
    "titre_genre2":"Conseiller",
    "remuneration":"31127",
    "allocation":"15563",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46690",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":732,
    "nom_corrige2":"Martin Lajeunesse",
    "nom_famille":"Lajeunesse",
    "titre_genre2":"Conseiller",
    "remuneration":"31127",
    "allocation":"15563",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46690",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":733,
    "nom_corrige2":"Jacques Laurendeau",
    "nom_famille":"Laurendeau",
    "titre_genre2":"Maire suppléant",
    "remuneration":"32595",
    "allocation":"13785",
    "remuneration2":"194,00$",
    "allocation2":"97,00$",
    "total":"46671",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":734,
    "nom_corrige2":"Hugo Berthelet",
    "nom_famille":"Berthelet",
    "titre_genre2":"Conseiller",
    "remuneration":"31583",
    "allocation":"14702",
    "remuneration2":"382,00$",
    "allocation2":"0",
    "total":"46667",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":735,
    "nom_corrige2":"Patrice Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"32060",
    "allocation":"14559",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46619",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":736,
    "nom_corrige2":"Philip Panet-Raymond",
    "nom_famille":"Panet-Raymond",
    "titre_genre2":"Conseiller",
    "remuneration":"27128",
    "allocation":"13564",
    "remuneration2":"3876",
    "allocation2":"1938",
    "total":"46506",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":737,
    "nom_corrige2":"Guylaine Lejeune",
    "nom_famille":"Lejeune",
    "titre_genre2":"Conseillère",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"6247",
    "allocation2":"3124",
    "total":"46491",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":738,
    "nom_corrige2":"Catherine Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseillère",
    "remuneration":"30964",
    "allocation":"15482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46446",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":739,
    "nom_corrige2":"Yves Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"31942",
    "allocation":"14501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46443",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":740,
    "nom_corrige2":"Jean-François Molnar",
    "nom_famille":"Molnar",
    "titre_genre2":"Conseiller",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46440",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":741,
    "nom_corrige2":"Anny Legendre",
    "nom_famille":"Legendre",
    "titre_genre2":"Conseillère",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46440",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":742,
    "nom_corrige2":"Jean-Philippe Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46440",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":743,
    "nom_corrige2":"Justin Carey",
    "nom_famille":"Carey",
    "titre_genre2":"Conseiller",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46440",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":744,
    "nom_corrige2":"Serge Savoie",
    "nom_famille":"Savoie",
    "titre_genre2":"Conseiller",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46440",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":745,
    "nom_corrige2":"Luc Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Conseiller",
    "remuneration":"30960",
    "allocation":"15480",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46440",
    "ville":"Chambly",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"31938"
  },
  {
    "ID":746,
    "nom_corrige2":"Claude Cousineau",
    "nom_famille":"Cousineau",
    "titre_genre2":"Conseillère",
    "remuneration":"30844",
    "allocation":"15422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46266",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":747,
    "nom_corrige2":"Brent Cowan",
    "nom_famille":"Cowan",
    "titre_genre2":"Conseiller",
    "remuneration":"30844",
    "allocation":"15422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46266",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":748,
    "nom_corrige2":"Paul Bissonnette",
    "nom_famille":"Bissonnette",
    "titre_genre2":"Conseiller",
    "remuneration":"30844",
    "allocation":"15422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46266",
    "ville":"Pointe-Claire",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"36255"
  },
  {
    "ID":749,
    "nom_corrige2":"Richard Belhumeur",
    "nom_famille":"Belhumeur",
    "titre_genre2":"Maire",
    "remuneration":"30851",
    "allocation":"15403",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46254",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":750,
    "nom_corrige2":"Billie-Jeanne Graton",
    "nom_famille":"Graton",
    "titre_genre2":"Conseillère",
    "remuneration":"30831",
    "allocation":"15416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46247",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":751,
    "nom_corrige2":"Guylaine Lyras",
    "nom_famille":"Lyras",
    "titre_genre2":"Conseillère",
    "remuneration":"30831",
    "allocation":"15416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46247",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":752,
    "nom_corrige2":"Roxanne Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseillère",
    "remuneration":"30831",
    "allocation":"15416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46247",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":753,
    "nom_corrige2":"Tyler Cook",
    "nom_famille":"Cook",
    "titre_genre2":"Conseiller",
    "remuneration":"30831",
    "allocation":"15416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46247",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":754,
    "nom_corrige2":"Sylvie Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseillère",
    "remuneration":"30831",
    "allocation":"15416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46247",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":755,
    "nom_corrige2":"Roch Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Maire",
    "remuneration":"33804",
    "allocation":"9860",
    "remuneration2":"2574",
    "allocation2":"0",
    "total":"46238",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":756,
    "nom_corrige2":"Josée Marc-Aurèle",
    "nom_famille":"Marc-Aurèle",
    "titre_genre2":"Conseillère",
    "remuneration":"30805",
    "allocation":"15403",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"46208",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":757,
    "nom_corrige2":"Julie Simoneau",
    "nom_famille":"Simoneau",
    "titre_genre2":"Conseillère",
    "remuneration":"31884",
    "allocation":"14113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45997",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":758,
    "nom_corrige2":"Nancy Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseillère",
    "remuneration":"28873",
    "allocation":"14437",
    "remuneration2":"1772",
    "allocation2":"886,00$",
    "total":"45968",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":759,
    "nom_corrige2":"Jean-Guy Galipeau",
    "nom_famille":"Galipeau",
    "titre_genre2":"Maire",
    "remuneration":"26771",
    "allocation":"10520",
    "remuneration2":"5783",
    "allocation2":"2892",
    "total":"45966",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":760,
    "nom_corrige2":"Catherine Craig-St-Louis",
    "nom_famille":"Craig-St-Louis",
    "titre_genre2":"Conseillère",
    "remuneration":"35999",
    "allocation":"9263",
    "remuneration2":"600,00$",
    "allocation2":"0",
    "total":"45862",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":761,
    "nom_corrige2":"Sylvie Major",
    "nom_famille":"Major",
    "titre_genre2":"Conseillère",
    "remuneration":"31745",
    "allocation":"14113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45858",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":762,
    "nom_corrige2":"Marie Eve Pante-Hébert",
    "nom_famille":"Eve Pante-Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"31736",
    "allocation":"14113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45849",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":763,
    "nom_corrige2":"Solange Morneau",
    "nom_famille":"Morneau",
    "titre_genre2":"Mairesse",
    "remuneration":"26884",
    "allocation":"13442",
    "remuneration2":"3668",
    "allocation2":"1834",
    "total":"45828",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":764,
    "nom_corrige2":"Karine Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseillère",
    "remuneration":"31684",
    "allocation":"14113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45797",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":765,
    "nom_corrige2":"Pierre Thauvette",
    "nom_famille":"Thauvette",
    "titre_genre2":"Maire",
    "remuneration":"20565",
    "allocation":"10303",
    "remuneration2":"9893",
    "allocation2":"4946",
    "total":"45707",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":766,
    "nom_corrige2":"Isabelle Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"31420",
    "allocation":"14239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45659",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":767,
    "nom_corrige2":"Jean-Paul Descoeurs",
    "nom_famille":"Descoeurs",
    "titre_genre2":"Maire",
    "remuneration":"24328",
    "allocation":"12164",
    "remuneration2":"6104",
    "allocation2":"3052",
    "total":"45648",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":768,
    "nom_corrige2":"Chantal Goyette",
    "nom_famille":"Goyette",
    "titre_genre2":"Conseillère",
    "remuneration":"30322",
    "allocation":"15155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45477",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":769,
    "nom_corrige2":"Kevin Vocino",
    "nom_famille":"Vocino",
    "titre_genre2":"Conseiller",
    "remuneration":"30322",
    "allocation":"15155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45477",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":770,
    "nom_corrige2":"Marie-Josée Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseillère",
    "remuneration":"30322",
    "allocation":"15155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45477",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":771,
    "nom_corrige2":"Mélanie Roldan",
    "nom_famille":"Roldan",
    "titre_genre2":"Conseillère",
    "remuneration":"30322",
    "allocation":"15155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45477",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":772,
    "nom_corrige2":"Vincent Chatel",
    "nom_famille":"Chatel",
    "titre_genre2":"Conseiller",
    "remuneration":"30322",
    "allocation":"15155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45477",
    "ville":"Candiac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"24445"
  },
  {
    "ID":773,
    "nom_corrige2":"Nicole Duschatel",
    "nom_famille":"Duschatel",
    "titre_genre2":"Conseillère",
    "remuneration":"31001",
    "allocation":"14448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45449",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":774,
    "nom_corrige2":"Alain Chapdelaine",
    "nom_famille":"Chapdelaine",
    "titre_genre2":"Maire",
    "remuneration":"18818",
    "allocation":"9409",
    "remuneration2":"13269",
    "allocation2":"3909",
    "total":"45405",
    "ville":"Saint-Roch-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2878"
  },
  {
    "ID":775,
    "nom_corrige2":"Nathalie Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseillère",
    "remuneration":"27903",
    "allocation":"13051",
    "remuneration2":"2962",
    "allocation2":"1481",
    "total":"45397",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":776,
    "nom_corrige2":"Bertrand Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Maire",
    "remuneration":"25001",
    "allocation":"12501",
    "remuneration2":"5238",
    "allocation2":"2619",
    "total":"45359",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":777,
    "nom_corrige2":"Brigitte Collin",
    "nom_famille":"Collin",
    "titre_genre2":"Conseillère",
    "remuneration":"28703",
    "allocation":"13051",
    "remuneration2":"2616",
    "allocation2":"818,00$",
    "total":"45188",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":778,
    "nom_corrige2":"Sylvain Dubuc",
    "nom_famille":"Dubuc",
    "titre_genre2":"Conseiller",
    "remuneration":"30095",
    "allocation":"15047",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"45142",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":779,
    "nom_corrige2":"Daniel Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Maire",
    "remuneration":"23296",
    "allocation":"11648",
    "remuneration2":"6782",
    "allocation2":"3391",
    "total":"45117",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":780,
    "nom_corrige2":"Gabriel Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Maire",
    "remuneration":"21797",
    "allocation":"10899",
    "remuneration2":"12412",
    "allocation2":"0",
    "total":"45108",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":781,
    "nom_corrige2":"Luc Cauchon",
    "nom_famille":"Cauchon",
    "titre_genre2":"Maire",
    "remuneration":"19895",
    "allocation":"9947",
    "remuneration2":"10155",
    "allocation2":"5078",
    "total":"45075",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":782,
    "nom_corrige2":"Isabelle Mattioli",
    "nom_famille":"Mattioli",
    "titre_genre2":"Conseillère",
    "remuneration":"30961",
    "allocation":"14010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44971",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":783,
    "nom_corrige2":"Marc Tassé",
    "nom_famille":"Tassé",
    "titre_genre2":"Maire suppléant",
    "remuneration":"30333",
    "allocation":"14622",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44955",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":784,
    "nom_corrige2":"Christian Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Maire",
    "remuneration":"19189",
    "allocation":"9594",
    "remuneration2":"10638",
    "allocation2":"5319",
    "total":"44740",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":785,
    "nom_corrige2":"Roseanna Cirino",
    "nom_famille":"Cirino",
    "titre_genre2":"Conseillère",
    "remuneration":"27690",
    "allocation":"13845",
    "remuneration2":"2118",
    "allocation2":"1059",
    "total":"44712",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":786,
    "nom_corrige2":"Jody Stone",
    "nom_famille":"Stone",
    "titre_genre2":"Maire",
    "remuneration":"19444",
    "allocation":"9366",
    "remuneration2":"10512",
    "allocation2":"5256",
    "total":"44578",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":787,
    "nom_corrige2":"Sophie Galarneau",
    "nom_famille":"Galarneau",
    "titre_genre2":"Mairesse",
    "remuneration":"29700",
    "allocation":"14850",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44550",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":788,
    "nom_corrige2":"Eugène Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Maire",
    "remuneration":"23550",
    "allocation":"11775",
    "remuneration2":"6122",
    "allocation2":"3061",
    "total":"44508",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":789,
    "nom_corrige2":"Ryan Anthony Browstein",
    "nom_famille":"Anthony Browstein",
    "titre_genre2":"Conseiller",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"1003",
    "allocation2":"427,00$",
    "total":"44479",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":790,
    "nom_corrige2":"Maryon Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Maire",
    "remuneration":"24399",
    "allocation":"12199",
    "remuneration2":"5317",
    "allocation2":"2549",
    "total":"44464",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":791,
    "nom_corrige2":"Antonin Brunet",
    "nom_famille":"Brunet",
    "titre_genre2":"Maire",
    "remuneration":"21776",
    "allocation":"10533",
    "remuneration2":"8094",
    "allocation2":"4047",
    "total":"44450",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":792,
    "nom_corrige2":"Christian Huard",
    "nom_famille":"Huard",
    "titre_genre2":"Conseiller",
    "remuneration":"29384",
    "allocation":"14692",
    "remuneration2":"245,00$",
    "allocation2":"123,00$",
    "total":"44444",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":793,
    "nom_corrige2":"Anita Ouellet Castonguay",
    "nom_famille":"Ouellet Castonguay",
    "titre_genre2":"Mairesse",
    "remuneration":"15537",
    "allocation":"15537",
    "remuneration2":"8892",
    "allocation2":"4446",
    "total":"44412",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":794,
    "nom_corrige2":"Majella Pichette",
    "nom_famille":"Pichette",
    "titre_genre2":"Maire",
    "remuneration":"17253",
    "allocation":"8626",
    "remuneration2":"12252",
    "allocation2":"6126",
    "total":"44257",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":795,
    "nom_corrige2":"Gustave Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Maire",
    "remuneration":"26273",
    "allocation":"9972",
    "remuneration2":"6449",
    "allocation2":"1445",
    "total":"44139",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":796,
    "nom_corrige2":"Sylvie Mallette",
    "nom_famille":"Mallette",
    "titre_genre2":"Conseillère",
    "remuneration":"30402",
    "allocation":"13730",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44132",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":797,
    "nom_corrige2":"Michèle Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"30402",
    "allocation":"13730",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44132",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":798,
    "nom_corrige2":"Daniel Goyer",
    "nom_famille":"Goyer",
    "titre_genre2":"Conseiller",
    "remuneration":"30402",
    "allocation":"13730",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44132",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":799,
    "nom_corrige2":"Marc Lamarre",
    "nom_famille":"Lamarre",
    "titre_genre2":"Conseiller",
    "remuneration":"30402",
    "allocation":"13730",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44132",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":800,
    "nom_corrige2":"Raymond Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"30402",
    "allocation":"13730",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44132",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":801,
    "nom_corrige2":"Nicole Carignan Lefebvre",
    "nom_famille":"Carignan Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"30402",
    "allocation":"13730",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44132",
    "ville":"Saint-Eustache",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"47499"
  },
  {
    "ID":802,
    "nom_corrige2":"Jean-Marc Bousquet",
    "nom_famille":"Bousquet",
    "titre_genre2":"Maire",
    "remuneration":"17369",
    "allocation":"8684",
    "remuneration2":"12081",
    "allocation2":"5967",
    "total":"44101",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":803,
    "nom_corrige2":"Lucie Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Conseillère",
    "remuneration":"29384",
    "allocation":"14692",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44076",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":804,
    "nom_corrige2":"Éric Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseiller",
    "remuneration":"29384",
    "allocation":"14692",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"44076",
    "ville":"Sainte-Julie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"30917"
  },
  {
    "ID":805,
    "nom_corrige2":"Nathalie Bresse",
    "nom_famille":"Bresse",
    "titre_genre2":"Maire",
    "remuneration":"25821",
    "allocation":"12910",
    "remuneration2":"3516",
    "allocation2":"1758",
    "total":"44005",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":806,
    "nom_corrige2":"Caroline Decaluwe",
    "nom_famille":"Decaluwe",
    "titre_genre2":"Conseillère",
    "remuneration":"31200",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43925",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":807,
    "nom_corrige2":"Benoit Guévremont",
    "nom_famille":"Guévremont",
    "titre_genre2":"Conseiller",
    "remuneration":"28910",
    "allocation":"15001",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43911",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":808,
    "nom_corrige2":"Marc-André Savaria",
    "nom_famille":"Savaria",
    "titre_genre2":"Conseiller",
    "remuneration":"27903",
    "allocation":"13051",
    "remuneration2":"1953",
    "allocation2":"977,00$",
    "total":"43884",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":809,
    "nom_corrige2":"Joey Leckman",
    "nom_famille":"Leckman",
    "titre_genre2":"Maire suppléant",
    "remuneration":"34339",
    "allocation":"9468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43807",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":810,
    "nom_corrige2":"Christopher von Roretz",
    "nom_famille":"von Roretz",
    "titre_genre2":"Conseiller",
    "remuneration":"29328",
    "allocation":"14448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43776",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":811,
    "nom_corrige2":"Paul Trudeau",
    "nom_famille":"Trudeau",
    "titre_genre2":"Conseiller",
    "remuneration":"29328",
    "allocation":"14448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43776",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":812,
    "nom_corrige2":"Brigitte Voss",
    "nom_famille":"Voss",
    "titre_genre2":"Conseillère",
    "remuneration":"29083",
    "allocation":"14542",
    "remuneration2":"100,00$",
    "allocation2":"0",
    "total":"43725",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":813,
    "nom_corrige2":"Nathalie Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseillère",
    "remuneration":"29083",
    "allocation":"14542",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43625",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":814,
    "nom_corrige2":"Sylvain Marinier",
    "nom_famille":"Marinier",
    "titre_genre2":"Conseiller",
    "remuneration":"29083",
    "allocation":"14542",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43625",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":815,
    "nom_corrige2":"Chantal Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"29083",
    "allocation":"14542",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43625",
    "ville":"Sainte-Agathe-des-Monts",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12014"
  },
  {
    "ID":816,
    "nom_corrige2":"Jocelyn Mondou",
    "nom_famille":"Mondou",
    "titre_genre2":"Conseiller",
    "remuneration":"28127",
    "allocation":"14063",
    "remuneration2":"881,00$",
    "allocation2":"440,00$",
    "total":"43511",
    "ville":"Sorel-Tracy",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"36249"
  },
  {
    "ID":817,
    "nom_corrige2":"Lyne Rémillard",
    "nom_famille":"Rémillard",
    "titre_genre2":"Conseillère",
    "remuneration":"28639",
    "allocation":"14321",
    "remuneration2":"323,00$",
    "allocation2":"161,00$",
    "total":"43444",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":818,
    "nom_corrige2":"Guy Berthe",
    "nom_famille":"Berthe",
    "titre_genre2":"Conseiller",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"4167",
    "allocation2":"2083",
    "total":"43370",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":819,
    "nom_corrige2":"Jean-François Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseiller",
    "remuneration":"28896",
    "allocation":"14448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43344",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":820,
    "nom_corrige2":"Pascal Brault",
    "nom_famille":"Brault",
    "titre_genre2":"Conseiller",
    "remuneration":"28896",
    "allocation":"14448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43344",
    "ville":"Dorval",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20765"
  },
  {
    "ID":821,
    "nom_corrige2":"Michèle Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseillère",
    "remuneration":"33751",
    "allocation":"9468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43219",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":822,
    "nom_corrige2":"Daniel Pilon",
    "nom_famille":"Pilon",
    "titre_genre2":"Conseiller",
    "remuneration":"30450",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43175",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":823,
    "nom_corrige2":"Yves Métras",
    "nom_famille":"Métras",
    "titre_genre2":"Maire",
    "remuneration":"22088",
    "allocation":"10988",
    "remuneration2":"6695",
    "allocation2":"3348",
    "total":"43119",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":824,
    "nom_corrige2":"Pier-Luc Laurin",
    "nom_famille":"Laurin",
    "titre_genre2":"Conseiller",
    "remuneration":"33617",
    "allocation":"9468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43085",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":825,
    "nom_corrige2":"Morris Vesely",
    "nom_famille":"Vesely",
    "titre_genre2":"Conseiller",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43049",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":826,
    "nom_corrige2":"Mickey Max Guttman",
    "nom_famille":"Max Guttman",
    "titre_genre2":"Conseiller",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43049",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":827,
    "nom_corrige2":"Laurence Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43049",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":828,
    "nom_corrige2":"Errol Johnson",
    "nom_famille":"Johnson",
    "titre_genre2":"Conseiller",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43049",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":829,
    "nom_corrige2":"Valerie Assouline",
    "nom_famille":"Assouline",
    "titre_genre2":"Conseillère",
    "remuneration":"28699",
    "allocation":"14350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"43049",
    "ville":"Dollard-des-Ormeaux",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"50699"
  },
  {
    "ID":830,
    "nom_corrige2":"Daniel Aucoin",
    "nom_famille":"Aucoin",
    "titre_genre2":"Conseiller",
    "remuneration":"28640",
    "allocation":"14320",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42960",
    "ville":"Terrebonne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"124919"
  },
  {
    "ID":831,
    "nom_corrige2":"Sylvain Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Maire",
    "remuneration":"26750",
    "allocation":"13375",
    "remuneration2":"1864",
    "allocation2":"935,00$",
    "total":"42924",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":832,
    "nom_corrige2":"Paule Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseillère",
    "remuneration":"28665",
    "allocation":"14113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42778",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":833,
    "nom_corrige2":"Patrick Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseiller",
    "remuneration":"28665",
    "allocation":"14113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42778",
    "ville":"La Prairie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"27117"
  },
  {
    "ID":834,
    "nom_corrige2":"Gaétan Marcil",
    "nom_famille":"Marcil",
    "titre_genre2":"Conseiller",
    "remuneration":"26103",
    "allocation":"13051",
    "remuneration2":"2387",
    "allocation2":"1194",
    "total":"42735",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":835,
    "nom_corrige2":"Thomas Arnold",
    "nom_famille":"Arnold",
    "titre_genre2":"Maire",
    "remuneration":"18657",
    "allocation":"9720",
    "remuneration2":"9567",
    "allocation2":"4784",
    "total":"42728",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":836,
    "nom_corrige2":"Roger Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Maire",
    "remuneration":"15867",
    "allocation":"7933",
    "remuneration2":"12331",
    "allocation2":"6577",
    "total":"42708",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":837,
    "nom_corrige2":"Alain Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Maire",
    "remuneration":"20268",
    "allocation":"10134",
    "remuneration2":"8192",
    "allocation2":"4048",
    "total":"42642",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":838,
    "nom_corrige2":"Benjamin Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Maire suppléant",
    "remuneration":"29824",
    "allocation":"12764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42588",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":839,
    "nom_corrige2":"Marie-Noëlle Bhérer",
    "nom_famille":"Bhérer",
    "titre_genre2":"Mairesse",
    "remuneration":"28356",
    "allocation":"14178",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42534",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":840,
    "nom_corrige2":"Marianne Dessureault",
    "nom_famille":"Dessureault",
    "titre_genre2":"Conseillère",
    "remuneration":"28336",
    "allocation":"14168",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42504",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":841,
    "nom_corrige2":"Claude Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Maire",
    "remuneration":"13165",
    "allocation":"6583",
    "remuneration2":"19553",
    "allocation2":"2959",
    "total":"42260",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":842,
    "nom_corrige2":"Diane D. Lavallée",
    "nom_famille":"D. Lavallée",
    "titre_genre2":"Conseillère",
    "remuneration":"28163",
    "allocation":"14080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"42243",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":843,
    "nom_corrige2":"Tatiana Contreras",
    "nom_famille":"Contreras",
    "titre_genre2":"Conseillère",
    "remuneration":"26963",
    "allocation":"13482",
    "remuneration2":"1024",
    "allocation2":"512,00$",
    "total":"41981",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":844,
    "nom_corrige2":"Pierre Barrette",
    "nom_famille":"Barrette",
    "titre_genre2":"Conseiller",
    "remuneration":"27907",
    "allocation":"13954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41861",
    "ville":"Lorraine",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"9738"
  },
  {
    "ID":845,
    "nom_corrige2":"Geneviève Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseillère",
    "remuneration":"28103",
    "allocation":"13051",
    "remuneration2":"419,00$",
    "allocation2":"209,00$",
    "total":"41782",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":846,
    "nom_corrige2":"Normand St-Amour",
    "nom_famille":"St-Amour",
    "titre_genre2":"Maire",
    "remuneration":"27787",
    "allocation":"13893",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41680",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":847,
    "nom_corrige2":"Catherine Hamé",
    "nom_famille":"Hamé",
    "titre_genre2":"Mairesse",
    "remuneration":"27787",
    "allocation":"13892",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41679",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":848,
    "nom_corrige2":"Sébastien Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire suppléant",
    "remuneration":"27717",
    "allocation":"13858",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41575",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":849,
    "nom_corrige2":"Éric Normandin",
    "nom_famille":"Normandin",
    "titre_genre2":"Conseiller",
    "remuneration":"27702",
    "allocation":"13852",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41554",
    "ville":"Longueuil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"267524"
  },
  {
    "ID":850,
    "nom_corrige2":"Yvan Pinsonneault",
    "nom_famille":"Pinsonneault",
    "titre_genre2":"Maire",
    "remuneration":"15381",
    "allocation":"7691",
    "remuneration2":"12314",
    "allocation2":"6157",
    "total":"41543",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":851,
    "nom_corrige2":"Pierre Moras",
    "nom_famille":"Moras",
    "titre_genre2":"Conseiller",
    "remuneration":"23562",
    "allocation":"11781",
    "remuneration2":"5090",
    "allocation2":"1045",
    "total":"41478",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":852,
    "nom_corrige2":"Michel Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"31951",
    "allocation":"9468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41419",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":853,
    "nom_corrige2":"Jean-François Rompré",
    "nom_famille":"Rompré",
    "titre_genre2":"Conseiller",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":854,
    "nom_corrige2":"Jean-Noël Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":855,
    "nom_corrige2":"Josée Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseillère",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":856,
    "nom_corrige2":"Nathalie Laporte",
    "nom_famille":"Laporte",
    "titre_genre2":"Conseillère",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":857,
    "nom_corrige2":"Samuel Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":858,
    "nom_corrige2":"Sébastien Bélair",
    "nom_famille":"Bélair",
    "titre_genre2":"Conseiller",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":859,
    "nom_corrige2":"Bertrand Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"27571",
    "allocation":"13785",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"41356",
    "ville":"Magog",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"29915"
  },
  {
    "ID":860,
    "nom_corrige2":"Cathy Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Mairesse",
    "remuneration":"27977",
    "allocation":"9826",
    "remuneration2":"3542",
    "allocation2":"0",
    "total":"41345",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":861,
    "nom_corrige2":"Julie Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Mairesse",
    "remuneration":"17730",
    "allocation":"8865",
    "remuneration2":"9784",
    "allocation2":"4887",
    "total":"41266",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":862,
    "nom_corrige2":"Marion Lamothe",
    "nom_famille":"Lamothe",
    "titre_genre2":"Conseiller",
    "remuneration":"23562",
    "allocation":"11781",
    "remuneration2":"3641",
    "allocation2":"1821",
    "total":"40805",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":863,
    "nom_corrige2":"Yves Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"388,00$",
    "allocation2":"194,00$",
    "total":"40749",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":864,
    "nom_corrige2":"Lyne Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"27125",
    "allocation":"13562",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40687",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":865,
    "nom_corrige2":"Michel Maurice",
    "nom_famille":"Maurice",
    "titre_genre2":"Conseiller",
    "remuneration":"27124",
    "allocation":"13562",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40686",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":866,
    "nom_corrige2":"Herman Herbes",
    "nom_famille":"Herbes",
    "titre_genre2":"Maire",
    "remuneration":"19733",
    "allocation":"9867",
    "remuneration2":"7358",
    "allocation2":"3679",
    "total":"40637",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":867,
    "nom_corrige2":"Bianka Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseillère",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"258,00$",
    "allocation2":"129,00$",
    "total":"40554",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":868,
    "nom_corrige2":"Robert Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Maire",
    "remuneration":"16500",
    "allocation":"8244",
    "remuneration2":"10617",
    "allocation2":"5184",
    "total":"40545",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":869,
    "nom_corrige2":"Yvan Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Maire",
    "remuneration":"24125",
    "allocation":"12063",
    "remuneration2":"2898",
    "allocation2":"1449",
    "total":"40535",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":870,
    "nom_corrige2":"Charles Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Maire",
    "remuneration":"25200",
    "allocation":"12600",
    "remuneration2":"1800",
    "allocation2":"900,00$",
    "total":"40500",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":871,
    "nom_corrige2":"Jocelyne Corbeil",
    "nom_famille":"Corbeil",
    "titre_genre2":"Conseillère",
    "remuneration":"26963",
    "allocation":"13482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40445",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":872,
    "nom_corrige2":"Michel Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"26963",
    "allocation":"13482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40445",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":873,
    "nom_corrige2":"Nicolas Robillard",
    "nom_famille":"Robillard",
    "titre_genre2":"Conseiller",
    "remuneration":"26963",
    "allocation":"13482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40445",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":874,
    "nom_corrige2":"Claire Mailhot",
    "nom_famille":"Mailhot",
    "titre_genre2":"Conseillère",
    "remuneration":"26963",
    "allocation":"13482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40445",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":875,
    "nom_corrige2":"Jacques Lapensée",
    "nom_famille":"Lapensée",
    "titre_genre2":"Conseiller",
    "remuneration":"26963",
    "allocation":"13482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40445",
    "ville":"Bromont",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"12230"
  },
  {
    "ID":876,
    "nom_corrige2":"Gaby Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Maire",
    "remuneration":"24440",
    "allocation":"12220",
    "remuneration2":"2473",
    "allocation2":"1237",
    "total":"40370",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":877,
    "nom_corrige2":"Jérémy Dion-Bernard",
    "nom_famille":"Dion-Bernard",
    "titre_genre2":"Conseiller",
    "remuneration":"25089",
    "allocation":"12545",
    "remuneration2":"1760",
    "allocation2":"880,00$",
    "total":"40274",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":878,
    "nom_corrige2":"Luce Daneau",
    "nom_famille":"Daneau",
    "titre_genre2":"Mairesse",
    "remuneration":"21705",
    "allocation":"10852",
    "remuneration2":"5092",
    "allocation2":"2546",
    "total":"40195",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":879,
    "nom_corrige2":"Véronique Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"26778",
    "allocation":"13389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40167",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":880,
    "nom_corrige2":"Maxime Betournay",
    "nom_famille":"Betournay",
    "titre_genre2":"Conseiller",
    "remuneration":"38214",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40124",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":881,
    "nom_corrige2":"Daniel Guérault",
    "nom_famille":"Guérault",
    "titre_genre2":"Conseiller",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"1914",
    "allocation2":"907,00$",
    "total":"39941",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":882,
    "nom_corrige2":"Hélène Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Mairesse",
    "remuneration":"26609",
    "allocation":"13304",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39913",
    "ville":"L'Île-d'Anticosti",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"196"
  },
  {
    "ID":883,
    "nom_corrige2":"Claude Ferguson",
    "nom_famille":"Ferguson",
    "titre_genre2":"Conseiller",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"8840",
    "allocation2":"4070",
    "total":"39813",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":884,
    "nom_corrige2":"Cédric Laplante",
    "nom_famille":"Laplante",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":885,
    "nom_corrige2":"Stéphane Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":886,
    "nom_corrige2":"Guillaume Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":887,
    "nom_corrige2":"Louis Dallaire",
    "nom_famille":"Dallaire",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":888,
    "nom_corrige2":"Daniel Camden",
    "nom_famille":"Camden",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":889,
    "nom_corrige2":"Claudette Carignan",
    "nom_famille":"Carignan",
    "titre_genre2":"Conseillère",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":890,
    "nom_corrige2":"Réal Beauchamp",
    "nom_famille":"Beauchamp",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":891,
    "nom_corrige2":"Yves Drolet",
    "nom_famille":"Drolet",
    "titre_genre2":"Conseiller",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":892,
    "nom_corrige2":"Sylvie Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseillère",
    "remuneration":"26505",
    "allocation":"13253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39758",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":893,
    "nom_corrige2":"Annie Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"25770",
    "allocation":"12885",
    "remuneration2":"674,00$",
    "allocation2":"337,00$",
    "total":"39666",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":894,
    "nom_corrige2":"Pierre Daigneault",
    "nom_famille":"Daigneault",
    "titre_genre2":"Conseiller",
    "remuneration":"30196",
    "allocation":"9468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39664",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":895,
    "nom_corrige2":"Louise Arpin",
    "nom_famille":"Louise",
    "titre_genre2":"Mairesse",
    "remuneration":"26694",
    "allocation":"12847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39541",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":896,
    "nom_corrige2":"Marie-Josée Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseillère",
    "remuneration":"26280",
    "allocation":"13140",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39420",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":897,
    "nom_corrige2":"France Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Mairesse",
    "remuneration":"35449",
    "allocation":"3964",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39413",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":898,
    "nom_corrige2":"Guillaume Carignan",
    "nom_famille":"Carignan",
    "titre_genre2":"Conseiller",
    "remuneration":"26212",
    "allocation":"13106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39318",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":899,
    "nom_corrige2":"Sophie Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Conseillère",
    "remuneration":"26450",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39175",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":900,
    "nom_corrige2":"Carine Durocher",
    "nom_famille":"Durocher",
    "titre_genre2":"Conseillère",
    "remuneration":"26103",
    "allocation":"13051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39154",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":901,
    "nom_corrige2":"Guillaume Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"26103",
    "allocation":"13051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39154",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":902,
    "nom_corrige2":"Benoit Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Conseiller",
    "remuneration":"26103",
    "allocation":"13051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39154",
    "ville":"Varennes",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"21619"
  },
  {
    "ID":903,
    "nom_corrige2":"Michel Poitras",
    "nom_famille":"Poitras",
    "titre_genre2":"Maire suppléant",
    "remuneration":"26444",
    "allocation":"12679",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"39123",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":904,
    "nom_corrige2":"Dave Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Maire",
    "remuneration":"20517",
    "allocation":"10259",
    "remuneration2":"5497",
    "allocation2":"2748",
    "total":"39021",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":905,
    "nom_corrige2":"Olive Kamanyana",
    "nom_famille":"Kamanyana",
    "titre_genre2":"Conseillère",
    "remuneration":"30910",
    "allocation":"7288",
    "remuneration2":"800,00$",
    "allocation2":"0",
    "total":"38998",
    "ville":"Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"302616"
  },
  {
    "ID":906,
    "nom_corrige2":"Michel Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Conseiller",
    "remuneration":"26315",
    "allocation":"12669",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38984",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":907,
    "nom_corrige2":"Yan Major",
    "nom_famille":"Major",
    "titre_genre2":"Conseiller",
    "remuneration":"26312",
    "allocation":"12669",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38981",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":908,
    "nom_corrige2":"Jean-Paul Dahm",
    "nom_famille":"Dahm",
    "titre_genre2":"Conseiller",
    "remuneration":"26312",
    "allocation":"12669",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38981",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":909,
    "nom_corrige2":"Denis Marcil",
    "nom_famille":"Marcil",
    "titre_genre2":"Conseiller",
    "remuneration":"26312",
    "allocation":"12669",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38981",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":910,
    "nom_corrige2":"Robert Schloesser",
    "nom_famille":"Schloesser",
    "titre_genre2":"Conseiller",
    "remuneration":"26313",
    "allocation":"12668",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38981",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":911,
    "nom_corrige2":"Mario Bordeleau",
    "nom_famille":"Bordeleau",
    "titre_genre2":"Conseiller",
    "remuneration":"26312",
    "allocation":"12669",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38981",
    "ville":"Montréal-Est",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"4918"
  },
  {
    "ID":912,
    "nom_corrige2":"Alain Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Maire",
    "remuneration":"19355",
    "allocation":"9677",
    "remuneration2":"6536",
    "allocation2":"3268",
    "total":"38836",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":913,
    "nom_corrige2":"Sara Dupras",
    "nom_famille":"Dupras",
    "titre_genre2":"Conseillère",
    "remuneration":"29344",
    "allocation":"9468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38812",
    "ville":"Prévost",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14198"
  },
  {
    "ID":914,
    "nom_corrige2":"Jason Ball",
    "nom_famille":"Ball",
    "titre_genre2":"Conseiller",
    "remuneration":"26327",
    "allocation":"12374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38701",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":915,
    "nom_corrige2":"Antoine Tayar",
    "nom_famille":"Tayar",
    "titre_genre2":"Conseiller",
    "remuneration":"25950",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38675",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":916,
    "nom_corrige2":"Guy Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"25754",
    "allocation":"12877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38631",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":917,
    "nom_corrige2":"Johanne Babin",
    "nom_famille":"Babin",
    "titre_genre2":"Conseillère",
    "remuneration":"25754",
    "allocation":"12877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38631",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":918,
    "nom_corrige2":"Norman St-Amour",
    "nom_famille":"St-Amour",
    "titre_genre2":"Conseiller",
    "remuneration":"25754",
    "allocation":"12877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38631",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4920"
  },
  {
    "ID":919,
    "nom_corrige2":"Julie Halde",
    "nom_famille":"Halde",
    "titre_genre2":"Conseillère",
    "remuneration":"25850",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38575",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":920,
    "nom_corrige2":"Alexandre Bastien",
    "nom_famille":"Bastien",
    "titre_genre2":"Maire",
    "remuneration":"18467",
    "allocation":"9234",
    "remuneration2":"7198",
    "allocation2":"3599",
    "total":"38498",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":921,
    "nom_corrige2":"Noël Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Maire",
    "remuneration":"9625",
    "allocation":"28869",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38494",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":922,
    "nom_corrige2":"Guy Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Maire",
    "remuneration":"22110",
    "allocation":"11055",
    "remuneration2":"3489",
    "allocation2":"1673",
    "total":"38327",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":923,
    "nom_corrige2":"Maryam Kamali Nezhad",
    "nom_famille":"Kamali Nezhad",
    "titre_genre2":"Conseillère",
    "remuneration":"25450",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38175",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":924,
    "nom_corrige2":"Maya Chammas",
    "nom_famille":"Chammas",
    "titre_genre2":"Conseillère",
    "remuneration":"25450",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38175",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":925,
    "nom_corrige2":"Sébastien Dreyfuss",
    "nom_famille":"Dreyfuss",
    "titre_genre2":"Conseiller",
    "remuneration":"25450",
    "allocation":"12725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38175",
    "ville":"Mont-Royal",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"22396"
  },
  {
    "ID":926,
    "nom_corrige2":"Stéphanie Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"25402",
    "allocation":"12701",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"38103",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":927,
    "nom_corrige2":"Jean-Marie Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Maire",
    "remuneration":"25310",
    "allocation":"12655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37965",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":928,
    "nom_corrige2":"Donna Salvati",
    "nom_famille":"Salvati",
    "titre_genre2":"Mairesse",
    "remuneration":"24411",
    "allocation":"12206",
    "remuneration2":"1284",
    "allocation2":"0",
    "total":"37901",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":929,
    "nom_corrige2":"Sylvain Jutras",
    "nom_famille":"Jutras",
    "titre_genre2":"Maire",
    "remuneration":"16029",
    "allocation":"8015",
    "remuneration2":"9162",
    "allocation2":"4581",
    "total":"37787",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":930,
    "nom_corrige2":"Robert Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Maire",
    "remuneration":"25191",
    "allocation":"12595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37786",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":931,
    "nom_corrige2":"Hélène Ringuet",
    "nom_famille":"Ringuet",
    "titre_genre2":"Conseillère",
    "remuneration":"25089",
    "allocation":"12545",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37634",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":932,
    "nom_corrige2":"Marc-André Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"25089",
    "allocation":"12545",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37634",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":933,
    "nom_corrige2":"Mathieu Marcil",
    "nom_famille":"Marcil",
    "titre_genre2":"Conseiller",
    "remuneration":"25089",
    "allocation":"12545",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37634",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":934,
    "nom_corrige2":"Vincent Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"25089",
    "allocation":"12545",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37634",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":935,
    "nom_corrige2":"Louis Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"25089",
    "allocation":"12545",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37634",
    "ville":"Saint-Bruno-de-Montarville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"26735"
  },
  {
    "ID":936,
    "nom_corrige2":"Alexandre Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"403,00$",
    "allocation2":"0",
    "total":"37523",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":937,
    "nom_corrige2":"David Pharand",
    "nom_famille":"Pharand",
    "titre_genre2":"Maire",
    "remuneration":"18896",
    "allocation":"9448",
    "remuneration2":"6071",
    "allocation2":"3036",
    "total":"37451",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":938,
    "nom_corrige2":"Carole Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseillère",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"302,00$",
    "allocation2":"0",
    "total":"37422",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":939,
    "nom_corrige2":"Charlie-Maude Giroux Bossé",
    "nom_famille":"Giroux Bossé",
    "titre_genre2":"Conseillère",
    "remuneration":"24913",
    "allocation":"12457",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37370",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":940,
    "nom_corrige2":"Ghislain Smith",
    "nom_famille":"Smith",
    "titre_genre2":"Conseiller",
    "remuneration":"24913",
    "allocation":"12457",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37370",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":941,
    "nom_corrige2":"James-Alexander Keays",
    "nom_famille":"Keays",
    "titre_genre2":"Conseiller",
    "remuneration":"24913",
    "allocation":"12457",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37370",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":942,
    "nom_corrige2":"Mathieu Denis",
    "nom_famille":"Denis",
    "titre_genre2":"Conseiller",
    "remuneration":"24913",
    "allocation":"12457",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37370",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":943,
    "nom_corrige2":"Réal Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"24913",
    "allocation":"12457",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37370",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":944,
    "nom_corrige2":"Jean-Michel Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseiller",
    "remuneration":"24913",
    "allocation":"12457",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37370",
    "ville":"Gaspé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"15627"
  },
  {
    "ID":945,
    "nom_corrige2":"Arielle Beaudin",
    "nom_famille":"Beaudin",
    "titre_genre2":"Conseillère",
    "remuneration":"25258",
    "allocation":"12081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37339",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":946,
    "nom_corrige2":"Richard Chartrand",
    "nom_famille":"Chartrand",
    "titre_genre2":"Conseiller",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":947,
    "nom_corrige2":"Marc Emond",
    "nom_famille":"Emond",
    "titre_genre2":"Conseiller",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":948,
    "nom_corrige2":"Brian Trainor",
    "nom_famille":"Trainor",
    "titre_genre2":"Conseiller",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":949,
    "nom_corrige2":"David Hill",
    "nom_famille":"Hill",
    "titre_genre2":"Conseiller",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":950,
    "nom_corrige2":"Donald Andrews",
    "nom_famille":"Andrews",
    "titre_genre2":"Conseiller",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":951,
    "nom_corrige2":"Pierre Casavant",
    "nom_famille":"Casavant",
    "titre_genre2":"Conseiller",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":952,
    "nom_corrige2":"Tanja Minisini",
    "nom_famille":"Minisini",
    "titre_genre2":"Conseillère",
    "remuneration":"24866",
    "allocation":"12433",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37299",
    "ville":"Saint-Lazare",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"22910"
  },
  {
    "ID":953,
    "nom_corrige2":"Ronald Cross",
    "nom_famille":"Cross",
    "titre_genre2":"Maire",
    "remuneration":"37224",
    "allocation":"",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37224",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":954,
    "nom_corrige2":"Anitra Meridith Bostock",
    "nom_famille":"Bostock",
    "titre_genre2":"Conseillère",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":955,
    "nom_corrige2":"Antonio D'Amico",
    "nom_famille":"D'Amico",
    "titre_genre2":"Conseiller",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":956,
    "nom_corrige2":"Conrad Peart",
    "nom_famille":"Peart",
    "titre_genre2":"Conseiller",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":957,
    "nom_corrige2":"Elisabeth Roux",
    "nom_famille":"Roux",
    "titre_genre2":"Conseillère",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":958,
    "nom_corrige2":"Kathleen Kez",
    "nom_famille":"Kez",
    "titre_genre2":"Conseillère",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":959,
    "nom_corrige2":"Mary Gallery",
    "nom_famille":"Gallery",
    "titre_genre2":"Conseillère",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":960,
    "nom_corrige2":"Matt Aronson",
    "nom_famille":"Aronson",
    "titre_genre2":"Conseiller",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":961,
    "nom_corrige2":"Jeff Shamie",
    "nom_famille":"Shamie",
    "titre_genre2":"Conseiller",
    "remuneration":"24765",
    "allocation":"12382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37147",
    "ville":"Westmount",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"20350"
  },
  {
    "ID":962,
    "nom_corrige2":"Chantale Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseillère",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37120",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":963,
    "nom_corrige2":"Mélissa Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"24747",
    "allocation":"12373",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"37120",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":964,
    "nom_corrige2":"Jean-François Robillard",
    "nom_famille":"Robillard",
    "titre_genre2":"Conseiller",
    "remuneration":"25001",
    "allocation":"11958",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36959",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":965,
    "nom_corrige2":"Doris Réhel",
    "nom_famille":"Réhel",
    "titre_genre2":"Conseillère",
    "remuneration":"24337",
    "allocation":"9420",
    "remuneration2":"2103",
    "allocation2":"1052",
    "total":"36912",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":966,
    "nom_corrige2":"Yves Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Maire",
    "remuneration":"17491",
    "allocation":"8746",
    "remuneration2":"7109",
    "allocation2":"3555",
    "total":"36901",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":967,
    "nom_corrige2":"Martin Dumaresq",
    "nom_famille":"Dumaresq",
    "titre_genre2":"Maire",
    "remuneration":"15291",
    "allocation":"7646",
    "remuneration2":"9308",
    "allocation2":"4654",
    "total":"36899",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":968,
    "nom_corrige2":"Anastasia Kokinasidis",
    "nom_famille":"Kokinasidis",
    "titre_genre2":"Conseillère",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":969,
    "nom_corrige2":"Domenico Zito",
    "nom_famille":"Zito",
    "titre_genre2":"Conseiller",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":970,
    "nom_corrige2":"John Morson",
    "nom_famille":"Morson",
    "titre_genre2":"Conseiller",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":971,
    "nom_corrige2":"Karen Cliffe",
    "nom_famille":"Cliffe",
    "titre_genre2":"Conseillère",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":972,
    "nom_corrige2":"Luciano Piciacchia",
    "nom_famille":"Piciacchia",
    "titre_genre2":"Conseiller",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":973,
    "nom_corrige2":"Michael Brown",
    "nom_famille":"Brown",
    "titre_genre2":"Conseiller",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":974,
    "nom_corrige2":"Paul Dufort",
    "nom_famille":"Dufort",
    "titre_genre2":"Conseiller",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":975,
    "nom_corrige2":"Stephen Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"24579",
    "allocation":"12289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36868",
    "ville":"Kirkland",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19552"
  },
  {
    "ID":976,
    "nom_corrige2":"Yvon Barette",
    "nom_famille":"Barette",
    "titre_genre2":"Maire",
    "remuneration":"21175",
    "allocation":"10587",
    "remuneration2":"3389",
    "allocation2":"1701",
    "total":"36852",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":977,
    "nom_corrige2":"Ghislain Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Maire",
    "remuneration":"24266",
    "allocation":"12133",
    "remuneration2":"225,00$",
    "allocation2":"112,00$",
    "total":"36736",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":978,
    "nom_corrige2":"Gilles Salvas",
    "nom_famille":"Salvas",
    "titre_genre2":"Maire",
    "remuneration":"16103",
    "allocation":"8051",
    "remuneration2":"8609",
    "allocation2":"3909",
    "total":"36672",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":979,
    "nom_corrige2":"Loic Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseiller",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":980,
    "nom_corrige2":"Alex Brisebois-Proulx",
    "nom_famille":"Brisebois-Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":981,
    "nom_corrige2":"Claire Wallot",
    "nom_famille":"Wallot",
    "titre_genre2":"Conseillère",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":982,
    "nom_corrige2":"Francis Limoges",
    "nom_famille":"Limoges",
    "titre_genre2":"Conseiller",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":983,
    "nom_corrige2":"Julie Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":984,
    "nom_corrige2":"Line Surprenant",
    "nom_famille":"Surprenant",
    "titre_genre2":"Conseillère",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":985,
    "nom_corrige2":"Marc-André Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Conseiller",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":986,
    "nom_corrige2":"Priscilla Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Conseillère",
    "remuneration":"24430",
    "allocation":"12215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36645",
    "ville":"Sainte-Marthe-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"21772"
  },
  {
    "ID":987,
    "nom_corrige2":"David Lépine",
    "nom_famille":"Lépine",
    "titre_genre2":"Maire",
    "remuneration":"20000",
    "allocation":"10000",
    "remuneration2":"6632",
    "allocation2":"0",
    "total":"36632",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":988,
    "nom_corrige2":"Luc Grenon",
    "nom_famille":"Grenon",
    "titre_genre2":"Maire",
    "remuneration":"22250",
    "allocation":"11124",
    "remuneration2":"3250",
    "allocation2":"0",
    "total":"36624",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":989,
    "nom_corrige2":"Pierre Tétrault",
    "nom_famille":"Tétrault",
    "titre_genre2":"Maire",
    "remuneration":"25312",
    "allocation":"11311",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36623",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":990,
    "nom_corrige2":"Mario St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Maire",
    "remuneration":"17142",
    "allocation":"8571",
    "remuneration2":"7272",
    "allocation2":"3636",
    "total":"36621",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":991,
    "nom_corrige2":"André Ibghy",
    "nom_famille":"Ibghy",
    "titre_genre2":"Maire",
    "remuneration":"24392",
    "allocation":"12195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36587",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":992,
    "nom_corrige2":"Richard Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"24668",
    "allocation":"11799",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36467",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":993,
    "nom_corrige2":"Amélie Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseillère",
    "remuneration":"21285",
    "allocation":"10643",
    "remuneration2":"3003",
    "allocation2":"1501",
    "total":"36432",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":994,
    "nom_corrige2":"Joël Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Conseiller",
    "remuneration":"24276",
    "allocation":"12138",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36414",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":995,
    "nom_corrige2":"Louise Brais",
    "nom_famille":"Brais",
    "titre_genre2":"Conseillère",
    "remuneration":"25800",
    "allocation":"10500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36300",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":996,
    "nom_corrige2":"Robert Bertrand",
    "nom_famille":"Bertrand",
    "titre_genre2":"Maire",
    "remuneration":"18103",
    "allocation":"9051",
    "remuneration2":"6088",
    "allocation2":"3044",
    "total":"36286",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":997,
    "nom_corrige2":"Lucien Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Maire",
    "remuneration":"18765",
    "allocation":"9383",
    "remuneration2":"5406",
    "allocation2":"2703",
    "total":"36257",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":998,
    "nom_corrige2":"David Newell",
    "nom_famille":"Newell",
    "titre_genre2":"Conseiller",
    "remuneration":"25164",
    "allocation":"11082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36246",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":999,
    "nom_corrige2":"Claudette Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Mairesse",
    "remuneration":"14255",
    "allocation":"7127",
    "remuneration2":"9874",
    "allocation2":"4936",
    "total":"36192",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":1000,
    "nom_corrige2":"Alain Goyette",
    "nom_famille":"Goyette",
    "titre_genre2":"Maire",
    "remuneration":"18391",
    "allocation":"6010",
    "remuneration2":"7824",
    "allocation2":"3912",
    "total":"36137",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":1001,
    "nom_corrige2":"Yves Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Maire",
    "remuneration":"15174",
    "allocation":"7287",
    "remuneration2":"9089",
    "allocation2":"4544",
    "total":"36094",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":1002,
    "nom_corrige2":"Jennifer Garfat",
    "nom_famille":"Garfat",
    "titre_genre2":"Conseillère",
    "remuneration":"24113",
    "allocation":"11963",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36076",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":1003,
    "nom_corrige2":"France Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Conseillère",
    "remuneration":"22081",
    "allocation":"10385",
    "remuneration2":"2400",
    "allocation2":"1200",
    "total":"36066",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":1004,
    "nom_corrige2":"Pascal Doucet",
    "nom_famille":"Doucet",
    "titre_genre2":"Conseiller",
    "remuneration":"24004",
    "allocation":"12002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36006",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":1005,
    "nom_corrige2":"Nicolas Pentassuglia",
    "nom_famille":"Pentassuglia",
    "titre_genre2":"Maire",
    "remuneration":"24000",
    "allocation":"12000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"36000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":1006,
    "nom_corrige2":"Pierre Gingras",
    "nom_famille":"Gingras",
    "titre_genre2":"Maire",
    "remuneration":"20619",
    "allocation":"10309",
    "remuneration2":"3348",
    "allocation2":"1674",
    "total":"35950",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":1007,
    "nom_corrige2":"Mario Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire",
    "remuneration":"18821",
    "allocation":"6860",
    "remuneration2":"6982",
    "allocation2":"3166",
    "total":"35829",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":1008,
    "nom_corrige2":"Maxime Proulx-Cadieux",
    "nom_famille":"Proulx-Cadieux",
    "titre_genre2":"Maire",
    "remuneration":"17160",
    "allocation":"8580",
    "remuneration2":"6678",
    "allocation2":"3339",
    "total":"35757",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":1009,
    "nom_corrige2":"Diane Sirard",
    "nom_famille":"Sirard",
    "titre_genre2":"Mairesse",
    "remuneration":"23764",
    "allocation":"11882",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35646",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":1010,
    "nom_corrige2":"Alexandre Laganière",
    "nom_famille":"Laganière",
    "titre_genre2":"Conseiller",
    "remuneration":"24110",
    "allocation":"11532",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35642",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":1011,
    "nom_corrige2":"Gaetan Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"24110",
    "allocation":"11532",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35642",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":1012,
    "nom_corrige2":"David Huggins-Daines",
    "nom_famille":"Huggins-Daines",
    "titre_genre2":"Conseiller",
    "remuneration":"24110",
    "allocation":"11532",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35642",
    "ville":"Sainte-Adèle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15027"
  },
  {
    "ID":1013,
    "nom_corrige2":"Jean Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"17571",
    "allocation":"8404",
    "remuneration2":"7243",
    "allocation2":"2414",
    "total":"35632",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":1014,
    "nom_corrige2":"Alain Quirion",
    "nom_famille":"Quirion",
    "titre_genre2":"Maire",
    "remuneration":"21507",
    "allocation":"10512",
    "remuneration2":"2288",
    "allocation2":"1144",
    "total":"35451",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":1015,
    "nom_corrige2":"Mario Lasalle",
    "nom_famille":"Lasalle",
    "titre_genre2":"Maire",
    "remuneration":"23585",
    "allocation":"11793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35378",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":1016,
    "nom_corrige2":"Jasmine Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"23562",
    "allocation":"11781",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35343",
    "ville":"Bécancour",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"14555"
  },
  {
    "ID":1017,
    "nom_corrige2":"Guillaume Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Maire",
    "remuneration":"21232",
    "allocation":"10616",
    "remuneration2":"2326",
    "allocation2":"1115",
    "total":"35289",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":1018,
    "nom_corrige2":"Steven Larose",
    "nom_famille":"Larose",
    "titre_genre2":"Maire",
    "remuneration":"13751",
    "allocation":"6875",
    "remuneration2":"9749",
    "allocation2":"4875",
    "total":"35250",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":1019,
    "nom_corrige2":"Micheline Groulx Stabile",
    "nom_famille":"Groulx Stabile",
    "titre_genre2":"Conseillère",
    "remuneration":"23439",
    "allocation":"11719",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35158",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":1020,
    "nom_corrige2":"Caroline Vinet",
    "nom_famille":"Vinet",
    "titre_genre2":"Conseillère",
    "remuneration":"23427",
    "allocation":"11714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"35141",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":1021,
    "nom_corrige2":"Normand Latreille",
    "nom_famille":"Latreille",
    "titre_genre2":"Conseiller",
    "remuneration":"21253",
    "allocation":"10627",
    "remuneration2":"2126",
    "allocation2":"1062",
    "total":"35068",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":1022,
    "nom_corrige2":"Stéphane Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Maire",
    "remuneration":"13881",
    "allocation":"6941",
    "remuneration2":"9452",
    "allocation2":"4726",
    "total":"35000",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":1023,
    "nom_corrige2":"Claude Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Maire",
    "remuneration":"23273",
    "allocation":"11636",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34909",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":1024,
    "nom_corrige2":"Mario Desbiens",
    "nom_famille":"Desbiens",
    "titre_genre2":"Maire",
    "remuneration":"13131",
    "allocation":"6561",
    "remuneration2":"10136",
    "allocation2":"5068",
    "total":"34896",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":1025,
    "nom_corrige2":"Pierre Deshaies",
    "nom_famille":"Deshaies",
    "titre_genre2":"Conseiller",
    "remuneration":"21284",
    "allocation":"10642",
    "remuneration2":"2965",
    "allocation2":"0",
    "total":"34891",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":1026,
    "nom_corrige2":"François Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"23173",
    "allocation":"11587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34760",
    "ville":"Alma",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"30889"
  },
  {
    "ID":1027,
    "nom_corrige2":"Dany Brosseau",
    "nom_famille":"Brosseau",
    "titre_genre2":"Conseiller",
    "remuneration":"24200",
    "allocation":"10500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34700",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":1028,
    "nom_corrige2":"Mario Lyonnais",
    "nom_famille":"Lyonnais",
    "titre_genre2":"Maire",
    "remuneration":"5742",
    "allocation":"2870",
    "remuneration2":"17308",
    "allocation2":"8654",
    "total":"34574",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":1029,
    "nom_corrige2":"Claude Rollin",
    "nom_famille":"Rollin",
    "titre_genre2":"Conseiller",
    "remuneration":"23034",
    "allocation":"11517",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34551",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":1030,
    "nom_corrige2":"Diane Soucry",
    "nom_famille":"Soucry",
    "titre_genre2":"Conseillère",
    "remuneration":"24000",
    "allocation":"10500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34500",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":1031,
    "nom_corrige2":"Yves Charlebois",
    "nom_famille":"Charlebois",
    "titre_genre2":"Maire",
    "remuneration":"16497",
    "allocation":"8249",
    "remuneration2":"6478",
    "allocation2":"3239",
    "total":"34463",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":1032,
    "nom_corrige2":"Chrystian Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Maire",
    "remuneration":"15374",
    "allocation":"7672",
    "remuneration2":"7582",
    "allocation2":"3791",
    "total":"34419",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":1033,
    "nom_corrige2":"Claire Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Mairesse",
    "remuneration":"12728",
    "allocation":"6365",
    "remuneration2":"10155",
    "allocation2":"5078",
    "total":"34326",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":1034,
    "nom_corrige2":"Marie-José Cossette",
    "nom_famille":"Cossette",
    "titre_genre2":"Conseillère",
    "remuneration":"22965",
    "allocation":"11343",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34308",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":1035,
    "nom_corrige2":"Patricia Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Mairesse",
    "remuneration":"12482",
    "allocation":"6241",
    "remuneration2":"2579",
    "allocation2":"12990",
    "total":"34292",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":1036,
    "nom_corrige2":"Réal Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Maire",
    "remuneration":"20000",
    "allocation":"10000",
    "remuneration2":"2831",
    "allocation2":"1415",
    "total":"34246",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":1037,
    "nom_corrige2":"Hugo Lajoie",
    "nom_famille":"Lajoie",
    "titre_genre2":"Maire suppléant",
    "remuneration":"22799",
    "allocation":"11399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34198",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":1038,
    "nom_corrige2":"Kimberley Chan",
    "nom_famille":"Chan",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"23737",
    "allocation":"10428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34165",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":1039,
    "nom_corrige2":"Rosa Borreggine",
    "nom_famille":"Borreggine",
    "titre_genre2":"Conseillère",
    "remuneration":"22763",
    "allocation":"11381",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34144",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":1040,
    "nom_corrige2":"Andee Shuster",
    "nom_famille":"Shuster",
    "titre_genre2":"Conseillère",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1041,
    "nom_corrige2":"Oren Sebag",
    "nom_famille":"Sebag",
    "titre_genre2":"Conseiller",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1042,
    "nom_corrige2":"Sidney Benizri",
    "nom_famille":"Benizri",
    "titre_genre2":"Conseiller",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1043,
    "nom_corrige2":"Steven Erdelyi",
    "nom_famille":"Erdelyi",
    "titre_genre2":"Conseiller",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1044,
    "nom_corrige2":"Dida Berku",
    "nom_famille":"Berku",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1045,
    "nom_corrige2":"Lior Azerad",
    "nom_famille":"Azerad",
    "titre_genre2":"Conseiller",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1046,
    "nom_corrige2":"Micheal Cohen",
    "nom_famille":"Cohen",
    "titre_genre2":"Conseiller",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1047,
    "nom_corrige2":"Michell Kujavsky",
    "nom_famille":"Kujavsky",
    "titre_genre2":"Conseiller",
    "remuneration":"22693",
    "allocation":"11346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"34039",
    "ville":"Côte-Saint-Luc",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"38369"
  },
  {
    "ID":1048,
    "nom_corrige2":"Nathalie Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Mairesse",
    "remuneration":"15658",
    "allocation":"7829",
    "remuneration2":"6981",
    "allocation2":"3490",
    "total":"33958",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":1049,
    "nom_corrige2":"Hugo Mc Dermott",
    "nom_famille":"Mc Dermott",
    "titre_genre2":"Maire",
    "remuneration":"14645",
    "allocation":"7323",
    "remuneration2":"7948",
    "allocation2":"3974",
    "total":"33890",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":1050,
    "nom_corrige2":"Suzanne Rompré",
    "nom_famille":"Rompré",
    "titre_genre2":"Mairesse",
    "remuneration":"14736",
    "allocation":"7368",
    "remuneration2":"7856",
    "allocation2":"3928",
    "total":"33888",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":1051,
    "nom_corrige2":"Odette Filion",
    "nom_famille":"Filion",
    "titre_genre2":"Conseillère",
    "remuneration":"22565",
    "allocation":"11283",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33848",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":1052,
    "nom_corrige2":"Ginette Gagné-Stoklosa",
    "nom_famille":"Gagné-Stoklosa",
    "titre_genre2":"Conseillère",
    "remuneration":"22565",
    "allocation":"11283",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33848",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":1053,
    "nom_corrige2":"Gaston Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Maire",
    "remuneration":"17584",
    "allocation":"8835",
    "remuneration2":"4928",
    "allocation2":"2464",
    "total":"33811",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":1054,
    "nom_corrige2":"Cynthia Sherrer",
    "nom_famille":"Sherrer",
    "titre_genre2":"Conseillère",
    "remuneration":"23177",
    "allocation":"10606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33783",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":1055,
    "nom_corrige2":"Éric Dupont",
    "nom_famille":"Dupont",
    "titre_genre2":"Maire",
    "remuneration":"20353",
    "allocation":"10177",
    "remuneration2":"2158",
    "allocation2":"1079",
    "total":"33767",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":1056,
    "nom_corrige2":"Julie Jolivette",
    "nom_famille":"Jolivette",
    "titre_genre2":"Mairesse",
    "remuneration":"11101",
    "allocation":"5551",
    "remuneration2":"11441",
    "allocation2":"5532",
    "total":"33625",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":1057,
    "nom_corrige2":"Stéphane Biron",
    "nom_famille":"Biron",
    "titre_genre2":"Conseiller",
    "remuneration":"15772",
    "allocation":"7504",
    "remuneration2":"9229",
    "allocation2":"1104",
    "total":"33609",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":1058,
    "nom_corrige2":"Emilie Hébert-Larue",
    "nom_famille":"Hébert-Larue",
    "titre_genre2":"Conseillère",
    "remuneration":"22994",
    "allocation":"10606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33600",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":1059,
    "nom_corrige2":"Délisca Ritchie Roussy",
    "nom_famille":"Ritchie Roussy",
    "titre_genre2":"Mairesse",
    "remuneration":"22384",
    "allocation":"11199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33583",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":1060,
    "nom_corrige2":"Réjean Rajotte",
    "nom_famille":"Rajotte",
    "titre_genre2":"Maire",
    "remuneration":"15800",
    "allocation":"7900",
    "remuneration2":"6536",
    "allocation2":"3268",
    "total":"33504",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":1061,
    "nom_corrige2":"Daniel Lauzon",
    "nom_famille":"Lauzon",
    "titre_genre2":"Conseiller",
    "remuneration":"21271",
    "allocation":"10553",
    "remuneration2":"1100",
    "allocation2":"550,00$",
    "total":"33474",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":1062,
    "nom_corrige2":"Éric Fiset",
    "nom_famille":"Fiset",
    "titre_genre2":"Conseiller",
    "remuneration":"22313",
    "allocation":"11156",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33469",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":1063,
    "nom_corrige2":"Chantal Brochu",
    "nom_famille":"Brochu",
    "titre_genre2":"Conseillère",
    "remuneration":"22313",
    "allocation":"11156",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33469",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":1064,
    "nom_corrige2":"Marie-Josée Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseillère",
    "remuneration":"22313",
    "allocation":"11156",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33469",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":1065,
    "nom_corrige2":"Martin Maranda",
    "nom_famille":"Maranda",
    "titre_genre2":"Conseiller",
    "remuneration":"22313",
    "allocation":"11156",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33469",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":1066,
    "nom_corrige2":"Yannick Lebrasseur",
    "nom_famille":"Lebrasseur",
    "titre_genre2":"Conseiller",
    "remuneration":"22313",
    "allocation":"11156",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33469",
    "ville":"Saint-Augustin-de-Desmaures",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"20844"
  },
  {
    "ID":1067,
    "nom_corrige2":"Charles Guérard",
    "nom_famille":"Guérard",
    "titre_genre2":"Conseiller",
    "remuneration":"22294",
    "allocation":"11147",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33441",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":1068,
    "nom_corrige2":"Isabelle Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"22294",
    "allocation":"11147",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33441",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":1069,
    "nom_corrige2":"Johanne Laurin",
    "nom_famille":"Laurin",
    "titre_genre2":"Conseillère",
    "remuneration":"22294",
    "allocation":"11147",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33441",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":1070,
    "nom_corrige2":"Josée Ossio",
    "nom_famille":"Ossio",
    "titre_genre2":"Conseillère",
    "remuneration":"22294",
    "allocation":"11147",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33441",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":1071,
    "nom_corrige2":"Nicolas Dubuc St-Gelais",
    "nom_famille":"Dubuc St-Gelais",
    "titre_genre2":"Conseiller",
    "remuneration":"22294",
    "allocation":"11147",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33441",
    "ville":"L'Ancienne-Lorette",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"17862"
  },
  {
    "ID":1072,
    "nom_corrige2":"Simon Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Maire",
    "remuneration":"18648",
    "allocation":"9324",
    "remuneration2":"3541",
    "allocation2":"1770",
    "total":"33283",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":1073,
    "nom_corrige2":"Clément Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Maire",
    "remuneration":"19295",
    "allocation":"9648",
    "remuneration2":"2893",
    "allocation2":"1447",
    "total":"33283",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":1074,
    "nom_corrige2":"Giovanni Moretti",
    "nom_famille":"Moretti",
    "titre_genre2":"Maire",
    "remuneration":"18375",
    "allocation":"6125",
    "remuneration2":"5848",
    "allocation2":"2924",
    "total":"33272",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":1075,
    "nom_corrige2":"Dominique Godin",
    "nom_famille":"Godin",
    "titre_genre2":"Conseillère",
    "remuneration":"22164",
    "allocation":"11082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33246",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":1076,
    "nom_corrige2":"Martin St-Jean",
    "nom_famille":"St-Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"22164",
    "allocation":"11082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33246",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":1077,
    "nom_corrige2":"Peggy Alexopoulos",
    "nom_famille":"Alexopoulos",
    "titre_genre2":"Conseillère",
    "remuneration":"22164",
    "allocation":"11082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33246",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":1078,
    "nom_corrige2":"Robert Mercuri",
    "nom_famille":"Mercuri",
    "titre_genre2":"Conseiller",
    "remuneration":"22164",
    "allocation":"11082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33246",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":1079,
    "nom_corrige2":"Roger Moss",
    "nom_famille":"Moss",
    "titre_genre2":"Conseiller",
    "remuneration":"22164",
    "allocation":"11082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33246",
    "ville":"Beaconsfield",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"19390"
  },
  {
    "ID":1080,
    "nom_corrige2":"Michel Mendes",
    "nom_famille":"Mendes",
    "titre_genre2":"Conseiller",
    "remuneration":"22155",
    "allocation":"11078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33233",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":1081,
    "nom_corrige2":"André Ducharme",
    "nom_famille":"Ducharme",
    "titre_genre2":"Conseiller",
    "remuneration":"22567",
    "allocation":"10606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33173",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":1082,
    "nom_corrige2":"Christine Baudinet",
    "nom_famille":"Baudinet",
    "titre_genre2":"Conseillère",
    "remuneration":"22567",
    "allocation":"10606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33173",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":1083,
    "nom_corrige2":"Francis Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Conseiller",
    "remuneration":"22567",
    "allocation":"10606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33173",
    "ville":"Potton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2210"
  },
  {
    "ID":1084,
    "nom_corrige2":"Johanne Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Mairesse",
    "remuneration":"12753",
    "allocation":"6414",
    "remuneration2":"9320",
    "allocation2":"4660",
    "total":"33147",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":1085,
    "nom_corrige2":"Mariane Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Mairesse",
    "remuneration":"18953",
    "allocation":"9595",
    "remuneration2":"3064",
    "allocation2":"1532",
    "total":"33144",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":1086,
    "nom_corrige2":"Richard Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Maire",
    "remuneration":"16745",
    "allocation":"8373",
    "remuneration2":"8004",
    "allocation2":"0",
    "total":"33122",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":1087,
    "nom_corrige2":"Michel Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Maire",
    "remuneration":"22402",
    "allocation":"10693",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33095",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":1088,
    "nom_corrige2":"Pascal Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"22053",
    "allocation":"11027",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33080",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1089,
    "nom_corrige2":"Francine Ranger",
    "nom_famille":"Ranger",
    "titre_genre2":"Conseillère",
    "remuneration":"22053",
    "allocation":"11027",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33080",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1090,
    "nom_corrige2":"Denis Bourgeois",
    "nom_famille":"Bourgeois",
    "titre_genre2":"Conseiller",
    "remuneration":"22046",
    "allocation":"11024",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33070",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":1091,
    "nom_corrige2":"Denis Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"22046",
    "allocation":"11024",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33070",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":1092,
    "nom_corrige2":"Lise Castilloux",
    "nom_famille":"Castilloux",
    "titre_genre2":"Mairesse",
    "remuneration":"22000",
    "allocation":"11000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"33000",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":1093,
    "nom_corrige2":"Lisette Falker",
    "nom_famille":"Falker",
    "titre_genre2":"Conseillère",
    "remuneration":"21993",
    "allocation":"10997",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32990",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1094,
    "nom_corrige2":"Benoît Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Conseiller",
    "remuneration":"21492",
    "allocation":"10746",
    "remuneration2":"498,00$",
    "allocation2":"249,00$",
    "total":"32985",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":1095,
    "nom_corrige2":"Luc Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"21962",
    "allocation":"10981",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32943",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":1096,
    "nom_corrige2":"Carole Viau",
    "nom_famille":"Viau",
    "titre_genre2":"Conseillère",
    "remuneration":"21962",
    "allocation":"10981",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32943",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":1097,
    "nom_corrige2":"Mario Groleau",
    "nom_famille":"Groleau",
    "titre_genre2":"Maire",
    "remuneration":"17195",
    "allocation":"8598",
    "remuneration2":"4758",
    "allocation2":"2379",
    "total":"32930",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":1098,
    "nom_corrige2":"Robert Pellerin",
    "nom_famille":"Pellerin",
    "titre_genre2":"Conseiller",
    "remuneration":"21933",
    "allocation":"10967",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32900",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1099,
    "nom_corrige2":"Jocelyn Guévremont",
    "nom_famille":"Guévremont",
    "titre_genre2":"Conseiller",
    "remuneration":"21873",
    "allocation":"10937",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32810",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1100,
    "nom_corrige2":"Mario Brunet",
    "nom_famille":"Brunet",
    "titre_genre2":"Conseiller",
    "remuneration":"21284",
    "allocation":"10642",
    "remuneration2":"882,00$",
    "allocation2":"0",
    "total":"32808",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":1101,
    "nom_corrige2":"Nathalie Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"21284",
    "allocation":"10642",
    "remuneration2":"831,00$",
    "allocation2":"0",
    "total":"32757",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":1102,
    "nom_corrige2":"Guillaume Lirette-Gélinas",
    "nom_famille":"Lirette-Gélinas",
    "titre_genre2":"Conseiller",
    "remuneration":"21870",
    "allocation":"10849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32719",
    "ville":"Sherbrooke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184667"
  },
  {
    "ID":1103,
    "nom_corrige2":"Dany Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"19416",
    "allocation":"9708",
    "remuneration2":"2387",
    "allocation2":"1194",
    "total":"32705",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":1104,
    "nom_corrige2":"Jean-François Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Conseiller",
    "remuneration":"22200",
    "allocation":"10500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32700",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":1105,
    "nom_corrige2":"Jocelyne Coursol",
    "nom_famille":"Coursol",
    "titre_genre2":"Conseillère",
    "remuneration":"21792",
    "allocation":"10896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32688",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":1106,
    "nom_corrige2":"Gilles Bertrand",
    "nom_famille":"Bertrand",
    "titre_genre2":"Conseiller",
    "remuneration":"21792",
    "allocation":"10896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32688",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":1107,
    "nom_corrige2":"Martin Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"21792",
    "allocation":"10896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32688",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":1108,
    "nom_corrige2":"Roxanne Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseillère",
    "remuneration":"21792",
    "allocation":"10896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32688",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":1109,
    "nom_corrige2":"Sébastien Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"21792",
    "allocation":"10896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32688",
    "ville":"Sainte-Sophie",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"19410"
  },
  {
    "ID":1110,
    "nom_corrige2":"Bruno Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"21346",
    "allocation":"10553",
    "remuneration2":"510,00$",
    "allocation2":"254,00$",
    "total":"32663",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":1111,
    "nom_corrige2":"Anne-Pierre Charlot",
    "nom_famille":"Charlot",
    "titre_genre2":"Conseillère",
    "remuneration":"21753",
    "allocation":"10877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32630",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1112,
    "nom_corrige2":"Marie-Pier Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseillère",
    "remuneration":"21753",
    "allocation":"10877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32630",
    "ville":"Lavaltrie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"15911"
  },
  {
    "ID":1113,
    "nom_corrige2":"Jocelyne Lyrette",
    "nom_famille":"Lyrette",
    "titre_genre2":"Mairesse",
    "remuneration":"21775",
    "allocation":"10841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32616",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":1114,
    "nom_corrige2":"Christian Pilon",
    "nom_famille":"Pilon",
    "titre_genre2":"Maire",
    "remuneration":"15581",
    "allocation":"7790",
    "remuneration2":"6138",
    "allocation2":"3069",
    "total":"32578",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":1115,
    "nom_corrige2":"Natalia Pereira",
    "nom_famille":"Pereira",
    "titre_genre2":"Conseillère",
    "remuneration":"22021",
    "allocation":"10553",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32574",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":1116,
    "nom_corrige2":"Réal Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Maire",
    "remuneration":"17693",
    "allocation":"8849",
    "remuneration2":"4894",
    "allocation2":"1104",
    "total":"32540",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":1117,
    "nom_corrige2":"Vinciane Peeters",
    "nom_famille":"Peeters",
    "titre_genre2":"Mairesse",
    "remuneration":"15919",
    "allocation":"8213",
    "remuneration2":"5553",
    "allocation2":"2777",
    "total":"32462",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":1118,
    "nom_corrige2":"Richard Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Maire",
    "remuneration":"12203",
    "allocation":"6102",
    "remuneration2":"9814",
    "allocation2":"4306",
    "total":"32425",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":1119,
    "nom_corrige2":"Diane Morneau",
    "nom_famille":"Morneau",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"21610",
    "allocation":"10805",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32415",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":1120,
    "nom_corrige2":"Isabelle Thibeault",
    "nom_famille":"Thibeault",
    "titre_genre2":"Conseillère",
    "remuneration":"19818",
    "allocation":"9909",
    "remuneration2":"1743",
    "allocation2":"872,00$",
    "total":"32342",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":1121,
    "nom_corrige2":"Marie-Dominique Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"21800",
    "allocation":"10500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32300",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":1122,
    "nom_corrige2":"Benoist Latour",
    "nom_famille":"Latour",
    "titre_genre2":"Conseillère",
    "remuneration":"21527",
    "allocation":"10764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32291",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":1123,
    "nom_corrige2":"Gilbert Guérette",
    "nom_famille":"Guérette",
    "titre_genre2":"Conseiller",
    "remuneration":"21527",
    "allocation":"10764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32291",
    "ville":"Bois-des-Filion",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"10706"
  },
  {
    "ID":1124,
    "nom_corrige2":"Adam Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Maire",
    "remuneration":"17467",
    "allocation":"8733",
    "remuneration2":"4026",
    "allocation2":"2011",
    "total":"32237",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":1125,
    "nom_corrige2":"Francis Le Chatelier",
    "nom_famille":"Le Chatelier",
    "titre_genre2":"Conseiller",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"3525",
    "allocation2":"1763",
    "total":"32191",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1126,
    "nom_corrige2":"Christopher Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"22877",
    "allocation":"9199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32076",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":1127,
    "nom_corrige2":"David Christopher",
    "nom_famille":"Christopher",
    "titre_genre2":"Maire",
    "remuneration":"16959",
    "allocation":"8479",
    "remuneration2":"4386",
    "allocation2":"2193",
    "total":"32017",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":1128,
    "nom_corrige2":"Tony Boudreau",
    "nom_famille":"Boudreau",
    "titre_genre2":"Maire",
    "remuneration":"21285",
    "allocation":"10642",
    "remuneration2":"59,00$",
    "allocation2":"29,00$",
    "total":"32015",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":1129,
    "nom_corrige2":"Francine Nzang Essono",
    "nom_famille":"Nzang Essono",
    "titre_genre2":"Conseillère",
    "remuneration":"21342",
    "allocation":"10671",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"32013",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":1130,
    "nom_corrige2":"Yves Desjardins",
    "nom_famille":"Desjardins",
    "titre_genre2":"Conseiller",
    "remuneration":"21253",
    "allocation":"10627",
    "remuneration2":"87,00$",
    "allocation2":"44,00$",
    "total":"32011",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":1131,
    "nom_corrige2":"David Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"19818",
    "allocation":"9909",
    "remuneration2":"1502",
    "allocation2":"751,00$",
    "total":"31980",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":1132,
    "nom_corrige2":"Annie Quenneville",
    "nom_famille":"Quenneville",
    "titre_genre2":"Conseillère",
    "remuneration":"21284",
    "allocation":"10642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31926",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":1133,
    "nom_corrige2":"Martin Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"21284",
    "allocation":"10642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31926",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":1134,
    "nom_corrige2":"Lucien Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Maire",
    "remuneration":"12800",
    "allocation":"6400",
    "remuneration2":"8472",
    "allocation2":"4236",
    "total":"31908",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":1135,
    "nom_corrige2":"Claudie Lacelle",
    "nom_famille":"Lacelle",
    "titre_genre2":"Conseillère",
    "remuneration":"21253",
    "allocation":"10627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31880",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":1136,
    "nom_corrige2":"Émilie Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseillère",
    "remuneration":"21253",
    "allocation":"10627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31880",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":1137,
    "nom_corrige2":"Suzanne Parisé",
    "nom_famille":"Parisé",
    "titre_genre2":"Conseillère",
    "remuneration":"21253",
    "allocation":"10627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31880",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":1138,
    "nom_corrige2":"Véronie Whear",
    "nom_famille":"Whear",
    "titre_genre2":"Conseillère",
    "remuneration":"21253",
    "allocation":"10627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31880",
    "ville":"Mont-Laurier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14641"
  },
  {
    "ID":1139,
    "nom_corrige2":"Jean Fournel",
    "nom_famille":"Fournel",
    "titre_genre2":"Conseiller",
    "remuneration":"21271",
    "allocation":"10553",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31824",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":1140,
    "nom_corrige2":"Normand Pigeon",
    "nom_famille":"Pigeon",
    "titre_genre2":"Conseiller",
    "remuneration":"21271",
    "allocation":"10553",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31824",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":1141,
    "nom_corrige2":"Stéphan Denis",
    "nom_famille":"Denis",
    "titre_genre2":"Conseiller",
    "remuneration":"21271",
    "allocation":"10553",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31824",
    "ville":"Notre-Dame-de-l'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11781"
  },
  {
    "ID":1142,
    "nom_corrige2":"Sylvain Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Maire",
    "remuneration":"11050",
    "allocation":"5525",
    "remuneration2":"10155",
    "allocation2":"5078",
    "total":"31808",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":1143,
    "nom_corrige2":"Esther Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1144,
    "nom_corrige2":"Jean Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseiller",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1145,
    "nom_corrige2":"Jean-Pierre Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1146,
    "nom_corrige2":"Manon Bougie",
    "nom_famille":"Bougie",
    "titre_genre2":"Conseillère",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1147,
    "nom_corrige2":"Olivier Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Conseiller",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1148,
    "nom_corrige2":"Renaud Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1149,
    "nom_corrige2":"Serge Thomassin",
    "nom_famille":"Thomassin",
    "titre_genre2":"Conseiller",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1150,
    "nom_corrige2":"Tom Redmond",
    "nom_famille":"Redmond",
    "titre_genre2":"Conseiller",
    "remuneration":"21101",
    "allocation":"10550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31651",
    "ville":"Saint-Georges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"34097"
  },
  {
    "ID":1151,
    "nom_corrige2":"Martin Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseiller",
    "remuneration":"21063",
    "allocation":"10531",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31594",
    "ville":"Sept-Îles",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"24373"
  },
  {
    "ID":1152,
    "nom_corrige2":"Alain Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseiller",
    "remuneration":"21045",
    "allocation":"10523",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31568",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":1153,
    "nom_corrige2":"Annie Payant",
    "nom_famille":"Payant",
    "titre_genre2":"Conseiller",
    "remuneration":"21000",
    "allocation":"10500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31500",
    "ville":"Saint-Rémi",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"9541"
  },
  {
    "ID":1154,
    "nom_corrige2":"Claude Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"21684",
    "allocation":"9793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31477",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":1155,
    "nom_corrige2":"Clément Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"21684",
    "allocation":"9793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31477",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":1156,
    "nom_corrige2":"Dorys Duchesne",
    "nom_famille":"Duchesne",
    "titre_genre2":"Conseillère",
    "remuneration":"21684",
    "allocation":"9793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31477",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":1157,
    "nom_corrige2":"Éric Chagnon",
    "nom_famille":"Chagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"21684",
    "allocation":"9793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31477",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":1158,
    "nom_corrige2":"François Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"21684",
    "allocation":"9793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31477",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":1159,
    "nom_corrige2":"Michel Pronovost",
    "nom_famille":"Pronovost",
    "titre_genre2":"Conseiller",
    "remuneration":"21684",
    "allocation":"9793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31477",
    "ville":"La Tuque",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"11243"
  },
  {
    "ID":1160,
    "nom_corrige2":"Daniel Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Maire",
    "remuneration":"20291",
    "allocation":"10145",
    "remuneration2":"675,00$",
    "allocation2":"337,00$",
    "total":"31448",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":1161,
    "nom_corrige2":"Daniel Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire suppléant",
    "remuneration":"18338",
    "allocation":"9169",
    "remuneration2":"2582",
    "allocation2":"1273",
    "total":"31362",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":1162,
    "nom_corrige2":"Jacques Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Maire",
    "remuneration":"20950",
    "allocation":"10400",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31350",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":1163,
    "nom_corrige2":"Deny Lépine",
    "nom_famille":"Lépine",
    "titre_genre2":"Maire",
    "remuneration":"16223",
    "allocation":"8111",
    "remuneration2":"4694",
    "allocation2":"2251",
    "total":"31279",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":1164,
    "nom_corrige2":"Yvan Barrette",
    "nom_famille":"Barrette",
    "titre_genre2":"Conseiller",
    "remuneration":"18180",
    "allocation":"9090",
    "remuneration2":"2604",
    "allocation2":"1302",
    "total":"31176",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":1165,
    "nom_corrige2":"Alain Maheux",
    "nom_famille":"Maheux",
    "titre_genre2":"Maire",
    "remuneration":"16176",
    "allocation":"8088",
    "remuneration2":"4547",
    "allocation2":"2274",
    "total":"31085",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":1166,
    "nom_corrige2":"Olivier Prégent",
    "nom_famille":"Prégent",
    "titre_genre2":"Conseiller",
    "remuneration":"20696",
    "allocation":"10348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31044",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":1167,
    "nom_corrige2":"Nancy Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"20696",
    "allocation":"10348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31044",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":1168,
    "nom_corrige2":"Pierre-Yves L'Heureux",
    "nom_famille":"L'Heureux",
    "titre_genre2":"Conseiller",
    "remuneration":"20696",
    "allocation":"10348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31044",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":1169,
    "nom_corrige2":"Denis Ladouceur",
    "nom_famille":"Ladouceur",
    "titre_genre2":"Conseiller",
    "remuneration":"20696",
    "allocation":"10348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31044",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":1170,
    "nom_corrige2":"Marc Deslauriers",
    "nom_famille":"Deslauriers",
    "titre_genre2":"Conseiller",
    "remuneration":"20696",
    "allocation":"10348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31044",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":1171,
    "nom_corrige2":"Gabrielle Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseillère",
    "remuneration":"20696",
    "allocation":"10348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"31044",
    "ville":"L'Île-Perrot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"11900"
  },
  {
    "ID":1172,
    "nom_corrige2":"Julie Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Mairesse",
    "remuneration":"15363",
    "allocation":"7681",
    "remuneration2":"5269",
    "allocation2":"2634",
    "total":"30947",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":1173,
    "nom_corrige2":"Lise Baillargeon",
    "nom_famille":"Baillargeon",
    "titre_genre2":"Mairesse",
    "remuneration":"10438",
    "allocation":"5219",
    "remuneration2":"10143",
    "allocation2":"5072",
    "total":"30872",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":1174,
    "nom_corrige2":"Mathieu Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Maire",
    "remuneration":"12000",
    "allocation":"6000",
    "remuneration2":"11227",
    "allocation2":"1642",
    "total":"30869",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":1175,
    "nom_corrige2":"Steve Lanciaux",
    "nom_famille":"Lanciaux",
    "titre_genre2":"Maire",
    "remuneration":"15265",
    "allocation":"7632",
    "remuneration2":"5303",
    "allocation2":"2652",
    "total":"30852",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":1176,
    "nom_corrige2":"Yvon Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"20490",
    "allocation":"10245",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30735",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":1177,
    "nom_corrige2":"Robert Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"19416",
    "allocation":"9708",
    "remuneration2":"1047",
    "allocation2":"523,00$",
    "total":"30694",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":1178,
    "nom_corrige2":"Jean-Benoit Létourneau",
    "nom_famille":"Létourneau",
    "titre_genre2":"Maire",
    "remuneration":"20410",
    "allocation":"10205",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30615",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":1179,
    "nom_corrige2":"Alexis Nantel",
    "nom_famille":"Nantel",
    "titre_genre2":"Conseiller",
    "remuneration":"20942",
    "allocation":"9594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30536",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":1180,
    "nom_corrige2":"Chantal Riopel",
    "nom_famille":"Riopel",
    "titre_genre2":"Conseillère",
    "remuneration":"20942",
    "allocation":"9594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30536",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":1181,
    "nom_corrige2":"Denis Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"20942",
    "allocation":"9594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30536",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":1182,
    "nom_corrige2":"Janie Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"20942",
    "allocation":"9594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30536",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":1183,
    "nom_corrige2":"Jean-Sébastien Hénault",
    "nom_famille":"Hénault",
    "titre_genre2":"Conseiller",
    "remuneration":"20942",
    "allocation":"9594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30536",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":1184,
    "nom_corrige2":"Robert Groulx",
    "nom_famille":"Groulx",
    "titre_genre2":"Conseiller",
    "remuneration":"20942",
    "allocation":"9594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30536",
    "ville":"Saint-Charles-Borromée",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"16541"
  },
  {
    "ID":1185,
    "nom_corrige2":"Luce Lacroix",
    "nom_famille":"Lacroix",
    "titre_genre2":"Conseillère",
    "remuneration":"18057",
    "allocation":"9028",
    "remuneration2":"2275",
    "allocation2":"1137",
    "total":"30497",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":1186,
    "nom_corrige2":"Alain Gamache",
    "nom_famille":"Gamache",
    "titre_genre2":"Maire",
    "remuneration":"14128",
    "allocation":"7064",
    "remuneration2":"6188",
    "allocation2":"3094",
    "total":"30474",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":1187,
    "nom_corrige2":"Sonia Desjardins",
    "nom_famille":"Desjardins",
    "titre_genre2":"Mairesse",
    "remuneration":"18480",
    "allocation":"11990",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30470",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":1188,
    "nom_corrige2":"Martin Leprohon",
    "nom_famille":"Leprohon",
    "titre_genre2":"Conseiller",
    "remuneration":"19349",
    "allocation":"9674",
    "remuneration2":"1027",
    "allocation2":"381,00$",
    "total":"30431",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":1189,
    "nom_corrige2":"Sylvain Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Maire",
    "remuneration":"20258",
    "allocation":"10129",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30387",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":1190,
    "nom_corrige2":"Vicky Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Conseillère",
    "remuneration":"19416",
    "allocation":"9708",
    "remuneration2":"927,00$",
    "allocation2":"328,00$",
    "total":"30379",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":1191,
    "nom_corrige2":"Christian Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseiller",
    "remuneration":"20241",
    "allocation":"10121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30362",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":1192,
    "nom_corrige2":"Michel Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseiller",
    "remuneration":"20241",
    "allocation":"10121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30362",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":1193,
    "nom_corrige2":"Michel Beaumont",
    "nom_famille":"Beaumont",
    "titre_genre2":"Conseiller",
    "remuneration":"20241",
    "allocation":"10121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30362",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":1194,
    "nom_corrige2":"Michèle Abdelnour",
    "nom_famille":"Abdelnour",
    "titre_genre2":"Conseillère",
    "remuneration":"20241",
    "allocation":"10121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30362",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":1195,
    "nom_corrige2":"Nancy Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"20241",
    "allocation":"10121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30362",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":1196,
    "nom_corrige2":"Serge Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"20241",
    "allocation":"10121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30362",
    "ville":"Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4256"
  },
  {
    "ID":1197,
    "nom_corrige2":"Sylvie Ouellette",
    "nom_famille":"Ouellette",
    "titre_genre2":"Conseillère",
    "remuneration":"16977",
    "allocation":"8488",
    "remuneration2":"3621",
    "allocation2":"1207",
    "total":"30293",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":1198,
    "nom_corrige2":"Loïc Blancquaert",
    "nom_famille":"Blancquaert",
    "titre_genre2":"Conseiller",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"2200",
    "allocation2":"1100",
    "total":"30203",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1199,
    "nom_corrige2":"Valérie Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseillère",
    "remuneration":"20527",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30132",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1200,
    "nom_corrige2":"Laurent Phoenix",
    "nom_famille":"Phoenix",
    "titre_genre2":"Maire",
    "remuneration":"13817",
    "allocation":"6907",
    "remuneration2":"6216",
    "allocation2":"3108",
    "total":"30048",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":1201,
    "nom_corrige2":"Marie-France Beaudry",
    "nom_famille":"Beaudry",
    "titre_genre2":"Conseillère",
    "remuneration":"19500",
    "allocation":"9750",
    "remuneration2":"512,00$",
    "allocation2":"256,00$",
    "total":"30018",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":1202,
    "nom_corrige2":"Andrew Etheridge",
    "nom_famille":"Etheridge",
    "titre_genre2":"Maire",
    "remuneration":"20000",
    "allocation":"10000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"30000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1203,
    "nom_corrige2":"Isabelle Hardy",
    "nom_famille":"Hardy",
    "titre_genre2":"Conseillère",
    "remuneration":"19986",
    "allocation":"9993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29979",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":1204,
    "nom_corrige2":"Keven Renière",
    "nom_famille":"Renière",
    "titre_genre2":"Conseiller",
    "remuneration":"19986",
    "allocation":"9993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29979",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":1205,
    "nom_corrige2":"Marc-Olivier Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"19986",
    "allocation":"9993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29979",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":1206,
    "nom_corrige2":"Pierre Berthiaume",
    "nom_famille":"Berthiaume",
    "titre_genre2":"Conseiller",
    "remuneration":"19986",
    "allocation":"9993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29979",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":1207,
    "nom_corrige2":"Sébastien Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"19986",
    "allocation":"9993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29979",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":1208,
    "nom_corrige2":"Véronique Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Conseillère",
    "remuneration":"19986",
    "allocation":"9993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29979",
    "ville":"Sainte-Anne-des-Plaines",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15900"
  },
  {
    "ID":1209,
    "nom_corrige2":"Marcel Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Maire",
    "remuneration":"20475",
    "allocation":"9408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29883",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":1210,
    "nom_corrige2":"Alexandre Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"19896",
    "allocation":"9948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29844",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1211,
    "nom_corrige2":"Claudia Bertinotti",
    "nom_famille":"Bertinotti",
    "titre_genre2":"Conseillère",
    "remuneration":"19896",
    "allocation":"9948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29844",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1212,
    "nom_corrige2":"Luc Beauséjour",
    "nom_famille":"Beauséjour",
    "titre_genre2":"Conseiller",
    "remuneration":"19896",
    "allocation":"9948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29844",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1213,
    "nom_corrige2":"Patrick Lasalle",
    "nom_famille":"Lasalle",
    "titre_genre2":"Conseiller",
    "remuneration":"19896",
    "allocation":"9948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29844",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1214,
    "nom_corrige2":"Richard Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"19896",
    "allocation":"9948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29844",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1215,
    "nom_corrige2":"Cédric Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"19896",
    "allocation":"9948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29844",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1216,
    "nom_corrige2":"Enrico Valente",
    "nom_famille":"Valente",
    "titre_genre2":"Conseiller",
    "remuneration":"20637",
    "allocation":"9199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29836",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":1217,
    "nom_corrige2":"Gilles Jr. Bédard",
    "nom_famille":"Jr. Bédard",
    "titre_genre2":"Maire",
    "remuneration":"13921",
    "allocation":"6984",
    "remuneration2":"7808",
    "allocation2":"1104",
    "total":"29817",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":1218,
    "nom_corrige2":"Jean-Kristov Carpentier",
    "nom_famille":"Carpentier",
    "titre_genre2":"Conseiller",
    "remuneration":"19870",
    "allocation":"9935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29805",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":1219,
    "nom_corrige2":"Bruno Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"19870",
    "allocation":"9935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29805",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":1220,
    "nom_corrige2":"Josianne Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"19870",
    "allocation":"9935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29805",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":1221,
    "nom_corrige2":"Kimberly St-Denis",
    "nom_famille":"St-Denis",
    "titre_genre2":"Conseillère",
    "remuneration":"19870",
    "allocation":"9935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29805",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":1222,
    "nom_corrige2":"Raynald Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"19870",
    "allocation":"9935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29805",
    "ville":"Rawdon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12722"
  },
  {
    "ID":1223,
    "nom_corrige2":"Patrice Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Maire",
    "remuneration":"12300",
    "allocation":"6150",
    "remuneration2":"7543",
    "allocation2":"3772",
    "total":"29765",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":1224,
    "nom_corrige2":"France Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseillère",
    "remuneration":"19416",
    "allocation":"9708",
    "remuneration2":"409,00$",
    "allocation2":"205,00$",
    "total":"29738",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":1225,
    "nom_corrige2":"Claude Rainville",
    "nom_famille":"Rainville",
    "titre_genre2":"Conseiller",
    "remuneration":"19818",
    "allocation":"9909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29727",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":1226,
    "nom_corrige2":"Marcel Leboeuf",
    "nom_famille":"Leboeuf",
    "titre_genre2":"Conseiller",
    "remuneration":"19818",
    "allocation":"9909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29727",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":1227,
    "nom_corrige2":"Mélodie Georget",
    "nom_famille":"Georget",
    "titre_genre2":"Conseillère",
    "remuneration":"19818",
    "allocation":"9909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29727",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":1228,
    "nom_corrige2":"Gaston Meilleur",
    "nom_famille":"Meilleur",
    "titre_genre2":"Conseiller",
    "remuneration":"19818",
    "allocation":"9909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29727",
    "ville":"Mont-Saint-Hilaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"19444"
  },
  {
    "ID":1229,
    "nom_corrige2":"Pascal Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Maire",
    "remuneration":"16234",
    "allocation":"8117",
    "remuneration2":"3533",
    "allocation2":"1766",
    "total":"29650",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":1230,
    "nom_corrige2":"Louis-Marie Bastille",
    "nom_famille":"Bastille",
    "titre_genre2":"Maire",
    "remuneration":"9639",
    "allocation":"4819",
    "remuneration2":"10500",
    "allocation2":"4667",
    "total":"29625",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":1231,
    "nom_corrige2":"Margaret Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseillère",
    "remuneration":"19737",
    "allocation":"9869",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29606",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":1232,
    "nom_corrige2":"Manon Robitaille",
    "nom_famille":"Robitaille",
    "titre_genre2":"Conseillère",
    "remuneration":"19737",
    "allocation":"9869",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29606",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":1233,
    "nom_corrige2":"Erik Johnson",
    "nom_famille":"Johnson",
    "titre_genre2":"Conseiller",
    "remuneration":"19737",
    "allocation":"9869",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29606",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":1234,
    "nom_corrige2":"Jean-Guy Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"19735",
    "allocation":"9867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29602",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":1235,
    "nom_corrige2":"Marie-Christine Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseillère",
    "remuneration":"19735",
    "allocation":"9867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29602",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":1236,
    "nom_corrige2":"Mylène Allary",
    "nom_famille":"Allary",
    "titre_genre2":"Conseillère",
    "remuneration":"19735",
    "allocation":"9867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29602",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":1237,
    "nom_corrige2":"Nicole Chevalier",
    "nom_famille":"Chevalier",
    "titre_genre2":"Conseillère",
    "remuneration":"19735",
    "allocation":"9867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29602",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":1238,
    "nom_corrige2":"Régis Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Conseiller",
    "remuneration":"19735",
    "allocation":"9867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29602",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":1239,
    "nom_corrige2":"Stéphanie Godin",
    "nom_famille":"Godin",
    "titre_genre2":"Conseillère",
    "remuneration":"19735",
    "allocation":"9867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29602",
    "ville":"Notre-Dame-des-Prairies",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9580"
  },
  {
    "ID":1240,
    "nom_corrige2":"Lisyane Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"20893",
    "allocation":"8598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29491",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1241,
    "nom_corrige2":"Alexandre Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Maire",
    "remuneration":"8325",
    "allocation":"4604",
    "remuneration2":"15233",
    "allocation2":"1269",
    "total":"29431",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":1242,
    "nom_corrige2":"Jonathan Chalifoux",
    "nom_famille":"Chalifoux",
    "titre_genre2":"Maire",
    "remuneration":"20351",
    "allocation":"9065",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29416",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":1243,
    "nom_corrige2":"Gaston Donovan",
    "nom_famille":"Donovan",
    "titre_genre2":"Maire",
    "remuneration":"13441",
    "allocation":"6720",
    "remuneration2":"6088",
    "allocation2":"3044",
    "total":"29293",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":1244,
    "nom_corrige2":"Stéphane Beaudry",
    "nom_famille":"Beaudry",
    "titre_genre2":"Conseiller",
    "remuneration":"19500",
    "allocation":"9750",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29250",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":1245,
    "nom_corrige2":"Dominic Labrie",
    "nom_famille":"Labrie",
    "titre_genre2":"Conseiller",
    "remuneration":"19997",
    "allocation":"9199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29196",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":1246,
    "nom_corrige2":"Ayla Scriven",
    "nom_famille":"Scriven",
    "titre_genre2":"Conseillère",
    "remuneration":"19589",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29194",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1247,
    "nom_corrige2":"Olivier Cameron Chevrier",
    "nom_famille":"Cameron Chevrier",
    "titre_genre2":"Conseiller",
    "remuneration":"19349",
    "allocation":"9674",
    "remuneration2":"93,00$",
    "allocation2":"46,00$",
    "total":"29162",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":1248,
    "nom_corrige2":"Alain Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"19440",
    "allocation":"9720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29160",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":1249,
    "nom_corrige2":"Dominique Bellemare",
    "nom_famille":"Bellemare",
    "titre_genre2":"Conseiller",
    "remuneration":"19440",
    "allocation":"9720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29160",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":1250,
    "nom_corrige2":"Francis Laberge",
    "nom_famille":"Laberge",
    "titre_genre2":"Conseiller",
    "remuneration":"19440",
    "allocation":"9720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29160",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":1251,
    "nom_corrige2":"Jocelyne Rajotte",
    "nom_famille":"Rajotte",
    "titre_genre2":"Conseillère",
    "remuneration":"19440",
    "allocation":"9720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29160",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":1252,
    "nom_corrige2":"Manon Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseillère",
    "remuneration":"19440",
    "allocation":"9720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29160",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":1253,
    "nom_corrige2":"Mario Charette",
    "nom_famille":"Charette",
    "titre_genre2":"Conseiller",
    "remuneration":"19440",
    "allocation":"9720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29160",
    "ville":"Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15156"
  },
  {
    "ID":1254,
    "nom_corrige2":"Mathieu Daviault",
    "nom_famille":"Daviault",
    "titre_genre2":"Conseiller",
    "remuneration":"19416",
    "allocation":"9708",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29124",
    "ville":"Saint-Amable",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"14089"
  },
  {
    "ID":1255,
    "nom_corrige2":"Sandra Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseillère",
    "remuneration":"19461",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29066",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1256,
    "nom_corrige2":"Yvon Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Maire",
    "remuneration":"11290",
    "allocation":"5646",
    "remuneration2":"8071",
    "allocation2":"4035",
    "total":"29042",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":1257,
    "nom_corrige2":"Denis Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"19349",
    "allocation":"9674",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29023",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":1258,
    "nom_corrige2":"Kim Méthot",
    "nom_famille":"Méthot",
    "titre_genre2":"Conseillère",
    "remuneration":"19349",
    "allocation":"9674",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29023",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":1259,
    "nom_corrige2":"Guy Lacroix",
    "nom_famille":"Lacroix",
    "titre_genre2":"Conseiller",
    "remuneration":"19349",
    "allocation":"9674",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29023",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":1260,
    "nom_corrige2":"Laurie-Line Lallemand-Raymond",
    "nom_famille":"Lallemand-Raymond",
    "titre_genre2":"Conseillère",
    "remuneration":"19349",
    "allocation":"9674",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29023",
    "ville":"Saint-Basile-le-Grand",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"17309"
  },
  {
    "ID":1261,
    "nom_corrige2":"Èveline Laverdière",
    "nom_famille":"Laverdière",
    "titre_genre2":"Conseillère",
    "remuneration":"20413",
    "allocation":"8598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29011",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1262,
    "nom_corrige2":"Jean St-Jules",
    "nom_famille":"St-Jules",
    "titre_genre2":"Conseiller",
    "remuneration":"20413",
    "allocation":"8598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29011",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1263,
    "nom_corrige2":"Sylvie Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"20413",
    "allocation":"8598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29011",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1264,
    "nom_corrige2":"Yvon Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseiller",
    "remuneration":"20413",
    "allocation":"8598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29011",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1265,
    "nom_corrige2":"Martin Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"20413",
    "allocation":"8598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"29011",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1266,
    "nom_corrige2":"Jean-Yves Boulianne",
    "nom_famille":"Boulianne",
    "titre_genre2":"Conseiller",
    "remuneration":"15997",
    "allocation":"7998",
    "remuneration2":"3328",
    "allocation2":"1664",
    "total":"28987",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":1267,
    "nom_corrige2":"Jacques Dostie",
    "nom_famille":"Dostie",
    "titre_genre2":"Conseiller",
    "remuneration":"19343",
    "allocation":"9183",
    "remuneration2":"281,00$",
    "allocation2":"141,00$",
    "total":"28948",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":1268,
    "nom_corrige2":"Serge Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Maire",
    "remuneration":"14990",
    "allocation":"7571",
    "remuneration2":"4236",
    "allocation2":"2126",
    "total":"28923",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":1269,
    "nom_corrige2":"Michèle Dufresne",
    "nom_famille":"Dufresne",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"19546",
    "allocation":"9093",
    "remuneration2":"173,00$",
    "allocation2":"87,00$",
    "total":"28899",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":1270,
    "nom_corrige2":"Julie Bourgoin",
    "nom_famille":"Bourgoin",
    "titre_genre2":"Conseillère",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"1320",
    "allocation2":"660,00$",
    "total":"28883",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1271,
    "nom_corrige2":"Raymond Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Maire",
    "remuneration":"18165",
    "allocation":"8914",
    "remuneration2":"1186",
    "allocation2":"595,00$",
    "total":"28860",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":1272,
    "nom_corrige2":"Frédéric Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"19210",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28815",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":1273,
    "nom_corrige2":"Jessica Raby-Beaulieu",
    "nom_famille":"Raby-Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"19209",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28814",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1274,
    "nom_corrige2":"Étienne Urbain",
    "nom_famille":"Urbain",
    "titre_genre2":"Conseiller",
    "remuneration":"19209",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28814",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1275,
    "nom_corrige2":"Christiane Wilson",
    "nom_famille":"Wilson",
    "titre_genre2":"Conseillère",
    "remuneration":"19209",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28814",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1276,
    "nom_corrige2":"Isabelle Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"19209",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28814",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1277,
    "nom_corrige2":"Danielle Deraîche",
    "nom_famille":"Deraîche",
    "titre_genre2":"Conseillère",
    "remuneration":"19209",
    "allocation":"9605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28814",
    "ville":"Saint-Colomban",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18836"
  },
  {
    "ID":1278,
    "nom_corrige2":"Stéphane Amireault",
    "nom_famille":"Amireault",
    "titre_genre2":"Conseiller",
    "remuneration":"19440",
    "allocation":"9356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28796",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":1279,
    "nom_corrige2":"Cybele Wilson",
    "nom_famille":"Wilson",
    "titre_genre2":"Conseillère",
    "remuneration":"19517",
    "allocation":"9199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28716",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":1280,
    "nom_corrige2":"Guy Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Maire",
    "remuneration":"19100",
    "allocation":"9550",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28650",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":1281,
    "nom_corrige2":"Alain Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseiller",
    "remuneration":"9326",
    "allocation":"4460",
    "remuneration2":"9893",
    "allocation2":"4946",
    "total":"28625",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":1282,
    "nom_corrige2":"Rita Jain",
    "nom_famille":"Jain",
    "titre_genre2":"Conseillère",
    "remuneration":"19352",
    "allocation":"9199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28551",
    "ville":"Chelsea",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"8982"
  },
  {
    "ID":1283,
    "nom_corrige2":"Denis Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"19343",
    "allocation":"9183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28526",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":1284,
    "nom_corrige2":"René Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"19343",
    "allocation":"9183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28526",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":1285,
    "nom_corrige2":"Richard Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"19343",
    "allocation":"9183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28526",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":1286,
    "nom_corrige2":"Éric Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"18953",
    "allocation":"9477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28430",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":1287,
    "nom_corrige2":"Jean-Pierre Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Conseiller",
    "remuneration":"18953",
    "allocation":"9477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28430",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":1288,
    "nom_corrige2":"Jonathan Anderson",
    "nom_famille":"Anderson",
    "titre_genre2":"Conseiller",
    "remuneration":"18953",
    "allocation":"9477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28430",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":1289,
    "nom_corrige2":"Patrick Lecuyer",
    "nom_famille":"Lecuyer",
    "titre_genre2":"Conseiller",
    "remuneration":"18953",
    "allocation":"9477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28430",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":1290,
    "nom_corrige2":"Paul Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"18953",
    "allocation":"9477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28430",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":1291,
    "nom_corrige2":"Yannick Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseiller",
    "remuneration":"18953",
    "allocation":"9477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28430",
    "ville":"Saint-Zotique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"10392"
  },
  {
    "ID":1292,
    "nom_corrige2":"Huguette Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseillère",
    "remuneration":"19243",
    "allocation":"9183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28426",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":1293,
    "nom_corrige2":"Yves Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"19243",
    "allocation":"9183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28426",
    "ville":"Lac-Mégantic",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5955"
  },
  {
    "ID":1294,
    "nom_corrige2":"Real Ryan",
    "nom_famille":"Ryan",
    "titre_genre2":"Maire",
    "remuneration":"19803",
    "allocation":"8610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28413",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":1295,
    "nom_corrige2":"Daniel St-Jean",
    "nom_famille":"St-Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"18940",
    "allocation":"9470",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28410",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":1296,
    "nom_corrige2":"Luc Laforge",
    "nom_famille":"Laforge",
    "titre_genre2":"Conseiller",
    "remuneration":"18940",
    "allocation":"9470",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28410",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":1297,
    "nom_corrige2":"Stéphanie Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"18940",
    "allocation":"9470",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28410",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":1298,
    "nom_corrige2":"Edith Labrosse",
    "nom_famille":"Labrosse",
    "titre_genre2":"Conseillère",
    "remuneration":"18940",
    "allocation":"9470",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28410",
    "ville":"Carignan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"12529"
  },
  {
    "ID":1299,
    "nom_corrige2":"Pierre Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Maire",
    "remuneration":"10506",
    "allocation":"5252",
    "remuneration2":"8751",
    "allocation2":"3862",
    "total":"28371",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":1300,
    "nom_corrige2":"Dona Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"18963",
    "allocation":"9356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28319",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":1301,
    "nom_corrige2":"Manon Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"18963",
    "allocation":"9356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28319",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":1302,
    "nom_corrige2":"Michel Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"18963",
    "allocation":"9356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28319",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":1303,
    "nom_corrige2":"Michel Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"18963",
    "allocation":"9356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28319",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":1304,
    "nom_corrige2":"Vicky Robichaud",
    "nom_famille":"Robichaud",
    "titre_genre2":"Conseillère",
    "remuneration":"18963",
    "allocation":"9356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28319",
    "ville":"L'Épiphanie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"9156"
  },
  {
    "ID":1305,
    "nom_corrige2":"Michel-Henri Goyette",
    "nom_famille":"Goyette",
    "titre_genre2":"Maire",
    "remuneration":"9600",
    "allocation":"4800",
    "remuneration2":"9254",
    "allocation2":"4627",
    "total":"28281",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":1306,
    "nom_corrige2":"Martin Berllefroid",
    "nom_famille":"Berllefroid",
    "titre_genre2":"Maire",
    "remuneration":"11141",
    "allocation":"5571",
    "remuneration2":"7681",
    "allocation2":"3840",
    "total":"28233",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":1307,
    "nom_corrige2":"Daniel Millette",
    "nom_famille":"Millette",
    "titre_genre2":"Maire suppléant",
    "remuneration":"18820",
    "allocation":"9410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28230",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":1308,
    "nom_corrige2":"Pierre-Alexandre Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"18809",
    "allocation":"9405",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28214",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":1309,
    "nom_corrige2":"Sébastien Bazinet",
    "nom_famille":"Bazinet",
    "titre_genre2":"Conseiller",
    "remuneration":"18809",
    "allocation":"9405",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28214",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":1310,
    "nom_corrige2":"Patrice Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Maire",
    "remuneration":"12335",
    "allocation":"6167",
    "remuneration2":"6457",
    "allocation2":"3228",
    "total":"28187",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":1311,
    "nom_corrige2":"Nathalie Dépeault",
    "nom_famille":"Dépeault",
    "titre_genre2":"Conseillère",
    "remuneration":"19077",
    "allocation":"9088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28165",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":1312,
    "nom_corrige2":"Micheline Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Mairesse",
    "remuneration":"13257",
    "allocation":"6739",
    "remuneration2":"5407",
    "allocation2":"2704",
    "total":"28107",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":1313,
    "nom_corrige2":"Johanne Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Conseillère",
    "remuneration":"14019",
    "allocation":"7010",
    "remuneration2":"6656",
    "allocation2":"0",
    "total":"27685",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":1314,
    "nom_corrige2":"Guy-Julien Maynè",
    "nom_famille":"Maynè",
    "titre_genre2":"Maire",
    "remuneration":"18690",
    "allocation":"9345",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28035",
    "ville":"Sainte-Clotilde",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3127"
  },
  {
    "ID":1315,
    "nom_corrige2":"Sylvain Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Maire",
    "remuneration":"18672",
    "allocation":"9336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"28008",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":1316,
    "nom_corrige2":"Rolland Camiré",
    "nom_famille":"Camiré",
    "titre_genre2":"Maire",
    "remuneration":"13316",
    "allocation":"6660",
    "remuneration2":"5320",
    "allocation2":"2660",
    "total":"27956",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":1317,
    "nom_corrige2":"Aryane Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseillère",
    "remuneration":"18624",
    "allocation":"9312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27936",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":1318,
    "nom_corrige2":"Diego Scalzo",
    "nom_famille":"Scalzo",
    "titre_genre2":"Maire",
    "remuneration":"17201",
    "allocation":"8600",
    "remuneration2":"1418",
    "allocation2":"709,00$",
    "total":"27928",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":1319,
    "nom_corrige2":"Stéphane Beauchemin",
    "nom_famille":"Beauchemin",
    "titre_genre2":"Maire",
    "remuneration":"15935",
    "allocation":"7339",
    "remuneration2":"3017",
    "allocation2":"1509",
    "total":"27800",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":1320,
    "nom_corrige2":"Denis Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Maire",
    "remuneration":"18504",
    "allocation":"9252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27756",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":1321,
    "nom_corrige2":"Yves Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Maire",
    "remuneration":"18491",
    "allocation":"9245",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27736",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":1322,
    "nom_corrige2":"Francis Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Maire",
    "remuneration":"18400",
    "allocation":"9200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27600",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":1323,
    "nom_corrige2":"Martine Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseillère",
    "remuneration":"15792",
    "allocation":"7896",
    "remuneration2":"2582",
    "allocation2":"1273",
    "total":"27543",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":1324,
    "nom_corrige2":"Normand Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire",
    "remuneration":"14115",
    "allocation":"6922",
    "remuneration2":"4309",
    "allocation2":"2155",
    "total":"27501",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":1325,
    "nom_corrige2":"Dominique Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Mairesse",
    "remuneration":"11168",
    "allocation":"5481",
    "remuneration2":"7223",
    "allocation2":"3612",
    "total":"27484",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":1326,
    "nom_corrige2":"Harold Poisson",
    "nom_famille":"Poisson",
    "titre_genre2":"Maire",
    "remuneration":"15039",
    "allocation":"7520",
    "remuneration2":"3242",
    "allocation2":"1621",
    "total":"27422",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":1327,
    "nom_corrige2":"Pierre Nelson Renaud",
    "nom_famille":"Nelson Renaud",
    "titre_genre2":"Maire",
    "remuneration":"12232",
    "allocation":"6068",
    "remuneration2":"6034",
    "allocation2":"3017",
    "total":"27351",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":1328,
    "nom_corrige2":"Jacques David",
    "nom_famille":"David",
    "titre_genre2":"Maire",
    "remuneration":"10400",
    "allocation":"5200",
    "remuneration2":"8699",
    "allocation2":"3051",
    "total":"27350",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":1329,
    "nom_corrige2":"Vincent Lanteigne",
    "nom_famille":"Lanteigne",
    "titre_genre2":"Conseiller",
    "remuneration":"16958",
    "allocation":"8479",
    "remuneration2":"1255",
    "allocation2":"627,00$",
    "total":"27319",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":1330,
    "nom_corrige2":"Benoit Voyer",
    "nom_famille":"Voyer",
    "titre_genre2":"Conseiller",
    "remuneration":"18180",
    "allocation":"9090",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27270",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":1331,
    "nom_corrige2":"Fernand Lirette",
    "nom_famille":"Lirette",
    "titre_genre2":"Conseiller",
    "remuneration":"18180",
    "allocation":"9090",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27270",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":1332,
    "nom_corrige2":"Philippe Gasse",
    "nom_famille":"Gasse",
    "titre_genre2":"Conseiller",
    "remuneration":"18180",
    "allocation":"9090",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27270",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":1333,
    "nom_corrige2":"Pierre Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"18180",
    "allocation":"9090",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27270",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":1334,
    "nom_corrige2":"Claude Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Conseiller",
    "remuneration":"18180",
    "allocation":"9090",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27270",
    "ville":"Saint-Raymond",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11821"
  },
  {
    "ID":1335,
    "nom_corrige2":"Joe Falci",
    "nom_famille":"Falci",
    "titre_genre2":"Conseiller",
    "remuneration":"18150",
    "allocation":"9075",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27225",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":1336,
    "nom_corrige2":"Lucie Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseillère",
    "remuneration":"18150",
    "allocation":"9075",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27225",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":1337,
    "nom_corrige2":"Pauline Lavoie-Dubé",
    "nom_famille":"Lavoie-Dubé",
    "titre_genre2":"Conseillère",
    "remuneration":"18150",
    "allocation":"9075",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27225",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":1338,
    "nom_corrige2":"Serge Desjardins",
    "nom_famille":"Desjardins",
    "titre_genre2":"Conseiller",
    "remuneration":"18150",
    "allocation":"9075",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27225",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":1339,
    "nom_corrige2":"Sylvain Crevier",
    "nom_famille":"Crevier",
    "titre_genre2":"Conseiller",
    "remuneration":"18150",
    "allocation":"9075",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27225",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":1340,
    "nom_corrige2":"Josée Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseillère",
    "remuneration":"18150",
    "allocation":"9075",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27225",
    "ville":"Charlemagne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"6666"
  },
  {
    "ID":1341,
    "nom_corrige2":"Gilbert Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Maire",
    "remuneration":"13239",
    "allocation":"6319",
    "remuneration2":"5096",
    "allocation2":"2548",
    "total":"27202",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":1342,
    "nom_corrige2":"Marie-Andrée Bonneau",
    "nom_famille":"Bonneau",
    "titre_genre2":"Conseillère",
    "remuneration":"18124",
    "allocation":"9062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27186",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":1343,
    "nom_corrige2":"Eric Langlois",
    "nom_famille":"Langlois",
    "titre_genre2":"Conseiller",
    "remuneration":"18092",
    "allocation":"9046",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"27138",
    "ville":"Deux-Montagnes",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"18440"
  },
  {
    "ID":1344,
    "nom_corrige2":"Annick Corbeil",
    "nom_famille":"Corbeil",
    "titre_genre2":"Mairesse",
    "remuneration":"12062",
    "allocation":"6031",
    "remuneration2":"6018",
    "allocation2":"3009",
    "total":"27120",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":1345,
    "nom_corrige2":"Johanne Delage",
    "nom_famille":"Delage",
    "titre_genre2":"Mairesse",
    "remuneration":"13669",
    "allocation":"6835",
    "remuneration2":"4409",
    "allocation2":"2205",
    "total":"27118",
    "ville":"La Patrie",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"828"
  },
  {
    "ID":1346,
    "nom_corrige2":"Josée Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Mairesse",
    "remuneration":"11790",
    "allocation":"5895",
    "remuneration2":"6519",
    "allocation2":"2898",
    "total":"27102",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":1347,
    "nom_corrige2":"Donald Rheault",
    "nom_famille":"Rheault",
    "titre_genre2":"Maire",
    "remuneration":"15766",
    "allocation":"7792",
    "remuneration2":"3481",
    "allocation2":"0",
    "total":"27039",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":1348,
    "nom_corrige2":"Alexandrine Lamoureux-Salvas",
    "nom_famille":"Lamoureux-Salvas",
    "titre_genre2":"Conseillère",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26903",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1349,
    "nom_corrige2":"Liette Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26903",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1350,
    "nom_corrige2":"Stéphanie Verreault",
    "nom_famille":"Verreault",
    "titre_genre2":"Conseillère",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26903",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1351,
    "nom_corrige2":"Virginie Dostie-Toupin",
    "nom_famille":"Dostie-Toupin",
    "titre_genre2":"Conseillère",
    "remuneration":"17935",
    "allocation":"8968",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26903",
    "ville":"Saint-Lambert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"23521"
  },
  {
    "ID":1352,
    "nom_corrige2":"Yves Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Maire",
    "remuneration":"13279",
    "allocation":"6639",
    "remuneration2":"4620",
    "allocation2":"2310",
    "total":"26848",
    "ville":"Lac-Sergent",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"616"
  },
  {
    "ID":1353,
    "nom_corrige2":"Jean Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Maire",
    "remuneration":"12740",
    "allocation":"6370",
    "remuneration2":"5086",
    "allocation2":"2543",
    "total":"26739",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":1354,
    "nom_corrige2":"Martin Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Maire",
    "remuneration":"17788",
    "allocation":"8894",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26682",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":1355,
    "nom_corrige2":"Lucie Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"17986",
    "allocation":"8124",
    "remuneration2":"365,00$",
    "allocation2":"170,00$",
    "total":"26645",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":1356,
    "nom_corrige2":"Colette Quevillon",
    "nom_famille":"Quevillon",
    "titre_genre2":"Mairesse",
    "remuneration":"17739",
    "allocation":"8870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26609",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":1357,
    "nom_corrige2":"Gaétan Larose",
    "nom_famille":"Larose",
    "titre_genre2":"Conseiller",
    "remuneration":"17730",
    "allocation":"8865",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26595",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":1358,
    "nom_corrige2":"Aline Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseillère",
    "remuneration":"17730",
    "allocation":"8865",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26595",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":1359,
    "nom_corrige2":"Guylaine Desforges",
    "nom_famille":"Desforges",
    "titre_genre2":"Conseillère",
    "remuneration":"17730",
    "allocation":"8865",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26595",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":1360,
    "nom_corrige2":"Christian David",
    "nom_famille":"David",
    "titre_genre2":"Conseiller",
    "remuneration":"17730",
    "allocation":"8865",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26595",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":1361,
    "nom_corrige2":"Virginie Filiatrault",
    "nom_famille":"Filiatrault",
    "titre_genre2":"Conseillère",
    "remuneration":"17730",
    "allocation":"8865",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26595",
    "ville":"Lachute",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"15292"
  },
  {
    "ID":1362,
    "nom_corrige2":"Stéphane Houde",
    "nom_famille":"Houde",
    "titre_genre2":"Conseiller",
    "remuneration":"12232",
    "allocation":"6116",
    "remuneration2":"5497",
    "allocation2":"2748",
    "total":"26593",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":1363,
    "nom_corrige2":"Michel Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Maire",
    "remuneration":"17700",
    "allocation":"8850",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26550",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":1364,
    "nom_corrige2":"Norman Young",
    "nom_famille":"Young",
    "titre_genre2":"Maire",
    "remuneration":"15120",
    "allocation":"7560",
    "remuneration2":"2547",
    "allocation2":"1274",
    "total":"26501",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":1365,
    "nom_corrige2":"Réal Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Maire",
    "remuneration":"17350",
    "allocation":"4475",
    "remuneration2":"3107",
    "allocation2":"1554",
    "total":"26486",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":1366,
    "nom_corrige2":"Ginette Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Mairesse",
    "remuneration":"13867",
    "allocation":"6934",
    "remuneration2":"5638",
    "allocation2":"0",
    "total":"26439",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":1367,
    "nom_corrige2":"Denis Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Maire",
    "remuneration":"6955",
    "allocation":"3478",
    "remuneration2":"11156",
    "allocation2":"4827",
    "total":"26416",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":1368,
    "nom_corrige2":"Steven Neil",
    "nom_famille":"Neil",
    "titre_genre2":"Maire",
    "remuneration":"11975",
    "allocation":"5988",
    "remuneration2":"5630",
    "allocation2":"2815",
    "total":"26408",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":1369,
    "nom_corrige2":"Louis Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Maire",
    "remuneration":"18422",
    "allocation":"7961",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26383",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":1370,
    "nom_corrige2":"Lynda Tétreault",
    "nom_famille":"Tétreault",
    "titre_genre2":"Mairesse",
    "remuneration":"9762",
    "allocation":"4881",
    "remuneration2":"7818",
    "allocation2":"3909",
    "total":"26370",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":1371,
    "nom_corrige2":"Simon Angers",
    "nom_famille":"Angers",
    "titre_genre2":"Conseiller",
    "remuneration":"17529",
    "allocation":"8765",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26294",
    "ville":"Cowansville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"16906"
  },
  {
    "ID":1372,
    "nom_corrige2":"Daniel Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Maire",
    "remuneration":"12365",
    "allocation":"6182",
    "remuneration2":"5158",
    "allocation2":"2579",
    "total":"26284",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":1373,
    "nom_corrige2":"Benoît Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire",
    "remuneration":"14621",
    "allocation":"7311",
    "remuneration2":"3707",
    "allocation2":"591,00$",
    "total":"26230",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":1374,
    "nom_corrige2":"Hervé Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Maire",
    "remuneration":"10291",
    "allocation":"5138",
    "remuneration2":"7179",
    "allocation2":"3589",
    "total":"26197",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":1375,
    "nom_corrige2":"Jessika Lacombe",
    "nom_famille":"Lacombe",
    "titre_genre2":"Mairesse",
    "remuneration":"13789",
    "allocation":"6895",
    "remuneration2":"4107",
    "allocation2":"1369",
    "total":"26160",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":1376,
    "nom_corrige2":"Yvan Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Maire",
    "remuneration":"12546",
    "allocation":"6273",
    "remuneration2":"4864",
    "allocation2":"2432",
    "total":"26115",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":1377,
    "nom_corrige2":"André Coulombe",
    "nom_famille":"Coulombe",
    "titre_genre2":"Conseiller",
    "remuneration":"17986",
    "allocation":"8124",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26110",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":1378,
    "nom_corrige2":"Marc Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Conseiller",
    "remuneration":"17986",
    "allocation":"8124",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26110",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":1379,
    "nom_corrige2":"Nelson Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"17986",
    "allocation":"8124",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26110",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":1380,
    "nom_corrige2":"Nelson Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"17986",
    "allocation":"8124",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26110",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":1381,
    "nom_corrige2":"Mario Hamilton",
    "nom_famille":"Hamilton",
    "titre_genre2":"Conseiller",
    "remuneration":"17986",
    "allocation":"8124",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26110",
    "ville":"Matane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"14436"
  },
  {
    "ID":1382,
    "nom_corrige2":"Olivier Surprenant",
    "nom_famille":"Surprenant",
    "titre_genre2":"Conseiller",
    "remuneration":"17677",
    "allocation":"8388",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"26065",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":1383,
    "nom_corrige2":"Dany Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"13050",
    "allocation":"6525",
    "remuneration2":"4311",
    "allocation2":"2155",
    "total":"26041",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":1384,
    "nom_corrige2":"Françoise Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Mairesse",
    "remuneration":"11409",
    "allocation":"5704",
    "remuneration2":"5946",
    "allocation2":"2973",
    "total":"26032",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":1385,
    "nom_corrige2":"Dominique Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Maire",
    "remuneration":"15585",
    "allocation":"7793",
    "remuneration2":"1756",
    "allocation2":"878,00$",
    "total":"26012",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":1386,
    "nom_corrige2":"Guy Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Maire",
    "remuneration":"9114",
    "allocation":"4557",
    "remuneration2":"9170",
    "allocation2":"3138",
    "total":"25979",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":1387,
    "nom_corrige2":"Donald Kenny",
    "nom_famille":"Kenny",
    "titre_genre2":"Maire",
    "remuneration":"7149",
    "allocation":"3586",
    "remuneration2":"10155",
    "allocation2":"5078",
    "total":"25968",
    "ville":"Baie-Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"164"
  },
  {
    "ID":1388,
    "nom_corrige2":"Paméla B. Steen",
    "nom_famille":"B. Steen",
    "titre_genre2":"Mairesse",
    "remuneration":"11423",
    "allocation":"5710",
    "remuneration2":"5860",
    "allocation2":"2930",
    "total":"25923",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":1389,
    "nom_corrige2":"Muriel Lafarge",
    "nom_famille":"Lafarge",
    "titre_genre2":"Conseillère",
    "remuneration":"17272",
    "allocation":"8636",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25908",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1390,
    "nom_corrige2":"Pierre Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Maire",
    "remuneration":"11133",
    "allocation":"5567",
    "remuneration2":"6071",
    "allocation2":"3036",
    "total":"25807",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":1391,
    "nom_corrige2":"Daniel Campbell",
    "nom_famille":"Campbell",
    "titre_genre2":"Conseiller",
    "remuneration":"17497",
    "allocation":"8298",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25795",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":1392,
    "nom_corrige2":"Francine Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Mairesse",
    "remuneration":"17121",
    "allocation":"8646",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25767",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":1393,
    "nom_corrige2":"Hugo Desormeaux",
    "nom_famille":"Desormeaux",
    "titre_genre2":"Maire",
    "remuneration":"10498",
    "allocation":"5249",
    "remuneration2":"6678",
    "allocation2":"3339",
    "total":"25764",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":1394,
    "nom_corrige2":"Claire Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Mairesse",
    "remuneration":"10121",
    "allocation":"4831",
    "remuneration2":"7205",
    "allocation2":"3603",
    "total":"25760",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":1395,
    "nom_corrige2":"Marguerite Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Mairesse",
    "remuneration":"8463",
    "allocation":"4231",
    "remuneration2":"8695",
    "allocation2":"4348",
    "total":"25737",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":1396,
    "nom_corrige2":"Suzanne Rhéaume",
    "nom_famille":"Rhéaume",
    "titre_genre2":"Mairesse",
    "remuneration":"17120",
    "allocation":"8560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25680",
    "ville":"Cacouna",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1882"
  },
  {
    "ID":1397,
    "nom_corrige2":"Bernard Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"13050",
    "allocation":"6525",
    "remuneration2":"4060",
    "allocation2":"2030",
    "total":"25665",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":1398,
    "nom_corrige2":"Claude Benjamin",
    "nom_famille":"Benjamin",
    "titre_genre2":"Conseiller",
    "remuneration":"17337",
    "allocation":"8218",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25555",
    "ville":"Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"11267"
  },
  {
    "ID":1399,
    "nom_corrige2":"Michel Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Maire",
    "remuneration":"9987",
    "allocation":"4813",
    "remuneration2":"7167",
    "allocation2":"3583",
    "total":"25550",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":1400,
    "nom_corrige2":"Thomas Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Maire suppléant",
    "remuneration":"17019",
    "allocation":"8510",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25529",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":1401,
    "nom_corrige2":"Myriam Cabana",
    "nom_famille":"Cabana",
    "titre_genre2":"Mairesse",
    "remuneration":"10932",
    "allocation":"5466",
    "remuneration2":"6071",
    "allocation2":"3036",
    "total":"25505",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":1402,
    "nom_corrige2":"Claude St-Cyr",
    "nom_famille":"St-Cyr",
    "titre_genre2":"Conseiller",
    "remuneration":"16999",
    "allocation":"8500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25499",
    "ville":"Joliette",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"22333"
  },
  {
    "ID":1403,
    "nom_corrige2":"Alain Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"16958",
    "allocation":"8479",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25437",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":1404,
    "nom_corrige2":"Émilie St-Onge",
    "nom_famille":"St-Onge",
    "titre_genre2":"Conseillère",
    "remuneration":"16958",
    "allocation":"8479",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25437",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":1405,
    "nom_corrige2":"Nancy Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Conseillère",
    "remuneration":"16958",
    "allocation":"8479",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25437",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":1406,
    "nom_corrige2":"Sylvie Messier",
    "nom_famille":"Messier",
    "titre_genre2":"Conseillère",
    "remuneration":"16958",
    "allocation":"8479",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25437",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":1407,
    "nom_corrige2":"Gabrielle Garand",
    "nom_famille":"Garand",
    "titre_genre2":"Conseillère",
    "remuneration":"16958",
    "allocation":"8479",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25437",
    "ville":"Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"8437"
  },
  {
    "ID":1408,
    "nom_corrige2":"Gervais Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Maire",
    "remuneration":"7955",
    "allocation":"3944",
    "remuneration2":"9000",
    "allocation2":"4500",
    "total":"25399",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":1409,
    "nom_corrige2":"Gilles Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Maire",
    "remuneration":"13228",
    "allocation":"6810",
    "remuneration2":"3573",
    "allocation2":"1787",
    "total":"25398",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":1410,
    "nom_corrige2":"Nancy Lehoux",
    "nom_famille":"Lehoux",
    "titre_genre2":"Mairesse",
    "remuneration":"13509",
    "allocation":"6755",
    "remuneration2":"3391",
    "allocation2":"1696",
    "total":"25351",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":1411,
    "nom_corrige2":"Jean-François Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Maire",
    "remuneration":"14559",
    "allocation":"7280",
    "remuneration2":"2322",
    "allocation2":"1161",
    "total":"25322",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":1412,
    "nom_corrige2":"Stéphane Breault",
    "nom_famille":"Breault",
    "titre_genre2":"Conseiller",
    "remuneration":"16873",
    "allocation":"8437",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25310",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":1413,
    "nom_corrige2":"Derek Grilli",
    "nom_famille":"Grilli",
    "titre_genre2":"Maire",
    "remuneration":"12000",
    "allocation":"6000",
    "remuneration2":"4858",
    "allocation2":"2434",
    "total":"25292",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":1414,
    "nom_corrige2":"André Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"16848",
    "allocation":"8424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25272",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":1415,
    "nom_corrige2":"Carl Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"16848",
    "allocation":"8424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25272",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":1416,
    "nom_corrige2":"Chantal Amstad",
    "nom_famille":"Amstad",
    "titre_genre2":"Conseillère",
    "remuneration":"16848",
    "allocation":"8424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25272",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":1417,
    "nom_corrige2":"Edith Samson",
    "nom_famille":"Samson",
    "titre_genre2":"Conseillère",
    "remuneration":"16848",
    "allocation":"8424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25272",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":1418,
    "nom_corrige2":"Nelson Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Conseiller",
    "remuneration":"16848",
    "allocation":"8424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25272",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":1419,
    "nom_corrige2":"Steeve Drapeau",
    "nom_famille":"Drapeau",
    "titre_genre2":"Conseiller",
    "remuneration":"16848",
    "allocation":"8424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25272",
    "ville":"Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"20667"
  },
  {
    "ID":1420,
    "nom_corrige2":"Ginette Deshaies",
    "nom_famille":"Deshaies",
    "titre_genre2":"Mairesse",
    "remuneration":"6875",
    "allocation":"4143",
    "remuneration2":"9492",
    "allocation2":"4746",
    "total":"25256",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":1421,
    "nom_corrige2":"Bernard Mallet",
    "nom_famille":"Mallet",
    "titre_genre2":"Conseiller",
    "remuneration":"16779",
    "allocation":"8389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25168",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":1422,
    "nom_corrige2":"Martin Laplaine",
    "nom_famille":"Laplaine",
    "titre_genre2":"Conseiller",
    "remuneration":"16779",
    "allocation":"8389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25168",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":1423,
    "nom_corrige2":"Philippe Drolet",
    "nom_famille":"Drolet",
    "titre_genre2":"Conseiller",
    "remuneration":"16779",
    "allocation":"8389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25168",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":1424,
    "nom_corrige2":"Stéphane Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"16779",
    "allocation":"8389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25168",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":1425,
    "nom_corrige2":"Stéphanie Felx",
    "nom_famille":"Felx",
    "titre_genre2":"Conseillère",
    "remuneration":"16779",
    "allocation":"8389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25168",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":1426,
    "nom_corrige2":"Tony Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseiller",
    "remuneration":"16779",
    "allocation":"8389",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"25168",
    "ville":"Mercier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"15690"
  },
  {
    "ID":1427,
    "nom_corrige2":"Guy Jubinville",
    "nom_famille":"Jubinville",
    "titre_genre2":"Conseiller",
    "remuneration":"15982",
    "allocation":"8338",
    "remuneration2":"825,00$",
    "allocation2":"0",
    "total":"25145",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":1428,
    "nom_corrige2":"François Fréchette",
    "nom_famille":"Fréchette",
    "titre_genre2":"Maire",
    "remuneration":"8203",
    "allocation":"4102",
    "remuneration2":"8542",
    "allocation2":"4271",
    "total":"25118",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":1429,
    "nom_corrige2":"Isabelle Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Mairesse",
    "remuneration":"24966",
    "allocation":"",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24966",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":1430,
    "nom_corrige2":"Daniel Plouffe",
    "nom_famille":"Plouffe",
    "titre_genre2":"Maire",
    "remuneration":"16638",
    "allocation":"8316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24954",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":1431,
    "nom_corrige2":"Marie Léveillée",
    "nom_famille":"Léveillée",
    "titre_genre2":"Mairesse",
    "remuneration":"8410",
    "allocation":"4205",
    "remuneration2":"8419",
    "allocation2":"3909",
    "total":"24943",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":1432,
    "nom_corrige2":"Jean-Guy Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Maire",
    "remuneration":"11436",
    "allocation":"5718",
    "remuneration2":"5147",
    "allocation2":"2573",
    "total":"24874",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":1433,
    "nom_corrige2":"Roch Carpentier",
    "nom_famille":"Carpentier",
    "titre_genre2":"Maire",
    "remuneration":"16636",
    "allocation":"8203",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24839",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":1434,
    "nom_corrige2":"Marcel Beaubien",
    "nom_famille":"Beaubien",
    "titre_genre2":"Maire",
    "remuneration":"10372",
    "allocation":"5186",
    "remuneration2":"6071",
    "allocation2":"3036",
    "total":"24665",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":1435,
    "nom_corrige2":"Christian Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Maire",
    "remuneration":"10968",
    "allocation":"5484",
    "remuneration2":"5462",
    "allocation2":"2731",
    "total":"24645",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":1436,
    "nom_corrige2":"Enock-Robin Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"16369",
    "allocation":"8185",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24554",
    "ville":"Sainte-Julienne",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"12518"
  },
  {
    "ID":1437,
    "nom_corrige2":"Marc Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Conseiller",
    "remuneration":"16072",
    "allocation":"8036",
    "remuneration2":"420,00$",
    "allocation2":"0",
    "total":"24528",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":1438,
    "nom_corrige2":"Guylaine Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseillère",
    "remuneration":"15982",
    "allocation":"8338",
    "remuneration2":"200,00$",
    "allocation2":"0",
    "total":"24520",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":1439,
    "nom_corrige2":"Sylviane Ferland",
    "nom_famille":"Ferland",
    "titre_genre2":"Conseillère",
    "remuneration":"15982",
    "allocation":"8338",
    "remuneration2":"200,00$",
    "allocation2":"0",
    "total":"24520",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":1440,
    "nom_corrige2":"Sébastien Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Conseiller",
    "remuneration":"16400",
    "allocation":"7992",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24392",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":1441,
    "nom_corrige2":"Pierre Fradette",
    "nom_famille":"Fradette",
    "titre_genre2":"Maire",
    "remuneration":"13011",
    "allocation":"6505",
    "remuneration2":"3251",
    "allocation2":"1625",
    "total":"24392",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":1442,
    "nom_corrige2":"Denis Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseiller",
    "remuneration":"15982",
    "allocation":"8338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24320",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":1443,
    "nom_corrige2":"Gaétan Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseiller",
    "remuneration":"15982",
    "allocation":"8338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24320",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":1444,
    "nom_corrige2":"Vincent Brochu",
    "nom_famille":"Brochu",
    "titre_genre2":"Conseiller",
    "remuneration":"15982",
    "allocation":"8338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24320",
    "ville":"Coaticook",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"9068"
  },
  {
    "ID":1445,
    "nom_corrige2":"Jacline Rouleau",
    "nom_famille":"Rouleau",
    "titre_genre2":"Mairesse",
    "remuneration":"12909",
    "allocation":"6715",
    "remuneration2":"3069",
    "allocation2":"1535",
    "total":"24228",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":1446,
    "nom_corrige2":"Claudie Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseillère",
    "remuneration":"11826",
    "allocation":"5913",
    "remuneration2":"4311",
    "allocation2":"2155",
    "total":"24205",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":1447,
    "nom_corrige2":"Gaston Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Conseiller",
    "remuneration":"11826",
    "allocation":"5913",
    "remuneration2":"4311",
    "allocation2":"2155",
    "total":"24205",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":1448,
    "nom_corrige2":"Alain Otto",
    "nom_famille":"Otto",
    "titre_genre2":"Conseiller",
    "remuneration":"16122",
    "allocation":"8061",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24183",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":1449,
    "nom_corrige2":"Claude Paradis",
    "nom_famille":"Paradis",
    "titre_genre2":"Conseiller",
    "remuneration":"16122",
    "allocation":"8061",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24183",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":1450,
    "nom_corrige2":"Gilbert Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"16122",
    "allocation":"8061",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24183",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":1451,
    "nom_corrige2":"Blanche Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseillère",
    "remuneration":"16122",
    "allocation":"8061",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24183",
    "ville":"Rivière-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4862"
  },
  {
    "ID":1452,
    "nom_corrige2":"Jean-Marc Chevalier",
    "nom_famille":"Chevalier",
    "titre_genre2":"Maire",
    "remuneration":"10073",
    "allocation":"4966",
    "remuneration2":"6071",
    "allocation2":"3036",
    "total":"24146",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":1453,
    "nom_corrige2":"Laval Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Maire",
    "remuneration":"9907",
    "allocation":"4954",
    "remuneration2":"6179",
    "allocation2":"3089",
    "total":"24129",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":1454,
    "nom_corrige2":"James Johnston",
    "nom_famille":"Johnston",
    "titre_genre2":"Maire",
    "remuneration":"12100",
    "allocation":"6050",
    "remuneration2":"3982",
    "allocation2":"1991",
    "total":"24123",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":1455,
    "nom_corrige2":"Luc Forand",
    "nom_famille":"Forand",
    "titre_genre2":"Maire",
    "remuneration":"16308",
    "allocation":"7797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24105",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":1456,
    "nom_corrige2":"Richard Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Maire",
    "remuneration":"11595",
    "allocation":"5797",
    "remuneration2":"4430",
    "allocation2":"2215",
    "total":"24037",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":1457,
    "nom_corrige2":"Derek Dagenais-Guy",
    "nom_famille":"Dagenais-Guy",
    "titre_genre2":"Conseiller",
    "remuneration":"16420",
    "allocation":"7610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24030",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":1458,
    "nom_corrige2":"David Hogan",
    "nom_famille":"Hogan",
    "titre_genre2":"Conseiller",
    "remuneration":"16019",
    "allocation":"8010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24029",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":1459,
    "nom_corrige2":"Dorothy Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseillère",
    "remuneration":"16019",
    "allocation":"8010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24029",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":1460,
    "nom_corrige2":"Maureen Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"16019",
    "allocation":"8010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24029",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":1461,
    "nom_corrige2":"Raymond Bureau",
    "nom_famille":"Bureau",
    "titre_genre2":"Conseiller",
    "remuneration":"16019",
    "allocation":"8010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24029",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":1462,
    "nom_corrige2":"Shelley MacDougal",
    "nom_famille":"MacDougal",
    "titre_genre2":"Conseillère",
    "remuneration":"16019",
    "allocation":"8010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"24029",
    "ville":"Saint-Gabriel-de-Valcartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3401"
  },
  {
    "ID":1463,
    "nom_corrige2":"Bernard Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire",
    "remuneration":"9976",
    "allocation":"4988",
    "remuneration2":"5968",
    "allocation2":"2984",
    "total":"23916",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":1464,
    "nom_corrige2":"Ginette Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Mairesse",
    "remuneration":"12052",
    "allocation":"6026",
    "remuneration2":"3982",
    "allocation2":"1770",
    "total":"23830",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":1465,
    "nom_corrige2":"Jocelyn Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Maire",
    "remuneration":"10974",
    "allocation":"5487",
    "remuneration2":"4828",
    "allocation2":"2414",
    "total":"23703",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":1466,
    "nom_corrige2":"Michel Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Maire",
    "remuneration":"15291",
    "allocation":"7646",
    "remuneration2":"506,00$",
    "allocation2":"253,00$",
    "total":"23696",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":1467,
    "nom_corrige2":"Jean-François Paradis",
    "nom_famille":"Paradis",
    "titre_genre2":"Conseiller",
    "remuneration":"15792",
    "allocation":"7896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23688",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":1468,
    "nom_corrige2":"Lynne Colquhoun",
    "nom_famille":"Colquhoun",
    "titre_genre2":"Conseillère",
    "remuneration":"15792",
    "allocation":"7896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23688",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":1469,
    "nom_corrige2":"Marie-Pierre Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"15792",
    "allocation":"7896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23688",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":1470,
    "nom_corrige2":"Vincent Guillot",
    "nom_famille":"Guillot",
    "titre_genre2":"Conseiller",
    "remuneration":"15792",
    "allocation":"7896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23688",
    "ville":"Boischatel",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9015"
  },
  {
    "ID":1471,
    "nom_corrige2":"Marc-Antoine Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"14984",
    "allocation":"7492",
    "remuneration2":"781,00$",
    "allocation2":"391,00$",
    "total":"23648",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":1472,
    "nom_corrige2":"Mario Gaumont",
    "nom_famille":"Gaumont",
    "titre_genre2":"Conseiller",
    "remuneration":"16091",
    "allocation":"7546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23637",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":1473,
    "nom_corrige2":"Hervé Provencher",
    "nom_famille":"Provencher",
    "titre_genre2":"Maire",
    "remuneration":"9850",
    "allocation":"4925",
    "remuneration2":"5779",
    "allocation2":"3049",
    "total":"23603",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":1474,
    "nom_corrige2":"Chantal Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Mairesse",
    "remuneration":"15718",
    "allocation":"7859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23577",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":1475,
    "nom_corrige2":"Charlotte Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseillère",
    "remuneration":"17104",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23556",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":1476,
    "nom_corrige2":"Michel Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Maire",
    "remuneration":"15652",
    "allocation":"7826",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23478",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":1477,
    "nom_corrige2":"Estelle Muzzi",
    "nom_famille":"Muzzi",
    "titre_genre2":"Mairesse",
    "remuneration":"15640",
    "allocation":"7820",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23460",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":1478,
    "nom_corrige2":"Gilles Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"15753",
    "allocation":"7546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23299",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":1479,
    "nom_corrige2":"André Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Maire",
    "remuneration":"13739",
    "allocation":"5809",
    "remuneration2":"2487",
    "allocation2":"1244",
    "total":"23279",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":1480,
    "nom_corrige2":"Laurier Chagnon",
    "nom_famille":"Chagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"12201",
    "allocation":"6100",
    "remuneration2":"3318",
    "allocation2":"1659",
    "total":"23278",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":1481,
    "nom_corrige2":"Carolyne Aubin",
    "nom_famille":"Aubin",
    "titre_genre2":"Conseillère",
    "remuneration":"15772",
    "allocation":"7504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23276",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":1482,
    "nom_corrige2":"Chantal McMahon",
    "nom_famille":"McMahon",
    "titre_genre2":"Conseillère",
    "remuneration":"15772",
    "allocation":"7504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23276",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":1483,
    "nom_corrige2":"Denis Jutras",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseiller",
    "remuneration":"15772",
    "allocation":"7504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23276",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":1484,
    "nom_corrige2":"Dominic Massé",
    "nom_famille":"Massé",
    "titre_genre2":"Conseiller",
    "remuneration":"15772",
    "allocation":"7504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23276",
    "ville":"Nicolet",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"8775"
  },
  {
    "ID":1485,
    "nom_corrige2":"Chantal Chartrand",
    "nom_famille":"Chartrand",
    "titre_genre2":"Conseillère",
    "remuneration":"15514",
    "allocation":"7757",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23271",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":1486,
    "nom_corrige2":"Daniel Camiré",
    "nom_famille":"Camiré",
    "titre_genre2":"Conseiller",
    "remuneration":"15680",
    "allocation":"7546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23226",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":1487,
    "nom_corrige2":"Michel Brière",
    "nom_famille":"Brière",
    "titre_genre2":"Conseiller",
    "remuneration":"15459",
    "allocation":"7729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23188",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":1488,
    "nom_corrige2":"Nathalie Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseillère",
    "remuneration":"15459",
    "allocation":"7729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23188",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":1489,
    "nom_corrige2":"Johanne Joannette",
    "nom_famille":"Joannette",
    "titre_genre2":"Conseillère",
    "remuneration":"16987",
    "allocation":"6177",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23164",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":1490,
    "nom_corrige2":"Raymond Bisaillon",
    "nom_famille":"Bisaillon",
    "titre_genre2":"Conseiller",
    "remuneration":"16987",
    "allocation":"6177",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23164",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":1491,
    "nom_corrige2":"Pierre Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Maire",
    "remuneration":"14609",
    "allocation":"7305",
    "remuneration2":"1229",
    "allocation2":"0",
    "total":"23143",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":1492,
    "nom_corrige2":"Danielle Beaupré",
    "nom_famille":"Beaupré",
    "titre_genre2":"Conseillère",
    "remuneration":"15591",
    "allocation":"7546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"23137",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":1493,
    "nom_corrige2":"Christine Gaudet",
    "nom_famille":"Gaudet",
    "titre_genre2":"Mairesse",
    "remuneration":"11200",
    "allocation":"5600",
    "remuneration2":"5218",
    "allocation2":"1104",
    "total":"23122",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":1494,
    "nom_corrige2":"Claude Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Maire",
    "remuneration":"7526",
    "allocation":"3762",
    "remuneration2":"7880",
    "allocation2":"3940",
    "total":"23108",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":1495,
    "nom_corrige2":"Jean-Marie Dugass",
    "nom_famille":"Dugass",
    "titre_genre2":"Maire",
    "remuneration":"11584",
    "allocation":"5792",
    "remuneration2":"3780",
    "allocation2":"1880",
    "total":"23036",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":1496,
    "nom_corrige2":"Jean Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Maire",
    "remuneration":"13109",
    "allocation":"6289",
    "remuneration2":"2390",
    "allocation2":"1195",
    "total":"22983",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":1497,
    "nom_corrige2":"Josée Lampron",
    "nom_famille":"Lampron",
    "titre_genre2":"Conseillère",
    "remuneration":"15302",
    "allocation":"7651",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22953",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":1498,
    "nom_corrige2":"Martin Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Conseiller",
    "remuneration":"15302",
    "allocation":"7651",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22953",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":1499,
    "nom_corrige2":"Nathalie Laprade",
    "nom_famille":"Laprade",
    "titre_genre2":"Conseillère",
    "remuneration":"15302",
    "allocation":"7651",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22953",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":1500,
    "nom_corrige2":"Raynald Houde",
    "nom_famille":"Houde",
    "titre_genre2":"Conseiller",
    "remuneration":"15302",
    "allocation":"7651",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22953",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":1501,
    "nom_corrige2":"Sylvain Ferland",
    "nom_famille":"Ferland",
    "titre_genre2":"Conseiller",
    "remuneration":"15302",
    "allocation":"7651",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22953",
    "ville":"Sainte-Catherine-de-la-Jacques-Cartier",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9483"
  },
  {
    "ID":1502,
    "nom_corrige2":"Claude Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"15295",
    "allocation":"7647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22942",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":1503,
    "nom_corrige2":"Eddy Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseiller",
    "remuneration":"15295",
    "allocation":"7647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22942",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":1504,
    "nom_corrige2":"Marco Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"15295",
    "allocation":"7647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22942",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":1505,
    "nom_corrige2":"Nicole Boilard",
    "nom_famille":"Boilard",
    "titre_genre2":"Conseillère",
    "remuneration":"15295",
    "allocation":"7647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22942",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":1506,
    "nom_corrige2":"Steve Rouleau",
    "nom_famille":"Rouleau",
    "titre_genre2":"Conseiller",
    "remuneration":"15295",
    "allocation":"7647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22942",
    "ville":"Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"13837"
  },
  {
    "ID":1507,
    "nom_corrige2":"Raynald Duguay",
    "nom_famille":"Duguay",
    "titre_genre2":"Conseiller",
    "remuneration":"15341",
    "allocation":"7546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22887",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":1508,
    "nom_corrige2":"François Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"15155",
    "allocation":"7577",
    "remuneration2":"87,00$",
    "allocation2":"43,00$",
    "total":"22862",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":1509,
    "nom_corrige2":"Johnny Piszar",
    "nom_famille":"Piszar",
    "titre_genre2":"Maire",
    "remuneration":"8721",
    "allocation":"4360",
    "remuneration2":"6510",
    "allocation2":"3255",
    "total":"22846",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":1510,
    "nom_corrige2":"Eugénie Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseiller",
    "remuneration":"15220",
    "allocation":"7610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22830",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":1511,
    "nom_corrige2":"Line Légaré",
    "nom_famille":"Légaré",
    "titre_genre2":"Conseiller",
    "remuneration":"15220",
    "allocation":"7610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22830",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":1512,
    "nom_corrige2":"Meighen Vaillancourt-Campeau",
    "nom_famille":"Vaillancourt-Campeau",
    "titre_genre2":"Conseillère",
    "remuneration":"15220",
    "allocation":"7610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22830",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":1513,
    "nom_corrige2":"Bryan Dunaj",
    "nom_famille":"Dunaj",
    "titre_genre2":"Conseiller",
    "remuneration":"15220",
    "allocation":"7610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22830",
    "ville":"Saint-Adolphe-d'Howard",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3930"
  },
  {
    "ID":1514,
    "nom_corrige2":"Jean-François Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Maire",
    "remuneration":"12198",
    "allocation":"5853",
    "remuneration2":"3172",
    "allocation2":"1586",
    "total":"22809",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":1515,
    "nom_corrige2":"Luc Lalonde",
    "nom_famille":"Lalonde",
    "titre_genre2":"Maire",
    "remuneration":"15191",
    "allocation":"7595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22786",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":1516,
    "nom_corrige2":"Mathieu Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Conseiller",
    "remuneration":"15155",
    "allocation":"7577",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22732",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":1517,
    "nom_corrige2":"Étienne Brunet",
    "nom_famille":"Brunet",
    "titre_genre2":"Maire",
    "remuneration":"15136",
    "allocation":"7568",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22704",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":1518,
    "nom_corrige2":"Maryse Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"14902",
    "allocation":"7451",
    "remuneration2":"194,00$",
    "allocation2":"97,00$",
    "total":"22644",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":1519,
    "nom_corrige2":"Roger Vignola",
    "nom_famille":"Vignola",
    "titre_genre2":"Conseiller",
    "remuneration":"15091",
    "allocation":"7546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22637",
    "ville":"Port-Cartier",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"6483"
  },
  {
    "ID":1520,
    "nom_corrige2":"Pierre Lepicier",
    "nom_famille":"Lepicier",
    "titre_genre2":"Maire suppléant",
    "remuneration":"15909",
    "allocation":"6718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22627",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":1521,
    "nom_corrige2":"Gray Forster",
    "nom_famille":"Forster",
    "titre_genre2":"Maire",
    "remuneration":"12010",
    "allocation":"6005",
    "remuneration2":"3064",
    "allocation2":"1532",
    "total":"22611",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":1522,
    "nom_corrige2":"Marc Simoneau",
    "nom_famille":"Simoneau",
    "titre_genre2":"Maire",
    "remuneration":"9846",
    "allocation":"4924",
    "remuneration2":"5212",
    "allocation2":"2606",
    "total":"22588",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":1523,
    "nom_corrige2":"Vanessa Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Mairesse",
    "remuneration":"13195",
    "allocation":"6597",
    "remuneration2":"1830",
    "allocation2":"915,00$",
    "total":"22537",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":1524,
    "nom_corrige2":"Serge Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Maire",
    "remuneration":"10302",
    "allocation":"4917",
    "remuneration2":"4828",
    "allocation2":"2414",
    "total":"22461",
    "ville":"Ham-Sud",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"230"
  },
  {
    "ID":1525,
    "nom_corrige2":"Ghislain Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Maire",
    "remuneration":"14932",
    "allocation":"7484",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22416",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":1526,
    "nom_corrige2":"Yves Coulombe",
    "nom_famille":"Coulombe",
    "titre_genre2":"Maire",
    "remuneration":"14874",
    "allocation":"7437",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22311",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":1527,
    "nom_corrige2":"Guy Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"14851",
    "allocation":"7425",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22276",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":1528,
    "nom_corrige2":"Lina Moisan",
    "nom_famille":"Moisan",
    "titre_genre2":"Conseillère",
    "remuneration":"14851",
    "allocation":"7425",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22276",
    "ville":"Pont-Rouge",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"11160"
  },
  {
    "ID":1529,
    "nom_corrige2":"Huguette Larose",
    "nom_famille":"Larose",
    "titre_genre2":"Conseillère",
    "remuneration":"12898",
    "allocation":"6449",
    "remuneration2":"1940",
    "allocation2":"970,00$",
    "total":"22257",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":1530,
    "nom_corrige2":"Éric Antoine",
    "nom_famille":"Antoine",
    "titre_genre2":"Conseiller",
    "remuneration":"14799",
    "allocation":"7399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22198",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":1531,
    "nom_corrige2":"Anne-Marie Arcand",
    "nom_famille":"Arcand",
    "titre_genre2":"Conseillère",
    "remuneration":"14799",
    "allocation":"7399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22198",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":1532,
    "nom_corrige2":"Luc Verner",
    "nom_famille":"Verner",
    "titre_genre2":"Conseiller",
    "remuneration":"14799",
    "allocation":"7399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22198",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":1533,
    "nom_corrige2":"Martin Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"14799",
    "allocation":"7399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22198",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":1534,
    "nom_corrige2":"Pierre Pharand",
    "nom_famille":"Pharand",
    "titre_genre2":"Conseiller",
    "remuneration":"14799",
    "allocation":"7399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22198",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"6919"
  },
  {
    "ID":1535,
    "nom_corrige2":"Gervais dDrisse",
    "nom_famille":"dDrisse",
    "titre_genre2":"Maire",
    "remuneration":"8500",
    "allocation":"4250",
    "remuneration2":"6252",
    "allocation2":"3126",
    "total":"22128",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":1536,
    "nom_corrige2":"Carole Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Mairesse",
    "remuneration":"14747",
    "allocation":"7374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22121",
    "ville":"Low",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1060"
  },
  {
    "ID":1537,
    "nom_corrige2":"Daniel Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Maire",
    "remuneration":"6403",
    "allocation":"3201",
    "remuneration2":"8432",
    "allocation2":"4062",
    "total":"22098",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":1538,
    "nom_corrige2":"Denis Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Maire",
    "remuneration":"11552",
    "allocation":"5778",
    "remuneration2":"3148",
    "allocation2":"1574",
    "total":"22052",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":1539,
    "nom_corrige2":"Denis Desaulniers",
    "nom_famille":"Desaulniers",
    "titre_genre2":"Maire suppléant",
    "remuneration":"14700",
    "allocation":"7350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22050",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":1540,
    "nom_corrige2":"Alexandre D'Amour",
    "nom_famille":"D'Amour",
    "titre_genre2":"Conseiller",
    "remuneration":"14700",
    "allocation":"7350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22050",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":1541,
    "nom_corrige2":"Daniel Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseiller",
    "remuneration":"14700",
    "allocation":"7350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22050",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":1542,
    "nom_corrige2":"Jason Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"14700",
    "allocation":"7350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22050",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":1543,
    "nom_corrige2":"Jean-Pierre Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Conseiller",
    "remuneration":"14700",
    "allocation":"7350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22050",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":1544,
    "nom_corrige2":"Prescylla Bégin",
    "nom_famille":"Bégin",
    "titre_genre2":"Conseillère",
    "remuneration":"14700",
    "allocation":"7350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"22050",
    "ville":"Saint-Apollinaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"9085"
  },
  {
    "ID":1545,
    "nom_corrige2":"Pierre Saillant",
    "nom_famille":"Saillant",
    "titre_genre2":"Maire",
    "remuneration":"10000",
    "allocation":"5000",
    "remuneration2":"4700",
    "allocation2":"2350",
    "total":"22050",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":1546,
    "nom_corrige2":"Carl Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Maire",
    "remuneration":"12871",
    "allocation":"6435",
    "remuneration2":"1824",
    "allocation2":"912,00$",
    "total":"22042",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":1547,
    "nom_corrige2":"Jacynthe Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Mairesse",
    "remuneration":"13041",
    "allocation":"6520",
    "remuneration2":"1650",
    "allocation2":"825,00$",
    "total":"22036",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":1548,
    "nom_corrige2":"Jean-François Giasson",
    "nom_famille":"Giasson",
    "titre_genre2":"Conseiller",
    "remuneration":"14643",
    "allocation":"7321",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21964",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":1549,
    "nom_corrige2":"Benjamin Dagar-Magnan",
    "nom_famille":"Dagar-Magnan",
    "titre_genre2":"Conseiller",
    "remuneration":"14616",
    "allocation":"7308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21924",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":1550,
    "nom_corrige2":"Charles Morisette",
    "nom_famille":"Morisette",
    "titre_genre2":"Conseiller",
    "remuneration":"14616",
    "allocation":"7308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21924",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":1551,
    "nom_corrige2":"Simon St-Hilaire",
    "nom_famille":"St-Hilaire",
    "titre_genre2":"Conseiller",
    "remuneration":"14616",
    "allocation":"7308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21924",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":1552,
    "nom_corrige2":"Mathieu Thomassin",
    "nom_famille":"Thomassin",
    "titre_genre2":"Conseiller",
    "remuneration":"14616",
    "allocation":"7308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21924",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":1553,
    "nom_corrige2":"Gilles DesRosiers",
    "nom_famille":"DesRosiers",
    "titre_genre2":"Maire",
    "remuneration":"9557",
    "allocation":"4779",
    "remuneration2":"5046",
    "allocation2":"2523",
    "total":"21905",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":1554,
    "nom_corrige2":"Rachel Goupil",
    "nom_famille":"Goupil",
    "titre_genre2":"Mairesse",
    "remuneration":"11517",
    "allocation":"5758",
    "remuneration2":"3228",
    "allocation2":"1364",
    "total":"21867",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":1555,
    "nom_corrige2":"Luc Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"14577",
    "allocation":"7288",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21865",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":1556,
    "nom_corrige2":"Donald Lamontage",
    "nom_famille":"Lamontage",
    "titre_genre2":"Maire",
    "remuneration":"8218",
    "allocation":"4109",
    "remuneration2":"6320",
    "allocation2":"3160",
    "total":"21807",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":1557,
    "nom_corrige2":"Robert Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"12849",
    "allocation":"6424",
    "remuneration2":"1774",
    "allocation2":"755,00$",
    "total":"21802",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":1558,
    "nom_corrige2":"Jean-Guy Cournoyer",
    "nom_famille":"Cournoyer",
    "titre_genre2":"Conseiller",
    "remuneration":"13608",
    "allocation":"6787",
    "remuneration2":"881,00$",
    "allocation2":"441,00$",
    "total":"21717",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":1559,
    "nom_corrige2":"Jacques Lavallé",
    "nom_famille":"Lavallé",
    "titre_genre2":"Maire",
    "remuneration":"14461",
    "allocation":"7230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21691",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":1560,
    "nom_corrige2":"Yves Arcouette",
    "nom_famille":"Arcouette",
    "titre_genre2":"Conseiller",
    "remuneration":"15504",
    "allocation":"6177",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21681",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":1561,
    "nom_corrige2":"Annie Gagon",
    "nom_famille":"Gagon",
    "titre_genre2":"Conseillère",
    "remuneration":"15504",
    "allocation":"6177",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21681",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":1562,
    "nom_corrige2":"Cécile Desnoyers",
    "nom_famille":"Desnoyers",
    "titre_genre2":"Conseillère",
    "remuneration":"14360",
    "allocation":"7315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21675",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":1563,
    "nom_corrige2":"Jérémie Bourque",
    "nom_famille":"Bourque",
    "titre_genre2":"Conseiller",
    "remuneration":"14360",
    "allocation":"7315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21675",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":1564,
    "nom_corrige2":"Karine Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"14360",
    "allocation":"7315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21675",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":1565,
    "nom_corrige2":"Philippe Aubin-Steben",
    "nom_famille":"Aubin-Steben",
    "titre_genre2":"Conseiller",
    "remuneration":"14360",
    "allocation":"7315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21675",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":1566,
    "nom_corrige2":"Steve Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"14360",
    "allocation":"7315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21675",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":1567,
    "nom_corrige2":"Yannick Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"14360",
    "allocation":"7315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21675",
    "ville":"Oka",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6216"
  },
  {
    "ID":1568,
    "nom_corrige2":"Diane De Tonnancourt",
    "nom_famille":"DeTonnancourt",
    "titre_genre2":"Mairesse",
    "remuneration":"14135",
    "allocation":"7031",
    "remuneration2":"302,00$",
    "allocation2":"151,00$",
    "total":"21619",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":1569,
    "nom_corrige2":"Michel Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Maire suppléant",
    "remuneration":"13558",
    "allocation":"6779",
    "remuneration2":"1154",
    "allocation2":"127,00$",
    "total":"21618",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":1570,
    "nom_corrige2":"Robert Savoie",
    "nom_famille":"Savoie",
    "titre_genre2":"Maire",
    "remuneration":"8532",
    "allocation":"4266",
    "remuneration2":"6421",
    "allocation2":"2289",
    "total":"21508",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":1571,
    "nom_corrige2":"Yves Boissonneault",
    "nom_famille":"Boissonneault",
    "titre_genre2":"Maire",
    "remuneration":"11274",
    "allocation":"3333",
    "remuneration2":"4582",
    "allocation2":"2292",
    "total":"21481",
    "ville":"Lyster",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1699"
  },
  {
    "ID":1572,
    "nom_corrige2":"Céline Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Mairesse",
    "remuneration":"11474",
    "allocation":"5737",
    "remuneration2":"2829",
    "allocation2":"1415",
    "total":"21455",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":1573,
    "nom_corrige2":"Annie Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"14279",
    "allocation":"7136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21415",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":1574,
    "nom_corrige2":"Ghislain Boily",
    "nom_famille":"Boily",
    "titre_genre2":"Conseiller",
    "remuneration":"14279",
    "allocation":"7136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21415",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":1575,
    "nom_corrige2":"Jean-François Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseiller",
    "remuneration":"14279",
    "allocation":"7136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21415",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":1576,
    "nom_corrige2":"Michel Fiset",
    "nom_famille":"Fiset",
    "titre_genre2":"Conseiller",
    "remuneration":"14279",
    "allocation":"7136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21415",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":1577,
    "nom_corrige2":"Xavier Bessone",
    "nom_famille":"Bessone",
    "titre_genre2":"Conseiller",
    "remuneration":"14279",
    "allocation":"7136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21415",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":1578,
    "nom_corrige2":"Gaston Duchesne",
    "nom_famille":"Duchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"14279",
    "allocation":"7136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21415",
    "ville":"Baie-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7852"
  },
  {
    "ID":1579,
    "nom_corrige2":"Pierre Benoît",
    "nom_famille":"Benoît",
    "titre_genre2":"Conseiller",
    "remuneration":"14445",
    "allocation":"6909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21354",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":1580,
    "nom_corrige2":"Andréanne Ladouceur",
    "nom_famille":"Ladouceur",
    "titre_genre2":"Conseillère",
    "remuneration":"14445",
    "allocation":"6909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21354",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":1581,
    "nom_corrige2":"Isabelle Forcier",
    "nom_famille":"Forcier",
    "titre_genre2":"Conseillère",
    "remuneration":"14445",
    "allocation":"6909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21354",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":1582,
    "nom_corrige2":"René Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"14444",
    "allocation":"6909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21353",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":1583,
    "nom_corrige2":"Caroline Payer",
    "nom_famille":"Payer",
    "titre_genre2":"Conseillère",
    "remuneration":"14444",
    "allocation":"6909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21353",
    "ville":"Val-des-Sources",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7405"
  },
  {
    "ID":1584,
    "nom_corrige2":"Hugo Guénette",
    "nom_famille":"Guénette",
    "titre_genre2":"Maire suppléant",
    "remuneration":"14409",
    "allocation":"6927",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21336",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":1585,
    "nom_corrige2":"Denis Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Maire",
    "remuneration":"14206",
    "allocation":"7103",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21309",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":1586,
    "nom_corrige2":"Alain Brisson",
    "nom_famille":"Brisson",
    "titre_genre2":"Conseiller",
    "remuneration":"14205",
    "allocation":"7102",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21307",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":1587,
    "nom_corrige2":"Jacques Lauzon",
    "nom_famille":"Lauzon",
    "titre_genre2":"Conseiller",
    "remuneration":"14205",
    "allocation":"7102",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21307",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":1588,
    "nom_corrige2":"Martine Javelas",
    "nom_famille":"Javelas",
    "titre_genre2":"Conseillère",
    "remuneration":"14205",
    "allocation":"7102",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21307",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":1589,
    "nom_corrige2":"Richard Bousquet",
    "nom_famille":"Bousquet",
    "titre_genre2":"Conseiller",
    "remuneration":"14205",
    "allocation":"7102",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21307",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":1590,
    "nom_corrige2":"René Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Maire",
    "remuneration":"7499",
    "allocation":"3750",
    "remuneration2":"6705",
    "allocation2":"3353",
    "total":"21307",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":1591,
    "nom_corrige2":"Maria Torres",
    "nom_famille":"Torres",
    "titre_genre2":"Conseillère",
    "remuneration":"14193",
    "allocation":"7097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21290",
    "ville":"Montréal-Ouest",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5372"
  },
  {
    "ID":1592,
    "nom_corrige2":"Lauren Small-Pennefather",
    "nom_famille":"Small-Pennefather",
    "titre_genre2":"Conseillère",
    "remuneration":"14193",
    "allocation":"7097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21290",
    "ville":"Montréal-Ouest",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5372"
  },
  {
    "ID":1593,
    "nom_corrige2":"Elizabeth Ulin",
    "nom_famille":"Ulin",
    "titre_genre2":"Conseillère",
    "remuneration":"14193",
    "allocation":"7097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21290",
    "ville":"Montréal-Ouest",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5372"
  },
  {
    "ID":1594,
    "nom_corrige2":"Colleen Feeney",
    "nom_famille":"Feeney",
    "titre_genre2":"Conseillère",
    "remuneration":"14193",
    "allocation":"7097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21290",
    "ville":"Montréal-Ouest",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5372"
  },
  {
    "ID":1595,
    "nom_corrige2":"Louise Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Mairesse",
    "remuneration":"9600",
    "allocation":"4800",
    "remuneration2":"4591",
    "allocation2":"2296",
    "total":"21287",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":1596,
    "nom_corrige2":"Bruno Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseiller",
    "remuneration":"14022",
    "allocation":"6177",
    "remuneration2":"723,00$",
    "allocation2":"364,00$",
    "total":"21286",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":1597,
    "nom_corrige2":"Jean-Luc Beauchemin",
    "nom_famille":"Beauchemin",
    "titre_genre2":"Mairesse",
    "remuneration":"7592",
    "allocation":"2996",
    "remuneration2":"7149",
    "allocation2":"3548",
    "total":"21285",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":1598,
    "nom_corrige2":"André Sabourin",
    "nom_famille":"Sabourin",
    "titre_genre2":"Conseiller",
    "remuneration":"14163",
    "allocation":"7081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21244",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":1599,
    "nom_corrige2":"Dominique Mahé",
    "nom_famille":"Mahé",
    "titre_genre2":"Conseiller",
    "remuneration":"14163",
    "allocation":"7081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21244",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":1600,
    "nom_corrige2":"Hélène Joseph",
    "nom_famille":"Joseph",
    "titre_genre2":"Conseillère",
    "remuneration":"14163",
    "allocation":"7081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21244",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":1601,
    "nom_corrige2":"Sébastien Cottinet",
    "nom_famille":"Cottinet",
    "titre_genre2":"Conseiller",
    "remuneration":"14163",
    "allocation":"7081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21244",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":1602,
    "nom_corrige2":"Yannick Plamondon",
    "nom_famille":"Plamondon",
    "titre_genre2":"Conseiller",
    "remuneration":"14163",
    "allocation":"7081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21244",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":1603,
    "nom_corrige2":"Gaétane St-Laurent",
    "nom_famille":"St-Laurent",
    "titre_genre2":"Conseillère",
    "remuneration":"14163",
    "allocation":"7081",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21244",
    "ville":"Stoneham-et-Tewkesbury",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"10095"
  },
  {
    "ID":1604,
    "nom_corrige2":"Sylvie Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseillère",
    "remuneration":"13011",
    "allocation":"6506",
    "remuneration2":"1112",
    "allocation2":"556,00$",
    "total":"21185",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":1605,
    "nom_corrige2":"Christian Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Maire",
    "remuneration":"9564",
    "allocation":"4782",
    "remuneration2":"4547",
    "allocation2":"2274",
    "total":"21167",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":1606,
    "nom_corrige2":"Richard Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Maire",
    "remuneration":"14029",
    "allocation":"7015",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21044",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":1607,
    "nom_corrige2":"Robert Julien",
    "nom_famille":"Julien",
    "titre_genre2":"Maire",
    "remuneration":"14023",
    "allocation":"7011",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21034",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":1608,
    "nom_corrige2":"Claude Robitaille",
    "nom_famille":"Robitaille",
    "titre_genre2":"Conseiller",
    "remuneration":"14019",
    "allocation":"7010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21029",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":1609,
    "nom_corrige2":"Denise Papineau",
    "nom_famille":"Papineau",
    "titre_genre2":"Conseillère",
    "remuneration":"14019",
    "allocation":"7010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21029",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":1610,
    "nom_corrige2":"Jean-Paul Dutrisac",
    "nom_famille":"Dutrisac",
    "titre_genre2":"Conseiller",
    "remuneration":"14019",
    "allocation":"7010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21029",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":1611,
    "nom_corrige2":"Michael Vautour",
    "nom_famille":"Vautour",
    "titre_genre2":"Conseiller",
    "remuneration":"14019",
    "allocation":"7010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21029",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":1612,
    "nom_corrige2":"Ernest Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseiller",
    "remuneration":"14019",
    "allocation":"7010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21029",
    "ville":"Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"7663"
  },
  {
    "ID":1613,
    "nom_corrige2":"Marissa Lavallee",
    "nom_famille":"Lavallee",
    "titre_genre2":"Conseillère",
    "remuneration":"20000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1614,
    "nom_corrige2":"Mitchell Lawless",
    "nom_famille":"Lawless",
    "titre_genre2":"Conseiller",
    "remuneration":"20000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1615,
    "nom_corrige2":"Jarvin Joncas",
    "nom_famille":"Joncas",
    "titre_genre2":"Conseiller",
    "remuneration":"20000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1616,
    "nom_corrige2":"Jean-Roger Dumas",
    "nom_famille":"Dumas",
    "titre_genre2":"Conseiller",
    "remuneration":"20000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1617,
    "nom_corrige2":"Johanne Vaillancourt Beaudoin",
    "nom_famille":"Vaillancourt Beaudoin",
    "titre_genre2":"Conseillère",
    "remuneration":"20000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1618,
    "nom_corrige2":"Dany Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"20000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"21000",
    "ville":"Blanc-Sablon",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1080"
  },
  {
    "ID":1619,
    "nom_corrige2":"Denis Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Maire",
    "remuneration":"13950",
    "allocation":"6975",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20925",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":1620,
    "nom_corrige2":"Richard Handfield",
    "nom_famille":"Handfield",
    "titre_genre2":"Conseiller",
    "remuneration":"13950",
    "allocation":"6975",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20925",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":1621,
    "nom_corrige2":"Patrick Beauchamp",
    "nom_famille":"Beauchamp",
    "titre_genre2":"Conseiller",
    "remuneration":"13950",
    "allocation":"6975",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20925",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":1622,
    "nom_corrige2":"Samuel Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"13950",
    "allocation":"6975",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20925",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":1623,
    "nom_corrige2":"Serge Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"13950",
    "allocation":"6975",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20925",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":1624,
    "nom_corrige2":"Barbara Legault",
    "nom_famille":"Legault",
    "titre_genre2":"Conseillère",
    "remuneration":"13950",
    "allocation":"6975",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20925",
    "ville":"Pointe-Calumet",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"6422"
  },
  {
    "ID":1625,
    "nom_corrige2":"Mathilde Peloquin-Guay",
    "nom_famille":"Peloquin-Guay",
    "titre_genre2":"Conseillère",
    "remuneration":"13948",
    "allocation":"6974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20922",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":1626,
    "nom_corrige2":"Claude Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Conseiller",
    "remuneration":"13929",
    "allocation":"6965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20894",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":1627,
    "nom_corrige2":"Peter MacLaurin",
    "nom_famille":"MacLaurin",
    "titre_genre2":"Conseiller",
    "remuneration":"13929",
    "allocation":"6965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20894",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":1628,
    "nom_corrige2":"Vincent More",
    "nom_famille":"More",
    "titre_genre2":"Maire",
    "remuneration":"8850",
    "allocation":"4405",
    "remuneration2":"5250",
    "allocation2":"2334",
    "total":"20839",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":1629,
    "nom_corrige2":"Vincent Beckert",
    "nom_famille":"Beckert",
    "titre_genre2":"Maire",
    "remuneration":"13878",
    "allocation":"6939",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20817",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":1630,
    "nom_corrige2":"Darling Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"13848",
    "allocation":"6924",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20772",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":1631,
    "nom_corrige2":"Sylvie Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Mairesse",
    "remuneration":"9984",
    "allocation":"4996",
    "remuneration2":"3776",
    "allocation2":"1888",
    "total":"20644",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":1632,
    "nom_corrige2":"Pascal Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Maire",
    "remuneration":"7747",
    "allocation":"3873",
    "remuneration2":"6012",
    "allocation2":"3006",
    "total":"20638",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":1633,
    "nom_corrige2":"Patrick Darsigny",
    "nom_famille":"Darsigny",
    "titre_genre2":"Conseiller",
    "remuneration":"7220",
    "allocation":"3610",
    "remuneration2":"6536",
    "allocation2":"3268",
    "total":"20634",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":1634,
    "nom_corrige2":"Bernard Jeansonne",
    "nom_famille":"Jeansonne",
    "titre_genre2":"Conseiller",
    "remuneration":"13746",
    "allocation":"6873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20619",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":1635,
    "nom_corrige2":"Claire Rocher",
    "nom_famille":"Rocher",
    "titre_genre2":"Conseillère",
    "remuneration":"13746",
    "allocation":"6873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20619",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":1636,
    "nom_corrige2":"François Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseiller",
    "remuneration":"13746",
    "allocation":"6873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20619",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":1637,
    "nom_corrige2":"Pierre Henrichon",
    "nom_famille":"Henrichon",
    "titre_genre2":"Conseiller",
    "remuneration":"13746",
    "allocation":"6873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20619",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":1638,
    "nom_corrige2":"Victor Dingman",
    "nom_famille":"Dingman",
    "titre_genre2":"Conseiller",
    "remuneration":"13746",
    "allocation":"6873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20619",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":1639,
    "nom_corrige2":"Gilles St-Jean",
    "nom_famille":"St-Jean",
    "titre_genre2":"Maire",
    "remuneration":"9357",
    "allocation":"4679",
    "remuneration2":"4380",
    "allocation2":"2190",
    "total":"20606",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":1640,
    "nom_corrige2":"Bruno Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Maire",
    "remuneration":"5475",
    "allocation":"2737",
    "remuneration2":"8211",
    "allocation2":"4183",
    "total":"20606",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":1641,
    "nom_corrige2":"Kevin Mitchell",
    "nom_famille":"Mitchell",
    "titre_genre2":"Conseiller",
    "remuneration":"10603",
    "allocation":"5301",
    "remuneration2":"3072",
    "allocation2":"1536",
    "total":"20512",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":1642,
    "nom_corrige2":"France Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Mairesse",
    "remuneration":"9352",
    "allocation":"4676",
    "remuneration2":"4272",
    "allocation2":"2192",
    "total":"20492",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":1643,
    "nom_corrige2":"Bruno Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Maire",
    "remuneration":"8124",
    "allocation":"4062",
    "remuneration2":"5531",
    "allocation2":"2765",
    "total":"20482",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":1644,
    "nom_corrige2":"Maxime Roberge",
    "nom_famille":"Roberge",
    "titre_genre2":"Maire suppléant",
    "remuneration":"12738",
    "allocation":"5649",
    "remuneration2":"1396",
    "allocation2":"698,00$",
    "total":"20481",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":1645,
    "nom_corrige2":"Madeleine Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"13643",
    "allocation":"6821",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20464",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":1646,
    "nom_corrige2":"Denis Nault",
    "nom_famille":"Nault",
    "titre_genre2":"Conseiller",
    "remuneration":"13643",
    "allocation":"6821",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20464",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":1647,
    "nom_corrige2":"Denis Gignac",
    "nom_famille":"Gignac",
    "titre_genre2":"Conseiller",
    "remuneration":"13637",
    "allocation":"6819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20456",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":1648,
    "nom_corrige2":"Jean-Pierre Cardinal",
    "nom_famille":"Cardinal",
    "titre_genre2":"Conseiller",
    "remuneration":"13637",
    "allocation":"6819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20456",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":1649,
    "nom_corrige2":"Ryan Young",
    "nom_famille":"Young",
    "titre_genre2":"Conseiller",
    "remuneration":"13637",
    "allocation":"6819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20456",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":1650,
    "nom_corrige2":"Thomas Broad",
    "nom_famille":"Broad",
    "titre_genre2":"Conseiller",
    "remuneration":"13637",
    "allocation":"6819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20456",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":1651,
    "nom_corrige2":"Yvan Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseiller",
    "remuneration":"13637",
    "allocation":"6819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20456",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":1652,
    "nom_corrige2":"Daniel Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseiller",
    "remuneration":"13637",
    "allocation":"6819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20456",
    "ville":"Sainte-Anne-de-Bellevue",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"5497"
  },
  {
    "ID":1653,
    "nom_corrige2":"Mélanie Gladu",
    "nom_famille":"Gladu",
    "titre_genre2":"Conseillère",
    "remuneration":"13608",
    "allocation":"6787",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20395",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":1654,
    "nom_corrige2":"Pierre St-Louis",
    "nom_famille":"St-Louis",
    "titre_genre2":"Conseiller",
    "remuneration":"13608",
    "allocation":"6787",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20395",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":1655,
    "nom_corrige2":"Sophie Dufresne",
    "nom_famille":"Dufresne",
    "titre_genre2":"Conseillère",
    "remuneration":"13608",
    "allocation":"6787",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20395",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":1656,
    "nom_corrige2":"Ginette Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseillère",
    "remuneration":"13575",
    "allocation":"6787",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20362",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":1657,
    "nom_corrige2":"Michel Latour",
    "nom_famille":"Latour",
    "titre_genre2":"Conseiller",
    "remuneration":"13575",
    "allocation":"6787",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20362",
    "ville":"Saint-Joseph-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1562"
  },
  {
    "ID":1658,
    "nom_corrige2":"Sonny Constantineau",
    "nom_famille":"Constantineau",
    "titre_genre2":"Conseiller",
    "remuneration":"13543",
    "allocation":"6773",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20316",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":1659,
    "nom_corrige2":"Jacques Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Maire",
    "remuneration":"13536",
    "allocation":"6768",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20304",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":1660,
    "nom_corrige2":"Gilles Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Maire",
    "remuneration":"4749",
    "allocation":"2374",
    "remuneration2":"8325",
    "allocation2":"4824",
    "total":"20272",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":1661,
    "nom_corrige2":"Julien Normand",
    "nom_famille":"Normand",
    "titre_genre2":"Maire",
    "remuneration":"13507",
    "allocation":"6754",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20261",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":1662,
    "nom_corrige2":"Mike Touzin",
    "nom_famille":"Touzin",
    "titre_genre2":"Conseiller",
    "remuneration":"13711",
    "allocation":"6506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20217",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":1663,
    "nom_corrige2":"Pierrette Lajoie",
    "nom_famille":"Lajoie",
    "titre_genre2":"Conseillère",
    "remuneration":"14022",
    "allocation":"6177",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20199",
    "ville":"Acton Vale",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7978"
  },
  {
    "ID":1664,
    "nom_corrige2":"Larry Guigley",
    "nom_famille":"Guigley",
    "titre_genre2":"Maire",
    "remuneration":"9481",
    "allocation":"4741",
    "remuneration2":"3983",
    "allocation2":"1991",
    "total":"20196",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":1665,
    "nom_corrige2":"Daniel Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Conseiller",
    "remuneration":"13437",
    "allocation":"6718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20155",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":1666,
    "nom_corrige2":"Ingrid Haegeman",
    "nom_famille":"Haegeman",
    "titre_genre2":"Conseillère",
    "remuneration":"13437",
    "allocation":"6718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20155",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":1667,
    "nom_corrige2":"Luc Ducharme",
    "nom_famille":"Ducharme",
    "titre_genre2":"Conseiller",
    "remuneration":"13437",
    "allocation":"6718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20155",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":1668,
    "nom_corrige2":"Patrice Ayotte",
    "nom_famille":"Ayotte",
    "titre_genre2":"Conseiller",
    "remuneration":"13437",
    "allocation":"6718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20155",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":1669,
    "nom_corrige2":"Sophie Lajeunesse",
    "nom_famille":"Lajeunesse",
    "titre_genre2":"Conseillère",
    "remuneration":"13437",
    "allocation":"6718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20155",
    "ville":"Saint-Félix-de-Valois",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7441"
  },
  {
    "ID":1670,
    "nom_corrige2":"Ghislaine M.-Hudon",
    "nom_famille":"M.-Hudon",
    "titre_genre2":"Mairesse",
    "remuneration":"13412",
    "allocation":"6706",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"20118",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":1671,
    "nom_corrige2":"Gérald Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"13461",
    "allocation":"6506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19967",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":1672,
    "nom_corrige2":"Gilbert Dardel",
    "nom_famille":"Dardel",
    "titre_genre2":"Maire",
    "remuneration":"7485",
    "allocation":"3372",
    "remuneration2":"6071",
    "allocation2":"3036",
    "total":"19964",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":1673,
    "nom_corrige2":"Lyne Clermont",
    "nom_famille":"Clermont",
    "titre_genre2":"Conseillère",
    "remuneration":"14958",
    "allocation":"4986",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19944",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":1674,
    "nom_corrige2":"Estelle Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"13290",
    "allocation":"6645",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19935",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":1675,
    "nom_corrige2":"Sophie Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseillère",
    "remuneration":"13290",
    "allocation":"6645",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19935",
    "ville":"Maniwaki",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"3743"
  },
  {
    "ID":1676,
    "nom_corrige2":"Benjamin Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"13253",
    "allocation":"6626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19879",
    "ville":"Rouyn-Noranda",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"43229"
  },
  {
    "ID":1677,
    "nom_corrige2":"Mark Goldman",
    "nom_famille":"Goldman",
    "titre_genre2":"Conseiller",
    "remuneration":"13213",
    "allocation":"6606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19819",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":1678,
    "nom_corrige2":"Caroline Belleau-Poirier",
    "nom_famille":"Belleau-Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"14044",
    "allocation":"5768",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19812",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":1679,
    "nom_corrige2":"Guy Brousseau",
    "nom_famille":"Brousseau",
    "titre_genre2":"Maire",
    "remuneration":"10534",
    "allocation":"5268",
    "remuneration2":"2642",
    "allocation2":"1321",
    "total":"19765",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":1680,
    "nom_corrige2":"Hélène Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Mairesse",
    "remuneration":"11622",
    "allocation":"5811",
    "remuneration2":"1537",
    "allocation2":"769,00$",
    "total":"19739",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":1681,
    "nom_corrige2":"Lucie Chagnon",
    "nom_famille":"Chagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"13138",
    "allocation":"6569",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19707",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":1682,
    "nom_corrige2":"Daniel Thibeault",
    "nom_famille":"Thibeault",
    "titre_genre2":"Maire",
    "remuneration":"9618",
    "allocation":"4809",
    "remuneration2":"3683",
    "allocation2":"1566",
    "total":"19676",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":1683,
    "nom_corrige2":"Frédéric Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"12177",
    "allocation":"6088",
    "remuneration2":"937,00$",
    "allocation2":"468,00$",
    "total":"19670",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":1684,
    "nom_corrige2":"Emmanuel Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Maire",
    "remuneration":"9582",
    "allocation":"4376",
    "remuneration2":"3791",
    "allocation2":"1895",
    "total":"19644",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":1685,
    "nom_corrige2":"Pierre Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Maire",
    "remuneration":"12120",
    "allocation":"6060",
    "remuneration2":"970,00$",
    "allocation2":"485,00$",
    "total":"19635",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":1686,
    "nom_corrige2":"Dominic Boucher-Paquette",
    "nom_famille":"Boucher-Paquette",
    "titre_genre2":"Maire",
    "remuneration":"11986",
    "allocation":"5993",
    "remuneration2":"1068",
    "allocation2":"534,00$",
    "total":"19581",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":1687,
    "nom_corrige2":"Alexandre Paradis Leclerc",
    "nom_famille":"Paradis Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"13050",
    "allocation":"6525",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19575",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":1688,
    "nom_corrige2":"Jean-Philippe Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"13050",
    "allocation":"6525",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19575",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":1689,
    "nom_corrige2":"Josée Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"13050",
    "allocation":"6525",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19575",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":1690,
    "nom_corrige2":"Michel Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"13050",
    "allocation":"6525",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19575",
    "ville":"Saint-Félicien",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"10392"
  },
  {
    "ID":1691,
    "nom_corrige2":"Philippe Pagé",
    "nom_famille":"Pagé",
    "titre_genre2":"Maire",
    "remuneration":"8464",
    "allocation":"3851",
    "remuneration2":"4828",
    "allocation2":"2414",
    "total":"19557",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":1692,
    "nom_corrige2":"Deborah Stewart",
    "nom_famille":"Stewart",
    "titre_genre2":"Mairesse",
    "remuneration":"6665",
    "allocation":"3322",
    "remuneration2":"6371",
    "allocation2":"3186",
    "total":"19544",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":1693,
    "nom_corrige2":"Pascale Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Mairesse",
    "remuneration":"9396",
    "allocation":"5298",
    "remuneration2":"3233",
    "allocation2":"1617",
    "total":"19544",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":1694,
    "nom_corrige2":"Bruno Gattuso",
    "nom_famille":"Gattuso",
    "titre_genre2":"Conseiller",
    "remuneration":"12541",
    "allocation":"6195",
    "remuneration2":"522,00$",
    "allocation2":"261,00$",
    "total":"19519",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":1695,
    "nom_corrige2":"Alain Pichette",
    "nom_famille":"Pichette",
    "titre_genre2":"Conseiller",
    "remuneration":"13011",
    "allocation":"6506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19517",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":1696,
    "nom_corrige2":"Françoise Hogue Plante",
    "nom_famille":"Hogue Plante",
    "titre_genre2":"Conseillère",
    "remuneration":"13011",
    "allocation":"6506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19517",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":1697,
    "nom_corrige2":"Gilles Pagé",
    "nom_famille":"Pagé",
    "titre_genre2":"Conseiller",
    "remuneration":"13011",
    "allocation":"6506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19517",
    "ville":"Louiseville",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"7632"
  },
  {
    "ID":1698,
    "nom_corrige2":"Alexandre Mantha",
    "nom_famille":"Mantha",
    "titre_genre2":"Conseiller",
    "remuneration":"12998",
    "allocation":"6499",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19497",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":1699,
    "nom_corrige2":"Sandra St-Amour-Moreau",
    "nom_famille":"St-Amour-Moreau",
    "titre_genre2":"Mairesse",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"6471",
    "allocation2":"1015",
    "total":"19486",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":1700,
    "nom_corrige2":"Richard Bujold",
    "nom_famille":"Bujold",
    "titre_genre2":"Conseiller",
    "remuneration":"12655",
    "allocation":"6328",
    "remuneration2":"376,00$",
    "allocation2":"126,00$",
    "total":"19485",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":1701,
    "nom_corrige2":"Mario Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Maire",
    "remuneration":"8528",
    "allocation":"4264",
    "remuneration2":"4616",
    "allocation2":"2052",
    "total":"19460",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":1702,
    "nom_corrige2":"Marcel Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Maire",
    "remuneration":"12946",
    "allocation":"6474",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19420",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":1703,
    "nom_corrige2":"Dany Langlois",
    "nom_famille":"Langlois",
    "titre_genre2":"Conseiller",
    "remuneration":"11097",
    "allocation":"5548",
    "remuneration2":"1834",
    "allocation2":"917,00$",
    "total":"19396",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":1704,
    "nom_corrige2":"Annie Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Mairesse",
    "remuneration":"12920",
    "allocation":"6460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19380",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":1705,
    "nom_corrige2":"Jonathan Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"12904",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19356",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":1706,
    "nom_corrige2":"Marie-Ève Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseillère",
    "remuneration":"12904",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19356",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":1707,
    "nom_corrige2":"Sylvain Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseiller",
    "remuneration":"12904",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19356",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":1708,
    "nom_corrige2":"Nathalie Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseillère",
    "remuneration":"12904",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19356",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":1709,
    "nom_corrige2":"Charles Arseneault",
    "nom_famille":"Arseneault",
    "titre_genre2":"Conseiller",
    "remuneration":"12904",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19356",
    "ville":"Havre-Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"3371"
  },
  {
    "ID":1710,
    "nom_corrige2":"Marilou Laurin",
    "nom_famille":"Laurin",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"14101",
    "allocation":"5250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19351",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":1711,
    "nom_corrige2":"Martin Roch",
    "nom_famille":"Roch",
    "titre_genre2":"Maire",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"976,00$",
    "allocation2":"0",
    "total":"19321",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":1712,
    "nom_corrige2":"Sylvie Lemonde",
    "nom_famille":"Lemonde",
    "titre_genre2":"Conseillère",
    "remuneration":"12850",
    "allocation":"6425",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19275",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":1713,
    "nom_corrige2":"Gilles Saulnier",
    "nom_famille":"Saulnier",
    "titre_genre2":"Conseiller",
    "remuneration":"12836",
    "allocation":"6418",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19254",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":1714,
    "nom_corrige2":"Carole Patenaude",
    "nom_famille":"Patenaude",
    "titre_genre2":"Conseillère",
    "remuneration":"12832",
    "allocation":"6416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19248",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":1715,
    "nom_corrige2":"Leigh MacLeod",
    "nom_famille":"MacLeod",
    "titre_genre2":"Conseillère",
    "remuneration":"12832",
    "allocation":"6416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19248",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":1716,
    "nom_corrige2":"Louise Cossette",
    "nom_famille":"Cossette",
    "titre_genre2":"Conseillère",
    "remuneration":"12832",
    "allocation":"6416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19248",
    "ville":"Morin-Heights",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4953"
  },
  {
    "ID":1717,
    "nom_corrige2":"Claude H Pelletier",
    "nom_famille":"H Pelletier",
    "titre_genre2":"Maire",
    "remuneration":"12831",
    "allocation":"6416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19247",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":1718,
    "nom_corrige2":"Guylaine Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"12823",
    "allocation":"6412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19235",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":1719,
    "nom_corrige2":"Francine Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"12811",
    "allocation":"6406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19217",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":1720,
    "nom_corrige2":"Lynn Chiasson",
    "nom_famille":"Chiasson",
    "titre_genre2":"Conseillère",
    "remuneration":"12811",
    "allocation":"6406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19217",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":1721,
    "nom_corrige2":"Mario Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Conseiller",
    "remuneration":"12811",
    "allocation":"6406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19217",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":1722,
    "nom_corrige2":"Saül Branco",
    "nom_famille":"Branco",
    "titre_genre2":"Conseiller",
    "remuneration":"12811",
    "allocation":"6406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19217",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":1723,
    "nom_corrige2":"Michel Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Maire",
    "remuneration":"10947",
    "allocation":"5474",
    "remuneration2":"1855",
    "allocation2":"928,00$",
    "total":"19204",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":1724,
    "nom_corrige2":"Guy Bond",
    "nom_famille":"Bond",
    "titre_genre2":"Maire",
    "remuneration":"10205",
    "allocation":"5103",
    "remuneration2":"1296",
    "allocation2":"2593",
    "total":"19197",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":1725,
    "nom_corrige2":"Yvon Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Maire",
    "remuneration":"9899",
    "allocation":"4949",
    "remuneration2":"2893",
    "allocation2":"1447",
    "total":"19188",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":1726,
    "nom_corrige2":"Martin J. Côté",
    "nom_famille":"J. Côté",
    "titre_genre2":"Maire",
    "remuneration":"9489",
    "allocation":"4741",
    "remuneration2":"3292",
    "allocation2":"1646",
    "total":"19168",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":1727,
    "nom_corrige2":"Jeannot Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Maire",
    "remuneration":"6930",
    "allocation":"3465",
    "remuneration2":"5840",
    "allocation2":"2920",
    "total":"19155",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":1728,
    "nom_corrige2":"Christiane Beaudry",
    "nom_famille":"Beaudry",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"12752",
    "allocation":"6376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19128",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":1729,
    "nom_corrige2":"Gaétan Graveline",
    "nom_famille":"Graveline",
    "titre_genre2":"Maire suppléant",
    "remuneration":"12399",
    "allocation":"6199",
    "remuneration2":"319,00$",
    "allocation2":"159,00$",
    "total":"19076",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":1730,
    "nom_corrige2":"Jacques Guilbault",
    "nom_famille":"Guilbault",
    "titre_genre2":"Conseiller",
    "remuneration":"12717",
    "allocation":"6358",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"19075",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":1731,
    "nom_corrige2":"Claude Viel",
    "nom_famille":"Viel",
    "titre_genre2":"Maire",
    "remuneration":"9150",
    "allocation":"4575",
    "remuneration2":"3564",
    "allocation2":"1782",
    "total":"19071",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":1732,
    "nom_corrige2":"Myriam Belley",
    "nom_famille":"Belley",
    "titre_genre2":"Conseillère",
    "remuneration":"12655",
    "allocation":"6328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18983",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":1733,
    "nom_corrige2":"Simon Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"12655",
    "allocation":"6328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18983",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":1734,
    "nom_corrige2":"Simon Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"12655",
    "allocation":"6328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18983",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":1735,
    "nom_corrige2":"Ariane Levesque",
    "nom_famille":"Levesque",
    "titre_genre2":"Conseillère",
    "remuneration":"12655",
    "allocation":"6328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18983",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":1736,
    "nom_corrige2":"Jacques Letourneau",
    "nom_famille":"Letourneau",
    "titre_genre2":"Conseiller",
    "remuneration":"12655",
    "allocation":"6328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18983",
    "ville":"Sainte-Anne-des-Monts",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"6131"
  },
  {
    "ID":1737,
    "nom_corrige2":"Yvon Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Maire",
    "remuneration":"6344",
    "allocation":"3172",
    "remuneration2":"6299",
    "allocation2":"3150",
    "total":"18965",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":1738,
    "nom_corrige2":"Danièle Provencher",
    "nom_famille":"Provencher",
    "titre_genre2":"Mairesse",
    "remuneration":"11400",
    "allocation":"5700",
    "remuneration2":"1237",
    "allocation2":"618,00$",
    "total":"18955",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":1739,
    "nom_corrige2":"Vincent Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Maire",
    "remuneration":"11080",
    "allocation":"5540",
    "remuneration2":"1553",
    "allocation2":"777,00$",
    "total":"18950",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":1740,
    "nom_corrige2":"Sarah-Josee Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseillère",
    "remuneration":"12609",
    "allocation":"6305",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18914",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":1741,
    "nom_corrige2":"Michel Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Maire",
    "remuneration":"10559",
    "allocation":"5280",
    "remuneration2":"2092",
    "allocation2":"973,00$",
    "total":"18904",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":1742,
    "nom_corrige2":"Shane Beauchamps",
    "nom_famille":"Beauchamps",
    "titre_genre2":"Conseiller",
    "remuneration":"12600",
    "allocation":"6300",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18900",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":1743,
    "nom_corrige2":"Alexandre Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"11298",
    "allocation":"5649",
    "remuneration2":"1290",
    "allocation2":"645,00$",
    "total":"18882",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":1744,
    "nom_corrige2":"Vincent Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"12584",
    "allocation":"6292",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18876",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":1745,
    "nom_corrige2":"Louise Bourassa",
    "nom_famille":"Bourassa",
    "titre_genre2":"Conseillère",
    "remuneration":"12577",
    "allocation":"6288",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18865",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":1746,
    "nom_corrige2":"Gaetan Lavallee",
    "nom_famille":"Lavallee",
    "titre_genre2":"Conseiller",
    "remuneration":"12577",
    "allocation":"6288",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18865",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":1747,
    "nom_corrige2":"Any-Pier Houle",
    "nom_famille":"Houle",
    "titre_genre2":"Conseillère",
    "remuneration":"12577",
    "allocation":"6288",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18865",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":1748,
    "nom_corrige2":"Jean-Guy Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"12177",
    "allocation":"6088",
    "remuneration2":"390,00$",
    "allocation2":"195,00$",
    "total":"18850",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":1749,
    "nom_corrige2":"Maxime Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"12566",
    "allocation":"6283",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18849",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":1750,
    "nom_corrige2":"Anne Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Mairesse",
    "remuneration":"7594",
    "allocation":"3799",
    "remuneration2":"4935",
    "allocation2":"2468",
    "total":"18796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":1751,
    "nom_corrige2":"Pierre Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Maire",
    "remuneration":"10495",
    "allocation":"5247",
    "remuneration2":"2033",
    "allocation2":"1020",
    "total":"18795",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":1752,
    "nom_corrige2":"Benoît Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Maire",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"4527",
    "allocation2":"2264",
    "total":"18791",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":1753,
    "nom_corrige2":"Andréa Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Mairesse",
    "remuneration":"12291",
    "allocation":"5365",
    "remuneration2":"750,00$",
    "allocation2":"375,00$",
    "total":"18781",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":1754,
    "nom_corrige2":"Alain Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"12507",
    "allocation":"6253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18760",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":1755,
    "nom_corrige2":"Annie Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"12507",
    "allocation":"6253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18760",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":1756,
    "nom_corrige2":"Denis Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"12507",
    "allocation":"6253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18760",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":1757,
    "nom_corrige2":"Gilles Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"12507",
    "allocation":"6253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18760",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":1758,
    "nom_corrige2":"Jean-Pierre Labonté",
    "nom_famille":"Labonté",
    "titre_genre2":"Conseiller",
    "remuneration":"12507",
    "allocation":"6253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18760",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":1759,
    "nom_corrige2":"Robin Guy",
    "nom_famille":"Guy",
    "titre_genre2":"Conseiller",
    "remuneration":"12507",
    "allocation":"6253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18760",
    "ville":"Mont-Joli",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6481"
  },
  {
    "ID":1760,
    "nom_corrige2":"Bruno Bonesso",
    "nom_famille":"Bonesso",
    "titre_genre2":"Maire",
    "remuneration":"7071",
    "allocation":"3536",
    "remuneration2":"6698",
    "allocation2":"1445",
    "total":"18750",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":1761,
    "nom_corrige2":"Marie-Eve Mondor",
    "nom_famille":"Mondor",
    "titre_genre2":"Conseillère",
    "remuneration":"14058",
    "allocation":"4686",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18744",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":1762,
    "nom_corrige2":"Lucie Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"14058",
    "allocation":"4686",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18744",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":1763,
    "nom_corrige2":"François Boisjoly",
    "nom_famille":"Boisjoly",
    "titre_genre2":"Conseiller",
    "remuneration":"14058",
    "allocation":"4686",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18744",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":1764,
    "nom_corrige2":"Josee Castonguay",
    "nom_famille":"Castonguay",
    "titre_genre2":"Conseillère",
    "remuneration":"14058",
    "allocation":"4686",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18744",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":1765,
    "nom_corrige2":"Martin Lavallee",
    "nom_famille":"Lavallee",
    "titre_genre2":"Conseiller",
    "remuneration":"14058",
    "allocation":"4686",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18744",
    "ville":"Lanoraie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"5602"
  },
  {
    "ID":1766,
    "nom_corrige2":"Jean-Claude Malenfant",
    "nom_famille":"Malenfant",
    "titre_genre2":"Maire",
    "remuneration":"12496",
    "allocation":"6248",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18744",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":1767,
    "nom_corrige2":"Réjean Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Maire",
    "remuneration":"8820",
    "allocation":"4219",
    "remuneration2":"3675",
    "allocation2":"2029",
    "total":"18743",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":1768,
    "nom_corrige2":"Marquis Bedard",
    "nom_famille":"Bedard",
    "titre_genre2":"Maire",
    "remuneration":"10083",
    "allocation":"4305",
    "remuneration2":"2902",
    "allocation2":"1451",
    "total":"18741",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":1769,
    "nom_corrige2":"François-Pierre Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Maire",
    "remuneration":"12464",
    "allocation":"6232",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18696",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":1770,
    "nom_corrige2":"Archill Gladu",
    "nom_famille":"Gladu",
    "titre_genre2":"Maire",
    "remuneration":"7225",
    "allocation":"3613",
    "remuneration2":"5179",
    "allocation2":"2589",
    "total":"18606",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":1771,
    "nom_corrige2":"Robert Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Maire",
    "remuneration":"9283",
    "allocation":"5327",
    "remuneration2":"2643",
    "allocation2":"1321",
    "total":"18574",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":1772,
    "nom_corrige2":"Maxime Villemaire",
    "nom_famille":"Villemaire",
    "titre_genre2":"Conseiller",
    "remuneration":"11468",
    "allocation":"5734",
    "remuneration2":"884,00$",
    "allocation2":"442,00$",
    "total":"18528",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":1773,
    "nom_corrige2":"Mathieu Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Conseiller",
    "remuneration":"12343",
    "allocation":"6171",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18514",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":1774,
    "nom_corrige2":"Michel Laberge",
    "nom_famille":"Laberge",
    "titre_genre2":"Conseiller",
    "remuneration":"11000",
    "allocation":"5500",
    "remuneration2":"1291",
    "allocation2":"645,00$",
    "total":"18436",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":1775,
    "nom_corrige2":"Roger Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"11000",
    "allocation":"5500",
    "remuneration2":"1291",
    "allocation2":"645,00$",
    "total":"18436",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":1776,
    "nom_corrige2":"Léonard Labrie",
    "nom_famille":"Labrie",
    "titre_genre2":"Maire",
    "remuneration":"11712",
    "allocation":"6708",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18420",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":1777,
    "nom_corrige2":"Alain Sarrazin",
    "nom_famille":"Sarrazin",
    "titre_genre2":"Maire",
    "remuneration":"9804",
    "allocation":"4902",
    "remuneration2":"2474",
    "allocation2":"1237",
    "total":"18417",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":1778,
    "nom_corrige2":"Suzie Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Mairesse",
    "remuneration":"8881",
    "allocation":"4560",
    "remuneration2":"3292",
    "allocation2":"1646",
    "total":"18379",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":1779,
    "nom_corrige2":"Stephan Schwab",
    "nom_famille":"Schwab",
    "titre_genre2":"Conseiller",
    "remuneration":"12243",
    "allocation":"6121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18364",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":1780,
    "nom_corrige2":"Christian Lachaine",
    "nom_famille":"Lachaine",
    "titre_genre2":"Conseiller",
    "remuneration":"12243",
    "allocation":"6121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18364",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":1781,
    "nom_corrige2":"Manon Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Conseillère",
    "remuneration":"12243",
    "allocation":"6121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18364",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":1782,
    "nom_corrige2":"Guy Seguin",
    "nom_famille":"Seguin",
    "titre_genre2":"Conseiller",
    "remuneration":"12243",
    "allocation":"6121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18364",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":1783,
    "nom_corrige2":"Daniel Lacroix",
    "nom_famille":"Lacroix",
    "titre_genre2":"Conseiller",
    "remuneration":"9317",
    "allocation":"3789",
    "remuneration2":"3501",
    "allocation2":"1751",
    "total":"18358",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":1784,
    "nom_corrige2":"Alexandre Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"12232",
    "allocation":"6116",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18348",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":1785,
    "nom_corrige2":"Caroline Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseillère",
    "remuneration":"12232",
    "allocation":"6116",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18348",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":1786,
    "nom_corrige2":"Guylaine Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseillère",
    "remuneration":"12232",
    "allocation":"6116",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18348",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":1787,
    "nom_corrige2":"Stéphane Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"12232",
    "allocation":"6116",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18348",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":1788,
    "nom_corrige2":"Rémi Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"12232",
    "allocation":"6116",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18348",
    "ville":"Dolbeau-Mistassini",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"13746"
  },
  {
    "ID":1789,
    "nom_corrige2":"Claude Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Conseiller",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18345",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":1790,
    "nom_corrige2":"François Deschamps",
    "nom_famille":"Deschamps",
    "titre_genre2":"Conseiller",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18345",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":1791,
    "nom_corrige2":"Josée Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18345",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":1792,
    "nom_corrige2":"Michel Joly",
    "nom_famille":"Joly",
    "titre_genre2":"Conseiller",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18345",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":1793,
    "nom_corrige2":"Myriam Sauvé",
    "nom_famille":"Sauvé",
    "titre_genre2":"Conseillère",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18345",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":1794,
    "nom_corrige2":"Véronique Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"12230",
    "allocation":"6115",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18345",
    "ville":"Les Coteaux",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6108"
  },
  {
    "ID":1795,
    "nom_corrige2":"Denis Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Maire",
    "remuneration":"9527",
    "allocation":"4763",
    "remuneration2":"2691",
    "allocation2":"1345",
    "total":"18326",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":1796,
    "nom_corrige2":"Jean-Robert Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"12201",
    "allocation":"6100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18301",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":1797,
    "nom_corrige2":"Claude Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"12201",
    "allocation":"6100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18301",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":1798,
    "nom_corrige2":"Martine Lampron",
    "nom_famille":"Lampron",
    "titre_genre2":"Conseillère",
    "remuneration":"12201",
    "allocation":"6100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18301",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":1799,
    "nom_corrige2":"Serge Bizier",
    "nom_famille":"Bizier",
    "titre_genre2":"Conseiller",
    "remuneration":"12201",
    "allocation":"6100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18301",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":1800,
    "nom_corrige2":"Denis Beauvillier",
    "nom_famille":"Beauvillier",
    "titre_genre2":"Conseiller",
    "remuneration":"12201",
    "allocation":"6100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18301",
    "ville":"Princeville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"6460"
  },
  {
    "ID":1801,
    "nom_corrige2":"Thomas Vandor",
    "nom_famille":"Vandor",
    "titre_genre2":"Conseiller",
    "remuneration":"12200",
    "allocation":"6100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18300",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":1802,
    "nom_corrige2":"Myriam Derome",
    "nom_famille":"Derome",
    "titre_genre2":"Conseillère",
    "remuneration":"11300",
    "allocation":"5650",
    "remuneration2":"884,00$",
    "allocation2":"442,00$",
    "total":"18276",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":1803,
    "nom_corrige2":"Carol Oster",
    "nom_famille":"Oster",
    "titre_genre2":"Conseillère",
    "remuneration":"12178",
    "allocation":"6089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18267",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":1804,
    "nom_corrige2":"Christian Legault",
    "nom_famille":"Legault",
    "titre_genre2":"Maire",
    "remuneration":"10508",
    "allocation":"5254",
    "remuneration2":"2505",
    "allocation2":"0",
    "total":"18267",
    "ville":"Saint-Dominique-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"456"
  },
  {
    "ID":1805,
    "nom_corrige2":"Tanya Czinkan",
    "nom_famille":"Czinkan",
    "titre_genre2":"Conseillère",
    "remuneration":"12177",
    "allocation":"6088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18265",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":1806,
    "nom_corrige2":"François Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"12177",
    "allocation":"6088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18265",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":1807,
    "nom_corrige2":"Magalie Taillon",
    "nom_famille":"Taillon",
    "titre_genre2":"Conseillère",
    "remuneration":"12177",
    "allocation":"6088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18265",
    "ville":"McMasterville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6151"
  },
  {
    "ID":1808,
    "nom_corrige2":"Julie Pressé",
    "nom_famille":"Pressé",
    "titre_genre2":"Mairesse",
    "remuneration":"7542",
    "allocation":"3726",
    "remuneration2":"4648",
    "allocation2":"2324",
    "total":"18240",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":1809,
    "nom_corrige2":"Claude Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Maire",
    "remuneration":"8291",
    "allocation":"4056",
    "remuneration2":"4418",
    "allocation2":"1473",
    "total":"18238",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":1810,
    "nom_corrige2":"Claude Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"12126",
    "allocation":"6060",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18186",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":1811,
    "nom_corrige2":"Denis Forest",
    "nom_famille":"Forest",
    "titre_genre2":"Conseiller",
    "remuneration":"12126",
    "allocation":"6060",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18186",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":1812,
    "nom_corrige2":"François Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"12126",
    "allocation":"6060",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18186",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":1813,
    "nom_corrige2":"Jean-François Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"12126",
    "allocation":"6060",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18186",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":1814,
    "nom_corrige2":"Michel Lachapelle",
    "nom_famille":"Lachapelle",
    "titre_genre2":"Conseiller",
    "remuneration":"12126",
    "allocation":"6060",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18186",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":1815,
    "nom_corrige2":"Denis Chagnon",
    "nom_famille":"Chagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"12458",
    "allocation":"5725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18183",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":1816,
    "nom_corrige2":"Denis Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Maire",
    "remuneration":"9461",
    "allocation":"4730",
    "remuneration2":"2634",
    "allocation2":"1317",
    "total":"18142",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":1817,
    "nom_corrige2":"Guy Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Maire",
    "remuneration":"8463",
    "allocation":"4231",
    "remuneration2":"3616",
    "allocation2":"1808",
    "total":"18118",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":1818,
    "nom_corrige2":"Alain Lauzon",
    "nom_famille":"Lauzon",
    "titre_genre2":"Conseiller",
    "remuneration":"12067",
    "allocation":"6033",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18100",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":1819,
    "nom_corrige2":"Anne Létourneau",
    "nom_famille":"Létourneau",
    "titre_genre2":"Conseillère",
    "remuneration":"12067",
    "allocation":"6033",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18100",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":1820,
    "nom_corrige2":"Guy Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"12067",
    "allocation":"6033",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18100",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":1821,
    "nom_corrige2":"Michèle Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Mairesse",
    "remuneration":"11602",
    "allocation":"6452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18054",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":1822,
    "nom_corrige2":"Lucie Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Mairesse",
    "remuneration":"9219",
    "allocation":"4134",
    "remuneration2":"3133",
    "allocation2":"1566",
    "total":"18052",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":1823,
    "nom_corrige2":"Alain Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Maire",
    "remuneration":"11336",
    "allocation":"4864",
    "remuneration2":"1220",
    "allocation2":"610,00$",
    "total":"18030",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":1824,
    "nom_corrige2":"Julie Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseillère",
    "remuneration":"12017",
    "allocation":"6008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18025",
    "ville":"Saint-Calixte",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7557"
  },
  {
    "ID":1825,
    "nom_corrige2":"François Parenteau",
    "nom_famille":"Parenteau",
    "titre_genre2":"Maire",
    "remuneration":"7527",
    "allocation":"3764",
    "remuneration2":"4485",
    "allocation2":"2242",
    "total":"18018",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":1826,
    "nom_corrige2":"Jean-Paul Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Maire",
    "remuneration":"10205",
    "allocation":"5103",
    "remuneration2":"1800",
    "allocation2":"900,00$",
    "total":"18008",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":1827,
    "nom_corrige2":"Stephen Ovans",
    "nom_famille":"Ovans",
    "titre_genre2":"Conseiller",
    "remuneration":"12000",
    "allocation":"6000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18000",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":1828,
    "nom_corrige2":"Louis Coutu",
    "nom_famille":"Coutu",
    "titre_genre2":"Maire",
    "remuneration":"9000",
    "allocation":"9000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"18000",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":1829,
    "nom_corrige2":"Gérard Litalien",
    "nom_famille":"Litalien",
    "titre_genre2":"Maire",
    "remuneration":"11963",
    "allocation":"5982",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17945",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":1830,
    "nom_corrige2":"Bruno Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"11953",
    "allocation":"5976",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17929",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":1831,
    "nom_corrige2":"Gilles Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"11953",
    "allocation":"5976",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17929",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":1832,
    "nom_corrige2":"Normand Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"11953",
    "allocation":"5976",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17929",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":1833,
    "nom_corrige2":"Roland Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"11953",
    "allocation":"5976",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17929",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":1834,
    "nom_corrige2":"Jean-François Maltais",
    "nom_famille":"Maltais",
    "titre_genre2":"Conseiller",
    "remuneration":"11953",
    "allocation":"5976",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17929",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":1835,
    "nom_corrige2":"Normand Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Maire",
    "remuneration":"10330",
    "allocation":"5165",
    "remuneration2":"1596",
    "allocation2":"798,00$",
    "total":"17889",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":1836,
    "nom_corrige2":"Jean-Pierre Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Maire",
    "remuneration":"11924",
    "allocation":"5962",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17886",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":1837,
    "nom_corrige2":"Daphné Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseillère",
    "remuneration":"11522",
    "allocation":"5762",
    "remuneration2":"374,00$",
    "allocation2":"187,00$",
    "total":"17845",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":1838,
    "nom_corrige2":"Mario Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Maire",
    "remuneration":"8834",
    "allocation":"4417",
    "remuneration2":"3057",
    "allocation2":"1528",
    "total":"17836",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":1839,
    "nom_corrige2":"Pierre Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"9865",
    "allocation":"4008",
    "remuneration2":"2633",
    "allocation2":"1317",
    "total":"17823",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":1840,
    "nom_corrige2":"Alexandra Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"11849",
    "allocation":"5925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17774",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":1841,
    "nom_corrige2":"Dominique Mondor",
    "nom_famille":"Mondor",
    "titre_genre2":"Conseiller",
    "remuneration":"11849",
    "allocation":"5925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17774",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":1842,
    "nom_corrige2":"Jacinthe Breault",
    "nom_famille":"Breault",
    "titre_genre2":"Conseillère",
    "remuneration":"11849",
    "allocation":"5925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17774",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":1843,
    "nom_corrige2":"Mannix Marion",
    "nom_famille":"Marion",
    "titre_genre2":"Conseiller",
    "remuneration":"11849",
    "allocation":"5925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17774",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":1844,
    "nom_corrige2":"Marc Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"11849",
    "allocation":"5925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17774",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":1845,
    "nom_corrige2":"Mélanie Desjardins",
    "nom_famille":"Desjardins",
    "titre_genre2":"Conseillère",
    "remuneration":"11849",
    "allocation":"5925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17774",
    "ville":"Saint-Paul",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"7128"
  },
  {
    "ID":1846,
    "nom_corrige2":"Esther St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseillère",
    "remuneration":"11826",
    "allocation":"5913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17739",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":1847,
    "nom_corrige2":"Germain Maltais",
    "nom_famille":"Maltais",
    "titre_genre2":"Conseiller",
    "remuneration":"11826",
    "allocation":"5913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17739",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":1848,
    "nom_corrige2":"Nicole Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseillère",
    "remuneration":"11826",
    "allocation":"5913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17739",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":1849,
    "nom_corrige2":"Pascal Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"11826",
    "allocation":"5913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17739",
    "ville":"Roberval",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"9872"
  },
  {
    "ID":1850,
    "nom_corrige2":"François Bessette",
    "nom_famille":"Bessette",
    "titre_genre2":"Conseiller",
    "remuneration":"11800",
    "allocation":"5900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17700",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":1851,
    "nom_corrige2":"Michel Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Conseiller",
    "remuneration":"11800",
    "allocation":"5900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17700",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":1852,
    "nom_corrige2":"Michel St-Amour",
    "nom_famille":"St-Amour",
    "titre_genre2":"Conseiller",
    "remuneration":"11800",
    "allocation":"5900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17700",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":1853,
    "nom_corrige2":"Pierre Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Maire",
    "remuneration":"11800",
    "allocation":"5900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17700",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":1854,
    "nom_corrige2":"Jacqueline Croisetiere",
    "nom_famille":"Croisetiere",
    "titre_genre2":"Conseillère",
    "remuneration":"11800",
    "allocation":"5900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17700",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":1855,
    "nom_corrige2":"Jean Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"11782",
    "allocation":"5891",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17673",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":1856,
    "nom_corrige2":"Patrick Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Conseiller",
    "remuneration":"11781",
    "allocation":"5891",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17672",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":1857,
    "nom_corrige2":"Eve Darmana",
    "nom_famille":"Darmana",
    "titre_genre2":"Conseillère",
    "remuneration":"11775",
    "allocation":"5887",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17662",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":1858,
    "nom_corrige2":"Antoni Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseiller",
    "remuneration":"11097",
    "allocation":"5548",
    "remuneration2":"650,00$",
    "allocation2":"325,00$",
    "total":"17620",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":1859,
    "nom_corrige2":"Pierre Daigneault",
    "nom_famille":"Daigneault",
    "titre_genre2":"Maire",
    "remuneration":"7536",
    "allocation":"3769",
    "remuneration2":"5560",
    "allocation2":"722,00$",
    "total":"17587",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":1860,
    "nom_corrige2":"Julie Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseillère",
    "remuneration":"11706",
    "allocation":"5853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17559",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":1861,
    "nom_corrige2":"Jeannot Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Maire",
    "remuneration":"10280",
    "allocation":"5140",
    "remuneration2":"1405",
    "allocation2":"703,00$",
    "total":"17528",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":1862,
    "nom_corrige2":"Guylaine Rajotte",
    "nom_famille":"Rajotte",
    "titre_genre2":"Conseillère",
    "remuneration":"11651",
    "allocation":"5826",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17477",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":1863,
    "nom_corrige2":"Nicole Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseillère",
    "remuneration":"11097",
    "allocation":"5548",
    "remuneration2":"550,00$",
    "allocation2":"275,00$",
    "total":"17470",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":1864,
    "nom_corrige2":"Pascal Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Maire",
    "remuneration":"6552",
    "allocation":"3276",
    "remuneration2":"5089",
    "allocation2":"2544",
    "total":"17461",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":1865,
    "nom_corrige2":"Jean Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Maire",
    "remuneration":"9814",
    "allocation":"4907",
    "remuneration2":"1819",
    "allocation2":"910,00$",
    "total":"17450",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":1866,
    "nom_corrige2":"Josseline Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Mairesse",
    "remuneration":"9186",
    "allocation":"4593",
    "remuneration2":"2008",
    "allocation2":"1657",
    "total":"17444",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":1867,
    "nom_corrige2":"Richard Kirouac",
    "nom_famille":"Kirouac",
    "titre_genre2":"Maire",
    "remuneration":"7745",
    "allocation":"3872",
    "remuneration2":"4098",
    "allocation2":"1704",
    "total":"17419",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":1868,
    "nom_corrige2":"Patricia Sévigny",
    "nom_famille":"Sévigny",
    "titre_genre2":"Conseillère",
    "remuneration":"11593",
    "allocation":"5797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17390",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":1869,
    "nom_corrige2":"Carl De Montigny",
    "nom_famille":"De Montigny",
    "titre_genre2":"Conseiller",
    "remuneration":"11551",
    "allocation":"5776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17327",
    "ville":"Val-David",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"5861"
  },
  {
    "ID":1870,
    "nom_corrige2":"René Laverdière",
    "nom_famille":"Laverdière",
    "titre_genre2":"Maire",
    "remuneration":"11550",
    "allocation":"5775",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17325",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":1871,
    "nom_corrige2":"Guy Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"10591",
    "allocation":"5295",
    "remuneration2":"957,00$",
    "allocation2":"478,00$",
    "total":"17321",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":1872,
    "nom_corrige2":"Jean-Marc Dickenson",
    "nom_famille":"Dickenson",
    "titre_genre2":"Conseiller",
    "remuneration":"11522",
    "allocation":"5762",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17284",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":1873,
    "nom_corrige2":"Cindy Duquette",
    "nom_famille":"Duquette",
    "titre_genre2":"Conseillère",
    "remuneration":"11522",
    "allocation":"5762",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17284",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":1874,
    "nom_corrige2":"Josée Pérusse",
    "nom_famille":"Pérusse",
    "titre_genre2":"Conseiller",
    "remuneration":"11522",
    "allocation":"5762",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17284",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":1875,
    "nom_corrige2":"Roger Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"11522",
    "allocation":"5762",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17284",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":1876,
    "nom_corrige2":"Marcel Charpentier",
    "nom_famille":"Charpentier",
    "titre_genre2":"Conseiller",
    "remuneration":"11522",
    "allocation":"5762",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17284",
    "ville":"Cookshire-Eaton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5463"
  },
  {
    "ID":1877,
    "nom_corrige2":"Andrew Somerville",
    "nom_famille":"Somerville",
    "titre_genre2":"Maire",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"6192",
    "allocation2":"2569",
    "total":"17284",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":1878,
    "nom_corrige2":"Guy Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Maire",
    "remuneration":"8639",
    "allocation":"4319",
    "remuneration2":"2860",
    "allocation2":"1430",
    "total":"17248",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":1879,
    "nom_corrige2":"Yvon Carle",
    "nom_famille":"Carle",
    "titre_genre2":"Maire",
    "remuneration":"10263",
    "allocation":"5131",
    "remuneration2":"1216",
    "allocation2":"608,00$",
    "total":"17218",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":1880,
    "nom_corrige2":"Sylvain Toupin",
    "nom_famille":"Toupin",
    "titre_genre2":"Conseiller",
    "remuneration":"11456",
    "allocation":"5728",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17184",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":1881,
    "nom_corrige2":"Valérie Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseillère",
    "remuneration":"11410",
    "allocation":"5705",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17115",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":1882,
    "nom_corrige2":"Gérald Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Maire",
    "remuneration":"9862",
    "allocation":"4503",
    "remuneration2":"1800",
    "allocation2":"900,00$",
    "total":"17065",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":1883,
    "nom_corrige2":"Jean-Félipe Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"11366",
    "allocation":"5683",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"17049",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":1884,
    "nom_corrige2":"Guillaume Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"11097",
    "allocation":"5548",
    "remuneration2":"249,00$",
    "allocation2":"124,00$",
    "total":"17018",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":1885,
    "nom_corrige2":"Peter Manning",
    "nom_famille":"Manning",
    "titre_genre2":"Maire",
    "remuneration":"9473",
    "allocation":"4736",
    "remuneration2":"1855",
    "allocation2":"928,00$",
    "total":"16992",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":1886,
    "nom_corrige2":"Guy Favreau",
    "nom_famille":"Favreau",
    "titre_genre2":"Maire",
    "remuneration":"8246",
    "allocation":"4123",
    "remuneration2":"3072",
    "allocation2":"1536",
    "total":"16977",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":1887,
    "nom_corrige2":"Richard Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseiller",
    "remuneration":"11310",
    "allocation":"5655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16965",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":1888,
    "nom_corrige2":"Guylaine Lefrancois",
    "nom_famille":"Lefrancois",
    "titre_genre2":"Conseillère",
    "remuneration":"11298",
    "allocation":"5649",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16947",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":1889,
    "nom_corrige2":"Christine Pleau",
    "nom_famille":"Pleau",
    "titre_genre2":"Conseillère",
    "remuneration":"11298",
    "allocation":"5649",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16947",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":1890,
    "nom_corrige2":"Éric Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"11298",
    "allocation":"5649",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16947",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":1891,
    "nom_corrige2":"Vincent Latour",
    "nom_famille":"Latour",
    "titre_genre2":"Conseiller",
    "remuneration":"11298",
    "allocation":"5649",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16947",
    "ville":"Château-Richer",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4633"
  },
  {
    "ID":1892,
    "nom_corrige2":"Jean Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"11283",
    "allocation":"5642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16925",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":1893,
    "nom_corrige2":"Anne-Marie Masson",
    "nom_famille":"Masson",
    "titre_genre2":"Conseillère",
    "remuneration":"11280",
    "allocation":"5640",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16920",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":1894,
    "nom_corrige2":"Marjorie Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseillère",
    "remuneration":"11280",
    "allocation":"5640",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16920",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":1895,
    "nom_corrige2":"Alain Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"11280",
    "allocation":"5640",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16920",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":1896,
    "nom_corrige2":"Alexander Weil",
    "nom_famille":"Weil",
    "titre_genre2":"Conseiller",
    "remuneration":"11280",
    "allocation":"5640",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16920",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":1897,
    "nom_corrige2":"Charles Coulson",
    "nom_famille":"Coulson",
    "titre_genre2":"Conseiller",
    "remuneration":"11280",
    "allocation":"5640",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16920",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":1898,
    "nom_corrige2":"Debra Margles",
    "nom_famille":"Margles",
    "titre_genre2":"Conseillère",
    "remuneration":"11280",
    "allocation":"5640",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16920",
    "ville":"Estérel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"293"
  },
  {
    "ID":1899,
    "nom_corrige2":"Patrick Clowery",
    "nom_famille":"Clowery",
    "titre_genre2":"Conseiller",
    "remuneration":"9271",
    "allocation":"4635",
    "remuneration2":"1993",
    "allocation2":"1000",
    "total":"16899",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":1900,
    "nom_corrige2":"Mona Beaulac",
    "nom_famille":"Beaulac",
    "titre_genre2":"Conseillère",
    "remuneration":"12890",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16898",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":1901,
    "nom_corrige2":"Sylvain Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Maire",
    "remuneration":"6288",
    "allocation":"3144",
    "remuneration2":"4975",
    "allocation2":"2487",
    "total":"16894",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":1902,
    "nom_corrige2":"Pierre Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"11262",
    "allocation":"5631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16893",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":1903,
    "nom_corrige2":"Ashley Miligan",
    "nom_famille":"Miligan",
    "titre_genre2":"Mairesse",
    "remuneration":"11259",
    "allocation":"5630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16889",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":1904,
    "nom_corrige2":"Marcel Gaumond",
    "nom_famille":"Gaumond",
    "titre_genre2":"Conseiller",
    "remuneration":"10312",
    "allocation":"5051",
    "remuneration2":"955,00$",
    "allocation2":"477,00$",
    "total":"16795",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":1905,
    "nom_corrige2":"Rachel Grégoire",
    "nom_famille":"Grégoire",
    "titre_genre2":"Conseillère",
    "remuneration":"11178",
    "allocation":"5589",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16767",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":1906,
    "nom_corrige2":"Sylvain Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseiller",
    "remuneration":"11009",
    "allocation":"5504",
    "remuneration2":"158,00$",
    "allocation2":"79,00$",
    "total":"16750",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":1907,
    "nom_corrige2":"Amélie Lebrun",
    "nom_famille":"Lebrun",
    "titre_genre2":"Conseillère",
    "remuneration":"11314",
    "allocation":"5412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16726",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":1908,
    "nom_corrige2":"Denis Darveau",
    "nom_famille":"Darveau",
    "titre_genre2":"Conseiller",
    "remuneration":"11314",
    "allocation":"5412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16726",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":1909,
    "nom_corrige2":"Isabelle Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseillère",
    "remuneration":"11314",
    "allocation":"5412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16726",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":1910,
    "nom_corrige2":"Jean-François Frenière",
    "nom_famille":"Frenière",
    "titre_genre2":"Conseiller",
    "remuneration":"11314",
    "allocation":"5412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16726",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":1911,
    "nom_corrige2":"Sylvain Destrempes",
    "nom_famille":"Destrempes",
    "titre_genre2":"Conseiller",
    "remuneration":"11314",
    "allocation":"5412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16726",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":1912,
    "nom_corrige2":"Patrick Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseillère",
    "remuneration":"11314",
    "allocation":"5412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16726",
    "ville":"Berthierville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4518"
  },
  {
    "ID":1913,
    "nom_corrige2":"Alain Vouligny",
    "nom_famille":"Vouligny",
    "titre_genre2":"Maire",
    "remuneration":"8168",
    "allocation":"2809",
    "remuneration2":"4644",
    "allocation2":"1104",
    "total":"16725",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":1914,
    "nom_corrige2":"Yves Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Conseiller",
    "remuneration":"13003",
    "allocation":"3328",
    "remuneration2":"254,00$",
    "allocation2":"127,00$",
    "total":"16712",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":1915,
    "nom_corrige2":"Danielle Lanciaux",
    "nom_famille":"Lanciaux",
    "titre_genre2":"Conseillère",
    "remuneration":"11140",
    "allocation":"5570",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16710",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":1916,
    "nom_corrige2":"Gerry Clark",
    "nom_famille":"Clark",
    "titre_genre2":"Maire suppléant",
    "remuneration":"11106",
    "allocation":"5553",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16659",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":1917,
    "nom_corrige2":"William Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Maire suppléant",
    "remuneration":"11103",
    "allocation":"5551",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16654",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":1918,
    "nom_corrige2":"Rémi Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Maire",
    "remuneration":"11097",
    "allocation":"5549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16646",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":1919,
    "nom_corrige2":"Denis Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"11097",
    "allocation":"5548",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16645",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":1920,
    "nom_corrige2":"Michel Champigny",
    "nom_famille":"Champigny",
    "titre_genre2":"Conseiller",
    "remuneration":"11097",
    "allocation":"5548",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16645",
    "ville":"East Angus",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4074"
  },
  {
    "ID":1921,
    "nom_corrige2":"Suzie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Mairesse",
    "remuneration":"10052",
    "allocation":"5325",
    "remuneration2":"843,00$",
    "allocation2":"422,00$",
    "total":"16642",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":1922,
    "nom_corrige2":"Frédéric Lizotte",
    "nom_famille":"Lizotte",
    "titre_genre2":"Maire",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"3107",
    "allocation2":"1533",
    "total":"16640",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":1923,
    "nom_corrige2":"Rachelle Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Mairesse",
    "remuneration":"7255",
    "allocation":"3628",
    "remuneration2":"3982",
    "allocation2":"1770",
    "total":"16635",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":1924,
    "nom_corrige2":"François Marcotte",
    "nom_famille":"Marcotte",
    "titre_genre2":"Maire",
    "remuneration":"11083",
    "allocation":"5542",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16625",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":1925,
    "nom_corrige2":"André Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Maire",
    "remuneration":"8286",
    "allocation":"4143",
    "remuneration2":"3139",
    "allocation2":"1047",
    "total":"16615",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":1926,
    "nom_corrige2":"Ghislain Brunet",
    "nom_famille":"Brunet",
    "titre_genre2":"Conseiller",
    "remuneration":"10803",
    "allocation":"5776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16579",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":1927,
    "nom_corrige2":"Benoit Chevalier",
    "nom_famille":"Chevalier",
    "titre_genre2":"Maire",
    "remuneration":"11031",
    "allocation":"5516",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16547",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":1928,
    "nom_corrige2":"Mario Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Maire",
    "remuneration":"7059",
    "allocation":"3529",
    "remuneration2":"5233",
    "allocation2":"722,00$",
    "total":"16543",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":1929,
    "nom_corrige2":"Hazen Whittom",
    "nom_famille":"Whittom",
    "titre_genre2":"Maire",
    "remuneration":"11021",
    "allocation":"5511",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16532",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":1930,
    "nom_corrige2":"Éric Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Conseiller",
    "remuneration":"11017",
    "allocation":"5509",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16526",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":1931,
    "nom_corrige2":"Christine Gingras",
    "nom_famille":"Gingras",
    "titre_genre2":"Conseillère",
    "remuneration":"11009",
    "allocation":"5504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16513",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":1932,
    "nom_corrige2":"Marc Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"11009",
    "allocation":"5504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16513",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":1933,
    "nom_corrige2":"Alain Beaudin",
    "nom_famille":"Beaudin",
    "titre_genre2":"Conseiller",
    "remuneration":"11002",
    "allocation":"5501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16503",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":1934,
    "nom_corrige2":"Ana Rosa Mariscal",
    "nom_famille":"Mariscal",
    "titre_genre2":"Conseillère",
    "remuneration":"11002",
    "allocation":"5501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16503",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":1935,
    "nom_corrige2":"Daniel Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"11002",
    "allocation":"5501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16503",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":1936,
    "nom_corrige2":"Mario Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"11002",
    "allocation":"5501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16503",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":1937,
    "nom_corrige2":"Solange Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseillère",
    "remuneration":"11002",
    "allocation":"5501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16503",
    "ville":"Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5417"
  },
  {
    "ID":1938,
    "nom_corrige2":"Chantale Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"11000",
    "allocation":"5500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16500",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":1939,
    "nom_corrige2":"Diane Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseillère",
    "remuneration":"11000",
    "allocation":"5500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16500",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":1940,
    "nom_corrige2":"William St-Cyr",
    "nom_famille":"St-Cyr",
    "titre_genre2":"Conseiller",
    "remuneration":"11000",
    "allocation":"5500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16500",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":1941,
    "nom_corrige2":"Félix Laberge",
    "nom_famille":"Laberge",
    "titre_genre2":"Conseiller",
    "remuneration":"11000",
    "allocation":"5500",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16500",
    "ville":"L'Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3999"
  },
  {
    "ID":1942,
    "nom_corrige2":"Nadia Bissada",
    "nom_famille":"Nadia",
    "titre_genre2":"Conseillère",
    "remuneration":"10982",
    "allocation":"5491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16473",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":1943,
    "nom_corrige2":"Anthony Brown",
    "nom_famille":"Anthony",
    "titre_genre2":"Conseiller",
    "remuneration":"10982",
    "allocation":"5491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16473",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":1944,
    "nom_corrige2":"Brigitte Chartrand",
    "nom_famille":"Chartrand",
    "titre_genre2":"Conseillère",
    "remuneration":"10982",
    "allocation":"5491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16473",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":1945,
    "nom_corrige2":"Wanda Lowensteyn",
    "nom_famille":"Lowensteyn",
    "titre_genre2":"Conseillère",
    "remuneration":"10982",
    "allocation":"5491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16473",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":1946,
    "nom_corrige2":"Tom Thompson",
    "nom_famille":"Thompson",
    "titre_genre2":"Conseiller",
    "remuneration":"10982",
    "allocation":"5491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16473",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":1947,
    "nom_corrige2":"Stephen Gruber",
    "nom_famille":"Gruber",
    "titre_genre2":"Conseiller",
    "remuneration":"10982",
    "allocation":"5491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16473",
    "ville":"Baie-D'Urfé",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"3712"
  },
  {
    "ID":1948,
    "nom_corrige2":"Luc Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseiller",
    "remuneration":"10964",
    "allocation":"5482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16446",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":1949,
    "nom_corrige2":"Pier-Luc Denoncourt",
    "nom_famille":"Denoncourt",
    "titre_genre2":"Conseiller",
    "remuneration":"10964",
    "allocation":"5482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16446",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":1950,
    "nom_corrige2":"Richard Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"10964",
    "allocation":"5482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16446",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":1951,
    "nom_corrige2":"Egide Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Conseiller",
    "remuneration":"10964",
    "allocation":"5482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16446",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":1952,
    "nom_corrige2":"Elaine-Andree Guilbault",
    "nom_famille":"Guilbault",
    "titre_genre2":"Conseillère",
    "remuneration":"10964",
    "allocation":"5482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16446",
    "ville":"Amqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"6109"
  },
  {
    "ID":1953,
    "nom_corrige2":"Alain Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Maire",
    "remuneration":"8256",
    "allocation":"4128",
    "remuneration2":"3321",
    "allocation2":"722,00$",
    "total":"16427",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":1954,
    "nom_corrige2":"Martin Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"11009",
    "allocation":"5404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16413",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":1955,
    "nom_corrige2":"Jacques Laprise",
    "nom_famille":"Laprise",
    "titre_genre2":"Maire",
    "remuneration":"9550",
    "allocation":"4775",
    "remuneration2":"1350",
    "allocation2":"675,00$",
    "total":"16350",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":1956,
    "nom_corrige2":"Lina Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Mairesse",
    "remuneration":"10884",
    "allocation":"5442",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16326",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":1957,
    "nom_corrige2":"Alain Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Maire",
    "remuneration":"7663",
    "allocation":"3833",
    "remuneration2":"3210",
    "allocation2":"1605",
    "total":"16311",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":1958,
    "nom_corrige2":"Pierre Dumas",
    "nom_famille":"Dumas",
    "titre_genre2":"Maire",
    "remuneration":"9568",
    "allocation":"4784",
    "remuneration2":"1293",
    "allocation2":"646,00$",
    "total":"16291",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":1959,
    "nom_corrige2":"Claude Poupart",
    "nom_famille":"Poupart",
    "titre_genre2":"Conseiller",
    "remuneration":"10843",
    "allocation":"5422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16265",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":1960,
    "nom_corrige2":"Marcel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"10843",
    "allocation":"5422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16265",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":1961,
    "nom_corrige2":"Mario Guérin",
    "nom_famille":"Guérin",
    "titre_genre2":"Conseiller",
    "remuneration":"10843",
    "allocation":"5422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16265",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":1962,
    "nom_corrige2":"Mario Isabelle",
    "nom_famille":"Isabelle",
    "titre_genre2":"Conseiller",
    "remuneration":"10843",
    "allocation":"5422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16265",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":1963,
    "nom_corrige2":"Patrice Lirette",
    "nom_famille":"Lirette",
    "titre_genre2":"Conseiller",
    "remuneration":"10843",
    "allocation":"5422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16265",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":1964,
    "nom_corrige2":"Patrick Phaneuf",
    "nom_famille":"Phaneuf",
    "titre_genre2":"Conseiller",
    "remuneration":"10843",
    "allocation":"5422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16265",
    "ville":"Saint-Michel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3673"
  },
  {
    "ID":1965,
    "nom_corrige2":"Marc-André Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"10827",
    "allocation":"5413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16240",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":1966,
    "nom_corrige2":"Carl Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Maire",
    "remuneration":"10821",
    "allocation":"5411",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16232",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":1967,
    "nom_corrige2":"Anick Campeau",
    "nom_famille":"Campeau",
    "titre_genre2":"Conseillère",
    "remuneration":"10807",
    "allocation":"5404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16211",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":1968,
    "nom_corrige2":"Dave Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseiller",
    "remuneration":"10807",
    "allocation":"5404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16211",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":1969,
    "nom_corrige2":"Germain Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"10807",
    "allocation":"5404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16211",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":1970,
    "nom_corrige2":"Renaud Labonté",
    "nom_famille":"Labonté",
    "titre_genre2":"Conseiller",
    "remuneration":"10807",
    "allocation":"5404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16211",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":1971,
    "nom_corrige2":"Stéphanie Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseillère",
    "remuneration":"10807",
    "allocation":"5404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16211",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":1972,
    "nom_corrige2":"Alain Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseiller",
    "remuneration":"10767",
    "allocation":"5384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16151",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":1973,
    "nom_corrige2":"Guy Corriveau",
    "nom_famille":"Corriveau",
    "titre_genre2":"Conseiller",
    "remuneration":"10762",
    "allocation":"5381",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16143",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":1974,
    "nom_corrige2":"Marie Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"10781",
    "allocation":"5348",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16129",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":1975,
    "nom_corrige2":"Lina Courtois",
    "nom_famille":"Courtois",
    "titre_genre2":"Conseillère",
    "remuneration":"10744",
    "allocation":"5372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16116",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":1976,
    "nom_corrige2":"Jean Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseiller",
    "remuneration":"11539",
    "allocation":"4532",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16071",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":1977,
    "nom_corrige2":"Alexandre Binette",
    "nom_famille":"Binette",
    "titre_genre2":"Maire",
    "remuneration":"7761",
    "allocation":"3393",
    "remuneration2":"3274",
    "allocation2":"1637",
    "total":"16065",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":1978,
    "nom_corrige2":"Madeleine Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"10808",
    "allocation":"5196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16004",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":1979,
    "nom_corrige2":"Jean-Philippe Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"10808",
    "allocation":"5196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16004",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":1980,
    "nom_corrige2":"Mélanie Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"10808",
    "allocation":"5196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16004",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":1981,
    "nom_corrige2":"Alain Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseiller",
    "remuneration":"10808",
    "allocation":"5196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16004",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":1982,
    "nom_corrige2":"Daniel-Luc Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"10808",
    "allocation":"5196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"16004",
    "ville":"Gracefield",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"2516"
  },
  {
    "ID":1983,
    "nom_corrige2":"Mélanie Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"10650",
    "allocation":"5325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15975",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":1984,
    "nom_corrige2":"Karine Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseillère",
    "remuneration":"10636",
    "allocation":"5318",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15954",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":1985,
    "nom_corrige2":"Pierre Bourget",
    "nom_famille":"Bourget",
    "titre_genre2":"Conseiller",
    "remuneration":"10636",
    "allocation":"5318",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15954",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":1986,
    "nom_corrige2":"Réjean Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"10636",
    "allocation":"5318",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15954",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":1987,
    "nom_corrige2":"Renée Thiboutot",
    "nom_famille":"Thiboutot",
    "titre_genre2":"Conseillère",
    "remuneration":"10636",
    "allocation":"5318",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15954",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":1988,
    "nom_corrige2":"Steve Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"10636",
    "allocation":"5318",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15954",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":1989,
    "nom_corrige2":"Victor Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"10636",
    "allocation":"5318",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15954",
    "ville":"La Sarre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"7177"
  },
  {
    "ID":1990,
    "nom_corrige2":"François Desaulniers",
    "nom_famille":"Desaulniers",
    "titre_genre2":"Conseiller",
    "remuneration":"10603",
    "allocation":"5301",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15904",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":1991,
    "nom_corrige2":"Katherine Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Conseillère",
    "remuneration":"10591",
    "allocation":"5295",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15886",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":1992,
    "nom_corrige2":"Claude Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Maire",
    "remuneration":"9232",
    "allocation":"4618",
    "remuneration2":"1349",
    "allocation2":"675,00$",
    "total":"15874",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":1993,
    "nom_corrige2":"Alain Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"10580",
    "allocation":"5290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15870",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":1994,
    "nom_corrige2":"Claude Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"10580",
    "allocation":"5290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15870",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":1995,
    "nom_corrige2":"Jonathan Mattson",
    "nom_famille":"Mattson",
    "titre_genre2":"Conseiller",
    "remuneration":"10580",
    "allocation":"5290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15870",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":1996,
    "nom_corrige2":"Luc Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"10580",
    "allocation":"5290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15870",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":1997,
    "nom_corrige2":"Nichèle Compartino",
    "nom_famille":"Compartino",
    "titre_genre2":"Conseillère",
    "remuneration":"10580",
    "allocation":"5290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15870",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":1998,
    "nom_corrige2":"Stéphane Hudon",
    "nom_famille":"Hudon",
    "titre_genre2":"Conseiller",
    "remuneration":"10580",
    "allocation":"5290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15870",
    "ville":"Chibougamau",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"7327"
  },
  {
    "ID":1999,
    "nom_corrige2":"Raymond Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"11797",
    "allocation":"4044",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15841",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":2000,
    "nom_corrige2":"Richard Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Maire",
    "remuneration":"8750",
    "allocation":"4375",
    "remuneration2":"1800",
    "allocation2":"900,00$",
    "total":"15825",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":2001,
    "nom_corrige2":"Charles-André Pagé",
    "nom_famille":"Pagé",
    "titre_genre2":"Maire suppléant",
    "remuneration":"10532",
    "allocation":"5266",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15798",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":2002,
    "nom_corrige2":"André Jr. Florestal",
    "nom_famille":"Florestal",
    "titre_genre2":"Conseiller",
    "remuneration":"10501",
    "allocation":"5250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15751",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":2003,
    "nom_corrige2":"Louis Quevillon",
    "nom_famille":"Quevillon",
    "titre_genre2":"Conseiller",
    "remuneration":"10501",
    "allocation":"5250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15751",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":2004,
    "nom_corrige2":"Pierre Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Conseiller",
    "remuneration":"10501",
    "allocation":"5250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15751",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":2005,
    "nom_corrige2":"Stephen Rowland",
    "nom_famille":"Rowland",
    "titre_genre2":"Conseiller",
    "remuneration":"10501",
    "allocation":"5250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15751",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":2006,
    "nom_corrige2":"Martine Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Conseillère",
    "remuneration":"10501",
    "allocation":"5250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15751",
    "ville":"Brownsburg-Chatham",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"8146"
  },
  {
    "ID":2007,
    "nom_corrige2":"Chantale Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"10727",
    "allocation":"5007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15734",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":2008,
    "nom_corrige2":"Alain Castonguay",
    "nom_famille":"Castonguay",
    "titre_genre2":"Conseiller",
    "remuneration":"10471",
    "allocation":"5235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15706",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":2009,
    "nom_corrige2":"Dominique Dupont",
    "nom_famille":"Dupont",
    "titre_genre2":"Conseiller",
    "remuneration":"10471",
    "allocation":"5235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15706",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":2010,
    "nom_corrige2":"Fabrice Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"10471",
    "allocation":"5235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15706",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":2011,
    "nom_corrige2":"Jean-Roch Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"10471",
    "allocation":"5235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15706",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":2012,
    "nom_corrige2":"Mario Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"10471",
    "allocation":"5235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15706",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":2013,
    "nom_corrige2":"René Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"10471",
    "allocation":"5235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15706",
    "ville":"Saint-Antonin",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"4618"
  },
  {
    "ID":2014,
    "nom_corrige2":"Réal Ducharme",
    "nom_famille":"Ducharme",
    "titre_genre2":"Maire suppléant",
    "remuneration":"10464",
    "allocation":"5232",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15696",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":2015,
    "nom_corrige2":"Gerard Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"10433",
    "allocation":"5216",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15649",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":2016,
    "nom_corrige2":"Clifford Lancaster",
    "nom_famille":"Lancaster",
    "titre_genre2":"Conseiller",
    "remuneration":"10433",
    "allocation":"5216",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15649",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":2017,
    "nom_corrige2":"Valérie Taillefer",
    "nom_famille":"Taillefer",
    "titre_genre2":"Conseillère",
    "remuneration":"10400",
    "allocation":"5200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15600",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":2018,
    "nom_corrige2":"Jean-Côme Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Maire",
    "remuneration":"10389",
    "allocation":"5195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15584",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":2019,
    "nom_corrige2":"Sylvain Morel",
    "nom_famille":"Morel",
    "titre_genre2":"Conseiller",
    "remuneration":"10382",
    "allocation":"5189",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15571",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":2020,
    "nom_corrige2":"Sara Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseillère",
    "remuneration":"10382",
    "allocation":"5189",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15571",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":2021,
    "nom_corrige2":"Luc Delisle",
    "nom_famille":"Delisle",
    "titre_genre2":"Conseiller",
    "remuneration":"8876",
    "allocation":"4438",
    "remuneration2":"1495",
    "allocation2":"748,00$",
    "total":"15557",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":2022,
    "nom_corrige2":"Emmanuelle Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"10475",
    "allocation":"5051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15526",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":2023,
    "nom_corrige2":"Georges Belec",
    "nom_famille":"Belec",
    "titre_genre2":"Conseiller",
    "remuneration":"10079",
    "allocation":"5040",
    "remuneration2":"254,00$",
    "allocation2":"127,00$",
    "total":"15500",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":2024,
    "nom_corrige2":"Peter Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseiller",
    "remuneration":"10314",
    "allocation":"5155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15469",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":2025,
    "nom_corrige2":"André Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Conseiller",
    "remuneration":"10309",
    "allocation":"5155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15464",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":2026,
    "nom_corrige2":"Dominique Majeau",
    "nom_famille":"Majeau",
    "titre_genre2":"Conseiller",
    "remuneration":"10309",
    "allocation":"5155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15464",
    "ville":"Saint-Esprit",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2350"
  },
  {
    "ID":2027,
    "nom_corrige2":"Vincent Normandeau",
    "nom_famille":"Normandeau",
    "titre_genre2":"Conseiller",
    "remuneration":"9781",
    "allocation":"4890",
    "remuneration2":"509,00$",
    "allocation2":"254,00$",
    "total":"15434",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":2028,
    "nom_corrige2":"Sébastien Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Maire",
    "remuneration":"10282",
    "allocation":"5141",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15423",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":2029,
    "nom_corrige2":"Myriam Deroy",
    "nom_famille":"Deroy",
    "titre_genre2":"Conseiller",
    "remuneration":"10367",
    "allocation":"5051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15418",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":2030,
    "nom_corrige2":"Charles Malette",
    "nom_famille":"Malette",
    "titre_genre2":"Conseiller",
    "remuneration":"10275",
    "allocation":"5137",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15412",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":2031,
    "nom_corrige2":"Jonathan Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Conseiller",
    "remuneration":"10116",
    "allocation":"5058",
    "remuneration2":"158,00$",
    "allocation2":"79,00$",
    "total":"15411",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":2032,
    "nom_corrige2":"Yanick Beauchemin",
    "nom_famille":"Beauchemin",
    "titre_genre2":"Conseiller",
    "remuneration":"6933",
    "allocation":"4311",
    "remuneration2":"4165",
    "allocation2":"0",
    "total":"15409",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":2033,
    "nom_corrige2":"Annie Levasseur",
    "nom_famille":"Levasseur",
    "titre_genre2":"Mairesse",
    "remuneration":"8040",
    "allocation":"4020",
    "remuneration2":"2225",
    "allocation2":"1113",
    "total":"15398",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":2034,
    "nom_corrige2":"Luce Bouley",
    "nom_famille":"Bouley",
    "titre_genre2":"Conseillère",
    "remuneration":"10262",
    "allocation":"5130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15392",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":2035,
    "nom_corrige2":"Pierre Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Maire suppléant",
    "remuneration":"10103",
    "allocation":"5286",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15389",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":2036,
    "nom_corrige2":"Valérie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"10246",
    "allocation":"5122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15368",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":2037,
    "nom_corrige2":"Manon Huard",
    "nom_famille":"Huard",
    "titre_genre2":"Conseillère",
    "remuneration":"10312",
    "allocation":"5051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15363",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":2038,
    "nom_corrige2":"Michael Tuppert",
    "nom_famille":"Tuppert",
    "titre_genre2":"Conseiller",
    "remuneration":"10312",
    "allocation":"5051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15363",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":2039,
    "nom_corrige2":"Roxane Boutet",
    "nom_famille":"Boutet",
    "titre_genre2":"Conseillère",
    "remuneration":"10312",
    "allocation":"5051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15363",
    "ville":"Fossambault-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2463"
  },
  {
    "ID":2040,
    "nom_corrige2":"Vincent Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"10241",
    "allocation":"5120",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15361",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":2041,
    "nom_corrige2":"Caroline Cusson",
    "nom_famille":"Cusson",
    "titre_genre2":"Mairesse",
    "remuneration":"7195",
    "allocation":"3548",
    "remuneration2":"3072",
    "allocation2":"1536",
    "total":"15351",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":2042,
    "nom_corrige2":"Claudie Létourneau",
    "nom_famille":"Létourneau",
    "titre_genre2":"Conseillère",
    "remuneration":"10547",
    "allocation":"4791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15338",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":2043,
    "nom_corrige2":"Jacques Bienvenue",
    "nom_famille":"Bienvenue",
    "titre_genre2":"Conseiller",
    "remuneration":"10547",
    "allocation":"4791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15338",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":2044,
    "nom_corrige2":"Richard Harland",
    "nom_famille":"Harland",
    "titre_genre2":"Conseiller",
    "remuneration":"10210",
    "allocation":"5105",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15315",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":2045,
    "nom_corrige2":"Denise Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseillère",
    "remuneration":"8876",
    "allocation":"4438",
    "remuneration2":"1329",
    "allocation2":"665,00$",
    "total":"15308",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":2046,
    "nom_corrige2":"Alain Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseiller",
    "remuneration":"10200",
    "allocation":"5100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15300",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":2047,
    "nom_corrige2":"Michel Denicourt",
    "nom_famille":"Denicourt",
    "titre_genre2":"Conseiller",
    "remuneration":"10506",
    "allocation":"4791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15297",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":2048,
    "nom_corrige2":"Caroline Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseillère",
    "remuneration":"10195",
    "allocation":"5098",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15293",
    "ville":"Saint-Lambert-de-Lauzon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"7245"
  },
  {
    "ID":2049,
    "nom_corrige2":"Elisabeth Boily",
    "nom_famille":"Boily",
    "titre_genre2":"Conseillère",
    "remuneration":"10177",
    "allocation":"5089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15266",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":2050,
    "nom_corrige2":"André Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Maire",
    "remuneration":"8594",
    "allocation":"4297",
    "remuneration2":"2365",
    "allocation2":"0",
    "total":"15256",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":2051,
    "nom_corrige2":"Magella Roussel",
    "nom_famille":"Roussel",
    "titre_genre2":"Maire",
    "remuneration":"6460",
    "allocation":"3230",
    "remuneration2":"3706",
    "allocation2":"1853",
    "total":"15249",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":2052,
    "nom_corrige2":"Céline Langlais",
    "nom_famille":"Langlais",
    "titre_genre2":"Conseillère",
    "remuneration":"9920",
    "allocation":"4960",
    "remuneration2":"207,00$",
    "allocation2":"104,00$",
    "total":"15191",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":2053,
    "nom_corrige2":"Kevin Pomerleau",
    "nom_famille":"Pomerleau",
    "titre_genre2":"Conseiller",
    "remuneration":"10122",
    "allocation":"5061",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15183",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":2054,
    "nom_corrige2":"Annick Héon",
    "nom_famille":"Héon",
    "titre_genre2":"Conseillère",
    "remuneration":"10116",
    "allocation":"5058",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15174",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":2055,
    "nom_corrige2":"Bélinda Drolet",
    "nom_famille":"Drolet",
    "titre_genre2":"Conseillère",
    "remuneration":"10116",
    "allocation":"5058",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15174",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":2056,
    "nom_corrige2":"Joanie Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"10116",
    "allocation":"5058",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15174",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":2057,
    "nom_corrige2":"Marc Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"10116",
    "allocation":"5058",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15174",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":2058,
    "nom_corrige2":"Rémi Brassard",
    "nom_famille":"Brassard",
    "titre_genre2":"Conseiller",
    "remuneration":"10116",
    "allocation":"5058",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15174",
    "ville":"Plessisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"9613"
  },
  {
    "ID":2059,
    "nom_corrige2":"Joanie Généreux",
    "nom_famille":"Généreux",
    "titre_genre2":"Conseillère",
    "remuneration":"10381",
    "allocation":"4791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15172",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":2060,
    "nom_corrige2":"Michel Deschamps",
    "nom_famille":"Deschamps",
    "titre_genre2":"Conseiller",
    "remuneration":"10380",
    "allocation":"4791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15171",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":2061,
    "nom_corrige2":"Simon Chapleau",
    "nom_famille":"Chapleau",
    "titre_genre2":"Conseiller",
    "remuneration":"10105",
    "allocation":"5050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15155",
    "ville":"Saint-Jacques",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4737"
  },
  {
    "ID":2062,
    "nom_corrige2":"Frederic Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"10568",
    "allocation":"4584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15152",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":2063,
    "nom_corrige2":"Jude Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"10584",
    "allocation":"4542",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15126",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":2064,
    "nom_corrige2":"Réal Tourigny",
    "nom_famille":"Tourigny",
    "titre_genre2":"Conseiller",
    "remuneration":"10080",
    "allocation":"5040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15120",
    "ville":"Mont-Blanc",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4036"
  },
  {
    "ID":2065,
    "nom_corrige2":"Mathieu Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Maire",
    "remuneration":"9190",
    "allocation":"4607",
    "remuneration2":"878,00$",
    "allocation2":"439,00$",
    "total":"15114",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":2066,
    "nom_corrige2":"Nicole Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseillère",
    "remuneration":"10063",
    "allocation":"5032",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15095",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":2067,
    "nom_corrige2":"Jérôme Pomerleau",
    "nom_famille":"Pomerleau",
    "titre_genre2":"Conseiller",
    "remuneration":"10063",
    "allocation":"5032",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15095",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":2068,
    "nom_corrige2":"Léo Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Maire",
    "remuneration":"8076",
    "allocation":"4038",
    "remuneration2":"1970",
    "allocation2":"985,00$",
    "total":"15069",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":2069,
    "nom_corrige2":"Simon Brunelle",
    "nom_famille":"Brunelle",
    "titre_genre2":"Maire",
    "remuneration":"6287",
    "allocation":"3007",
    "remuneration2":"3843",
    "allocation2":"1922",
    "total":"15059",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":2070,
    "nom_corrige2":"Marie-Pier Tougas",
    "nom_famille":"Tougas",
    "titre_genre2":"Conseillère",
    "remuneration":"11015",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"15023",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":2071,
    "nom_corrige2":"Annie Sylvestre",
    "nom_famille":"Sylvestre",
    "titre_genre2":"Conseillère",
    "remuneration":"9991",
    "allocation":"4996",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14987",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":2072,
    "nom_corrige2":"Roland Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Maire",
    "remuneration":"9974",
    "allocation":"4987",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14961",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":2073,
    "nom_corrige2":"Kimberly Meyer",
    "nom_famille":"Meyer",
    "titre_genre2":"Conseillère",
    "remuneration":"9966",
    "allocation":"4983",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14949",
    "ville":"Mont-Tremblant",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12026"
  },
  {
    "ID":2074,
    "nom_corrige2":"Réjean Mégré",
    "nom_famille":"Mégré",
    "titre_genre2":"Conseiller",
    "remuneration":"9962",
    "allocation":"4981",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14943",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":2075,
    "nom_corrige2":"Guillaume Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"9960",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14940",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":2076,
    "nom_corrige2":"Daniel Audette",
    "nom_famille":"Audette",
    "titre_genre2":"Conseiller",
    "remuneration":"10890",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14898",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":2077,
    "nom_corrige2":"Jean-Marc Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Maire",
    "remuneration":"7807",
    "allocation":"3904",
    "remuneration2":"2124",
    "allocation2":"1062",
    "total":"14897",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":2078,
    "nom_corrige2":"Sylvie Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"10223",
    "allocation":"4670",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14893",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":2079,
    "nom_corrige2":"Patrice Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire",
    "remuneration":"6994",
    "allocation":"3338",
    "remuneration2":"2735",
    "allocation2":"1824",
    "total":"14891",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":2080,
    "nom_corrige2":"Luc Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"9911",
    "allocation":"4956",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14867",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":2081,
    "nom_corrige2":"Jacques Darche",
    "nom_famille":"Darche",
    "titre_genre2":"Conseiller",
    "remuneration":"9911",
    "allocation":"4956",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14867",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":2082,
    "nom_corrige2":"Jo-Ann Quérel",
    "nom_famille":"Quérel",
    "titre_genre2":"Conseillère",
    "remuneration":"9911",
    "allocation":"4956",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14867",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":2083,
    "nom_corrige2":"Lucie Marchand",
    "nom_famille":"Marchand",
    "titre_genre2":"Conseillère",
    "remuneration":"9911",
    "allocation":"4956",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14867",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":2084,
    "nom_corrige2":"Tania Ann Blanchette",
    "nom_famille":"Ann Blanchette",
    "titre_genre2":"Conseillère",
    "remuneration":"9911",
    "allocation":"4956",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14867",
    "ville":"Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5998"
  },
  {
    "ID":2085,
    "nom_corrige2":"Chantal Crête",
    "nom_famille":"Crête",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"9909",
    "allocation":"4954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14863",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":2086,
    "nom_corrige2":"Benoît Bouthillette",
    "nom_famille":"Bouthillette",
    "titre_genre2":"Conseiller",
    "remuneration":"10275",
    "allocation":"4578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14853",
    "ville":"Compton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3326"
  },
  {
    "ID":2087,
    "nom_corrige2":"Carole Monette",
    "nom_famille":"Monette",
    "titre_genre2":"Conseillère",
    "remuneration":"9900",
    "allocation":"4950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14850",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":2088,
    "nom_corrige2":"Bertrand Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"9900",
    "allocation":"4950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14850",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":2089,
    "nom_corrige2":"Denis Monette",
    "nom_famille":"Monette",
    "titre_genre2":"Conseiller",
    "remuneration":"9900",
    "allocation":"4950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14850",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":2090,
    "nom_corrige2":"Jeane Francoeur",
    "nom_famille":"Francoeur",
    "titre_genre2":"Conseillère",
    "remuneration":"9900",
    "allocation":"4950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14850",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":2091,
    "nom_corrige2":"Réjean SR. Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Conseiller",
    "remuneration":"9900",
    "allocation":"4950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14850",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":2092,
    "nom_corrige2":"Sylvain Riopel",
    "nom_famille":"Riopel",
    "titre_genre2":"Conseiller",
    "remuneration":"9900",
    "allocation":"4950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14850",
    "ville":"Entrelacs",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1081"
  },
  {
    "ID":2093,
    "nom_corrige2":"Charles Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"9510",
    "allocation":"4755",
    "remuneration2":"388,00$",
    "allocation2":"194,00$",
    "total":"14847",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":2094,
    "nom_corrige2":"Raymond Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Maire",
    "remuneration":"4468",
    "allocation":"2234",
    "remuneration2":"6698",
    "allocation2":"1445",
    "total":"14845",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":2095,
    "nom_corrige2":"David Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Conseiller",
    "remuneration":"9885",
    "allocation":"4943",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14828",
    "ville":"Beauceville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6283"
  },
  {
    "ID":2096,
    "nom_corrige2":"Bertrand Prévost",
    "nom_famille":"Prévost",
    "titre_genre2":"Maire",
    "remuneration":"7387",
    "allocation":"3693",
    "remuneration2":"2487",
    "allocation2":"1244",
    "total":"14811",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":2097,
    "nom_corrige2":"Simon Sheehy",
    "nom_famille":"Sheehy",
    "titre_genre2":"Conseiller",
    "remuneration":"8876",
    "allocation":"4438",
    "remuneration2":"997,00$",
    "allocation2":"498,00$",
    "total":"14809",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":2098,
    "nom_corrige2":"Pierre Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseiller",
    "remuneration":"9869",
    "allocation":"4934",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14803",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":2099,
    "nom_corrige2":"Yvon Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Maire",
    "remuneration":"5410",
    "allocation":"2705",
    "remuneration2":"4616",
    "allocation2":"2052",
    "total":"14783",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":2100,
    "nom_corrige2":"Pierre Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"9846",
    "allocation":"4923",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14769",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":2101,
    "nom_corrige2":"Guylaine Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseillère",
    "remuneration":"10168",
    "allocation":"4584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14752",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":2102,
    "nom_corrige2":"Melissa Theberge",
    "nom_famille":"Theberge",
    "titre_genre2":"Conseillère",
    "remuneration":"9834",
    "allocation":"4917",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14751",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":2103,
    "nom_corrige2":"David Arseneault",
    "nom_famille":"Arseneault",
    "titre_genre2":"Conseiller",
    "remuneration":"9828",
    "allocation":"4914",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14742",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":2104,
    "nom_corrige2":"Éric Barrière",
    "nom_famille":"Barrière",
    "titre_genre2":"Conseiller",
    "remuneration":"9828",
    "allocation":"4914",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14742",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":2105,
    "nom_corrige2":"Martin Deguire",
    "nom_famille":"Deguire",
    "titre_genre2":"Conseiller",
    "remuneration":"9828",
    "allocation":"4914",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14742",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":2106,
    "nom_corrige2":"Patrice Deneault",
    "nom_famille":"Deneault",
    "titre_genre2":"Conseiller",
    "remuneration":"9828",
    "allocation":"4914",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14742",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":2107,
    "nom_corrige2":"Suzanne Lacroix",
    "nom_famille":"Lacroix",
    "titre_genre2":"Conseillère",
    "remuneration":"9828",
    "allocation":"4914",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14742",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":2108,
    "nom_corrige2":"Nancy Sorel",
    "nom_famille":"Sorel",
    "titre_genre2":"Conseillère",
    "remuneration":"9828",
    "allocation":"4914",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14742",
    "ville":"Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2802"
  },
  {
    "ID":2109,
    "nom_corrige2":"Manon Jutras",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseillère",
    "remuneration":"9760",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14740",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":2110,
    "nom_corrige2":"Jean-Marc Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Maire",
    "remuneration":"9062",
    "allocation":"4531",
    "remuneration2":"763,00$",
    "allocation2":"381,00$",
    "total":"14737",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":2111,
    "nom_corrige2":"René Allen",
    "nom_famille":"Allen",
    "titre_genre2":"Maire",
    "remuneration":"6241",
    "allocation":"3000",
    "remuneration2":"3638",
    "allocation2":"1819",
    "total":"14698",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":2112,
    "nom_corrige2":"Annick Laviolette",
    "nom_famille":"Laviolette",
    "titre_genre2":"Conseillère",
    "remuneration":"9781",
    "allocation":"4890",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14671",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":2113,
    "nom_corrige2":"Isabelle Laramée",
    "nom_famille":"Laramée",
    "titre_genre2":"Conseillère",
    "remuneration":"9781",
    "allocation":"4890",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14671",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":2114,
    "nom_corrige2":"Nicolas Bottreau",
    "nom_famille":"Bottreau",
    "titre_genre2":"Conseiller",
    "remuneration":"9781",
    "allocation":"4890",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14671",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":2115,
    "nom_corrige2":"Noémie Biardeau",
    "nom_famille":"Biardeau",
    "titre_genre2":"Conseillère",
    "remuneration":"9781",
    "allocation":"4890",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14671",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":2116,
    "nom_corrige2":"Julie Marchildon",
    "nom_famille":"Marchildon",
    "titre_genre2":"Conseillère",
    "remuneration":"9781",
    "allocation":"4890",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14671",
    "ville":"Labelle",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2878"
  },
  {
    "ID":2117,
    "nom_corrige2":"Danielle Cote",
    "nom_famille":"Cote",
    "titre_genre2":"Conseillère",
    "remuneration":"9771",
    "allocation":"4885",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14656",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":2118,
    "nom_corrige2":"Bruno Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseillère",
    "remuneration":"8917",
    "allocation":"4458",
    "remuneration2":"847,00$",
    "allocation2":"425,00$",
    "total":"14647",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":2119,
    "nom_corrige2":"Hélène St-Cyr",
    "nom_famille":"St-Cyr",
    "titre_genre2":"Conseillère",
    "remuneration":"9755",
    "allocation":"4877",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14632",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":2120,
    "nom_corrige2":"Marie-Josée Lamothe",
    "nom_famille":"Lamothe",
    "titre_genre2":"Conseillère",
    "remuneration":"10615",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14623",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":2121,
    "nom_corrige2":"Roch Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"9740",
    "allocation":"4870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14610",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":2122,
    "nom_corrige2":"Lucie Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"9721",
    "allocation":"4860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14581",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":2123,
    "nom_corrige2":"Sylvie Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseillère",
    "remuneration":"8607",
    "allocation":"4303",
    "remuneration2":"1115",
    "allocation2":"554,00$",
    "total":"14579",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":2124,
    "nom_corrige2":"Géraldine Veilleux Perron",
    "nom_famille":"Veilleux Perron",
    "titre_genre2":"Conseillère",
    "remuneration":"9709",
    "allocation":"4855",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14564",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":2125,
    "nom_corrige2":"Diane Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"7242",
    "allocation":"3309",
    "remuneration2":"2671",
    "allocation2":"1335",
    "total":"14557",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":2126,
    "nom_corrige2":"Carl Woodbury",
    "nom_famille":"Woodbury",
    "titre_genre2":"Conseiller",
    "remuneration":"9560",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14540",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":2127,
    "nom_corrige2":"Raynald Stockless",
    "nom_famille":"Stockless",
    "titre_genre2":"Conseiller",
    "remuneration":"7568",
    "allocation":"6968",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14536",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":2128,
    "nom_corrige2":"René Guimond",
    "nom_famille":"Guimond",
    "titre_genre2":"Maire",
    "remuneration":"6638",
    "allocation":"3319",
    "remuneration2":"3034",
    "allocation2":"1517",
    "total":"14508",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":2129,
    "nom_corrige2":"Richard Léveillée",
    "nom_famille":"Léveillée",
    "titre_genre2":"Maire suppléant",
    "remuneration":"9659",
    "allocation":"4830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14489",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":2130,
    "nom_corrige2":"Denise Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Conseillère",
    "remuneration":"9659",
    "allocation":"4830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14489",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":2131,
    "nom_corrige2":"Jacques Suzor",
    "nom_famille":"Suzor",
    "titre_genre2":"Conseiller",
    "remuneration":"9659",
    "allocation":"4830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14489",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":2132,
    "nom_corrige2":"Louise Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseillère",
    "remuneration":"9659",
    "allocation":"4830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14489",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":2133,
    "nom_corrige2":"Marc Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseiller",
    "remuneration":"9659",
    "allocation":"4830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14489",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":2134,
    "nom_corrige2":"Yves Robineau",
    "nom_famille":"Robineau",
    "titre_genre2":"Conseiller",
    "remuneration":"9659",
    "allocation":"4830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14489",
    "ville":"Lac-Sainte-Marie",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"726"
  },
  {
    "ID":2135,
    "nom_corrige2":"Noëlla Comtois",
    "nom_famille":"Comtois",
    "titre_genre2":"Conseillère",
    "remuneration":"9173",
    "allocation":"4587",
    "remuneration2":"473,00$",
    "allocation2":"236,00$",
    "total":"14469",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":2136,
    "nom_corrige2":"Sébastien Ricard",
    "nom_famille":"Ricard",
    "titre_genre2":"Conseiller",
    "remuneration":"9643",
    "allocation":"4822",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14465",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":2137,
    "nom_corrige2":"Robert Cardinal",
    "nom_famille":"Cardinal",
    "titre_genre2":"Conseiller",
    "remuneration":"11113",
    "allocation":"3328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14441",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":2138,
    "nom_corrige2":"Patrice Deslongchamps",
    "nom_famille":"Deslongchamps",
    "titre_genre2":"Conseiller",
    "remuneration":"9460",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14440",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":2139,
    "nom_corrige2":"Jacques Mailloux",
    "nom_famille":"Mailloux",
    "titre_genre2":"Conseiller",
    "remuneration":"10351",
    "allocation":"4044",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14395",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":2140,
    "nom_corrige2":"Chantal Robichaud",
    "nom_famille":"Robichaud",
    "titre_genre2":"Conseillère",
    "remuneration":"9593",
    "allocation":"4797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14390",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":2141,
    "nom_corrige2":"Denis Fillion",
    "nom_famille":"Fillion",
    "titre_genre2":"Conseiller",
    "remuneration":"9410",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14390",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":2142,
    "nom_corrige2":"Natalia Czarnecka",
    "nom_famille":"Czarnecka",
    "titre_genre2":"Conseillère",
    "remuneration":"9410",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14390",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":2143,
    "nom_corrige2":"Jessica Laforest",
    "nom_famille":"Laforest",
    "titre_genre2":"Conseillère",
    "remuneration":"9592",
    "allocation":"4796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14388",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":2144,
    "nom_corrige2":"Pierre Imbeault",
    "nom_famille":"Imbeault",
    "titre_genre2":"Conseiller",
    "remuneration":"9592",
    "allocation":"4796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14388",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":2145,
    "nom_corrige2":"Réjean Marcheterre",
    "nom_famille":"Marcheterre",
    "titre_genre2":"Conseiller",
    "remuneration":"9592",
    "allocation":"4796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14388",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":2146,
    "nom_corrige2":"Audrey Hottin",
    "nom_famille":"Hottin",
    "titre_genre2":"Conseillère",
    "remuneration":"9592",
    "allocation":"4796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14388",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":2147,
    "nom_corrige2":"Daniel Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"9592",
    "allocation":"4796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14388",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":2148,
    "nom_corrige2":"Julie Soulard",
    "nom_famille":"Soulard",
    "titre_genre2":"Conseillère",
    "remuneration":"9592",
    "allocation":"4796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14388",
    "ville":"Saint-Sulpice",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3442"
  },
  {
    "ID":2149,
    "nom_corrige2":"Réal Déry",
    "nom_famille":"Déry",
    "titre_genre2":"Conseiller",
    "remuneration":"6756",
    "allocation":"3378",
    "remuneration2":"2823",
    "allocation2":"1412",
    "total":"14369",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":2150,
    "nom_corrige2":"Joachim Courchesne",
    "nom_famille":"Courchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"9564",
    "allocation":"4776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":2151,
    "nom_corrige2":"Annie Neveu",
    "nom_famille":"Neveu",
    "titre_genre2":"Conseillère",
    "remuneration":"9564",
    "allocation":"4776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":2152,
    "nom_corrige2":"Éliane Neveu",
    "nom_famille":"Neveu",
    "titre_genre2":"Conseillère",
    "remuneration":"9564",
    "allocation":"4776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":2153,
    "nom_corrige2":"Frédéric Bourgeois",
    "nom_famille":"Bourgeois",
    "titre_genre2":"Conseiller",
    "remuneration":"9564",
    "allocation":"4776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":2154,
    "nom_corrige2":"Jean Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"9564",
    "allocation":"4776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":2155,
    "nom_corrige2":"Roxane Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Préfète suppléante",
    "remuneration":"9564",
    "allocation":"4776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Saint-Ambroise-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4554"
  },
  {
    "ID":2156,
    "nom_corrige2":"Isabelle Brisson",
    "nom_famille":"Brisson",
    "titre_genre2":"Conseillère",
    "remuneration":"9360",
    "allocation":"4980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14340",
    "ville":"Grenville-sur-la-Rouge",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3041"
  },
  {
    "ID":2157,
    "nom_corrige2":"André Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"9555",
    "allocation":"4777",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14332",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":2158,
    "nom_corrige2":"Alain Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Maire",
    "remuneration":"8321",
    "allocation":"4161",
    "remuneration2":"1220",
    "allocation2":"610,00$",
    "total":"14312",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":2159,
    "nom_corrige2":"Marie-Claude Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"7318",
    "allocation":"6968",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14286",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":2160,
    "nom_corrige2":"Amélie Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"9522",
    "allocation":"4761",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14283",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":2161,
    "nom_corrige2":"Caroline Nicole",
    "nom_famille":"Nicole",
    "titre_genre2":"Conseillère",
    "remuneration":"9522",
    "allocation":"4761",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14283",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":2162,
    "nom_corrige2":"Hubert Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"9522",
    "allocation":"4761",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14283",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":2163,
    "nom_corrige2":"Lucie Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseillère",
    "remuneration":"9522",
    "allocation":"4761",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14283",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":2164,
    "nom_corrige2":"Manon Trépanier",
    "nom_famille":"Trépanier",
    "titre_genre2":"Conseillère",
    "remuneration":"9522",
    "allocation":"4761",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14283",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":2165,
    "nom_corrige2":"Martin Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"9522",
    "allocation":"4761",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14283",
    "ville":"Sainte-Anne-de-Beaupré",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3098"
  },
  {
    "ID":2166,
    "nom_corrige2":"Carol Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"9510",
    "allocation":"4755",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14265",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":2167,
    "nom_corrige2":"Lucie Lanteigne",
    "nom_famille":"Lanteigne",
    "titre_genre2":"Conseillère",
    "remuneration":"9510",
    "allocation":"4755",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14265",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":2168,
    "nom_corrige2":"Maurice Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Conseiller",
    "remuneration":"9510",
    "allocation":"4755",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14265",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":2169,
    "nom_corrige2":"Patrick McDonald",
    "nom_famille":"McDonald",
    "titre_genre2":"Conseiller",
    "remuneration":"9510",
    "allocation":"4755",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14265",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":2170,
    "nom_corrige2":"Yves Boileau",
    "nom_famille":"Boileau",
    "titre_genre2":"Conseiller",
    "remuneration":"9510",
    "allocation":"4755",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14265",
    "ville":"Eastman",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2665"
  },
  {
    "ID":2171,
    "nom_corrige2":"Vicky Bombardier",
    "nom_famille":"Bombardier",
    "titre_genre2":"Conseillère",
    "remuneration":"10457",
    "allocation":"3789",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14246",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":2172,
    "nom_corrige2":"Yannick Bedard",
    "nom_famille":"Bedard",
    "titre_genre2":"Conseiller",
    "remuneration":"9494",
    "allocation":"4747",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14241",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":2173,
    "nom_corrige2":"Myriam Arbour",
    "nom_famille":"Arbour",
    "titre_genre2":"Conseillère",
    "remuneration":"9493",
    "allocation":"4747",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14240",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":2174,
    "nom_corrige2":"Mélissa Lord",
    "nom_famille":"Lord",
    "titre_genre2":"Mairesse",
    "remuneration":"9472",
    "allocation":"4736",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14208",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":2175,
    "nom_corrige2":"Martine Brouard",
    "nom_famille":"Brouard",
    "titre_genre2":"Mairesse",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"1855",
    "allocation2":"928,00$",
    "total":"14174",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":2176,
    "nom_corrige2":"Louis Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseiller",
    "remuneration":"9568",
    "allocation":"4584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14152",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":2177,
    "nom_corrige2":"Karine Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseillère",
    "remuneration":"9568",
    "allocation":"4584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14152",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":2178,
    "nom_corrige2":"Christelle Brassard",
    "nom_famille":"Brassard",
    "titre_genre2":"Conseillère",
    "remuneration":"9424",
    "allocation":"4712",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14136",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":2179,
    "nom_corrige2":"Roxanne Lajoie",
    "nom_famille":"Lajoie",
    "titre_genre2":"Conseillère",
    "remuneration":"9424",
    "allocation":"4712",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14136",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":2180,
    "nom_corrige2":"Hossein Falsafii",
    "nom_famille":"Falsafii",
    "titre_genre2":"Conseiller",
    "remuneration":"9424",
    "allocation":"4712",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14136",
    "ville":"La Conception",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1688"
  },
  {
    "ID":2181,
    "nom_corrige2":"Sophie Martinbeault",
    "nom_famille":"Martinbeault",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"9719",
    "allocation":"3194",
    "remuneration2":"1218",
    "allocation2":"0",
    "total":"14131",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":2182,
    "nom_corrige2":"Jacques Bogenez",
    "nom_famille":"Bogenez",
    "titre_genre2":"Conseiller",
    "remuneration":"9391",
    "allocation":"4695",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14086",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":2183,
    "nom_corrige2":"André Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"9108",
    "allocation":"3975",
    "remuneration2":"658,00$",
    "allocation2":"329,00$",
    "total":"14070",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":2184,
    "nom_corrige2":"Clément Pratte",
    "nom_famille":"Pratte",
    "titre_genre2":"Conseiller",
    "remuneration":"9374",
    "allocation":"4687",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14061",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":2185,
    "nom_corrige2":"Daniel Duchemin",
    "nom_famille":"Duchemin",
    "titre_genre2":"Conseiller",
    "remuneration":"9374",
    "allocation":"4687",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14061",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":2186,
    "nom_corrige2":"Jacques Trépanier",
    "nom_famille":"Trépanier",
    "titre_genre2":"Conseiller",
    "remuneration":"9374",
    "allocation":"4687",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14061",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":2187,
    "nom_corrige2":"Jean-Guy Mongrain",
    "nom_famille":"Mongrain",
    "titre_genre2":"Conseiller",
    "remuneration":"9374",
    "allocation":"4687",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14061",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":2188,
    "nom_corrige2":"Julie Régis",
    "nom_famille":"Régis",
    "titre_genre2":"Conseillère",
    "remuneration":"9374",
    "allocation":"4687",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14061",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":2189,
    "nom_corrige2":"Marylène Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseillère",
    "remuneration":"9374",
    "allocation":"4687",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14061",
    "ville":"Notre-Dame-du-Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"6585"
  },
  {
    "ID":2190,
    "nom_corrige2":"Claudette Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Mairesse",
    "remuneration":"7600",
    "allocation":"3800",
    "remuneration2":"2639",
    "allocation2":"0",
    "total":"14039",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":2191,
    "nom_corrige2":"Richard Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Maire",
    "remuneration":"9333",
    "allocation":"4667",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"14000",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":2192,
    "nom_corrige2":"Gilles Arbour",
    "nom_famille":"Arbour",
    "titre_genre2":"Conseiller",
    "remuneration":"9333",
    "allocation":"4666",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13999",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":2193,
    "nom_corrige2":"Mélanie Laberge",
    "nom_famille":"Laberge",
    "titre_genre2":"Conseillère",
    "remuneration":"9333",
    "allocation":"4666",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13999",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":2194,
    "nom_corrige2":"Marilyne Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseillère",
    "remuneration":"9333",
    "allocation":"4666",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13999",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":2195,
    "nom_corrige2":"Serge Forest",
    "nom_famille":"Forest",
    "titre_genre2":"Conseiller",
    "remuneration":"9333",
    "allocation":"4666",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13999",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":2196,
    "nom_corrige2":"Yanick Langlais",
    "nom_famille":"Langlais",
    "titre_genre2":"Conseiller",
    "remuneration":"9333",
    "allocation":"4666",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13999",
    "ville":"Sainte-Marcelline-de-Kildare",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1867"
  },
  {
    "ID":2197,
    "nom_corrige2":"Sylvie Cassar",
    "nom_famille":"Cassar",
    "titre_genre2":"Conseillère",
    "remuneration":"9331",
    "allocation":"4665",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13996",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":2198,
    "nom_corrige2":"Frédéric Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Maire",
    "remuneration":"9327",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13990",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":2199,
    "nom_corrige2":"Caroline Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Conseillère",
    "remuneration":"9326",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13989",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":2200,
    "nom_corrige2":"Helen Morrison",
    "nom_famille":"Morrison",
    "titre_genre2":"Conseillère",
    "remuneration":"9326",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13989",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":2201,
    "nom_corrige2":"Louis Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseiller",
    "remuneration":"9326",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13989",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":2202,
    "nom_corrige2":"Sylvain Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"9326",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13989",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":2203,
    "nom_corrige2":"Jean Sébastien Vaillancourt",
    "nom_famille":"Sébastien Vaillancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"9326",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13989",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":2204,
    "nom_corrige2":"Bernard Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Maire",
    "remuneration":"9326",
    "allocation":"4663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13989",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":2205,
    "nom_corrige2":"Roger Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Maire",
    "remuneration":"9319",
    "allocation":"4659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13978",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":2206,
    "nom_corrige2":"Frédéric Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"9316",
    "allocation":"4658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13974",
    "ville":"Lambton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1732"
  },
  {
    "ID":2207,
    "nom_corrige2":"Sylvie Coulombe",
    "nom_famille":"Coulombe",
    "titre_genre2":"Mairesse",
    "remuneration":"9313",
    "allocation":"4657",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13970",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":2208,
    "nom_corrige2":"Denis Pagé",
    "nom_famille":"Pagé",
    "titre_genre2":"Conseiller",
    "remuneration":"9267",
    "allocation":"4633",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13900",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":2209,
    "nom_corrige2":"Michaël Otis",
    "nom_famille":"Otis",
    "titre_genre2":"Maire",
    "remuneration":"8323",
    "allocation":"4162",
    "remuneration2":"941,00$",
    "allocation2":"472,00$",
    "total":"13898",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":2210,
    "nom_corrige2":"Jacques Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseiller",
    "remuneration":"9231",
    "allocation":"4665",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13896",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":2211,
    "nom_corrige2":"Roger Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Maire",
    "remuneration":"6115",
    "allocation":"3058",
    "remuneration2":"3148",
    "allocation2":"1574",
    "total":"13895",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":2212,
    "nom_corrige2":"Bertrand Quesnel",
    "nom_famille":"Quesnel",
    "titre_genre2":"Conseiller",
    "remuneration":"9262",
    "allocation":"4631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13893",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":2213,
    "nom_corrige2":"Carolyne Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"9262",
    "allocation":"4631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13893",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":2214,
    "nom_corrige2":"Denise Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"9262",
    "allocation":"4631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13893",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":2215,
    "nom_corrige2":"Mireille Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseillère",
    "remuneration":"9262",
    "allocation":"4631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13893",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":2216,
    "nom_corrige2":"René De la Sablonnière",
    "nom_famille":"De la Sablonnière",
    "titre_genre2":"Conseiller",
    "remuneration":"9262",
    "allocation":"4631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13893",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":2217,
    "nom_corrige2":"Christine Bleau",
    "nom_famille":"Bleau",
    "titre_genre2":"Conseillère",
    "remuneration":"9213",
    "allocation":"4607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13820",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":2218,
    "nom_corrige2":"Ghislain Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseiller",
    "remuneration":"9213",
    "allocation":"4607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13820",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":2219,
    "nom_corrige2":"Mario Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"9213",
    "allocation":"4607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13820",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":2220,
    "nom_corrige2":"Marthe Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseillère",
    "remuneration":"9213",
    "allocation":"4607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13820",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":2221,
    "nom_corrige2":"Serge Brault",
    "nom_famille":"Brault",
    "titre_genre2":"Conseiller",
    "remuneration":"9213",
    "allocation":"4607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13820",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":2222,
    "nom_corrige2":"David Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseiller",
    "remuneration":"9213",
    "allocation":"4607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13820",
    "ville":"Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4169"
  },
  {
    "ID":2223,
    "nom_corrige2":"Lisa Cadorette",
    "nom_famille":"Cadorette",
    "titre_genre2":"Conseillère",
    "remuneration":"8607",
    "allocation":"4303",
    "remuneration2":"600,00$",
    "allocation2":"300,00$",
    "total":"13810",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":2224,
    "nom_corrige2":"Daniel Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"9325",
    "allocation":"4461",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13786",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":2225,
    "nom_corrige2":"Anik Korosec",
    "nom_famille":"Korosec",
    "titre_genre2":"Conseillère",
    "remuneration":"9326",
    "allocation":"4460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13786",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":2226,
    "nom_corrige2":"Anselmo Marandola",
    "nom_famille":"Marandola",
    "titre_genre2":"Conseiller",
    "remuneration":"9326",
    "allocation":"4460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13786",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":2227,
    "nom_corrige2":"Shirley Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"9326",
    "allocation":"4460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13786",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":2228,
    "nom_corrige2":"Sakina Khan",
    "nom_famille":"Khan",
    "titre_genre2":"Conseillère",
    "remuneration":"9325",
    "allocation":"4461",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13786",
    "ville":"Gore",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2686"
  },
  {
    "ID":2229,
    "nom_corrige2":"Simon Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Maire",
    "remuneration":"9174",
    "allocation":"4587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13761",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"416"
  },
  {
    "ID":2230,
    "nom_corrige2":"Gilles Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseiller",
    "remuneration":"8925",
    "allocation":"4462",
    "remuneration2":"245,00$",
    "allocation2":"123,00$",
    "total":"13755",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":2231,
    "nom_corrige2":"Michel Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseiller",
    "remuneration":"9168",
    "allocation":"4584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13752",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":2232,
    "nom_corrige2":"Audrey Marie Sergerie",
    "nom_famille":"Marie Sergerie",
    "titre_genre2":"Conseillère",
    "remuneration":"9168",
    "allocation":"4584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13752",
    "ville":"Saint-Jean-Baptiste",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3359"
  },
  {
    "ID":2233,
    "nom_corrige2":"Yannick Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"8889",
    "allocation":"4445",
    "remuneration2":"264,00$",
    "allocation2":"132,00$",
    "total":"13730",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":2234,
    "nom_corrige2":"Sylvain Ouimet",
    "nom_famille":"Ouimet",
    "titre_genre2":"Conseiller",
    "remuneration":"9146",
    "allocation":"4573",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13719",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":2235,
    "nom_corrige2":"Chantal Nault",
    "nom_famille":"Nault",
    "titre_genre2":"Conseillère",
    "remuneration":"9137",
    "allocation":"",
    "remuneration2":"4569",
    "allocation2":"0",
    "total":"13706",
    "ville":"Saint-Germain-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"5075"
  },
  {
    "ID":2236,
    "nom_corrige2":"Patrice Boislard",
    "nom_famille":"Boislard",
    "titre_genre2":"Conseiller",
    "remuneration":"9137",
    "allocation":"",
    "remuneration2":"4569",
    "allocation2":"0",
    "total":"13706",
    "ville":"Saint-Germain-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"5075"
  },
  {
    "ID":2237,
    "nom_corrige2":"Sarah McAlden",
    "nom_famille":"McAlden",
    "titre_genre2":"Conseillère",
    "remuneration":"9137",
    "allocation":"",
    "remuneration2":"4569",
    "allocation2":"0",
    "total":"13706",
    "ville":"Saint-Germain-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"5075"
  },
  {
    "ID":2238,
    "nom_corrige2":"Sylvain Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"9137",
    "allocation":"",
    "remuneration2":"4569",
    "allocation2":"0",
    "total":"13706",
    "ville":"Saint-Germain-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"5075"
  },
  {
    "ID":2239,
    "nom_corrige2":"Pascal Frappier",
    "nom_famille":"Frappier",
    "titre_genre2":"Conseiller",
    "remuneration":"9132",
    "allocation":"4560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13692",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":2240,
    "nom_corrige2":"Marc Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"9132",
    "allocation":"4560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13692",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":2241,
    "nom_corrige2":"Michel Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"9132",
    "allocation":"4560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13692",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":2242,
    "nom_corrige2":"Sophie Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseillère",
    "remuneration":"9132",
    "allocation":"4560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13692",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":2243,
    "nom_corrige2":"Véronique Filion",
    "nom_famille":"Filion",
    "titre_genre2":"Conseillère",
    "remuneration":"9132",
    "allocation":"4560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13692",
    "ville":"Saint-André-Avellin",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"4145"
  },
  {
    "ID":2244,
    "nom_corrige2":"André Legros",
    "nom_famille":"Legros",
    "titre_genre2":"Conseiller",
    "remuneration":"9127",
    "allocation":"4564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13691",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":2245,
    "nom_corrige2":"Jules Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Maire",
    "remuneration":"9114",
    "allocation":"4557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13671",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":2246,
    "nom_corrige2":"Yvon Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseiller",
    "remuneration":"6784",
    "allocation":"3392",
    "remuneration2":"3000",
    "allocation2":"492,00$",
    "total":"13668",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":2247,
    "nom_corrige2":"Andrée Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Mairesse",
    "remuneration":"9029",
    "allocation":"4598",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13627",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":2248,
    "nom_corrige2":"Rémi Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"8872",
    "allocation":"4436",
    "remuneration2":"207,00$",
    "allocation2":"104,00$",
    "total":"13619",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":2249,
    "nom_corrige2":"André Ste-Marie",
    "nom_famille":"Ste-Marie",
    "titre_genre2":"Conseiller",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"5463",
    "allocation2":"2146",
    "total":"13609",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":2250,
    "nom_corrige2":"Gino Canuel",
    "nom_famille":"Canuel",
    "titre_genre2":"Maire",
    "remuneration":"9209",
    "allocation":"4380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13589",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":2251,
    "nom_corrige2":"Nicole Généreux",
    "nom_famille":"Généreux",
    "titre_genre2":"Mairesse",
    "remuneration":"6765",
    "allocation":"3145",
    "remuneration2":"2446",
    "allocation2":"1223",
    "total":"13579",
    "ville":"Saint-Denis-De La Bouteillerie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"517"
  },
  {
    "ID":2252,
    "nom_corrige2":"Catherine Venne",
    "nom_famille":"Venne",
    "titre_genre2":"Conseillère",
    "remuneration":"9043",
    "allocation":"4522",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13565",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":2253,
    "nom_corrige2":"Bertrand Taillefer",
    "nom_famille":"Taillefer",
    "titre_genre2":"Conseiller",
    "remuneration":"9246",
    "allocation":"4310",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13556",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":2254,
    "nom_corrige2":"Katherine Ramacieri l'Heureux",
    "nom_famille":"Ramacieri l'Heureux",
    "titre_genre2":"Conseillère",
    "remuneration":"9033",
    "allocation":"4516",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13549",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":2255,
    "nom_corrige2":"Marie-Claude Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"13376",
    "allocation":"133,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13509",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":2256,
    "nom_corrige2":"Michel Rhéaume",
    "nom_famille":"Rhéaume",
    "titre_genre2":"Conseiller",
    "remuneration":"8995",
    "allocation":"4497",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13492",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":2257,
    "nom_corrige2":"Luc Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"10163",
    "allocation":"3328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13491",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":2258,
    "nom_corrige2":"Steeves Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Conseiller",
    "remuneration":"8984",
    "allocation":"4492",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13476",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":2259,
    "nom_corrige2":"Sylvain Dansereau",
    "nom_famille":"Dansereau",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"1115",
    "allocation2":"558,00$",
    "total":"13448",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":2260,
    "nom_corrige2":"Stéphane Laplante",
    "nom_famille":"Laplante",
    "titre_genre2":"Conseiller",
    "remuneration":"8963",
    "allocation":"4482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13445",
    "ville":"Sainte-Catherine-de-Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2907"
  },
  {
    "ID":2261,
    "nom_corrige2":"Greg Vaughan",
    "nom_famille":"Vaughan",
    "titre_genre2":"Maire",
    "remuneration":"9086",
    "allocation":"4346",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13432",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":2262,
    "nom_corrige2":"Francis Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"8954",
    "allocation":"4477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13431",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":2263,
    "nom_corrige2":"Jocelyn Brière",
    "nom_famille":"Brière",
    "titre_genre2":"Conseiller",
    "remuneration":"4807",
    "allocation":"2404",
    "remuneration2":"4140",
    "allocation2":"2070",
    "total":"13421",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":2264,
    "nom_corrige2":"Michel Colpron",
    "nom_famille":"Colpron",
    "titre_genre2":"Maire",
    "remuneration":"8940",
    "allocation":"4464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13404",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":2265,
    "nom_corrige2":"Mario Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Maire",
    "remuneration":"4930",
    "allocation":"2465",
    "remuneration2":"5933",
    "allocation2":"59,00$",
    "total":"13387",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":2266,
    "nom_corrige2":"Jonathan Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"8807",
    "allocation":"4404",
    "remuneration2":"111,00$",
    "allocation2":"55,00$",
    "total":"13377",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2267,
    "nom_corrige2":"Denis Langlois",
    "nom_famille":"Langlois",
    "titre_genre2":"Conseiller",
    "remuneration":"8917",
    "allocation":"4459",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13376",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":2268,
    "nom_corrige2":"François Beaudin",
    "nom_famille":"Beaudin",
    "titre_genre2":"Conseiller",
    "remuneration":"8917",
    "allocation":"4459",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13376",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":2269,
    "nom_corrige2":"Jo-Annie Castilloux",
    "nom_famille":"Castilloux",
    "titre_genre2":"Conseillère",
    "remuneration":"8917",
    "allocation":"4459",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13376",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":2270,
    "nom_corrige2":"Marc-Aurèle Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"8917",
    "allocation":"4459",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13376",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":2271,
    "nom_corrige2":"Marie-Ève Allain",
    "nom_famille":"Allain",
    "titre_genre2":"Conseillère",
    "remuneration":"8917",
    "allocation":"4459",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13376",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":2272,
    "nom_corrige2":"Sylvie Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"8917",
    "allocation":"4459",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13376",
    "ville":"Port-Daniel–Gascons",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2276"
  },
  {
    "ID":2273,
    "nom_corrige2":"Eric Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"8917",
    "allocation":"4458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13375",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":2274,
    "nom_corrige2":"Alain Gaucher",
    "nom_famille":"Gaucher",
    "titre_genre2":"Conseiller",
    "remuneration":"8917",
    "allocation":"4458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13375",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":2275,
    "nom_corrige2":"Alexandre Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"8917",
    "allocation":"4458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13375",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":2276,
    "nom_corrige2":"Jade Choinière-Pinard",
    "nom_famille":"Choinière-Pinard",
    "titre_genre2":"Conseillère",
    "remuneration":"8917",
    "allocation":"4458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13375",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":2277,
    "nom_corrige2":"Pierre Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"1064",
    "allocation2":"532,00$",
    "total":"13371",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":2278,
    "nom_corrige2":"Eric Belzile",
    "nom_famille":"Belzile",
    "titre_genre2":"Conseiller",
    "remuneration":"8889",
    "allocation":"4445",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13334",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":2279,
    "nom_corrige2":"Johanne Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"8889",
    "allocation":"4445",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13334",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":2280,
    "nom_corrige2":"Maurice Vaney",
    "nom_famille":"Vaney",
    "titre_genre2":"Conseiller",
    "remuneration":"8889",
    "allocation":"4445",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13334",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":2281,
    "nom_corrige2":"Steve Cote",
    "nom_famille":"Cote",
    "titre_genre2":"Conseiller",
    "remuneration":"8889",
    "allocation":"4445",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13334",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":2282,
    "nom_corrige2":"Claudia Lagacé",
    "nom_famille":"Lagacé",
    "titre_genre2":"Conseillère",
    "remuneration":"8888",
    "allocation":"4445",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13333",
    "ville":"Trois-Pistoles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3172"
  },
  {
    "ID":2283,
    "nom_corrige2":"Robert Laperrière",
    "nom_famille":"Laperrière",
    "titre_genre2":"Conseiller",
    "remuneration":"9996",
    "allocation":"3328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13324",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":2284,
    "nom_corrige2":"Anne-Sophie Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"8876",
    "allocation":"4438",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13314",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":2285,
    "nom_corrige2":"Luc Bertrand",
    "nom_famille":"Bertrand",
    "titre_genre2":"Conseiller",
    "remuneration":"8876",
    "allocation":"4438",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13314",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":2286,
    "nom_corrige2":"Serge Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"8876",
    "allocation":"4438",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13314",
    "ville":"Neuville",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"4618"
  },
  {
    "ID":2287,
    "nom_corrige2":"Stéphane Baillargeon",
    "nom_famille":"Baillargeon",
    "titre_genre2":"Conseiller",
    "remuneration":"8607",
    "allocation":"4303",
    "remuneration2":"400,00$",
    "allocation2":"0",
    "total":"13310",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":2288,
    "nom_corrige2":"Alain Laprade",
    "nom_famille":"Laprade",
    "titre_genre2":"Conseiller",
    "remuneration":"8873",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13309",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":2289,
    "nom_corrige2":"Christine Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseillère",
    "remuneration":"8873",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13309",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":2290,
    "nom_corrige2":"Isabelle Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"8873",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13309",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":2291,
    "nom_corrige2":"Patrick Delforge",
    "nom_famille":"Delforge",
    "titre_genre2":"Conseiller",
    "remuneration":"8873",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13309",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":2292,
    "nom_corrige2":"Isabelle Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Conseillère",
    "remuneration":"8872",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13308",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":2293,
    "nom_corrige2":"Josée Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Conseillère",
    "remuneration":"8872",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13308",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":2294,
    "nom_corrige2":"François Bérubé-Gagné",
    "nom_famille":"Bérubé-Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"8872",
    "allocation":"4436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13308",
    "ville":"Saint-Pascal",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"3536"
  },
  {
    "ID":2295,
    "nom_corrige2":"Gaston Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"8748",
    "allocation":"4374",
    "remuneration2":"176,00$",
    "allocation2":"0",
    "total":"13298",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":2296,
    "nom_corrige2":"Daniel Blier",
    "nom_famille":"Blier",
    "titre_genre2":"Conseiller",
    "remuneration":"7989",
    "allocation":"3995",
    "remuneration2":"1178",
    "allocation2":"131,00$",
    "total":"13293",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":2297,
    "nom_corrige2":"Daniel Leboeuf",
    "nom_famille":"Leboeuf",
    "titre_genre2":"Maire",
    "remuneration":"8765",
    "allocation":"3078",
    "remuneration2":"941,00$",
    "allocation2":"470,00$",
    "total":"13254",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2298,
    "nom_corrige2":"Normand Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"8830",
    "allocation":"4415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13245",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":2299,
    "nom_corrige2":"Jocelyn Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"8830",
    "allocation":"4415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13245",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":2300,
    "nom_corrige2":"Michel Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Conseiller",
    "remuneration":"8830",
    "allocation":"4415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13245",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":2301,
    "nom_corrige2":"Pierre-Olivier Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"8830",
    "allocation":"4415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13245",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":2302,
    "nom_corrige2":"Éric Blanchette-Ouellet",
    "nom_famille":"Blanchette-Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"8830",
    "allocation":"4415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13245",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":2303,
    "nom_corrige2":"Michel Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Maire",
    "remuneration":"6636",
    "allocation":"2923",
    "remuneration2":"2573",
    "allocation2":"1112",
    "total":"13244",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":2304,
    "nom_corrige2":"Denis Pérusse",
    "nom_famille":"Pérusse",
    "titre_genre2":"Conseiller",
    "remuneration":"8823",
    "allocation":"4412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13235",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":2305,
    "nom_corrige2":"Ghislain Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"8823",
    "allocation":"4412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13235",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":2306,
    "nom_corrige2":"Jessika Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseillère",
    "remuneration":"8823",
    "allocation":"4412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13235",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":2307,
    "nom_corrige2":"Marc Legros",
    "nom_famille":"Legros",
    "titre_genre2":"Conseiller",
    "remuneration":"8823",
    "allocation":"4412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13235",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":2308,
    "nom_corrige2":"Suzanne Croteau",
    "nom_famille":"Croteau",
    "titre_genre2":"Conseillère",
    "remuneration":"8823",
    "allocation":"4412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13235",
    "ville":"Laurier-Station",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2759"
  },
  {
    "ID":2309,
    "nom_corrige2":"Danye Anctil",
    "nom_famille":"Anctil",
    "titre_genre2":"Mairesse",
    "remuneration":"5297",
    "allocation":"2648",
    "remuneration2":"3527",
    "allocation2":"1763",
    "total":"13235",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":2310,
    "nom_corrige2":"Joel Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Conseiller",
    "remuneration":"8821",
    "allocation":"4410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13231",
    "ville":"Saint-Damien",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2528"
  },
  {
    "ID":2311,
    "nom_corrige2":"Francis Cassidy",
    "nom_famille":"Cassidy",
    "titre_genre2":"Conseiller",
    "remuneration":"8813",
    "allocation":"4407",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13220",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":2312,
    "nom_corrige2":"Mona S. Morin",
    "nom_famille":"S. Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"10780",
    "allocation":"2434",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13214",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":2313,
    "nom_corrige2":"Allyson Cahill-Vibert",
    "nom_famille":"Cahill-Vibert",
    "titre_genre2":"Conseillère",
    "remuneration":"8807",
    "allocation":"4404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13211",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2314,
    "nom_corrige2":"Gaétane Hautcoeur",
    "nom_famille":"Hautcoeur",
    "titre_genre2":"Conseillère",
    "remuneration":"8807",
    "allocation":"4404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13211",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2315,
    "nom_corrige2":"Michel Rail",
    "nom_famille":"Rail",
    "titre_genre2":"Conseiller",
    "remuneration":"8807",
    "allocation":"4404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13211",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2316,
    "nom_corrige2":"Shanna Roussy",
    "nom_famille":"Roussy",
    "titre_genre2":"Conseillère",
    "remuneration":"8807",
    "allocation":"4404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13211",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2317,
    "nom_corrige2":"Yannick Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"8807",
    "allocation":"4404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13211",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":2318,
    "nom_corrige2":"Nathalie Gamelin",
    "nom_famille":"Gamelin",
    "titre_genre2":"Conseillère",
    "remuneration":"6316",
    "allocation":"6018",
    "remuneration2":"570,00$",
    "allocation2":"285,00$",
    "total":"13189",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":2319,
    "nom_corrige2":"Jules Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Maire",
    "remuneration":"8786",
    "allocation":"4393",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13179",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":2320,
    "nom_corrige2":"Cindy Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseillère",
    "remuneration":"8514",
    "allocation":"4632",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13146",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":2321,
    "nom_corrige2":"Jacques Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Maire",
    "remuneration":"8761",
    "allocation":"4380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13141",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":2322,
    "nom_corrige2":"Marie-Claude Larose Létourneau",
    "nom_famille":"Larose Létourneau",
    "titre_genre2":"Conseillère",
    "remuneration":"8741",
    "allocation":"4370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13111",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":2323,
    "nom_corrige2":"Pierre Brosseau",
    "nom_famille":"Brosseau",
    "titre_genre2":"Maire",
    "remuneration":"7077",
    "allocation":"3411",
    "remuneration2":"1743",
    "allocation2":"871,00$",
    "total":"13102",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":2324,
    "nom_corrige2":"Hélène Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"8607",
    "allocation":"4303",
    "remuneration2":"124,00$",
    "allocation2":"62,00$",
    "total":"13096",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":2325,
    "nom_corrige2":"Sophie Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseillère",
    "remuneration":"8535",
    "allocation":"4267",
    "remuneration2":"173,00$",
    "allocation2":"87,00$",
    "total":"13062",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":2326,
    "nom_corrige2":"Dominic Lampron",
    "nom_famille":"Lampron",
    "titre_genre2":"Conseiller",
    "remuneration":"8710",
    "allocation":"4335",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13045",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":2327,
    "nom_corrige2":"Natacha G. Tremblay",
    "nom_famille":"G. Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"7394",
    "allocation":"3697",
    "remuneration2":"1295",
    "allocation2":"647,00$",
    "total":"13033",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":2328,
    "nom_corrige2":"Najat Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"8686",
    "allocation":"4341",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"13027",
    "ville":"Saint-Honoré",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"6875"
  },
  {
    "ID":2329,
    "nom_corrige2":"Gaétan Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"8514",
    "allocation":"4482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12996",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":2330,
    "nom_corrige2":"Neil Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Maire",
    "remuneration":"9012",
    "allocation":"3978",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12990",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":2331,
    "nom_corrige2":"Christian Brault",
    "nom_famille":"Brault",
    "titre_genre2":"Conseiller",
    "remuneration":"8630",
    "allocation":"4315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12945",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":2332,
    "nom_corrige2":"André Lafrenière",
    "nom_famille":"Lafrenière",
    "titre_genre2":"Conseiller",
    "remuneration":"8621",
    "allocation":"4310",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12931",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":2333,
    "nom_corrige2":"Julie-Anne Cousineau",
    "nom_famille":"Cousineau",
    "titre_genre2":"Conseillère",
    "remuneration":"8621",
    "allocation":"4310",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12931",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":2334,
    "nom_corrige2":"Lucie Vignola",
    "nom_famille":"Vignola",
    "titre_genre2":"Conseillère",
    "remuneration":"8621",
    "allocation":"4310",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12931",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":2335,
    "nom_corrige2":"Jacques Bourassa",
    "nom_famille":"Bourassa",
    "titre_genre2":"Conseiller",
    "remuneration":"8621",
    "allocation":"4310",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12931",
    "ville":"Notre-Dame-de-la-Merci",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1126"
  },
  {
    "ID":2336,
    "nom_corrige2":"Philip Tétrault",
    "nom_famille":"Tétrault",
    "titre_genre2":"Maire",
    "remuneration":"8618",
    "allocation":"4309",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12927",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":2337,
    "nom_corrige2":"Julien Bussières",
    "nom_famille":"Bussières",
    "titre_genre2":"Conseiller",
    "remuneration":"9137",
    "allocation":"3789",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12926",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":2338,
    "nom_corrige2":"Alain Rondeau",
    "nom_famille":"Rondeau",
    "titre_genre2":"Conseiller",
    "remuneration":"8607",
    "allocation":"4303",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12910",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":2339,
    "nom_corrige2":"Gina Castelli",
    "nom_famille":"Castelli",
    "titre_genre2":"Conseillère",
    "remuneration":"8607",
    "allocation":"4303",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12910",
    "ville":"Ascot Corner",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3586"
  },
  {
    "ID":2340,
    "nom_corrige2":"Philippe Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"8602",
    "allocation":"4301",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12903",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":2341,
    "nom_corrige2":"Annie Dubeau",
    "nom_famille":"Dubeau",
    "titre_genre2":"Conseillère",
    "remuneration":"8602",
    "allocation":"4301",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12903",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":2342,
    "nom_corrige2":"Daniel Dodier",
    "nom_famille":"Dodier",
    "titre_genre2":"Conseiller",
    "remuneration":"8587",
    "allocation":"4293",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12880",
    "ville":"Stoke",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3267"
  },
  {
    "ID":2343,
    "nom_corrige2":"Sylvain Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"8585",
    "allocation":"4293",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12878",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":2344,
    "nom_corrige2":"Lyne Ash",
    "nom_famille":"Ash",
    "titre_genre2":"Mairesse",
    "remuneration":"5216",
    "allocation":"2608",
    "remuneration2":"3378",
    "allocation2":"1674",
    "total":"12876",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":2345,
    "nom_corrige2":"Charles Plourdes",
    "nom_famille":"Plourdes",
    "titre_genre2":"Conseiller",
    "remuneration":"8567",
    "allocation":"4284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12851",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":2346,
    "nom_corrige2":"Camil Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Maire",
    "remuneration":"7202",
    "allocation":"2914",
    "remuneration2":"1819",
    "allocation2":"910,00$",
    "total":"12845",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":2347,
    "nom_corrige2":"Yves Gnocchini",
    "nom_famille":"Gnocchini",
    "titre_genre2":"Conseiller",
    "remuneration":"8815",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12823",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2733"
  },
  {
    "ID":2348,
    "nom_corrige2":"Fernand Major",
    "nom_famille":"Major",
    "titre_genre2":"Maire",
    "remuneration":"8016",
    "allocation":"4008",
    "remuneration2":"529,00$",
    "allocation2":"265,00$",
    "total":"12818",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":2349,
    "nom_corrige2":"Danny Quesnel",
    "nom_famille":"Quesnel",
    "titre_genre2":"Conseiller",
    "remuneration":"8543",
    "allocation":"4272",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12815",
    "ville":"Saint-Alexis",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1487"
  },
  {
    "ID":2350,
    "nom_corrige2":"Myriam Bruneau",
    "nom_famille":"Bruneau",
    "titre_genre2":"Conseillère",
    "remuneration":"8514",
    "allocation":"4257",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12771",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":2351,
    "nom_corrige2":"Marie-Claude Tétreault",
    "nom_famille":"Tétreault",
    "titre_genre2":"Conseillère",
    "remuneration":"8957",
    "allocation":"3789",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12746",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":2352,
    "nom_corrige2":"Matthew MacDonald-Charbonneau",
    "nom_famille":"MacDonald-Charbonneau",
    "titre_genre2":"Maire",
    "remuneration":"8479",
    "allocation":"4240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12719",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":2353,
    "nom_corrige2":"Laurence Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Conseillère",
    "remuneration":"8468",
    "allocation":"4234",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12702",
    "ville":"Saint-Blaise-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2165"
  },
  {
    "ID":2354,
    "nom_corrige2":"Éric Payette",
    "nom_famille":"Payette",
    "titre_genre2":"Conseiller",
    "remuneration":"8304",
    "allocation":"4377",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12681",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":2355,
    "nom_corrige2":"André-Marcel Évoquez",
    "nom_famille":"Évoquez",
    "titre_genre2":"Maire",
    "remuneration":"8453",
    "allocation":"4227",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12680",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":2356,
    "nom_corrige2":"Jean-Louis Soulard",
    "nom_famille":"Soulard",
    "titre_genre2":"Maire suppléant",
    "remuneration":"7992",
    "allocation":"3996",
    "remuneration2":"437,00$",
    "allocation2":"218,00$",
    "total":"12643",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":2357,
    "nom_corrige2":"Daniel Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Conseiller",
    "remuneration":"8137",
    "allocation":"4069",
    "remuneration2":"428,00$",
    "allocation2":"0",
    "total":"12634",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":2358,
    "nom_corrige2":"Sylvain Loiselle",
    "nom_famille":"Loiselle",
    "titre_genre2":"Conseiller",
    "remuneration":"8137",
    "allocation":"4069",
    "remuneration2":"428,00$",
    "allocation2":"0",
    "total":"12634",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":2359,
    "nom_corrige2":"Annick Lévellé",
    "nom_famille":"Lévellé",
    "titre_genre2":"Conseillère",
    "remuneration":"8137",
    "allocation":"4069",
    "remuneration2":"428,00$",
    "allocation2":"0",
    "total":"12634",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":2360,
    "nom_corrige2":"Audrey Mailhot",
    "nom_famille":"Mailhot",
    "titre_genre2":"Conseillère",
    "remuneration":"8410",
    "allocation":"4205",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12615",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":2361,
    "nom_corrige2":"Daniel Braun",
    "nom_famille":"Braun",
    "titre_genre2":"Conseiller",
    "remuneration":"8410",
    "allocation":"4205",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12615",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":2362,
    "nom_corrige2":"Martial Matteau",
    "nom_famille":"Matteau",
    "titre_genre2":"Conseiller",
    "remuneration":"8400",
    "allocation":"4200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12600",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":2363,
    "nom_corrige2":"Alain Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseiller",
    "remuneration":"8400",
    "allocation":"4200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12600",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":2364,
    "nom_corrige2":"Claude Jolicoeur",
    "nom_famille":"Jolicoeur",
    "titre_genre2":"Conseiller",
    "remuneration":"8400",
    "allocation":"4200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12600",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":2365,
    "nom_corrige2":"Daniel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"8400",
    "allocation":"4200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12600",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":2366,
    "nom_corrige2":"Germain Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"8400",
    "allocation":"4200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12600",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":2367,
    "nom_corrige2":"Jean-François Marois",
    "nom_famille":"Marois",
    "titre_genre2":"Conseiller",
    "remuneration":"8400",
    "allocation":"4200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12600",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2389"
  },
  {
    "ID":2368,
    "nom_corrige2":"Alan Pavilanis",
    "nom_famille":"Pavilanis",
    "titre_genre2":"Conseiller",
    "remuneration":"8397",
    "allocation":"4198",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12595",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":2369,
    "nom_corrige2":"Carole Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseillère",
    "remuneration":"8397",
    "allocation":"4198",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12595",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":2370,
    "nom_corrige2":"Lynda Graham",
    "nom_famille":"Graham",
    "titre_genre2":"Conseillère",
    "remuneration":"8397",
    "allocation":"4198",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12595",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":2371,
    "nom_corrige2":"Marc-André Blain",
    "nom_famille":"Blain",
    "titre_genre2":"Conseiller",
    "remuneration":"8397",
    "allocation":"4198",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12595",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":2372,
    "nom_corrige2":"Marie-José Auclair",
    "nom_famille":"Auclair",
    "titre_genre2":"Conseillère",
    "remuneration":"8397",
    "allocation":"4198",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12595",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":2373,
    "nom_corrige2":"Éric Sauvageau",
    "nom_famille":"Sauvageau",
    "titre_genre2":"Conseiller",
    "remuneration":"8390",
    "allocation":"4195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12585",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":2374,
    "nom_corrige2":"Gaétan Garneau",
    "nom_famille":"Garneau",
    "titre_genre2":"Conseiller",
    "remuneration":"8390",
    "allocation":"4195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12585",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":2375,
    "nom_corrige2":"Martin Renauld",
    "nom_famille":"Renauld",
    "titre_genre2":"Conseiller",
    "remuneration":"8390",
    "allocation":"4195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12585",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":2376,
    "nom_corrige2":"Marianne Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseillère",
    "remuneration":"8390",
    "allocation":"4195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12585",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":2377,
    "nom_corrige2":"Jean Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"8390",
    "allocation":"4195",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12585",
    "ville":"Deschambault-Grondines",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2270"
  },
  {
    "ID":2378,
    "nom_corrige2":"Nathalie Fillion",
    "nom_famille":"Fillion",
    "titre_genre2":"Conseillère",
    "remuneration":"8316",
    "allocation":"4158",
    "remuneration2":"109,00$",
    "allocation2":"0",
    "total":"12583",
    "ville":"Verchères",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"5832"
  },
  {
    "ID":2379,
    "nom_corrige2":"Jean-Sébastien Béliveau",
    "nom_famille":"Béliveau",
    "titre_genre2":"Conseiller",
    "remuneration":"8388",
    "allocation":"4194",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12582",
    "ville":"Saint-Denis-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5087"
  },
  {
    "ID":2380,
    "nom_corrige2":"Sébastien Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseiller",
    "remuneration":"11580",
    "allocation":"971,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12551",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":2381,
    "nom_corrige2":"Jean-Claude Tremblay Junior",
    "nom_famille":"Tremblay Junior",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4795",
    "allocation":"2372",
    "remuneration2":"3561",
    "allocation2":"1781",
    "total":"12509",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":2382,
    "nom_corrige2":"Paquerette Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Mairesse",
    "remuneration":"8337",
    "allocation":"4169",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12506",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":2383,
    "nom_corrige2":"Claudia Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseillère",
    "remuneration":"8333",
    "allocation":"4167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12500",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":2384,
    "nom_corrige2":"Geneviève Henry",
    "nom_famille":"Henry",
    "titre_genre2":"Conseillère",
    "remuneration":"8333",
    "allocation":"4167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12500",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":2385,
    "nom_corrige2":"Jacques Robitaille",
    "nom_famille":"Robitaille",
    "titre_genre2":"Conseiller",
    "remuneration":"8333",
    "allocation":"4167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12500",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":2386,
    "nom_corrige2":"Marie Ouellette",
    "nom_famille":"Ouellette",
    "titre_genre2":"Conseillère",
    "remuneration":"8333",
    "allocation":"4167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12500",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":2387,
    "nom_corrige2":"Maurice Marchand",
    "nom_famille":"Marchand",
    "titre_genre2":"Conseiller",
    "remuneration":"8333",
    "allocation":"4167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12500",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":2388,
    "nom_corrige2":"Agnès Derouin Plourde",
    "nom_famille":"Derouin Plourde",
    "titre_genre2":"Conseillère",
    "remuneration":"8333",
    "allocation":"4167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12500",
    "ville":"Saint-Thomas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3596"
  },
  {
    "ID":2389,
    "nom_corrige2":"Caroline Champoux",
    "nom_famille":"Champoux",
    "titre_genre2":"Conseillère",
    "remuneration":"9130",
    "allocation":"3328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12458",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":2390,
    "nom_corrige2":"Roxane Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"8286",
    "allocation":"4143",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12429",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":2391,
    "nom_corrige2":"Marcel Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Maire",
    "remuneration":"8279",
    "allocation":"4139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12418",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":2392,
    "nom_corrige2":"Patrick Barry",
    "nom_famille":"Barry",
    "titre_genre2":"Conseiller",
    "remuneration":"8685",
    "allocation":"3725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12410",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":2393,
    "nom_corrige2":"Maryse Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Conseillère",
    "remuneration":"7996",
    "allocation":"3998",
    "remuneration2":"267,00$",
    "allocation2":"133,00$",
    "total":"12394",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2447"
  },
  {
    "ID":2394,
    "nom_corrige2":"Alex Papineau",
    "nom_famille":"Papineau",
    "titre_genre2":"Conseiller",
    "remuneration":"8260",
    "allocation":"4130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12390",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":2395,
    "nom_corrige2":"Carmen Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"8260",
    "allocation":"4130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12390",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":2396,
    "nom_corrige2":"Marc-Olivier Habel",
    "nom_famille":"Habel",
    "titre_genre2":"Conseiller",
    "remuneration":"8260",
    "allocation":"4130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12390",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":2397,
    "nom_corrige2":"Mylène Neault",
    "nom_famille":"Neault",
    "titre_genre2":"Conseillère",
    "remuneration":"8260",
    "allocation":"4130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12390",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":2398,
    "nom_corrige2":"Sophie Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"8260",
    "allocation":"4130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12390",
    "ville":"Sainte-Croix",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2634"
  },
  {
    "ID":2399,
    "nom_corrige2":"Mark Blair",
    "nom_famille":"Blair",
    "titre_genre2":"Conseiller",
    "remuneration":"8192",
    "allocation":"4190",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12382",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":2400,
    "nom_corrige2":"Patrick Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"9588",
    "allocation":"2791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12379",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":2401,
    "nom_corrige2":"Luc Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Conseiller",
    "remuneration":"8250",
    "allocation":"4125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12375",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":2402,
    "nom_corrige2":"Linda Marleau",
    "nom_famille":"Marleau",
    "titre_genre2":"Conseillère",
    "remuneration":"8250",
    "allocation":"4125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12375",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":2403,
    "nom_corrige2":"Dany Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseiller",
    "remuneration":"8250",
    "allocation":"4125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12375",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":2404,
    "nom_corrige2":"Marie Meunier",
    "nom_famille":"Meunier",
    "titre_genre2":"Conseillère",
    "remuneration":"8250",
    "allocation":"4125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12375",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":2405,
    "nom_corrige2":"Jean-Denis Patenaude",
    "nom_famille":"Patenaude",
    "titre_genre2":"Conseiller",
    "remuneration":"8250",
    "allocation":"4125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12375",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":2406,
    "nom_corrige2":"Jocelyne Louis-Seize",
    "nom_famille":"Louis-Seize",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"8249",
    "allocation":"4121",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12370",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":2407,
    "nom_corrige2":"Francis Vigneault",
    "nom_famille":"Vigneault",
    "titre_genre2":"Conseiller",
    "remuneration":"6933",
    "allocation":"4311",
    "remuneration2":"1114",
    "allocation2":"0",
    "total":"12358",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":2408,
    "nom_corrige2":"Dany Boyer",
    "nom_famille":"Boyer",
    "titre_genre2":"Conseiller",
    "remuneration":"8537",
    "allocation":"3789",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12326",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":2409,
    "nom_corrige2":"Fernand Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"8205",
    "allocation":"4102",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12307",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":2410,
    "nom_corrige2":"Guy Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"8818",
    "allocation":"3484",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12302",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":2411,
    "nom_corrige2":"Gérald Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Maire",
    "remuneration":"6257",
    "allocation":"3129",
    "remuneration2":"1941",
    "allocation2":"970,00$",
    "total":"12297",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":2412,
    "nom_corrige2":"Maryse Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Conseillère",
    "remuneration":"8197",
    "allocation":"4098",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12295",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":2413,
    "nom_corrige2":"Jacques Rivière",
    "nom_famille":"Rivière",
    "titre_genre2":"Conseiller",
    "remuneration":"8197",
    "allocation":"4098",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12295",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":2414,
    "nom_corrige2":"Jean Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseiller",
    "remuneration":"8197",
    "allocation":"4098",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12295",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":2415,
    "nom_corrige2":"Bertrand Boire",
    "nom_famille":"Boire",
    "titre_genre2":"Conseiller",
    "remuneration":"8194",
    "allocation":"4097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12291",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":2416,
    "nom_corrige2":"Jean-François Boire",
    "nom_famille":"Boire",
    "titre_genre2":"Conseiller",
    "remuneration":"8194",
    "allocation":"4097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12291",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":2417,
    "nom_corrige2":"Martin Van Winden",
    "nom_famille":"Van Winden",
    "titre_genre2":"Conseiller",
    "remuneration":"8194",
    "allocation":"4097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12291",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":2418,
    "nom_corrige2":"Michel Monette",
    "nom_famille":"Monette",
    "titre_genre2":"Conseiller",
    "remuneration":"8194",
    "allocation":"4097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12291",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":2419,
    "nom_corrige2":"Gérald Dumesnil",
    "nom_famille":"Dumesnil",
    "titre_genre2":"Conseiller",
    "remuneration":"8194",
    "allocation":"4097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12291",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":2420,
    "nom_corrige2":"Josianne Surprenant",
    "nom_famille":"Surprenant",
    "titre_genre2":"Conseillère",
    "remuneration":"8194",
    "allocation":"4097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12291",
    "ville":"Saint-Cyprien-de-Napierville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1796"
  },
  {
    "ID":2421,
    "nom_corrige2":"Christian Valois",
    "nom_famille":"Valois",
    "titre_genre2":"Maire suppléant",
    "remuneration":"8218",
    "allocation":"3863",
    "remuneration2":"138,00$",
    "allocation2":"69,00$",
    "total":"12288",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":2422,
    "nom_corrige2":"Erick Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"8177",
    "allocation":"4088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12265",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":2423,
    "nom_corrige2":"Francine Craig",
    "nom_famille":"Craig",
    "titre_genre2":"Conseillère",
    "remuneration":"8177",
    "allocation":"4088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12265",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":2424,
    "nom_corrige2":"François Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"8177",
    "allocation":"4088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12265",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":2425,
    "nom_corrige2":"Virginie Arbour Trépanier",
    "nom_famille":"Arbour Trépanier",
    "titre_genre2":"Conseillère",
    "remuneration":"8177",
    "allocation":"4088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12265",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":2426,
    "nom_corrige2":"Danièle Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"8768",
    "allocation":"3484",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12252",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":2427,
    "nom_corrige2":"Denise Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Mairesse",
    "remuneration":"8164",
    "allocation":"4082",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12246",
    "ville":"Sainte-Jeanne-d'Arc",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1122"
  },
  {
    "ID":2428,
    "nom_corrige2":"Louise Théorêt",
    "nom_famille":"Théorêt",
    "titre_genre2":"Conseillère",
    "remuneration":"8189",
    "allocation":"4044",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12233",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":2429,
    "nom_corrige2":"Guy Rochette",
    "nom_famille":"Rochette",
    "titre_genre2":"Maire",
    "remuneration":"8206",
    "allocation":"4013",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12219",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":2430,
    "nom_corrige2":"Daniel St-Onge",
    "nom_famille":"St-Onge",
    "titre_genre2":"Conseiller",
    "remuneration":"8143",
    "allocation":"4071",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12214",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":2431,
    "nom_corrige2":"Julie James",
    "nom_famille":"James",
    "titre_genre2":"Conseillère",
    "remuneration":"8143",
    "allocation":"4071",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12214",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":2432,
    "nom_corrige2":"Robert Dewar",
    "nom_famille":"Dewar",
    "titre_genre2":"Conseiller",
    "remuneration":"8143",
    "allocation":"4071",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12214",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":2433,
    "nom_corrige2":"Chantal Scapino",
    "nom_famille":"Scapino",
    "titre_genre2":"Conseillère",
    "remuneration":"8143",
    "allocation":"4071",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12214",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":2434,
    "nom_corrige2":"Richard Francoeur",
    "nom_famille":"Francoeur",
    "titre_genre2":"Conseiller",
    "remuneration":"8143",
    "allocation":"4071",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12214",
    "ville":"Harrington",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"954"
  },
  {
    "ID":2435,
    "nom_corrige2":"Marie-Josée Brodeur",
    "nom_famille":"Brodeur",
    "titre_genre2":"Conseillère",
    "remuneration":"8137",
    "allocation":"4069",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12206",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":2436,
    "nom_corrige2":"Michel Bazinet",
    "nom_famille":"Bazinet",
    "titre_genre2":"Conseiller",
    "remuneration":"8137",
    "allocation":"4069",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12206",
    "ville":"Val-Morin",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3211"
  },
  {
    "ID":2437,
    "nom_corrige2":"Don Saliba",
    "nom_famille":"Saliba",
    "titre_genre2":"Conseiller",
    "remuneration":"8109",
    "allocation":"4055",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12164",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":2438,
    "nom_corrige2":"Gilles Ladouceur",
    "nom_famille":"Ladouceur",
    "titre_genre2":"Conseiller",
    "remuneration":"8109",
    "allocation":"4055",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12164",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":2439,
    "nom_corrige2":"Jocelyn Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"8109",
    "allocation":"4055",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12164",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":2440,
    "nom_corrige2":"Manon Bastien Couturier",
    "nom_famille":"Bastien Couturier",
    "titre_genre2":"Conseillère",
    "remuneration":"8109",
    "allocation":"4055",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12164",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":2441,
    "nom_corrige2":"Anick Bois",
    "nom_famille":"Bois",
    "titre_genre2":"Conseillère",
    "remuneration":"8109",
    "allocation":"4055",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12164",
    "ville":"Lac-Simon",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1152"
  },
  {
    "ID":2442,
    "nom_corrige2":"Scott Mitchell",
    "nom_famille":"Mitchell",
    "titre_genre2":"Maire suppléant",
    "remuneration":"8104",
    "allocation":"4052",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12156",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":2443,
    "nom_corrige2":"Denis Rondeau",
    "nom_famille":"Rondeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"249,00$",
    "allocation2":"124,00$",
    "total":"12148",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":2444,
    "nom_corrige2":"Rolande Beebe",
    "nom_famille":"Beebe",
    "titre_genre2":"Mairesse",
    "remuneration":"7535",
    "allocation":"4600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12135",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":2445,
    "nom_corrige2":"Mario Archambault",
    "nom_famille":"Archambault",
    "titre_genre2":"Conseiller",
    "remuneration":"8089",
    "allocation":"4044",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12133",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":2446,
    "nom_corrige2":"Sylvain Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"8089",
    "allocation":"4044",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12133",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":2447,
    "nom_corrige2":"Mario Prevost",
    "nom_famille":"Prevost",
    "titre_genre2":"Conseiller",
    "remuneration":"8089",
    "allocation":"4044",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12133",
    "ville":"Saint-Stanislas-de-Kostka",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2099"
  },
  {
    "ID":2448,
    "nom_corrige2":"Sylvie Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseillère",
    "remuneration":"10431",
    "allocation":"261,00$",
    "remuneration2":"955,00$",
    "allocation2":"477,00$",
    "total":"12124",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":2449,
    "nom_corrige2":"Lori Carroll-Sutton",
    "nom_famille":"Carroll-Sutton",
    "titre_genre2":"Conseillère",
    "remuneration":"7977",
    "allocation":"3989",
    "remuneration2":"100,00$",
    "allocation2":"50,00$",
    "total":"12116",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":2450,
    "nom_corrige2":"Guy Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseiller",
    "remuneration":"7235",
    "allocation":"3617",
    "remuneration2":"715,00$",
    "allocation2":"532,00$",
    "total":"12099",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":2451,
    "nom_corrige2":"Claude Laporte",
    "nom_famille":"Laporte",
    "titre_genre2":"Conseiller",
    "remuneration":"8035",
    "allocation":"4017",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12052",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":2452,
    "nom_corrige2":"Étienne Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseiller",
    "remuneration":"8035",
    "allocation":"4017",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12052",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":2453,
    "nom_corrige2":"Isabel Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseillère",
    "remuneration":"8035",
    "allocation":"4017",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12052",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":2454,
    "nom_corrige2":"Sylvie Frigon",
    "nom_famille":"Frigon",
    "titre_genre2":"Conseillère",
    "remuneration":"8035",
    "allocation":"4017",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12052",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":2455,
    "nom_corrige2":"Véronique Payette",
    "nom_famille":"Payette",
    "titre_genre2":"Conseillère",
    "remuneration":"8035",
    "allocation":"4017",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12052",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":2456,
    "nom_corrige2":"Pascale Dupaul",
    "nom_famille":"Dupaul",
    "titre_genre2":"Conseillère",
    "remuneration":"8035",
    "allocation":"4017",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12052",
    "ville":"Crabtree",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"4194"
  },
  {
    "ID":2457,
    "nom_corrige2":"Éric Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Maire suppléant",
    "remuneration":"7883",
    "allocation":"3461",
    "remuneration2":"471,00$",
    "allocation2":"235,00$",
    "total":"12050",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":2458,
    "nom_corrige2":"Lise Julien",
    "nom_famille":"Julien",
    "titre_genre2":"Conseillère",
    "remuneration":"7077",
    "allocation":"3538",
    "remuneration2":"955,00$",
    "allocation2":"477,00$",
    "total":"12047",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":2459,
    "nom_corrige2":"Anny Boisjoli",
    "nom_famille":"Boisjoli",
    "titre_genre2":"Conseillère",
    "remuneration":"6316",
    "allocation":"5728",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12044",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":2460,
    "nom_corrige2":"Gilles Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"8861",
    "allocation":"3183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12044",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":2461,
    "nom_corrige2":"Dany St-Amant",
    "nom_famille":"St-Amant",
    "titre_genre2":"Conseiller",
    "remuneration":"8237",
    "allocation":"3789",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12026",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2178"
  },
  {
    "ID":2462,
    "nom_corrige2":"Line Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"8017",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12025",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":2463,
    "nom_corrige2":"Jocelyn Isabelle",
    "nom_famille":"Isabelle",
    "titre_genre2":"Conseiller",
    "remuneration":"8017",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12025",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":2464,
    "nom_corrige2":"Guy St-Arnauld",
    "nom_famille":"St-Arnauld",
    "titre_genre2":"Conseiller",
    "remuneration":"8017",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12025",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":2465,
    "nom_corrige2":"Marc Bastien",
    "nom_famille":"Bastien",
    "titre_genre2":"Conseiller",
    "remuneration":"8017",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12025",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":2466,
    "nom_corrige2":"Nicolas Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"8017",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12025",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":2467,
    "nom_corrige2":"Paul Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Conseiller",
    "remuneration":"8017",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12025",
    "ville":"Saint-Étienne-des-Grès",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"4718"
  },
  {
    "ID":2468,
    "nom_corrige2":"Monique Allaire",
    "nom_famille":"Allaire",
    "titre_genre2":"Conseillère",
    "remuneration":"7416",
    "allocation":"3708",
    "remuneration2":"900,00$",
    "allocation2":"0",
    "total":"12024",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":2469,
    "nom_corrige2":"Pierre-Luc Guertin",
    "nom_famille":"Guertin",
    "titre_genre2":"Conseiller",
    "remuneration":"8011",
    "allocation":"4008",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12019",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":2470,
    "nom_corrige2":"Daniel Enright",
    "nom_famille":"Enright",
    "titre_genre2":"Conseiller",
    "remuneration":"7691",
    "allocation":"3846",
    "remuneration2":"319,00$",
    "allocation2":"159,00$",
    "total":"12015",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":2471,
    "nom_corrige2":"Daniel Lampron",
    "nom_famille":"Lampron",
    "titre_genre2":"Conseiller",
    "remuneration":"8683",
    "allocation":"3328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12011",
    "ville":"Amherst",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1665"
  },
  {
    "ID":2472,
    "nom_corrige2":"Mathieu Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseiller",
    "remuneration":"10780",
    "allocation":"1229",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12009",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":2473,
    "nom_corrige2":"Guylaine Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseillère",
    "remuneration":"8004",
    "allocation":"4002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12006",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":2474,
    "nom_corrige2":"Louis Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"8004",
    "allocation":"4002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12006",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":2475,
    "nom_corrige2":"Michel Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Conseiller",
    "remuneration":"8004",
    "allocation":"4002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12006",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":2476,
    "nom_corrige2":"Milisa Pepin",
    "nom_famille":"Pepin",
    "titre_genre2":"Conseillère",
    "remuneration":"8004",
    "allocation":"4002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12006",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":2477,
    "nom_corrige2":"René Rancourt",
    "nom_famille":"Rancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"8004",
    "allocation":"4002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12006",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":2478,
    "nom_corrige2":"Robert Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"8004",
    "allocation":"4002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12006",
    "ville":"Saint-Martin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2677"
  },
  {
    "ID":2479,
    "nom_corrige2":"Jacques Defoy",
    "nom_famille":"Defoy",
    "titre_genre2":"Conseiller",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":2480,
    "nom_corrige2":"Pierre Metras",
    "nom_famille":"Metras",
    "titre_genre2":"Conseiller",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":2481,
    "nom_corrige2":"Pierre Raiche",
    "nom_famille":"Raiche",
    "titre_genre2":"Conseiller",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":2482,
    "nom_corrige2":"Christian Gamache",
    "nom_famille":"Gamache",
    "titre_genre2":"Conseiller",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":2483,
    "nom_corrige2":"Daniel Guindon",
    "nom_famille":"Guindon",
    "titre_genre2":"Conseiller",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":2484,
    "nom_corrige2":"Roxane Janson Bélisle",
    "nom_famille":"Janson Bélisle",
    "titre_genre2":"Conseillère",
    "remuneration":"8000",
    "allocation":"4000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"12000",
    "ville":"Lac-du-Cerf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"495"
  },
  {
    "ID":2485,
    "nom_corrige2":"Réjean Gamelin",
    "nom_famille":"Gamelin",
    "titre_genre2":"Conseiller",
    "remuneration":"6316",
    "allocation":"5238",
    "remuneration2":"290,00$",
    "allocation2":"145,00$",
    "total":"11989",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":2486,
    "nom_corrige2":"Mario Cardin",
    "nom_famille":"Cardin",
    "titre_genre2":"Conseiller",
    "remuneration":"7987",
    "allocation":"3994",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11981",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":2487,
    "nom_corrige2":"Benoit Bibeau",
    "nom_famille":"Bibeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7986",
    "allocation":"3993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11979",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":2488,
    "nom_corrige2":"Guy Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseiller",
    "remuneration":"7986",
    "allocation":"3993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11979",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":2489,
    "nom_corrige2":"Myriam Cournoyer",
    "nom_famille":"Cournoyer",
    "titre_genre2":"Conseillère",
    "remuneration":"7986",
    "allocation":"3993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11979",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":2490,
    "nom_corrige2":"Roger Soulières",
    "nom_famille":"Soulières",
    "titre_genre2":"Conseiller",
    "remuneration":"7986",
    "allocation":"3993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11979",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":2491,
    "nom_corrige2":"Vincent Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseiller",
    "remuneration":"7986",
    "allocation":"3993",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11979",
    "ville":"Sainte-Anne-de-Sorel",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2741"
  },
  {
    "ID":2492,
    "nom_corrige2":"Pascal Rheault",
    "nom_famille":"Rheault",
    "titre_genre2":"Maire",
    "remuneration":"6081",
    "allocation":"3520",
    "remuneration2":"2360",
    "allocation2":"0",
    "total":"11961",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":2493,
    "nom_corrige2":"Cynthia Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Mairesse",
    "remuneration":"7960",
    "allocation":"3980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11940",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":2494,
    "nom_corrige2":"Chantal Gélinas",
    "nom_famille":"Gélinas",
    "titre_genre2":"Conseillère",
    "remuneration":"7948",
    "allocation":"3974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11922",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":2495,
    "nom_corrige2":"Luc Arseneault",
    "nom_famille":"Arseneault",
    "titre_genre2":"Conseiller",
    "remuneration":"7948",
    "allocation":"3974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11922",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":2496,
    "nom_corrige2":"André Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"7948",
    "allocation":"3974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11922",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":2497,
    "nom_corrige2":"Jocelyn Melançon",
    "nom_famille":"Melançon",
    "titre_genre2":"Conseiller",
    "remuneration":"7948",
    "allocation":"3974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11922",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":2498,
    "nom_corrige2":"Sylvain Areseneault",
    "nom_famille":"Areseneault",
    "titre_genre2":"Conseiller",
    "remuneration":"7948",
    "allocation":"3974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11922",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":2499,
    "nom_corrige2":"David Vincent",
    "nom_famille":"Vincent",
    "titre_genre2":"Maire",
    "remuneration":"6515",
    "allocation":"3258",
    "remuneration2":"1418",
    "allocation2":"709,00$",
    "total":"11900",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":2500,
    "nom_corrige2":"Pierre Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseiller",
    "remuneration":"7925",
    "allocation":"3962",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11887",
    "ville":"Saint-Alphonse-Rodriguez",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"3583"
  },
  {
    "ID":2501,
    "nom_corrige2":"Jean-Claude Ratelle",
    "nom_famille":"Ratelle",
    "titre_genre2":"Conseiller",
    "remuneration":"7921",
    "allocation":"3961",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11882",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":2502,
    "nom_corrige2":"Richard Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"7921",
    "allocation":"3961",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11882",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":2503,
    "nom_corrige2":"Sébastien Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"7921",
    "allocation":"3961",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11882",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":2504,
    "nom_corrige2":"Yvon Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"7921",
    "allocation":"3961",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11882",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":2505,
    "nom_corrige2":"Michel Venne",
    "nom_famille":"Venne",
    "titre_genre2":"Conseiller",
    "remuneration":"7921",
    "allocation":"3961",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11882",
    "ville":"Ferme-Neuve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"2817"
  },
  {
    "ID":2506,
    "nom_corrige2":"Daniel Magnan",
    "nom_famille":"Magnan",
    "titre_genre2":"Conseiller",
    "remuneration":"8234",
    "allocation":"3629",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11863",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":2507,
    "nom_corrige2":"Lyne Mckenzie",
    "nom_famille":"Mckenzie",
    "titre_genre2":"Conseillère",
    "remuneration":"7817",
    "allocation":"4040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11857",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":2508,
    "nom_corrige2":"Andre Desilet",
    "nom_famille":"Desilet",
    "titre_genre2":"Conseiller",
    "remuneration":"9705",
    "allocation":"2152",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11857",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":2509,
    "nom_corrige2":"Jean Duhaime",
    "nom_famille":"Duhaime",
    "titre_genre2":"Conseiller",
    "remuneration":"6316",
    "allocation":"5118",
    "remuneration2":"280,00$",
    "allocation2":"140,00$",
    "total":"11854",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":2510,
    "nom_corrige2":"Michelle Jackson Trépanier",
    "nom_famille":"Jackson Trépanier",
    "titre_genre2":"Conseillère",
    "remuneration":"7902",
    "allocation":"3951",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11853",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":2511,
    "nom_corrige2":"Christopher Jackson",
    "nom_famille":"Jackson",
    "titre_genre2":"Conseiller",
    "remuneration":"7902",
    "allocation":"3951",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11853",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":2512,
    "nom_corrige2":"Dennis Dicks",
    "nom_famille":"Dicks",
    "titre_genre2":"Conseiller",
    "remuneration":"7902",
    "allocation":"3951",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11853",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":2513,
    "nom_corrige2":"Pierre Matuszewski",
    "nom_famille":"Matuszewski",
    "titre_genre2":"Conseiller",
    "remuneration":"7902",
    "allocation":"3951",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11853",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":2514,
    "nom_corrige2":"Stephen Lee",
    "nom_famille":"Lee",
    "titre_genre2":"Conseiller",
    "remuneration":"7902",
    "allocation":"3951",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11853",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":2515,
    "nom_corrige2":"Tanya Narang",
    "nom_famille":"Narang",
    "titre_genre2":"Conseillère",
    "remuneration":"7902",
    "allocation":"3951",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11853",
    "ville":"Senneville",
    "arrondissement":"",
    "region_adm":"Montréal",
    "population":"1024"
  },
  {
    "ID":2516,
    "nom_corrige2":"Charles Brochu",
    "nom_famille":"Brochu",
    "titre_genre2":"Conseiller",
    "remuneration":"7897",
    "allocation":"3948",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11845",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":2517,
    "nom_corrige2":"Nathalie Clark",
    "nom_famille":"Clark",
    "titre_genre2":"Conseillère",
    "remuneration":"7888",
    "allocation":"3944",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11832",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":2518,
    "nom_corrige2":"Pamela Dow",
    "nom_famille":"Dow",
    "titre_genre2":"Conseillère",
    "remuneration":"7888",
    "allocation":"3944",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11832",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":2519,
    "nom_corrige2":"Jean-Pierre Querry",
    "nom_famille":"Querry",
    "titre_genre2":"Conseiller",
    "remuneration":"7888",
    "allocation":"3944",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11832",
    "ville":"New Richmond",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3856"
  },
  {
    "ID":2520,
    "nom_corrige2":"Karine St-Germain",
    "nom_famille":"St-Germain",
    "titre_genre2":"Conseillère",
    "remuneration":"8067",
    "allocation":"3725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11792",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":2521,
    "nom_corrige2":"Marie-Danielle Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Conseillère",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":2522,
    "nom_corrige2":"Éric fortin",
    "nom_famille":"fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":2523,
    "nom_corrige2":"Marielle Farley",
    "nom_famille":"Farley",
    "titre_genre2":"Conseillère",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":2524,
    "nom_corrige2":"Isabelle Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseillère",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Rougemont",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2768"
  },
  {
    "ID":2525,
    "nom_corrige2":"Renée Montgrain",
    "nom_famille":"Montgrain",
    "titre_genre2":"Conseillère",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":2526,
    "nom_corrige2":"Daniel Groleau",
    "nom_famille":"Groleau",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":2527,
    "nom_corrige2":"Daniel Sabourin",
    "nom_famille":"Sabourin",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":2528,
    "nom_corrige2":"Pierre Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":2529,
    "nom_corrige2":"Olivier Paiement",
    "nom_famille":"Paiement",
    "titre_genre2":"Conseiller",
    "remuneration":"7850",
    "allocation":"3925",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11775",
    "ville":"Weedon",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2838"
  },
  {
    "ID":2530,
    "nom_corrige2":"Gérald Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"6933",
    "allocation":"4311",
    "remuneration2":"525,00$",
    "allocation2":"0",
    "total":"11769",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":2531,
    "nom_corrige2":"Rolande Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseillère",
    "remuneration":"7833",
    "allocation":"3916",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11749",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":2532,
    "nom_corrige2":"Henri Pariseau",
    "nom_famille":"Pariseau",
    "titre_genre2":"Maire",
    "remuneration":"2814",
    "allocation":"1407",
    "remuneration2":"4998",
    "allocation2":"2499",
    "total":"11718",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":2533,
    "nom_corrige2":"Karine Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"6354",
    "allocation":"1830",
    "remuneration2":"2609",
    "allocation2":"915,00$",
    "total":"11708",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":2534,
    "nom_corrige2":"Zakary Armstrong",
    "nom_famille":"Armstrong",
    "titre_genre2":"Conseillère",
    "remuneration":"7823",
    "allocation":"3873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11696",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":2535,
    "nom_corrige2":"Paul Brouillard",
    "nom_famille":"Brouillard",
    "titre_genre2":"Conseiller",
    "remuneration":"7823",
    "allocation":"3873",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11696",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":2536,
    "nom_corrige2":"Julie Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseillère",
    "remuneration":"7965",
    "allocation":"3725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11690",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":2537,
    "nom_corrige2":"Keven Patenaude",
    "nom_famille":"Patenaude",
    "titre_genre2":"Conseiller",
    "remuneration":"7913",
    "allocation":"3725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11638",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":2538,
    "nom_corrige2":"Éric Comeau",
    "nom_famille":"Comeau",
    "titre_genre2":"Maire",
    "remuneration":"7755",
    "allocation":"3878",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11633",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":2539,
    "nom_corrige2":"François Dubeau",
    "nom_famille":"Dubeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7751",
    "allocation":"3875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11626",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":2540,
    "nom_corrige2":"Bruce Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"138,00$",
    "allocation2":"69,00$",
    "total":"11598",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":2541,
    "nom_corrige2":"Claude Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"7169",
    "allocation":"3504",
    "remuneration2":"610,00$",
    "allocation2":"305,00$",
    "total":"11588",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":2542,
    "nom_corrige2":"Patrick Gripon",
    "nom_famille":"Gripon",
    "titre_genre2":"Conseiller",
    "remuneration":"7722",
    "allocation":"3861",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11583",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2895"
  },
  {
    "ID":2543,
    "nom_corrige2":"Pierre Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseiller",
    "remuneration":"6398",
    "allocation":"3657",
    "remuneration2":"1017",
    "allocation2":"510,00$",
    "total":"11582",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":2544,
    "nom_corrige2":"Danielle Ferland",
    "nom_famille":"Ferland",
    "titre_genre2":"Conseillère",
    "remuneration":"7718",
    "allocation":"3859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11577",
    "ville":"Chute-Saint-Philippe",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1104"
  },
  {
    "ID":2545,
    "nom_corrige2":"William Miller",
    "nom_famille":"Miller",
    "titre_genre2":"Maire",
    "remuneration":"8679",
    "allocation":"2893",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11572",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":2546,
    "nom_corrige2":"Guillaume Brais",
    "nom_famille":"Brais",
    "titre_genre2":"Conseiller",
    "remuneration":"7710",
    "allocation":"3855",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11565",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":2547,
    "nom_corrige2":"Jules Brunelle-Marineau",
    "nom_famille":"Brunelle-Marineau",
    "titre_genre2":"Conseiller",
    "remuneration":"7710",
    "allocation":"3855",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11565",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":2548,
    "nom_corrige2":"Florencia Saravia Maria",
    "nom_famille":"Saravia Maria",
    "titre_genre2":"Conseillère",
    "remuneration":"7710",
    "allocation":"3855",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11565",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":2549,
    "nom_corrige2":"Jeremy Page",
    "nom_famille":"Page",
    "titre_genre2":"Conseiller",
    "remuneration":"7710",
    "allocation":"3855",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11565",
    "ville":"Dunham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3640"
  },
  {
    "ID":2550,
    "nom_corrige2":"Marc Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"9405",
    "allocation":"2152",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11557",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":2551,
    "nom_corrige2":"Nathaniel St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"7592",
    "allocation":"3890",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11482",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":2552,
    "nom_corrige2":"Stéphanie Lafrenière-Milot",
    "nom_famille":"Lafrenière-Milot",
    "titre_genre2":"Conseillère",
    "remuneration":"6933",
    "allocation":"4311",
    "remuneration2":"225,00$",
    "allocation2":"0",
    "total":"11469",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":2553,
    "nom_corrige2":"Alphé St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Maire",
    "remuneration":"7640",
    "allocation":"3820",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11460",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":2554,
    "nom_corrige2":"Guylaine Labbée",
    "nom_famille":"Labbée",
    "titre_genre2":"Mairesse",
    "remuneration":"4554",
    "allocation":"2277",
    "remuneration2":"3067",
    "allocation2":"1535",
    "total":"11433",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":2555,
    "nom_corrige2":"Claudia Drogue",
    "nom_famille":"Drogue",
    "titre_genre2":"Conseillère",
    "remuneration":"7707",
    "allocation":"3725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11432",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":2556,
    "nom_corrige2":"Luc Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"6341",
    "allocation":"3171",
    "remuneration2":"1275",
    "allocation2":"638,00$",
    "total":"11425",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":2557,
    "nom_corrige2":"Jean-François Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"7614",
    "allocation":"",
    "remuneration2":"3808",
    "allocation2":"0",
    "total":"11422",
    "ville":"Saint-Germain-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"5075"
  },
  {
    "ID":2558,
    "nom_corrige2":"Alain Prescott",
    "nom_famille":"Prescott",
    "titre_genre2":"Conseiller",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11391",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":2559,
    "nom_corrige2":"Denis Desroches",
    "nom_famille":"Desroches",
    "titre_genre2":"Conseiller",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11391",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":2560,
    "nom_corrige2":"Manon Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseillère",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11391",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":2561,
    "nom_corrige2":"Nicole Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseillère",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11391",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":2562,
    "nom_corrige2":"Vivian Beausoleil",
    "nom_famille":"Beausoleil",
    "titre_genre2":"Conseillère",
    "remuneration":"7594",
    "allocation":"3797",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11391",
    "ville":"Saint-Gabriel-de-Brandon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2904"
  },
  {
    "ID":2563,
    "nom_corrige2":"François Vadnais",
    "nom_famille":"Vadnais",
    "titre_genre2":"Conseiller",
    "remuneration":"7592",
    "allocation":"3796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11388",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":2564,
    "nom_corrige2":"Benoit Isaia",
    "nom_famille":"Isaia",
    "titre_genre2":"Conseiller",
    "remuneration":"7592",
    "allocation":"3796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11388",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":2565,
    "nom_corrige2":"Bertrand Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"7592",
    "allocation":"3796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11388",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":2566,
    "nom_corrige2":"Gilbert cabana",
    "nom_famille":"cabana",
    "titre_genre2":"Conseiller",
    "remuneration":"7592",
    "allocation":"3796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11388",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":2567,
    "nom_corrige2":"Suzanne Choinière",
    "nom_famille":"Choinière",
    "titre_genre2":"Conseillère",
    "remuneration":"7592",
    "allocation":"3796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11388",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":2568,
    "nom_corrige2":"Alexandra Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseillère",
    "remuneration":"7592",
    "allocation":"3796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11388",
    "ville":"Saint-Alphonse-de-Granby",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3531"
  },
  {
    "ID":2569,
    "nom_corrige2":"Lisa Collard",
    "nom_famille":"Collard",
    "titre_genre2":"Conseillère",
    "remuneration":"7655",
    "allocation":"3725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11380",
    "ville":"Mont-Saint-Grégoire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3200"
  },
  {
    "ID":2570,
    "nom_corrige2":"Evelyne Latour",
    "nom_famille":"Latour",
    "titre_genre2":"Conseillère",
    "remuneration":"7585",
    "allocation":"3795",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11380",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":2571,
    "nom_corrige2":"Vincent Gingras",
    "nom_famille":"Gingras",
    "titre_genre2":"Mairesse",
    "remuneration":"5101",
    "allocation":"2526",
    "remuneration2":"2475",
    "allocation2":"1237",
    "total":"11339",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":2572,
    "nom_corrige2":"John Dalzell",
    "nom_famille":"Dalzell",
    "titre_genre2":"Conseiller",
    "remuneration":"7552",
    "allocation":"3776",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11328",
    "ville":"Sainte-Anne-des-Lacs",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"4054"
  },
  {
    "ID":2573,
    "nom_corrige2":"Pierre Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"5719",
    "allocation":"2859",
    "remuneration2":"1827",
    "allocation2":"914,00$",
    "total":"11319",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":2574,
    "nom_corrige2":"Nadia Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Mairesse",
    "remuneration":"4332",
    "allocation":"2166",
    "remuneration2":"3210",
    "allocation2":"1605",
    "total":"11313",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":2575,
    "nom_corrige2":"Jean-Luc Dulude",
    "nom_famille":"Dulude",
    "titre_genre2":"Conseiller",
    "remuneration":"8520",
    "allocation":"2791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11311",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":2576,
    "nom_corrige2":"Pierre Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseiller",
    "remuneration":"7588",
    "allocation":"3716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11304",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":2577,
    "nom_corrige2":"Mario Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"7643",
    "allocation":"3644",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11287",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":2578,
    "nom_corrige2":"Pascal Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"7643",
    "allocation":"3644",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11287",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":2579,
    "nom_corrige2":"André Perrault",
    "nom_famille":"Perrault",
    "titre_genre2":"Conseiller",
    "remuneration":"7519",
    "allocation":"3759",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11278",
    "ville":"Sainte-Clotilde",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3127"
  },
  {
    "ID":2580,
    "nom_corrige2":"Louis-Charles Guertin",
    "nom_famille":"Guertin",
    "titre_genre2":"Conseiller",
    "remuneration":"7514",
    "allocation":"3760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11274",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":2581,
    "nom_corrige2":"Rémi Lagacé",
    "nom_famille":"Lagacé",
    "titre_genre2":"Maire",
    "remuneration":"7511",
    "allocation":"3756",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11267",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":2582,
    "nom_corrige2":"Sylvie Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseillère",
    "remuneration":"7477",
    "allocation":"3738",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11215",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":2583,
    "nom_corrige2":"Patrick Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"7470",
    "allocation":"3735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11205",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":2584,
    "nom_corrige2":"Donald Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"7209",
    "allocation":"3605",
    "remuneration2":"244,00$",
    "allocation2":"122,00$",
    "total":"11180",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":2585,
    "nom_corrige2":"Alexandre Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"6654",
    "allocation":"3327",
    "remuneration2":"797,00$",
    "allocation2":"399,00$",
    "total":"11177",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":2586,
    "nom_corrige2":"Serge Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"9005",
    "allocation":"2152",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11157",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":2587,
    "nom_corrige2":"Paul Sauvé",
    "nom_famille":"Sauvé",
    "titre_genre2":"Conseiller",
    "remuneration":"7433",
    "allocation":"3716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11149",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":2588,
    "nom_corrige2":"Philippe Cyr",
    "nom_famille":"Cyr",
    "titre_genre2":"Maire suppléant",
    "remuneration":"7433",
    "allocation":"3716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11149",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":2589,
    "nom_corrige2":"Allan Page",
    "nom_famille":"Page",
    "titre_genre2":"Conseiller",
    "remuneration":"7433",
    "allocation":"3716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11149",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":2590,
    "nom_corrige2":"Jay Brothers",
    "nom_famille":"Brothers",
    "titre_genre2":"Conseiller",
    "remuneration":"7433",
    "allocation":"3716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11149",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":2591,
    "nom_corrige2":"William Gauley",
    "nom_famille":"Gauley",
    "titre_genre2":"Conseiller",
    "remuneration":"7433",
    "allocation":"3716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11149",
    "ville":"Wentworth",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"667"
  },
  {
    "ID":2592,
    "nom_corrige2":"Gabrielle Lavigne",
    "nom_famille":"Lavigne",
    "titre_genre2":"Conseillère",
    "remuneration":"7416",
    "allocation":"3708",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11124",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":2593,
    "nom_corrige2":"Martin Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"7416",
    "allocation":"3708",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11124",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":2594,
    "nom_corrige2":"Sylvain Loranger",
    "nom_famille":"Loranger",
    "titre_genre2":"Conseiller",
    "remuneration":"7416",
    "allocation":"3708",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11124",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":2595,
    "nom_corrige2":"Isabelle Brunette",
    "nom_famille":"Brunette",
    "titre_genre2":"Conseillère",
    "remuneration":"7416",
    "allocation":"3708",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11124",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":2596,
    "nom_corrige2":"Bertrand Thibaudeau",
    "nom_famille":"Thibaudeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7077",
    "allocation":"3538",
    "remuneration2":"332,00$",
    "allocation2":"159,00$",
    "total":"11106",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":2597,
    "nom_corrige2":"Karina Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"7077",
    "allocation":"3538",
    "remuneration2":"332,00$",
    "allocation2":"159,00$",
    "total":"11106",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":2598,
    "nom_corrige2":"Danio Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"7403",
    "allocation":"3702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11105",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":2599,
    "nom_corrige2":"Francine Trottier",
    "nom_famille":"Trottier",
    "titre_genre2":"Conseillère",
    "remuneration":"7403",
    "allocation":"3702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11105",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":2600,
    "nom_corrige2":"Louise Allaire",
    "nom_famille":"Allaire",
    "titre_genre2":"Conseillère",
    "remuneration":"7403",
    "allocation":"3702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11105",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":2601,
    "nom_corrige2":"Marie-Pier Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"7403",
    "allocation":"3702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11105",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":2602,
    "nom_corrige2":"René Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Conseiller",
    "remuneration":"7403",
    "allocation":"3702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11105",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":2603,
    "nom_corrige2":"Véronique Perrier",
    "nom_famille":"Perrier",
    "titre_genre2":"Conseillère",
    "remuneration":"7403",
    "allocation":"3702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11105",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2790"
  },
  {
    "ID":2604,
    "nom_corrige2":"Ghislain Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseiller",
    "remuneration":"7394",
    "allocation":"3697",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11091",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":2605,
    "nom_corrige2":"Karine Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseillère",
    "remuneration":"7394",
    "allocation":"3697",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11091",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":2606,
    "nom_corrige2":"Martin Loiselle",
    "nom_famille":"Loiselle",
    "titre_genre2":"Conseiller",
    "remuneration":"7394",
    "allocation":"3697",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11091",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":2607,
    "nom_corrige2":"Valéry Casavant",
    "nom_famille":"Casavant",
    "titre_genre2":"Conseillère",
    "remuneration":"7394",
    "allocation":"3697",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11091",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":2608,
    "nom_corrige2":"Pierre Yves Viens",
    "nom_famille":"Yves Viens",
    "titre_genre2":"Conseiller",
    "remuneration":"7394",
    "allocation":"3697",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11091",
    "ville":"Saint-Mathias-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4629"
  },
  {
    "ID":2609,
    "nom_corrige2":"Robert Arcoite",
    "nom_famille":"Arcoite",
    "titre_genre2":"Conseiller",
    "remuneration":"7386",
    "allocation":"3693",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11079",
    "ville":"Sainte-Clotilde",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3127"
  },
  {
    "ID":2610,
    "nom_corrige2":"Francis Malenfant",
    "nom_famille":"Malenfant",
    "titre_genre2":"Conseiller",
    "remuneration":"7379",
    "allocation":"3689",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11068",
    "ville":"Cleveland",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1658"
  },
  {
    "ID":2611,
    "nom_corrige2":"Richard Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"7402",
    "allocation":"3665",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11067",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":2612,
    "nom_corrige2":"Shirley Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseillère",
    "remuneration":"7370",
    "allocation":"3685",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11055",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":2613,
    "nom_corrige2":"Annie Chevalier",
    "nom_famille":"Chevalier",
    "titre_genre2":"Conseillère",
    "remuneration":"7568",
    "allocation":"3484",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11052",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":2614,
    "nom_corrige2":"Roger Lalonde",
    "nom_famille":"Lalonde",
    "titre_genre2":"Conseiller",
    "remuneration":"7358",
    "allocation":"3676",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11034",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":2615,
    "nom_corrige2":"Marc-Olivier Racette",
    "nom_famille":"Racette",
    "titre_genre2":"Conseiller",
    "remuneration":"7468",
    "allocation":"3564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11032",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":2616,
    "nom_corrige2":"Bertrand Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"7468",
    "allocation":"3564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11032",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":2617,
    "nom_corrige2":"Dominique Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseillère",
    "remuneration":"7468",
    "allocation":"3564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11032",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":2618,
    "nom_corrige2":"Johanne Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseillère",
    "remuneration":"7468",
    "allocation":"3564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11032",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":2619,
    "nom_corrige2":"Réjean Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"7468",
    "allocation":"3564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11032",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":2620,
    "nom_corrige2":"Sarah Bellavance",
    "nom_famille":"Bellavance",
    "titre_genre2":"Conseillère",
    "remuneration":"7468",
    "allocation":"3564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11032",
    "ville":"Saint-Christophe-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"3289"
  },
  {
    "ID":2621,
    "nom_corrige2":"André Woodbury",
    "nom_famille":"Woodbury",
    "titre_genre2":"Conseiller",
    "remuneration":"7356",
    "allocation":"3675",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11031",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":2622,
    "nom_corrige2":"Francis Lacelle",
    "nom_famille":"Lacelle",
    "titre_genre2":"Conseiller",
    "remuneration":"7339",
    "allocation":"3669",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"11008",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":2623,
    "nom_corrige2":"Sonia Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseillère",
    "remuneration":"6612",
    "allocation":"3135",
    "remuneration2":"825,00$",
    "allocation2":"413,00$",
    "total":"10985",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":2624,
    "nom_corrige2":"Audrey Paquette-Poulin",
    "nom_famille":"Paquette-Poulin",
    "titre_genre2":"Conseillère",
    "remuneration":"7320",
    "allocation":"3661",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10981",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":2625,
    "nom_corrige2":"Jacques Decoeur",
    "nom_famille":"Decoeur",
    "titre_genre2":"Conseiller",
    "remuneration":"7320",
    "allocation":"3661",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10981",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":2626,
    "nom_corrige2":"Michael Steimer",
    "nom_famille":"Steimer",
    "titre_genre2":"Conseiller",
    "remuneration":"7320",
    "allocation":"3661",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10981",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":2627,
    "nom_corrige2":"Jessica Larriviere",
    "nom_famille":"Larriviere",
    "titre_genre2":"Conseillère",
    "remuneration":"7320",
    "allocation":"3661",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10981",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":2628,
    "nom_corrige2":"Pierre Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"7320",
    "allocation":"3661",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10981",
    "ville":"Saint-André-d'Argenteuil",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"3257"
  },
  {
    "ID":2629,
    "nom_corrige2":"David Lisbona",
    "nom_famille":"Lisbona",
    "titre_genre2":"Conseiller",
    "remuneration":"7318",
    "allocation":"3659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10977",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":2630,
    "nom_corrige2":"Gabriela Opas",
    "nom_famille":"Opas",
    "titre_genre2":"Conseillère",
    "remuneration":"7318",
    "allocation":"3659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10977",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":2631,
    "nom_corrige2":"Jean-Pierre Charette",
    "nom_famille":"Charette",
    "titre_genre2":"Conseiller",
    "remuneration":"7318",
    "allocation":"3659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10977",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":2632,
    "nom_corrige2":"Julia Ann Wilkins",
    "nom_famille":"Ann Wilkins",
    "titre_genre2":"Conseillère",
    "remuneration":"7318",
    "allocation":"3659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10977",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":2633,
    "nom_corrige2":"Julia Bourke",
    "nom_famille":"Bourke",
    "titre_genre2":"Conseillère",
    "remuneration":"7318",
    "allocation":"3659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10977",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":2634,
    "nom_corrige2":"Maxime Arcand",
    "nom_famille":"Arcand",
    "titre_genre2":"Conseiller",
    "remuneration":"7318",
    "allocation":"3659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10977",
    "ville":"Ivry-sur-le-Lac",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"387"
  },
  {
    "ID":2635,
    "nom_corrige2":"Daniel Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseiller",
    "remuneration":"6316",
    "allocation":"4658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10974",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":2636,
    "nom_corrige2":"Gilles Courchesne",
    "nom_famille":"Courchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"7301",
    "allocation":"3653",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10954",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":2637,
    "nom_corrige2":"Roxanne Laliberté",
    "nom_famille":"Laliberté",
    "titre_genre2":"Mairesse",
    "remuneration":"5880",
    "allocation":"2940",
    "remuneration2":"1422",
    "allocation2":"711,00$",
    "total":"10953",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":2638,
    "nom_corrige2":"Daniel Forgues",
    "nom_famille":"Forgues",
    "titre_genre2":"Conseiller",
    "remuneration":"7288",
    "allocation":"3644",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10932",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":2639,
    "nom_corrige2":"Guyda Deblois",
    "nom_famille":"Deblois",
    "titre_genre2":"Conseiller",
    "remuneration":"5768",
    "allocation":"2884",
    "remuneration2":"1516",
    "allocation2":"758,00$",
    "total":"10926",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":2640,
    "nom_corrige2":"Annie Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseillère",
    "remuneration":"8755",
    "allocation":"2152",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10907",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":2641,
    "nom_corrige2":"Sylvie Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseillère",
    "remuneration":"7259",
    "allocation":"3629",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10888",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":2642,
    "nom_corrige2":"Alexy Vézeau",
    "nom_famille":"Vézeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7259",
    "allocation":"3629",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10888",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":2643,
    "nom_corrige2":"Catherine Larivière",
    "nom_famille":"Larivière",
    "titre_genre2":"Conseillère",
    "remuneration":"7259",
    "allocation":"3629",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10888",
    "ville":"Malartic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"3489"
  },
  {
    "ID":2644,
    "nom_corrige2":"Simon Brennan",
    "nom_famille":"Brennan",
    "titre_genre2":"Conseiller",
    "remuneration":"7292",
    "allocation":"3590",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10882",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":2645,
    "nom_corrige2":"Michel Dinnigan",
    "nom_famille":"Dinnigan",
    "titre_genre2":"Conseiller",
    "remuneration":"7252",
    "allocation":"3626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10878",
    "ville":"Sainte-Clotilde",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3127"
  },
  {
    "ID":2646,
    "nom_corrige2":"Yves Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseiller",
    "remuneration":"6316",
    "allocation":"4558",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10874",
    "ville":"Saint-François-du-Lac",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1917"
  },
  {
    "ID":2647,
    "nom_corrige2":"Daniel Valois",
    "nom_famille":"Valois",
    "titre_genre2":"Conseiller",
    "remuneration":"7237",
    "allocation":"3622",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10859",
    "ville":"Saint-Ignace-de-Loyola",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2144"
  },
  {
    "ID":2648,
    "nom_corrige2":"Pascal Houle",
    "nom_famille":"Houle",
    "titre_genre2":"Conseiller",
    "remuneration":"7235",
    "allocation":"3617",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10852",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":2649,
    "nom_corrige2":"Pierre Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"7235",
    "allocation":"3617",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10852",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":2650,
    "nom_corrige2":"Raymonde Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"7235",
    "allocation":"3617",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10852",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":2651,
    "nom_corrige2":"Chantal Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseillère",
    "remuneration":"7235",
    "allocation":"3617",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10852",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":2652,
    "nom_corrige2":"Jean-François Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"7256",
    "allocation":"3566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10822",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":2653,
    "nom_corrige2":"Patricia Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseillère",
    "remuneration":"7256",
    "allocation":"3566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10822",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":2654,
    "nom_corrige2":"Marie-Lou Darveau",
    "nom_famille":"Darveau",
    "titre_genre2":"Conseillère",
    "remuneration":"7256",
    "allocation":"3566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10822",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":2655,
    "nom_corrige2":"Denis Bourgault",
    "nom_famille":"Bourgault",
    "titre_genre2":"Conseiller",
    "remuneration":"7256",
    "allocation":"3566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10822",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":2656,
    "nom_corrige2":"François Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseiller",
    "remuneration":"7256",
    "allocation":"3566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10822",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":2657,
    "nom_corrige2":"Dave Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"7209",
    "allocation":"3605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10814",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":2658,
    "nom_corrige2":"Claude Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"7209",
    "allocation":"3605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10814",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":2659,
    "nom_corrige2":"Gaétan Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseiller",
    "remuneration":"7209",
    "allocation":"3605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10814",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":2660,
    "nom_corrige2":"Nicole Massicotte",
    "nom_famille":"Massicotte",
    "titre_genre2":"Conseillère",
    "remuneration":"7209",
    "allocation":"3605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10814",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":2661,
    "nom_corrige2":"Suzanne Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseillère",
    "remuneration":"7209",
    "allocation":"3605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10814",
    "ville":"Beaumont",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3135"
  },
  {
    "ID":2662,
    "nom_corrige2":"Richard Lecours",
    "nom_famille":"Lecours",
    "titre_genre2":"Conseiller",
    "remuneration":"10780",
    "allocation":"",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10780",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":2663,
    "nom_corrige2":"Isabelle Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"7179",
    "allocation":"3585",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10764",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":2664,
    "nom_corrige2":"Claude Gaucher",
    "nom_famille":"Gaucher",
    "titre_genre2":"Conseiller",
    "remuneration":"6452",
    "allocation":"3226",
    "remuneration2":"723,00$",
    "allocation2":"361,00$",
    "total":"10762",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":2665,
    "nom_corrige2":"Mario Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"8605",
    "allocation":"2152",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10757",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":2666,
    "nom_corrige2":"Mario Montambault",
    "nom_famille":"Montambault",
    "titre_genre2":"Conseiller",
    "remuneration":"7063",
    "allocation":"3685",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10748",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":2667,
    "nom_corrige2":"Michel Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Conseiller",
    "remuneration":"7095",
    "allocation":"3647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10742",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":2668,
    "nom_corrige2":"André Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"7156",
    "allocation":"3578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10734",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":2669,
    "nom_corrige2":"Eric Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"7156",
    "allocation":"3578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10734",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":2670,
    "nom_corrige2":"Jean-Pierre Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"7156",
    "allocation":"3578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10734",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":2671,
    "nom_corrige2":"Julie Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"7156",
    "allocation":"3578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10734",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":2672,
    "nom_corrige2":"Line Racicot-Lapointe",
    "nom_famille":"Racicot-Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"7156",
    "allocation":"3578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10734",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":2673,
    "nom_corrige2":"Guillaume Scott",
    "nom_famille":"Scott",
    "titre_genre2":"Conseiller",
    "remuneration":"7156",
    "allocation":"3578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10734",
    "ville":"Sainte-Émélie-de-l'Énergie",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1801"
  },
  {
    "ID":2674,
    "nom_corrige2":"Denis Dugas",
    "nom_famille":"Dugas",
    "titre_genre2":"Conseiller",
    "remuneration":"6273",
    "allocation":"3136",
    "remuneration2":"881,00$",
    "allocation2":"440,00$",
    "total":"10730",
    "ville":"Saint-Roch-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2878"
  },
  {
    "ID":2675,
    "nom_corrige2":"François Barbeau",
    "nom_famille":"Barbeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7152",
    "allocation":"3576",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10728",
    "ville":"Sainte-Clotilde",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3127"
  },
  {
    "ID":2676,
    "nom_corrige2":"Peter Dopelhamer",
    "nom_famille":"Dopelhamer",
    "titre_genre2":"Conseiller",
    "remuneration":"7150",
    "allocation":"3572",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10722",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":2677,
    "nom_corrige2":"Johnny Izzi",
    "nom_famille":"Izzi",
    "titre_genre2":"Conseiller",
    "remuneration":"7433",
    "allocation":"3020",
    "remuneration2":"169,00$",
    "allocation2":"85,00$",
    "total":"10707",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":2678,
    "nom_corrige2":"Danie Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"10431",
    "allocation":"261,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10692",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":2679,
    "nom_corrige2":"Francis Bellemare",
    "nom_famille":"Bellemare",
    "titre_genre2":"Conseiller",
    "remuneration":"10431",
    "allocation":"261,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10692",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":2680,
    "nom_corrige2":"Francyne Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"10431",
    "allocation":"261,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10692",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":2681,
    "nom_corrige2":"Renée-Claude Pichette",
    "nom_famille":"Pichette",
    "titre_genre2":"Conseillère",
    "remuneration":"10431",
    "allocation":"261,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10692",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":2682,
    "nom_corrige2":"Jean-Pierre Pagé",
    "nom_famille":"Pagé",
    "titre_genre2":"Conseiller",
    "remuneration":"10431",
    "allocation":"261,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10692",
    "ville":"Donnacona",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"7850"
  },
  {
    "ID":2683,
    "nom_corrige2":"Solange Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"7121",
    "allocation":"3561",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10682",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":2684,
    "nom_corrige2":"René Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Maire",
    "remuneration":"7121",
    "allocation":"3560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10681",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":2685,
    "nom_corrige2":"Alain Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"7169",
    "allocation":"3504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10673",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":2686,
    "nom_corrige2":"Cathy Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Conseillère",
    "remuneration":"7169",
    "allocation":"3504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10673",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":2687,
    "nom_corrige2":"Claude Deblois",
    "nom_famille":"Deblois",
    "titre_genre2":"Conseiller",
    "remuneration":"7169",
    "allocation":"3504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10673",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":2688,
    "nom_corrige2":"Jean-Philippe Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"7169",
    "allocation":"3504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10673",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":2689,
    "nom_corrige2":"Rémi Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseiller",
    "remuneration":"7169",
    "allocation":"3504",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10673",
    "ville":"Saint-Gédéon-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2148"
  },
  {
    "ID":2690,
    "nom_corrige2":"Patrick Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"5179",
    "allocation":"5179",
    "remuneration2":"207,00$",
    "allocation2":"104,00$",
    "total":"10669",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":2691,
    "nom_corrige2":"Louis Andre Desjardins",
    "nom_famille":"Andre Desjardins",
    "titre_genre2":"Conseiller",
    "remuneration":"7108",
    "allocation":"3551",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10659",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":2692,
    "nom_corrige2":"Denys Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"7077",
    "allocation":"3538",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10615",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":2693,
    "nom_corrige2":"Martial Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"7077",
    "allocation":"3538",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10615",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":2694,
    "nom_corrige2":"Mathias Piché",
    "nom_famille":"Piché",
    "titre_genre2":"Conseiller",
    "remuneration":"7077",
    "allocation":"3538",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10615",
    "ville":"Saint-Basile",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2876"
  },
  {
    "ID":2695,
    "nom_corrige2":"Christian Massé",
    "nom_famille":"Massé",
    "titre_genre2":"Maire",
    "remuneration":"7068",
    "allocation":"3534",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10602",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":2696,
    "nom_corrige2":"Michel Lesage",
    "nom_famille":"Lesage",
    "titre_genre2":"Conseiller",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"600,00$",
    "allocation2":"0",
    "total":"10600",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":2697,
    "nom_corrige2":"Marcel Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"7052",
    "allocation":"3526",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10578",
    "ville":"Sainte-Clotilde",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3127"
  },
  {
    "ID":2698,
    "nom_corrige2":"July Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Conseillère",
    "remuneration":"8405",
    "allocation":"2152",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10557",
    "ville":"Mandeville",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2455"
  },
  {
    "ID":2699,
    "nom_corrige2":"Évelyne Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"7242",
    "allocation":"3309",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10551",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":2700,
    "nom_corrige2":"Mario Desmeules",
    "nom_famille":"Desmeules",
    "titre_genre2":"Conseiller",
    "remuneration":"7242",
    "allocation":"3309",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10551",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":2701,
    "nom_corrige2":"Mathieu Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"7242",
    "allocation":"3309",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10551",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":2702,
    "nom_corrige2":"Michel Crevier",
    "nom_famille":"Crevier",
    "titre_genre2":"Conseiller",
    "remuneration":"7242",
    "allocation":"3309",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10551",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":2703,
    "nom_corrige2":"Louis Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"6858",
    "allocation":"3685",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10543",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":2704,
    "nom_corrige2":"Louise Magnan",
    "nom_famille":"Magnan",
    "titre_genre2":"Conseillère",
    "remuneration":"6858",
    "allocation":"3685",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10543",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":2705,
    "nom_corrige2":"Lynda Bouffard",
    "nom_famille":"Bouffard",
    "titre_genre2":"Conseillère",
    "remuneration":"7139",
    "allocation":"3382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10521",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":2706,
    "nom_corrige2":"Daniel Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"6964",
    "allocation":"3382",
    "remuneration2":"112,00$",
    "allocation2":"56,00$",
    "total":"10514",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":2707,
    "nom_corrige2":"Luc A Bonneau",
    "nom_famille":"A Bonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"6981",
    "allocation":"3491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10472",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":2708,
    "nom_corrige2":"Isabelle Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseillère",
    "remuneration":"6981",
    "allocation":"3491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10472",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":2709,
    "nom_corrige2":"Mario Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseiller",
    "remuneration":"6981",
    "allocation":"3491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10472",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":2710,
    "nom_corrige2":"Nathalie Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseillère",
    "remuneration":"6981",
    "allocation":"3491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10472",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":2711,
    "nom_corrige2":"Vincent Pagé",
    "nom_famille":"Pagé",
    "titre_genre2":"Conseiller",
    "remuneration":"6981",
    "allocation":"3491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10472",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":2712,
    "nom_corrige2":"Angèle Forest",
    "nom_famille":"Forest",
    "titre_genre2":"Conseillère",
    "remuneration":"6980",
    "allocation":"3490",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10470",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":2713,
    "nom_corrige2":"Keven Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Conseiller",
    "remuneration":"7807",
    "allocation":"2654",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10461",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":2714,
    "nom_corrige2":"Michel Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"7807",
    "allocation":"2654",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10461",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":2715,
    "nom_corrige2":"Sabin Westernerg",
    "nom_famille":"Westernerg",
    "titre_genre2":"Conseiller",
    "remuneration":"7807",
    "allocation":"2654",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10461",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":2716,
    "nom_corrige2":"Claude Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseiller",
    "remuneration":"6971",
    "allocation":"3485",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10456",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":2717,
    "nom_corrige2":"Yves Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"6968",
    "allocation":"3484",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10452",
    "ville":"L'Ascension",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"970"
  },
  {
    "ID":2718,
    "nom_corrige2":"Gérald Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Maire",
    "remuneration":"6966",
    "allocation":"3483",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10449",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":2719,
    "nom_corrige2":"Simon-Pierre Caron Labranche",
    "nom_famille":"Caron Labranche",
    "titre_genre2":"Conseiller",
    "remuneration":"6970",
    "allocation":"3476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":2720,
    "nom_corrige2":"Bruno Guilbault",
    "nom_famille":"Guilbault",
    "titre_genre2":"Conseiller",
    "remuneration":"6970",
    "allocation":"3476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":2721,
    "nom_corrige2":"Laurence Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseillère",
    "remuneration":"6970",
    "allocation":"3476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":2722,
    "nom_corrige2":"Lucie Racine",
    "nom_famille":"Racine",
    "titre_genre2":"Conseillère",
    "remuneration":"6970",
    "allocation":"3476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":2723,
    "nom_corrige2":"Marie-Claude Bourbeau",
    "nom_famille":"Bourbeau",
    "titre_genre2":"Conseillère",
    "remuneration":"6970",
    "allocation":"3476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":2724,
    "nom_corrige2":"Pascal Verreault",
    "nom_famille":"Verreault",
    "titre_genre2":"Conseiller",
    "remuneration":"6970",
    "allocation":"3476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Joachim",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1415"
  },
  {
    "ID":2725,
    "nom_corrige2":"André Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseiller",
    "remuneration":"6964",
    "allocation":"3482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":2726,
    "nom_corrige2":"Cécile Comtois",
    "nom_famille":"Comtois",
    "titre_genre2":"Conseillère",
    "remuneration":"6964",
    "allocation":"3482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":2727,
    "nom_corrige2":"Denis Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"6964",
    "allocation":"3482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":2728,
    "nom_corrige2":"Vanessa Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"6964",
    "allocation":"3482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10446",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":2729,
    "nom_corrige2":"Ghislain Henri",
    "nom_famille":"Henri",
    "titre_genre2":"Conseiller",
    "remuneration":"6756",
    "allocation":"3378",
    "remuneration2":"207,00$",
    "allocation2":"104,00$",
    "total":"10445",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":2730,
    "nom_corrige2":"Mélodie Boissy",
    "nom_famille":"Boissy",
    "titre_genre2":"Conseillère",
    "remuneration":"6962",
    "allocation":"3481",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10443",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":2731,
    "nom_corrige2":"Anthony Mangione",
    "nom_famille":"Mangione",
    "titre_genre2":"Conseiller",
    "remuneration":"6962",
    "allocation":"3481",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10443",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":2732,
    "nom_corrige2":"Karine Coallier",
    "nom_famille":"Coallier",
    "titre_genre2":"Conseillère",
    "remuneration":"6962",
    "allocation":"3481",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10443",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":2733,
    "nom_corrige2":"Louise Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseillère",
    "remuneration":"6962",
    "allocation":"3481",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10443",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":2734,
    "nom_corrige2":"Denis Englis",
    "nom_famille":"Englis",
    "titre_genre2":"Conseiller",
    "remuneration":"6962",
    "allocation":"3481",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10443",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":2735,
    "nom_corrige2":"Rejean Cousineau",
    "nom_famille":"Cousineau",
    "titre_genre2":"Conseiller",
    "remuneration":"6962",
    "allocation":"3481",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10443",
    "ville":"Saint-Patrice-de-Sherrington",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2074"
  },
  {
    "ID":2736,
    "nom_corrige2":"Michel Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Conseiller",
    "remuneration":"6394",
    "allocation":"3199",
    "remuneration2":"390,00$",
    "allocation2":"442,00$",
    "total":"10425",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":2737,
    "nom_corrige2":"Julie Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseillère",
    "remuneration":"7039",
    "allocation":"3382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10421",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":2738,
    "nom_corrige2":"Normand Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Maire",
    "remuneration":"6945",
    "allocation":"3472",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10417",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":2739,
    "nom_corrige2":"André Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"6940",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10407",
    "ville":"Grenville",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1856"
  },
  {
    "ID":2740,
    "nom_corrige2":"Jean-Marc Collin",
    "nom_famille":"Collin",
    "titre_genre2":"Conseiller",
    "remuneration":"6934",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10401",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":2741,
    "nom_corrige2":"Claude Vibert",
    "nom_famille":"Vibert",
    "titre_genre2":"Conseiller",
    "remuneration":"6934",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10401",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":2742,
    "nom_corrige2":"Laurentia Duguay",
    "nom_famille":"Duguay",
    "titre_genre2":"Conseillère",
    "remuneration":"6934",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10401",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":2743,
    "nom_corrige2":"Bianca Vibert",
    "nom_famille":"Vibert",
    "titre_genre2":"Conseillère",
    "remuneration":"6934",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10401",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":2744,
    "nom_corrige2":"Jean Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"6934",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10401",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":2745,
    "nom_corrige2":"Pierre Vibert",
    "nom_famille":"Vibert",
    "titre_genre2":"Conseiller",
    "remuneration":"6934",
    "allocation":"3467",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10401",
    "ville":"Longue-Pointe-de-Mingan",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"414"
  },
  {
    "ID":2746,
    "nom_corrige2":"Alain Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Maire",
    "remuneration":"6931",
    "allocation":"3465",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10396",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":2747,
    "nom_corrige2":"Robert Vallée",
    "nom_famille":"Vallée",
    "titre_genre2":"Conseiller",
    "remuneration":"6933",
    "allocation":"3461",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10394",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":2748,
    "nom_corrige2":"Rosaire Phaneuf",
    "nom_famille":"Phaneuf",
    "titre_genre2":"Conseiller",
    "remuneration":"7173",
    "allocation":"3212",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10385",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":2749,
    "nom_corrige2":"Daniel Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"252,00$",
    "allocation2":"126,00$",
    "total":"10378",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":2750,
    "nom_corrige2":"Louis Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"7707",
    "allocation":"2654",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10361",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":2751,
    "nom_corrige2":"Marc Levesque",
    "nom_famille":"Levesque",
    "titre_genre2":"Conseiller",
    "remuneration":"5179",
    "allocation":"5179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10358",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":2752,
    "nom_corrige2":"Cydia Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"5179",
    "allocation":"5179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10358",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":2753,
    "nom_corrige2":"Johanne Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseillère",
    "remuneration":"5179",
    "allocation":"5179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10358",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":2754,
    "nom_corrige2":"Simon Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"5179",
    "allocation":"5179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10358",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":2755,
    "nom_corrige2":"Alexandre Lefrançois",
    "nom_famille":"Lefrançois",
    "titre_genre2":"Conseiller",
    "remuneration":"5179",
    "allocation":"5179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10358",
    "ville":"Saint-Alexandre-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2518"
  },
  {
    "ID":2756,
    "nom_corrige2":"Bruneau Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseiller",
    "remuneration":"6964",
    "allocation":"3382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10346",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":2757,
    "nom_corrige2":"Louise Lafrance",
    "nom_famille":"Lafrance",
    "titre_genre2":"Conseillère",
    "remuneration":"8037",
    "allocation":"2286",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10323",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":2758,
    "nom_corrige2":"Céline Dumas",
    "nom_famille":"Dumas",
    "titre_genre2":"Conseillère",
    "remuneration":"6880",
    "allocation":"3440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10320",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":2759,
    "nom_corrige2":"Martin Vaudreuil",
    "nom_famille":"Vaudreuil",
    "titre_genre2":"Conseiller",
    "remuneration":"6880",
    "allocation":"3440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10320",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":2760,
    "nom_corrige2":"Patricia Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseillère",
    "remuneration":"6880",
    "allocation":"3440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10320",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":2761,
    "nom_corrige2":"Marie-Josée Boissonneault",
    "nom_famille":"Boissonneault",
    "titre_genre2":"Conseillère",
    "remuneration":"6880",
    "allocation":"3440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10320",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":2762,
    "nom_corrige2":"Robert Juien",
    "nom_famille":"Juien",
    "titre_genre2":"Conseiller",
    "remuneration":"6876",
    "allocation":"3438",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10314",
    "ville":"Amos",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"12 675"
  },
  {
    "ID":2763,
    "nom_corrige2":"Bernard Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"6876",
    "allocation":"3438",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10314",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":2764,
    "nom_corrige2":"Alain Grégoire",
    "nom_famille":"Grégoire",
    "titre_genre2":"Maire",
    "remuneration":"6875",
    "allocation":"3438",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10313",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":2765,
    "nom_corrige2":"Alain Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"6873",
    "allocation":"3436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10309",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":2766,
    "nom_corrige2":"André Valiquette",
    "nom_famille":"Valiquette",
    "titre_genre2":"Conseiller",
    "remuneration":"6873",
    "allocation":"3436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10309",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":2767,
    "nom_corrige2":"Steve Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseiller",
    "remuneration":"6873",
    "allocation":"3436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10309",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":2768,
    "nom_corrige2":"Chrytal Luscombe",
    "nom_famille":"Luscombe",
    "titre_genre2":"Conseillère",
    "remuneration":"6873",
    "allocation":"3436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10309",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":2769,
    "nom_corrige2":"Bertrand Gélinas",
    "nom_famille":"Gélinas",
    "titre_genre2":"Conseiller",
    "remuneration":"6873",
    "allocation":"3436",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10309",
    "ville":"Témiscaming",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2353"
  },
  {
    "ID":2770,
    "nom_corrige2":"Gilles Sénécal",
    "nom_famille":"Sénécal",
    "titre_genre2":"Conseiller",
    "remuneration":"6871",
    "allocation":"3435",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10306",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":2771,
    "nom_corrige2":"David Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseiller",
    "remuneration":"7122",
    "allocation":"3165",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10287",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":2772,
    "nom_corrige2":"Germain Pitre",
    "nom_famille":"Pitre",
    "titre_genre2":"Conseiller",
    "remuneration":"7122",
    "allocation":"3165",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10287",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":2773,
    "nom_corrige2":"Louis-Philippe Laprade",
    "nom_famille":"Laprade",
    "titre_genre2":"Conseiller",
    "remuneration":"7122",
    "allocation":"3165",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10287",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":2774,
    "nom_corrige2":"Réjean Collette",
    "nom_famille":"Collette",
    "titre_genre2":"Conseiller",
    "remuneration":"7122",
    "allocation":"3165",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10287",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":2775,
    "nom_corrige2":"Robert Mayrand",
    "nom_famille":"Mayrand",
    "titre_genre2":"Conseiller",
    "remuneration":"7122",
    "allocation":"3165",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10287",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":2776,
    "nom_corrige2":"Marc-André Girard-Provos",
    "nom_famille":"Girard-Provos",
    "titre_genre2":"Conseiller",
    "remuneration":"7122",
    "allocation":"3165",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10287",
    "ville":"Saint-Antoine-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1844"
  },
  {
    "ID":2777,
    "nom_corrige2":"Marie-Ève Godbout",
    "nom_famille":"Godbout",
    "titre_genre2":"Conseillère",
    "remuneration":"7114",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10250",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":2778,
    "nom_corrige2":"Jacinthe Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"7114",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10250",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":2779,
    "nom_corrige2":"Jean-Claude Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Conseiller",
    "remuneration":"7114",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10250",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":2780,
    "nom_corrige2":"Mathieu-Olivier St-Louis",
    "nom_famille":"St-Louis",
    "titre_genre2":"Conseiller",
    "remuneration":"7114",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10250",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":2781,
    "nom_corrige2":"Renald Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"7114",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10250",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":2782,
    "nom_corrige2":"Régis Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Conseiller",
    "remuneration":"7114",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10250",
    "ville":"Cap-Chat",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2547"
  },
  {
    "ID":2783,
    "nom_corrige2":"Gilbert Boileau",
    "nom_famille":"Boileau",
    "titre_genre2":"Conseiller",
    "remuneration":"6832",
    "allocation":"3416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10248",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":2784,
    "nom_corrige2":"Jacques Mayer",
    "nom_famille":"Mayer",
    "titre_genre2":"Conseiller",
    "remuneration":"3268",
    "allocation":"1634",
    "remuneration2":"3549",
    "allocation2":"1774",
    "total":"10225",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":2785,
    "nom_corrige2":"François Robitaille",
    "nom_famille":"Robitaille",
    "titre_genre2":"Conseiller",
    "remuneration":"6816",
    "allocation":"3408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10224",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":2786,
    "nom_corrige2":"Bruno Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseiller",
    "remuneration":"6816",
    "allocation":"3408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10224",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":2787,
    "nom_corrige2":"Gervais Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"6816",
    "allocation":"3408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10224",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":2788,
    "nom_corrige2":"Julie Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseillère",
    "remuneration":"6816",
    "allocation":"3408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10224",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":2789,
    "nom_corrige2":"Michel L'Heureux",
    "nom_famille":"L'Heureux",
    "titre_genre2":"Conseiller",
    "remuneration":"6816",
    "allocation":"3408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10224",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":2790,
    "nom_corrige2":"Richard Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseiller",
    "remuneration":"6816",
    "allocation":"3408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10224",
    "ville":"Saint-Henri",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"6103"
  },
  {
    "ID":2791,
    "nom_corrige2":"Michel Longtin",
    "nom_famille":"Longtin",
    "titre_genre2":"Maire suppléant",
    "remuneration":"6809",
    "allocation":"3405",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10214",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":2792,
    "nom_corrige2":"Marc-André Laberge",
    "nom_famille":"Laberge",
    "titre_genre2":"Conseiller",
    "remuneration":"6879",
    "allocation":"3327",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10206",
    "ville":"Franklin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1717"
  },
  {
    "ID":2793,
    "nom_corrige2":"Darell Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"6803",
    "allocation":"3402",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10205",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":2794,
    "nom_corrige2":"André Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"6803",
    "allocation":"3402",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10205",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":2795,
    "nom_corrige2":"Julie Leblond",
    "nom_famille":"Leblond",
    "titre_genre2":"Conseillère",
    "remuneration":"6803",
    "allocation":"3402",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10205",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":2796,
    "nom_corrige2":"Renald Douin",
    "nom_famille":"Douin",
    "titre_genre2":"Conseiller",
    "remuneration":"6803",
    "allocation":"3402",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10205",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":2797,
    "nom_corrige2":"Guylaine Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"6791",
    "allocation":"3395",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10186",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":2798,
    "nom_corrige2":"Richard Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"6791",
    "allocation":"3395",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10186",
    "ville":"Saint-Michel-des-Saints",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2809"
  },
  {
    "ID":2799,
    "nom_corrige2":"Michael Tousignant",
    "nom_famille":"Tousignant",
    "titre_genre2":"Conseiller",
    "remuneration":"6784",
    "allocation":"3392",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10176",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":2800,
    "nom_corrige2":"Claude Durand",
    "nom_famille":"Durand",
    "titre_genre2":"Conseiller",
    "remuneration":"6784",
    "allocation":"3392",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10176",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":2801,
    "nom_corrige2":"Gilles Marchand",
    "nom_famille":"Marchand",
    "titre_genre2":"Conseiller",
    "remuneration":"6784",
    "allocation":"3392",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10176",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":2802,
    "nom_corrige2":"Jean-Lorrain Lafond",
    "nom_famille":"Lafond",
    "titre_genre2":"Conseiller",
    "remuneration":"6784",
    "allocation":"3392",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10176",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":2803,
    "nom_corrige2":"Louis-Vincent Legault",
    "nom_famille":"Legault",
    "titre_genre2":"Conseiller",
    "remuneration":"6784",
    "allocation":"3392",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10176",
    "ville":"Saint-Pierre-les-Becquets",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1181"
  },
  {
    "ID":2804,
    "nom_corrige2":"Laurent Laverdière",
    "nom_famille":"Laverdière",
    "titre_genre2":"Maire",
    "remuneration":"6780",
    "allocation":"3388",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10168",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":2805,
    "nom_corrige2":"Jaclin Bégin",
    "nom_famille":"Bégin",
    "titre_genre2":"Maire",
    "remuneration":"7348",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10166",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":2806,
    "nom_corrige2":"Michael Sudlow",
    "nom_famille":"Sudlow",
    "titre_genre2":"Conseiller",
    "remuneration":"6777",
    "allocation":"3388",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10165",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":2807,
    "nom_corrige2":"Jean Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"7507",
    "allocation":"2654",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10161",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":2808,
    "nom_corrige2":"Nellie Fleury",
    "nom_famille":"Fleury",
    "titre_genre2":"Conseillère",
    "remuneration":"7507",
    "allocation":"2654",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10161",
    "ville":"L'Ascension-de-Notre-Seigneur",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2240"
  },
  {
    "ID":2809,
    "nom_corrige2":"Richard Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseiller",
    "remuneration":"6764",
    "allocation":"3382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10146",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":2810,
    "nom_corrige2":"Danielle Boulet",
    "nom_famille":"Boulet",
    "titre_genre2":"Conseillère",
    "remuneration":"6764",
    "allocation":"3382",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10146",
    "ville":"Nantes",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1417"
  },
  {
    "ID":2811,
    "nom_corrige2":"Yvon Forget",
    "nom_famille":"Forget",
    "titre_genre2":"Conseiller",
    "remuneration":"6756",
    "allocation":"3378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10134",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":2812,
    "nom_corrige2":"Marie-Claude Racine",
    "nom_famille":"Racine",
    "titre_genre2":"Conseillère",
    "remuneration":"6756",
    "allocation":"3378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10134",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":2813,
    "nom_corrige2":"Maurice Rolland",
    "nom_famille":"Rolland",
    "titre_genre2":"Conseiller",
    "remuneration":"6756",
    "allocation":"3378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10134",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":2814,
    "nom_corrige2":"John Bradley",
    "nom_famille":"Bradley",
    "titre_genre2":"Conseiller",
    "remuneration":"6756",
    "allocation":"3378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10134",
    "ville":"Saint-Marc-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2308"
  },
  {
    "ID":2815,
    "nom_corrige2":"François Pichette",
    "nom_famille":"Pichette",
    "titre_genre2":"Conseiller",
    "remuneration":"6753",
    "allocation":"3376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10129",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":2816,
    "nom_corrige2":"Martin Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"6753",
    "allocation":"3376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10129",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":2817,
    "nom_corrige2":"Nancy Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"6753",
    "allocation":"3376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10129",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":2818,
    "nom_corrige2":"Nathalie Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseillère",
    "remuneration":"6753",
    "allocation":"3376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10129",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":2819,
    "nom_corrige2":"Patrick Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseiller",
    "remuneration":"6753",
    "allocation":"3376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10129",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":2820,
    "nom_corrige2":"Véronique Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Conseillère",
    "remuneration":"6753",
    "allocation":"3376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10129",
    "ville":"Saint-Pierre-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1731"
  },
  {
    "ID":2821,
    "nom_corrige2":"Jean Précourt",
    "nom_famille":"Précourt",
    "titre_genre2":"Conseiller",
    "remuneration":"6394",
    "allocation":"3199",
    "remuneration2":"220,00$",
    "allocation2":"295,00$",
    "total":"10108",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":2822,
    "nom_corrige2":"Logan Loiseau",
    "nom_famille":"Loiseau",
    "titre_genre2":"Conseiller",
    "remuneration":"6735",
    "allocation":"3367",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10102",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":2823,
    "nom_corrige2":"Sébastien Houle",
    "nom_famille":"Houle",
    "titre_genre2":"Conseiller",
    "remuneration":"6120",
    "allocation":"3972",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10092",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":2824,
    "nom_corrige2":"Denyse Riquier",
    "nom_famille":"Riquier",
    "titre_genre2":"Conseillère",
    "remuneration":"6120",
    "allocation":"3972",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10092",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":2825,
    "nom_corrige2":"Marylin Shallow",
    "nom_famille":"Shallow",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"6619",
    "allocation":"3160",
    "remuneration2":"209,00$",
    "allocation2":"104,00$",
    "total":"10092",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":2826,
    "nom_corrige2":"Nathalie Traversy",
    "nom_famille":"Traversy",
    "titre_genre2":"Conseillère",
    "remuneration":"6394",
    "allocation":"3199",
    "remuneration2":"415,00$",
    "allocation2":"74,00$",
    "total":"10082",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":2827,
    "nom_corrige2":"Alain Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Conseiller",
    "remuneration":"7099",
    "allocation":"2971",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10070",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":2828,
    "nom_corrige2":"Marie-Pier Guévin-Michaud",
    "nom_famille":"Guévin-Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"6394",
    "allocation":"3199",
    "remuneration2":"290,00$",
    "allocation2":"145,00$",
    "total":"10028",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":2829,
    "nom_corrige2":"Diane Pinet",
    "nom_famille":"Pinet",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"6673",
    "allocation":"3336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10009",
    "ville":"Lac-Sergent",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"616"
  },
  {
    "ID":2830,
    "nom_corrige2":"Wiliam Scott",
    "nom_famille":"Scott",
    "titre_genre2":"Conseiller",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":2831,
    "nom_corrige2":"Claudette Dupras",
    "nom_famille":"Dupras",
    "titre_genre2":"Conseillère",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":2832,
    "nom_corrige2":"Éric Fafard",
    "nom_famille":"Fafard",
    "titre_genre2":"Conseiller",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Ogden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"814"
  },
  {
    "ID":2833,
    "nom_corrige2":"Antoine Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":2834,
    "nom_corrige2":"Cindy Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":2835,
    "nom_corrige2":"Diane Rhéaume",
    "nom_famille":"Rhéaume",
    "titre_genre2":"Conseillère",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":2836,
    "nom_corrige2":"Jean-François Allen",
    "nom_famille":"Allen",
    "titre_genre2":"Conseiller",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":2837,
    "nom_corrige2":"Hélène Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseillère",
    "remuneration":"6667",
    "allocation":"3333",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"10000",
    "ville":"Saint-Isidore",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3542"
  },
  {
    "ID":2838,
    "nom_corrige2":"Patrice Goupil",
    "nom_famille":"Goupil",
    "titre_genre2":"Maire",
    "remuneration":"5390",
    "allocation":"2695",
    "remuneration2":"1264",
    "allocation2":"632,00$",
    "total":"9981",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":2839,
    "nom_corrige2":"Pierre Dumas",
    "nom_famille":"Dumas",
    "titre_genre2":"Maire suppléant",
    "remuneration":"6647",
    "allocation":"3326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9973",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":2840,
    "nom_corrige2":"Claude Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Maire suppléant",
    "remuneration":"6641",
    "allocation":"3321",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9962",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":2841,
    "nom_corrige2":"Harry Bird",
    "nom_famille":"Bird",
    "titre_genre2":"Conseiller",
    "remuneration":"6634",
    "allocation":"3317",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9951",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":2842,
    "nom_corrige2":"Rémy Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseiller",
    "remuneration":"6631",
    "allocation":"3316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9947",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":2843,
    "nom_corrige2":"André Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"6631",
    "allocation":"3316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9947",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":2844,
    "nom_corrige2":"Josée Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseillère",
    "remuneration":"6631",
    "allocation":"3316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9947",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":2845,
    "nom_corrige2":"François Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"6631",
    "allocation":"3316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9947",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"3130"
  },
  {
    "ID":2846,
    "nom_corrige2":"Mathieu Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"6630",
    "allocation":"3315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9945",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":2847,
    "nom_corrige2":"Jean-François Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"6630",
    "allocation":"3315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9945",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":2848,
    "nom_corrige2":"Julie Baillargeon",
    "nom_famille":"Baillargeon",
    "titre_genre2":"Conseillère",
    "remuneration":"6630",
    "allocation":"3315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9945",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":2849,
    "nom_corrige2":"Mélanie Genesse",
    "nom_famille":"Genesse",
    "titre_genre2":"Conseillère",
    "remuneration":"6630",
    "allocation":"3315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9945",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":2850,
    "nom_corrige2":"Paul Lavallière",
    "nom_famille":"Lavallière",
    "titre_genre2":"Conseiller",
    "remuneration":"6630",
    "allocation":"3315",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9945",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2470"
  },
  {
    "ID":2851,
    "nom_corrige2":"Frédéric Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseiller",
    "remuneration":"6723",
    "allocation":"3212",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9935",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":2852,
    "nom_corrige2":"Sabryna Barabé-Favreau",
    "nom_famille":"Barabé-Favreau",
    "titre_genre2":"Conseillère",
    "remuneration":"7142",
    "allocation":"2791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9933",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":2853,
    "nom_corrige2":"Alain Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"4410",
    "allocation":"2109",
    "remuneration2":"2205",
    "allocation2":"1198",
    "total":"9922",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":2854,
    "nom_corrige2":"Jean-Charles Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"6606",
    "allocation":"3303",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9909",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":2855,
    "nom_corrige2":"Richard Desbiens",
    "nom_famille":"Desbiens",
    "titre_genre2":"Conseiller",
    "remuneration":"6606",
    "allocation":"3303",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9909",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":2856,
    "nom_corrige2":"François Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"6602",
    "allocation":"3301",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9903",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":2857,
    "nom_corrige2":"Pierre-Luc Archambault",
    "nom_famille":"Archambault",
    "titre_genre2":"Conseiller",
    "remuneration":"6601",
    "allocation":"3301",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9902",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":2858,
    "nom_corrige2":"Samuel Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Conseiller",
    "remuneration":"6598",
    "allocation":"3299",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9897",
    "ville":"Saint-Joseph-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"5321"
  },
  {
    "ID":2859,
    "nom_corrige2":"Jean Provost",
    "nom_famille":"Provost",
    "titre_genre2":"Conseiller",
    "remuneration":"6673",
    "allocation":"3212",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9885",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":2860,
    "nom_corrige2":"Mélanie Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseillère",
    "remuneration":"6673",
    "allocation":"3212",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9885",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":2861,
    "nom_corrige2":"Bernard Georges-Étienne",
    "nom_famille":"Georges-Étienne",
    "titre_genre2":"Conseiller",
    "remuneration":"6673",
    "allocation":"3212",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9885",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":2862,
    "nom_corrige2":"Éric Lussier-Houle",
    "nom_famille":"Lussier-Houle",
    "titre_genre2":"Conseiller",
    "remuneration":"9881",
    "allocation":"",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9881",
    "ville":"Saint-Mathieu-de-Beloeil",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3031"
  },
  {
    "ID":2863,
    "nom_corrige2":"Sylvain Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseiller",
    "remuneration":"6587",
    "allocation":"3294",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9881",
    "ville":"Adstock",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3170"
  },
  {
    "ID":2864,
    "nom_corrige2":"Marie-Michèle Paradis",
    "nom_famille":"Paradis",
    "titre_genre2":"Conseillère",
    "remuneration":"6120",
    "allocation":"3760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9880",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":2865,
    "nom_corrige2":"Réjean Cossette",
    "nom_famille":"Cossette",
    "titre_genre2":"Conseiller",
    "remuneration":"5780",
    "allocation":"2890",
    "remuneration2":"803,00$",
    "allocation2":"402,00$",
    "total":"9875",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":2866,
    "nom_corrige2":"Xavier Bouhy",
    "nom_famille":"Bouhy",
    "titre_genre2":"Conseiller",
    "remuneration":"6573",
    "allocation":"3287",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9860",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":2867,
    "nom_corrige2":"Céline Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Conseiller",
    "remuneration":"5816",
    "allocation":"2908",
    "remuneration2":"750,00$",
    "allocation2":"375,00$",
    "total":"9849",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":2868,
    "nom_corrige2":"Maureen Mcevoy",
    "nom_famille":"Mcevoy",
    "titre_genre2":"Conseillère",
    "remuneration":"6596",
    "allocation":"3248",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9844",
    "ville":"Low",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1060"
  },
  {
    "ID":2869,
    "nom_corrige2":"Patrick Pilon",
    "nom_famille":"Pilon",
    "titre_genre2":"Conseiller",
    "remuneration":"5995",
    "allocation":"3847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9842",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":2870,
    "nom_corrige2":"Michel Mondoux",
    "nom_famille":"Mondoux",
    "titre_genre2":"Conseiller",
    "remuneration":"5995",
    "allocation":"3847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9842",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":2871,
    "nom_corrige2":"Yvan Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"5995",
    "allocation":"3847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9842",
    "ville":"Saint-Norbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1143"
  },
  {
    "ID":2872,
    "nom_corrige2":"Yves Monast",
    "nom_famille":"Monast",
    "titre_genre2":"Conseiller",
    "remuneration":"6452",
    "allocation":"3226",
    "remuneration2":"108,00$",
    "allocation2":"54,00$",
    "total":"9840",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":2873,
    "nom_corrige2":"Myriam La Frenière",
    "nom_famille":"La Frenière",
    "titre_genre2":"Conseillère",
    "remuneration":"6623",
    "allocation":"3212",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9835",
    "ville":"La Présentation",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2715"
  },
  {
    "ID":2874,
    "nom_corrige2":"Michel Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"6257",
    "allocation":"3128",
    "remuneration2":"450,00$",
    "allocation2":"0",
    "total":"9835",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":2875,
    "nom_corrige2":"Marie-Claude Sauvé",
    "nom_famille":"Sauvé",
    "titre_genre2":"Conseillère",
    "remuneration":"6552",
    "allocation":"3276",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9828",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":2876,
    "nom_corrige2":"Brigitte Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseillère",
    "remuneration":"7497",
    "allocation":"2327",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9824",
    "ville":"Saint-Prime",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2843"
  },
  {
    "ID":2877,
    "nom_corrige2":"André Courtemanche",
    "nom_famille":"Courtemanche",
    "titre_genre2":"Conseiller",
    "remuneration":"6543",
    "allocation":"2286",
    "remuneration2":"658,00$",
    "allocation2":"329,00$",
    "total":"9816",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":2878,
    "nom_corrige2":"Stéphanie Martin-Gauthier",
    "nom_famille":"Martin-Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"6288",
    "allocation":"3144",
    "remuneration2":"256,00$",
    "allocation2":"128,00$",
    "total":"9816",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":2879,
    "nom_corrige2":"Sandra Harrisson",
    "nom_famille":"Harrisson",
    "titre_genre2":"Conseillère",
    "remuneration":"6611",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9795",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":2880,
    "nom_corrige2":"Deborah Bishop",
    "nom_famille":"Bishop",
    "titre_genre2":"Conseillère",
    "remuneration":"6611",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9795",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":2881,
    "nom_corrige2":"Harvey Stevens",
    "nom_famille":"Stevens",
    "titre_genre2":"Conseiller",
    "remuneration":"6611",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9795",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":2882,
    "nom_corrige2":"Nicholas Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"6611",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9795",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":2883,
    "nom_corrige2":"Valérie Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseillère",
    "remuneration":"6611",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9795",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":2884,
    "nom_corrige2":"Philippe Dutil",
    "nom_famille":"Dutil",
    "titre_genre2":"Conseiller",
    "remuneration":"6611",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9795",
    "ville":"Stanstead",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3041"
  },
  {
    "ID":2885,
    "nom_corrige2":"Norman Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"6980",
    "allocation":"2791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9771",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":2886,
    "nom_corrige2":"Mélanie Bourgault",
    "nom_famille":"Bourgault",
    "titre_genre2":"Mairesse",
    "remuneration":"6512",
    "allocation":"3256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9768",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":2887,
    "nom_corrige2":"Mario Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseiller",
    "remuneration":"5628",
    "allocation":"2814",
    "remuneration2":"868,00$",
    "allocation2":"434,00$",
    "total":"9744",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":2888,
    "nom_corrige2":"Angus Lee",
    "nom_famille":"Lee",
    "titre_genre2":"Conseiller",
    "remuneration":"6496",
    "allocation":"3248",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9744",
    "ville":"Low",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1060"
  },
  {
    "ID":2889,
    "nom_corrige2":"Joanne Mayer",
    "nom_famille":"Mayer",
    "titre_genre2":"Conseillère",
    "remuneration":"6496",
    "allocation":"3248",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9744",
    "ville":"Low",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1060"
  },
  {
    "ID":2890,
    "nom_corrige2":"Luc Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseiller",
    "remuneration":"6496",
    "allocation":"3248",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9744",
    "ville":"Low",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1060"
  },
  {
    "ID":2891,
    "nom_corrige2":"Pierre Godbout",
    "nom_famille":"Godbout",
    "titre_genre2":"Maire",
    "remuneration":"6479",
    "allocation":"3239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9718",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":2892,
    "nom_corrige2":"David Ferguson",
    "nom_famille":"Ferguson",
    "titre_genre2":"Maire",
    "remuneration":"6468",
    "allocation":"3234",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9702",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":2893,
    "nom_corrige2":"André Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseiller",
    "remuneration":"6465",
    "allocation":"3233",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9698",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":2894,
    "nom_corrige2":"Anne Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Conseillère",
    "remuneration":"6465",
    "allocation":"3233",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9698",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":2895,
    "nom_corrige2":"Annie Galipeau",
    "nom_famille":"Galipeau",
    "titre_genre2":"Conseillère",
    "remuneration":"6465",
    "allocation":"3233",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9698",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":2896,
    "nom_corrige2":"Charles Rondeau",
    "nom_famille":"Rondeau",
    "titre_genre2":"Conseiller",
    "remuneration":"6465",
    "allocation":"3233",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9698",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":2897,
    "nom_corrige2":"Marie-Anne Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseillère",
    "remuneration":"6465",
    "allocation":"3233",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9698",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":2898,
    "nom_corrige2":"Yves St-Jacques",
    "nom_famille":"St-Jacques",
    "titre_genre2":"Conseiller",
    "remuneration":"6465",
    "allocation":"3233",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9698",
    "ville":"Messines",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1648"
  },
  {
    "ID":2899,
    "nom_corrige2":"Marie-Soleil Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseillère",
    "remuneration":"6463",
    "allocation":"3231",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9694",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":2900,
    "nom_corrige2":"Edward Claxton",
    "nom_famille":"Claxton",
    "titre_genre2":"Conseiller",
    "remuneration":"6459",
    "allocation":"3230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9689",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":2901,
    "nom_corrige2":"Michel Roch",
    "nom_famille":"Roch",
    "titre_genre2":"Conseiller",
    "remuneration":"6459",
    "allocation":"3230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9689",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":2902,
    "nom_corrige2":"Olivier Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Conseiller",
    "remuneration":"6459",
    "allocation":"3230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9689",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":2903,
    "nom_corrige2":"Philippe Deschamps",
    "nom_famille":"Deschamps",
    "titre_genre2":"Conseiller",
    "remuneration":"6459",
    "allocation":"3230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9689",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":2904,
    "nom_corrige2":"Russ St-Germain",
    "nom_famille":"St-Germain",
    "titre_genre2":"Conseiller",
    "remuneration":"6459",
    "allocation":"3230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9689",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":2905,
    "nom_corrige2":"Élise A. Latour",
    "nom_famille":"A. Latour",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"6459",
    "allocation":"3230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9689",
    "ville":"Lac-des-Seize-Îles",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"210"
  },
  {
    "ID":2906,
    "nom_corrige2":"Gaetan Jodoin",
    "nom_famille":"Jodoin",
    "titre_genre2":"Conseiller",
    "remuneration":"6452",
    "allocation":"3226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9678",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":2907,
    "nom_corrige2":"Ghislaine Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseillère",
    "remuneration":"6452",
    "allocation":"3226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9678",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":2908,
    "nom_corrige2":"Guy Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseiller",
    "remuneration":"6452",
    "allocation":"3226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9678",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":2909,
    "nom_corrige2":"Yvon Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseiller",
    "remuneration":"6452",
    "allocation":"3226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9678",
    "ville":"Saint-Damase",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2463"
  },
  {
    "ID":2910,
    "nom_corrige2":"Bernard Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"6298",
    "allocation":"3014",
    "remuneration2":"357,00$",
    "allocation2":"0",
    "total":"9669",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":2911,
    "nom_corrige2":"Alain Guillemette",
    "nom_famille":"Guillemette",
    "titre_genre2":"Maire",
    "remuneration":"6149",
    "allocation":"3075",
    "remuneration2":"294,00$",
    "allocation2":"147,00$",
    "total":"9665",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":2912,
    "nom_corrige2":"Michel Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"7365",
    "allocation":"2286",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9651",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":2913,
    "nom_corrige2":"Sylvie Tourangeau",
    "nom_famille":"Tourangeau",
    "titre_genre2":"Conseillère",
    "remuneration":"6125",
    "allocation":"3062",
    "remuneration2":"300,00$",
    "allocation2":"150,00$",
    "total":"9637",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":2914,
    "nom_corrige2":"Francis Marcotte",
    "nom_famille":"Marcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"3893",
    "allocation":"1947",
    "remuneration2":"2517",
    "allocation2":"1259",
    "total":"9616",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":2915,
    "nom_corrige2":"Pierre Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Conseiller",
    "remuneration":"6398",
    "allocation":"3199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9597",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":2916,
    "nom_corrige2":"Jonathan Gamelin",
    "nom_famille":"Gamelin",
    "titre_genre2":"Conseiller",
    "remuneration":"6394",
    "allocation":"3199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9593",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":2917,
    "nom_corrige2":"Josée Bussières",
    "nom_famille":"Bussières",
    "titre_genre2":"Conseillère",
    "remuneration":"6394",
    "allocation":"3199",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9593",
    "ville":"Pierreville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2201"
  },
  {
    "ID":2918,
    "nom_corrige2":"Francine Néron",
    "nom_famille":"Néron",
    "titre_genre2":"Conseillère",
    "remuneration":"6385",
    "allocation":"3193",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9578",
    "ville":"Macamic",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"2685"
  },
  {
    "ID":2919,
    "nom_corrige2":"Charles Corriveau",
    "nom_famille":"Corriveau",
    "titre_genre2":"Conseiller",
    "remuneration":"5736",
    "allocation":"3157",
    "remuneration2":"675,00$",
    "allocation2":"0",
    "total":"9568",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":2920,
    "nom_corrige2":"Nancy Toulza",
    "nom_famille":"Toulza",
    "titre_genre2":"Conseillère",
    "remuneration":"6377",
    "allocation":"3188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9565",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":2921,
    "nom_corrige2":"Douce Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"6368",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9552",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":2922,
    "nom_corrige2":"Vicky Boily",
    "nom_famille":"Boily",
    "titre_genre2":"Conseillère",
    "remuneration":"6367",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9551",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":2923,
    "nom_corrige2":"Danie Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"6367",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9551",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":2924,
    "nom_corrige2":"Fernand Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"6367",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9551",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":2925,
    "nom_corrige2":"Pascal Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseiller",
    "remuneration":"6367",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9551",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":2926,
    "nom_corrige2":"Dominique Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"6367",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9551",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":2927,
    "nom_corrige2":"Jean-Philippe Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"6367",
    "allocation":"3184",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9551",
    "ville":"Larouche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1705"
  },
  {
    "ID":2928,
    "nom_corrige2":"Annie Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"6366",
    "allocation":"3183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9549",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":2929,
    "nom_corrige2":"Éric Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"6366",
    "allocation":"3183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9549",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":2930,
    "nom_corrige2":"Jacques Rodgers",
    "nom_famille":"Rodgers",
    "titre_genre2":"Conseiller",
    "remuneration":"6366",
    "allocation":"3183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9549",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":2931,
    "nom_corrige2":"Julie Paiement",
    "nom_famille":"Paiement",
    "titre_genre2":"Conseillère",
    "remuneration":"6366",
    "allocation":"3183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9549",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":2932,
    "nom_corrige2":"Rodrigue Lacourcière",
    "nom_famille":"Lacourcière",
    "titre_genre2":"Conseiller",
    "remuneration":"6366",
    "allocation":"3183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9549",
    "ville":"Grand-Remous",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1194"
  },
  {
    "ID":2933,
    "nom_corrige2":"Véronique St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseillère",
    "remuneration":"5466",
    "allocation":"2733",
    "remuneration2":"884,00$",
    "allocation2":"442,00$",
    "total":"9525",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":2934,
    "nom_corrige2":"Marie-Céline Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"6345",
    "allocation":"3173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9518",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":2935,
    "nom_corrige2":"Lise Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"6348",
    "allocation":"3168",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9516",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":2936,
    "nom_corrige2":"Luc Bertrand",
    "nom_famille":"Bertrand",
    "titre_genre2":"Conseiller",
    "remuneration":"6348",
    "allocation":"3168",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9516",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":2937,
    "nom_corrige2":"Pierre Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"6348",
    "allocation":"3168",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9516",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":2938,
    "nom_corrige2":"Robert Beaudreault",
    "nom_famille":"Beaudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"6348",
    "allocation":"3168",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9516",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":2939,
    "nom_corrige2":"Sophie Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"6348",
    "allocation":"3168",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9516",
    "ville":"Saint-Ours",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1766"
  },
  {
    "ID":2940,
    "nom_corrige2":"Éric Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"6335",
    "allocation":"3167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9502",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":2941,
    "nom_corrige2":"François Berthiaume",
    "nom_famille":"Berthiaume",
    "titre_genre2":"Conseiller",
    "remuneration":"6334",
    "allocation":"3167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9501",
    "ville":"Saint-Denis-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2435"
  },
  {
    "ID":2942,
    "nom_corrige2":"André Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Maire",
    "remuneration":"4956",
    "allocation":"2484",
    "remuneration2":"1373",
    "allocation2":"686,00$",
    "total":"9499",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":2943,
    "nom_corrige2":"Marjolaine Larocque",
    "nom_famille":"Larocque",
    "titre_genre2":"Conseillère",
    "remuneration":"6318",
    "allocation":"3178",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9496",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":2944,
    "nom_corrige2":"Domenica Guzzo",
    "nom_famille":"Guzzo",
    "titre_genre2":"Conseillère",
    "remuneration":"6318",
    "allocation":"3178",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9496",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":2945,
    "nom_corrige2":"Réjean Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"6318",
    "allocation":"3178",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9496",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":2946,
    "nom_corrige2":"Vincent Dodier",
    "nom_famille":"Dodier",
    "titre_genre2":"Conseiller",
    "remuneration":"6318",
    "allocation":"3178",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9496",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":2947,
    "nom_corrige2":"Réjean Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"6302",
    "allocation":"3170",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9472",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":2948,
    "nom_corrige2":"Owen Mac Callum",
    "nom_famille":"Mac Callum",
    "titre_genre2":"Conseiller",
    "remuneration":"6601",
    "allocation":"2870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9471",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":2949,
    "nom_corrige2":"Randy Robert Smith",
    "nom_famille":"Robert Smith",
    "titre_genre2":"Conseiller",
    "remuneration":"6601",
    "allocation":"2870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9471",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":2950,
    "nom_corrige2":"Melissa Gushue",
    "nom_famille":"Gushue",
    "titre_genre2":"Conseillère",
    "remuneration":"6601",
    "allocation":"2870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9471",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":2951,
    "nom_corrige2":"Nathan Kaiser",
    "nom_famille":"Kaiser",
    "titre_genre2":"Conseiller",
    "remuneration":"6601",
    "allocation":"2870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9471",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":2952,
    "nom_corrige2":"Sonia Chiasson",
    "nom_famille":"Chiasson",
    "titre_genre2":"Conseillère",
    "remuneration":"6601",
    "allocation":"2870",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9471",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":2953,
    "nom_corrige2":"Christian Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"6310",
    "allocation":"3155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9465",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":2954,
    "nom_corrige2":"Dominique Laforce",
    "nom_famille":"Laforce",
    "titre_genre2":"Conseillère",
    "remuneration":"6310",
    "allocation":"3155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9465",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":2955,
    "nom_corrige2":"Francine Julien",
    "nom_famille":"Julien",
    "titre_genre2":"Conseillère",
    "remuneration":"6310",
    "allocation":"3155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9465",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":2956,
    "nom_corrige2":"Jocelyn Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Conseiller",
    "remuneration":"6310",
    "allocation":"3155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9465",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":2957,
    "nom_corrige2":"Luc Chapdelaine",
    "nom_famille":"Chapdelaine",
    "titre_genre2":"Conseiller",
    "remuneration":"6310",
    "allocation":"3155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9465",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":2958,
    "nom_corrige2":"Mathieu Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"6310",
    "allocation":"3155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9465",
    "ville":"Saint-Guillaume",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1497"
  },
  {
    "ID":2959,
    "nom_corrige2":"Philippe Dunn",
    "nom_famille":"Dunn",
    "titre_genre2":"Conseiller",
    "remuneration":"6307",
    "allocation":"3154",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9461",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":2960,
    "nom_corrige2":"Jocelyn Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"6343",
    "allocation":"3113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9456",
    "ville":"Chapais",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1399"
  },
  {
    "ID":2961,
    "nom_corrige2":"Daniel Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"6298",
    "allocation":"3150",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9448",
    "ville":"Sutton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"4768"
  },
  {
    "ID":2962,
    "nom_corrige2":"Denise Corneau-Bazinet",
    "nom_famille":"Corneau-Bazinet",
    "titre_genre2":"Conseillère",
    "remuneration":"6299",
    "allocation":"3149",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9448",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":2963,
    "nom_corrige2":"Gilles Payer",
    "nom_famille":"Payer",
    "titre_genre2":"Conseiller",
    "remuneration":"6299",
    "allocation":"3149",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9448",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":2964,
    "nom_corrige2":"Noël Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"6299",
    "allocation":"3149",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9448",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":2965,
    "nom_corrige2":"Raymond Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Conseiller",
    "remuneration":"6299",
    "allocation":"3149",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9448",
    "ville":"Duhamel",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"561"
  },
  {
    "ID":2966,
    "nom_corrige2":"Steve Robitaille",
    "nom_famille":"Robitaille",
    "titre_genre2":"Conseiller",
    "remuneration":"5943",
    "allocation":"2971",
    "remuneration2":"339,00$",
    "allocation2":"170,00$",
    "total":"9423",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":2967,
    "nom_corrige2":"Maxim Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Conseiller",
    "remuneration":"5736",
    "allocation":"3157",
    "remuneration2":"525,00$",
    "allocation2":"0",
    "total":"9418",
    "ville":"Saint-Charles-sur-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1831"
  },
  {
    "ID":2968,
    "nom_corrige2":"Lyssa Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseillère",
    "remuneration":"2534",
    "allocation":"1267",
    "remuneration2":"3744",
    "allocation2":"1872",
    "total":"9417",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":2969,
    "nom_corrige2":"Martin Evangeliste",
    "nom_famille":"Evangeliste",
    "titre_genre2":"Conseiller",
    "remuneration":"6273",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9409",
    "ville":"Saint-Roch-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2878"
  },
  {
    "ID":2970,
    "nom_corrige2":"Steeve Coll",
    "nom_famille":"Coll",
    "titre_genre2":"Conseiller",
    "remuneration":"6273",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9409",
    "ville":"Saint-Roch-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2878"
  },
  {
    "ID":2971,
    "nom_corrige2":"Guy Nadon",
    "nom_famille":"Nadon",
    "titre_genre2":"Conseiller",
    "remuneration":"6273",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9409",
    "ville":"Saint-Roch-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2878"
  },
  {
    "ID":2972,
    "nom_corrige2":"René Courtemanche",
    "nom_famille":"Courtemanche",
    "titre_genre2":"Conseiller",
    "remuneration":"6273",
    "allocation":"3136",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9409",
    "ville":"Saint-Roch-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2878"
  },
  {
    "ID":2973,
    "nom_corrige2":"Dany Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseillère",
    "remuneration":"6573",
    "allocation":"2825",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9398",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":2974,
    "nom_corrige2":"Nancy Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseillère",
    "remuneration":"6573",
    "allocation":"2825",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9398",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":2975,
    "nom_corrige2":"Patricia Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"6573",
    "allocation":"2825",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9398",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":2976,
    "nom_corrige2":"Richard Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Conseiller",
    "remuneration":"6573",
    "allocation":"2825",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9398",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":2977,
    "nom_corrige2":"Carole Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"6653",
    "allocation":"2426",
    "remuneration2":"207,00$",
    "allocation2":"104,00$",
    "total":"9390",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":2978,
    "nom_corrige2":"Robert Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Conseiller",
    "remuneration":"6257",
    "allocation":"3128",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":2979,
    "nom_corrige2":"Charline Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseillère",
    "remuneration":"6317",
    "allocation":"3068",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":2980,
    "nom_corrige2":"Édith Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Conseillère",
    "remuneration":"6317",
    "allocation":"3068",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":2981,
    "nom_corrige2":"Guillaume Painchaud",
    "nom_famille":"Painchaud",
    "titre_genre2":"Conseiller",
    "remuneration":"6317",
    "allocation":"3068",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":2982,
    "nom_corrige2":"Isabelle Thibeault",
    "nom_famille":"Thibeault",
    "titre_genre2":"Conseillère",
    "remuneration":"6317",
    "allocation":"3068",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":2983,
    "nom_corrige2":"Nick St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"6317",
    "allocation":"3068",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":2984,
    "nom_corrige2":"Tommy Laliberté",
    "nom_famille":"Laliberté",
    "titre_genre2":"Conseiller",
    "remuneration":"6317",
    "allocation":"3068",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9385",
    "ville":"Albanel",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2184"
  },
  {
    "ID":2985,
    "nom_corrige2":"Jennifer Levie",
    "nom_famille":"Levie",
    "titre_genre2":"Conseillère",
    "remuneration":"6255",
    "allocation":"3128",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9383",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":2986,
    "nom_corrige2":"Jean-Marc Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseiller",
    "remuneration":"6255",
    "allocation":"3128",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9383",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":2987,
    "nom_corrige2":"Julie Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseillère",
    "remuneration":"6255",
    "allocation":"3128",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9383",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":2988,
    "nom_corrige2":"Pierre Bossé",
    "nom_famille":"Bossé",
    "titre_genre2":"Maire",
    "remuneration":"6246",
    "allocation":"3123",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9369",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":2989,
    "nom_corrige2":"Patrick Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"6216",
    "allocation":"3108",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9324",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":2990,
    "nom_corrige2":"Peter McHarg",
    "nom_famille":"McHarg",
    "titre_genre2":"Conseiller",
    "remuneration":"6216",
    "allocation":"3108",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9324",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":2991,
    "nom_corrige2":"Nancy Vanasse",
    "nom_famille":"Vanasse",
    "titre_genre2":"Conseillère",
    "remuneration":"6216",
    "allocation":"3108",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9324",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":2992,
    "nom_corrige2":"Caroline Paul",
    "nom_famille":"Paul",
    "titre_genre2":"Conseillère",
    "remuneration":"6216",
    "allocation":"3108",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9324",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":2993,
    "nom_corrige2":"France Coulombe",
    "nom_famille":"Coulombe",
    "titre_genre2":"Conseillère",
    "remuneration":"6216",
    "allocation":"3108",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9324",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":2994,
    "nom_corrige2":"Nicolas Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"7027",
    "allocation":"2286",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9313",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":2995,
    "nom_corrige2":"Richard Bard",
    "nom_famille":"Bard",
    "titre_genre2":"Conseiller",
    "remuneration":"6298",
    "allocation":"3014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9312",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":2996,
    "nom_corrige2":"Brigitte Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"6298",
    "allocation":"3014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9312",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":2997,
    "nom_corrige2":"Linda Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseillère",
    "remuneration":"6298",
    "allocation":"3014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9312",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":2998,
    "nom_corrige2":"Lucienne Lagacé",
    "nom_famille":"Lagacé",
    "titre_genre2":"Conseillère",
    "remuneration":"6298",
    "allocation":"3014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9312",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":2999,
    "nom_corrige2":"Olivier Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"6298",
    "allocation":"3014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9312",
    "ville":"Dégelis",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2925"
  },
  {
    "ID":3000,
    "nom_corrige2":"Martin Doucet",
    "nom_famille":"Doucet",
    "titre_genre2":"Conseiller",
    "remuneration":"5400",
    "allocation":"2700",
    "remuneration2":"803,00$",
    "allocation2":"402,00$",
    "total":"9305",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":3001,
    "nom_corrige2":"Adrien Steudler",
    "nom_famille":"Steudler",
    "titre_genre2":"Conseiller",
    "remuneration":"6598",
    "allocation":"2464",
    "remuneration2":"159,00$",
    "allocation2":"80,00$",
    "total":"9301",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":3002,
    "nom_corrige2":"Luc Darsigny",
    "nom_famille":"Darsigny",
    "titre_genre2":"Conseiller",
    "remuneration":"5714",
    "allocation":"2857",
    "remuneration2":"482,00$",
    "allocation2":"241,00$",
    "total":"9294",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":3003,
    "nom_corrige2":"Stéphane Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Conseiller",
    "remuneration":"6078",
    "allocation":"3039",
    "remuneration2":"174,00$",
    "allocation2":"0",
    "total":"9291",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":3004,
    "nom_corrige2":"Mélanie Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseillère",
    "remuneration":"6311",
    "allocation":"2971",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9282",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":3005,
    "nom_corrige2":"Martine Monette",
    "nom_famille":"Monette",
    "titre_genre2":"Conseillère",
    "remuneration":"6485",
    "allocation":"2791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9276",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":3006,
    "nom_corrige2":"Marie-Andrée Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"6176",
    "allocation":"3088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9264",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":3007,
    "nom_corrige2":"Nathalie Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseillère",
    "remuneration":"6165",
    "allocation":"3089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9254",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":3008,
    "nom_corrige2":"André Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"6165",
    "allocation":"3089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9254",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":3009,
    "nom_corrige2":"François Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire",
    "remuneration":"4644",
    "allocation":"2322",
    "remuneration2":"1525",
    "allocation2":"763,00$",
    "total":"9254",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":3010,
    "nom_corrige2":"Geneviève Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Conseillère",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":3011,
    "nom_corrige2":"Philippe Brunet",
    "nom_famille":"Brunet",
    "titre_genre2":"Conseiller",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":3012,
    "nom_corrige2":"Jean-Michel Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseiller",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":3013,
    "nom_corrige2":"Pierrette Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseillère",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":3014,
    "nom_corrige2":"Sébastien Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":3015,
    "nom_corrige2":"Gregg Edward",
    "nom_famille":"Edward",
    "titre_genre2":"Conseiller",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":3016,
    "nom_corrige2":"Michael Allen",
    "nom_famille":"Allen",
    "titre_genre2":"Conseiller",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":3017,
    "nom_corrige2":"Vivianne Bleau",
    "nom_famille":"Bleau",
    "titre_genre2":"Conseillère",
    "remuneration":"6156",
    "allocation":"3078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9234",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":3018,
    "nom_corrige2":"Vincent Deblois",
    "nom_famille":"Deblois",
    "titre_genre2":"Conseiller",
    "remuneration":"6144",
    "allocation":"3072",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9216",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":3019,
    "nom_corrige2":"Pascal Cauchon",
    "nom_famille":"Cauchon",
    "titre_genre2":"Conseiller",
    "remuneration":"5528",
    "allocation":"3685",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9213",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3020,
    "nom_corrige2":"Patrice Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"6133",
    "allocation":"3067",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9200",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":3021,
    "nom_corrige2":"Anne-Marie Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"6133",
    "allocation":"3067",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9200",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":3022,
    "nom_corrige2":"Étienne Lemelin",
    "nom_famille":"Lemelin",
    "titre_genre2":"Conseiller",
    "remuneration":"6133",
    "allocation":"3067",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9200",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":3023,
    "nom_corrige2":"Gilbert Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseiller",
    "remuneration":"6133",
    "allocation":"3067",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9200",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":3024,
    "nom_corrige2":"Ginette Camiré",
    "nom_famille":"Camiré",
    "titre_genre2":"Conseillère",
    "remuneration":"6133",
    "allocation":"3067",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9200",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":3025,
    "nom_corrige2":"Sonia Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"6133",
    "allocation":"3067",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9200",
    "ville":"Saint-Bernard",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2727"
  },
  {
    "ID":3026,
    "nom_corrige2":"Karine Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseillère",
    "remuneration":"6083",
    "allocation":"3106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9189",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":3027,
    "nom_corrige2":"Marc Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"6125",
    "allocation":"3063",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9188",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":3028,
    "nom_corrige2":"Anne-Marie Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"6125",
    "allocation":"3062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9187",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":3029,
    "nom_corrige2":"Audrey Caza",
    "nom_famille":"Caza",
    "titre_genre2":"Conseillère",
    "remuneration":"6125",
    "allocation":"3062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9187",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":3030,
    "nom_corrige2":"Ginette Caza",
    "nom_famille":"Caza",
    "titre_genre2":"Conseillère",
    "remuneration":"6125",
    "allocation":"3062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9187",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":3031,
    "nom_corrige2":"Lyne Cardinal",
    "nom_famille":"Cardinal",
    "titre_genre2":"Conseillère",
    "remuneration":"6125",
    "allocation":"3062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9187",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":3032,
    "nom_corrige2":"Bradley Duke",
    "nom_famille":"Duke",
    "titre_genre2":"Conseiller",
    "remuneration":"6125",
    "allocation":"3062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9187",
    "ville":"Saint-Anicet",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2753"
  },
  {
    "ID":3033,
    "nom_corrige2":"Benoit Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Conseiller",
    "remuneration":"5807",
    "allocation":"2881",
    "remuneration2":"325,00$",
    "allocation2":"162,00$",
    "total":"9175",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":3034,
    "nom_corrige2":"Geneviève Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"5714",
    "allocation":"2857",
    "remuneration2":"402,00$",
    "allocation2":"201,00$",
    "total":"9174",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":3035,
    "nom_corrige2":"Sabrina Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"6098",
    "allocation":"3055",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9153",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":3036,
    "nom_corrige2":"David Roux",
    "nom_famille":"Roux",
    "titre_genre2":"Conseiller",
    "remuneration":"6100",
    "allocation":"3050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9150",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":3037,
    "nom_corrige2":"Marc Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"5323",
    "allocation":"2682",
    "remuneration2":"763,00$",
    "allocation2":"381,00$",
    "total":"9149",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":3038,
    "nom_corrige2":"Alain Dumouchel",
    "nom_famille":"Dumouchel",
    "titre_genre2":"Conseiller",
    "remuneration":"6098",
    "allocation":"3049",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9147",
    "ville":"Saint-Édouard",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1435"
  },
  {
    "ID":3039,
    "nom_corrige2":"Amélie Sauvé",
    "nom_famille":"Sauvé",
    "titre_genre2":"Conseillère",
    "remuneration":"6095",
    "allocation":"3047",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9142",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":3040,
    "nom_corrige2":"Catherine Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseillère",
    "remuneration":"6095",
    "allocation":"3047",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9142",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":3041,
    "nom_corrige2":"Martin Filion",
    "nom_famille":"Filion",
    "titre_genre2":"Conseiller",
    "remuneration":"6095",
    "allocation":"3047",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9142",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":3042,
    "nom_corrige2":"Réal Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"6095",
    "allocation":"3047",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9142",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":3043,
    "nom_corrige2":"Pierre-Luc Brousseau",
    "nom_famille":"Brousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"6095",
    "allocation":"3047",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9142",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":3044,
    "nom_corrige2":"Marie-Pier Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"6078",
    "allocation":"3039",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9117",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":3045,
    "nom_corrige2":"Gilles Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"6078",
    "allocation":"3039",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9117",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":3046,
    "nom_corrige2":"Chantal Briand",
    "nom_famille":"Briand",
    "titre_genre2":"Conseillère",
    "remuneration":"6078",
    "allocation":"3039",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9117",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":3047,
    "nom_corrige2":"Clermonde Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseillère",
    "remuneration":"6078",
    "allocation":"3039",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9117",
    "ville":"Pohénégamook",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"2491"
  },
  {
    "ID":3048,
    "nom_corrige2":"Pierre Bertrand",
    "nom_famille":"Bertrand",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4584",
    "allocation":"2292",
    "remuneration2":"1872",
    "allocation2":"350,00$",
    "total":"9098",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":3049,
    "nom_corrige2":"Frédéric Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Maire suppléant",
    "remuneration":"6898",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9098",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":3050,
    "nom_corrige2":"Martine Bechtold",
    "nom_famille":"Bechtold",
    "titre_genre2":"Conseillère",
    "remuneration":"6034",
    "allocation":"3016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9050",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":3051,
    "nom_corrige2":"Cynthia Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"6030",
    "allocation":"3020",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9050",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":3052,
    "nom_corrige2":"André Angers",
    "nom_famille":"Angers",
    "titre_genre2":"Conseiller",
    "remuneration":"6030",
    "allocation":"3020",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9050",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":3053,
    "nom_corrige2":"Deborah Beattie",
    "nom_famille":"Beattie",
    "titre_genre2":"Conseillère",
    "remuneration":"6030",
    "allocation":"3015",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9045",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":3054,
    "nom_corrige2":"Claude Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Conseiller",
    "remuneration":"6018",
    "allocation":"3009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9027",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":3055,
    "nom_corrige2":"Jean Bourgeois",
    "nom_famille":"Bourgeois",
    "titre_genre2":"Conseiller",
    "remuneration":"6018",
    "allocation":"3009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9027",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":3056,
    "nom_corrige2":"Pierre-Luc Payette",
    "nom_famille":"Payette",
    "titre_genre2":"Conseiller",
    "remuneration":"6018",
    "allocation":"3009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9027",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":3057,
    "nom_corrige2":"Serge Rivest",
    "nom_famille":"Rivest",
    "titre_genre2":"Conseiller",
    "remuneration":"6018",
    "allocation":"3009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9027",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":3058,
    "nom_corrige2":"Sophie Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Conseillère",
    "remuneration":"6018",
    "allocation":"3009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9027",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":3059,
    "nom_corrige2":"Patrice Pinard",
    "nom_famille":"Pinard",
    "titre_genre2":"Conseiller",
    "remuneration":"6004",
    "allocation":"3002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"9006",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":3060,
    "nom_corrige2":"Alain Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"5999",
    "allocation":"2999",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8998",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":3061,
    "nom_corrige2":"Jean Gascon",
    "nom_famille":"Gascon",
    "titre_genre2":"Conseiller",
    "remuneration":"5999",
    "allocation":"2999",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8998",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":3062,
    "nom_corrige2":"Jean Murray",
    "nom_famille":"Murray",
    "titre_genre2":"Conseiller",
    "remuneration":"5999",
    "allocation":"2999",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8998",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":3063,
    "nom_corrige2":"Luc Robitaille",
    "nom_famille":"Robitaille",
    "titre_genre2":"Conseiller",
    "remuneration":"5999",
    "allocation":"2999",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8998",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":3064,
    "nom_corrige2":"Saweay Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseiller",
    "remuneration":"5999",
    "allocation":"2999",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8998",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":3065,
    "nom_corrige2":"France Perron Leboeuf",
    "nom_famille":"Perron Leboeuf",
    "titre_genre2":"Conseillère",
    "remuneration":"5999",
    "allocation":"2999",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8998",
    "ville":"Lac-Saint-Paul",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"563"
  },
  {
    "ID":3066,
    "nom_corrige2":"Hélène Côté Lambert",
    "nom_famille":"Côté Lambert",
    "titre_genre2":"Conseillère",
    "remuneration":"5987",
    "allocation":"2994",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8981",
    "ville":"La Patrie",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"828"
  },
  {
    "ID":3067,
    "nom_corrige2":"André Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"5977",
    "allocation":"2989",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8966",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":3068,
    "nom_corrige2":"Andréanne Lapointe Deblois",
    "nom_famille":"Lapointe Deblois",
    "titre_genre2":"Conseillère",
    "remuneration":"5977",
    "allocation":"2989",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8966",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":3069,
    "nom_corrige2":"Bruno Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"5977",
    "allocation":"2989",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8966",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":3070,
    "nom_corrige2":"Marc-André Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseiller",
    "remuneration":"5977",
    "allocation":"2989",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8966",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":3071,
    "nom_corrige2":"Marion Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"5977",
    "allocation":"2989",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8966",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":3072,
    "nom_corrige2":"Olivier Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"5977",
    "allocation":"2989",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8966",
    "ville":"Saint-Laurent-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1714"
  },
  {
    "ID":3073,
    "nom_corrige2":"Jean-Claude Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Conseiller",
    "remuneration":"5968",
    "allocation":"2984",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8952",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":3074,
    "nom_corrige2":"Danny Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"5926",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8880",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":3075,
    "nom_corrige2":"Dial Lepage",
    "nom_famille":"Lepage",
    "titre_genre2":"Conseiller",
    "remuneration":"5926",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8880",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":3076,
    "nom_corrige2":"Pierre Sarrazin",
    "nom_famille":"Sarrazin",
    "titre_genre2":"Conseiller",
    "remuneration":"5926",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8880",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":3077,
    "nom_corrige2":"Richard Bourdages",
    "nom_famille":"Bourdages",
    "titre_genre2":"Conseiller",
    "remuneration":"5926",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8880",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":3078,
    "nom_corrige2":"Serge-Paul Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"5926",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8880",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":3079,
    "nom_corrige2":"Stéphane-Alexandre Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"5926",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8880",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1251"
  },
  {
    "ID":3080,
    "nom_corrige2":"Julie Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseillère",
    "remuneration":"6075",
    "allocation":"2791",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8866",
    "ville":"Saint-Mathieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2551"
  },
  {
    "ID":3081,
    "nom_corrige2":"Lois Miller",
    "nom_famille":"Miller",
    "titre_genre2":"Conseillère",
    "remuneration":"5907",
    "allocation":"2954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8861",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":3082,
    "nom_corrige2":"Anne-Marie Meyran",
    "nom_famille":"Meyran",
    "titre_genre2":"Conseillère",
    "remuneration":"5900",
    "allocation":"2950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8850",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":3083,
    "nom_corrige2":"Annie Meilleur",
    "nom_famille":"Meilleur",
    "titre_genre2":"Conseillère",
    "remuneration":"5900",
    "allocation":"2950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8850",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":3084,
    "nom_corrige2":"Christian Lacroix",
    "nom_famille":"Lacroix",
    "titre_genre2":"Conseiller",
    "remuneration":"5900",
    "allocation":"2950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8850",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":3085,
    "nom_corrige2":"Diane Imonti",
    "nom_famille":"Imonti",
    "titre_genre2":"Conseillère",
    "remuneration":"5900",
    "allocation":"2950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8850",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":3086,
    "nom_corrige2":"Mélanie Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"5900",
    "allocation":"2950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8850",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":3087,
    "nom_corrige2":"Michel Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseiller",
    "remuneration":"5900",
    "allocation":"2950",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8850",
    "ville":"Kiamika",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"838"
  },
  {
    "ID":3088,
    "nom_corrige2":"Line Quévillon",
    "nom_famille":"Quévillon",
    "titre_genre2":"Conseillère",
    "remuneration":"6039",
    "allocation":"2808",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8847",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":3089,
    "nom_corrige2":"Philippe Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Maire",
    "remuneration":"5898",
    "allocation":"2949",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8847",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":3090,
    "nom_corrige2":"Laincy Fecteau",
    "nom_famille":"Fecteau",
    "titre_genre2":"Conseillère",
    "remuneration":"5894",
    "allocation":"2952",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8846",
    "ville":"Saint-Joseph-de-Coleraine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1896"
  },
  {
    "ID":3091,
    "nom_corrige2":"Anne-Sylvie Forney",
    "nom_famille":"Forney",
    "titre_genre2":"Conseillère",
    "remuneration":"5891",
    "allocation":"2945",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8836",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":3092,
    "nom_corrige2":"Stéphane Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"5891",
    "allocation":"2945",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8836",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":3093,
    "nom_corrige2":"Jean-François Berthiaume",
    "nom_famille":"Berthiaume",
    "titre_genre2":"Conseiller",
    "remuneration":"5891",
    "allocation":"2945",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8836",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":3094,
    "nom_corrige2":"Marie-Eve Denicourt",
    "nom_famille":"Denicourt",
    "titre_genre2":"Conseillère",
    "remuneration":"5891",
    "allocation":"2945",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8836",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":3095,
    "nom_corrige2":"Florent Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseiller",
    "remuneration":"5891",
    "allocation":"2945",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8836",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":3096,
    "nom_corrige2":"Julie Vadeboncoeur",
    "nom_famille":"Vadeboncoeur",
    "titre_genre2":"Conseillère",
    "remuneration":"5891",
    "allocation":"2945",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8836",
    "ville":"Saint-Alexandre",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2722"
  },
  {
    "ID":3097,
    "nom_corrige2":"Alain Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Maire",
    "remuneration":"4485",
    "allocation":"2242",
    "remuneration2":"2109",
    "allocation2":"0",
    "total":"8836",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":3098,
    "nom_corrige2":"Lilian Steudler",
    "nom_famille":"Steudler",
    "titre_genre2":"Conseillère",
    "remuneration":"6547",
    "allocation":"2286",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8833",
    "ville":"Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1457"
  },
  {
    "ID":3099,
    "nom_corrige2":"Yvan-René Black",
    "nom_famille":"Black",
    "titre_genre2":"Conseiller",
    "remuneration":"5880",
    "allocation":"2940",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8820",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":3100,
    "nom_corrige2":"Mylène Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseillère",
    "remuneration":"5880",
    "allocation":"2940",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8820",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":3101,
    "nom_corrige2":"Xavier Sanchez",
    "nom_famille":"Sanchez",
    "titre_genre2":"Conseiller",
    "remuneration":"5880",
    "allocation":"2940",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8820",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":3102,
    "nom_corrige2":"Marie-Ève Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseillère",
    "remuneration":"5880",
    "allocation":"2940",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8820",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":3103,
    "nom_corrige2":"Patricia Venessa Lafrenière",
    "nom_famille":"Venessa Lafrenière",
    "titre_genre2":"Conseillère",
    "remuneration":"5880",
    "allocation":"2940",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8820",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":3104,
    "nom_corrige2":"Derek O'Hearn",
    "nom_famille":"O'Hearn",
    "titre_genre2":"Conseiller",
    "remuneration":"6284",
    "allocation":"2138",
    "remuneration2":"247,00$",
    "allocation2":"123,00$",
    "total":"8792",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":3105,
    "nom_corrige2":"Sylvain Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"6851",
    "allocation":"",
    "remuneration2":"1925",
    "allocation2":"0",
    "total":"8776",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":3106,
    "nom_corrige2":"Gaétan Guidon",
    "nom_famille":"Guidon",
    "titre_genre2":"Maire",
    "remuneration":"5864",
    "allocation":"2909",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8773",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":3107,
    "nom_corrige2":"Gaetan Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseiller",
    "remuneration":"5830",
    "allocation":"2915",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8745",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":3108,
    "nom_corrige2":"Alain Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"5830",
    "allocation":"2915",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8745",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":3109,
    "nom_corrige2":"Denise Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"5830",
    "allocation":"2915",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8745",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":3110,
    "nom_corrige2":"Simon Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"5830",
    "allocation":"2915",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8745",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":3111,
    "nom_corrige2":"Jean-François Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"5830",
    "allocation":"2915",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8745",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":3112,
    "nom_corrige2":"Jérôme Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"5830",
    "allocation":"2915",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8745",
    "ville":"Saint-Anselme",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4510"
  },
  {
    "ID":3113,
    "nom_corrige2":"Cheryl Labrie",
    "nom_famille":"Labrie",
    "titre_genre2":"Conseillère",
    "remuneration":"5826",
    "allocation":"2913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8739",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":3114,
    "nom_corrige2":"Karl Frappier",
    "nom_famille":"Frappier",
    "titre_genre2":"Conseiller",
    "remuneration":"5826",
    "allocation":"2913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8739",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":3115,
    "nom_corrige2":"Michel Frappier",
    "nom_famille":"Frappier",
    "titre_genre2":"Conseiller",
    "remuneration":"5826",
    "allocation":"2913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8739",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":3116,
    "nom_corrige2":"René Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseiller",
    "remuneration":"5826",
    "allocation":"2913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8739",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":3117,
    "nom_corrige2":"Claude Paulin",
    "nom_famille":"Paulin",
    "titre_genre2":"Conseiller",
    "remuneration":"5826",
    "allocation":"2913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8739",
    "ville":"Saint-François-Xavier-de-Brompton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2638"
  },
  {
    "ID":3118,
    "nom_corrige2":"Paul-Emile Bourdages",
    "nom_famille":"Bourdages",
    "titre_genre2":"Conseiller",
    "remuneration":"5821",
    "allocation":"2911",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8732",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":3119,
    "nom_corrige2":"Sylvain Bourque",
    "nom_famille":"Bourque",
    "titre_genre2":"Conseiller",
    "remuneration":"5821",
    "allocation":"2911",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8732",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":3120,
    "nom_corrige2":"Maude Brinck-Poirier",
    "nom_famille":"Brinck-Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"5821",
    "allocation":"2911",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8732",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":3121,
    "nom_corrige2":"Joshua Burns",
    "nom_famille":"Burns",
    "titre_genre2":"Conseiller",
    "remuneration":"5821",
    "allocation":"2911",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8732",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":3122,
    "nom_corrige2":"Jean Bertrand Molloy",
    "nom_famille":"Molloy",
    "titre_genre2":"Conseiller",
    "remuneration":"5821",
    "allocation":"2911",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8732",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":3123,
    "nom_corrige2":"Jean-Marc Moses",
    "nom_famille":"Moses",
    "titre_genre2":"Conseiller",
    "remuneration":"5821",
    "allocation":"2911",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8732",
    "ville":"Caplan",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1942"
  },
  {
    "ID":3124,
    "nom_corrige2":"Richmond Viau",
    "nom_famille":"Viau",
    "titre_genre2":"Conseiller",
    "remuneration":"5806",
    "allocation":"2903",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8709",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":3125,
    "nom_corrige2":"Daniel Favreau",
    "nom_famille":"Favreau",
    "titre_genre2":"Maire",
    "remuneration":"5804",
    "allocation":"2902",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8706",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":3126,
    "nom_corrige2":"Christian Tisluck",
    "nom_famille":"Tisluck",
    "titre_genre2":"Conseiller",
    "remuneration":"3565",
    "allocation":"1783",
    "remuneration2":"2229",
    "allocation2":"1115",
    "total":"8692",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":3127,
    "nom_corrige2":"Joan Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"5768",
    "allocation":"2884",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8652",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":3128,
    "nom_corrige2":"Marie-Noel Duclos",
    "nom_famille":"Duclos",
    "titre_genre2":"Conseillère",
    "remuneration":"5751",
    "allocation":"2875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8626",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3129,
    "nom_corrige2":"Éric Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"5751",
    "allocation":"2875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8626",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3130,
    "nom_corrige2":"Ghislain Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"5751",
    "allocation":"2875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8626",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3131,
    "nom_corrige2":"Normand Duclos",
    "nom_famille":"Duclos",
    "titre_genre2":"Conseiller",
    "remuneration":"5751",
    "allocation":"2875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8626",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3132,
    "nom_corrige2":"Reynald Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseiller",
    "remuneration":"5751",
    "allocation":"2875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8626",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3133,
    "nom_corrige2":"Richard Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"5751",
    "allocation":"2875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8626",
    "ville":"Saint-Tite-des-Caps",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3134,
    "nom_corrige2":"Dominic Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"5733",
    "allocation":"2867",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8600",
    "ville":"Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"4955"
  },
  {
    "ID":3135,
    "nom_corrige2":"André Minville",
    "nom_famille":"Minville",
    "titre_genre2":"Conseiller",
    "remuneration":"5732",
    "allocation":"2866",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8598",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":3136,
    "nom_corrige2":"Daniel Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"5732",
    "allocation":"2866",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8598",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":3137,
    "nom_corrige2":"Gilles Bernatchez",
    "nom_famille":"Bernatchez",
    "titre_genre2":"Conseiller",
    "remuneration":"5732",
    "allocation":"2866",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8598",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":3138,
    "nom_corrige2":"Harold Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"5732",
    "allocation":"2866",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8598",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":3139,
    "nom_corrige2":"Jean-Pierre Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Conseiller",
    "remuneration":"5732",
    "allocation":"2866",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8598",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":3140,
    "nom_corrige2":"Mathieu Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseiller",
    "remuneration":"5732",
    "allocation":"2866",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8598",
    "ville":"Murdochville",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"618"
  },
  {
    "ID":3141,
    "nom_corrige2":"Audrey Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseillère",
    "remuneration":"5720",
    "allocation":"2860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8580",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":3142,
    "nom_corrige2":"Danielle Meunier",
    "nom_famille":"Meunier",
    "titre_genre2":"Conseillère",
    "remuneration":"5720",
    "allocation":"2860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8580",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":3143,
    "nom_corrige2":"Yves Laurendeau",
    "nom_famille":"Laurendeau",
    "titre_genre2":"Conseiller",
    "remuneration":"5720",
    "allocation":"2860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8580",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":3144,
    "nom_corrige2":"Maryse Gougeon",
    "nom_famille":"Gougeon",
    "titre_genre2":"Conseillère",
    "remuneration":"5720",
    "allocation":"2860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8580",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":3145,
    "nom_corrige2":"Sylvie Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseillère",
    "remuneration":"5720",
    "allocation":"2860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8580",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":3146,
    "nom_corrige2":"Alexandre Lafleur",
    "nom_famille":"Lafleur",
    "titre_genre2":"Conseiller",
    "remuneration":"5720",
    "allocation":"2860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8580",
    "ville":"Chénéville",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"934"
  },
  {
    "ID":3147,
    "nom_corrige2":"Chantal Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseillère",
    "remuneration":"5719",
    "allocation":"2859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8578",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":3148,
    "nom_corrige2":"Christian Riendeau",
    "nom_famille":"Riendeau",
    "titre_genre2":"Conseiller",
    "remuneration":"5719",
    "allocation":"2859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8578",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":3149,
    "nom_corrige2":"Jocelyn Jutras",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseiller",
    "remuneration":"5719",
    "allocation":"2859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8578",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":3150,
    "nom_corrige2":"Mario Blanchard",
    "nom_famille":"Blanchard",
    "titre_genre2":"Conseiller",
    "remuneration":"5719",
    "allocation":"2859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8578",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":3151,
    "nom_corrige2":"Mario Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Conseiller",
    "remuneration":"5719",
    "allocation":"2859",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8578",
    "ville":"Saint-Paul-d'Abbotsford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2963"
  },
  {
    "ID":3152,
    "nom_corrige2":"Gérald Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Maire",
    "remuneration":"5715",
    "allocation":"2857",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8572",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":3153,
    "nom_corrige2":"Jean Pinard",
    "nom_famille":"Pinard",
    "titre_genre2":"Conseiller",
    "remuneration":"5714",
    "allocation":"2857",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8571",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":3154,
    "nom_corrige2":"Pascale Binette",
    "nom_famille":"Binette",
    "titre_genre2":"Conseillère",
    "remuneration":"5714",
    "allocation":"2857",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8571",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":3155,
    "nom_corrige2":"Sylvie Guévin",
    "nom_famille":"Guévin",
    "titre_genre2":"Conseillère",
    "remuneration":"5714",
    "allocation":"2857",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8571",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":3156,
    "nom_corrige2":"Louis-René Perrault",
    "nom_famille":"Perrault",
    "titre_genre2":"Conseiller",
    "remuneration":"5707",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8560",
    "ville":"Cacouna",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1882"
  },
  {
    "ID":3157,
    "nom_corrige2":"Danielle Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"5707",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8560",
    "ville":"Cacouna",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1882"
  },
  {
    "ID":3158,
    "nom_corrige2":"Francine Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"5707",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8560",
    "ville":"Cacouna",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1882"
  },
  {
    "ID":3159,
    "nom_corrige2":"Johanne Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"5707",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8560",
    "ville":"Cacouna",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1882"
  },
  {
    "ID":3160,
    "nom_corrige2":"Rémi Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"5707",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8560",
    "ville":"Cacouna",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1882"
  },
  {
    "ID":3161,
    "nom_corrige2":"Jean-Paul Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Maire",
    "remuneration":"5699",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8552",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":3162,
    "nom_corrige2":"Bernard Beauchemin",
    "nom_famille":"Beauchemin",
    "titre_genre2":"Conseiller",
    "remuneration":"5700",
    "allocation":"2850",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8550",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":3163,
    "nom_corrige2":"Jean Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"4593",
    "allocation":"2296",
    "remuneration2":"1106",
    "allocation2":"553,00$",
    "total":"8548",
    "ville":"Lac-Sergent",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"616"
  },
  {
    "ID":3164,
    "nom_corrige2":"Jacques Berthiaume",
    "nom_famille":"Berthiaume",
    "titre_genre2":"Conseiller",
    "remuneration":"5505",
    "allocation":"3040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8545",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":3165,
    "nom_corrige2":"Carol Denis",
    "nom_famille":"Denis",
    "titre_genre2":"Conseiller",
    "remuneration":"5728",
    "allocation":"2814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8542",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":3166,
    "nom_corrige2":"Marcel Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"5343",
    "allocation":"2672",
    "remuneration2":"345,00$",
    "allocation2":"173,00$",
    "total":"8533",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":3167,
    "nom_corrige2":"Jason Gourde",
    "nom_famille":"Gourde",
    "titre_genre2":"Conseiller",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8523",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":3168,
    "nom_corrige2":"Mario Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8523",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":3169,
    "nom_corrige2":"Matthew Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8523",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":3170,
    "nom_corrige2":"Mireille Caux",
    "nom_famille":"Caux",
    "titre_genre2":"Conseillère",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8523",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":3171,
    "nom_corrige2":"Roger Samson",
    "nom_famille":"Samson",
    "titre_genre2":"Conseiller",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8523",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":3172,
    "nom_corrige2":"Yves Joly",
    "nom_famille":"Joly",
    "titre_genre2":"Conseiller",
    "remuneration":"5682",
    "allocation":"2841",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8523",
    "ville":"Saint-Narcisse-de-Beaurivage",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1246"
  },
  {
    "ID":3173,
    "nom_corrige2":"Robin Cotnoir",
    "nom_famille":"Cotnoir",
    "titre_genre2":"Conseiller",
    "remuneration":"5680",
    "allocation":"2840",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8520",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":3174,
    "nom_corrige2":"Michel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"5679",
    "allocation":"2839",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8518",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":3175,
    "nom_corrige2":"Cécile Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Conseillère",
    "remuneration":"5072",
    "allocation":"3417",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8489",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":3176,
    "nom_corrige2":"Éric Bourdeau",
    "nom_famille":"Bourdeau",
    "titre_genre2":"Conseiller",
    "remuneration":"5650",
    "allocation":"2825",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8475",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":3177,
    "nom_corrige2":"Philippe-David Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseiller",
    "remuneration":"5636",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8454",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":3178,
    "nom_corrige2":"Véronique Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"5636",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8454",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":3179,
    "nom_corrige2":"René Bessette",
    "nom_famille":"Bessette",
    "titre_genre2":"Conseiller",
    "remuneration":"5636",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8454",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":3180,
    "nom_corrige2":"Gaétan Lafond",
    "nom_famille":"Lafond",
    "titre_genre2":"Conseiller",
    "remuneration":"5636",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8454",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":3181,
    "nom_corrige2":"Karl Hunting",
    "nom_famille":"Hunting",
    "titre_genre2":"Conseiller",
    "remuneration":"5636",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8454",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":3182,
    "nom_corrige2":"Gordon Barnett",
    "nom_famille":"Barnett",
    "titre_genre2":"Conseiller",
    "remuneration":"5636",
    "allocation":"2818",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8454",
    "ville":"Waterville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2536"
  },
  {
    "ID":3183,
    "nom_corrige2":"Marie-Josée Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseillère",
    "remuneration":"5634",
    "allocation":"2817",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8451",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":3184,
    "nom_corrige2":"Gérald Grenon",
    "nom_famille":"Grenon",
    "titre_genre2":"Conseiller",
    "remuneration":"4997",
    "allocation":"2498",
    "remuneration2":"951,00$",
    "allocation2":"0",
    "total":"8446",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":3185,
    "nom_corrige2":"Claude Groleau",
    "nom_famille":"Groleau",
    "titre_genre2":"Conseiller",
    "remuneration":"5628",
    "allocation":"2814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8442",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":3186,
    "nom_corrige2":"Élodie Brochu",
    "nom_famille":"Brochu",
    "titre_genre2":"Conseillère",
    "remuneration":"5628",
    "allocation":"2814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8442",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":3187,
    "nom_corrige2":"Mario Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"5628",
    "allocation":"2814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8442",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":3188,
    "nom_corrige2":"Claire Dussault",
    "nom_famille":"Dussault",
    "titre_genre2":"Conseillère",
    "remuneration":"5628",
    "allocation":"2814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8442",
    "ville":"Saint-Marc-des-Carrières",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"2922"
  },
  {
    "ID":3189,
    "nom_corrige2":"Pierre-Yves Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Conseiller",
    "remuneration":"5617",
    "allocation":"2808",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8425",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":3190,
    "nom_corrige2":"Charles Goyer",
    "nom_famille":"Goyer",
    "titre_genre2":"Conseiller",
    "remuneration":"5617",
    "allocation":"2808",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8425",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":3191,
    "nom_corrige2":"Denis Lemoyne",
    "nom_famille":"Lemoyne",
    "titre_genre2":"Conseiller",
    "remuneration":"5617",
    "allocation":"2808",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8425",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":3192,
    "nom_corrige2":"Marc Blain",
    "nom_famille":"Blain",
    "titre_genre2":"Conseiller",
    "remuneration":"5617",
    "allocation":"2808",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8425",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":3193,
    "nom_corrige2":"Violaine Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"5617",
    "allocation":"2808",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8425",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":3194,
    "nom_corrige2":"Marco Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"5615",
    "allocation":"2807",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8422",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":3195,
    "nom_corrige2":"Mario Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Conseiller",
    "remuneration":"5615",
    "allocation":"2807",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8422",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":3196,
    "nom_corrige2":"Alain Dumas",
    "nom_famille":"Dumas",
    "titre_genre2":"Conseiller",
    "remuneration":"5449",
    "allocation":"2725",
    "remuneration2":"152,00$",
    "allocation2":"76,00$",
    "total":"8402",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":3197,
    "nom_corrige2":"Mathieu Guillemette",
    "nom_famille":"Guillemette",
    "titre_genre2":"Maire",
    "remuneration":"5566",
    "allocation":"2824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8390",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":3198,
    "nom_corrige2":"Alain Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Maire",
    "remuneration":"5592",
    "allocation":"2796",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8388",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":3199,
    "nom_corrige2":"Sonia Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"5589",
    "allocation":"2794",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8383",
    "ville":"Matagami",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"1396"
  },
  {
    "ID":3200,
    "nom_corrige2":"Hugo Carle",
    "nom_famille":"Carle",
    "titre_genre2":"Conseiller",
    "remuneration":"5614",
    "allocation":"2767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8381",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":3201,
    "nom_corrige2":"Sylvie Leclair",
    "nom_famille":"Leclair",
    "titre_genre2":"Conseillère",
    "remuneration":"5614",
    "allocation":"2767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8381",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":3202,
    "nom_corrige2":"Yves Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"5614",
    "allocation":"2767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8381",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":3203,
    "nom_corrige2":"Gilles Courchaine",
    "nom_famille":"Courchaine",
    "titre_genre2":"Maire suppléant",
    "remuneration":"5614",
    "allocation":"2767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8381",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":3204,
    "nom_corrige2":"Linda Lirette",
    "nom_famille":"Lirette",
    "titre_genre2":"Conseillère",
    "remuneration":"5614",
    "allocation":"2767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8381",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":3205,
    "nom_corrige2":"Amélie Massé",
    "nom_famille":"Massé",
    "titre_genre2":"Conseillère",
    "remuneration":"5585",
    "allocation":"2793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8378",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":3206,
    "nom_corrige2":"Casandra Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"5585",
    "allocation":"2793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8378",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":3207,
    "nom_corrige2":"David Gervais",
    "nom_famille":"Gervais",
    "titre_genre2":"Conseiller",
    "remuneration":"5585",
    "allocation":"2793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8378",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":3208,
    "nom_corrige2":"Isabelle Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"5585",
    "allocation":"2793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8378",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":3209,
    "nom_corrige2":"Jean-Paul Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"5585",
    "allocation":"2793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8378",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":3210,
    "nom_corrige2":"Sébastien Petitclerc",
    "nom_famille":"Petitclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"5585",
    "allocation":"2793",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8378",
    "ville":"Preissac",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"966"
  },
  {
    "ID":3211,
    "nom_corrige2":"Marie-Josée Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseillère",
    "remuneration":"5581",
    "allocation":"2790",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8371",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":3212,
    "nom_corrige2":"Line Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseillère",
    "remuneration":"5581",
    "allocation":"2790",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8371",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":3213,
    "nom_corrige2":"Nathalie Dupont",
    "nom_famille":"Dupont",
    "titre_genre2":"Conseillère",
    "remuneration":"5581",
    "allocation":"2790",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8371",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":3214,
    "nom_corrige2":"Jessica Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseillère",
    "remuneration":"5581",
    "allocation":"2790",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8371",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":3215,
    "nom_corrige2":"Steve Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"5581",
    "allocation":"2790",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8371",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":3216,
    "nom_corrige2":"Stéphane Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Maire suppléant",
    "remuneration":"5580",
    "allocation":"2790",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8370",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":3217,
    "nom_corrige2":"Chad Whittaker",
    "nom_famille":"Whittaker",
    "titre_genre2":"Conseiller",
    "remuneration":"4997",
    "allocation":"2498",
    "remuneration2":"856,00$",
    "allocation2":"0",
    "total":"8351",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":3218,
    "nom_corrige2":"Harold Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"5505",
    "allocation":"2829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8334",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":3219,
    "nom_corrige2":"Jacques Malouin",
    "nom_famille":"Malouin",
    "titre_genre2":"Conseiller",
    "remuneration":"5551",
    "allocation":"2775",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8326",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":3220,
    "nom_corrige2":"Sophie Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Conseillère",
    "remuneration":"5551",
    "allocation":"2775",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8326",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":3221,
    "nom_corrige2":"Martin Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"5551",
    "allocation":"2775",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8326",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":3222,
    "nom_corrige2":"Karine Cloâtre",
    "nom_famille":"Cloâtre",
    "titre_genre2":"Conseillère",
    "remuneration":"5551",
    "allocation":"2775",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8326",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":3223,
    "nom_corrige2":"Gina Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseillère",
    "remuneration":"5173",
    "allocation":"2386",
    "remuneration2":"503,00$",
    "allocation2":"252,00$",
    "total":"8314",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":3224,
    "nom_corrige2":"Mario Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"4880",
    "allocation":"2440",
    "remuneration2":"658,00$",
    "allocation2":"329,00$",
    "total":"8307",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":3225,
    "nom_corrige2":"Sébastien Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"5532",
    "allocation":"2766",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8298",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":3226,
    "nom_corrige2":"Johanne Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseillère",
    "remuneration":"5505",
    "allocation":"2753",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8258",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":3227,
    "nom_corrige2":"Sylvie Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"5505",
    "allocation":"2753",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8258",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":3228,
    "nom_corrige2":"Yvan Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"5505",
    "allocation":"2753",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8258",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":3229,
    "nom_corrige2":"Francis Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"5505",
    "allocation":"2753",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8258",
    "ville":"Saint-Frédéric",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1194"
  },
  {
    "ID":3230,
    "nom_corrige2":"Audrey Ouellette",
    "nom_famille":"Ouellette",
    "titre_genre2":"Conseillère",
    "remuneration":"5503",
    "allocation":"2752",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8255",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":3231,
    "nom_corrige2":"Jean-Claude Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"5503",
    "allocation":"2752",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8255",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":3232,
    "nom_corrige2":"Jean-Paul Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"5503",
    "allocation":"2752",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8255",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":3233,
    "nom_corrige2":"Joël Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"5503",
    "allocation":"2752",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8255",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":3234,
    "nom_corrige2":"Mathieu Henri",
    "nom_famille":"Henri",
    "titre_genre2":"Conseiller",
    "remuneration":"5503",
    "allocation":"2752",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8255",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":3235,
    "nom_corrige2":"Roger East",
    "nom_famille":"East",
    "titre_genre2":"Conseiller",
    "remuneration":"5503",
    "allocation":"2752",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8255",
    "ville":"Saint-Ferdinand",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2083"
  },
  {
    "ID":3236,
    "nom_corrige2":"Sylvain La France",
    "nom_famille":"La France",
    "titre_genre2":"Maire suppléant",
    "remuneration":"5484",
    "allocation":"2760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8244",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":3237,
    "nom_corrige2":"Matthiew Orlando",
    "nom_famille":"Orlando",
    "titre_genre2":"Conseiller",
    "remuneration":"5484",
    "allocation":"2760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8244",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":3238,
    "nom_corrige2":"Damien Lafrenière",
    "nom_famille":"Lafrenière",
    "titre_genre2":"Conseiller",
    "remuneration":"5484",
    "allocation":"2760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8244",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":3239,
    "nom_corrige2":"Lynne Lachapelle",
    "nom_famille":"Lachapelle",
    "titre_genre2":"Conseillère",
    "remuneration":"5484",
    "allocation":"2760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8244",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":3240,
    "nom_corrige2":"Paul Chamberlain",
    "nom_famille":"Chamberlain",
    "titre_genre2":"Conseiller",
    "remuneration":"5484",
    "allocation":"2760",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8244",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":3241,
    "nom_corrige2":"Pascale Renzo Charbonneau",
    "nom_famille":"Renzo Charbonneau",
    "titre_genre2":"Conseillère",
    "remuneration":"5490",
    "allocation":"2745",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8235",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":3242,
    "nom_corrige2":"Bruno Napert",
    "nom_famille":"Napert",
    "titre_genre2":"Conseiller",
    "remuneration":"5490",
    "allocation":"2745",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8235",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":3243,
    "nom_corrige2":"Claude Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseiller",
    "remuneration":"5490",
    "allocation":"2745",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8235",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":3244,
    "nom_corrige2":"Daniel Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseiller",
    "remuneration":"5490",
    "allocation":"2745",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8235",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":3245,
    "nom_corrige2":"Daniel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"4635",
    "allocation":"2317",
    "remuneration2":"850,00$",
    "allocation2":"425,00$",
    "total":"8227",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":3246,
    "nom_corrige2":"Pierre Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Maire suppléant",
    "remuneration":"5040",
    "allocation":"2520",
    "remuneration2":"437,00$",
    "allocation2":"218,00$",
    "total":"8215",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":3247,
    "nom_corrige2":"Karina Poudrier",
    "nom_famille":"Poudrier",
    "titre_genre2":"Conseillère",
    "remuneration":"4627",
    "allocation":"2313",
    "remuneration2":"605,00$",
    "allocation2":"657,00$",
    "total":"8202",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":3248,
    "nom_corrige2":"Pierre Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"5327",
    "allocation":"2874",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8201",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":3249,
    "nom_corrige2":"Marco Legault",
    "nom_famille":"Legault",
    "titre_genre2":"Conseiller",
    "remuneration":"5327",
    "allocation":"2874",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8201",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":3250,
    "nom_corrige2":"Benoit Tousignant",
    "nom_famille":"Tousignant",
    "titre_genre2":"Conseiller",
    "remuneration":"5466",
    "allocation":"2733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8199",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":3251,
    "nom_corrige2":"Marc Foisy",
    "nom_famille":"Foisy",
    "titre_genre2":"Conseiller",
    "remuneration":"5466",
    "allocation":"2733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8199",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":3252,
    "nom_corrige2":"Diane Trépanier",
    "nom_famille":"Trépanier",
    "titre_genre2":"Conseillère",
    "remuneration":"5466",
    "allocation":"2733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8199",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":3253,
    "nom_corrige2":"Juliette Melançon-Caillé",
    "nom_famille":"Melançon-Caillé",
    "titre_genre2":"Conseillère",
    "remuneration":"5466",
    "allocation":"2733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8199",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":3254,
    "nom_corrige2":"Cindy Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"5466",
    "allocation":"2733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8199",
    "ville":"Sainte-Marie-Salomé",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1282"
  },
  {
    "ID":3255,
    "nom_corrige2":"Léon Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Maire",
    "remuneration":"3705",
    "allocation":"1853",
    "remuneration2":"1754",
    "allocation2":"877,00$",
    "total":"8189",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":3256,
    "nom_corrige2":"Cynthia St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseillère",
    "remuneration":"5458",
    "allocation":"2729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8187",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":3257,
    "nom_corrige2":"Pierre Piché",
    "nom_famille":"Piché",
    "titre_genre2":"Conseiller",
    "remuneration":"5327",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8180",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":3258,
    "nom_corrige2":"Alain Déry",
    "nom_famille":"Déry",
    "titre_genre2":"Conseiller",
    "remuneration":"5327",
    "allocation":"2853",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8180",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":3259,
    "nom_corrige2":"Georges Halasz",
    "nom_famille":"Halasz",
    "titre_genre2":"Conseiller",
    "remuneration":"5451",
    "allocation":"2726",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8177",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":3260,
    "nom_corrige2":"Valérie Descôteaux",
    "nom_famille":"Descôteaux",
    "titre_genre2":"Conseillère",
    "remuneration":"5451",
    "allocation":"2726",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8177",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":3261,
    "nom_corrige2":"Joel Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"5450",
    "allocation":"2725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8175",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":3262,
    "nom_corrige2":"Bianca Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseillère",
    "remuneration":"5449",
    "allocation":"2725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8174",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":3263,
    "nom_corrige2":"Yvan Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"5449",
    "allocation":"2725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8174",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":3264,
    "nom_corrige2":"Jean-Denis Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseiller",
    "remuneration":"5449",
    "allocation":"2725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8174",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":3265,
    "nom_corrige2":"Simon Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"5449",
    "allocation":"2725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8174",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":3266,
    "nom_corrige2":"Steven Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseiller",
    "remuneration":"5449",
    "allocation":"2725",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8174",
    "ville":"Saint-Côme–Linière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3451"
  },
  {
    "ID":3267,
    "nom_corrige2":"Daniel Meunier",
    "nom_famille":"Meunier",
    "titre_genre2":"Conseiller",
    "remuneration":"4934",
    "allocation":"2466",
    "remuneration2":"512,00$",
    "allocation2":"256,00$",
    "total":"8168",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":3268,
    "nom_corrige2":"Elaine Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseillère",
    "remuneration":"5327",
    "allocation":"2832",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8159",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":3269,
    "nom_corrige2":"Simon Normandin",
    "nom_famille":"Normandin",
    "titre_genre2":"Conseiller",
    "remuneration":"5432",
    "allocation":"2716",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8148",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":3270,
    "nom_corrige2":"Bruno Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"5427",
    "allocation":"2714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8141",
    "ville":"Saint-Jacques-le-Mineur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1889"
  },
  {
    "ID":3271,
    "nom_corrige2":"Charles Chateauvert",
    "nom_famille":"Chateauvert",
    "titre_genre2":"Conseiller",
    "remuneration":"5327",
    "allocation":"2810",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8137",
    "ville":"Bolton-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1276"
  },
  {
    "ID":3272,
    "nom_corrige2":"Gino Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"5405",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8107",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":3273,
    "nom_corrige2":"Carl Robichaud",
    "nom_famille":"Robichaud",
    "titre_genre2":"Conseiller",
    "remuneration":"5405",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8107",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":3274,
    "nom_corrige2":"Alexandre Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"5405",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8107",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":3275,
    "nom_corrige2":"Réjean Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"5405",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8107",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":3276,
    "nom_corrige2":"Réjean Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"5405",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8107",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":3277,
    "nom_corrige2":"Yvon Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"5405",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8107",
    "ville":"Saint-Charles-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2743"
  },
  {
    "ID":3278,
    "nom_corrige2":"Clément Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"5403",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8105",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":3279,
    "nom_corrige2":"Frédéric Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseiller",
    "remuneration":"5403",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8105",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":3280,
    "nom_corrige2":"Ghislain Lowe",
    "nom_famille":"Lowe",
    "titre_genre2":"Conseiller",
    "remuneration":"5403",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8105",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":3281,
    "nom_corrige2":"Pierre-Luc Langevin",
    "nom_famille":"Langevin",
    "titre_genre2":"Conseiller",
    "remuneration":"5403",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8105",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":3282,
    "nom_corrige2":"Johnny Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"5403",
    "allocation":"2702",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8105",
    "ville":"Scott",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2910"
  },
  {
    "ID":3283,
    "nom_corrige2":"Louis-Philippe Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseiller",
    "remuneration":"5378",
    "allocation":"2726",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8104",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":3284,
    "nom_corrige2":"Robert Chevrier",
    "nom_famille":"Chevrier",
    "titre_genre2":"Conseiller",
    "remuneration":"5400",
    "allocation":"2700",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8100",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":3285,
    "nom_corrige2":"Daniel Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseiller",
    "remuneration":"5400",
    "allocation":"2700",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8100",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":3286,
    "nom_corrige2":"Michel Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseiller",
    "remuneration":"5400",
    "allocation":"2700",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8100",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":3287,
    "nom_corrige2":"Pierre Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"5400",
    "allocation":"2700",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8100",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":3288,
    "nom_corrige2":"Hélène Dufault",
    "nom_famille":"Dufault",
    "titre_genre2":"Conseillère",
    "remuneration":"5400",
    "allocation":"2700",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8100",
    "ville":"Sainte-Hélène-de-Bagot",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1878"
  },
  {
    "ID":3289,
    "nom_corrige2":"Mireille Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseillère",
    "remuneration":"4881",
    "allocation":"2441",
    "remuneration2":"512,00$",
    "allocation2":"256,00$",
    "total":"8090",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":3290,
    "nom_corrige2":"Donald Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseiller",
    "remuneration":"5391",
    "allocation":"2696",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8087",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":3291,
    "nom_corrige2":"Étienne Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseiller",
    "remuneration":"5391",
    "allocation":"2696",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8087",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":3292,
    "nom_corrige2":"Francis Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"5391",
    "allocation":"2696",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8087",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":3293,
    "nom_corrige2":"Marc-Antoine Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"5391",
    "allocation":"2696",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8087",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":3294,
    "nom_corrige2":"Marie-Andrée Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseillère",
    "remuneration":"5391",
    "allocation":"2696",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8087",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":3295,
    "nom_corrige2":"Jerome Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"5391",
    "allocation":"2696",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8087",
    "ville":"Saint-Prosper",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"3973"
  },
  {
    "ID":3296,
    "nom_corrige2":"Patrice Pinard",
    "nom_famille":"Pinard",
    "titre_genre2":"Conseiller",
    "remuneration":"5346",
    "allocation":"2710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8056",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":3297,
    "nom_corrige2":"Annie Laliberté",
    "nom_famille":"Laliberté",
    "titre_genre2":"Conseillère",
    "remuneration":"5368",
    "allocation":"2684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8052",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":3298,
    "nom_corrige2":"Michel Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Conseiller",
    "remuneration":"5368",
    "allocation":"2684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8052",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":3299,
    "nom_corrige2":"Stéphane Cournoyer",
    "nom_famille":"Cournoyer",
    "titre_genre2":"Conseiller",
    "remuneration":"5368",
    "allocation":"2684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8052",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":3300,
    "nom_corrige2":"Yan Bussières",
    "nom_famille":"Bussières",
    "titre_genre2":"Conseiller",
    "remuneration":"5368",
    "allocation":"2684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8052",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":3301,
    "nom_corrige2":"Myriam Chapdelaine",
    "nom_famille":"Chapdelaine",
    "titre_genre2":"Conseillère",
    "remuneration":"5368",
    "allocation":"2684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8052",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":3302,
    "nom_corrige2":"Joël Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"",
    "remuneration":"5368",
    "allocation":"2684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8052",
    "ville":"Saint-Robert",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1853"
  },
  {
    "ID":3303,
    "nom_corrige2":"Jean-François Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"4882",
    "allocation":"2441",
    "remuneration2":"482,00$",
    "allocation2":"241,00$",
    "total":"8046",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":3304,
    "nom_corrige2":"Vicky Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseillère",
    "remuneration":"4382",
    "allocation":"2126",
    "remuneration2":"1024",
    "allocation2":"512,00$",
    "total":"8044",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":3305,
    "nom_corrige2":"Normand Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"5355",
    "allocation":"2678",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8033",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":3306,
    "nom_corrige2":"Vincent Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"2265",
    "allocation":"1133",
    "remuneration2":"3089",
    "allocation2":"1544",
    "total":"8031",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":3307,
    "nom_corrige2":"Jean-François Baril",
    "nom_famille":"Baril",
    "titre_genre2":"Conseiller",
    "remuneration":"5352",
    "allocation":"2676",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8028",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":3308,
    "nom_corrige2":"Luc Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"5352",
    "allocation":"2676",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8028",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":3309,
    "nom_corrige2":"Maurice Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"5352",
    "allocation":"2676",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8028",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":3310,
    "nom_corrige2":"Noel Beaulé",
    "nom_famille":"Beaulé",
    "titre_genre2":"Conseiller",
    "remuneration":"5352",
    "allocation":"2676",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8028",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":3311,
    "nom_corrige2":"Yvon Charette",
    "nom_famille":"Charette",
    "titre_genre2":"Conseiller",
    "remuneration":"5352",
    "allocation":"2676",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8028",
    "ville":"Rivière-Héva",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1562"
  },
  {
    "ID":3312,
    "nom_corrige2":"Sonya Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"5363",
    "allocation":"2655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8018",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":3313,
    "nom_corrige2":"Gérard Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"5343",
    "allocation":"2672",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8015",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":3314,
    "nom_corrige2":"Guy Bournival",
    "nom_famille":"Bournival",
    "titre_genre2":"Conseiller",
    "remuneration":"5343",
    "allocation":"2672",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8015",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":3315,
    "nom_corrige2":"Manon Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseillère",
    "remuneration":"5343",
    "allocation":"2672",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8015",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":3316,
    "nom_corrige2":"Pierre Généreux",
    "nom_famille":"Généreux",
    "titre_genre2":"Conseiller",
    "remuneration":"5343",
    "allocation":"2672",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8015",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":3317,
    "nom_corrige2":"Vincent Grandmont",
    "nom_famille":"Grandmont",
    "titre_genre2":"Conseiller",
    "remuneration":"5343",
    "allocation":"2672",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"8015",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1867"
  },
  {
    "ID":3318,
    "nom_corrige2":"Ronald Gonthier",
    "nom_famille":"Gonthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4996",
    "allocation":"2230",
    "remuneration2":"488,00$",
    "allocation2":"244,00$",
    "total":"7958",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":3319,
    "nom_corrige2":"Thierry Ratté",
    "nom_famille":"Ratté",
    "titre_genre2":"Conseiller",
    "remuneration":"5258",
    "allocation":"2695",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7953",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":3320,
    "nom_corrige2":"Georges Guénard",
    "nom_famille":"Guénard",
    "titre_genre2":"Maire",
    "remuneration":"5285",
    "allocation":"2642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7927",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":3321,
    "nom_corrige2":"Sylvain T. Bouffard",
    "nom_famille":"T. Bouffard",
    "titre_genre2":"Conseiller",
    "remuneration":"5605",
    "allocation":"2308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7913",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":3322,
    "nom_corrige2":"Éric Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"5258",
    "allocation":"2629",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7887",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":3323,
    "nom_corrige2":"Madone Denis",
    "nom_famille":"Denis",
    "titre_genre2":"Conseillère",
    "remuneration":"5252",
    "allocation":"2626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7878",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":3324,
    "nom_corrige2":"Alyson Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseillère",
    "remuneration":"5252",
    "allocation":"2626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7878",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":3325,
    "nom_corrige2":"Guylain Saucier",
    "nom_famille":"Saucier",
    "titre_genre2":"Conseillère",
    "remuneration":"5252",
    "allocation":"2626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7878",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":3326,
    "nom_corrige2":"Marc Brunelle",
    "nom_famille":"Brunelle",
    "titre_genre2":"Conseillère",
    "remuneration":"5252",
    "allocation":"2626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7878",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":3327,
    "nom_corrige2":"Pierre Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"5252",
    "allocation":"2626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7878",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":3328,
    "nom_corrige2":"Carole Sierpien",
    "nom_famille":"Sierpien",
    "titre_genre2":"Conseillère",
    "remuneration":"5252",
    "allocation":"2626",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7878",
    "ville":"Saint-Mathieu-de-Rioux",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"720"
  },
  {
    "ID":3329,
    "nom_corrige2":"Jacques Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"5249",
    "allocation":"2625",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7874",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":3330,
    "nom_corrige2":"Louise Boudreault",
    "nom_famille":"Boudreault",
    "titre_genre2":"Conseillère",
    "remuneration":"5249",
    "allocation":"2625",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7874",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":3331,
    "nom_corrige2":"Pierre Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseiller",
    "remuneration":"5249",
    "allocation":"2625",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7874",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":3332,
    "nom_corrige2":"Michel Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Préfet suppléant",
    "remuneration":"5249",
    "allocation":"2625",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7874",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":3333,
    "nom_corrige2":"Elaine Juteau",
    "nom_famille":"Juteau",
    "titre_genre2":"Conseillère",
    "remuneration":"5249",
    "allocation":"2625",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7874",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":3334,
    "nom_corrige2":"Marie-Andrée Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseillère",
    "remuneration":"5249",
    "allocation":"2625",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7874",
    "ville":"Saint-Émile-de-Suffolk",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"554"
  },
  {
    "ID":3335,
    "nom_corrige2":"Mario St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"5226",
    "allocation":"2613",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7839",
    "ville":"Saint-Herménégilde",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"745"
  },
  {
    "ID":3336,
    "nom_corrige2":"Jean-Philippe Bouffard",
    "nom_famille":"Bouffard",
    "titre_genre2":"Conseiller",
    "remuneration":"5224",
    "allocation":"2612",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7836",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":3337,
    "nom_corrige2":"Audrey Gingras",
    "nom_famille":"Gingras",
    "titre_genre2":"Conseillère",
    "remuneration":"5222",
    "allocation":"2611",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7833",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":3338,
    "nom_corrige2":"Dominic Turmel",
    "nom_famille":"Turmel",
    "titre_genre2":"Conseiller",
    "remuneration":"5222",
    "allocation":"2611",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7833",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":3339,
    "nom_corrige2":"Jean-Claude Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"5222",
    "allocation":"2611",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7833",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":3340,
    "nom_corrige2":"Jean-Claude Lecours",
    "nom_famille":"Lecours",
    "titre_genre2":"Conseiller",
    "remuneration":"5222",
    "allocation":"2611",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7833",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":3341,
    "nom_corrige2":"Stéphane Brideau",
    "nom_famille":"Brideau",
    "titre_genre2":"Conseiller",
    "remuneration":"5222",
    "allocation":"2611",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7833",
    "ville":"Saint-Janvier-de-Joly",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1166"
  },
  {
    "ID":3342,
    "nom_corrige2":"Guy Bruneau",
    "nom_famille":"Bruneau",
    "titre_genre2":"Conseiller",
    "remuneration":"5217",
    "allocation":"2609",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7826",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":3343,
    "nom_corrige2":"Jean-Pierre Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"5217",
    "allocation":"2609",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7826",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":3344,
    "nom_corrige2":"Pierre Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseiller",
    "remuneration":"5217",
    "allocation":"2609",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7826",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":3345,
    "nom_corrige2":"Marie-Claire Labelle",
    "nom_famille":"Labelle",
    "titre_genre2":"Conseillère",
    "remuneration":"5217",
    "allocation":"2609",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7826",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":3346,
    "nom_corrige2":"Martine Labrosse",
    "nom_famille":"Labrosse",
    "titre_genre2":"Conseillère",
    "remuneration":"5217",
    "allocation":"2609",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7826",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":3347,
    "nom_corrige2":"Louise Mc Mahon",
    "nom_famille":"Mc Mahon",
    "titre_genre2":"Conseillère",
    "remuneration":"5213",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7819",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3348,
    "nom_corrige2":"Marc Arseneault",
    "nom_famille":"Arseneault",
    "titre_genre2":"Conseiller",
    "remuneration":"5213",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7819",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3349,
    "nom_corrige2":"Olivier Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Conseiller",
    "remuneration":"5213",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7819",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3350,
    "nom_corrige2":"Sylvain Lamothe",
    "nom_famille":"Lamothe",
    "titre_genre2":"Conseiller",
    "remuneration":"5213",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7819",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3351,
    "nom_corrige2":"Yvon Parenteau",
    "nom_famille":"Parenteau",
    "titre_genre2":"Conseiller",
    "remuneration":"5213",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7819",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3352,
    "nom_corrige2":"Denis Croteau",
    "nom_famille":"Croteau",
    "titre_genre2":"Conseiller",
    "remuneration":"5213",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7819",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3353,
    "nom_corrige2":"Carole Ste-Marie",
    "nom_famille":"Ste-Marie",
    "titre_genre2":"Conseillère",
    "remuneration":"5211",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7817",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":3354,
    "nom_corrige2":"Carmyn Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"5211",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7817",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":3355,
    "nom_corrige2":"Marie-Claude Adam",
    "nom_famille":"Adam",
    "titre_genre2":"Conseillère",
    "remuneration":"5211",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7817",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":3356,
    "nom_corrige2":"Michel Dubuc",
    "nom_famille":"Dubuc",
    "titre_genre2":"Conseiller",
    "remuneration":"5211",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7817",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":3357,
    "nom_corrige2":"Simon Lejour",
    "nom_famille":"Lejour",
    "titre_genre2":"Conseiller",
    "remuneration":"5211",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7817",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":3358,
    "nom_corrige2":"Vicky Landry Bergeron",
    "nom_famille":"Landry Bergeron",
    "titre_genre2":"Conseillère",
    "remuneration":"5211",
    "allocation":"2606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7817",
    "ville":"Saint-Bernard-de-Lacolle",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1639"
  },
  {
    "ID":3359,
    "nom_corrige2":"Daniel Céleste",
    "nom_famille":"Céleste",
    "titre_genre2":"Maire",
    "remuneration":"4780",
    "allocation":"2749",
    "remuneration2":"176,00$",
    "allocation2":"88,00$",
    "total":"7793",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":3360,
    "nom_corrige2":"Jean-François Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"5191",
    "allocation":"2595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7786",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":3361,
    "nom_corrige2":"Alex Bouthillette",
    "nom_famille":"Bouthillette",
    "titre_genre2":"Conseiller",
    "remuneration":"5231",
    "allocation":"2542",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7773",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":3362,
    "nom_corrige2":"Michaël Crook",
    "nom_famille":"Crook",
    "titre_genre2":"Conseiller",
    "remuneration":"5180",
    "allocation":"2590",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7770",
    "ville":"Ayer's Cliff",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1277"
  },
  {
    "ID":3363,
    "nom_corrige2":"Nathalie Dorion",
    "nom_famille":"Dorion",
    "titre_genre2":"Conseillère",
    "remuneration":"5133",
    "allocation":"2631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7764",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":3364,
    "nom_corrige2":"Anne Minville",
    "nom_famille":"Minville",
    "titre_genre2":"Conseillère",
    "remuneration":"5133",
    "allocation":"2631",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7764",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":3365,
    "nom_corrige2":"Yvon Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Maire",
    "remuneration":"5000",
    "allocation":"2500",
    "remuneration2":"176,00$",
    "allocation2":"88,00$",
    "total":"7764",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":3366,
    "nom_corrige2":"Marco Dénommé",
    "nom_famille":"Dénommé",
    "titre_genre2":"Maire",
    "remuneration":"5147",
    "allocation":"2574",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7721",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":3367,
    "nom_corrige2":"Alexandre Vermette",
    "nom_famille":"Vermette",
    "titre_genre2":"Conseiller",
    "remuneration":"5140",
    "allocation":"2570",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7710",
    "ville":"Saint-Simon",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1418"
  },
  {
    "ID":3368,
    "nom_corrige2":"Fabrice Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"5571",
    "allocation":"2138",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7709",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":3369,
    "nom_corrige2":"Nelson Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"5091",
    "allocation":"2609",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7700",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":3370,
    "nom_corrige2":"Mathieu Laliberté",
    "nom_famille":"Laliberté",
    "titre_genre2":"Conseiller",
    "remuneration":"4795",
    "allocation":"2396",
    "remuneration2":"333,00$",
    "allocation2":"167,00$",
    "total":"7691",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":3371,
    "nom_corrige2":"Frédéric Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"5124",
    "allocation":"2562",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7686",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":3372,
    "nom_corrige2":"Stéphanie Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseillère",
    "remuneration":"4882",
    "allocation":"2441",
    "remuneration2":"241,00$",
    "allocation2":"120,00$",
    "total":"7684",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":3373,
    "nom_corrige2":"Martine Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseillère",
    "remuneration":"5125",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7682",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":3374,
    "nom_corrige2":"Bernard Boudreault",
    "nom_famille":"Boudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"5125",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7682",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":3375,
    "nom_corrige2":"Patrice Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"5125",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7682",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":3376,
    "nom_corrige2":"Kathleen Normand",
    "nom_famille":"Normand",
    "titre_genre2":"Conseillère",
    "remuneration":"5125",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7682",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":3377,
    "nom_corrige2":"Noêlle-Ange Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseillère",
    "remuneration":"5125",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7682",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":3378,
    "nom_corrige2":"Christian Hobden",
    "nom_famille":"Hobden",
    "titre_genre2":"Maire suppléant",
    "remuneration":"5114",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7671",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":3379,
    "nom_corrige2":"Rhéal Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4845",
    "allocation":"2423",
    "remuneration2":"261,00$",
    "allocation2":"130,00$",
    "total":"7659",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":3380,
    "nom_corrige2":"Douglas Morrison",
    "nom_famille":"Morrison",
    "titre_genre2":"Conseiller",
    "remuneration":"5105",
    "allocation":"2552",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7657",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":3381,
    "nom_corrige2":"Martin Couillard",
    "nom_famille":"Couillard",
    "titre_genre2":"Conseiller",
    "remuneration":"5097",
    "allocation":"2549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7646",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":3382,
    "nom_corrige2":"Guy Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"5097",
    "allocation":"2549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7646",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":3383,
    "nom_corrige2":"Mathieu Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"5097",
    "allocation":"2549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7646",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":3384,
    "nom_corrige2":"Benjamin Bourcier",
    "nom_famille":"Bourcier",
    "titre_genre2":"Conseiller",
    "remuneration":"5097",
    "allocation":"2549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7646",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":3385,
    "nom_corrige2":"Guy Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"5097",
    "allocation":"2549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7646",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":3386,
    "nom_corrige2":"Jacques Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseiller",
    "remuneration":"5097",
    "allocation":"2549",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7646",
    "ville":"Saint-Étienne-de-Beauharnois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1133"
  },
  {
    "ID":3387,
    "nom_corrige2":"Charles Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"5507",
    "allocation":"2138",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7645",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":3388,
    "nom_corrige2":"Ann-Marielle Tinkler",
    "nom_famille":"Tinkler",
    "titre_genre2":"Conseillère",
    "remuneration":"5094",
    "allocation":"2547",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7641",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":3389,
    "nom_corrige2":"Daphné Rodgers",
    "nom_famille":"Rodgers",
    "titre_genre2":"Conseillère",
    "remuneration":"5094",
    "allocation":"2547",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7641",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":3390,
    "nom_corrige2":"Miguel Dicaire",
    "nom_famille":"Dicaire",
    "titre_genre2":"Conseiller",
    "remuneration":"5094",
    "allocation":"2547",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7641",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":3391,
    "nom_corrige2":"Monique Malo",
    "nom_famille":"Malo",
    "titre_genre2":"Conseillère",
    "remuneration":"5094",
    "allocation":"2547",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7641",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":3392,
    "nom_corrige2":"Nil Béland",
    "nom_famille":"Béland",
    "titre_genre2":"Conseiller",
    "remuneration":"5094",
    "allocation":"2547",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7641",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":3393,
    "nom_corrige2":"Thierry Dansereau",
    "nom_famille":"Dansereau",
    "titre_genre2":"Conseiller",
    "remuneration":"5094",
    "allocation":"2547",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7641",
    "ville":"Plaisance",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1179"
  },
  {
    "ID":3394,
    "nom_corrige2":"Alexandra Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"5091",
    "allocation":"2545",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7636",
    "ville":"Saint-Rosaire",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"948"
  },
  {
    "ID":3395,
    "nom_corrige2":"Nathalie Bonneville",
    "nom_famille":"Bonneville",
    "titre_genre2":"Conseillère",
    "remuneration":"5088",
    "allocation":"2544",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7632",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":3396,
    "nom_corrige2":"Geneviève Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"5088",
    "allocation":"2544",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7632",
    "ville":"Sainte-Anne-de-Sabrevois",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2270"
  },
  {
    "ID":3397,
    "nom_corrige2":"Luce Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Mairesse",
    "remuneration":"3684",
    "allocation":"1655",
    "remuneration2":"1516",
    "allocation2":"758,00$",
    "total":"7613",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":3398,
    "nom_corrige2":"Rock Arpin",
    "nom_famille":"Arpin",
    "titre_genre2":"Conseiller",
    "remuneration":"5066",
    "allocation":"2533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7599",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":3399,
    "nom_corrige2":"Mario Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"5066",
    "allocation":"2533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7599",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":3400,
    "nom_corrige2":"Richard Gélinas",
    "nom_famille":"Gélinas",
    "titre_genre2":"Conseiller",
    "remuneration":"5061",
    "allocation":"2530",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7591",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":3401,
    "nom_corrige2":"Johanne Lacourse",
    "nom_famille":"Lacourse",
    "titre_genre2":"Conseillère",
    "remuneration":"5164",
    "allocation":"2426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7590",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":3402,
    "nom_corrige2":"Gilles Viens",
    "nom_famille":"Viens",
    "titre_genre2":"Conseiller",
    "remuneration":"4439",
    "allocation":"2219",
    "remuneration2":"509,00$",
    "allocation2":"412,00$",
    "total":"7579",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":3403,
    "nom_corrige2":"Sébastien Primeau",
    "nom_famille":"Primeau",
    "titre_genre2":"Conseiller",
    "remuneration":"5048",
    "allocation":"2524",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7572",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":3404,
    "nom_corrige2":"Steven Strong-Gallant",
    "nom_famille":"Strong-Gallant",
    "titre_genre2":"Conseiller",
    "remuneration":"5048",
    "allocation":"2524",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7572",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":3405,
    "nom_corrige2":"Nicole Hémond",
    "nom_famille":"Hémond",
    "titre_genre2":"Conseillère",
    "remuneration":"5048",
    "allocation":"2524",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7572",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":3406,
    "nom_corrige2":"Willy Mouzon",
    "nom_famille":"Mouzon",
    "titre_genre2":"Conseiller",
    "remuneration":"5048",
    "allocation":"2524",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7572",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":3407,
    "nom_corrige2":"Line Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseillère",
    "remuneration":"5048",
    "allocation":"2524",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7572",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":3408,
    "nom_corrige2":"Isabelle Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseillère",
    "remuneration":"5048",
    "allocation":"2524",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7572",
    "ville":"Très-Saint-Rédempteur",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1142"
  },
  {
    "ID":3409,
    "nom_corrige2":"Hugo Berthiaume",
    "nom_famille":"Berthiaume",
    "titre_genre2":"Conseiller",
    "remuneration":"4290",
    "allocation":"2145",
    "remuneration2":"755,00$",
    "allocation2":"378,00$",
    "total":"7568",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":3410,
    "nom_corrige2":"David Branch",
    "nom_famille":"Branch",
    "titre_genre2":"Conseiller",
    "remuneration":"5045",
    "allocation":"2522",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7567",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":3411,
    "nom_corrige2":"Gaetan Lafrance",
    "nom_famille":"Lafrance",
    "titre_genre2":"Conseiller",
    "remuneration":"5045",
    "allocation":"2522",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7567",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":3412,
    "nom_corrige2":"Claude Carrière",
    "nom_famille":"Carrière",
    "titre_genre2":"Conseiller",
    "remuneration":"5040",
    "allocation":"2520",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7560",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":3413,
    "nom_corrige2":"Jody Arzberger",
    "nom_famille":"Arzberger",
    "titre_genre2":"Conseillère",
    "remuneration":"5040",
    "allocation":"2520",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7560",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":3414,
    "nom_corrige2":"Marie Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"5040",
    "allocation":"2520",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7560",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":3415,
    "nom_corrige2":"Michel Labrosse",
    "nom_famille":"Labrosse",
    "titre_genre2":"Conseiller",
    "remuneration":"5040",
    "allocation":"2520",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7560",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":3416,
    "nom_corrige2":"Patricia Cox",
    "nom_famille":"Cox",
    "titre_genre2":"Conseillère",
    "remuneration":"5040",
    "allocation":"2520",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7560",
    "ville":"Kipawa",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"419"
  },
  {
    "ID":3417,
    "nom_corrige2":"Nelson Pilote",
    "nom_famille":"Pilote",
    "titre_genre2":"Maire",
    "remuneration":"5011",
    "allocation":"2506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7517",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":3418,
    "nom_corrige2":"Léo-Paul Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Conseiller",
    "remuneration":"4712",
    "allocation":"2356",
    "remuneration2":"290,00$",
    "allocation2":"145,00$",
    "total":"7503",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":3419,
    "nom_corrige2":"Yannick Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseiller",
    "remuneration":"5002",
    "allocation":"2501",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7503",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":3420,
    "nom_corrige2":"David Adams",
    "nom_famille":"Adams",
    "titre_genre2":"Conseiller",
    "remuneration":"4997",
    "allocation":"2498",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7495",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":3421,
    "nom_corrige2":"Karine Beaudin",
    "nom_famille":"Beaudin",
    "titre_genre2":"Conseillère",
    "remuneration":"4997",
    "allocation":"2498",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7495",
    "ville":"Clarenceville",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1213"
  },
  {
    "ID":3422,
    "nom_corrige2":"Corrine Lizotte",
    "nom_famille":"Lizotte",
    "titre_genre2":"Conseillère",
    "remuneration":"4990",
    "allocation":"2495",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7485",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":3423,
    "nom_corrige2":"François Diguer",
    "nom_famille":"Diguer",
    "titre_genre2":"Conseiller",
    "remuneration":"4990",
    "allocation":"2495",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7485",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":3424,
    "nom_corrige2":"Lucie Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseillère",
    "remuneration":"4990",
    "allocation":"2495",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7485",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":3425,
    "nom_corrige2":"Lucien Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"4990",
    "allocation":"2495",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7485",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":3426,
    "nom_corrige2":"Mikael St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"4990",
    "allocation":"2495",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7485",
    "ville":"Saint-Aubert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1408"
  },
  {
    "ID":3427,
    "nom_corrige2":"Jean-Pierre Arpin",
    "nom_famille":"Arpin",
    "titre_genre2":"Conseiller",
    "remuneration":"4264",
    "allocation":"2132",
    "remuneration2":"723,00$",
    "allocation2":"361,00$",
    "total":"7480",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":3428,
    "nom_corrige2":"Sylvain Hinse",
    "nom_famille":"Hinse",
    "titre_genre2":"Conseiller",
    "remuneration":"5938",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7467",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":3429,
    "nom_corrige2":"France Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseillère",
    "remuneration":"4977",
    "allocation":"2488",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7465",
    "ville":"L'Île-d'Anticosti",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"196"
  },
  {
    "ID":3430,
    "nom_corrige2":"Isabelle Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseillère",
    "remuneration":"4977",
    "allocation":"2488",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7465",
    "ville":"L'Île-d'Anticosti",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"196"
  },
  {
    "ID":3431,
    "nom_corrige2":"Marie-Pierre Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"4977",
    "allocation":"2488",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7465",
    "ville":"L'Île-d'Anticosti",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"196"
  },
  {
    "ID":3432,
    "nom_corrige2":"Shawna Doucet",
    "nom_famille":"Doucet",
    "titre_genre2":"Conseillère",
    "remuneration":"4977",
    "allocation":"2488",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7465",
    "ville":"L'Île-d'Anticosti",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"196"
  },
  {
    "ID":3433,
    "nom_corrige2":"Lise Bourgeois-Doré",
    "nom_famille":"Bourgeois-Doré",
    "titre_genre2":"Conseillère",
    "remuneration":"4964",
    "allocation":"2482",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7446",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":3434,
    "nom_corrige2":"Éric Laliberté",
    "nom_famille":"Laliberté",
    "titre_genre2":"Conseiller",
    "remuneration":"4238",
    "allocation":"2119",
    "remuneration2":"361,00$",
    "allocation2":"723,00$",
    "total":"7441",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":3435,
    "nom_corrige2":"Marcel Boulay",
    "nom_famille":"Boulay",
    "titre_genre2":"Conseiller",
    "remuneration":"5009",
    "allocation":"2426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7435",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":3436,
    "nom_corrige2":"Patrick Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"5125",
    "allocation":"2308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7433",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":3437,
    "nom_corrige2":"Teddy Chiasson",
    "nom_famille":"Chiasson",
    "titre_genre2":"Conseiller",
    "remuneration":"4955",
    "allocation":"2477",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7432",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":3438,
    "nom_corrige2":"Gilles Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Maire",
    "remuneration":"4944",
    "allocation":"2472",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7416",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":3439,
    "nom_corrige2":"Jessyka Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseillère",
    "remuneration":"5064",
    "allocation":"2308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7372",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":3440,
    "nom_corrige2":"Serge Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseiller",
    "remuneration":"5064",
    "allocation":"2308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7372",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":3441,
    "nom_corrige2":"Guy Massicotte",
    "nom_famille":"Massicotte",
    "titre_genre2":"Conseiller",
    "remuneration":"4909",
    "allocation":"2455",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7364",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":3442,
    "nom_corrige2":"Francis Grégoire",
    "nom_famille":"Grégoire",
    "titre_genre2":"Conseiller",
    "remuneration":"4020",
    "allocation":"2010",
    "remuneration2":"884,00$",
    "allocation2":"442,00$",
    "total":"7356",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":3443,
    "nom_corrige2":"Gillles Rathier",
    "nom_famille":"Rathier",
    "titre_genre2":"Conseiller",
    "remuneration":"4911",
    "allocation":"2431",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7342",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":3444,
    "nom_corrige2":"Jacques Gour",
    "nom_famille":"Gour",
    "titre_genre2":"Conseiller",
    "remuneration":"4911",
    "allocation":"2431",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7342",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":3445,
    "nom_corrige2":"Linda Cournoyer",
    "nom_famille":"Cournoyer",
    "titre_genre2":"Conseillère",
    "remuneration":"4014",
    "allocation":"2007",
    "remuneration2":"873,00$",
    "allocation2":"437,00$",
    "total":"7331",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":3446,
    "nom_corrige2":"Paul Bourgeois",
    "nom_famille":"Bourgeois",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4886",
    "allocation":"2443",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7329",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":3447,
    "nom_corrige2":"Lise Bachand",
    "nom_famille":"Bachand",
    "titre_genre2":"Conseillère",
    "remuneration":"4882",
    "allocation":"2441",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7323",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":3448,
    "nom_corrige2":"Lydia Richer",
    "nom_famille":"Richer",
    "titre_genre2":"Conseillère",
    "remuneration":"4882",
    "allocation":"2441",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7323",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":3449,
    "nom_corrige2":"Mélissa Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseillère",
    "remuneration":"4882",
    "allocation":"2441",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7323",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":3450,
    "nom_corrige2":"Irène Drouin Dubreuil",
    "nom_famille":"Drouin Dubreuil",
    "titre_genre2":"Conseillère",
    "remuneration":"4882",
    "allocation":"2441",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7323",
    "ville":"Saint-Dominique",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2965"
  },
  {
    "ID":3451,
    "nom_corrige2":"Marie-Claude Samuel",
    "nom_famille":"Samuel",
    "titre_genre2":"Conseillère",
    "remuneration":"4864",
    "allocation":"2432",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7296",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":3452,
    "nom_corrige2":"Roger Marceau",
    "nom_famille":"Marceau",
    "titre_genre2":"Conseiller",
    "remuneration":"4864",
    "allocation":"2432",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7296",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":3453,
    "nom_corrige2":"Yanick Godon",
    "nom_famille":"Godon",
    "titre_genre2":"Conseiller",
    "remuneration":"4864",
    "allocation":"2432",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7296",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":3454,
    "nom_corrige2":"Isabelle Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseillère",
    "remuneration":"4751",
    "allocation":"2538",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7289",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":3455,
    "nom_corrige2":"Clarence Lloyd",
    "nom_famille":"Lloyd",
    "titre_genre2":"Conseillère",
    "remuneration":"4856",
    "allocation":"2428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7284",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":3456,
    "nom_corrige2":"Alexandre Berger",
    "nom_famille":"Berger",
    "titre_genre2":"Conseiller",
    "remuneration":"4856",
    "allocation":"2428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7284",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":3457,
    "nom_corrige2":"Suzy Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"4856",
    "allocation":"2428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7284",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":3458,
    "nom_corrige2":"François Castonguay",
    "nom_famille":"Castonguay",
    "titre_genre2":"Conseiller",
    "remuneration":"4375",
    "allocation":"2434",
    "remuneration2":"315,00$",
    "allocation2":"157,00$",
    "total":"7281",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":3459,
    "nom_corrige2":"Sylvain Dorion",
    "nom_famille":"Dorion",
    "titre_genre2":"Conseiller",
    "remuneration":"4853",
    "allocation":"2427",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7280",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":3460,
    "nom_corrige2":"Annie Sénéchal",
    "nom_famille":"Sénéchal",
    "titre_genre2":"Conseillère",
    "remuneration":"4853",
    "allocation":"2427",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7280",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":3461,
    "nom_corrige2":"Josée Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"4853",
    "allocation":"2427",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7280",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":3462,
    "nom_corrige2":"Pascale G. Malenfant",
    "nom_famille":"G. Malenfant",
    "titre_genre2":"Conseillère",
    "remuneration":"4853",
    "allocation":"2427",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7280",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":3463,
    "nom_corrige2":"Natasha Pelleteir",
    "nom_famille":"Pelleteir",
    "titre_genre2":"Conseillère",
    "remuneration":"4853",
    "allocation":"2427",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7280",
    "ville":"Sainte-Anne-de-la-Pocatière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1673"
  },
  {
    "ID":3464,
    "nom_corrige2":"Gaétan Dutil",
    "nom_famille":"Dutil",
    "titre_genre2":"Conseiller",
    "remuneration":"4853",
    "allocation":"2426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7279",
    "ville":"Sainte-Lucie-des-Laurentides",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1602"
  },
  {
    "ID":3465,
    "nom_corrige2":"Renaud Robinson",
    "nom_famille":"Robinson",
    "titre_genre2":"Conseiller",
    "remuneration":"4923",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7279",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":3466,
    "nom_corrige2":"Vincent Daraiche",
    "nom_famille":"Daraiche",
    "titre_genre2":"Conseiller",
    "remuneration":"4923",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7279",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":3467,
    "nom_corrige2":"Étienne Decelles",
    "nom_famille":"Decelles",
    "titre_genre2":"Conseiller",
    "remuneration":"4852",
    "allocation":"2426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7278",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":3468,
    "nom_corrige2":"Lise Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseillère",
    "remuneration":"4852",
    "allocation":"2426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7278",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":3469,
    "nom_corrige2":"Diane Kirouac",
    "nom_famille":"Kirouac",
    "titre_genre2":"Conseillère",
    "remuneration":"4849",
    "allocation":"2424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7273",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":3470,
    "nom_corrige2":"François Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"4849",
    "allocation":"2424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7273",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":3471,
    "nom_corrige2":"Jean-Philippe Bibeau",
    "nom_famille":"Bibeau",
    "titre_genre2":"Conseiller",
    "remuneration":"4849",
    "allocation":"2424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7273",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":3472,
    "nom_corrige2":"Nicolas Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseiller",
    "remuneration":"4849",
    "allocation":"2424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7273",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":3473,
    "nom_corrige2":"Pascale Boislard",
    "nom_famille":"Boislard",
    "titre_genre2":"Conseillère",
    "remuneration":"4849",
    "allocation":"2424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7273",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":3474,
    "nom_corrige2":"Francis Lacharité",
    "nom_famille":"Lacharité",
    "titre_genre2":"Conseiller",
    "remuneration":"4849",
    "allocation":"2424",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7273",
    "ville":"Saint-Albert",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1759"
  },
  {
    "ID":3475,
    "nom_corrige2":"Marie-Ève Goos",
    "nom_famille":"Goos",
    "titre_genre2":"Conseillère",
    "remuneration":"4845",
    "allocation":"2423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7268",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":3476,
    "nom_corrige2":"Benoit Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"4845",
    "allocation":"2423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7268",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":3477,
    "nom_corrige2":"Charles Choquette",
    "nom_famille":"Choquette",
    "titre_genre2":"Conseiller",
    "remuneration":"4845",
    "allocation":"2423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7268",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":3478,
    "nom_corrige2":"Éric Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseiller",
    "remuneration":"4845",
    "allocation":"2423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7268",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":3479,
    "nom_corrige2":"Jonathan Alix",
    "nom_famille":"Alix",
    "titre_genre2":"Conseiller",
    "remuneration":"4845",
    "allocation":"2423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7268",
    "ville":"Ange-Gardien",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"3074"
  },
  {
    "ID":3480,
    "nom_corrige2":"Daniel Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"4893",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7249",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":3481,
    "nom_corrige2":"Tim Robinson",
    "nom_famille":"Robinson",
    "titre_genre2":"Conseiller",
    "remuneration":"4893",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7249",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":3482,
    "nom_corrige2":"Benoit Magny",
    "nom_famille":"Magny",
    "titre_genre2":"Conseiller",
    "remuneration":"4831",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7246",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":3483,
    "nom_corrige2":"Hugo Massicotte",
    "nom_famille":"Massicotte",
    "titre_genre2":"Conseiller",
    "remuneration":"4831",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7246",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":3484,
    "nom_corrige2":"François Légaré",
    "nom_famille":"Légaré",
    "titre_genre2":"Conseiller",
    "remuneration":"4738",
    "allocation":"2506",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":3485,
    "nom_corrige2":"Carole Dumontier",
    "nom_famille":"Dumontier",
    "titre_genre2":"Conseillère",
    "remuneration":"4829",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":3486,
    "nom_corrige2":"Jacques Damphousse",
    "nom_famille":"Damphousse",
    "titre_genre2":"Conseiller",
    "remuneration":"4829",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":3487,
    "nom_corrige2":"Jonathan Lacourse",
    "nom_famille":"Lacourse",
    "titre_genre2":"Conseiller",
    "remuneration":"4829",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":3488,
    "nom_corrige2":"Marco Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseiller",
    "remuneration":"4829",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":3489,
    "nom_corrige2":"René Rinfret",
    "nom_famille":"Rinfret",
    "titre_genre2":"Conseiller",
    "remuneration":"4829",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":3490,
    "nom_corrige2":"Robert Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseiller",
    "remuneration":"4829",
    "allocation":"2415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7244",
    "ville":"Maskinongé",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2439"
  },
  {
    "ID":3491,
    "nom_corrige2":"Fabien Lacorre",
    "nom_famille":"Lacorre",
    "titre_genre2":"Conseiller",
    "remuneration":"4826",
    "allocation":"2413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7239",
    "ville":"Lac-Etchemin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"4073"
  },
  {
    "ID":3492,
    "nom_corrige2":"Mireille Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseillère",
    "remuneration":"4826",
    "allocation":"2413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7239",
    "ville":"Tring-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1612"
  },
  {
    "ID":3493,
    "nom_corrige2":"Sylvain Lafrenaye",
    "nom_famille":"Lafrenaye",
    "titre_genre2":"Conseiller",
    "remuneration":"4020",
    "allocation":"2010",
    "remuneration2":"794,00$",
    "allocation2":"397,00$",
    "total":"7221",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":3494,
    "nom_corrige2":"Geneviève Allaire",
    "nom_famille":"Allaire",
    "titre_genre2":"Conseillère",
    "remuneration":"4807",
    "allocation":"2404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7211",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":3495,
    "nom_corrige2":"Stéphanie Bonin",
    "nom_famille":"Bonin",
    "titre_genre2":"Conseillère",
    "remuneration":"4807",
    "allocation":"2404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7211",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":3496,
    "nom_corrige2":"Valérie Chicoine",
    "nom_famille":"Chicoine",
    "titre_genre2":"Conseillère",
    "remuneration":"4807",
    "allocation":"2404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7211",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":3497,
    "nom_corrige2":"Nancy Letendre",
    "nom_famille":"Letendre",
    "titre_genre2":"Conseillère",
    "remuneration":"4807",
    "allocation":"2404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7211",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":3498,
    "nom_corrige2":"Marcel Sinclair",
    "nom_famille":"Sinclair",
    "titre_genre2":"Conseiller",
    "remuneration":"4807",
    "allocation":"2404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7211",
    "ville":"Saint-Majorique-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1364"
  },
  {
    "ID":3499,
    "nom_corrige2":"Anthony Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseiller",
    "remuneration":"4669",
    "allocation":"2335",
    "remuneration2":"133,00$",
    "allocation2":"67,00$",
    "total":"7204",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":3500,
    "nom_corrige2":"Cathy Bruneau",
    "nom_famille":"Bruneau",
    "titre_genre2":"Mairesse",
    "remuneration":"4800",
    "allocation":"2400",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7200",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":3501,
    "nom_corrige2":"Réjean Normand",
    "nom_famille":"Normand",
    "titre_genre2":"Maire",
    "remuneration":"4800",
    "allocation":"2400",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7200",
    "ville":"Rivière-à-Claude",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"153"
  },
  {
    "ID":3502,
    "nom_corrige2":"Audrey Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Conseillère",
    "remuneration":"4798",
    "allocation":"2399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7197",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":3503,
    "nom_corrige2":"Elizabeth Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseillère",
    "remuneration":"4798",
    "allocation":"2399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7197",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":3504,
    "nom_corrige2":"Hugo-Pierre Bellemare",
    "nom_famille":"Bellemare",
    "titre_genre2":"Conseiller",
    "remuneration":"4798",
    "allocation":"2399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7197",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":3505,
    "nom_corrige2":"Noémi Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseillère",
    "remuneration":"4798",
    "allocation":"2399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7197",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":3506,
    "nom_corrige2":"Richard Cossette",
    "nom_famille":"Cossette",
    "titre_genre2":"Conseiller",
    "remuneration":"4798",
    "allocation":"2399",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7197",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":3507,
    "nom_corrige2":"Rébecca Plourde-Gagnon",
    "nom_famille":"Plourde-Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"5054",
    "allocation":"2138",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7192",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":3508,
    "nom_corrige2":"Roger Bouthillette",
    "nom_famille":"Bouthillette",
    "titre_genre2":"Maire",
    "remuneration":"4655",
    "allocation":"2522",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7177",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":3509,
    "nom_corrige2":"Cathy Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"4795",
    "allocation":"2372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7167",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":3510,
    "nom_corrige2":"Dominique Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"4795",
    "allocation":"2372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7167",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":3511,
    "nom_corrige2":"Guylaine Morel",
    "nom_famille":"Morel",
    "titre_genre2":"Conseillère",
    "remuneration":"4795",
    "allocation":"2372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7167",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":3512,
    "nom_corrige2":"Louise Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseillère",
    "remuneration":"4795",
    "allocation":"2372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7167",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":3513,
    "nom_corrige2":"Mélina Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseillère",
    "remuneration":"4795",
    "allocation":"2372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7167",
    "ville":"Saint-Hilarion",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1231"
  },
  {
    "ID":3514,
    "nom_corrige2":"Renaud Hould",
    "nom_famille":"Hould",
    "titre_genre2":"Conseiller",
    "remuneration":"4777",
    "allocation":"2388",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7165",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":3515,
    "nom_corrige2":"Catherine Bourget",
    "nom_famille":"Bourget",
    "titre_genre2":"Conseillère",
    "remuneration":"4760",
    "allocation":"2380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7140",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":3516,
    "nom_corrige2":"Gilles Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4760",
    "allocation":"2380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7140",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":3517,
    "nom_corrige2":"Jocelyn Cossette",
    "nom_famille":"Cossette",
    "titre_genre2":"Conseiller",
    "remuneration":"4760",
    "allocation":"2380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7140",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":3518,
    "nom_corrige2":"Kim Mongrain",
    "nom_famille":"Mongrain",
    "titre_genre2":"Conseillère",
    "remuneration":"4760",
    "allocation":"2380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7140",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":3519,
    "nom_corrige2":"Michel Larivière",
    "nom_famille":"Larivière",
    "titre_genre2":"Conseiller",
    "remuneration":"4760",
    "allocation":"2380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7140",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":3520,
    "nom_corrige2":"Nathalie Jacob",
    "nom_famille":"Jacob",
    "titre_genre2":"Conseillère",
    "remuneration":"4760",
    "allocation":"2380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7140",
    "ville":"Saint-Narcisse",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1889"
  },
  {
    "ID":3521,
    "nom_corrige2":"Berchmans Minville",
    "nom_famille":"Minville",
    "titre_genre2":"Conseiller",
    "remuneration":"4720",
    "allocation":"2419",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7139",
    "ville":"Grande-Vallée",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1070"
  },
  {
    "ID":3522,
    "nom_corrige2":"Éric Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseiller",
    "remuneration":"4705",
    "allocation":"2430",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7135",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":3523,
    "nom_corrige2":"Edwin Bond",
    "nom_famille":"Bond",
    "titre_genre2":"Conseiller",
    "remuneration":"4752",
    "allocation":"2376",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7128",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":3524,
    "nom_corrige2":"Jeffrey Garrett",
    "nom_famille":"Garrett",
    "titre_genre2":"Conseiller",
    "remuneration":"4748",
    "allocation":"2374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7122",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":3525,
    "nom_corrige2":"Andy Maheux",
    "nom_famille":"Maheux",
    "titre_genre2":"Conseiller",
    "remuneration":"4770",
    "allocation":"2350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7120",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":3526,
    "nom_corrige2":"Camil Samson",
    "nom_famille":"Samson",
    "titre_genre2":"Conseiller",
    "remuneration":"4651",
    "allocation":"2463",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7114",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":3527,
    "nom_corrige2":"Denise Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"4742",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7113",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":3528,
    "nom_corrige2":"Gaétan Boudreault",
    "nom_famille":"Boudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"4742",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7113",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":3529,
    "nom_corrige2":"Léonard Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"4742",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7113",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":3530,
    "nom_corrige2":"Lyne Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"4742",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7113",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":3531,
    "nom_corrige2":"Sandra Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseillère",
    "remuneration":"4742",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7113",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":3532,
    "nom_corrige2":"Sylvain Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"4742",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7113",
    "ville":"Saint-Urbain",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1419"
  },
  {
    "ID":3533,
    "nom_corrige2":"Stéphane Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"4741",
    "allocation":"2371",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7112",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":3534,
    "nom_corrige2":"Jean-François Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"4739",
    "allocation":"2369",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7108",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":3535,
    "nom_corrige2":"Valérie-Lora Trucon",
    "nom_famille":"Trucon",
    "titre_genre2":"Conseillère",
    "remuneration":"4739",
    "allocation":"2369",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7108",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":3536,
    "nom_corrige2":"Annie Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseillère",
    "remuneration":"4739",
    "allocation":"2369",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7108",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":3537,
    "nom_corrige2":"Gaétan Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"4739",
    "allocation":"2369",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7108",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":3538,
    "nom_corrige2":"Marie-Hélène Bouillon",
    "nom_famille":"Bouillon",
    "titre_genre2":"Conseillère",
    "remuneration":"4739",
    "allocation":"2369",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7108",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":3539,
    "nom_corrige2":"Nancy Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"4739",
    "allocation":"2369",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7108",
    "ville":"Saint-Ulric",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1656"
  },
  {
    "ID":3540,
    "nom_corrige2":"Denise Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Conseillère",
    "remuneration":"4718",
    "allocation":"2359",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7077",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":3541,
    "nom_corrige2":"Georges Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseiller",
    "remuneration":"4765",
    "allocation":"2308",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7073",
    "ville":"Saint-Flavien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1677"
  },
  {
    "ID":3542,
    "nom_corrige2":"Alain Crevier",
    "nom_famille":"Crevier",
    "titre_genre2":"Conseiller",
    "remuneration":"4712",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7068",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":3543,
    "nom_corrige2":"Danielle Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseillère",
    "remuneration":"4712",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7068",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":3544,
    "nom_corrige2":"Martin Joyal",
    "nom_famille":"Joyal",
    "titre_genre2":"Conseiller",
    "remuneration":"4712",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7068",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":3545,
    "nom_corrige2":"Richard Théroux",
    "nom_famille":"Théroux",
    "titre_genre2":"Conseiller",
    "remuneration":"4712",
    "allocation":"2356",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7068",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":3546,
    "nom_corrige2":"François Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"4712",
    "allocation":"2355",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7067",
    "ville":"Yamaska",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1754"
  },
  {
    "ID":3547,
    "nom_corrige2":"Mathieu Racine",
    "nom_famille":"Racine",
    "titre_genre2":"Conseiller",
    "remuneration":"4924",
    "allocation":"2138",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7062",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":3548,
    "nom_corrige2":"Stéphane Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"4705",
    "allocation":"2354",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7059",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":3549,
    "nom_corrige2":"Lucie Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Conseillère",
    "remuneration":"4700",
    "allocation":"2350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7050",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":3550,
    "nom_corrige2":"Mélanie Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseillère",
    "remuneration":"4700",
    "allocation":"2350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7050",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":3551,
    "nom_corrige2":"René Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"4700",
    "allocation":"2350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7050",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":3552,
    "nom_corrige2":"Sonya Provost",
    "nom_famille":"Provost",
    "titre_genre2":"Conseillère",
    "remuneration":"4700",
    "allocation":"2350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7050",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":3553,
    "nom_corrige2":"Marcel Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"4700",
    "allocation":"2350",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7050",
    "ville":"Frontenac",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1858"
  },
  {
    "ID":3554,
    "nom_corrige2":"Marie-Josée Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseillère",
    "remuneration":"4698",
    "allocation":"2349",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7047",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":3555,
    "nom_corrige2":"Maryse Lebrasseur",
    "nom_famille":"Lebrasseur",
    "titre_genre2":"Conseillère",
    "remuneration":"4698",
    "allocation":"2349",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7047",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":3556,
    "nom_corrige2":"Alain Conraud",
    "nom_famille":"Conraud",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"550,00$",
    "allocation2":"623,00$",
    "total":"7035",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":3557,
    "nom_corrige2":"Marlène langlois",
    "nom_famille":"langlois",
    "titre_genre2":"Conseillère",
    "remuneration":"4688",
    "allocation":"2344",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7032",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":3558,
    "nom_corrige2":"Chantal Guertin",
    "nom_famille":"Guertin",
    "titre_genre2":"Conseillère",
    "remuneration":"4676",
    "allocation":"2338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7014",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":3559,
    "nom_corrige2":"Diane Major",
    "nom_famille":"Major",
    "titre_genre2":"Conseillère",
    "remuneration":"4676",
    "allocation":"2338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7014",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":3560,
    "nom_corrige2":"Dominick Richer",
    "nom_famille":"Richer",
    "titre_genre2":"Conseiller",
    "remuneration":"4676",
    "allocation":"2338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7014",
    "ville":"Lac-des-Plages",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"543"
  },
  {
    "ID":3561,
    "nom_corrige2":"Fernando Sanchez",
    "nom_famille":"Sanchez",
    "titre_genre2":"Conseiller",
    "remuneration":"4669",
    "allocation":"2335",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"7004",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":3562,
    "nom_corrige2":"Alexandre Dubuc-Ringuette",
    "nom_famille":"Dubuc-Ringuette",
    "titre_genre2":"Conseiller",
    "remuneration":"4661",
    "allocation":"2338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6999",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":3563,
    "nom_corrige2":"Kathleen Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseillère",
    "remuneration":"4859",
    "allocation":"2138",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6997",
    "ville":"Saint-Nazaire",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"2138"
  },
  {
    "ID":3564,
    "nom_corrige2":"Pauline Dubois",
    "nom_famille":"Dubois",
    "titre_genre2":"Conseillère",
    "remuneration":"4576",
    "allocation":"2413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6989",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":3565,
    "nom_corrige2":"Johanne Maurice",
    "nom_famille":"Maurice",
    "titre_genre2":"Conseillère",
    "remuneration":"4656",
    "allocation":"2328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6984",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":3566,
    "nom_corrige2":"Jonathan Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"4656",
    "allocation":"2328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6984",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":3567,
    "nom_corrige2":"Philippe Verly",
    "nom_famille":"Verly",
    "titre_genre2":"Conseiller",
    "remuneration":"4656",
    "allocation":"2328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6984",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":3568,
    "nom_corrige2":"Raymond Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"4656",
    "allocation":"2328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6984",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":3569,
    "nom_corrige2":"Sylvain Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"4656",
    "allocation":"2328",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6984",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":3570,
    "nom_corrige2":"Pierre Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Maire",
    "remuneration":"4791",
    "allocation":"2188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6979",
    "ville":"Les Éboulements",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1610"
  },
  {
    "ID":3571,
    "nom_corrige2":"Marie-Blanche Richer",
    "nom_famille":"Richer",
    "titre_genre2":"Conseillère",
    "remuneration":"4650",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6975",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":3572,
    "nom_corrige2":"Gilles Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseiller",
    "remuneration":"4650",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6975",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":3573,
    "nom_corrige2":"Loren Allen",
    "nom_famille":"Allen",
    "titre_genre2":"Conseiller",
    "remuneration":"4650",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6975",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":3574,
    "nom_corrige2":"Margarita Lafontaine",
    "nom_famille":"Lafontaine",
    "titre_genre2":"Conseillère",
    "remuneration":"4650",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6975",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":3575,
    "nom_corrige2":"Nancy Lanteigne",
    "nom_famille":"Lanteigne",
    "titre_genre2":"Conseillère",
    "remuneration":"4650",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6975",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":3576,
    "nom_corrige2":"Eddy Whitcher",
    "nom_famille":"Whitcher",
    "titre_genre2":"Conseiller",
    "remuneration":"4650",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6975",
    "ville":"Bolton-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"776"
  },
  {
    "ID":3577,
    "nom_corrige2":"Catherine Pellerin",
    "nom_famille":"Pellerin",
    "titre_genre2":"Conseillère",
    "remuneration":"4648",
    "allocation":"2324",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6972",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":3578,
    "nom_corrige2":"Lyne Dubuc",
    "nom_famille":"Dubuc",
    "titre_genre2":"Conseillère",
    "remuneration":"4648",
    "allocation":"2324",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6972",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":3579,
    "nom_corrige2":"Gaétan Bastien",
    "nom_famille":"Bastien",
    "titre_genre2":"Conseiller",
    "remuneration":"4648",
    "allocation":"2324",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6972",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":3580,
    "nom_corrige2":"Eddy Boudreau",
    "nom_famille":"Boudreau",
    "titre_genre2":"Conseiller",
    "remuneration":"4644",
    "allocation":"2322",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6966",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":3581,
    "nom_corrige2":"Stéphane Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseiller",
    "remuneration":"4606",
    "allocation":"2354",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6960",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":3582,
    "nom_corrige2":"Pascal Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"4623",
    "allocation":"2337",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6960",
    "ville":"Roxton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1156"
  },
  {
    "ID":3583,
    "nom_corrige2":"Jonathan Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"4635",
    "allocation":"2317",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6952",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":3584,
    "nom_corrige2":"Lynda Cusson",
    "nom_famille":"Cusson",
    "titre_genre2":"Conseillère",
    "remuneration":"4635",
    "allocation":"2317",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6952",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":3585,
    "nom_corrige2":"Pierre Larivière",
    "nom_famille":"Larivière",
    "titre_genre2":"Conseiller",
    "remuneration":"4635",
    "allocation":"2317",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6952",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":3586,
    "nom_corrige2":"François Lupien",
    "nom_famille":"Lupien",
    "titre_genre2":"Conseiller",
    "remuneration":"4627",
    "allocation":"2314",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6941",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":3587,
    "nom_corrige2":"Marie-Lyne Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseillère",
    "remuneration":"4627",
    "allocation":"2314",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6941",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":3588,
    "nom_corrige2":"Pierre Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"4627",
    "allocation":"2314",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6941",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":3589,
    "nom_corrige2":"Maureen Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseillère",
    "remuneration":"4627",
    "allocation":"2313",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6940",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":3590,
    "nom_corrige2":"Eric Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"4627",
    "allocation":"2313",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6940",
    "ville":"Notre-Dame-du-Bon-Conseil",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"952"
  },
  {
    "ID":3591,
    "nom_corrige2":"Pascal Brûlé",
    "nom_famille":"Brûlé",
    "titre_genre2":"Conseiller",
    "remuneration":"4624",
    "allocation":"2312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6936",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":3592,
    "nom_corrige2":"Donald Laliberté",
    "nom_famille":"Laliberté",
    "titre_genre2":"Conseiller",
    "remuneration":"4624",
    "allocation":"2312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6936",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":3593,
    "nom_corrige2":"Jean-François Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"4624",
    "allocation":"2312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6936",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":3594,
    "nom_corrige2":"Nancy McCarthy",
    "nom_famille":"McCarthy",
    "titre_genre2":"Conseillère",
    "remuneration":"4624",
    "allocation":"2312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6936",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":3595,
    "nom_corrige2":"Sandra Chandonnet",
    "nom_famille":"Chandonnet",
    "titre_genre2":"Conseillère",
    "remuneration":"4624",
    "allocation":"2312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6936",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":3596,
    "nom_corrige2":"Yves Payette",
    "nom_famille":"Payette",
    "titre_genre2":"Conseiller",
    "remuneration":"4624",
    "allocation":"2312",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6936",
    "ville":"Notre-Dame-de-Lourdes",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"836"
  },
  {
    "ID":3597,
    "nom_corrige2":"Bernard Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"4377",
    "allocation":"2188",
    "remuneration2":"247,00$",
    "allocation2":"123,00$",
    "total":"6935",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":3598,
    "nom_corrige2":"Gilles Allain",
    "nom_famille":"Allain",
    "titre_genre2":"Conseiller",
    "remuneration":"4611",
    "allocation":"2305",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6916",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":3599,
    "nom_corrige2":"Chantal Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"4610",
    "allocation":"2305",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6915",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":3600,
    "nom_corrige2":"Julie Duhaime",
    "nom_famille":"Duhaime",
    "titre_genre2":"Conseillère",
    "remuneration":"4576",
    "allocation":"2338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6914",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":3601,
    "nom_corrige2":"Denis Bezeau",
    "nom_famille":"Bezeau",
    "titre_genre2":"Conseiller",
    "remuneration":"4590",
    "allocation":"2322",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6912",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":3602,
    "nom_corrige2":"Robert Basque",
    "nom_famille":"Basque",
    "titre_genre2":"Conseiller",
    "remuneration":"4748",
    "allocation":"2162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6910",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":3603,
    "nom_corrige2":"Guylaine St-Amour",
    "nom_famille":"St-Amour",
    "titre_genre2":"Conseillère",
    "remuneration":"4748",
    "allocation":"2162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6910",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":3604,
    "nom_corrige2":"Jean-Claude Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"4748",
    "allocation":"2162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6910",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":3605,
    "nom_corrige2":"Peter Alexander",
    "nom_famille":"Alexander",
    "titre_genre2":"Conseiller",
    "remuneration":"4748",
    "allocation":"2162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6910",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":3606,
    "nom_corrige2":"Richard David",
    "nom_famille":"David",
    "titre_genre2":"Conseiller",
    "remuneration":"4748",
    "allocation":"2162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6910",
    "ville":"Notre-Dame-de-la-Salette",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"881"
  },
  {
    "ID":3607,
    "nom_corrige2":"Pierre Reid",
    "nom_famille":"Reid",
    "titre_genre2":"Conseiller",
    "remuneration":"4003",
    "allocation":"2002",
    "remuneration2":"600,00$",
    "allocation2":"300,00$",
    "total":"6905",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":3608,
    "nom_corrige2":"Daniel Arteau",
    "nom_famille":"Arteau",
    "titre_genre2":"Conseiller",
    "remuneration":"4426",
    "allocation":"2213",
    "remuneration2":"174,00$",
    "allocation2":"87,00$",
    "total":"6900",
    "ville":"Lac-Sergent",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"616"
  },
  {
    "ID":3609,
    "nom_corrige2":"Stéphane Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"4426",
    "allocation":"2213",
    "remuneration2":"166,00$",
    "allocation2":"83,00$",
    "total":"6888",
    "ville":"Lac-Sergent",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"616"
  },
  {
    "ID":3610,
    "nom_corrige2":"Édith Crevier",
    "nom_famille":"Crevier",
    "titre_genre2":"Conseillère",
    "remuneration":"4584",
    "allocation":"2292",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6876",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":3611,
    "nom_corrige2":"Denis Courte",
    "nom_famille":"Courte",
    "titre_genre2":"Conseiller",
    "remuneration":"4584",
    "allocation":"2292",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6876",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":3612,
    "nom_corrige2":"Huguette Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseillère",
    "remuneration":"4584",
    "allocation":"2292",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6876",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":3613,
    "nom_corrige2":"Richard Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"4584",
    "allocation":"2292",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6876",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":3614,
    "nom_corrige2":"Suzanne Dyotte",
    "nom_famille":"Dyotte",
    "titre_genre2":"Conseillère",
    "remuneration":"4584",
    "allocation":"2292",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6876",
    "ville":"Montcalm",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"653"
  },
  {
    "ID":3615,
    "nom_corrige2":"Pierre Brunelle",
    "nom_famille":"Brunelle",
    "titre_genre2":"Conseiller",
    "remuneration":"4784",
    "allocation":"2092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6876",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":3616,
    "nom_corrige2":"Stéphane Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseiller",
    "remuneration":"4578",
    "allocation":"2289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6867",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":3617,
    "nom_corrige2":"Louise Peck",
    "nom_famille":"Peck",
    "titre_genre2":"Conseillère",
    "remuneration":"4578",
    "allocation":"2289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6867",
    "ville":"Bowman",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"714"
  },
  {
    "ID":3618,
    "nom_corrige2":"Julie Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"4578",
    "allocation":"2289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6867",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":3619,
    "nom_corrige2":"Chantal Montminy",
    "nom_famille":"Montminy",
    "titre_genre2":"Conseillère",
    "remuneration":"4383",
    "allocation":"2191",
    "remuneration2":"194,00$",
    "allocation2":"97,00$",
    "total":"6865",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":3620,
    "nom_corrige2":"Marie-Ève Marcotte Bussière",
    "nom_famille":"Marcotte Bussière",
    "titre_genre2":"Conseillère",
    "remuneration":"4576",
    "allocation":"2288",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6864",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":3621,
    "nom_corrige2":"Mathieu Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseiller",
    "remuneration":"4576",
    "allocation":"2288",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6864",
    "ville":"Val-Alain",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1069"
  },
  {
    "ID":3622,
    "nom_corrige2":"Mario Biron",
    "nom_famille":"Biron",
    "titre_genre2":"Maire",
    "remuneration":"4573",
    "allocation":"2287",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6860",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":3623,
    "nom_corrige2":"Anne-Marie Boudreau",
    "nom_famille":"Boudreau",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"4536",
    "allocation":"2268",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6804",
    "ville":"Rivière-au-Tonnerre",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"293"
  },
  {
    "ID":3624,
    "nom_corrige2":"Michel Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseiller",
    "remuneration":"4553",
    "allocation":"2250",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6803",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":3625,
    "nom_corrige2":"Marc-André Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseiller",
    "remuneration":"4528",
    "allocation":"2264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6792",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":3626,
    "nom_corrige2":"Sylvain Loyer",
    "nom_famille":"Loyer",
    "titre_genre2":"Conseiller",
    "remuneration":"4513",
    "allocation":"2257",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6770",
    "ville":"Saint-Liguori",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"2265"
  },
  {
    "ID":3627,
    "nom_corrige2":"Gilbert Marquis",
    "nom_famille":"Marquis",
    "titre_genre2":"Maire",
    "remuneration":"4628",
    "allocation":"2128",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6756",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":3628,
    "nom_corrige2":"Jimmy Royer",
    "nom_famille":"Royer",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6755",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":3629,
    "nom_corrige2":"Daniel Smith",
    "nom_famille":"Smith",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6755",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":3630,
    "nom_corrige2":"Jocelyne Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"4503",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6754",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":3631,
    "nom_corrige2":"Denis Cardinal",
    "nom_famille":"Cardinal",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6754",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":3632,
    "nom_corrige2":"Georges Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6754",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":3633,
    "nom_corrige2":"Jean-François Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6754",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":3634,
    "nom_corrige2":"Robert Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6754",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":3635,
    "nom_corrige2":"Normand Bissonnette",
    "nom_famille":"Bissonnette",
    "titre_genre2":"Conseiller",
    "remuneration":"4503",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6754",
    "ville":"Pointe-aux-Outardes",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"1443"
  },
  {
    "ID":3636,
    "nom_corrige2":"Éric Gobeil",
    "nom_famille":"Gobeil",
    "titre_genre2":"Conseiller",
    "remuneration":"4502",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6753",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":3637,
    "nom_corrige2":"Steeve Houley",
    "nom_famille":"Houley",
    "titre_genre2":"Conseiller",
    "remuneration":"4502",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6753",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":3638,
    "nom_corrige2":"Gilbert Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"4502",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6753",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":3639,
    "nom_corrige2":"Line Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"4502",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6753",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":3640,
    "nom_corrige2":"Sonia Lehoux",
    "nom_famille":"Lehoux",
    "titre_genre2":"Conseillère",
    "remuneration":"4502",
    "allocation":"2251",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6753",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":3641,
    "nom_corrige2":"Gilles Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"4497",
    "allocation":"2249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6746",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":3642,
    "nom_corrige2":"Rosaire Guénette",
    "nom_famille":"Guénette",
    "titre_genre2":"Maire",
    "remuneration":"3413",
    "allocation":"1706",
    "remuneration2":"1623",
    "allocation2":"0",
    "total":"6742",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":3643,
    "nom_corrige2":"Robert Charron",
    "nom_famille":"Charron",
    "titre_genre2":"Conseiller",
    "remuneration":"3764",
    "allocation":"1882",
    "remuneration2":"714,00$",
    "allocation2":"357,00$",
    "total":"6717",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":3644,
    "nom_corrige2":"Patrick Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseiller",
    "remuneration":"4478",
    "allocation":"2239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6717",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":3645,
    "nom_corrige2":"Philippe Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"4478",
    "allocation":"2239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6717",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":3646,
    "nom_corrige2":"Steven Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"4478",
    "allocation":"2239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6717",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":3647,
    "nom_corrige2":"Josée Busque",
    "nom_famille":"Busque",
    "titre_genre2":"Conseillère",
    "remuneration":"4478",
    "allocation":"2239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6717",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":3648,
    "nom_corrige2":"Catherine De Blois",
    "nom_famille":"De Blois",
    "titre_genre2":"Conseillère",
    "remuneration":"4478",
    "allocation":"2239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6717",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":3649,
    "nom_corrige2":"Claude Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"4471",
    "allocation":"2235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6706",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":3650,
    "nom_corrige2":"Josée Crane",
    "nom_famille":"Crane",
    "titre_genre2":"Conseillère",
    "remuneration":"4471",
    "allocation":"2235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6706",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":3651,
    "nom_corrige2":"Laurier Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"4471",
    "allocation":"2235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6706",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":3652,
    "nom_corrige2":"Nathalie Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"4471",
    "allocation":"2235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6706",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":3653,
    "nom_corrige2":"Vital Dumais",
    "nom_famille":"Dumais",
    "titre_genre2":"Conseiller",
    "remuneration":"4471",
    "allocation":"2235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6706",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":3654,
    "nom_corrige2":"Jean-François Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Conseiller",
    "remuneration":"4464",
    "allocation":"2232",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6696",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":3655,
    "nom_corrige2":"Nathalie Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseillère",
    "remuneration":"4461",
    "allocation":"2230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6691",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":3656,
    "nom_corrige2":"André Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseiller",
    "remuneration":"4461",
    "allocation":"2230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6691",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":3657,
    "nom_corrige2":"Dany Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"4461",
    "allocation":"2230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6691",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":3658,
    "nom_corrige2":"Rémy Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Conseiller",
    "remuneration":"4461",
    "allocation":"2230",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6691",
    "ville":"Saint-Michel-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1943"
  },
  {
    "ID":3659,
    "nom_corrige2":"Stéphane Cleary",
    "nom_famille":"Cleary",
    "titre_genre2":"Conseiller",
    "remuneration":"4530",
    "allocation":"2160",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6690",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":3660,
    "nom_corrige2":"Marielle Gervais",
    "nom_famille":"Gervais",
    "titre_genre2":"Conseillère",
    "remuneration":"4457",
    "allocation":"2229",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6686",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":3661,
    "nom_corrige2":"Michel Daigneault",
    "nom_famille":"Daigneault",
    "titre_genre2":"Conseiller",
    "remuneration":"4449",
    "allocation":"2225",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6674",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":3662,
    "nom_corrige2":"Réal Vel",
    "nom_famille":"Vel",
    "titre_genre2":"Conseiller",
    "remuneration":"3984",
    "allocation":"2689",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6673",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":3663,
    "nom_corrige2":"Michel Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"4445",
    "allocation":"2223",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6668",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":3664,
    "nom_corrige2":"Luc Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseiller",
    "remuneration":"4440",
    "allocation":"2220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6660",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":3665,
    "nom_corrige2":"Alain Létourneau",
    "nom_famille":"Létourneau",
    "titre_genre2":"Conseiller",
    "remuneration":"4440",
    "allocation":"2220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6660",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":3666,
    "nom_corrige2":"Alexandre Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"4440",
    "allocation":"2220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6660",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":3667,
    "nom_corrige2":"Frédéric Lagacé",
    "nom_famille":"Lagacé",
    "titre_genre2":"Conseiller",
    "remuneration":"4440",
    "allocation":"2220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6660",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":3668,
    "nom_corrige2":"Jean Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"4440",
    "allocation":"2220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6660",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":3669,
    "nom_corrige2":"Sandrine Reix",
    "nom_famille":"Reix",
    "titre_genre2":"Conseillère",
    "remuneration":"4440",
    "allocation":"2220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6660",
    "ville":"Saint-Jean-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1044"
  },
  {
    "ID":3670,
    "nom_corrige2":"Robert Meyer",
    "nom_famille":"Meyer",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4515",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6654",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":3671,
    "nom_corrige2":"Jean-Marie Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseiller",
    "remuneration":"4435",
    "allocation":"2217",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6652",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":3672,
    "nom_corrige2":"Éric Hammal",
    "nom_famille":"Hammal",
    "titre_genre2":"Conseiller",
    "remuneration":"4431",
    "allocation":"2215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6646",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":3673,
    "nom_corrige2":"Peter Buzzell",
    "nom_famille":"Buzzell",
    "titre_genre2":"Conseiller",
    "remuneration":"4429",
    "allocation":"2215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6644",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":3674,
    "nom_corrige2":"Jonathan Mailloux",
    "nom_famille":"Mailloux",
    "titre_genre2":"Conseiller",
    "remuneration":"5665",
    "allocation":"978,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6643",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":3675,
    "nom_corrige2":"Nicolas Ste-Croix",
    "nom_famille":"Ste-Croix",
    "titre_genre2":"Conseiller",
    "remuneration":"4427",
    "allocation":"2214",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6641",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":3676,
    "nom_corrige2":"Suzette de Rome",
    "nom_famille":"de Rome",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"4432",
    "allocation":"2196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6628",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":3677,
    "nom_corrige2":"Mélodie Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseillère",
    "remuneration":"4418",
    "allocation":"2209",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6627",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":3678,
    "nom_corrige2":"Marie-Danielle Hémond",
    "nom_famille":"Hémond",
    "titre_genre2":"Conseillère",
    "remuneration":"4465",
    "allocation":"2158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6623",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":3679,
    "nom_corrige2":"Aude Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseillère",
    "remuneration":"4414",
    "allocation":"2208",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6622",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":3680,
    "nom_corrige2":"Mélanie Cyr",
    "nom_famille":"Cyr",
    "titre_genre2":"Conseillère",
    "remuneration":"4003",
    "allocation":"2002",
    "remuneration2":"400,00$",
    "allocation2":"200,00$",
    "total":"6605",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":3681,
    "nom_corrige2":"Bruno Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"4400",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6600",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":3682,
    "nom_corrige2":"Mark Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"4440",
    "allocation":"2160",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6600",
    "ville":"Saint-Maxime-du-Mont-Louis",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"1020"
  },
  {
    "ID":3683,
    "nom_corrige2":"Carl Boilard",
    "nom_famille":"Boilard",
    "titre_genre2":"Conseiller",
    "remuneration":"4398",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6598",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":3684,
    "nom_corrige2":"Dave Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"4398",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6598",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":3685,
    "nom_corrige2":"Guylaine Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"4398",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6598",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":3686,
    "nom_corrige2":"Pierre Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Conseiller",
    "remuneration":"4398",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6598",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":3687,
    "nom_corrige2":"Vincent Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"4398",
    "allocation":"2200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6598",
    "ville":"La Guadeloupe",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1940"
  },
  {
    "ID":3688,
    "nom_corrige2":"Rémi Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Maire",
    "remuneration":"4219",
    "allocation":"2109",
    "remuneration2":"176,00$",
    "allocation2":"88,00$",
    "total":"6592",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":3689,
    "nom_corrige2":"José Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseiller",
    "remuneration":"4393",
    "allocation":"2196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6589",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":3690,
    "nom_corrige2":"Audrey Morneau",
    "nom_famille":"Morneau",
    "titre_genre2":"Conseillère",
    "remuneration":"4391",
    "allocation":"2196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6587",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":3691,
    "nom_corrige2":"Christine Gentes",
    "nom_famille":"Gentes",
    "titre_genre2":"Conseillère",
    "remuneration":"3358",
    "allocation":"1601",
    "remuneration2":"1081",
    "allocation2":"540,00$",
    "total":"6580",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":3692,
    "nom_corrige2":"Bruno Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseiller",
    "remuneration":"4377",
    "allocation":"2188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6565",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":3693,
    "nom_corrige2":"Jacques Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"4377",
    "allocation":"2188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6565",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":3694,
    "nom_corrige2":"Jonathan Boily",
    "nom_famille":"Boily",
    "titre_genre2":"Conseiller",
    "remuneration":"4377",
    "allocation":"2188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6565",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":3695,
    "nom_corrige2":"Pascal Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4377",
    "allocation":"2188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6565",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":3696,
    "nom_corrige2":"Roger Heath",
    "nom_famille":"Heath",
    "titre_genre2":"Conseiller",
    "remuneration":"4375",
    "allocation":"2188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6563",
    "ville":"Dixville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"827"
  },
  {
    "ID":3697,
    "nom_corrige2":"Céine Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseillère",
    "remuneration":"4371",
    "allocation":"2185",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6556",
    "ville":"La Minerve",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"1507"
  },
  {
    "ID":3698,
    "nom_corrige2":"Sarah Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Conseillère",
    "remuneration":"4371",
    "allocation":"2185",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6556",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":3699,
    "nom_corrige2":"Mélanie Guénet",
    "nom_famille":"Guénet",
    "titre_genre2":"Conseillère",
    "remuneration":"4371",
    "allocation":"2185",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6556",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":3700,
    "nom_corrige2":"René Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"4364",
    "allocation":"2182",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6546",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":3701,
    "nom_corrige2":"Manuel Bournival",
    "nom_famille":"Bournival",
    "titre_genre2":"Conseiller",
    "remuneration":"4371",
    "allocation":"2158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6529",
    "ville":"Sainte-Clotilde-de-Horton",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1598"
  },
  {
    "ID":3702,
    "nom_corrige2":"Jacques Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"4365",
    "allocation":"2158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6523",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":3703,
    "nom_corrige2":"Richard Labonté",
    "nom_famille":"Labonté",
    "titre_genre2":"Conseiller",
    "remuneration":"4365",
    "allocation":"2158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6523",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":3704,
    "nom_corrige2":"Johanne Larocque",
    "nom_famille":"Larocque",
    "titre_genre2":"Conseillère",
    "remuneration":"4349",
    "allocation":"2174",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6523",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":3705,
    "nom_corrige2":"Alain Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseiller",
    "remuneration":"4347",
    "allocation":"2173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6520",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":3706,
    "nom_corrige2":"Daniel Béliveau",
    "nom_famille":"Béliveau",
    "titre_genre2":"Conseiller",
    "remuneration":"4347",
    "allocation":"2173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6520",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":3707,
    "nom_corrige2":"Michel Bourgault",
    "nom_famille":"Bourgault",
    "titre_genre2":"Conseiller",
    "remuneration":"4347",
    "allocation":"2173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6520",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":3708,
    "nom_corrige2":"Samuel Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"4347",
    "allocation":"2173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6520",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":3709,
    "nom_corrige2":"François Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"4347",
    "allocation":"2173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6520",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":3710,
    "nom_corrige2":"Nancy Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"4347",
    "allocation":"2173",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6520",
    "ville":"Disraeli",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1175"
  },
  {
    "ID":3711,
    "nom_corrige2":"Daniel Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"4413",
    "allocation":"2106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6519",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":3712,
    "nom_corrige2":"Emmanuel Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Conseiller",
    "remuneration":"4413",
    "allocation":"2106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6519",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":3713,
    "nom_corrige2":"Guylaine Napert",
    "nom_famille":"Napert",
    "titre_genre2":"Conseillère",
    "remuneration":"4413",
    "allocation":"2106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6519",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":3714,
    "nom_corrige2":"Suzanne Cyr",
    "nom_famille":"Cyr",
    "titre_genre2":"Conseillère",
    "remuneration":"4413",
    "allocation":"2106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6519",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":3715,
    "nom_corrige2":"Alla McCaffrey",
    "nom_famille":"McCaffrey",
    "titre_genre2":"Conseillère",
    "remuneration":"4413",
    "allocation":"2106",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6519",
    "ville":"Sainte-Agathe-de-Lotbinière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1032"
  },
  {
    "ID":3716,
    "nom_corrige2":"Valérie Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Conseillère",
    "remuneration":"4335",
    "allocation":"2167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6502",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":3717,
    "nom_corrige2":"Kaven Delarosbil",
    "nom_famille":"Delarosbil",
    "titre_genre2":"Conseiller",
    "remuneration":"3147",
    "allocation":"1574",
    "remuneration2":"1184",
    "allocation2":"592,00$",
    "total":"6497",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":3718,
    "nom_corrige2":"Claudia Labrie",
    "nom_famille":"Labrie",
    "titre_genre2":"Conseillère",
    "remuneration":"4436",
    "allocation":"2051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6487",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":3719,
    "nom_corrige2":"Guy Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Conseiller",
    "remuneration":"4436",
    "allocation":"2051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6487",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":3720,
    "nom_corrige2":"Josée Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseillère",
    "remuneration":"4322",
    "allocation":"2161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6483",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":3721,
    "nom_corrige2":"Nicolas Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"4322",
    "allocation":"2161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6483",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":3722,
    "nom_corrige2":"Marc Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"4322",
    "allocation":"2161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6483",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":3723,
    "nom_corrige2":"Eric Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseiller",
    "remuneration":"4322",
    "allocation":"2161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6483",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":3724,
    "nom_corrige2":"Vincent Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"4322",
    "allocation":"2161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6483",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":3725,
    "nom_corrige2":"Chloé Allaire",
    "nom_famille":"Allaire",
    "titre_genre2":"Conseillère",
    "remuneration":"4315",
    "allocation":"2158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6473",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":3726,
    "nom_corrige2":"Krystèle Boilard",
    "nom_famille":"Boilard",
    "titre_genre2":"Conseillère",
    "remuneration":"4315",
    "allocation":"2158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6473",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":3727,
    "nom_corrige2":"Andre Rondeau",
    "nom_famille":"Rondeau",
    "titre_genre2":"Conseiller",
    "remuneration":"4877",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6471",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":3728,
    "nom_corrige2":"Maryse Courchesne",
    "nom_famille":"Courchesne",
    "titre_genre2":"Conseillère",
    "remuneration":"4877",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6471",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":3729,
    "nom_corrige2":"Serge Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"4877",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6471",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":3730,
    "nom_corrige2":"François Drainville",
    "nom_famille":"Drainville",
    "titre_genre2":"Conseiller",
    "remuneration":"4877",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6471",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":3731,
    "nom_corrige2":"Jacinthe Drainville",
    "nom_famille":"Drainville",
    "titre_genre2":"Conseillère",
    "remuneration":"4877",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6471",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":3732,
    "nom_corrige2":"Bertrand Le Grand",
    "nom_famille":"Le Grand",
    "titre_genre2":"Conseiller",
    "remuneration":"4306",
    "allocation":"2153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6459",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":3733,
    "nom_corrige2":"Fernand Brousseau",
    "nom_famille":"Brousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"4306",
    "allocation":"2153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6459",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":3734,
    "nom_corrige2":"Gaston L'Heureux",
    "nom_famille":"L'Heureux",
    "titre_genre2":"Conseiller",
    "remuneration":"4306",
    "allocation":"2153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6459",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":3735,
    "nom_corrige2":"Marco Julien",
    "nom_famille":"Julien",
    "titre_genre2":"Conseiller",
    "remuneration":"4306",
    "allocation":"2153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6459",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":3736,
    "nom_corrige2":"René Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"4306",
    "allocation":"2153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6459",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":3737,
    "nom_corrige2":"Jean-François Messier",
    "nom_famille":"Messier",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4306",
    "allocation":"2153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6459",
    "ville":"Notre-Dame-du-Sacré-Coeur-d'Issoudun",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"894"
  },
  {
    "ID":3738,
    "nom_corrige2":"Sean Boersen",
    "nom_famille":"Boersen",
    "titre_genre2":"Conseiller",
    "remuneration":"4302",
    "allocation":"2151",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6453",
    "ville":"Melbourne",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1148"
  },
  {
    "ID":3739,
    "nom_corrige2":"Jocelyn Brasseur",
    "nom_famille":"Brasseur",
    "titre_genre2":"Conseiller",
    "remuneration":"4259",
    "allocation":"2183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6442",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":3740,
    "nom_corrige2":"Vincent Jarry",
    "nom_famille":"Jarry",
    "titre_genre2":"Conseiller",
    "remuneration":"4259",
    "allocation":"2183",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6442",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":3741,
    "nom_corrige2":"Pierre Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseiller",
    "remuneration":"3190",
    "allocation":"1595",
    "remuneration2":"795,00$",
    "allocation2":"859,00$",
    "total":"6439",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":3742,
    "nom_corrige2":"Alain Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"4290",
    "allocation":"2145",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6435",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":3743,
    "nom_corrige2":"Johanne Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"4290",
    "allocation":"2145",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6435",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":3744,
    "nom_corrige2":"Shirley McInnes",
    "nom_famille":"McInnes",
    "titre_genre2":"Conseillère",
    "remuneration":"4290",
    "allocation":"2145",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6435",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":3745,
    "nom_corrige2":"Stéphane Lehoux",
    "nom_famille":"Lehoux",
    "titre_genre2":"Conseiller",
    "remuneration":"4290",
    "allocation":"2145",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6435",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":3746,
    "nom_corrige2":"Sylvie Lehoux",
    "nom_famille":"Lehoux",
    "titre_genre2":"Conseillère",
    "remuneration":"4290",
    "allocation":"2145",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6435",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2853"
  },
  {
    "ID":3747,
    "nom_corrige2":"Jayson Byrns",
    "nom_famille":"Byrns",
    "titre_genre2":"Conseiller",
    "remuneration":"4369",
    "allocation":"2051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6420",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":3748,
    "nom_corrige2":"Frédéric Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"4369",
    "allocation":"2051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6420",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":3749,
    "nom_corrige2":"Yvan Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseiller",
    "remuneration":"4369",
    "allocation":"2051",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6420",
    "ville":"Frampton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1356"
  },
  {
    "ID":3750,
    "nom_corrige2":"Claudine Marquis",
    "nom_famille":"Marquis",
    "titre_genre2":"Conseillère",
    "remuneration":"4277",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6416",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":3751,
    "nom_corrige2":"Lyne Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Conseillère",
    "remuneration":"4277",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6416",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":3752,
    "nom_corrige2":"Yves Gagne",
    "nom_famille":"Gagne",
    "titre_genre2":"Conseiller",
    "remuneration":"4277",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6416",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":3753,
    "nom_corrige2":"Christiane Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"4277",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6416",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":3754,
    "nom_corrige2":"Thérèse Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseillère",
    "remuneration":"4277",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6416",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":3755,
    "nom_corrige2":"Veronique Bosse",
    "nom_famille":"Bosse",
    "titre_genre2":"Conseillère",
    "remuneration":"4277",
    "allocation":"2139",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6416",
    "ville":"Rivière-Bleue",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1294"
  },
  {
    "ID":3756,
    "nom_corrige2":"Rock Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"4275",
    "allocation":"2137",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6412",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":3757,
    "nom_corrige2":"Daniel Laflèche",
    "nom_famille":"Laflèche",
    "titre_genre2":"Conseiller",
    "remuneration":"4275",
    "allocation":"2137",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6412",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":3758,
    "nom_corrige2":"Lynda Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseillère",
    "remuneration":"4267",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6400",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":3759,
    "nom_corrige2":"Lyne Perras",
    "nom_famille":"Perras",
    "titre_genre2":"Conseillère",
    "remuneration":"4266",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6399",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":3760,
    "nom_corrige2":"Sylvain Malette",
    "nom_famille":"Malette",
    "titre_genre2":"Conseiller",
    "remuneration":"4266",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6399",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":3761,
    "nom_corrige2":"Jean-Denis Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"4266",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6399",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":3762,
    "nom_corrige2":"Joël Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseiller",
    "remuneration":"4266",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6399",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":3763,
    "nom_corrige2":"Francis Ranger",
    "nom_famille":"Ranger",
    "titre_genre2":"Conseiller",
    "remuneration":"4266",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6399",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":3764,
    "nom_corrige2":"Antoine Quirion-Couture",
    "nom_famille":"Quirion-Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"4266",
    "allocation":"2133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6399",
    "ville":"Saint-Urbain-Premier",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1360"
  },
  {
    "ID":3765,
    "nom_corrige2":"Jacques Mathieu",
    "nom_famille":"Mathieu",
    "titre_genre2":"Conseiller",
    "remuneration":"4264",
    "allocation":"2132",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6396",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":3766,
    "nom_corrige2":"Jean-Marc Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseiller",
    "remuneration":"4264",
    "allocation":"2132",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6396",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":3767,
    "nom_corrige2":"Denis Naud",
    "nom_famille":"Naud",
    "titre_genre2":"Conseiller",
    "remuneration":"3479",
    "allocation":"1740",
    "remuneration2":"781,00$",
    "allocation2":"391,00$",
    "total":"6391",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":3768,
    "nom_corrige2":"Gérard Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseiller",
    "remuneration":"4144",
    "allocation":"2245",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6389",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":3769,
    "nom_corrige2":"Claude Hudon",
    "nom_famille":"Hudon",
    "titre_genre2":"Conseiller",
    "remuneration":"4256",
    "allocation":"2132",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6388",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":3770,
    "nom_corrige2":"Pierre-André Arès",
    "nom_famille":"Arès",
    "titre_genre2":"Conseiller",
    "remuneration":"4858",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6387",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":3771,
    "nom_corrige2":"Sylvain Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4458",
    "allocation":"1929",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6387",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":3772,
    "nom_corrige2":"Marie-Christine Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"4002",
    "allocation":"2001",
    "remuneration2":"252,00$",
    "allocation2":"126,00$",
    "total":"6381",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":3773,
    "nom_corrige2":"François Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"345,00$",
    "allocation2":"172,00$",
    "total":"6379",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":3774,
    "nom_corrige2":"Florian Ruckstuhl",
    "nom_famille":"Ruckstuhl",
    "titre_genre2":"Conseiller",
    "remuneration":"4252",
    "allocation":"2126",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6378",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":3775,
    "nom_corrige2":"François Mailloux",
    "nom_famille":"Mailloux",
    "titre_genre2":"Conseiller",
    "remuneration":"4252",
    "allocation":"2126",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6378",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":3776,
    "nom_corrige2":"Sylvain Thibodeau",
    "nom_famille":"Thibodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"4252",
    "allocation":"2126",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6378",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":3777,
    "nom_corrige2":"Thérèse Ménard Monty",
    "nom_famille":"Ménard Monty",
    "titre_genre2":"Conseillère",
    "remuneration":"4252",
    "allocation":"2126",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6378",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":3778,
    "nom_corrige2":"Jocelyne Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"4446",
    "allocation":"1923",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6369",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":3779,
    "nom_corrige2":"Jean-Claude Drolet",
    "nom_famille":"Drolet",
    "titre_genre2":"Conseiller",
    "remuneration":"3764",
    "allocation":"1881",
    "remuneration2":"481,00$",
    "allocation2":"241,00$",
    "total":"6367",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":3780,
    "nom_corrige2":"Danick Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"4244",
    "allocation":"2122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6366",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":3781,
    "nom_corrige2":"James Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"4244",
    "allocation":"2122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6366",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":3782,
    "nom_corrige2":"Marco Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"4244",
    "allocation":"2122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6366",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":3783,
    "nom_corrige2":"Monique Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseillère",
    "remuneration":"4244",
    "allocation":"2122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6366",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":3784,
    "nom_corrige2":"Rémi Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"4244",
    "allocation":"2122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6366",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":3785,
    "nom_corrige2":"Thomas-Louis Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseiller",
    "remuneration":"4244",
    "allocation":"2122",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6366",
    "ville":"Saint-Aimé-des-Lacs",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1209"
  },
  {
    "ID":3786,
    "nom_corrige2":"Daniel Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"4238",
    "allocation":"2119",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6357",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":3787,
    "nom_corrige2":"Diane Daigneault",
    "nom_famille":"Daigneault",
    "titre_genre2":"Conseillère",
    "remuneration":"4238",
    "allocation":"2119",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6357",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":3788,
    "nom_corrige2":"Éloi Champigny",
    "nom_famille":"Champigny",
    "titre_genre2":"Conseiller",
    "remuneration":"4238",
    "allocation":"2119",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6357",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":3789,
    "nom_corrige2":"Jean-François Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"4238",
    "allocation":"2119",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6357",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":3790,
    "nom_corrige2":"Jérémie Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseiller",
    "remuneration":"4238",
    "allocation":"2119",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6357",
    "ville":"Saint-Théodore-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1636"
  },
  {
    "ID":3791,
    "nom_corrige2":"Michel Gingras",
    "nom_famille":"Gingras",
    "titre_genre2":"Conseiller",
    "remuneration":"2969",
    "allocation":"3378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6347",
    "ville":"Saint-Ubalde",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1588"
  },
  {
    "ID":3792,
    "nom_corrige2":"Jacques Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"4425",
    "allocation":"1913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6338",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":3793,
    "nom_corrige2":"Nathalie Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseillère",
    "remuneration":"4213",
    "allocation":"2107",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6320",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":3794,
    "nom_corrige2":"Marie-Chistine Lafforgue",
    "nom_famille":"Lafforgue",
    "titre_genre2":"Conseillère",
    "remuneration":"4401",
    "allocation":"1913",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6314",
    "ville":"Noyan",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1498"
  },
  {
    "ID":3795,
    "nom_corrige2":"Nancy Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"4074",
    "allocation":"2037",
    "remuneration2":"133,00$",
    "allocation2":"67,00$",
    "total":"6311",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":3796,
    "nom_corrige2":"Annie Préfontaine",
    "nom_famille":"Préfontaine",
    "titre_genre2":"Conseillère",
    "remuneration":"4213",
    "allocation":"2080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6293",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":3797,
    "nom_corrige2":"Jacqueline Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"4264",
    "allocation":"2029",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6293",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":3798,
    "nom_corrige2":"Gilbert Ferland",
    "nom_famille":"Ferland",
    "titre_genre2":"Conseiller",
    "remuneration":"4195",
    "allocation":"2097",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6292",
    "ville":"Stanstead-Est",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"667"
  },
  {
    "ID":3799,
    "nom_corrige2":"Sylvie Jutras",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseillère",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"250,00$",
    "allocation2":"0",
    "total":"6250",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":3800,
    "nom_corrige2":"Jean-Sébastien Bouffard",
    "nom_famille":"Bouffard",
    "titre_genre2":"Conseiller",
    "remuneration":"4143",
    "allocation":"2071",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6214",
    "ville":"Hatley",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"835"
  },
  {
    "ID":3801,
    "nom_corrige2":"Isabelle Sévigny",
    "nom_famille":"Sévigny",
    "titre_genre2":"Conseillère",
    "remuneration":"4138",
    "allocation":"2069",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6207",
    "ville":"Sainte-Angèle-de-Monnoir",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1873"
  },
  {
    "ID":3802,
    "nom_corrige2":"Anolise Brault",
    "nom_famille":"Brault",
    "titre_genre2":"Conseillère",
    "remuneration":"4020",
    "allocation":"2010",
    "remuneration2":"108,00$",
    "allocation2":"54,00$",
    "total":"6192",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":3803,
    "nom_corrige2":"Lindsay Woo",
    "nom_famille":"Woo",
    "titre_genre2":"Conseillère",
    "remuneration":"4121",
    "allocation":"2062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6183",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":3804,
    "nom_corrige2":"Yvan Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseiller",
    "remuneration":"4121",
    "allocation":"2062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6183",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":3805,
    "nom_corrige2":"Benoit Jr Talbot",
    "nom_famille":"Talbot",
    "titre_genre2":"Conseiller",
    "remuneration":"4121",
    "allocation":"2062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6183",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":3806,
    "nom_corrige2":"Roger Noel",
    "nom_famille":"Noel",
    "titre_genre2":"Conseiller",
    "remuneration":"4121",
    "allocation":"2062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6183",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":3807,
    "nom_corrige2":"Catherine Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseillère",
    "remuneration":"3850",
    "allocation":"2325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6175",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":3808,
    "nom_corrige2":"Patricia Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"3855",
    "allocation":"2316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6171",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":3809,
    "nom_corrige2":"Samantha Talbot",
    "nom_famille":"Talbot",
    "titre_genre2":"Conseillère",
    "remuneration":"4164",
    "allocation":"1997",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6161",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":3810,
    "nom_corrige2":"Audrey Pomerleau",
    "nom_famille":"Pomerleau",
    "titre_genre2":"Conseillère",
    "remuneration":"4100",
    "allocation":"2050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6150",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":3811,
    "nom_corrige2":"Maryse Baillargeon",
    "nom_famille":"Baillargeon",
    "titre_genre2":"Conseillère",
    "remuneration":"4100",
    "allocation":"2050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6150",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":3812,
    "nom_corrige2":"Michel Pigeon",
    "nom_famille":"Pigeon",
    "titre_genre2":"Conseiller",
    "remuneration":"4100",
    "allocation":"2050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6150",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":3813,
    "nom_corrige2":"Sylvain Carbonneau",
    "nom_famille":"Carbonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"4100",
    "allocation":"2050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6150",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":3814,
    "nom_corrige2":"Vincent Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"4100",
    "allocation":"2050",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6150",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":3815,
    "nom_corrige2":"Myriam Falcon",
    "nom_famille":"Falcon",
    "titre_genre2":"Conseillère",
    "remuneration":"4113",
    "allocation":"2030",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6143",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":3816,
    "nom_corrige2":"Louise Newbury",
    "nom_famille":"Newbury",
    "titre_genre2":"Mairesse",
    "remuneration":"4086",
    "allocation":"2043",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6129",
    "ville":"Notre-Dame-des-Sept-Douleurs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"72"
  },
  {
    "ID":3817,
    "nom_corrige2":"Gaston Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"4080",
    "allocation":"2040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6120",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":3818,
    "nom_corrige2":"Annie Lévesque-Lauzier",
    "nom_famille":"Lévesque-Lauzier",
    "titre_genre2":"Conseillère",
    "remuneration":"4080",
    "allocation":"2040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6120",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":3819,
    "nom_corrige2":"Bruno Gamache",
    "nom_famille":"Gamache",
    "titre_genre2":"Conseiller",
    "remuneration":"4080",
    "allocation":"2040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6120",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":3820,
    "nom_corrige2":"Colombe April",
    "nom_famille":"April",
    "titre_genre2":"Conseillère",
    "remuneration":"4080",
    "allocation":"2040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6120",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":3821,
    "nom_corrige2":"Jean-Pierre Bélisle",
    "nom_famille":"Bélisle",
    "titre_genre2":"Conseiller",
    "remuneration":"4080",
    "allocation":"2040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6120",
    "ville":"Saint-Jean-de-Dieu",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1679"
  },
  {
    "ID":3822,
    "nom_corrige2":"Martin Thibeault",
    "nom_famille":"Thibeault",
    "titre_genre2":"Conseiller",
    "remuneration":"4079",
    "allocation":"2040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6119",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":3823,
    "nom_corrige2":"Guillaume Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"4077",
    "allocation":"2038",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6115",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":3824,
    "nom_corrige2":"Lucie Crépeault Offroy",
    "nom_famille":"Crépeault Offroy",
    "titre_genre2":"Conseillère",
    "remuneration":"4077",
    "allocation":"2038",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6115",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":3825,
    "nom_corrige2":"Miguel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"4077",
    "allocation":"2038",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6115",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":3826,
    "nom_corrige2":"Sébastien Morand",
    "nom_famille":"Morand",
    "titre_genre2":"Conseiller",
    "remuneration":"4077",
    "allocation":"2038",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6115",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":3827,
    "nom_corrige2":"Simon Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"4077",
    "allocation":"2038",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6115",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":3828,
    "nom_corrige2":"Éric Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"4077",
    "allocation":"2038",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6115",
    "ville":"Saint-Mathieu-d'Harricana",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"837"
  },
  {
    "ID":3829,
    "nom_corrige2":"Marianne Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"4073",
    "allocation":"2036",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6109",
    "ville":"Valcourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1077"
  },
  {
    "ID":3830,
    "nom_corrige2":"Colette Brulotte",
    "nom_famille":"Brulotte",
    "titre_genre2":"Conseillère",
    "remuneration":"3971",
    "allocation":"1378",
    "remuneration2":"505,00$",
    "allocation2":"253,00$",
    "total":"6107",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":3831,
    "nom_corrige2":"Richard Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"3658",
    "allocation":"1829",
    "remuneration2":"600,00$",
    "allocation2":"0",
    "total":"6087",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":3832,
    "nom_corrige2":"Carol Poitras",
    "nom_famille":"Poitras",
    "titre_genre2":"Maire",
    "remuneration":"4050",
    "allocation":"2025",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6075",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":3833,
    "nom_corrige2":"Martin Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"4413",
    "allocation":"1644",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6057",
    "ville":"La Malbaie",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"8524"
  },
  {
    "ID":3834,
    "nom_corrige2":"Michel Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Maire suppléant",
    "remuneration":"4031",
    "allocation":"2016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6047",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":3835,
    "nom_corrige2":"Émilie Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"4031",
    "allocation":"2016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6047",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":3836,
    "nom_corrige2":"Line Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"4031",
    "allocation":"2016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6047",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":3837,
    "nom_corrige2":"Patrice Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4031",
    "allocation":"2016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6047",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":3838,
    "nom_corrige2":"Sylvain Duquet",
    "nom_famille":"Duquet",
    "titre_genre2":"Conseiller",
    "remuneration":"4031",
    "allocation":"2016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6047",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":3839,
    "nom_corrige2":"Yoland Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4031",
    "allocation":"2016",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6047",
    "ville":"Saint-Irénée",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"712"
  },
  {
    "ID":3840,
    "nom_corrige2":"Francis Quirion",
    "nom_famille":"Quirion",
    "titre_genre2":"Conseiller",
    "remuneration":"4116",
    "allocation":"",
    "remuneration2":"1930",
    "allocation2":"0",
    "total":"6046",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":3841,
    "nom_corrige2":"Cédric Quirion",
    "nom_famille":"Quirion",
    "titre_genre2":"Conseiller",
    "remuneration":"4116",
    "allocation":"",
    "remuneration2":"1930",
    "allocation2":"0",
    "total":"6046",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":3842,
    "nom_corrige2":"Jacynthe Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseillère",
    "remuneration":"4020",
    "allocation":"2010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6030",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":3843,
    "nom_corrige2":"Pierre Letendre",
    "nom_famille":"Letendre",
    "titre_genre2":"Conseiller",
    "remuneration":"4020",
    "allocation":"2010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6030",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":3844,
    "nom_corrige2":"Richard Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseiller",
    "remuneration":"4020",
    "allocation":"2010",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6030",
    "ville":"Saint-Jude",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1419"
  },
  {
    "ID":3845,
    "nom_corrige2":"Catherine Desprès",
    "nom_famille":"Desprès",
    "titre_genre2":"Conseillère",
    "remuneration":"4017",
    "allocation":"2009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6026",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":3846,
    "nom_corrige2":"Jean-Jacques Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"4017",
    "allocation":"2009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6026",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":3847,
    "nom_corrige2":"Suzanne Marquis",
    "nom_famille":"Marquis",
    "titre_genre2":"Conseillère",
    "remuneration":"4017",
    "allocation":"2009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6026",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":3848,
    "nom_corrige2":"Alexandre Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"4017",
    "allocation":"2009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6026",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":3849,
    "nom_corrige2":"Denis Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"4017",
    "allocation":"2009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6026",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":3850,
    "nom_corrige2":"Véronique Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseillère",
    "remuneration":"4017",
    "allocation":"2009",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6026",
    "ville":"L'Isle-Verte",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1417"
  },
  {
    "ID":3851,
    "nom_corrige2":"Éric Morency",
    "nom_famille":"Morency",
    "titre_genre2":"Conseiller",
    "remuneration":"4015",
    "allocation":"2007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6022",
    "ville":"Saint-Odilon-de-Cranbourne",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1459"
  },
  {
    "ID":3852,
    "nom_corrige2":"Gilles Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseiller",
    "remuneration":"4014",
    "allocation":"2007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6021",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":3853,
    "nom_corrige2":"Marco Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseiller",
    "remuneration":"4014",
    "allocation":"2007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6021",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":3854,
    "nom_corrige2":"Patrick Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Conseiller",
    "remuneration":"4014",
    "allocation":"2007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6021",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":3855,
    "nom_corrige2":"Pier-Yves Chapdelaine",
    "nom_famille":"Chapdelaine",
    "titre_genre2":"Conseiller",
    "remuneration":"4014",
    "allocation":"2007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6021",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":3856,
    "nom_corrige2":"Joël Brouillard",
    "nom_famille":"Brouillard",
    "titre_genre2":"Conseiller",
    "remuneration":"4014",
    "allocation":"2007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6021",
    "ville":"Saint-David",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"903"
  },
  {
    "ID":3857,
    "nom_corrige2":"Claudia Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseillère",
    "remuneration":"4003",
    "allocation":"2002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6005",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":3858,
    "nom_corrige2":"Mario Dolbec",
    "nom_famille":"Dolbec",
    "titre_genre2":"Conseiller",
    "remuneration":"4003",
    "allocation":"2002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6005",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":3859,
    "nom_corrige2":"François Cliche",
    "nom_famille":"Cliche",
    "titre_genre2":"Conseiller",
    "remuneration":"4002",
    "allocation":"2001",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6003",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":3860,
    "nom_corrige2":"Dave Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"4002",
    "allocation":"2001",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6003",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":3861,
    "nom_corrige2":"Denis Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"4002",
    "allocation":"2001",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6003",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":3862,
    "nom_corrige2":"Marie-Ève Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"4002",
    "allocation":"2001",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6003",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":3863,
    "nom_corrige2":"Yannick Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseiller",
    "remuneration":"4002",
    "allocation":"2001",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6003",
    "ville":"Vallée-Jonction",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2071"
  },
  {
    "ID":3864,
    "nom_corrige2":"Dany Drolet",
    "nom_famille":"Drolet",
    "titre_genre2":"Conseillère",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":3865,
    "nom_corrige2":"Rachel Fahlman",
    "nom_famille":"Fahlman",
    "titre_genre2":"Conseillère",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":3866,
    "nom_corrige2":"Marie-Josée Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseillère",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":3867,
    "nom_corrige2":"Martin Tassé",
    "nom_famille":"Tassé",
    "titre_genre2":"Conseiller",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":3868,
    "nom_corrige2":"Pierre Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":3869,
    "nom_corrige2":"Pierre Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Conseiller",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":3870,
    "nom_corrige2":"Peter L. Vénezia",
    "nom_famille":"L. Vénezia",
    "titre_genre2":"Conseiller",
    "remuneration":"4000",
    "allocation":"2000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"6000",
    "ville":"Brébeuf",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"999"
  },
  {
    "ID":3871,
    "nom_corrige2":"Andre Choiniere",
    "nom_famille":"Choiniere",
    "titre_genre2":"Conseiller",
    "remuneration":"4013",
    "allocation":"1980",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5993",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":3872,
    "nom_corrige2":"Gisèle Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseillère",
    "remuneration":"3991",
    "allocation":"1996",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5987",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":3873,
    "nom_corrige2":"Réjean Racine",
    "nom_famille":"Racine",
    "titre_genre2":"Conseiller",
    "remuneration":"3991",
    "allocation":"1996",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5987",
    "ville":"Brigham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"2361"
  },
  {
    "ID":3874,
    "nom_corrige2":"Claude Beauchesne",
    "nom_famille":"Beauchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"4005",
    "allocation":"1978",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5983",
    "ville":"Saint-Norbert-d'Arthabaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1298"
  },
  {
    "ID":3875,
    "nom_corrige2":"Annik Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Conseillère",
    "remuneration":"3850",
    "allocation":"2125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5975",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":3876,
    "nom_corrige2":"France Thibodeau",
    "nom_famille":"Thibodeau",
    "titre_genre2":"Conseillère",
    "remuneration":"3850",
    "allocation":"2125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5975",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":3877,
    "nom_corrige2":"Marjolaine Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"3850",
    "allocation":"2125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5975",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":3878,
    "nom_corrige2":"Simon Bourgault",
    "nom_famille":"Bourgault",
    "titre_genre2":"Conseiller",
    "remuneration":"3850",
    "allocation":"2125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5975",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":3879,
    "nom_corrige2":"Vanessa Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Conseillère",
    "remuneration":"3850",
    "allocation":"2125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5975",
    "ville":"Saint-Adalbert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"480"
  },
  {
    "ID":3880,
    "nom_corrige2":"Michelle Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"3982",
    "allocation":"1991",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5973",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":3881,
    "nom_corrige2":"James Allan",
    "nom_famille":"Allan",
    "titre_genre2":"Conseiller",
    "remuneration":"3982",
    "allocation":"1991",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5973",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":3882,
    "nom_corrige2":"Solange Fillion",
    "nom_famille":"Fillion",
    "titre_genre2":"Conseillère",
    "remuneration":"3979",
    "allocation":"",
    "remuneration2":"1977",
    "allocation2":"0",
    "total":"5956",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":3883,
    "nom_corrige2":"François Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseiller",
    "remuneration":"3968",
    "allocation":"1984",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5952",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":3884,
    "nom_corrige2":"François Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"3833",
    "allocation":"1917",
    "remuneration2":"200,00$",
    "allocation2":"0",
    "total":"5950",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":3885,
    "nom_corrige2":"Julie Maurice",
    "nom_famille":"Maurice",
    "titre_genre2":"Conseillère",
    "remuneration":"4164",
    "allocation":"1782",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5946",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":3886,
    "nom_corrige2":"Sylvie Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Conseillère",
    "remuneration":"4284",
    "allocation":"1655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5939",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":3887,
    "nom_corrige2":"Guylaine Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"3948",
    "allocation":"1974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5922",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":3888,
    "nom_corrige2":"Mario Mongeon",
    "nom_famille":"Mongeon",
    "titre_genre2":"Conseiller",
    "remuneration":"3948",
    "allocation":"1974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5922",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":3889,
    "nom_corrige2":"Pierre mudie",
    "nom_famille":"mudie",
    "titre_genre2":"Conseiller",
    "remuneration":"3948",
    "allocation":"1974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5922",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":3890,
    "nom_corrige2":"Suzanne Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"3948",
    "allocation":"1974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5922",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":3891,
    "nom_corrige2":"Sylvie Rossignol",
    "nom_famille":"Rossignol",
    "titre_genre2":"Conseillère",
    "remuneration":"3948",
    "allocation":"1974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5922",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":3892,
    "nom_corrige2":"Linda Cousineau",
    "nom_famille":"Cousineau",
    "titre_genre2":"Conseillère",
    "remuneration":"3948",
    "allocation":"1974",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5922",
    "ville":"Lochaber-Partie-Ouest",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1035"
  },
  {
    "ID":3893,
    "nom_corrige2":"Claudette Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseillère",
    "remuneration":"4169",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5904",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":3894,
    "nom_corrige2":"Jacky Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"4169",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5904",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":3895,
    "nom_corrige2":"Line Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseillère",
    "remuneration":"4169",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5904",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":3896,
    "nom_corrige2":"Patricia Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"4169",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5904",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":3897,
    "nom_corrige2":"Robert Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"3660",
    "allocation":"1836",
    "remuneration2":"270,00$",
    "allocation2":"135,00$",
    "total":"5901",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":3898,
    "nom_corrige2":"Carl Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"3930",
    "allocation":"1965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5895",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":3899,
    "nom_corrige2":"Claude Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"3930",
    "allocation":"1965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5895",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":3900,
    "nom_corrige2":"Gérald Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseiller",
    "remuneration":"3930",
    "allocation":"1965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5895",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":3901,
    "nom_corrige2":"Guylaine D'Amours",
    "nom_famille":"D'Amours",
    "titre_genre2":"Conseillère",
    "remuneration":"3930",
    "allocation":"1965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5895",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":3902,
    "nom_corrige2":"Manon Belzile",
    "nom_famille":"Belzile",
    "titre_genre2":"Conseillère",
    "remuneration":"3930",
    "allocation":"1965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5895",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":3903,
    "nom_corrige2":"Rémi Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"3930",
    "allocation":"1965",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5895",
    "ville":"Saint-Hubert-de-Rivière-du-Loup",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1440"
  },
  {
    "ID":3904,
    "nom_corrige2":"Christian Jutras",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":3905,
    "nom_corrige2":"Frédéric Marier",
    "nom_famille":"Marier",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":3906,
    "nom_corrige2":"Nancy Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseillère",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":3907,
    "nom_corrige2":"Sarah Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseillère",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Sainte-Brigitte-des-Saults",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"857"
  },
  {
    "ID":3908,
    "nom_corrige2":"Roger Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":3909,
    "nom_corrige2":"Marisol Brochu",
    "nom_famille":"Brochu",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":3910,
    "nom_corrige2":"Joanne Labranche",
    "nom_famille":"Labranche",
    "titre_genre2":"Conseillère",
    "remuneration":"3908",
    "allocation":"1954",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5862",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":3911,
    "nom_corrige2":"Patrick Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"4110",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5845",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":3912,
    "nom_corrige2":"André Kirouac",
    "nom_famille":"Kirouac",
    "titre_genre2":"Conseiller",
    "remuneration":"4110",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5845",
    "ville":"Girardville",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1068"
  },
  {
    "ID":3913,
    "nom_corrige2":"Carmen Marquis",
    "nom_famille":"Marquis",
    "titre_genre2":"Conseillère",
    "remuneration":"3893",
    "allocation":"1947",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5840",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":3914,
    "nom_corrige2":"Christian Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"3893",
    "allocation":"1947",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5840",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":3915,
    "nom_corrige2":"Denis Piché",
    "nom_famille":"Piché",
    "titre_genre2":"Conseiller",
    "remuneration":"3893",
    "allocation":"1947",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5840",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":3916,
    "nom_corrige2":"Émilie Garneau",
    "nom_famille":"Garneau",
    "titre_genre2":"Conseillère",
    "remuneration":"3893",
    "allocation":"1947",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5840",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":3917,
    "nom_corrige2":"Julie Quintin",
    "nom_famille":"Quintin",
    "titre_genre2":"Conseillère",
    "remuneration":"3893",
    "allocation":"1947",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5840",
    "ville":"Saint-Alban",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1255"
  },
  {
    "ID":3918,
    "nom_corrige2":"Jacques Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"3690",
    "allocation":"1845",
    "remuneration2":"202,00$",
    "allocation2":"101,00$",
    "total":"5838",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":3919,
    "nom_corrige2":"Jean-Denis Morel",
    "nom_famille":"Morel",
    "titre_genre2":"Conseiller",
    "remuneration":"3329",
    "allocation":"1558",
    "remuneration2":"617,00$",
    "allocation2":"309,00$",
    "total":"5813",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":3920,
    "nom_corrige2":"Aline Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"3871",
    "allocation":"1936",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5807",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":3921,
    "nom_corrige2":"Antoine Letendre",
    "nom_famille":"Letendre",
    "titre_genre2":"Conseiller",
    "remuneration":"3871",
    "allocation":"1936",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5807",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":3922,
    "nom_corrige2":"Josée Letendre",
    "nom_famille":"Letendre",
    "titre_genre2":"Conseillère",
    "remuneration":"3871",
    "allocation":"1936",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5807",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":3923,
    "nom_corrige2":"Julie Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseillère",
    "remuneration":"3871",
    "allocation":"1936",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5807",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":3924,
    "nom_corrige2":"Marc Ladouceur",
    "nom_famille":"Ladouceur",
    "titre_genre2":"Conseiller",
    "remuneration":"3871",
    "allocation":"1936",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5807",
    "ville":"Saint-Georges-de-Windsor",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1006"
  },
  {
    "ID":3925,
    "nom_corrige2":"Denys Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"3871",
    "allocation":"1935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5806",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":3926,
    "nom_corrige2":"Marc Bégin",
    "nom_famille":"Bégin",
    "titre_genre2":"Conseiller",
    "remuneration":"3871",
    "allocation":"1935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5806",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":3927,
    "nom_corrige2":"Marie-Michèle Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseillère",
    "remuneration":"3871",
    "allocation":"1935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5806",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":3928,
    "nom_corrige2":"Pierre Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseiller",
    "remuneration":"3871",
    "allocation":"1935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5806",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":3929,
    "nom_corrige2":"Yves Bond",
    "nom_famille":"Bond",
    "titre_genre2":"Conseiller",
    "remuneration":"3871",
    "allocation":"1935",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5806",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":3930,
    "nom_corrige2":"Carole Duplessis",
    "nom_famille":"Duplessis",
    "titre_genre2":"Conseillère",
    "remuneration":"3867",
    "allocation":"",
    "remuneration2":"1934",
    "allocation2":"0",
    "total":"5801",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":3931,
    "nom_corrige2":"Éric Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Conseiller",
    "remuneration":"3864",
    "allocation":"1932",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5796",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":3932,
    "nom_corrige2":"Gaétan Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3864",
    "allocation":"1932",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5796",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":3933,
    "nom_corrige2":"Michel Turcot",
    "nom_famille":"Turcot",
    "titre_genre2":"Conseiller",
    "remuneration":"3864",
    "allocation":"1932",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5796",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":3934,
    "nom_corrige2":"Samuel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3864",
    "allocation":"1932",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5796",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":3935,
    "nom_corrige2":"Tonia Despont",
    "nom_famille":"Despont",
    "titre_genre2":"Conseillère",
    "remuneration":"3864",
    "allocation":"1932",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5796",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":3936,
    "nom_corrige2":"Gilles Lamarre",
    "nom_famille":"Lamarre",
    "titre_genre2":"Conseiller",
    "remuneration":"3861",
    "allocation":"1931",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5792",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":3937,
    "nom_corrige2":"Hélène Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"3861",
    "allocation":"1931",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5792",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":3938,
    "nom_corrige2":"Jean-Paul Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"3861",
    "allocation":"1931",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5792",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":3939,
    "nom_corrige2":"Lise-Marie Duguay",
    "nom_famille":"Duguay",
    "titre_genre2":"Conseillère",
    "remuneration":"3861",
    "allocation":"1931",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5792",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":3940,
    "nom_corrige2":"Tomy Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Maire suppléant",
    "remuneration":"3860",
    "allocation":"1930",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5790",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":3941,
    "nom_corrige2":"Joanie Laforce",
    "nom_famille":"Laforce",
    "titre_genre2":"Conseillère",
    "remuneration":"3855",
    "allocation":"1928",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5783",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":3942,
    "nom_corrige2":"Alain Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"3937",
    "allocation":"",
    "remuneration2":"1846",
    "allocation2":"0",
    "total":"5783",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":3943,
    "nom_corrige2":"Shawn Marier",
    "nom_famille":"Marier",
    "titre_genre2":"Conseiller",
    "remuneration":"3937",
    "allocation":"",
    "remuneration2":"1846",
    "allocation2":"0",
    "total":"5783",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":3944,
    "nom_corrige2":"Roger Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3851",
    "allocation":"",
    "remuneration2":"1925",
    "allocation2":"0",
    "total":"5776",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":3945,
    "nom_corrige2":"Geneviève Maheux",
    "nom_famille":"Maheux",
    "titre_genre2":"Conseillère",
    "remuneration":"3851",
    "allocation":"",
    "remuneration2":"1925",
    "allocation2":"0",
    "total":"5776",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":3946,
    "nom_corrige2":"Frédéric Destrijker",
    "nom_famille":"Destrijker",
    "titre_genre2":"Conseiller",
    "remuneration":"3851",
    "allocation":"",
    "remuneration2":"1925",
    "allocation2":"0",
    "total":"5776",
    "ville":"Saint-Ludger",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1111"
  },
  {
    "ID":3947,
    "nom_corrige2":"Serge Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseiller",
    "remuneration":"3761",
    "allocation":"2014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5775",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":3948,
    "nom_corrige2":"Christine Thibeault",
    "nom_famille":"Thibeault",
    "titre_genre2":"Conseillère",
    "remuneration":"3840",
    "allocation":"1920",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5760",
    "ville":"Normandin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"3063"
  },
  {
    "ID":3949,
    "nom_corrige2":"Pierre De Beaumont",
    "nom_famille":"De Beaumont",
    "titre_genre2":"Conseillère",
    "remuneration":"3839",
    "allocation":"1919",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5758",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":3950,
    "nom_corrige2":"Robert Sansfaçon",
    "nom_famille":"Sansfaçon",
    "titre_genre2":"Conseiller",
    "remuneration":"3833",
    "allocation":"1917",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5750",
    "ville":"Kinnear's Mills",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"417"
  },
  {
    "ID":3951,
    "nom_corrige2":"Sébastien St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"3694",
    "allocation":"1847",
    "remuneration2":"135,00$",
    "allocation2":"68,00$",
    "total":"5744",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3952,
    "nom_corrige2":"Chantal Desharnais",
    "nom_famille":"Desharnais",
    "titre_genre2":"Conseillère",
    "remuneration":"3694",
    "allocation":"1847",
    "remuneration2":"135,00$",
    "allocation2":"68,00$",
    "total":"5744",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":3953,
    "nom_corrige2":"Mario Hinse",
    "nom_famille":"Hinse",
    "titre_genre2":"Conseiller",
    "remuneration":"4468",
    "allocation":"1274",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5742",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":3954,
    "nom_corrige2":"Richard Thérien",
    "nom_famille":"Thérien",
    "titre_genre2":"Conseiller",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":3955,
    "nom_corrige2":"Bruno Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":3956,
    "nom_corrige2":"Jean-Baptiste Alagnoux",
    "nom_famille":"Alagnoux",
    "titre_genre2":"Conseiller",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":3957,
    "nom_corrige2":"Marc-Antoine Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":3958,
    "nom_corrige2":"Sylvie Deblois",
    "nom_famille":"Deblois",
    "titre_genre2":"Conseillère",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":3959,
    "nom_corrige2":"Yves Lévesques",
    "nom_famille":"Lévesques",
    "titre_genre2":"Conseiller",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Sainte-Famille-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"833"
  },
  {
    "ID":3960,
    "nom_corrige2":"Ginette Sheehy",
    "nom_famille":"Sheehy",
    "titre_genre2":"Conseillère",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":3961,
    "nom_corrige2":"Gilles St-Amand",
    "nom_famille":"St-Amand",
    "titre_genre2":"Conseiller",
    "remuneration":"3821",
    "allocation":"1910",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5731",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":3962,
    "nom_corrige2":"Samuel Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"3800",
    "allocation":"1900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5700",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":3963,
    "nom_corrige2":"Byanca Bouffard",
    "nom_famille":"Bouffard",
    "titre_genre2":"Conseillère",
    "remuneration":"3800",
    "allocation":"1900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5700",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":3964,
    "nom_corrige2":"Germain Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"3800",
    "allocation":"1900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5700",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":3965,
    "nom_corrige2":"Marthe Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"3800",
    "allocation":"1900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5700",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":3966,
    "nom_corrige2":"André Béliveau",
    "nom_famille":"Béliveau",
    "titre_genre2":"Conseiller",
    "remuneration":"3800",
    "allocation":"1900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5700",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":3967,
    "nom_corrige2":"Stéphane Cuerrier-Leblanc",
    "nom_famille":"Cuerrier-Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"3800",
    "allocation":"1900",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5700",
    "ville":"Audet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"710"
  },
  {
    "ID":3968,
    "nom_corrige2":"Mathieu Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"3792",
    "allocation":"1896",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5688",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":3969,
    "nom_corrige2":"David Gasser",
    "nom_famille":"Gasser",
    "titre_genre2":"Conseiller",
    "remuneration":"3790",
    "allocation":"1895",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5685",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":3970,
    "nom_corrige2":"Hélène Campbell",
    "nom_famille":"Campbell",
    "titre_genre2":"Conseillère",
    "remuneration":"3790",
    "allocation":"1895",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5685",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":3971,
    "nom_corrige2":"Justin Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseiller",
    "remuneration":"3790",
    "allocation":"1895",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5685",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":3972,
    "nom_corrige2":"Patricia Rachofsky",
    "nom_famille":"Rachofsky",
    "titre_genre2":"Conseillère",
    "remuneration":"3790",
    "allocation":"1895",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5685",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":3973,
    "nom_corrige2":"Jean Asnong",
    "nom_famille":"Asnong",
    "titre_genre2":"Conseiller",
    "remuneration":"3790",
    "allocation":"1895",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5685",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":3974,
    "nom_corrige2":"Marc Payeur",
    "nom_famille":"Payeur",
    "titre_genre2":"Conseiller",
    "remuneration":"3565",
    "allocation":"1783",
    "remuneration2":"203,00$",
    "allocation2":"101,00$",
    "total":"5652",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":3975,
    "nom_corrige2":"Jean Sioui",
    "nom_famille":"Sioui",
    "titre_genre2":"Conseiller",
    "remuneration":"3764",
    "allocation":"1882",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5646",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":3976,
    "nom_corrige2":"Patrice Forcier",
    "nom_famille":"Forcier",
    "titre_genre2":"Conseiller",
    "remuneration":"3764",
    "allocation":"1882",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5646",
    "ville":"Saint-Louis",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"764"
  },
  {
    "ID":3977,
    "nom_corrige2":"Martin Bussières",
    "nom_famille":"Bussières",
    "titre_genre2":"Conseiller",
    "remuneration":"3814",
    "allocation":"1830",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5644",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":3978,
    "nom_corrige2":"Gilles Héon",
    "nom_famille":"Héon",
    "titre_genre2":"Conseiller",
    "remuneration":"3751",
    "allocation":"1875",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5626",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":3979,
    "nom_corrige2":"Fanny Dupras Rossier",
    "nom_famille":"Dupras Rossier",
    "titre_genre2":"Mairesse",
    "remuneration":"3691",
    "allocation":"1926",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5617",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":3980,
    "nom_corrige2":"Pascal Gonnin",
    "nom_famille":"Gonnin",
    "titre_genre2":"Conseiller",
    "remuneration":"3045",
    "allocation":"2557",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5602",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":3981,
    "nom_corrige2":"Nicole Charette",
    "nom_famille":"Charette",
    "titre_genre2":"Conseillère",
    "remuneration":"4010",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5589",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":3982,
    "nom_corrige2":"Réal Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseiller",
    "remuneration":"3726",
    "allocation":"1863",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5589",
    "ville":"Lac-Bouchette",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1205"
  },
  {
    "ID":3983,
    "nom_corrige2":"Stéphane Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Conseiller",
    "remuneration":"4158",
    "allocation":"",
    "remuneration2":"1426",
    "allocation2":"0",
    "total":"5584",
    "ville":"Saint-Honoré-de-Shenley",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1645"
  },
  {
    "ID":3984,
    "nom_corrige2":"Marilyn Dagenais",
    "nom_famille":"Dagenais",
    "titre_genre2":"Conseillère",
    "remuneration":"3721",
    "allocation":"1860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5581",
    "ville":"Lantier",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"990"
  },
  {
    "ID":3985,
    "nom_corrige2":"Paul Lansbergen",
    "nom_famille":"Lansbergen",
    "titre_genre2":"Conseiller",
    "remuneration":"3908",
    "allocation":"1655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5563",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":3986,
    "nom_corrige2":"Michelle Payette",
    "nom_famille":"Payette",
    "titre_genre2":"Conseillère",
    "remuneration":"3701",
    "allocation":"1851",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5552",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":3987,
    "nom_corrige2":"François Beaumont",
    "nom_famille":"Beaumont",
    "titre_genre2":"Conseiller",
    "remuneration":"3701",
    "allocation":"1851",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5552",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":3988,
    "nom_corrige2":"Kim Bernatchez",
    "nom_famille":"Bernatchez",
    "titre_genre2":"Conseillère",
    "remuneration":"3701",
    "allocation":"1851",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5552",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":3989,
    "nom_corrige2":"Nyx Pilon",
    "nom_famille":"Pilon",
    "titre_genre2":"Conseiller",
    "remuneration":"3701",
    "allocation":"1851",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5552",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":3990,
    "nom_corrige2":"Suzanne Guilbault",
    "nom_famille":"Guilbault",
    "titre_genre2":"Conseillère",
    "remuneration":"3701",
    "allocation":"1851",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5552",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":3991,
    "nom_corrige2":"Philippe St-Jacques",
    "nom_famille":"St-Jacques",
    "titre_genre2":"Maire suppléant",
    "remuneration":"3701",
    "allocation":"1851",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5552",
    "ville":"Bois-Franc",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"418"
  },
  {
    "ID":3992,
    "nom_corrige2":"Benoit Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"3698",
    "allocation":"1849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":3993,
    "nom_corrige2":"Dominic Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"3698",
    "allocation":"1849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":3994,
    "nom_corrige2":"Gaétan Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"3698",
    "allocation":"1849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":3995,
    "nom_corrige2":"Gilles Gauvreau",
    "nom_famille":"Gauvreau",
    "titre_genre2":"Conseiller",
    "remuneration":"3698",
    "allocation":"1849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":3996,
    "nom_corrige2":"Rémi Beauchesne",
    "nom_famille":"Beauchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"3698",
    "allocation":"1849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":3997,
    "nom_corrige2":"Steve Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"3698",
    "allocation":"1849",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Ham-Nord",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"954"
  },
  {
    "ID":3998,
    "nom_corrige2":"Isabelle Bibeau",
    "nom_famille":"Bibeau",
    "titre_genre2":"Conseillère",
    "remuneration":"3685",
    "allocation":"1862",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5547",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":3999,
    "nom_corrige2":"Catherine Drolet Marchand",
    "nom_famille":"Drolet Marchand",
    "titre_genre2":"Conseillère",
    "remuneration":"3695",
    "allocation":"1848",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5543",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":4000,
    "nom_corrige2":"Steve Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"3694",
    "allocation":"1847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5541",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":4001,
    "nom_corrige2":"Martin Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Conseiller",
    "remuneration":"3694",
    "allocation":"1847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5541",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":4002,
    "nom_corrige2":"Jasmin Desharnais",
    "nom_famille":"Desharnais",
    "titre_genre2":"Conseiller",
    "remuneration":"3694",
    "allocation":"1847",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5541",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":4003,
    "nom_corrige2":"Charles Collin",
    "nom_famille":"Collin",
    "titre_genre2":"Conseiller",
    "remuneration":"3687",
    "allocation":"1844",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5531",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":4004,
    "nom_corrige2":"Dany Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"3683",
    "allocation":"1842",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5525",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":4005,
    "nom_corrige2":"Gilles Harvey",
    "nom_famille":"Harvey",
    "titre_genre2":"Conseiller",
    "remuneration":"3683",
    "allocation":"1842",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5525",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":4006,
    "nom_corrige2":"Joannie Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"3683",
    "allocation":"1842",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5525",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":4007,
    "nom_corrige2":"Martine Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"3683",
    "allocation":"1842",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5525",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":4008,
    "nom_corrige2":"Michel Kowalew",
    "nom_famille":"Kowalew",
    "titre_genre2":"Conseiller",
    "remuneration":"3683",
    "allocation":"1842",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5525",
    "ville":"Saint-Siméon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1138"
  },
  {
    "ID":4009,
    "nom_corrige2":"Fannie Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"3680",
    "allocation":"1840",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5520",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":4010,
    "nom_corrige2":"Caroline Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"3618",
    "allocation":"1902",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5520",
    "ville":"Lyster",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1699"
  },
  {
    "ID":4011,
    "nom_corrige2":"Jessica Pitt",
    "nom_famille":"Pitt",
    "titre_genre2":"Conseillère",
    "remuneration":"3675",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5512",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":4012,
    "nom_corrige2":"Danielle Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseillère",
    "remuneration":"3675",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5512",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":4013,
    "nom_corrige2":"Maxime Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"3675",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5512",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":4014,
    "nom_corrige2":"Martin Pilote",
    "nom_famille":"Pilote",
    "titre_genre2":"Conseiller",
    "remuneration":"3675",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5512",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":4015,
    "nom_corrige2":"Jonathan Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4016,
    "nom_corrige2":"Annick Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseillère",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":4017,
    "nom_corrige2":"Colette Plusquellec",
    "nom_famille":"Plusquellec",
    "titre_genre2":"Conseillère",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":4018,
    "nom_corrige2":"Delisca Doucet",
    "nom_famille":"Doucet",
    "titre_genre2":"Conseillère",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":4019,
    "nom_corrige2":"Linda Delarosbil",
    "nom_famille":"Delarosbil",
    "titre_genre2":"Conseillère",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":4020,
    "nom_corrige2":"Magella Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseiller",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":4021,
    "nom_corrige2":"Patricia Delarosbil",
    "nom_famille":"Delarosbil",
    "titre_genre2":"Conseillère",
    "remuneration":"3673",
    "allocation":"1837",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5510",
    "ville":"Hope",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"609"
  },
  {
    "ID":4022,
    "nom_corrige2":"Valérie Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseillère",
    "remuneration":"3660",
    "allocation":"1836",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5496",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":4023,
    "nom_corrige2":"Joanne Costo",
    "nom_famille":"Costo",
    "titre_genre2":"Conseillère",
    "remuneration":"3660",
    "allocation":"1836",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5496",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":4024,
    "nom_corrige2":"Amélie Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseillère",
    "remuneration":"3660",
    "allocation":"1836",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5496",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":4025,
    "nom_corrige2":"Annie Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"3660",
    "allocation":"1836",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5496",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":4026,
    "nom_corrige2":"Quentin Kelhelter",
    "nom_famille":"Kelhelter",
    "titre_genre2":"Conseiller",
    "remuneration":"3660",
    "allocation":"1836",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5496",
    "ville":"Deschaillons-sur-Saint-Laurent",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"918"
  },
  {
    "ID":4027,
    "nom_corrige2":"François Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"3661",
    "allocation":"1831",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5492",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":4028,
    "nom_corrige2":"Benoit Gratton",
    "nom_famille":"Gratton",
    "titre_genre2":"Conseiller",
    "remuneration":"3661",
    "allocation":"1831",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5492",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":4029,
    "nom_corrige2":"Audrey Charron Brosseau",
    "nom_famille":"Charron Brosseau",
    "titre_genre2":"Conseillère",
    "remuneration":"3661",
    "allocation":"1831",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5492",
    "ville":"Huberdeau",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"865"
  },
  {
    "ID":4030,
    "nom_corrige2":"Véronique Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseillère",
    "remuneration":"3714",
    "allocation":"1774",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5488",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":4031,
    "nom_corrige2":"Véronique Parenteau",
    "nom_famille":"Parenteau",
    "titre_genre2":"Conseillère",
    "remuneration":"3658",
    "allocation":"1829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5487",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":4032,
    "nom_corrige2":"Geneviève Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseillère",
    "remuneration":"3658",
    "allocation":"1829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5487",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":4033,
    "nom_corrige2":"Jasmin Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3658",
    "allocation":"1829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5487",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":4034,
    "nom_corrige2":"Donald Grimard",
    "nom_famille":"Grimard",
    "titre_genre2":"Conseiller",
    "remuneration":"3658",
    "allocation":"1829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5487",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":4035,
    "nom_corrige2":"Ghislain Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseiller",
    "remuneration":"3658",
    "allocation":"1829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5487",
    "ville":"Wotton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1480"
  },
  {
    "ID":4036,
    "nom_corrige2":"Serge Béchard",
    "nom_famille":"Béchard",
    "titre_genre2":"Conseiller",
    "remuneration":"3826",
    "allocation":"1655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5481",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":4037,
    "nom_corrige2":"Suzanne Larouche",
    "nom_famille":"Larouche",
    "titre_genre2":"Conseillère",
    "remuneration":"3647",
    "allocation":"1829",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5476",
    "ville":"Sainte-Monique",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"868"
  },
  {
    "ID":4038,
    "nom_corrige2":"Marie Forcier",
    "nom_famille":"Forcier",
    "titre_genre2":"Conseillère",
    "remuneration":"3649",
    "allocation":"1824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5473",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":4039,
    "nom_corrige2":"Alexandra Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Conseillère",
    "remuneration":"3649",
    "allocation":"1824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5473",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":4040,
    "nom_corrige2":"Jean Proteau",
    "nom_famille":"Proteau",
    "titre_genre2":"Conseiller",
    "remuneration":"3649",
    "allocation":"1824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5473",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":4041,
    "nom_corrige2":"Pascal Cliche",
    "nom_famille":"Cliche",
    "titre_genre2":"Conseiller",
    "remuneration":"3649",
    "allocation":"1824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5473",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":4042,
    "nom_corrige2":"Nathalie Harton",
    "nom_famille":"Harton",
    "titre_genre2":"Conseillère",
    "remuneration":"3649",
    "allocation":"1824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5473",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":4043,
    "nom_corrige2":"Maggie Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"3649",
    "allocation":"1824",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5473",
    "ville":"Lac-Drolet",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1107"
  },
  {
    "ID":4044,
    "nom_corrige2":"Andrée-Anne Bock",
    "nom_famille":"Bock",
    "titre_genre2":"Conseillère",
    "remuneration":"3644",
    "allocation":"1822",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5466",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":4045,
    "nom_corrige2":"Guy Whissell",
    "nom_famille":"Whissell",
    "titre_genre2":"Conseiller",
    "remuneration":"3644",
    "allocation":"1822",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5466",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":4046,
    "nom_corrige2":"Maryse Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseillère",
    "remuneration":"3644",
    "allocation":"1822",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5466",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":4047,
    "nom_corrige2":"Stéphane Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseiller",
    "remuneration":"3644",
    "allocation":"1822",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5466",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":4048,
    "nom_corrige2":"François Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"3644",
    "allocation":"1822",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5466",
    "ville":"Notre-Dame-de-la-Paix",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"706"
  },
  {
    "ID":4049,
    "nom_corrige2":"Gilles Isabel",
    "nom_famille":"Isabel",
    "titre_genre2":"Conseiller",
    "remuneration":"3527",
    "allocation":"1928",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5455",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":4050,
    "nom_corrige2":"Tom Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseillère",
    "remuneration":"3631",
    "allocation":"1815",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5446",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":4051,
    "nom_corrige2":"Denis Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"3628",
    "allocation":"1814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5442",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":4052,
    "nom_corrige2":"Dominique Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseiller",
    "remuneration":"3628",
    "allocation":"1814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5442",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":4053,
    "nom_corrige2":"Gaétan Longchamp",
    "nom_famille":"Longchamp",
    "titre_genre2":"Conseiller",
    "remuneration":"3628",
    "allocation":"1814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5442",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":4054,
    "nom_corrige2":"Lauréanne Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseillère",
    "remuneration":"3628",
    "allocation":"1814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5442",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":4055,
    "nom_corrige2":"Maude Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"3628",
    "allocation":"1814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5442",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":4056,
    "nom_corrige2":"Patrick Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"3628",
    "allocation":"1814",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5442",
    "ville":"Saint-François-de-l'Île-d'Orléans",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"551"
  },
  {
    "ID":4057,
    "nom_corrige2":"Edith Mageau",
    "nom_famille":"Mageau",
    "titre_genre2":"Conseillère",
    "remuneration":"3785",
    "allocation":"1655",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5440",
    "ville":"Boileau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"410"
  },
  {
    "ID":4058,
    "nom_corrige2":"Normand Henley",
    "nom_famille":"Henley",
    "titre_genre2":"Conseiller",
    "remuneration":"3736",
    "allocation":"1703",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5439",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":4059,
    "nom_corrige2":"Sylvie Salois",
    "nom_famille":"Salois",
    "titre_genre2":"Conseillère",
    "remuneration":"3421",
    "allocation":"1710",
    "remuneration2":"203,00$",
    "allocation2":"101,00$",
    "total":"5435",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4060,
    "nom_corrige2":"Stéphane Roussy",
    "nom_famille":"Roussy",
    "titre_genre2":"Conseiller",
    "remuneration":"3623",
    "allocation":"1812",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5435",
    "ville":"Lac-Saguay",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"571"
  },
  {
    "ID":4061,
    "nom_corrige2":"Gisèle Saindon",
    "nom_famille":"Saindon",
    "titre_genre2":"Mairesse",
    "remuneration":"3618",
    "allocation":"1809",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5427",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4062,
    "nom_corrige2":"Carl Croteau",
    "nom_famille":"Croteau",
    "titre_genre2":"Conseiller",
    "remuneration":"3410",
    "allocation":"1710",
    "remuneration2":"225,00$",
    "allocation2":"75,00$",
    "total":"5420",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":4063,
    "nom_corrige2":"Christian Marois",
    "nom_famille":"Marois",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5409",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":4064,
    "nom_corrige2":"Francine Vallières Juteau",
    "nom_famille":"Vallières Juteau",
    "titre_genre2":"Conseillère",
    "remuneration":"3606",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5409",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":4065,
    "nom_corrige2":"François Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5409",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":4066,
    "nom_corrige2":"Johanne Desabrais",
    "nom_famille":"Desabrais",
    "titre_genre2":"Conseillère",
    "remuneration":"3606",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5409",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":4067,
    "nom_corrige2":"Pierre Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5409",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":4068,
    "nom_corrige2":"Sophie Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseillère",
    "remuneration":"3606",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5409",
    "ville":"Saint-Joachim-de-Shefford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1573"
  },
  {
    "ID":4069,
    "nom_corrige2":"Guy Roussel",
    "nom_famille":"Roussel",
    "titre_genre2":"Conseiller",
    "remuneration":"3605",
    "allocation":"1802",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":4070,
    "nom_corrige2":"Alain Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseiller",
    "remuneration":"3605",
    "allocation":"1802",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":4071,
    "nom_corrige2":"Erin Kane",
    "nom_famille":"Kane",
    "titre_genre2":"Conseillère",
    "remuneration":"3605",
    "allocation":"1802",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":4072,
    "nom_corrige2":"Julie de Grâce",
    "nom_famille":"de Grâce",
    "titre_genre2":"Conseillère",
    "remuneration":"3605",
    "allocation":"1802",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":4073,
    "nom_corrige2":"Pierre Robineau",
    "nom_famille":"Robineau",
    "titre_genre2":"Conseiller",
    "remuneration":"3605",
    "allocation":"1802",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":4074,
    "nom_corrige2":"Tiffany Butler",
    "nom_famille":"Butler",
    "titre_genre2":"Conseillère",
    "remuneration":"3605",
    "allocation":"1802",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Mayo",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"720"
  },
  {
    "ID":4075,
    "nom_corrige2":"Noëlline Gallant",
    "nom_famille":"Gallant",
    "titre_genre2":"Conseillère",
    "remuneration":"3604",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":4076,
    "nom_corrige2":"Denis Rochette",
    "nom_famille":"Rochette",
    "titre_genre2":"Conseiller",
    "remuneration":"3604",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":4077,
    "nom_corrige2":"Francine Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"3604",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":4078,
    "nom_corrige2":"Romuald Gallant",
    "nom_famille":"Gallant",
    "titre_genre2":"Conseiller",
    "remuneration":"3604",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5407",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":4079,
    "nom_corrige2":"Paula Lacoursière",
    "nom_famille":"Lacoursière",
    "titre_genre2":"Conseillère",
    "remuneration":"3779",
    "allocation":"1621",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5400",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":4080,
    "nom_corrige2":"Michel Marquis",
    "nom_famille":"Marquis",
    "titre_genre2":"Conseiller",
    "remuneration":"3779",
    "allocation":"1621",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5400",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":4081,
    "nom_corrige2":"Dominique Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"3779",
    "allocation":"1621",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5400",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":4082,
    "nom_corrige2":"Ghislain Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseiller",
    "remuneration":"3779",
    "allocation":"1621",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5400",
    "ville":"Saint-Théophile",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"721"
  },
  {
    "ID":4083,
    "nom_corrige2":"Marlène Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Mairesse",
    "remuneration":"3600",
    "allocation":"1800",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5400",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":4084,
    "nom_corrige2":"Nancy Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"3247",
    "allocation":"999,00$",
    "remuneration2":"767,00$",
    "allocation2":"384,00$",
    "total":"5397",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":4085,
    "nom_corrige2":"Alexandre Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseiller",
    "remuneration":"3587",
    "allocation":"1794",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5381",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":4086,
    "nom_corrige2":"Gilles Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"3786",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5379",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":4087,
    "nom_corrige2":"René Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"3585",
    "allocation":"1792",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5377",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":4088,
    "nom_corrige2":"Denis Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"3838",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5367",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":4089,
    "nom_corrige2":"Marie-Hélène Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseillère",
    "remuneration":"3756",
    "allocation":"1603",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5359",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":4090,
    "nom_corrige2":"Aglaée D'Auteuil",
    "nom_famille":"D'Auteuil",
    "titre_genre2":"Conseillère",
    "remuneration":"3567",
    "allocation":"1784",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5351",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":4091,
    "nom_corrige2":"Yvan Fréchette",
    "nom_famille":"Fréchette",
    "titre_genre2":"Conseiller",
    "remuneration":"3500",
    "allocation":"1750",
    "remuneration2":"100,00$",
    "allocation2":"0",
    "total":"5350",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":4092,
    "nom_corrige2":"Audrey-Claude Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseillère",
    "remuneration":"3566",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5349",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":4093,
    "nom_corrige2":"Colette Fréchette Beausoleil",
    "nom_famille":"Fréchette Beausoleil",
    "titre_genre2":"Conseillère",
    "remuneration":"3566",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5349",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":4094,
    "nom_corrige2":"Geneviève Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"3566",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5349",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":4095,
    "nom_corrige2":"Nicolas Dujardin",
    "nom_famille":"Dujardin",
    "titre_genre2":"Conseiller",
    "remuneration":"3566",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5349",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":4096,
    "nom_corrige2":"Sylvain Pronovost",
    "nom_famille":"Pronovost",
    "titre_genre2":"Conseiller",
    "remuneration":"3566",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5349",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":4097,
    "nom_corrige2":"Marcelle Trottier",
    "nom_famille":"Trottier",
    "titre_genre2":"Conseillère",
    "remuneration":"3566",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5349",
    "ville":"Baie-du-Febvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1009"
  },
  {
    "ID":4098,
    "nom_corrige2":"Éric Fréchette",
    "nom_famille":"Fréchette",
    "titre_genre2":"Conseiller",
    "remuneration":"3565",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5348",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":4099,
    "nom_corrige2":"Marie-Josée Pleau",
    "nom_famille":"Pleau",
    "titre_genre2":"Conseillère",
    "remuneration":"3565",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5348",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":4100,
    "nom_corrige2":"Krystel Houle-Plante",
    "nom_famille":"Houle-Plante",
    "titre_genre2":"Conseillère",
    "remuneration":"3565",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5348",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":4101,
    "nom_corrige2":"Luc Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Conseiller",
    "remuneration":"3565",
    "allocation":"1783",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5348",
    "ville":"Kingsey Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2048"
  },
  {
    "ID":4102,
    "nom_corrige2":"Ginette Barnabé",
    "nom_famille":"Barnabé",
    "titre_genre2":"Conseillère",
    "remuneration":"3564",
    "allocation":"1782",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5346",
    "ville":"Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"912"
  },
  {
    "ID":4103,
    "nom_corrige2":"Dany Chapdelaine",
    "nom_famille":"Chapdelaine",
    "titre_genre2":"Conseiller",
    "remuneration":"3224",
    "allocation":"1612",
    "remuneration2":"329,00$",
    "allocation2":"164,00$",
    "total":"5329",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4104,
    "nom_corrige2":"Antonin Boulet",
    "nom_famille":"Boulet",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1721",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5327",
    "ville":"Ham-Sud",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"230"
  },
  {
    "ID":4105,
    "nom_corrige2":"Luc St-Laurent",
    "nom_famille":"St-Laurent",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1721",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5327",
    "ville":"Ham-Sud",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"230"
  },
  {
    "ID":4106,
    "nom_corrige2":"Marilene Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseillère",
    "remuneration":"3606",
    "allocation":"1721",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5327",
    "ville":"Ham-Sud",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"230"
  },
  {
    "ID":4107,
    "nom_corrige2":"William Darveau-Vaillancourt",
    "nom_famille":"Darveau-Vaillancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1721",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5327",
    "ville":"Ham-Sud",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"230"
  },
  {
    "ID":4108,
    "nom_corrige2":"Diane Audit-Goddard",
    "nom_famille":"Audit-Goddard",
    "titre_genre2":"Conseillère",
    "remuneration":"3606",
    "allocation":"1721",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5327",
    "ville":"Ham-Sud",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"230"
  },
  {
    "ID":4109,
    "nom_corrige2":"Guylaine Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Conseillère",
    "remuneration":"3541",
    "allocation":"1770",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5311",
    "ville":"Saint-Raphaël",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2498"
  },
  {
    "ID":4110,
    "nom_corrige2":"Marc-André Routhier",
    "nom_famille":"Routhier",
    "titre_genre2":"Conseiller",
    "remuneration":"3536",
    "allocation":"1767",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5303",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":4111,
    "nom_corrige2":"Eric Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"3532",
    "allocation":"1766",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5298",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":4112,
    "nom_corrige2":"Lucette Hallée",
    "nom_famille":"Hallée",
    "titre_genre2":"Conseillère",
    "remuneration":"3527",
    "allocation":"1771",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5298",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":4113,
    "nom_corrige2":"Richard Bisson",
    "nom_famille":"Bisson",
    "titre_genre2":"Conseiller",
    "remuneration":"3530",
    "allocation":"1765",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5295",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":4114,
    "nom_corrige2":"Patricia Rene",
    "nom_famille":"Rene",
    "titre_genre2":"Conseillère",
    "remuneration":"3530",
    "allocation":"1765",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5295",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":4115,
    "nom_corrige2":"Émilie Legras",
    "nom_famille":"Legras",
    "titre_genre2":"Conseillère",
    "remuneration":"3530",
    "allocation":"1765",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5295",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":4116,
    "nom_corrige2":"Guillaume Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseiller",
    "remuneration":"3530",
    "allocation":"1765",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5295",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":4117,
    "nom_corrige2":"Georges Chapados",
    "nom_famille":"Chapados",
    "titre_genre2":"Conseiller",
    "remuneration":"3528",
    "allocation":"1764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5292",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":4118,
    "nom_corrige2":"Johanne Horth",
    "nom_famille":"Horth",
    "titre_genre2":"Conseillère",
    "remuneration":"3528",
    "allocation":"1764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5292",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":4119,
    "nom_corrige2":"Nancy Huard",
    "nom_famille":"Huard",
    "titre_genre2":"Conseillère",
    "remuneration":"3528",
    "allocation":"1764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5292",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":4120,
    "nom_corrige2":"Sylvie Lecourtois",
    "nom_famille":"Lecourtois",
    "titre_genre2":"Conseillère",
    "remuneration":"3528",
    "allocation":"1764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5292",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":4121,
    "nom_corrige2":"Laurette Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"3528",
    "allocation":"1764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5292",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":4122,
    "nom_corrige2":"France Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"3528",
    "allocation":"1764",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5292",
    "ville":"Saint-Godefroi",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"361"
  },
  {
    "ID":4123,
    "nom_corrige2":"Guy Benjamin",
    "nom_famille":"Benjamin",
    "titre_genre2":"Maire",
    "remuneration":"3549",
    "allocation":"1733",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5282",
    "ville":"Saint-Césaire",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6168"
  },
  {
    "ID":4124,
    "nom_corrige2":"Jimmy-Frank Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseiller",
    "remuneration":"3520",
    "allocation":"1759",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5279",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":4125,
    "nom_corrige2":"Chantal Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"3511",
    "allocation":"1756",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5267",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":4126,
    "nom_corrige2":"Katherine Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"3511",
    "allocation":"1756",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5267",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":4127,
    "nom_corrige2":"Nancy Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseillère",
    "remuneration":"3511",
    "allocation":"1756",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5267",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":4128,
    "nom_corrige2":"Robert Karim",
    "nom_famille":"Karim",
    "titre_genre2":"Conseiller",
    "remuneration":"3511",
    "allocation":"1756",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5267",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":4129,
    "nom_corrige2":"Gaétan Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"3563",
    "allocation":"1701",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5264",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":4130,
    "nom_corrige2":"Paul Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"3563",
    "allocation":"1701",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5264",
    "ville":"Sainte-Praxède",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"387"
  },
  {
    "ID":4131,
    "nom_corrige2":"Marie-Pier Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseillère",
    "remuneration":"3502",
    "allocation":"1751",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5253",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":4132,
    "nom_corrige2":"Claude Dupont",
    "nom_famille":"Dupont",
    "titre_genre2":"Conseiller",
    "remuneration":"3502",
    "allocation":"1751",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5253",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":4133,
    "nom_corrige2":"Francis Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"3502",
    "allocation":"1751",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5253",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":4134,
    "nom_corrige2":"Pauline Dumoulin",
    "nom_famille":"Dumoulin",
    "titre_genre2":"Conseillère",
    "remuneration":"3502",
    "allocation":"1751",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5253",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":4135,
    "nom_corrige2":"Richard Viau",
    "nom_famille":"Viau",
    "titre_genre2":"Conseiller",
    "remuneration":"3502",
    "allocation":"1751",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5253",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":4136,
    "nom_corrige2":"Luc Van Velzen",
    "nom_famille":"Van Velzen",
    "titre_genre2":"Conseiller",
    "remuneration":"3498",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5247",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":4137,
    "nom_corrige2":"Michelle Richer",
    "nom_famille":"Richer",
    "titre_genre2":"Conseillère",
    "remuneration":"3498",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5247",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":4138,
    "nom_corrige2":"Nicole Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseillère",
    "remuneration":"3498",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5247",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":4139,
    "nom_corrige2":"Paolo Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"3498",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5247",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":4140,
    "nom_corrige2":"Pierre Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseiller",
    "remuneration":"3498",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5247",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":4141,
    "nom_corrige2":"Gaetan Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"3498",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5247",
    "ville":"Saint-Valentin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"432"
  },
  {
    "ID":4142,
    "nom_corrige2":"Nelson Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseiller",
    "remuneration":"3497",
    "allocation":"1749",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5246",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":4143,
    "nom_corrige2":"Patrick Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseiller",
    "remuneration":"3487",
    "allocation":"1744",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5231",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":4144,
    "nom_corrige2":"Joanie Mailloux",
    "nom_famille":"Mailloux",
    "titre_genre2":"Conseillère",
    "remuneration":"3487",
    "allocation":"1744",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5231",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":4145,
    "nom_corrige2":"Sébastien Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Conseiller",
    "remuneration":"3486",
    "allocation":"1743",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5229",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":4146,
    "nom_corrige2":"Aline Alain",
    "nom_famille":"Alain",
    "titre_genre2":"Conseillère",
    "remuneration":"3482",
    "allocation":"1741",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5223",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":4147,
    "nom_corrige2":"Aaron Bass",
    "nom_famille":"Bass",
    "titre_genre2":"Conseiller",
    "remuneration":"3479",
    "allocation":"1740",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5219",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":4148,
    "nom_corrige2":"Georges Mayrand",
    "nom_famille":"Mayrand",
    "titre_genre2":"Conseiller",
    "remuneration":"3479",
    "allocation":"1740",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5219",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":4149,
    "nom_corrige2":"Michel Trottier",
    "nom_famille":"Trottier",
    "titre_genre2":"Conseiller",
    "remuneration":"3479",
    "allocation":"1740",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5219",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":4150,
    "nom_corrige2":"André Filteau",
    "nom_famille":"Filteau",
    "titre_genre2":"Conseiller",
    "remuneration":"3479",
    "allocation":"1740",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5219",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":4151,
    "nom_corrige2":"Danielle Duchesneau Dusablon",
    "nom_famille":"Duchesneau Dusablon",
    "titre_genre2":"Conseillère",
    "remuneration":"3479",
    "allocation":"1740",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5219",
    "ville":"Saint-Casimir",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1489"
  },
  {
    "ID":4152,
    "nom_corrige2":"Paul Olsen",
    "nom_famille":"Olsen",
    "titre_genre2":"Conseiller",
    "remuneration":"3471",
    "allocation":"1735",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5206",
    "ville":"La Patrie",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"828"
  },
  {
    "ID":4153,
    "nom_corrige2":"Jean-Marc Perrier",
    "nom_famille":"Perrier",
    "titre_genre2":"Conseiller",
    "remuneration":"3378",
    "allocation":"1819",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5197",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":4154,
    "nom_corrige2":"Serge Levesque",
    "nom_famille":"Levesque",
    "titre_genre2":"Conseiller",
    "remuneration":"3463",
    "allocation":"1731",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5194",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":4155,
    "nom_corrige2":"Aubert Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"3463",
    "allocation":"1731",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5194",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":4156,
    "nom_corrige2":"Lise Pineault",
    "nom_famille":"Pineault",
    "titre_genre2":"Conseillère",
    "remuneration":"3463",
    "allocation":"1731",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5194",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":4157,
    "nom_corrige2":"Serge Imbeault",
    "nom_famille":"Imbeault",
    "titre_genre2":"Conseiller",
    "remuneration":"3463",
    "allocation":"1731",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5194",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":4158,
    "nom_corrige2":"Suzie Lacombe",
    "nom_famille":"Lacombe",
    "titre_genre2":"Conseillère",
    "remuneration":"3463",
    "allocation":"1731",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5194",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":4159,
    "nom_corrige2":"Charles Meunier",
    "nom_famille":"Meunier",
    "titre_genre2":"Conseiller",
    "remuneration":"3458",
    "allocation":"1729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":4160,
    "nom_corrige2":"Gerald Teske",
    "nom_famille":"Teske",
    "titre_genre2":"Conseiller",
    "remuneration":"3458",
    "allocation":"1729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":4161,
    "nom_corrige2":"John Abraham",
    "nom_famille":"Abraham",
    "titre_genre2":"Conseiller",
    "remuneration":"3458",
    "allocation":"1729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":4162,
    "nom_corrige2":"Lorraine Rochon",
    "nom_famille":"Rochon",
    "titre_genre2":"Conseillère",
    "remuneration":"3458",
    "allocation":"1729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":4163,
    "nom_corrige2":"Roland Barnabé",
    "nom_famille":"Barnabé",
    "titre_genre2":"Conseiller",
    "remuneration":"3458",
    "allocation":"1729",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Mulgrave-et-Derry",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"527"
  },
  {
    "ID":4164,
    "nom_corrige2":"Antoine Durand-Saddier",
    "nom_famille":"Durand-Saddier",
    "titre_genre2":"Conseiller",
    "remuneration":"3378",
    "allocation":"1809",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":4165,
    "nom_corrige2":"Rachel Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseillère",
    "remuneration":"3378",
    "allocation":"1809",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5187",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":4166,
    "nom_corrige2":"Guillaume Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"3454",
    "allocation":"1727",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5181",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":4167,
    "nom_corrige2":"Jocelyn Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Conseiller",
    "remuneration":"3452",
    "allocation":"1726",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5178",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":4168,
    "nom_corrige2":"Lucie Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseillère",
    "remuneration":"3378",
    "allocation":"1799",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5177",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":4169,
    "nom_corrige2":"Martin Dandurand",
    "nom_famille":"Dandurand",
    "titre_genre2":"Conseiller",
    "remuneration":"3378",
    "allocation":"1789",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5167",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":4170,
    "nom_corrige2":"David Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"3444",
    "allocation":"1722",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5166",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":4171,
    "nom_corrige2":"Francis Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseiller",
    "remuneration":"3444",
    "allocation":"1722",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5166",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":4172,
    "nom_corrige2":"Janelle L'Heureux",
    "nom_famille":"L'Heureux",
    "titre_genre2":"Conseillère",
    "remuneration":"3444",
    "allocation":"1722",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5166",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":4173,
    "nom_corrige2":"Manon Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseillère",
    "remuneration":"3444",
    "allocation":"1722",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5166",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":4174,
    "nom_corrige2":"Réjean Bournival",
    "nom_famille":"Bournival",
    "titre_genre2":"Conseiller",
    "remuneration":"3444",
    "allocation":"1722",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5166",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":4175,
    "nom_corrige2":"Cindy Cotten",
    "nom_famille":"Cotten",
    "titre_genre2":"Conseillère",
    "remuneration":"3444",
    "allocation":"1722",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5166",
    "ville":"Laverlochère-Angliers",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"982"
  },
  {
    "ID":4176,
    "nom_corrige2":"André Trudel",
    "nom_famille":"Trudel",
    "titre_genre2":"Conseiller",
    "remuneration":"3440",
    "allocation":"1720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5160",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":4177,
    "nom_corrige2":"Aurèle Cadieux",
    "nom_famille":"Cadieux",
    "titre_genre2":"Conseiller",
    "remuneration":"3440",
    "allocation":"1720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5160",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":4178,
    "nom_corrige2":"Éric Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"3440",
    "allocation":"1720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5160",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":4179,
    "nom_corrige2":"Manon Cadieux",
    "nom_famille":"Cadieux",
    "titre_genre2":"Conseiller",
    "remuneration":"3440",
    "allocation":"1720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5160",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":4180,
    "nom_corrige2":"Mélanie Larente",
    "nom_famille":"Larente",
    "titre_genre2":"Conseillère",
    "remuneration":"3440",
    "allocation":"1720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5160",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":4181,
    "nom_corrige2":"Pascal Bissonnette",
    "nom_famille":"Bissonnette",
    "titre_genre2":"Conseiller",
    "remuneration":"3440",
    "allocation":"1720",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5160",
    "ville":"Mont-Saint-Michel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"597"
  },
  {
    "ID":4182,
    "nom_corrige2":"Sylvie Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"3438",
    "allocation":"1719",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5157",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":4183,
    "nom_corrige2":"Denise Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"3438",
    "allocation":"1719",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5157",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":4184,
    "nom_corrige2":"Dominic Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseiller",
    "remuneration":"3437",
    "allocation":"1718",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5155",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":4185,
    "nom_corrige2":"Nancy Lizotte",
    "nom_famille":"Lizotte",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"1714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5141",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":4186,
    "nom_corrige2":"Nelson Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"1714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5141",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":4187,
    "nom_corrige2":"Alain Delisle",
    "nom_famille":"Delisle",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"1714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5141",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":4188,
    "nom_corrige2":"Carmen Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"1714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5141",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":4189,
    "nom_corrige2":"Nathalie Daoust",
    "nom_famille":"Daoust",
    "titre_genre2":"Conseillère",
    "remuneration":"3427",
    "allocation":"1714",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5141",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":4190,
    "nom_corrige2":"Daniel Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"",
    "remuneration2":"1713",
    "allocation2":"0",
    "total":"5140",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":4191,
    "nom_corrige2":"Gilbert Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"",
    "remuneration2":"1713",
    "allocation2":"0",
    "total":"5140",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":4192,
    "nom_corrige2":"Jean-Luc Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"",
    "remuneration2":"1713",
    "allocation2":"0",
    "total":"5140",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":4193,
    "nom_corrige2":"Robert Jolin",
    "nom_famille":"Jolin",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"",
    "remuneration2":"1713",
    "allocation2":"0",
    "total":"5140",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":4194,
    "nom_corrige2":"Denis Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"",
    "remuneration2":"1713",
    "allocation2":"0",
    "total":"5140",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":4195,
    "nom_corrige2":"Marcelin Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"3427",
    "allocation":"",
    "remuneration2":"1713",
    "allocation2":"0",
    "total":"5140",
    "ville":"Saint-Robert-Bellarmin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"530"
  },
  {
    "ID":4196,
    "nom_corrige2":"Jennylee Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseillère",
    "remuneration":"3423",
    "allocation":"1712",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5135",
    "ville":"Saint-Camille-de-Lellis",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"741"
  },
  {
    "ID":4197,
    "nom_corrige2":"Johanie Cliche",
    "nom_famille":"Cliche",
    "titre_genre2":"Conseillère",
    "remuneration":"3756",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5134",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":4198,
    "nom_corrige2":"Chantal Komlosy",
    "nom_famille":"Komlosy",
    "titre_genre2":"Conseillère",
    "remuneration":"3421",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5131",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4199,
    "nom_corrige2":"Elizabeth Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Conseillère",
    "remuneration":"3421",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5131",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4200,
    "nom_corrige2":"François-Michel Bonneau-Leclerc",
    "nom_famille":"Bonneau-Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"3421",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5131",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4201,
    "nom_corrige2":"Marc Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"3421",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5131",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4202,
    "nom_corrige2":"Suzanne Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"3598",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5127",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":4203,
    "nom_corrige2":"Alex Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"3410",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5120",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":4204,
    "nom_corrige2":"André Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"3410",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5120",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":4205,
    "nom_corrige2":"Marina Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"3410",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5120",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":4206,
    "nom_corrige2":"Mélissa Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseillère",
    "remuneration":"3410",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5120",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":4207,
    "nom_corrige2":"Rock Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"3410",
    "allocation":"1710",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5120",
    "ville":"Saint-Adrien-d'Irlande",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"363"
  },
  {
    "ID":4208,
    "nom_corrige2":"Nathalie Troquet-Marsh",
    "nom_famille":"Troquet-Marsh",
    "titre_genre2":"Conseillère",
    "remuneration":"3303",
    "allocation":"1803",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5106",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":4209,
    "nom_corrige2":"Alexandra Han",
    "nom_famille":"Han",
    "titre_genre2":"Conseillère",
    "remuneration":"3387",
    "allocation":"1694",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5081",
    "ville":"Sainte-Eulalie",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1056"
  },
  {
    "ID":4210,
    "nom_corrige2":"Lucien Boily",
    "nom_famille":"Boily",
    "titre_genre2":"Conseiller",
    "remuneration":"3329",
    "allocation":"1558",
    "remuneration2":"129,00$",
    "allocation2":"65,00$",
    "total":"5081",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":4211,
    "nom_corrige2":"Jean-Pierre Brien",
    "nom_famille":"Brien",
    "titre_genre2":"Conseiller",
    "remuneration":"3210",
    "allocation":"1860",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5070",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4212,
    "nom_corrige2":"Gilles Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"556,00$",
    "allocation2":"278,00$",
    "total":"5065",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":4213,
    "nom_corrige2":"André Bussiere",
    "nom_famille":"Bussiere",
    "titre_genre2":"Conseiller",
    "remuneration":"3367",
    "allocation":"1684",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5051",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":4214,
    "nom_corrige2":"Réjean Gouin",
    "nom_famille":"Gouin",
    "titre_genre2":"Conseillère",
    "remuneration":"3367",
    "allocation":"1683",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5050",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":4215,
    "nom_corrige2":"Cédric Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2409",
    "allocation":"1204",
    "remuneration2":"955,00$",
    "allocation2":"477,00$",
    "total":"5045",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":4216,
    "nom_corrige2":"David Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseiller",
    "remuneration":"3358",
    "allocation":"1679",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5037",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":4217,
    "nom_corrige2":"Lucie Lafrance",
    "nom_famille":"Lafrance",
    "titre_genre2":"Conseillère",
    "remuneration":"3378",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5036",
    "ville":"Senneterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1202"
  },
  {
    "ID":4218,
    "nom_corrige2":"Julie l'Homme",
    "nom_famille":"l'Homme",
    "titre_genre2":"Conseillère",
    "remuneration":"2669",
    "allocation":"1159",
    "remuneration2":"794,00$",
    "allocation2":"397,00$",
    "total":"5019",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":4219,
    "nom_corrige2":"Marc St-Louis",
    "nom_famille":"St-Louis",
    "titre_genre2":"Conseiller",
    "remuneration":"3353",
    "allocation":"1664",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5017",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":4220,
    "nom_corrige2":"Frédéric Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"3897",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5008",
    "ville":"Lyster",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1699"
  },
  {
    "ID":4221,
    "nom_corrige2":"Denis Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"3333",
    "allocation":"1667",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5000",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":4222,
    "nom_corrige2":"Mélanie Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseillère",
    "remuneration":"3333",
    "allocation":"1667",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5000",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":4223,
    "nom_corrige2":"Réjeanne Raymond Roussel",
    "nom_famille":"Raymond Roussel",
    "titre_genre2":"Conseillère",
    "remuneration":"3333",
    "allocation":"1667",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"5000",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":4224,
    "nom_corrige2":"Philippe Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseiller",
    "remuneration":"3332",
    "allocation":"1667",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4999",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":4225,
    "nom_corrige2":"Claude Sévigny",
    "nom_famille":"Sévigny",
    "titre_genre2":"Conseiller",
    "remuneration":"3208",
    "allocation":"1604",
    "remuneration2":"124,00$",
    "allocation2":"62,00$",
    "total":"4998",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":4226,
    "nom_corrige2":"Josée-Ann Dumais",
    "nom_famille":"Dumais",
    "titre_genre2":"Conseillère",
    "remuneration":"3329",
    "allocation":"1667",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4996",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":4227,
    "nom_corrige2":"Yan Dagenais",
    "nom_famille":"Dagenais",
    "titre_genre2":"Conseiller",
    "remuneration":"3328",
    "allocation":"1664",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4992",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":4228,
    "nom_corrige2":"Nathalie Émond",
    "nom_famille":"Émond",
    "titre_genre2":"Conseillère",
    "remuneration":"3328",
    "allocation":"1664",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4992",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":4229,
    "nom_corrige2":"Éric Chassé",
    "nom_famille":"Chassé",
    "titre_genre2":"Conseiller",
    "remuneration":"3328",
    "allocation":"1664",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4992",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":4230,
    "nom_corrige2":"André Casavant",
    "nom_famille":"Casavant",
    "titre_genre2":"Conseiller",
    "remuneration":"3328",
    "allocation":"1664",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4992",
    "ville":"Saint-Sylvère",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"800"
  },
  {
    "ID":4231,
    "nom_corrige2":"Jade Chrest",
    "nom_famille":"Chrest",
    "titre_genre2":"Conseillère",
    "remuneration":"3325",
    "allocation":"1663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4988",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":4232,
    "nom_corrige2":"Benoit Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Conseiller",
    "remuneration":"3325",
    "allocation":"1663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4988",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":4233,
    "nom_corrige2":"Denis Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"3325",
    "allocation":"1663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4988",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":4234,
    "nom_corrige2":"Lyne Rivest",
    "nom_famille":"Rivest",
    "titre_genre2":"Conseillère",
    "remuneration":"3325",
    "allocation":"1663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4988",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":4235,
    "nom_corrige2":"Stéphane Arbour",
    "nom_famille":"Arbour",
    "titre_genre2":"Conseiller",
    "remuneration":"3325",
    "allocation":"1663",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4988",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":4236,
    "nom_corrige2":"Sylvain Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"3606",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4984",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":4237,
    "nom_corrige2":"Alain Provençal",
    "nom_famille":"Provençal",
    "titre_genre2":"Conseiller",
    "remuneration":"3318",
    "allocation":"1659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4977",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":4238,
    "nom_corrige2":"Alexandre Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"3318",
    "allocation":"1659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4977",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":4239,
    "nom_corrige2":"Jonathan Larouche",
    "nom_famille":"Larouche",
    "titre_genre2":"Conseiller",
    "remuneration":"3318",
    "allocation":"1659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4977",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":4240,
    "nom_corrige2":"Lyse Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"3318",
    "allocation":"1659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4977",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":4241,
    "nom_corrige2":"Roger Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"3318",
    "allocation":"1659",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4977",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":4242,
    "nom_corrige2":"Éric Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"3316",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4974",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":4243,
    "nom_corrige2":"Denis Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"3316",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4974",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":4244,
    "nom_corrige2":"Guylaine Bhérer",
    "nom_famille":"Bhérer",
    "titre_genre2":"Conseillère",
    "remuneration":"3316",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4974",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":4245,
    "nom_corrige2":"Marc-André Ouellette",
    "nom_famille":"Ouellette",
    "titre_genre2":"Conseiller",
    "remuneration":"3316",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4974",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":4246,
    "nom_corrige2":"Mélissa Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"3316",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4974",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":4247,
    "nom_corrige2":"Nancy Prescott",
    "nom_famille":"Prescott",
    "titre_genre2":"Conseillère",
    "remuneration":"3316",
    "allocation":"1658",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4974",
    "ville":"Saint-Henri-de-Taillon",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"815"
  },
  {
    "ID":4248,
    "nom_corrige2":"Alain Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseiller",
    "remuneration":"3358",
    "allocation":"1601",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4959",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":4249,
    "nom_corrige2":"Carole-Anne Provencher",
    "nom_famille":"Provencher",
    "titre_genre2":"Conseillère",
    "remuneration":"3358",
    "allocation":"1601",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4959",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":4250,
    "nom_corrige2":"Nadia Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseillère",
    "remuneration":"3358",
    "allocation":"1601",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4959",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":4251,
    "nom_corrige2":"Sébastien Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3358",
    "allocation":"1601",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4959",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":4252,
    "nom_corrige2":"Valérie Loiselle",
    "nom_famille":"Loiselle",
    "titre_genre2":"Conseillère",
    "remuneration":"3358",
    "allocation":"1601",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4959",
    "ville":"Daveluyville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2418"
  },
  {
    "ID":4253,
    "nom_corrige2":"David Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3303",
    "allocation":"1652",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4955",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":4254,
    "nom_corrige2":"Molly Bujold",
    "nom_famille":"Bujold",
    "titre_genre2":"Conseillère",
    "remuneration":"3303",
    "allocation":"1652",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4955",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":4255,
    "nom_corrige2":"Jasmine Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"3295",
    "allocation":"1647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4942",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":4256,
    "nom_corrige2":"Jacynthe Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseillère",
    "remuneration":"3295",
    "allocation":"1647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4942",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":4257,
    "nom_corrige2":"Jean Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"3295",
    "allocation":"1647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4942",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":4258,
    "nom_corrige2":"Magella Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3295",
    "allocation":"1647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4942",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":4259,
    "nom_corrige2":"Isabelle Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"3295",
    "allocation":"1647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4942",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":4260,
    "nom_corrige2":"Steeve Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3295",
    "allocation":"1647",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4942",
    "ville":"Rivière-Éternité",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"435"
  },
  {
    "ID":4261,
    "nom_corrige2":"Melanie Renaud",
    "nom_famille":"Renaud",
    "titre_genre2":"Conseillère",
    "remuneration":"3307",
    "allocation":"1634",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4941",
    "ville":"Sainte-Thérèse-de-la-Gatineau",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"545"
  },
  {
    "ID":4262,
    "nom_corrige2":"Bernard Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"3556",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4934",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":4263,
    "nom_corrige2":"Ariel Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3556",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4934",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":4264,
    "nom_corrige2":"Marco Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"3385",
    "allocation":"1546",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4931",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":4265,
    "nom_corrige2":"Etienne Hudon-Gagnon",
    "nom_famille":"Hudon-Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"3283",
    "allocation":"1642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4925",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":4266,
    "nom_corrige2":"Lucie Coderre",
    "nom_famille":"Coderre",
    "titre_genre2":"Conseillère",
    "remuneration":"3283",
    "allocation":"1642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4925",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":4267,
    "nom_corrige2":"Marco Scrosati",
    "nom_famille":"Scrosati",
    "titre_genre2":"Conseiller",
    "remuneration":"3283",
    "allocation":"1642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4925",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":4268,
    "nom_corrige2":"Nicole Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"3283",
    "allocation":"1642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4925",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":4269,
    "nom_corrige2":"Yves Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"3283",
    "allocation":"1642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4925",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":4270,
    "nom_corrige2":"Yvon Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"3283",
    "allocation":"1642",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4925",
    "ville":"Saint-Claude",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1182"
  },
  {
    "ID":4271,
    "nom_corrige2":"Denis Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"3275",
    "allocation":"1638",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4913",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":4272,
    "nom_corrige2":"Geneviève Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"3275",
    "allocation":"1638",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4913",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":4273,
    "nom_corrige2":"Johanne D'Amours",
    "nom_famille":"D'Amours",
    "titre_genre2":"Conseillère",
    "remuneration":"3275",
    "allocation":"1638",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4913",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":4274,
    "nom_corrige2":"Maxime Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"3275",
    "allocation":"1638",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4913",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":4275,
    "nom_corrige2":"Stevens Perry Pelletier",
    "nom_famille":"Perry Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3275",
    "allocation":"1638",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4913",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":4276,
    "nom_corrige2":"Richard Turgeon",
    "nom_famille":"Turgeon",
    "titre_genre2":"Conseiller",
    "remuneration":"3275",
    "allocation":"1638",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4913",
    "ville":"Val-Brillant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"947"
  },
  {
    "ID":4277,
    "nom_corrige2":"Gilles Lefort",
    "nom_famille":"Lefort",
    "titre_genre2":"Conseiller",
    "remuneration":"3268",
    "allocation":"1634",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4902",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":4278,
    "nom_corrige2":"Jocelyn Berneche",
    "nom_famille":"Berneche",
    "titre_genre2":"Conseiller",
    "remuneration":"3268",
    "allocation":"1634",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4902",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":4279,
    "nom_corrige2":"Loydy Brousseau",
    "nom_famille":"Brousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"3268",
    "allocation":"1634",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4902",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":4280,
    "nom_corrige2":"Pierre-Louis Gilbert-Gauthier",
    "nom_famille":"Gilbert-Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"3268",
    "allocation":"1634",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4902",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":4281,
    "nom_corrige2":"Gilles Laplante",
    "nom_famille":"Laplante",
    "titre_genre2":"Maire suppléant",
    "remuneration":"3268",
    "allocation":"1634",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4902",
    "ville":"Duhamel-Ouest",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"941"
  },
  {
    "ID":4282,
    "nom_corrige2":"Daniel Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"3270",
    "allocation":"1630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4900",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":4283,
    "nom_corrige2":"Carl Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseiller",
    "remuneration":"3270",
    "allocation":"1630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4900",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":4284,
    "nom_corrige2":"Isabelle Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseillère",
    "remuneration":"3270",
    "allocation":"1630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4900",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":4285,
    "nom_corrige2":"Julie Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseillère",
    "remuneration":"3270",
    "allocation":"1630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4900",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":4286,
    "nom_corrige2":"Pierre Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"3270",
    "allocation":"1630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4900",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":4287,
    "nom_corrige2":"Suzy Bellerose",
    "nom_famille":"Bellerose",
    "titre_genre2":"Conseillère",
    "remuneration":"3270",
    "allocation":"1630",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4900",
    "ville":"Laurierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1390"
  },
  {
    "ID":4288,
    "nom_corrige2":"Christopher Hill",
    "nom_famille":"Hill",
    "titre_genre2":"Conseiller",
    "remuneration":"3913",
    "allocation":"978,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4891",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":4289,
    "nom_corrige2":"Pierre Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"3329",
    "allocation":"1558",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4887",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":4290,
    "nom_corrige2":"Érik Chassé",
    "nom_famille":"Chassé",
    "titre_genre2":"Conseillère",
    "remuneration":"3329",
    "allocation":"1558",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4887",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":4291,
    "nom_corrige2":"Jean-Pierre Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseiller",
    "remuneration":"3329",
    "allocation":"1558",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4887",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":4292,
    "nom_corrige2":"Joëlle Hénault",
    "nom_famille":"Hénault",
    "titre_genre2":"Conseillère",
    "remuneration":"3254",
    "allocation":"1627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4881",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":4293,
    "nom_corrige2":"Claude Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseiller",
    "remuneration":"3254",
    "allocation":"1627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4881",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":4294,
    "nom_corrige2":"Karl Lindsay",
    "nom_famille":"Lindsay",
    "titre_genre2":"Conseiller",
    "remuneration":"3254",
    "allocation":"1627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4881",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":4295,
    "nom_corrige2":"Marie Gervais",
    "nom_famille":"Gervais",
    "titre_genre2":"Conseillère",
    "remuneration":"3254",
    "allocation":"1627",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4881",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":4296,
    "nom_corrige2":"Pierre-Yves P. Blanchet",
    "nom_famille":"P. Blanchet",
    "titre_genre2":"Conseiller",
    "remuneration":"3758",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4869",
    "ville":"Lyster",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1699"
  },
  {
    "ID":4297,
    "nom_corrige2":"Tony Rancourt",
    "nom_famille":"Rancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"3239",
    "allocation":"1620",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4859",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":4298,
    "nom_corrige2":"Francine Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseillère",
    "remuneration":"3239",
    "allocation":"1620",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4859",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":4299,
    "nom_corrige2":"Hugh Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"3239",
    "allocation":"1620",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4859",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":4300,
    "nom_corrige2":"Réal Rancourt",
    "nom_famille":"Rancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"3239",
    "allocation":"1620",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4859",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":4301,
    "nom_corrige2":"Valérie Rancourt",
    "nom_famille":"Rancourt",
    "titre_genre2":"Conseillère",
    "remuneration":"3239",
    "allocation":"1620",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4859",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":4302,
    "nom_corrige2":"Priscillia Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"3239",
    "allocation":"1620",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4859",
    "ville":"Poularies",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"677"
  },
  {
    "ID":4303,
    "nom_corrige2":"Simon Dufault",
    "nom_famille":"Dufault",
    "titre_genre2":"Conseiller",
    "remuneration":"2756",
    "allocation":"1378",
    "remuneration2":"482,00$",
    "allocation2":"241,00$",
    "total":"4857",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":4304,
    "nom_corrige2":"Mathieu Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"3468",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4855",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":4305,
    "nom_corrige2":"Nicolas Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseiller",
    "remuneration":"3117",
    "allocation":"1559",
    "remuneration2":"112,00$",
    "allocation2":"56,00$",
    "total":"4844",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":4306,
    "nom_corrige2":"Réal Delorme",
    "nom_famille":"Delorme",
    "titre_genre2":"Conseiller",
    "remuneration":"3224",
    "allocation":"1612",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4836",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4307,
    "nom_corrige2":"Claude Jeanson",
    "nom_famille":"Jeanson",
    "titre_genre2":"Conseiller",
    "remuneration":"3224",
    "allocation":"1612",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4836",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4308,
    "nom_corrige2":"Éric Bossé",
    "nom_famille":"Bossé",
    "titre_genre2":"Conseiller",
    "remuneration":"3224",
    "allocation":"1612",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4836",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4309,
    "nom_corrige2":"Valérie Fontaine-Martin",
    "nom_famille":"Fontaine-Martin",
    "titre_genre2":"Conseillère",
    "remuneration":"3224",
    "allocation":"1612",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4836",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4310,
    "nom_corrige2":"Carl Massé",
    "nom_famille":"Massé",
    "titre_genre2":"Conseiller",
    "remuneration":"3224",
    "allocation":"1612",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4836",
    "ville":"Lawrenceville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4311,
    "nom_corrige2":"Richard Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"3221",
    "allocation":"1610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4831",
    "ville":"La Patrie",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"828"
  },
  {
    "ID":4312,
    "nom_corrige2":"Philippe Delage",
    "nom_famille":"Delage",
    "titre_genre2":"Conseillère",
    "remuneration":"3221",
    "allocation":"1610",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4831",
    "ville":"La Patrie",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"828"
  },
  {
    "ID":4313,
    "nom_corrige2":"Martine Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseillère",
    "remuneration":"3156",
    "allocation":"1675",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4831",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":4314,
    "nom_corrige2":"René St-Louis",
    "nom_famille":"St-Louis",
    "titre_genre2":"Conseiller",
    "remuneration":"3217",
    "allocation":"1608",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4825",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":4315,
    "nom_corrige2":"Jean Deblois",
    "nom_famille":"Deblois",
    "titre_genre2":"Conseiller",
    "remuneration":"3215",
    "allocation":"1607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4822",
    "ville":"Austin",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1938"
  },
  {
    "ID":4316,
    "nom_corrige2":"Jean-Philippe Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"3214",
    "allocation":"1607",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4821",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":4317,
    "nom_corrige2":"Cynthia Gamache",
    "nom_famille":"Gamache",
    "titre_genre2":"Conseillère",
    "remuneration":"3213",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4819",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":4318,
    "nom_corrige2":"Dany Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"3213",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4819",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":4319,
    "nom_corrige2":"Josianne Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseillère",
    "remuneration":"3213",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4819",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":4320,
    "nom_corrige2":"Simon Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3213",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4819",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":4321,
    "nom_corrige2":"Yannick Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"3213",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4819",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":4322,
    "nom_corrige2":"Émile-Olivier Desgens",
    "nom_famille":"Desgens",
    "titre_genre2":"Conseiller",
    "remuneration":"3213",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4819",
    "ville":"Saint-Modeste",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1213"
  },
  {
    "ID":4323,
    "nom_corrige2":"Guillaume Plamondon",
    "nom_famille":"Plamondon",
    "titre_genre2":"Conseiller",
    "remuneration":"3212",
    "allocation":"1606",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4818",
    "ville":"Sainte-Brigitte-de-Laval",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"9018"
  },
  {
    "ID":4324,
    "nom_corrige2":"Fanny Gauthier Patoine",
    "nom_famille":"Gauthier Patoine",
    "titre_genre2":"Conseillère",
    "remuneration":"3210",
    "allocation":"1605",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4815",
    "ville":"Saint-Adrien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"562"
  },
  {
    "ID":4325,
    "nom_corrige2":"Frédéric Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"3208",
    "allocation":"1604",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4812",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":4326,
    "nom_corrige2":"Jean Bellehumeur",
    "nom_famille":"Bellehumeur",
    "titre_genre2":"Conseiller",
    "remuneration":"3208",
    "allocation":"1604",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4812",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":4327,
    "nom_corrige2":"Joane Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseillère",
    "remuneration":"3208",
    "allocation":"1604",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4812",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":4328,
    "nom_corrige2":"Lise Bellehumeur",
    "nom_famille":"Bellehumeur",
    "titre_genre2":"Conseillère",
    "remuneration":"3208",
    "allocation":"1604",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4812",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":4329,
    "nom_corrige2":"Simon Lafrenière",
    "nom_famille":"Lafrenière",
    "titre_genre2":"Conseiller",
    "remuneration":"3208",
    "allocation":"1604",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4812",
    "ville":"Chartierville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"325"
  },
  {
    "ID":4330,
    "nom_corrige2":"Anne-Marie Beaudry",
    "nom_famille":"Beaudry",
    "titre_genre2":"Conseillère",
    "remuneration":"3206",
    "allocation":"1603",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4809",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":4331,
    "nom_corrige2":"Étienne Ménard",
    "nom_famille":"Ménard",
    "titre_genre2":"Conseiller",
    "remuneration":"3206",
    "allocation":"1603",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4809",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":4332,
    "nom_corrige2":"Gino Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseiller",
    "remuneration":"3206",
    "allocation":"1603",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4809",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":4333,
    "nom_corrige2":"Martine Rouillard",
    "nom_famille":"Rouillard",
    "titre_genre2":"Conseillère",
    "remuneration":"3206",
    "allocation":"1603",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4809",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":4334,
    "nom_corrige2":"Samuel Larochelle",
    "nom_famille":"Larochelle",
    "titre_genre2":"Conseiller",
    "remuneration":"3206",
    "allocation":"1603",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4809",
    "ville":"Saint-Magloire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"732"
  },
  {
    "ID":4335,
    "nom_corrige2":"Sabine Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"3202",
    "allocation":"1601",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4803",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":4336,
    "nom_corrige2":"Annick D'Amours",
    "nom_famille":"D'Amours",
    "titre_genre2":"Conseillère",
    "remuneration":"3200",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4800",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":4337,
    "nom_corrige2":"Benoit Harton",
    "nom_famille":"Harton",
    "titre_genre2":"Conseiller",
    "remuneration":"3200",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4800",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":4338,
    "nom_corrige2":"Cédric Vallois-Mercier",
    "nom_famille":"Vallois-Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"3200",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4800",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":4339,
    "nom_corrige2":"Chantal Boily",
    "nom_famille":"Boily",
    "titre_genre2":"Conseillère",
    "remuneration":"3200",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4800",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":4340,
    "nom_corrige2":"Jennifer Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"3200",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4800",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":4341,
    "nom_corrige2":"Virginie Gagné St-Pierre",
    "nom_famille":"Gagné St-Pierre",
    "titre_genre2":"Conseillère",
    "remuneration":"3200",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4800",
    "ville":"Saint-Pacôme",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1565"
  },
  {
    "ID":4342,
    "nom_corrige2":"Gervais Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1599",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4788",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":4343,
    "nom_corrige2":"Henri Guimont",
    "nom_famille":"Guimont",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1599",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4788",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":4344,
    "nom_corrige2":"Gérald Bérard",
    "nom_famille":"Bérard",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1599",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4788",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":4345,
    "nom_corrige2":"Roxane Martine Coutu",
    "nom_famille":"Martine Coutu",
    "titre_genre2":"Conseillère",
    "remuneration":"3189",
    "allocation":"1599",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4788",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":4346,
    "nom_corrige2":"Sylvie Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"3189",
    "allocation":"1599",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4788",
    "ville":"Saint-Roch-des-Aulnaies",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"944"
  },
  {
    "ID":4347,
    "nom_corrige2":"François Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4784",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":4348,
    "nom_corrige2":"Jean-François Boulet",
    "nom_famille":"Boulet",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4784",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":4349,
    "nom_corrige2":"Jean-Guy Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4784",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":4350,
    "nom_corrige2":"Réal Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4784",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":4351,
    "nom_corrige2":"Yvan Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseiller",
    "remuneration":"3189",
    "allocation":"1595",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4784",
    "ville":"Sainte-Cécile-de-Whitton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"914"
  },
  {
    "ID":4352,
    "nom_corrige2":"André Ferland",
    "nom_famille":"Ferland",
    "titre_genre2":"Conseiller",
    "remuneration":"3188",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4782",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":4353,
    "nom_corrige2":"Jean-Guy Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseiller",
    "remuneration":"3188",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4782",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":4354,
    "nom_corrige2":"Marcel Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseiller",
    "remuneration":"3188",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4782",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":4355,
    "nom_corrige2":"Réjean Labonté",
    "nom_famille":"Labonté",
    "titre_genre2":"Conseiller",
    "remuneration":"3188",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4782",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":4356,
    "nom_corrige2":"Linda Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseillère",
    "remuneration":"3188",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4782",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":4357,
    "nom_corrige2":"Daniel Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseiller",
    "remuneration":"3187",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4780",
    "ville":"Sainte-Geneviève-de-Batiscan",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1161"
  },
  {
    "ID":4358,
    "nom_corrige2":"Francine Bard",
    "nom_famille":"Bard",
    "titre_genre2":"Conseillère",
    "remuneration":"3186",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4779",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":4359,
    "nom_corrige2":"Gabriel D'Anjou",
    "nom_famille":"D'Anjou",
    "titre_genre2":"Conseiller",
    "remuneration":"3186",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4779",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":4360,
    "nom_corrige2":"Marilyne Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseillère",
    "remuneration":"3186",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4779",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":4361,
    "nom_corrige2":"Stéphanie Bard",
    "nom_famille":"Bard",
    "titre_genre2":"Conseillère",
    "remuneration":"3186",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4779",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":4362,
    "nom_corrige2":"Danielle D'Anjou",
    "nom_famille":"D'Anjou",
    "titre_genre2":"Conseillère",
    "remuneration":"3186",
    "allocation":"1593",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4779",
    "ville":"Saint-Gabriel-Lalemant",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"669"
  },
  {
    "ID":4363,
    "nom_corrige2":"Frédéric Lehoullier",
    "nom_famille":"Lehoullier",
    "titre_genre2":"Conseiller",
    "remuneration":"3184",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4776",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":4364,
    "nom_corrige2":"Frédéric Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Conseiller",
    "remuneration":"3184",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4776",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":4365,
    "nom_corrige2":"Nicolas Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseiller",
    "remuneration":"3184",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4776",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":4366,
    "nom_corrige2":"Pierre-Paul Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseiller",
    "remuneration":"3184",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4776",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":4367,
    "nom_corrige2":"Sabrina Turmel",
    "nom_famille":"Turmel",
    "titre_genre2":"Conseillère",
    "remuneration":"3184",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4776",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":4368,
    "nom_corrige2":"Stéphanie Bégin",
    "nom_famille":"Bégin",
    "titre_genre2":"Conseillère",
    "remuneration":"3184",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4776",
    "ville":"Sainte-Marguerite",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1303"
  },
  {
    "ID":4369,
    "nom_corrige2":"David Gouin",
    "nom_famille":"Gouin",
    "titre_genre2":"Conseiller",
    "remuneration":"3183",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4775",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":4370,
    "nom_corrige2":"Sébastien Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"3183",
    "allocation":"1592",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4775",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":4371,
    "nom_corrige2":"Karine Montminy",
    "nom_famille":"Montminy",
    "titre_genre2":"Conseillère",
    "remuneration":"3175",
    "allocation":"1587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4762",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":4372,
    "nom_corrige2":"Lyse Chatelois",
    "nom_famille":"Chatelois",
    "titre_genre2":"Conseillère",
    "remuneration":"3175",
    "allocation":"1587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4762",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":4373,
    "nom_corrige2":"Marc Fontaine",
    "nom_famille":"Fontaine",
    "titre_genre2":"Conseiller",
    "remuneration":"3175",
    "allocation":"1587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4762",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":4374,
    "nom_corrige2":"Marcel Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseiller",
    "remuneration":"3175",
    "allocation":"1587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4762",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":4375,
    "nom_corrige2":"René Madore",
    "nom_famille":"Madore",
    "titre_genre2":"Conseiller",
    "remuneration":"3175",
    "allocation":"1587",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4762",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":4376,
    "nom_corrige2":"Yves Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"3167",
    "allocation":"1584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4751",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":4377,
    "nom_corrige2":"Mathieu Lavigne-Demers",
    "nom_famille":"Lavigne-Demers",
    "titre_genre2":"Maire suppléant",
    "remuneration":"3167",
    "allocation":"1584",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4751",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":4378,
    "nom_corrige2":"Jean-Guy Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseiller",
    "remuneration":"3156",
    "allocation":"1594",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":4379,
    "nom_corrige2":"Louis Sexton",
    "nom_famille":"Sexton",
    "titre_genre2":"Conseiller",
    "remuneration":"3167",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":4380,
    "nom_corrige2":"Margaret-Ann Cooke",
    "nom_famille":"Cooke",
    "titre_genre2":"Conseillère",
    "remuneration":"3167",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":4381,
    "nom_corrige2":"Michel Boudreau",
    "nom_famille":"Boudreau",
    "titre_genre2":"Conseiller",
    "remuneration":"3167",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":4382,
    "nom_corrige2":"Rickey Barter",
    "nom_famille":"Barter",
    "titre_genre2":"Conseiller",
    "remuneration":"3167",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":4383,
    "nom_corrige2":"Tammy Burton",
    "nom_famille":"Burton",
    "titre_genre2":"Conseillère",
    "remuneration":"3167",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":4384,
    "nom_corrige2":"Kim Barter",
    "nom_famille":"Barter",
    "titre_genre2":"Conseillère",
    "remuneration":"3167",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4750",
    "ville":"Cascapédia–Saint-Jules",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"773"
  },
  {
    "ID":4385,
    "nom_corrige2":"Nathalie Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseillère",
    "remuneration":"3166",
    "allocation":"1583",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4749",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4386,
    "nom_corrige2":"Brigitte Claveau",
    "nom_famille":"Claveau",
    "titre_genre2":"Conseillère",
    "remuneration":"3163",
    "allocation":"1582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":4387,
    "nom_corrige2":"Frédéric Bonin",
    "nom_famille":"Bonin",
    "titre_genre2":"Conseiller",
    "remuneration":"3163",
    "allocation":"1582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":4388,
    "nom_corrige2":"Michel Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseiller",
    "remuneration":"3163",
    "allocation":"1582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":4389,
    "nom_corrige2":"Roger Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"3163",
    "allocation":"1582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":4390,
    "nom_corrige2":"Stéphane Leblond",
    "nom_famille":"Leblond",
    "titre_genre2":"Conseiller",
    "remuneration":"3163",
    "allocation":"1582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":4391,
    "nom_corrige2":"Alex Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Conseiller",
    "remuneration":"3163",
    "allocation":"1582",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Saint-Lazare-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1342"
  },
  {
    "ID":4392,
    "nom_corrige2":"Marco Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseiller",
    "remuneration":"3258",
    "allocation":"1487",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4745",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":4393,
    "nom_corrige2":"Lydia Pouliot",
    "nom_famille":"Pouliot",
    "titre_genre2":"Conseillère",
    "remuneration":"3161",
    "allocation":"1581",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4742",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":4394,
    "nom_corrige2":"Marcel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3161",
    "allocation":"1581",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4742",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":4395,
    "nom_corrige2":"Rodrigue Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Conseiller",
    "remuneration":"3161",
    "allocation":"1581",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4742",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":4396,
    "nom_corrige2":"Stéphane Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"3161",
    "allocation":"1581",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4742",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":4397,
    "nom_corrige2":"Yohan Guillemette",
    "nom_famille":"Guillemette",
    "titre_genre2":"Conseiller",
    "remuneration":"3161",
    "allocation":"1581",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4742",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":4398,
    "nom_corrige2":"Jayne McNaughton",
    "nom_famille":"McNaughton",
    "titre_genre2":"Conseillère",
    "remuneration":"3763",
    "allocation":"978,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4741",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":4399,
    "nom_corrige2":"Steven Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Conseiller",
    "remuneration":"3158",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4737",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4400,
    "nom_corrige2":"Catherine Demange",
    "nom_famille":"Demange",
    "titre_genre2":"Conseillère",
    "remuneration":"3158",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4737",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4401,
    "nom_corrige2":"Mindy Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseillère",
    "remuneration":"3158",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4737",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4402,
    "nom_corrige2":"Paule Rochette",
    "nom_famille":"Rochette",
    "titre_genre2":"Conseillère",
    "remuneration":"3158",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4737",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4403,
    "nom_corrige2":"Sarah Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseillère",
    "remuneration":"3158",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4737",
    "ville":"Piopolis",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4404,
    "nom_corrige2":"Johanny Morneau-Briand",
    "nom_famille":"Morneau-Briand",
    "titre_genre2":"Conseillère",
    "remuneration":"3157",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4736",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":4405,
    "nom_corrige2":"Frédéric Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"3157",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4736",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":4406,
    "nom_corrige2":"Normand Lizotte",
    "nom_famille":"Lizotte",
    "titre_genre2":"Conseiller",
    "remuneration":"3157",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4736",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":4407,
    "nom_corrige2":"Richard Bossé",
    "nom_famille":"Bossé",
    "titre_genre2":"Conseiller",
    "remuneration":"3157",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4736",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":4408,
    "nom_corrige2":"Roberto Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3157",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4736",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":4409,
    "nom_corrige2":"Patrick Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"3157",
    "allocation":"1579",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4736",
    "ville":"Saint-Louis-du-Ha! Ha!",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1344"
  },
  {
    "ID":4410,
    "nom_corrige2":"Corinne Marquis",
    "nom_famille":"Marquis",
    "titre_genre2":"Conseillère",
    "remuneration":"3156",
    "allocation":"1578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4734",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":4411,
    "nom_corrige2":"Mélissa Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"3156",
    "allocation":"1578",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4734",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":4412,
    "nom_corrige2":"Richard Lefrançois",
    "nom_famille":"Lefrançois",
    "titre_genre2":"Conseiller",
    "remuneration":"3153",
    "allocation":"1576",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4729",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":4413,
    "nom_corrige2":"Anny Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseillère",
    "remuneration":"3156",
    "allocation":"1572",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4728",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":4414,
    "nom_corrige2":"Katie Bossé",
    "nom_famille":"Bossé",
    "titre_genre2":"Conseillère",
    "remuneration":"3156",
    "allocation":"1572",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4728",
    "ville":"Saint-Marc-du-Lac-Long",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"386"
  },
  {
    "ID":4415,
    "nom_corrige2":"Mario St-Louis",
    "nom_famille":"St-Louis",
    "titre_genre2":"Maire",
    "remuneration":"3151",
    "allocation":"1575",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4726",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4416,
    "nom_corrige2":"Daniel Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseiller",
    "remuneration":"3150",
    "allocation":"1575",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4725",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":4417,
    "nom_corrige2":"Francis Lehoux",
    "nom_famille":"Lehoux",
    "titre_genre2":"Conseiller",
    "remuneration":"3150",
    "allocation":"1575",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4725",
    "ville":"Saint-Julien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":4418,
    "nom_corrige2":"Alex Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"3147",
    "allocation":"1574",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4721",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":4419,
    "nom_corrige2":"Steven Langlais",
    "nom_famille":"Langlais",
    "titre_genre2":"Conseiller",
    "remuneration":"3147",
    "allocation":"1574",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4721",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":4420,
    "nom_corrige2":"Patrick Salvas",
    "nom_famille":"Salvas",
    "titre_genre2":"Conseiller",
    "remuneration":"3147",
    "allocation":"1573",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4720",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":4421,
    "nom_corrige2":"Philippe Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3147",
    "allocation":"1573",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4720",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":4422,
    "nom_corrige2":"Sylvie fafard",
    "nom_famille":"fafard",
    "titre_genre2":"Conseillère",
    "remuneration":"3147",
    "allocation":"1573",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4720",
    "ville":"Saint-Nazaire-d'Acton",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"897"
  },
  {
    "ID":4423,
    "nom_corrige2":"Valérie Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"3143",
    "allocation":"1571",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4714",
    "ville":"Saint-Jacques-de-Leeds",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"745"
  },
  {
    "ID":4424,
    "nom_corrige2":"Lucie Crête",
    "nom_famille":"Crête",
    "titre_genre2":"Conseillère",
    "remuneration":"3136",
    "allocation":"1568",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4704",
    "ville":"Saint-Louis-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4425,
    "nom_corrige2":"Marc Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"3132",
    "allocation":"1566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4698",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":4426,
    "nom_corrige2":"Jonathan Morgan",
    "nom_famille":"Morgan",
    "titre_genre2":"Conseiller",
    "remuneration":"3132",
    "allocation":"1566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4698",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":4427,
    "nom_corrige2":"Carole Brandt",
    "nom_famille":"Brandt",
    "titre_genre2":"Conseillère",
    "remuneration":"3132",
    "allocation":"1566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4698",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":4428,
    "nom_corrige2":"Danny Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"3132",
    "allocation":"1566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4698",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":4429,
    "nom_corrige2":"Tamara Rathwell",
    "nom_famille":"Rathwell",
    "titre_genre2":"Conseillère",
    "remuneration":"3132",
    "allocation":"1566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4698",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":4430,
    "nom_corrige2":"Richard E. Dubeau",
    "nom_famille":"E. Dubeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3132",
    "allocation":"1566",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4698",
    "ville":"Arundel",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"595"
  },
  {
    "ID":4431,
    "nom_corrige2":"David Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3075",
    "allocation":"1539",
    "remuneration2":"56,00$",
    "allocation2":"28,00$",
    "total":"4698",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":4432,
    "nom_corrige2":"Réjean Boulanger",
    "nom_famille":"Boulanger",
    "titre_genre2":"Conseiller",
    "remuneration":"2847",
    "allocation":"1423",
    "remuneration2":"281,00$",
    "allocation2":"142,00$",
    "total":"4693",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":4433,
    "nom_corrige2":"Réal Daigle",
    "nom_famille":"Daigle",
    "titre_genre2":"Conseiller",
    "remuneration":"3127",
    "allocation":"1564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4691",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":4434,
    "nom_corrige2":"Martin Trucotte",
    "nom_famille":"Trucotte",
    "titre_genre2":"Conseiller",
    "remuneration":"3127",
    "allocation":"1564",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4691",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":4435,
    "nom_corrige2":"Pascal Corriveau",
    "nom_famille":"Corriveau",
    "titre_genre2":"Conseiller",
    "remuneration":"3125",
    "allocation":"1563",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4688",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":4436,
    "nom_corrige2":"Rémi Kelley",
    "nom_famille":"Kelley",
    "titre_genre2":"Conseiller",
    "remuneration":"3125",
    "allocation":"1563",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4688",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":4437,
    "nom_corrige2":"Ronald Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"3125",
    "allocation":"1563",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4688",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":4438,
    "nom_corrige2":"Yolande Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseillère",
    "remuneration":"3274",
    "allocation":"1412",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4686",
    "ville":"Saint-Didace",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"760"
  },
  {
    "ID":4439,
    "nom_corrige2":"Linda Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"3282",
    "allocation":"1404",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4686",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":4440,
    "nom_corrige2":"Geneviève Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"3121",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4681",
    "ville":"La Patrie",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"828"
  },
  {
    "ID":4441,
    "nom_corrige2":"Christine La Roche",
    "nom_famille":"La Roche",
    "titre_genre2":"Conseillère",
    "remuneration":"3119",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4679",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4442,
    "nom_corrige2":"Daniel Rivet",
    "nom_famille":"Rivet",
    "titre_genre2":"Conseiller",
    "remuneration":"3119",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4679",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4443,
    "nom_corrige2":"Dylan Bockus",
    "nom_famille":"Bockus",
    "titre_genre2":"Conseiller",
    "remuneration":"3119",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4679",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4444,
    "nom_corrige2":"Émilie Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"3119",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4679",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4445,
    "nom_corrige2":"France Groulx",
    "nom_famille":"Groulx",
    "titre_genre2":"Conseillère",
    "remuneration":"3119",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4679",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4446,
    "nom_corrige2":"Luc Courville",
    "nom_famille":"Courville",
    "titre_genre2":"Conseiller",
    "remuneration":"3119",
    "allocation":"1560",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4679",
    "ville":"Bedford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4447,
    "nom_corrige2":"Claudia Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"3117",
    "allocation":"1559",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4676",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":4448,
    "nom_corrige2":"Francis Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"3117",
    "allocation":"1559",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4676",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":4449,
    "nom_corrige2":"Philippe Jacques",
    "nom_famille":"Jacques",
    "titre_genre2":"Conseiller",
    "remuneration":"3117",
    "allocation":"1559",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4676",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":4450,
    "nom_corrige2":"Véronique Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"3117",
    "allocation":"1559",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4676",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":4451,
    "nom_corrige2":"Yvan Paradis",
    "nom_famille":"Paradis",
    "titre_genre2":"Conseiller",
    "remuneration":"3117",
    "allocation":"1559",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4676",
    "ville":"Saint-Sébastien",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"728"
  },
  {
    "ID":4452,
    "nom_corrige2":"Sébastien Lamarre",
    "nom_famille":"Lamarre",
    "titre_genre2":"Conseiller",
    "remuneration":"3206",
    "allocation":"1464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4670",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":4453,
    "nom_corrige2":"Mélyssa Talbot-Blais",
    "nom_famille":"Talbot-Blais",
    "titre_genre2":"Conseillère",
    "remuneration":"3109",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4663",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":4454,
    "nom_corrige2":"Chantal Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseillère",
    "remuneration":"3109",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4663",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":4455,
    "nom_corrige2":"Jean-Yves Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"3109",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4663",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":4456,
    "nom_corrige2":"Sandra Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseillère",
    "remuneration":"3109",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4663",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":4457,
    "nom_corrige2":"Michel Néron",
    "nom_famille":"Néron",
    "titre_genre2":"Conseiller",
    "remuneration":"3108",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4662",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":4458,
    "nom_corrige2":"Sylvie Brassard",
    "nom_famille":"Brassard",
    "titre_genre2":"Conseillère",
    "remuneration":"3108",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4662",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":4459,
    "nom_corrige2":"Sophie Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"3108",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4662",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":4460,
    "nom_corrige2":"Janye Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"3108",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4662",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":4461,
    "nom_corrige2":"Jacques Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"3108",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4662",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":4462,
    "nom_corrige2":"Marc Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"3108",
    "allocation":"1554",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4662",
    "ville":"Saint-Charles-de-Bourget",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"819"
  },
  {
    "ID":4463,
    "nom_corrige2":"Pierre Provost",
    "nom_famille":"Provost",
    "titre_genre2":"Conseiller",
    "remuneration":"2805",
    "allocation":"1403",
    "remuneration2":"290,00$",
    "allocation2":"145,00$",
    "total":"4643",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":4464,
    "nom_corrige2":"Louis Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"3075",
    "allocation":"1539",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4614",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":4465,
    "nom_corrige2":"Daniel Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"3075",
    "allocation":"1539",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4614",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":4466,
    "nom_corrige2":"Mario Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"3075",
    "allocation":"1539",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4614",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":4467,
    "nom_corrige2":"Paul Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"3075",
    "allocation":"1539",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4614",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":4468,
    "nom_corrige2":"Katy Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"3075",
    "allocation":"1539",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4614",
    "ville":"Marston",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"810"
  },
  {
    "ID":4469,
    "nom_corrige2":"Jacques Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Conseiller",
    "remuneration":"2369",
    "allocation":"1159",
    "remuneration2":"722,00$",
    "allocation2":"360,00$",
    "total":"4610",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":4470,
    "nom_corrige2":"Ghislaine Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Conseillère",
    "remuneration":"2833",
    "allocation":"1416",
    "remuneration2":"238,00$",
    "allocation2":"119,00$",
    "total":"4606",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":4471,
    "nom_corrige2":"Jérome Petit",
    "nom_famille":"Petit",
    "titre_genre2":"Conseiller",
    "remuneration":"3066",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4599",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":4472,
    "nom_corrige2":"Michel Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"3066",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4599",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":4473,
    "nom_corrige2":"Joël Jobin",
    "nom_famille":"Jobin",
    "titre_genre2":"Conseiller",
    "remuneration":"3066",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4599",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":4474,
    "nom_corrige2":"Manon Planté",
    "nom_famille":"Planté",
    "titre_genre2":"Conseillère",
    "remuneration":"3066",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4599",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":4475,
    "nom_corrige2":"Jesen Pomerleau",
    "nom_famille":"Pomerleau",
    "titre_genre2":"Conseiller",
    "remuneration":"3156",
    "allocation":"1441",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4597",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":4476,
    "nom_corrige2":"Lucie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"3526",
    "allocation":"1065",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4591",
    "ville":"Lyster",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1699"
  },
  {
    "ID":4477,
    "nom_corrige2":"Suzanne Casavant",
    "nom_famille":"Casavant",
    "titre_genre2":"Conseillère",
    "remuneration":"2745",
    "allocation":"1845",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4590",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4478,
    "nom_corrige2":"Nancy Malenfant",
    "nom_famille":"Malenfant",
    "titre_genre2":"Conseillère",
    "remuneration":"3130",
    "allocation":"1460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4590",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":4479,
    "nom_corrige2":"Charles Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"3058",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4587",
    "ville":"Tingwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1562"
  },
  {
    "ID":4480,
    "nom_corrige2":"Véronik Rioux-Pin",
    "nom_famille":"Rioux-Pin",
    "titre_genre2":"Conseillère",
    "remuneration":"3058",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4587",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"416"
  },
  {
    "ID":4481,
    "nom_corrige2":"André Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"3058",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4587",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"416"
  },
  {
    "ID":4482,
    "nom_corrige2":"Daniel Morais",
    "nom_famille":"Morais",
    "titre_genre2":"Conseiller",
    "remuneration":"3058",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4587",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"416"
  },
  {
    "ID":4483,
    "nom_corrige2":"Erick Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseiller",
    "remuneration":"3058",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4587",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"416"
  },
  {
    "ID":4484,
    "nom_corrige2":"Sylvain Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"3058",
    "allocation":"1529",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4587",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"416"
  },
  {
    "ID":4485,
    "nom_corrige2":"Lucien Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"3056",
    "allocation":"1528",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4584",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":4486,
    "nom_corrige2":"Claude Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Maire suppléant",
    "remuneration":"3043",
    "allocation":"1521",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4564",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":4487,
    "nom_corrige2":"Mélanie Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"2960",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":4488,
    "nom_corrige2":"Christian Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"2960",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":4489,
    "nom_corrige2":"Guylain Chamberland",
    "nom_famille":"Chamberland",
    "titre_genre2":"Conseiller",
    "remuneration":"2960",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":4490,
    "nom_corrige2":"Marie-Ève Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"2960",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":4491,
    "nom_corrige2":"Jean-François Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"2960",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":4492,
    "nom_corrige2":"Nicolas Guillemette",
    "nom_famille":"Guillemette",
    "titre_genre2":"Conseiller",
    "remuneration":"2960",
    "allocation":"1600",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Armagh",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1434"
  },
  {
    "ID":4493,
    "nom_corrige2":"Diane Soucy",
    "nom_famille":"Soucy",
    "titre_genre2":"Préfète suppléante",
    "remuneration":"3100",
    "allocation":"1460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":4494,
    "nom_corrige2":"Karine Dechamplain",
    "nom_famille":"Dechamplain",
    "titre_genre2":"Conseillère",
    "remuneration":"3100",
    "allocation":"1460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4560",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":4495,
    "nom_corrige2":"Robin Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseiller",
    "remuneration":"3130",
    "allocation":"1429",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4559",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":4496,
    "nom_corrige2":"David Trépanier",
    "nom_famille":"Trépanier",
    "titre_genre2":"Conseiller",
    "remuneration":"3130",
    "allocation":"1429",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4559",
    "ville":"Sainte-Clotilde-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"592"
  },
  {
    "ID":4497,
    "nom_corrige2":"Guillaume Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"3038",
    "allocation":"1519",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4557",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":4498,
    "nom_corrige2":"Jérôme Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"3038",
    "allocation":"1519",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4557",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":4499,
    "nom_corrige2":"Sébastien Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"3038",
    "allocation":"1519",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4557",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":4500,
    "nom_corrige2":"Yves Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseiller",
    "remuneration":"3038",
    "allocation":"1519",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4557",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":4501,
    "nom_corrige2":"Jean-Noel Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Conseiller",
    "remuneration":"3038",
    "allocation":"1519",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4557",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":4502,
    "nom_corrige2":"Linda Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseillère",
    "remuneration":"3038",
    "allocation":"1519",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4557",
    "ville":"Packington",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"595"
  },
  {
    "ID":4503,
    "nom_corrige2":"Frédéric Forgues",
    "nom_famille":"Forgues",
    "titre_genre2":"Conseiller",
    "remuneration":"3034",
    "allocation":"1517",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4551",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4504,
    "nom_corrige2":"Alain Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"2833",
    "allocation":"1416",
    "remuneration2":"200,00$",
    "allocation2":"100,00$",
    "total":"4549",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":4505,
    "nom_corrige2":"Fanny GOulet",
    "nom_famille":"GOulet",
    "titre_genre2":"Conseillère",
    "remuneration":"3031",
    "allocation":"1515",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4546",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":4506,
    "nom_corrige2":"Gabriel Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"3031",
    "allocation":"1515",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4546",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":4507,
    "nom_corrige2":"Josée Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"3031",
    "allocation":"1515",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4546",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":4508,
    "nom_corrige2":"Claire Leroux",
    "nom_famille":"Leroux",
    "titre_genre2":"Conseillère",
    "remuneration":"3031",
    "allocation":"1515",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4546",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":4509,
    "nom_corrige2":"Stephan Rhealt",
    "nom_famille":"Rhealt",
    "titre_genre2":"Conseiller",
    "remuneration":"3031",
    "allocation":"1515",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4546",
    "ville":"Landrienne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"931"
  },
  {
    "ID":4510,
    "nom_corrige2":"Carole Desbiens",
    "nom_famille":"Desbiens",
    "titre_genre2":"Conseillère",
    "remuneration":"3010",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4543",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":4511,
    "nom_corrige2":"Claudia Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"3010",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4543",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":4512,
    "nom_corrige2":"Jocelyn Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"3010",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4543",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":4513,
    "nom_corrige2":"Nicholas Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"3010",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4543",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":4514,
    "nom_corrige2":"Stéphanie Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"3010",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4543",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":4515,
    "nom_corrige2":"Richard Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"3010",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4543",
    "ville":"Saint-Honoré-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"801"
  },
  {
    "ID":4516,
    "nom_corrige2":"Luc Viens",
    "nom_famille":"Viens",
    "titre_genre2":"Conseiller",
    "remuneration":"3165",
    "allocation":"1370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4535",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":4517,
    "nom_corrige2":"Louis-David Bonin",
    "nom_famille":"Bonin",
    "titre_genre2":"Conseillère",
    "remuneration":"3021",
    "allocation":"1511",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4532",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":4518,
    "nom_corrige2":"Mélanie Raymond",
    "nom_famille":"Raymond",
    "titre_genre2":"Conseillère",
    "remuneration":"3021",
    "allocation":"1511",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4532",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":4519,
    "nom_corrige2":"Claude Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"3021",
    "allocation":"1511",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4532",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":4520,
    "nom_corrige2":"Ginette Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseillère",
    "remuneration":"3021",
    "allocation":"1511",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4532",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":4521,
    "nom_corrige2":"Jonathan Pépin",
    "nom_famille":"Pépin",
    "titre_genre2":"Conseiller",
    "remuneration":"3021",
    "allocation":"1511",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4532",
    "ville":"Saint-Benoît-Labre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1680"
  },
  {
    "ID":4522,
    "nom_corrige2":"Michel Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Conseiller",
    "remuneration":"3017",
    "allocation":"1509",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4526",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":4523,
    "nom_corrige2":"Jean Beaubien",
    "nom_famille":"Beaubien",
    "titre_genre2":"Conseiller",
    "remuneration":"2805",
    "allocation":"1403",
    "remuneration2":"193,00$",
    "allocation2":"97,00$",
    "total":"4498",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":4524,
    "nom_corrige2":"Gino Isabel",
    "nom_famille":"Isabel",
    "titre_genre2":"Conseiller",
    "remuneration":"2998",
    "allocation":"1499",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4497",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":4525,
    "nom_corrige2":"Philippe Boileau",
    "nom_famille":"Boileau",
    "titre_genre2":"Conseiller",
    "remuneration":"2826",
    "allocation":"1656",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4482",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":4526,
    "nom_corrige2":"Doris Moisan",
    "nom_famille":"Moisan",
    "titre_genre2":"Conseillère",
    "remuneration":"2989",
    "allocation":"1492",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4481",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":4527,
    "nom_corrige2":"Rose Lawlor",
    "nom_famille":"Lawlor",
    "titre_genre2":"Conseillère",
    "remuneration":"3029",
    "allocation":"1449",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4478",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":4528,
    "nom_corrige2":"Laurie-Ann Foucrault",
    "nom_famille":"Foucrault",
    "titre_genre2":"Conseillère",
    "remuneration":"3029",
    "allocation":"1449",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4478",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":4529,
    "nom_corrige2":"Robert Young",
    "nom_famille":"Young",
    "titre_genre2":"Conseiller",
    "remuneration":"3029",
    "allocation":"1449",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4478",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":4530,
    "nom_corrige2":"Laurent Marchal",
    "nom_famille":"Marchal",
    "titre_genre2":"Conseiller",
    "remuneration":"3029",
    "allocation":"1449",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4478",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":4531,
    "nom_corrige2":"Marcus Flynn",
    "nom_famille":"Flynn",
    "titre_genre2":"Conseiller",
    "remuneration":"3028",
    "allocation":"1448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4476",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":4532,
    "nom_corrige2":"Tanya Garrick-Rhicard",
    "nom_famille":"Garrick-Rhicard",
    "titre_genre2":"Conseillère",
    "remuneration":"3028",
    "allocation":"1448",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4476",
    "ville":"Stanbridge East",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"839"
  },
  {
    "ID":4533,
    "nom_corrige2":"Philippe Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"2983",
    "allocation":"1491",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4474",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":4534,
    "nom_corrige2":"Marc Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"2980",
    "allocation":"1460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4440",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":4535,
    "nom_corrige2":"Laurier Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseiller",
    "remuneration":"2754",
    "allocation":"1377",
    "remuneration2":"202,00$",
    "allocation2":"101,00$",
    "total":"4434",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":4536,
    "nom_corrige2":"Carole Dansereau",
    "nom_famille":"Dansereau",
    "titre_genre2":"Conseillère",
    "remuneration":"2951",
    "allocation":"1476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4427",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4537,
    "nom_corrige2":"Daniel Lanoue",
    "nom_famille":"Lanoue",
    "titre_genre2":"Conseiller",
    "remuneration":"2951",
    "allocation":"1476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4427",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4538,
    "nom_corrige2":"Jean-Pierre Morlot",
    "nom_famille":"Morlot",
    "titre_genre2":"Conseiller",
    "remuneration":"2951",
    "allocation":"1476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4427",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4539,
    "nom_corrige2":"Micheline Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseillère",
    "remuneration":"2951",
    "allocation":"1476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4427",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4540,
    "nom_corrige2":"Robert Gaboriault",
    "nom_famille":"Gaboriault",
    "titre_genre2":"Conseiller",
    "remuneration":"2951",
    "allocation":"1476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4427",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4541,
    "nom_corrige2":"Roger Santerre",
    "nom_famille":"Santerre",
    "titre_genre2":"Conseiller",
    "remuneration":"2951",
    "allocation":"1476",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4427",
    "ville":"Notre-Dame-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"704"
  },
  {
    "ID":4542,
    "nom_corrige2":"Noémie Ash",
    "nom_famille":"Ash",
    "titre_genre2":"Conseillère",
    "remuneration":"2945",
    "allocation":"1472",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4417",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":4543,
    "nom_corrige2":"Pierre Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"2945",
    "allocation":"1472",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4417",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":4544,
    "nom_corrige2":"François Clouâtre",
    "nom_famille":"Clouâtre",
    "titre_genre2":"Conseiller",
    "remuneration":"2945",
    "allocation":"1472",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4417",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":4545,
    "nom_corrige2":"Marie-Lee Therien",
    "nom_famille":"Therien",
    "titre_genre2":"Conseillère",
    "remuneration":"2945",
    "allocation":"1472",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4417",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":4546,
    "nom_corrige2":"Silvie Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"2957",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4415",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":4547,
    "nom_corrige2":"Christiane Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"2957",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4415",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":4548,
    "nom_corrige2":"Pascale Brouillette",
    "nom_famille":"Brouillette",
    "titre_genre2":"Conseillère",
    "remuneration":"2957",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4415",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":4549,
    "nom_corrige2":"Stéphane Fraser",
    "nom_famille":"Fraser",
    "titre_genre2":"Conseiller",
    "remuneration":"2957",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4415",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":4550,
    "nom_corrige2":"Véronique Béliveau",
    "nom_famille":"Béliveau",
    "titre_genre2":"Conseillère",
    "remuneration":"2957",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4415",
    "ville":"Notre-Dame-du-Portage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1336"
  },
  {
    "ID":4551,
    "nom_corrige2":"Sylvain Garant",
    "nom_famille":"Garant",
    "titre_genre2":"Conseiller",
    "remuneration":"2942",
    "allocation":"1471",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4413",
    "ville":"Saint-Pierre-de-Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"914"
  },
  {
    "ID":4552,
    "nom_corrige2":"Élyse Fafard",
    "nom_famille":"Fafard",
    "titre_genre2":"Conseillère",
    "remuneration":"2937",
    "allocation":"1469",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4406",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":4553,
    "nom_corrige2":"André Loubier",
    "nom_famille":"Loubier",
    "titre_genre2":"Conseiller",
    "remuneration":"2936",
    "allocation":"1468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4404",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":4554,
    "nom_corrige2":"Josianne Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseillère",
    "remuneration":"2936",
    "allocation":"1468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4404",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":4555,
    "nom_corrige2":"Maxime Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"2936",
    "allocation":"1468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4404",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":4556,
    "nom_corrige2":"Sylvia Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"2936",
    "allocation":"1468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4404",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":4557,
    "nom_corrige2":"Pierre Lantagne",
    "nom_famille":"Lantagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2936",
    "allocation":"1468",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4404",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":4558,
    "nom_corrige2":"Jacques Dussault",
    "nom_famille":"Dussault",
    "titre_genre2":"Conseiller",
    "remuneration":"2928",
    "allocation":"1464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4392",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":4559,
    "nom_corrige2":"Martine Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"2928",
    "allocation":"1464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4392",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":4560,
    "nom_corrige2":"René Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"2928",
    "allocation":"1464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4392",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":4561,
    "nom_corrige2":"Sylvie Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"2928",
    "allocation":"1464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4392",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":4562,
    "nom_corrige2":"Laurent Marcotte",
    "nom_famille":"Marcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"2928",
    "allocation":"1464",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4392",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":4563,
    "nom_corrige2":"Gilles Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Conseiller",
    "remuneration":"3057",
    "allocation":"1326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4383",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":4564,
    "nom_corrige2":"Jean-René Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"3057",
    "allocation":"1326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4383",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":4565,
    "nom_corrige2":"Patrick Feeny",
    "nom_famille":"Feeny",
    "titre_genre2":"Conseiller",
    "remuneration":"3057",
    "allocation":"1326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4383",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":4566,
    "nom_corrige2":"Pierre Laramée",
    "nom_famille":"Laramée",
    "titre_genre2":"Conseiller",
    "remuneration":"3057",
    "allocation":"1326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4383",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":4567,
    "nom_corrige2":"Yvan St-Amour",
    "nom_famille":"St-Amour",
    "titre_genre2":"Conseiller",
    "remuneration":"3057",
    "allocation":"1326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4383",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":4568,
    "nom_corrige2":"Jeannot Emond",
    "nom_famille":"Emond",
    "titre_genre2":"Conseiller",
    "remuneration":"3057",
    "allocation":"1326",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4383",
    "ville":"Egan-Sud",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"536"
  },
  {
    "ID":4569,
    "nom_corrige2":"Ghislain Campagne",
    "nom_famille":"Campagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2917",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4375",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":4570,
    "nom_corrige2":"Brent Maxwell",
    "nom_famille":"Maxwell",
    "titre_genre2":"Conseiller",
    "remuneration":"2917",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4375",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":4571,
    "nom_corrige2":"Gisèle Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseillère",
    "remuneration":"2917",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4375",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":4572,
    "nom_corrige2":"Pascal Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2917",
    "allocation":"1458",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4375",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":4573,
    "nom_corrige2":"Pierre Grondines",
    "nom_famille":"Grondines",
    "titre_genre2":"Conseiller",
    "remuneration":"3142",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4368",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":4574,
    "nom_corrige2":"Gaétan Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseiller",
    "remuneration":"1643",
    "allocation":"822,00$",
    "remuneration2":"825,00$",
    "allocation2":"1069",
    "total":"4359",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":4575,
    "nom_corrige2":"Shawn Brazel",
    "nom_famille":"Brazel",
    "titre_genre2":"Conseiller",
    "remuneration":"2903",
    "allocation":"1452",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4355",
    "ville":"Saint-Isidore-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"727"
  },
  {
    "ID":4576,
    "nom_corrige2":"Hélène Durette",
    "nom_famille":"Durette",
    "titre_genre2":"Conseillère",
    "remuneration":"2940",
    "allocation":"1406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4346",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":4577,
    "nom_corrige2":"Mélissa Boucher Caron",
    "nom_famille":"Boucher Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"2940",
    "allocation":"1406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4346",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":4578,
    "nom_corrige2":"Josée Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"2940",
    "allocation":"1406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4346",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":4579,
    "nom_corrige2":"Guy Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseiller",
    "remuneration":"2940",
    "allocation":"1406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4346",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":4580,
    "nom_corrige2":"Katy Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2940",
    "allocation":"1406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4346",
    "ville":"Saint-Elzéar-de-Témiscouata",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"339"
  },
  {
    "ID":4581,
    "nom_corrige2":"Patricia Gardner",
    "nom_famille":"Gardner",
    "titre_genre2":"Conseillère",
    "remuneration":"2760",
    "allocation":"1380",
    "remuneration2":"133,00$",
    "allocation2":"67,00$",
    "total":"4340",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":4582,
    "nom_corrige2":"Samuel Brault",
    "nom_famille":"Brault",
    "titre_genre2":"Conseiller",
    "remuneration":"2886",
    "allocation":"1443",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4329",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":4583,
    "nom_corrige2":"Patrick Godin",
    "nom_famille":"Godin",
    "titre_genre2":"Conseiller",
    "remuneration":"3169",
    "allocation":"1159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4328",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":4584,
    "nom_corrige2":"Alain Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseiller",
    "remuneration":"2880",
    "allocation":"1440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4320",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":4585,
    "nom_corrige2":"André Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"2880",
    "allocation":"1440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4320",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":4586,
    "nom_corrige2":"Jason Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"2880",
    "allocation":"1440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4320",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":4587,
    "nom_corrige2":"Valmond Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"2880",
    "allocation":"1440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4320",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":4588,
    "nom_corrige2":"Stéphane Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"2880",
    "allocation":"1440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4320",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":4589,
    "nom_corrige2":"François Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"2880",
    "allocation":"1440",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4320",
    "ville":"Sacré-Coeur-de-Jésus",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"573"
  },
  {
    "ID":4590,
    "nom_corrige2":"David Boissonneault",
    "nom_famille":"Boissonneault",
    "titre_genre2":"Conseiller",
    "remuneration":"3340",
    "allocation":"972,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4312",
    "ville":"Lyster",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1699"
  },
  {
    "ID":4591,
    "nom_corrige2":"André Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"2085",
    "allocation":"1042",
    "remuneration2":"605,00$",
    "allocation2":"578,00$",
    "total":"4310",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":4592,
    "nom_corrige2":"Pascal Bellefeuille",
    "nom_famille":"Bellefeuille",
    "titre_genre2":"Conseiller",
    "remuneration":"2688",
    "allocation":"1344",
    "remuneration2":"268,00$",
    "allocation2":"0",
    "total":"4300",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":4593,
    "nom_corrige2":"Donald Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseillère",
    "remuneration":"3067",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4293",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":4594,
    "nom_corrige2":"Anthony Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"2904",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4291",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":4595,
    "nom_corrige2":"Johanne Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"2904",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4291",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":4596,
    "nom_corrige2":"Rémi Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseiller",
    "remuneration":"2904",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4291",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":4597,
    "nom_corrige2":"Charles-Étienne Beaudet",
    "nom_famille":"Beaudet",
    "titre_genre2":"Conseiller",
    "remuneration":"2903",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4290",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":4598,
    "nom_corrige2":"Maxime Guimond",
    "nom_famille":"Guimond",
    "titre_genre2":"Conseiller",
    "remuneration":"2903",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4290",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":4599,
    "nom_corrige2":"Sophie Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"2903",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4290",
    "ville":"Leclercville",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"516"
  },
  {
    "ID":4600,
    "nom_corrige2":"Isabelle Fortin-Bélanger",
    "nom_famille":"Fortin-Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"2826",
    "allocation":"1461",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4287",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":4601,
    "nom_corrige2":"Laurence Bousquet",
    "nom_famille":"Bousquet",
    "titre_genre2":"Conseillère",
    "remuneration":"2857",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4285",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":4602,
    "nom_corrige2":"Regis Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"2856",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4284",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":4603,
    "nom_corrige2":"Sebastien Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"2856",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4284",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":4604,
    "nom_corrige2":"Marc Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"2856",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4284",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":4605,
    "nom_corrige2":"Marc Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"2856",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4284",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":4606,
    "nom_corrige2":"Robin Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseiller",
    "remuneration":"2856",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4284",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":4607,
    "nom_corrige2":"Yannick Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"2856",
    "allocation":"1428",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4284",
    "ville":"Saint-Arsène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1255"
  },
  {
    "ID":4608,
    "nom_corrige2":"Roger Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2961",
    "allocation":"1320",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4281",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":4609,
    "nom_corrige2":"Claude Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"2852",
    "allocation":"1426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4278",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":4610,
    "nom_corrige2":"Joël Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"2852",
    "allocation":"1426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4278",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":4611,
    "nom_corrige2":"Marc Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"2852",
    "allocation":"1426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4278",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":4612,
    "nom_corrige2":"Paul Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"2852",
    "allocation":"1426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4278",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":4613,
    "nom_corrige2":"Steeve Santerre",
    "nom_famille":"Santerre",
    "titre_genre2":"Conseiller",
    "remuneration":"2852",
    "allocation":"1426",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4278",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":4614,
    "nom_corrige2":"Jean-Guy St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"2850",
    "allocation":"1425",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4275",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":4615,
    "nom_corrige2":"Jean Jr. Binette",
    "nom_famille":"Binette",
    "titre_genre2":"Conseiller",
    "remuneration":"2847",
    "allocation":"1423",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4270",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":4616,
    "nom_corrige2":"Ghislain Quintal",
    "nom_famille":"Quintal",
    "titre_genre2":"Conseiller",
    "remuneration":"2863",
    "allocation":"1405",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4268",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":4617,
    "nom_corrige2":"Éric Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"2863",
    "allocation":"1405",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4268",
    "ville":"Saint-Ignace-de-Stanbridge",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"715"
  },
  {
    "ID":4618,
    "nom_corrige2":"Carl Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Conseiller",
    "remuneration":"2844",
    "allocation":"1422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4266",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":4619,
    "nom_corrige2":"Christian Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"2844",
    "allocation":"1422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4266",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":4620,
    "nom_corrige2":"Donald Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2844",
    "allocation":"1422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4266",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":4621,
    "nom_corrige2":"Ghislain Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"2844",
    "allocation":"1422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4266",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":4622,
    "nom_corrige2":"Gilles St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"2844",
    "allocation":"1422",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4266",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":4623,
    "nom_corrige2":"Barbara Talbot",
    "nom_famille":"Talbot",
    "titre_genre2":"Conseillère",
    "remuneration":"2843",
    "allocation":"1421",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4264",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4624,
    "nom_corrige2":"Bruno Delorme",
    "nom_famille":"Delorme",
    "titre_genre2":"Conseiller",
    "remuneration":"2843",
    "allocation":"1421",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4264",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4625,
    "nom_corrige2":"Guillaume Camille",
    "nom_famille":"Camille",
    "titre_genre2":"Conseiller",
    "remuneration":"2843",
    "allocation":"1421",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4264",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4626,
    "nom_corrige2":"Martin Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"2843",
    "allocation":"1421",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4264",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4627,
    "nom_corrige2":"Normande Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"2843",
    "allocation":"1421",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4264",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4628,
    "nom_corrige2":"Serge Blanchard",
    "nom_famille":"Blanchard",
    "titre_genre2":"Conseiller",
    "remuneration":"2843",
    "allocation":"1421",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4264",
    "ville":"Warden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"396"
  },
  {
    "ID":4629,
    "nom_corrige2":"Caroline Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseillère",
    "remuneration":"2796",
    "allocation":"1460",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4256",
    "ville":"Saint-Zénon-du-Lac-Humqui",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"365"
  },
  {
    "ID":4630,
    "nom_corrige2":"Benoit St-Jean",
    "nom_famille":"St-Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"2833",
    "allocation":"1416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4249",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":4631,
    "nom_corrige2":"Guy Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"2833",
    "allocation":"1416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4249",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":4632,
    "nom_corrige2":"Hélène Méthot",
    "nom_famille":"Méthot",
    "titre_genre2":"Conseillère",
    "remuneration":"2833",
    "allocation":"1416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4249",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":4633,
    "nom_corrige2":"Josianne Sirois",
    "nom_famille":"Sirois",
    "titre_genre2":"Conseillère",
    "remuneration":"2833",
    "allocation":"1416",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4249",
    "ville":"Saint-André-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"665"
  },
  {
    "ID":4634,
    "nom_corrige2":"Ghislain Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"2830",
    "allocation":"1415",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4245",
    "ville":"Mont-Carmel",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1165"
  },
  {
    "ID":4635,
    "nom_corrige2":"Gertie Cavalier",
    "nom_famille":"Cavalier",
    "titre_genre2":"Conseillère",
    "remuneration":"2826",
    "allocation":"1413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4239",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":4636,
    "nom_corrige2":"Rodrigue Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"2826",
    "allocation":"1413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4239",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":4637,
    "nom_corrige2":"Simon-Pierre Trahan",
    "nom_famille":"Trahan",
    "titre_genre2":"Conseiller",
    "remuneration":"2826",
    "allocation":"1413",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4239",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":4638,
    "nom_corrige2":"Vincent Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"2865",
    "allocation":"1370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4235",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":4639,
    "nom_corrige2":"Isabelle Houle",
    "nom_famille":"Houle",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":4640,
    "nom_corrige2":"Mélanie Hardy",
    "nom_famille":"Hardy",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":4641,
    "nom_corrige2":"Sylvie Viens",
    "nom_famille":"Viens",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":4642,
    "nom_corrige2":"Véronique Dufresne",
    "nom_famille":"Dufresne",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":4643,
    "nom_corrige2":"William McMahon",
    "nom_famille":"McMahon",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Marcel-de-Richelieu",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"506"
  },
  {
    "ID":4644,
    "nom_corrige2":"Manon Reed",
    "nom_famille":"Reed",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4645,
    "nom_corrige2":"Samuel St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4646,
    "nom_corrige2":"Raymond Paulhus",
    "nom_famille":"Paulhus",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4647,
    "nom_corrige2":"Sylvie Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4648,
    "nom_corrige2":"Yanick Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1410",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4231",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4649,
    "nom_corrige2":"Eden Lauzon",
    "nom_famille":"Lauzon",
    "titre_genre2":"Conseillère",
    "remuneration":"2565",
    "allocation":"1665",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4230",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4650,
    "nom_corrige2":"Marie-Soleil Beauregard",
    "nom_famille":"Beauregard",
    "titre_genre2":"Conseillère",
    "remuneration":"3069",
    "allocation":"1159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":4651,
    "nom_corrige2":"Caroline Chayer",
    "nom_famille":"Chayer",
    "titre_genre2":"Conseillère",
    "remuneration":"2820",
    "allocation":"1408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":4652,
    "nom_corrige2":"Claude Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseiller",
    "remuneration":"2820",
    "allocation":"1408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":4653,
    "nom_corrige2":"Grégoire Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"2820",
    "allocation":"1408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":4654,
    "nom_corrige2":"Janic Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"2820",
    "allocation":"1408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":4655,
    "nom_corrige2":"Jean Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseiller",
    "remuneration":"2820",
    "allocation":"1408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":4656,
    "nom_corrige2":"Samuel Choquette",
    "nom_famille":"Choquette",
    "titre_genre2":"Conseiller",
    "remuneration":"2820",
    "allocation":"1408",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4228",
    "ville":"Ferland-et-Boilleau",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"723"
  },
  {
    "ID":4657,
    "nom_corrige2":"Annie St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseillère",
    "remuneration":"2813",
    "allocation":"1406",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4219",
    "ville":"Dupuy",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"961"
  },
  {
    "ID":4658,
    "nom_corrige2":"Geneviève Marchand",
    "nom_famille":"Marchand",
    "titre_genre2":"Conseillère",
    "remuneration":"2815",
    "allocation":"1402",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4217",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":4659,
    "nom_corrige2":"Marie-Joelle Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Conseillère",
    "remuneration":"2811",
    "allocation":"1405",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4216",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":4660,
    "nom_corrige2":"Céline Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseillère",
    "remuneration":"2735",
    "allocation":"1367",
    "remuneration2":"55,00$",
    "allocation2":"53,00$",
    "total":"4210",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":4661,
    "nom_corrige2":"Éric Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"2805",
    "allocation":"1403",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4208",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":4662,
    "nom_corrige2":"Georges Forcier",
    "nom_famille":"Forcier",
    "titre_genre2":"Conseiller",
    "remuneration":"2805",
    "allocation":"1403",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4208",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":4663,
    "nom_corrige2":"Karine Descheneaux",
    "nom_famille":"Descheneaux",
    "titre_genre2":"Conseillère",
    "remuneration":"2805",
    "allocation":"1403",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4208",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":4664,
    "nom_corrige2":"Mélanie Parenteau",
    "nom_famille":"Parenteau",
    "titre_genre2":"Conseillère",
    "remuneration":"2805",
    "allocation":"1403",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4208",
    "ville":"Saint-Gérard-Majella",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"250"
  },
  {
    "ID":4665,
    "nom_corrige2":"Denis Vel",
    "nom_famille":"Vel",
    "titre_genre2":"Conseiller",
    "remuneration":"2550",
    "allocation":"1650",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4200",
    "ville":"Sainte-Anne-de-la-Rochelle",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"614"
  },
  {
    "ID":4666,
    "nom_corrige2":"Anne-Marie Yeates Dubeau",
    "nom_famille":"Yeates Dubeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2562",
    "allocation":"1258",
    "remuneration2":"249,00$",
    "allocation2":"124,00$",
    "total":"4193",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":4667,
    "nom_corrige2":"Véronique Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"2815",
    "allocation":"1370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4185",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":4668,
    "nom_corrige2":"Cam Nguyen Le Phan",
    "nom_famille":"Nguyen Le Phan",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":4669,
    "nom_corrige2":"Christian Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":4670,
    "nom_corrige2":"Denis Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":4671,
    "nom_corrige2":"Isabelle Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":4672,
    "nom_corrige2":"Michel Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":4673,
    "nom_corrige2":"Stéphane Auclair",
    "nom_famille":"Auclair",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Notre-Dame-des-Pins",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1958"
  },
  {
    "ID":4674,
    "nom_corrige2":"Julien Chalifoux",
    "nom_famille":"Chalifoux",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":4675,
    "nom_corrige2":"Patrick Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":4676,
    "nom_corrige2":"Zacharie Cloutier-Julien",
    "nom_famille":"Cloutier-Julien",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":4677,
    "nom_corrige2":"Henri Lampron",
    "nom_famille":"Lampron",
    "titre_genre2":"Conseiller",
    "remuneration":"2774",
    "allocation":"1387",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4161",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":4678,
    "nom_corrige2":"Mélanie Lavallée",
    "nom_famille":"Lavallée",
    "titre_genre2":"Conseillère",
    "remuneration":"2771",
    "allocation":"1386",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4157",
    "ville":"Saint-Pierre",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"294"
  },
  {
    "ID":4679,
    "nom_corrige2":"Dolorès Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseillère",
    "remuneration":"2770",
    "allocation":"1385",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4155",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4680,
    "nom_corrige2":"Carole Santerre",
    "nom_famille":"Santerre",
    "titre_genre2":"Mairesse",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4681,
    "nom_corrige2":"Danielle Coutu",
    "nom_famille":"Coutu",
    "titre_genre2":"Conseillère",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":4682,
    "nom_corrige2":"Laurie Godin",
    "nom_famille":"Godin",
    "titre_genre2":"Conseillère",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":4683,
    "nom_corrige2":"Léon-Paul Darveau",
    "nom_famille":"Darveau",
    "titre_genre2":"Conseiller",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":4684,
    "nom_corrige2":"Martial St-Amand",
    "nom_famille":"St-Amand",
    "titre_genre2":"Conseiller",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":4685,
    "nom_corrige2":"Richard Duchesne",
    "nom_famille":"Duchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":4686,
    "nom_corrige2":"Roger Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"2768",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4152",
    "ville":"Saint-Thomas-Didyme",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"763"
  },
  {
    "ID":4687,
    "nom_corrige2":"Audrey Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Conseillère",
    "remuneration":"2767",
    "allocation":"1384",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4151",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":4688,
    "nom_corrige2":"Eric Mc Kay",
    "nom_famille":"Mc Kay",
    "titre_genre2":"Conseiller",
    "remuneration":"3147",
    "allocation":"999,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4146",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":4689,
    "nom_corrige2":"Ludovic Ellefsen",
    "nom_famille":"Ellefsen",
    "titre_genre2":"Conseiller",
    "remuneration":"2760",
    "allocation":"1380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4140",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":4690,
    "nom_corrige2":"Christiane Paquet",
    "nom_famille":"Paquet",
    "titre_genre2":"Conseillère",
    "remuneration":"2760",
    "allocation":"1380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4140",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":4691,
    "nom_corrige2":"Gaby Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2760",
    "allocation":"1380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4140",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":4692,
    "nom_corrige2":"Marie-Pierre Dubeau",
    "nom_famille":"Dubeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2760",
    "allocation":"1380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4140",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":4693,
    "nom_corrige2":"Sylvain Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2760",
    "allocation":"1380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4140",
    "ville":"Martinville",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"461"
  },
  {
    "ID":4694,
    "nom_corrige2":"Normand Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseiller",
    "remuneration":"3161",
    "allocation":"978,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4139",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":4695,
    "nom_corrige2":"Francine Brasseur",
    "nom_famille":"Brasseur",
    "titre_genre2":"Conseillère",
    "remuneration":"2756",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4134",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":4696,
    "nom_corrige2":"Gilbert Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseiller",
    "remuneration":"2756",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4134",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":4697,
    "nom_corrige2":"Pierre Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseiller",
    "remuneration":"2756",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4134",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":4698,
    "nom_corrige2":"Patrick Wolput",
    "nom_famille":"Wolput",
    "titre_genre2":"Conseiller",
    "remuneration":"2756",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4134",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":4699,
    "nom_corrige2":"Mickaël L. Giguère",
    "nom_famille":"L. Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"2756",
    "allocation":"1378",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4134",
    "ville":"Sainte-Christine",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"827"
  },
  {
    "ID":4700,
    "nom_corrige2":"Marie-Andrée Buteau",
    "nom_famille":"Buteau",
    "titre_genre2":"Conseillère",
    "remuneration":"2754",
    "allocation":"1377",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4131",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":4701,
    "nom_corrige2":"Jessica Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"2754",
    "allocation":"1377",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4131",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":4702,
    "nom_corrige2":"Jocelyn Béliveau",
    "nom_famille":"Béliveau",
    "titre_genre2":"Conseiller",
    "remuneration":"2754",
    "allocation":"1377",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4131",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":4703,
    "nom_corrige2":"Joey Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Conseiller",
    "remuneration":"2754",
    "allocation":"1377",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4131",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":4704,
    "nom_corrige2":"Marie-Josée Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2754",
    "allocation":"1377",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4131",
    "ville":"Saint-Benjamin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1208"
  },
  {
    "ID":4705,
    "nom_corrige2":"Roseline Laplante",
    "nom_famille":"Laplante",
    "titre_genre2":"Conseillère",
    "remuneration":"2767",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4128",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":4706,
    "nom_corrige2":"Chantal Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"2767",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4128",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":4707,
    "nom_corrige2":"Louis Bigué",
    "nom_famille":"Bigué",
    "titre_genre2":"Conseiller",
    "remuneration":"2767",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4128",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":4708,
    "nom_corrige2":"Lise Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseillère",
    "remuneration":"2767",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4128",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":4709,
    "nom_corrige2":"David Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2767",
    "allocation":"1360",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4127",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":4710,
    "nom_corrige2":"Gaétan Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"2751",
    "allocation":"1375",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4126",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":4711,
    "nom_corrige2":"Jocelyn Lantagne",
    "nom_famille":"Lantagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2751",
    "allocation":"1375",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4126",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":4712,
    "nom_corrige2":"Mathieu Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"2751",
    "allocation":"1375",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4126",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":4713,
    "nom_corrige2":"Yvon Lantagne",
    "nom_famille":"Lantagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2751",
    "allocation":"1375",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4126",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":4714,
    "nom_corrige2":"Johanne Sabourin",
    "nom_famille":"Sabourin",
    "titre_genre2":"Conseillère",
    "remuneration":"2751",
    "allocation":"1375",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4126",
    "ville":"Saint-Marc-de-Figuery",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"908"
  },
  {
    "ID":4715,
    "nom_corrige2":"Bernard Carey",
    "nom_famille":"Carey",
    "titre_genre2":"Conseiller",
    "remuneration":"2749",
    "allocation":"1374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4123",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":4716,
    "nom_corrige2":"Margaret Lefebvre-Macey",
    "nom_famille":"Lefebvre-Macey",
    "titre_genre2":"Conseillère",
    "remuneration":"2749",
    "allocation":"1374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4123",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":4717,
    "nom_corrige2":"Roger Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"2749",
    "allocation":"1374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4123",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":4718,
    "nom_corrige2":"François Prévost",
    "nom_famille":"Prévost",
    "titre_genre2":"Conseiller",
    "remuneration":"2749",
    "allocation":"1374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4123",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":4719,
    "nom_corrige2":"Éric Bissonnette",
    "nom_famille":"Bissonnette",
    "titre_genre2":"Maire suppléant",
    "remuneration":"2749",
    "allocation":"1374",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4123",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":4720,
    "nom_corrige2":"Craig Gabie",
    "nom_famille":"Gabie",
    "titre_genre2":"Conseiller",
    "remuneration":"2742",
    "allocation":"1380",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4122",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":4721,
    "nom_corrige2":"Joey Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseiller",
    "remuneration":"2892",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4118",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":4722,
    "nom_corrige2":"Conrad Guay",
    "nom_famille":"Guay",
    "titre_genre2":"Conseiller",
    "remuneration":"2745",
    "allocation":"1372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4117",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":4723,
    "nom_corrige2":"Gratien Aubé",
    "nom_famille":"Aubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2745",
    "allocation":"1372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4117",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":4724,
    "nom_corrige2":"Danye Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseillère",
    "remuneration":"2745",
    "allocation":"1372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4117",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":4725,
    "nom_corrige2":"Rémy Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"2745",
    "allocation":"1372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4117",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":4726,
    "nom_corrige2":"Marie-Paule Gaudreault",
    "nom_famille":"Gaudreault",
    "titre_genre2":"Conseillère",
    "remuneration":"2745",
    "allocation":"1372",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4117",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":4727,
    "nom_corrige2":"Eric Poisson",
    "nom_famille":"Poisson",
    "titre_genre2":"Conseiller",
    "remuneration":"2740",
    "allocation":"1370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4110",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":4728,
    "nom_corrige2":"Dominique Gingras",
    "nom_famille":"Gingras",
    "titre_genre2":"Conseiller",
    "remuneration":"2740",
    "allocation":"1370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4110",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":4729,
    "nom_corrige2":"Gilles Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"2740",
    "allocation":"1370",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4110",
    "ville":"Saint-Pierre-Baptiste",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"605"
  },
  {
    "ID":4730,
    "nom_corrige2":"Martine Lanctôt",
    "nom_famille":"Lanctôt",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4105",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":4731,
    "nom_corrige2":"Adrien Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4105",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":4732,
    "nom_corrige2":"Christiane Bonneau",
    "nom_famille":"Bonneau",
    "titre_genre2":"Conseillère",
    "remuneration":"2821",
    "allocation":"1284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4105",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":4733,
    "nom_corrige2":"Enzo Marceau",
    "nom_famille":"Marceau",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4105",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":4734,
    "nom_corrige2":"Joël Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4105",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":4735,
    "nom_corrige2":"Pierre Bellerose",
    "nom_famille":"Bellerose",
    "titre_genre2":"Conseiller",
    "remuneration":"2821",
    "allocation":"1284",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4105",
    "ville":"Saint-Camille",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"601"
  },
  {
    "ID":4736,
    "nom_corrige2":"Alcide Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Conseiller",
    "remuneration":"2735",
    "allocation":"1367",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4102",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":4737,
    "nom_corrige2":"Marie-Pier Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseillère",
    "remuneration":"2735",
    "allocation":"1367",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4102",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":4738,
    "nom_corrige2":"Julien Paradis",
    "nom_famille":"Paradis",
    "titre_genre2":"Conseiller",
    "remuneration":"2735",
    "allocation":"1367",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4102",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":4739,
    "nom_corrige2":"Michel Lalonde",
    "nom_famille":"Lalonde",
    "titre_genre2":"Conseiller",
    "remuneration":"2735",
    "allocation":"1367",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4102",
    "ville":"L'Avenir",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1422"
  },
  {
    "ID":4740,
    "nom_corrige2":"Claude Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"2727",
    "allocation":"1364",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4091",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":4741,
    "nom_corrige2":"Pascal Laverdiere",
    "nom_famille":"Laverdiere",
    "titre_genre2":"Conseiller",
    "remuneration":"2727",
    "allocation":"1364",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4091",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":4742,
    "nom_corrige2":"Christian Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"2727",
    "allocation":"1364",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4091",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":4743,
    "nom_corrige2":"Francis Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseiller",
    "remuneration":"2727",
    "allocation":"1364",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4091",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":4744,
    "nom_corrige2":"Berthold Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"2722",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4083",
    "ville":"Sainte-Jeanne-d'Arc",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1122"
  },
  {
    "ID":4745,
    "nom_corrige2":"Michel Chiasson",
    "nom_famille":"Chiasson",
    "titre_genre2":"Conseillère",
    "remuneration":"2722",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4083",
    "ville":"Sainte-Jeanne-d'Arc",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1122"
  },
  {
    "ID":4746,
    "nom_corrige2":"Pierre Boudreault",
    "nom_famille":"Boudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"2722",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4083",
    "ville":"Sainte-Jeanne-d'Arc",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1122"
  },
  {
    "ID":4747,
    "nom_corrige2":"Anny-Pier Routhier",
    "nom_famille":"Routhier",
    "titre_genre2":"Conseillère",
    "remuneration":"2722",
    "allocation":"1361",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4083",
    "ville":"Sainte-Jeanne-d'Arc",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1122"
  },
  {
    "ID":4748,
    "nom_corrige2":"Joane Rochon",
    "nom_famille":"Rochon",
    "titre_genre2":"Conseillère",
    "remuneration":"3002",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4078",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":4749,
    "nom_corrige2":"Michael Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"3002",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4078",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":4750,
    "nom_corrige2":"Réjeanne Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseillère",
    "remuneration":"3002",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4078",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":4751,
    "nom_corrige2":"Bernard Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseiller",
    "remuneration":"2718",
    "allocation":"1359",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4077",
    "ville":"Saint-Roch-Ouest",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"289"
  },
  {
    "ID":4752,
    "nom_corrige2":"Charles Smith",
    "nom_famille":"Smith",
    "titre_genre2":"Conseiller",
    "remuneration":"2718",
    "allocation":"1359",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4077",
    "ville":"Saint-Roch-Ouest",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"289"
  },
  {
    "ID":4753,
    "nom_corrige2":"Josianne Chayer",
    "nom_famille":"Chayer",
    "titre_genre2":"Conseillère",
    "remuneration":"2718",
    "allocation":"1359",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4077",
    "ville":"Saint-Roch-Ouest",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"289"
  },
  {
    "ID":4754,
    "nom_corrige2":"Francis Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"2718",
    "allocation":"1359",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4077",
    "ville":"Saint-Roch-Ouest",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"289"
  },
  {
    "ID":4755,
    "nom_corrige2":"Sylvain Lafortune",
    "nom_famille":"Lafortune",
    "titre_genre2":"Conseiller",
    "remuneration":"2718",
    "allocation":"1359",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4077",
    "ville":"Saint-Roch-Ouest",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"289"
  },
  {
    "ID":4756,
    "nom_corrige2":"Charles Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"2178",
    "allocation":"1089",
    "remuneration2":"540,00$",
    "allocation2":"270,00$",
    "total":"4077",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":4757,
    "nom_corrige2":"Bradford Cooke",
    "nom_famille":"Cooke",
    "titre_genre2":"Conseiller",
    "remuneration":"2807",
    "allocation":"1264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4071",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":4758,
    "nom_corrige2":"Guy Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"2807",
    "allocation":"1264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4071",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":4759,
    "nom_corrige2":"Josée Dupuis",
    "nom_famille":"Dupuis",
    "titre_genre2":"Conseillère",
    "remuneration":"2807",
    "allocation":"1264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4071",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":4760,
    "nom_corrige2":"Martin Meilleur",
    "nom_famille":"Meilleur",
    "titre_genre2":"Conseiller",
    "remuneration":"2807",
    "allocation":"1264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4071",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":4761,
    "nom_corrige2":"Sébastien Daudlin",
    "nom_famille":"Daudlin",
    "titre_genre2":"Conseiller",
    "remuneration":"2807",
    "allocation":"1264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4071",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":4762,
    "nom_corrige2":"Sébastien Desormeaux",
    "nom_famille":"Desormeaux",
    "titre_genre2":"Conseiller",
    "remuneration":"2807",
    "allocation":"1264",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4071",
    "ville":"Namur",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"638"
  },
  {
    "ID":4763,
    "nom_corrige2":"Jocelyn Faucher",
    "nom_famille":"Faucher",
    "titre_genre2":"Conseiller",
    "remuneration":"2842",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4068",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":4764,
    "nom_corrige2":"André Bujold",
    "nom_famille":"Bujold",
    "titre_genre2":"Conseiller",
    "remuneration":"2705",
    "allocation":"1353",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4058",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":4765,
    "nom_corrige2":"Marc-Olivier Poirier",
    "nom_famille":"Poirier",
    "titre_genre2":"Conseiller",
    "remuneration":"2705",
    "allocation":"1352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4057",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":4766,
    "nom_corrige2":"Mélanie Valois",
    "nom_famille":"Valois",
    "titre_genre2":"Conseillère",
    "remuneration":"2704",
    "allocation":"1352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4056",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":4767,
    "nom_corrige2":"Michel Massé",
    "nom_famille":"Massé",
    "titre_genre2":"Conseiller",
    "remuneration":"2704",
    "allocation":"1352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4056",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":4768,
    "nom_corrige2":"Caroline Aubin",
    "nom_famille":"Aubin",
    "titre_genre2":"Conseillère",
    "remuneration":"2699",
    "allocation":"1349",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4048",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":4769,
    "nom_corrige2":"Georgette Chapados",
    "nom_famille":"Chapados",
    "titre_genre2":"Conseillère",
    "remuneration":"2511",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4044",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":4770,
    "nom_corrige2":"Heather Imhoff",
    "nom_famille":"Imhoff",
    "titre_genre2":"Conseillère",
    "remuneration":"2511",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4044",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":4771,
    "nom_corrige2":"Jeffrey Vautier",
    "nom_famille":"Vautier",
    "titre_genre2":"Conseiller",
    "remuneration":"2511",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4044",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":4772,
    "nom_corrige2":"Marcel Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"2511",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4044",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":4773,
    "nom_corrige2":"Michael Hayes",
    "nom_famille":"Hayes",
    "titre_genre2":"Conseiller",
    "remuneration":"2511",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4044",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":4774,
    "nom_corrige2":"Nancy Skeene",
    "nom_famille":"Skeene",
    "titre_genre2":"Conseillère",
    "remuneration":"2511",
    "allocation":"1533",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4044",
    "ville":"Shigawake",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"332"
  },
  {
    "ID":4775,
    "nom_corrige2":"David Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Maire suppléant",
    "remuneration":"2566",
    "allocation":"1456",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4022",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":4776,
    "nom_corrige2":"Gilles Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"2792",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4018",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":4777,
    "nom_corrige2":"Alexandre Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"2675",
    "allocation":"1338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4013",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":4778,
    "nom_corrige2":"Alexandre Poupart",
    "nom_famille":"Poupart",
    "titre_genre2":"Conseiller",
    "remuneration":"2675",
    "allocation":"1338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4013",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":4779,
    "nom_corrige2":"Christiane Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseillère",
    "remuneration":"2675",
    "allocation":"1338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4013",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":4780,
    "nom_corrige2":"Jannys Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseillère",
    "remuneration":"2675",
    "allocation":"1338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4013",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":4781,
    "nom_corrige2":"Jonathan Baker",
    "nom_famille":"Baker",
    "titre_genre2":"Conseiller",
    "remuneration":"2675",
    "allocation":"1338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4013",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":4782,
    "nom_corrige2":"Marc Boiteau",
    "nom_famille":"Boiteau",
    "titre_genre2":"Conseiller",
    "remuneration":"2675",
    "allocation":"1338",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4013",
    "ville":"Lac-Delage",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"792"
  },
  {
    "ID":4783,
    "nom_corrige2":"Florence Duguay",
    "nom_famille":"Duguay",
    "titre_genre2":"Conseillère",
    "remuneration":"2672",
    "allocation":"1336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4008",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":4784,
    "nom_corrige2":"Jean-Marc Neveu",
    "nom_famille":"Neveu",
    "titre_genre2":"Conseiller",
    "remuneration":"2672",
    "allocation":"1336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4008",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":4785,
    "nom_corrige2":"Serge Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseiller",
    "remuneration":"2672",
    "allocation":"1336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4008",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":4786,
    "nom_corrige2":"Luc Raby",
    "nom_famille":"Raby",
    "titre_genre2":"Conseiller",
    "remuneration":"2672",
    "allocation":"1336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4008",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":4787,
    "nom_corrige2":"Michelle D'Amours",
    "nom_famille":"D'Amours",
    "titre_genre2":"Conseillère",
    "remuneration":"2672",
    "allocation":"1336",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4008",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":4788,
    "nom_corrige2":"Alain Castonguay",
    "nom_famille":"Castonguay",
    "titre_genre2":"Maire suppléant",
    "remuneration":"2666",
    "allocation":"1334",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4000",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":4789,
    "nom_corrige2":"Jean-Charles Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"2666",
    "allocation":"1334",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4000",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":4790,
    "nom_corrige2":"Jean-Marie Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"2666",
    "allocation":"1334",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4000",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":4791,
    "nom_corrige2":"Kristina Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"2666",
    "allocation":"1334",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4000",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":4792,
    "nom_corrige2":"Marco Lizotte",
    "nom_famille":"Lizotte",
    "titre_genre2":"Conseiller",
    "remuneration":"2666",
    "allocation":"1334",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4000",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":4793,
    "nom_corrige2":"Roland Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"2666",
    "allocation":"1334",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"4000",
    "ville":"Saint-Philippe-de-Néri",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"854"
  },
  {
    "ID":4794,
    "nom_corrige2":"Rock Lamontagne",
    "nom_famille":"Lamontagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2664",
    "allocation":"1332",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3996",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":4795,
    "nom_corrige2":"Sylvain Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseiller",
    "remuneration":"2664",
    "allocation":"1332",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3996",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":4796,
    "nom_corrige2":"François Page",
    "nom_famille":"Page",
    "titre_genre2":"Conseiller",
    "remuneration":"2333",
    "allocation":"1167",
    "remuneration2":"480,00$",
    "allocation2":"0",
    "total":"3980",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":4797,
    "nom_corrige2":"Louise Fay",
    "nom_famille":"Fay",
    "titre_genre2":"Conseillère",
    "remuneration":"2649",
    "allocation":"1325",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3974",
    "ville":"Saint-Boniface",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"5328"
  },
  {
    "ID":4798,
    "nom_corrige2":"Roger Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseiller",
    "remuneration":"2638",
    "allocation":"1319",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3957",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4799,
    "nom_corrige2":"Marc-Antoine Bellefroid",
    "nom_famille":"Bellefroid",
    "titre_genre2":"Conseiller",
    "remuneration":"2634",
    "allocation":"1317",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3951",
    "ville":"Pike River",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"494"
  },
  {
    "ID":4800,
    "nom_corrige2":"André Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"2917",
    "allocation":"1034",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3951",
    "ville":"Saint-Louis-de-Gonzague",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"389"
  },
  {
    "ID":4801,
    "nom_corrige2":"Christiane Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseillère",
    "remuneration":"2631",
    "allocation":"1316",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3947",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":4802,
    "nom_corrige2":"Sophie Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"2461",
    "allocation":"1471",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3932",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":4803,
    "nom_corrige2":"Nancy Grimard",
    "nom_famille":"Grimard",
    "titre_genre2":"Conseillère",
    "remuneration":"2586",
    "allocation":"1235",
    "remuneration2":"68,00$",
    "allocation2":"34,00$",
    "total":"3923",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":4804,
    "nom_corrige2":"Kévin Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2644",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3923",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":4805,
    "nom_corrige2":"Aurele Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"2597",
    "allocation":"1299",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3896",
    "ville":"Saint-Léon-le-Grand",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"984"
  },
  {
    "ID":4806,
    "nom_corrige2":"Krystelle Noël",
    "nom_famille":"Noël",
    "titre_genre2":"Conseillère",
    "remuneration":"2587",
    "allocation":"1294",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3881",
    "ville":"Saint-Malo",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"528"
  },
  {
    "ID":4807,
    "nom_corrige2":"Gilles Forcier",
    "nom_famille":"Forcier",
    "titre_genre2":"Conseiller",
    "remuneration":"2586",
    "allocation":"1293",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3879",
    "ville":"Saint-Bonaventure",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1078"
  },
  {
    "ID":4808,
    "nom_corrige2":"Yanick Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Maire suppléant",
    "remuneration":"2585",
    "allocation":"1293",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3878",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":4809,
    "nom_corrige2":"Annie Grandmont",
    "nom_famille":"Grandmont",
    "titre_genre2":"Conseillère",
    "remuneration":"2585",
    "allocation":"1293",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3878",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":4810,
    "nom_corrige2":"André Gélinas",
    "nom_famille":"Gélinas",
    "titre_genre2":"Conseiller",
    "remuneration":"2585",
    "allocation":"1293",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3878",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":4811,
    "nom_corrige2":"Austin Leavey",
    "nom_famille":"Leavey",
    "titre_genre2":"Conseiller",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":4812,
    "nom_corrige2":"Marie-Claude Durand",
    "nom_famille":"Durand",
    "titre_genre2":"Conseillère",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":4813,
    "nom_corrige2":"Émilie Gauthier-Côté",
    "nom_famille":"Gauthier-Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":4814,
    "nom_corrige2":"Allyson Bigot",
    "nom_famille":"Bigot",
    "titre_genre2":"Conseillère",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":4815,
    "nom_corrige2":"Jean Malo",
    "nom_famille":"Malo",
    "titre_genre2":"Conseiller",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":4816,
    "nom_corrige2":"Lucie Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseillère",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":4817,
    "nom_corrige2":"Vincent Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"2582",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3873",
    "ville":"Saint-Nérée-de-Bellechasse",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"768"
  },
  {
    "ID":4818,
    "nom_corrige2":"Christian Lupien",
    "nom_famille":"Lupien",
    "titre_genre2":"Conseiller",
    "remuneration":"2581",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3872",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":4819,
    "nom_corrige2":"Steve Courchesne",
    "nom_famille":"Courchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"2581",
    "allocation":"1291",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3872",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":4820,
    "nom_corrige2":"Samuel Lanoie",
    "nom_famille":"Lanoie",
    "titre_genre2":"Conseiller",
    "remuneration":"2582",
    "allocation":"1290",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3872",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":4821,
    "nom_corrige2":"Normand Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"2578",
    "allocation":"1289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3867",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":4822,
    "nom_corrige2":"Alain Poitras",
    "nom_famille":"Poitras",
    "titre_genre2":"Conseiller",
    "remuneration":"2578",
    "allocation":"1289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3867",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":4823,
    "nom_corrige2":"Jacques O. Dufour",
    "nom_famille":"O. Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"2578",
    "allocation":"1289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3867",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":4824,
    "nom_corrige2":"Mario Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"2578",
    "allocation":"1289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3867",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":4825,
    "nom_corrige2":"Pierre Denis",
    "nom_famille":"Denis",
    "titre_genre2":"Conseiller",
    "remuneration":"2578",
    "allocation":"1289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3867",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":4826,
    "nom_corrige2":"Sylvie Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseillère",
    "remuneration":"2578",
    "allocation":"1289",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3867",
    "ville":"Saint-Alexis-de-Matapédia",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"513"
  },
  {
    "ID":4827,
    "nom_corrige2":"Pierre Carignan",
    "nom_famille":"Carignan",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1002",
    "remuneration2":"762,00$",
    "allocation2":"0",
    "total":"3860",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":4828,
    "nom_corrige2":"Christopher Whitehead",
    "nom_famille":"Whitehead",
    "titre_genre2":"Conseiller",
    "remuneration":"2893",
    "allocation":"964,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3857",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":4829,
    "nom_corrige2":"Larry Royea",
    "nom_famille":"Royea",
    "titre_genre2":"Conseiller",
    "remuneration":"2893",
    "allocation":"964,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3857",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":4830,
    "nom_corrige2":"Lisa Belanger",
    "nom_famille":"Belanger",
    "titre_genre2":"Conseillère",
    "remuneration":"2893",
    "allocation":"964,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3857",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":4831,
    "nom_corrige2":"Michael Allnutt",
    "nom_famille":"Allnutt",
    "titre_genre2":"Conseiller",
    "remuneration":"2893",
    "allocation":"964,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3857",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":4832,
    "nom_corrige2":"Wesley Patch",
    "nom_famille":"Patch",
    "titre_genre2":"Conseiller",
    "remuneration":"2893",
    "allocation":"964,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3857",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":4833,
    "nom_corrige2":"Pat Panasuk",
    "nom_famille":"Panasuk",
    "titre_genre2":"Conseiller",
    "remuneration":"2893",
    "allocation":"964,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3857",
    "ville":"Brome",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"339"
  },
  {
    "ID":4834,
    "nom_corrige2":"Tommy Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"2570",
    "allocation":"1285",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3855",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":4835,
    "nom_corrige2":"Gilles Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"2848",
    "allocation":"999,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3847",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":4836,
    "nom_corrige2":"Lucie Bourdon",
    "nom_famille":"Bourdon",
    "titre_genre2":"Conseillère",
    "remuneration":"2859",
    "allocation":"987,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3846",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":4837,
    "nom_corrige2":"Monique Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseillère",
    "remuneration":"2270",
    "allocation":"1575",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3845",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":4838,
    "nom_corrige2":"Normand Vigneau",
    "nom_famille":"Vigneau",
    "titre_genre2":"Conseiller",
    "remuneration":"2562",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3841",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":4839,
    "nom_corrige2":"Éric Thibaudeau",
    "nom_famille":"Thibaudeau",
    "titre_genre2":"Conseiller",
    "remuneration":"2557",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3836",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":4840,
    "nom_corrige2":"Pierre Legault",
    "nom_famille":"Legault",
    "titre_genre2":"Conseiller",
    "remuneration":"2557",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3836",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":4841,
    "nom_corrige2":"Carole Touchette",
    "nom_famille":"Touchette",
    "titre_genre2":"Conseillère",
    "remuneration":"2557",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3836",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":4842,
    "nom_corrige2":"Chantal Laviolette",
    "nom_famille":"Laviolette",
    "titre_genre2":"Conseillère",
    "remuneration":"2557",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3836",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":4843,
    "nom_corrige2":"Stefan Steiner",
    "nom_famille":"Steiner",
    "titre_genre2":"Conseiller",
    "remuneration":"2557",
    "allocation":"1279",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3836",
    "ville":"Lochaber",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"503"
  },
  {
    "ID":4844,
    "nom_corrige2":"Stéphanie Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseillère",
    "remuneration":"2554",
    "allocation":"1277",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3831",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":4845,
    "nom_corrige2":"Pascal D'Astous",
    "nom_famille":"D'Astous",
    "titre_genre2":"Conseiller",
    "remuneration":"2554",
    "allocation":"1277",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3831",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":4846,
    "nom_corrige2":"Lorraine Michud",
    "nom_famille":"Michud",
    "titre_genre2":"Conseillère",
    "remuneration":"2554",
    "allocation":"1277",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3831",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":4847,
    "nom_corrige2":"Sylvain Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"2554",
    "allocation":"1271",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3825",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":4848,
    "nom_corrige2":"Guy Pellerin",
    "nom_famille":"Pellerin",
    "titre_genre2":"Conseiller",
    "remuneration":"2549",
    "allocation":"1275",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3824",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":4849,
    "nom_corrige2":"Guylaine Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Conseillère",
    "remuneration":"2549",
    "allocation":"1275",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3824",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":4850,
    "nom_corrige2":"Lucie Bourgault",
    "nom_famille":"Bourgault",
    "titre_genre2":"Conseillère",
    "remuneration":"2549",
    "allocation":"1275",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3824",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":4851,
    "nom_corrige2":"Lucien Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"2549",
    "allocation":"1275",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3824",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":4852,
    "nom_corrige2":"Réjean Morneau",
    "nom_famille":"Morneau",
    "titre_genre2":"Conseiller",
    "remuneration":"2549",
    "allocation":"1275",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3824",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":4853,
    "nom_corrige2":"Yves Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"2549",
    "allocation":"1275",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3824",
    "ville":"Sainte-Félicité",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":4854,
    "nom_corrige2":"Jean-Bastien Rondeau",
    "nom_famille":"Rondeau",
    "titre_genre2":"Conseiller",
    "remuneration":"2586",
    "allocation":"1235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3821",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":4855,
    "nom_corrige2":"André Bougie",
    "nom_famille":"Bougie",
    "titre_genre2":"Conseiller",
    "remuneration":"2586",
    "allocation":"1235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3821",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":4856,
    "nom_corrige2":"Jean-Daniel Lavertu",
    "nom_famille":"Lavertu",
    "titre_genre2":"Conseiller",
    "remuneration":"2586",
    "allocation":"1235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3821",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":4857,
    "nom_corrige2":"Jeannot Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"2586",
    "allocation":"1235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3821",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":4858,
    "nom_corrige2":"Jessika Boisvert",
    "nom_famille":"Boisvert",
    "titre_genre2":"Conseillère",
    "remuneration":"2586",
    "allocation":"1235",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3821",
    "ville":"Sainte-Élizabeth-de-Warwick",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"391"
  },
  {
    "ID":4859,
    "nom_corrige2":"Amanda Hamel",
    "nom_famille":"Hamel",
    "titre_genre2":"Conseillère",
    "remuneration":"2562",
    "allocation":"1258",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3820",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":4860,
    "nom_corrige2":"Jacqueline Désindes",
    "nom_famille":"Désindes",
    "titre_genre2":"Conseillère",
    "remuneration":"2562",
    "allocation":"1258",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3820",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":4861,
    "nom_corrige2":"Jeffrey Bowker",
    "nom_famille":"Bowker",
    "titre_genre2":"Conseiller",
    "remuneration":"2562",
    "allocation":"1258",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3820",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":4862,
    "nom_corrige2":"Timothy Morrison",
    "nom_famille":"Morrison",
    "titre_genre2":"Conseiller",
    "remuneration":"2562",
    "allocation":"1258",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3820",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":4863,
    "nom_corrige2":"Sylvain Boisselle",
    "nom_famille":"Boisselle",
    "titre_genre2":"Conseiller",
    "remuneration":"2644",
    "allocation":"1159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3803",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":4864,
    "nom_corrige2":"Benjamin Cousineau",
    "nom_famille":"Cousineau",
    "titre_genre2":"Conseiller",
    "remuneration":"2534",
    "allocation":"1267",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3801",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":4865,
    "nom_corrige2":"Line Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseillère",
    "remuneration":"2534",
    "allocation":"1267",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3801",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":4866,
    "nom_corrige2":"Nicole Isabelle",
    "nom_famille":"Isabelle",
    "titre_genre2":"Conseillère",
    "remuneration":"2534",
    "allocation":"1267",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3801",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":4867,
    "nom_corrige2":"Éric Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"2534",
    "allocation":"1267",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3801",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":4868,
    "nom_corrige2":"Yvon Desrosiers",
    "nom_famille":"Desrosiers",
    "titre_genre2":"Conseiller",
    "remuneration":"2534",
    "allocation":"1267",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3801",
    "ville":"Sainte-Edwidge-de-Clifton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"557"
  },
  {
    "ID":4869,
    "nom_corrige2":"Cathy Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"2531",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":4870,
    "nom_corrige2":"Damien Jean",
    "nom_famille":"Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"2531",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":4871,
    "nom_corrige2":"Guillaume Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"2531",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":4872,
    "nom_corrige2":"Jonathan Duval",
    "nom_famille":"Duval",
    "titre_genre2":"Conseiller",
    "remuneration":"2531",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":4873,
    "nom_corrige2":"Marie-Jean Pellerin",
    "nom_famille":"Pellerin",
    "titre_genre2":"Conseiller",
    "remuneration":"2531",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":4874,
    "nom_corrige2":"Monique Gamache",
    "nom_famille":"Gamache",
    "titre_genre2":"Conseillère",
    "remuneration":"2531",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3796",
    "ville":"Saint-Damase-de-L'Islet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"570"
  },
  {
    "ID":4875,
    "nom_corrige2":"Linda Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"2530",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3795",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":4876,
    "nom_corrige2":"Rachelle Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"2530",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3795",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":4877,
    "nom_corrige2":"Réal Cameron",
    "nom_famille":"Cameron",
    "titre_genre2":"Conseiller",
    "remuneration":"2530",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3795",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":4878,
    "nom_corrige2":"Renald Béliveau",
    "nom_famille":"Béliveau",
    "titre_genre2":"Conseiller",
    "remuneration":"2530",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3795",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":4879,
    "nom_corrige2":"Richard Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseiller",
    "remuneration":"2530",
    "allocation":"1265",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3795",
    "ville":"Stornoway",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"556"
  },
  {
    "ID":4880,
    "nom_corrige2":"Serge Delongchamp",
    "nom_famille":"Delongchamp",
    "titre_genre2":"Conseiller",
    "remuneration":"2533",
    "allocation":"1259",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3792",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":4881,
    "nom_corrige2":"Denis Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"2533",
    "allocation":"1259",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3792",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":4882,
    "nom_corrige2":"Neil Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseiller",
    "remuneration":"2365",
    "allocation":"1035",
    "remuneration2":"256,00$",
    "allocation2":"128,00$",
    "total":"3784",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":4883,
    "nom_corrige2":"Samuel Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseiller",
    "remuneration":"2520",
    "allocation":"1260",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3780",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":4884,
    "nom_corrige2":"Gaétan Goyette",
    "nom_famille":"Goyette",
    "titre_genre2":"Conseiller",
    "remuneration":"2520",
    "allocation":"1260",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3780",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":4885,
    "nom_corrige2":"Virginie Ashby",
    "nom_famille":"Ashby",
    "titre_genre2":"Conseillère",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"133,00$",
    "allocation2":"67,00$",
    "total":"3776",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":4886,
    "nom_corrige2":"Serge Turcotte",
    "nom_famille":"Turcotte",
    "titre_genre2":"Conseiller",
    "remuneration":"2772",
    "allocation":"999,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3771",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":4887,
    "nom_corrige2":"Bianka Langlais",
    "nom_famille":"Bissada",
    "titre_genre2":"Conseillère",
    "remuneration":"2514",
    "allocation":"1257",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3771",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":4888,
    "nom_corrige2":"Patricia Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseillère",
    "remuneration":"2514",
    "allocation":"1 257,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3771",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":4889,
    "nom_corrige2":"Armelle Kermarrec",
    "nom_famille":"Kermarrec",
    "titre_genre2":"Conseillère",
    "remuneration":"2513",
    "allocation":"1256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3769",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":4890,
    "nom_corrige2":"Carole Viel",
    "nom_famille":"Viel",
    "titre_genre2":"Conseillère",
    "remuneration":"2513",
    "allocation":"1256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3769",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":4891,
    "nom_corrige2":"Patrice Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2513",
    "allocation":"1256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3769",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":4892,
    "nom_corrige2":"Fernand Albert",
    "nom_famille":"Albert",
    "titre_genre2":"Conseiller",
    "remuneration":"2513",
    "allocation":"1256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3769",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":4893,
    "nom_corrige2":"Marguerite Albert",
    "nom_famille":"Albert",
    "titre_genre2":"Conseillère",
    "remuneration":"2513",
    "allocation":"1256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3769",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":4894,
    "nom_corrige2":"Réjean Albert",
    "nom_famille":"Albert",
    "titre_genre2":"Conseiller",
    "remuneration":"2513",
    "allocation":"1256",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3769",
    "ville":"Lejeune",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"241"
  },
  {
    "ID":4895,
    "nom_corrige2":"André Lord",
    "nom_famille":"Lord",
    "titre_genre2":"Conseiller",
    "remuneration":"2508",
    "allocation":"1254",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3762",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":4896,
    "nom_corrige2":"Daniel Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"2508",
    "allocation":"1254",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3762",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":4897,
    "nom_corrige2":"Linda Plouffe",
    "nom_famille":"Plouffe",
    "titre_genre2":"Conseillère",
    "remuneration":"2508",
    "allocation":"1254",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3762",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":4898,
    "nom_corrige2":"Marie Fitzgerald",
    "nom_famille":"Fitzgerald",
    "titre_genre2":"Conseillère",
    "remuneration":"2508",
    "allocation":"1254",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3762",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":4899,
    "nom_corrige2":"Michel Villemure",
    "nom_famille":"Villemure",
    "titre_genre2":"Conseiller",
    "remuneration":"2508",
    "allocation":"1254",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3762",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":4900,
    "nom_corrige2":"Pierre Deschenes",
    "nom_famille":"Deschenes",
    "titre_genre2":"Conseiller",
    "remuneration":"2508",
    "allocation":"1254",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3762",
    "ville":"Charette",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"1141"
  },
  {
    "ID":4901,
    "nom_corrige2":"Jocelyn Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"2506",
    "allocation":"1253",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3759",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4902,
    "nom_corrige2":"Louis Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseiller",
    "remuneration":"2504",
    "allocation":"1252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3756",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":4903,
    "nom_corrige2":"Danie Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseillère",
    "remuneration":"2504",
    "allocation":"1252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3756",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":4904,
    "nom_corrige2":"Martial Pitre",
    "nom_famille":"Pitre",
    "titre_genre2":"Conseiller",
    "remuneration":"2504",
    "allocation":"1252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3756",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":4905,
    "nom_corrige2":"Mélissa Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"2504",
    "allocation":"1252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3756",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":4906,
    "nom_corrige2":"René Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseiller",
    "remuneration":"2504",
    "allocation":"1252",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3756",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":4907,
    "nom_corrige2":"Francis Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"2500",
    "allocation":"1249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3749",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":4908,
    "nom_corrige2":"François proulx",
    "nom_famille":"proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"2500",
    "allocation":"1249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3749",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":4909,
    "nom_corrige2":"Gaston Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"2500",
    "allocation":"1249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3749",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":4910,
    "nom_corrige2":"Jean-François Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"2500",
    "allocation":"1249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3749",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":4911,
    "nom_corrige2":"Marie-Pier Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseillère",
    "remuneration":"2500",
    "allocation":"1249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3749",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":4912,
    "nom_corrige2":"Patricia Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseillère",
    "remuneration":"2500",
    "allocation":"1249",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3749",
    "ville":"Saint-Séverin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"303"
  },
  {
    "ID":4913,
    "nom_corrige2":"Éric Morency",
    "nom_famille":"Morency",
    "titre_genre2":"Conseiller",
    "remuneration":"2493",
    "allocation":"1239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3732",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":4914,
    "nom_corrige2":"Geneviève Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"2493",
    "allocation":"1239",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3732",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":4915,
    "nom_corrige2":"Sandra Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Conseillère",
    "remuneration":"2556",
    "allocation":"1172",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3728",
    "ville":"Saint-Zacharie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1708"
  },
  {
    "ID":4916,
    "nom_corrige2":"Guillaume Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"2480",
    "allocation":"1240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3720",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":4917,
    "nom_corrige2":"Katrine Normandeau",
    "nom_famille":"Normandeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2480",
    "allocation":"1240",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3720",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":4918,
    "nom_corrige2":"Jonathan Parisé",
    "nom_famille":"Parisé",
    "titre_genre2":"Conseiller",
    "remuneration":"2341",
    "allocation":"1352",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3693",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":4919,
    "nom_corrige2":"Patrick Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Conseiller",
    "remuneration":"2453",
    "allocation":"1227",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3680",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":4920,
    "nom_corrige2":"Miguel Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Maire suppléant",
    "remuneration":"2452",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3678",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":4921,
    "nom_corrige2":"Alain Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"2452",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3678",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":4922,
    "nom_corrige2":"Annabelle Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseillère",
    "remuneration":"2452",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3678",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":4923,
    "nom_corrige2":"Véronique Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"2452",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3678",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":4924,
    "nom_corrige2":"Luc Saint-Pierre",
    "nom_famille":"Saint-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"2452",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3678",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":4925,
    "nom_corrige2":"Jérôme Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseiller",
    "remuneration":"2452",
    "allocation":"1226",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3678",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1095"
  },
  {
    "ID":4926,
    "nom_corrige2":"Stéphanie Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"2478",
    "allocation":"1197",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3675",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":4927,
    "nom_corrige2":"Pierre Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"2450",
    "allocation":"1225",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3675",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":4928,
    "nom_corrige2":"Frédéric Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"2453",
    "allocation":"1219",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3672",
    "ville":"Val-Racine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"184"
  },
  {
    "ID":4929,
    "nom_corrige2":"Élise Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"2497",
    "allocation":"1167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3664",
    "ville":"Lamarche",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"515"
  },
  {
    "ID":4930,
    "nom_corrige2":"Cyntia Ferland",
    "nom_famille":"Ferland",
    "titre_genre2":"Conseillère",
    "remuneration":"2442",
    "allocation":"1221",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3663",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":4931,
    "nom_corrige2":"Suzanne Serhan",
    "nom_famille":"Serhan",
    "titre_genre2":"Conseillère",
    "remuneration":"2440",
    "allocation":"1220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Ulverton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"459"
  },
  {
    "ID":4932,
    "nom_corrige2":"Régis Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"2115",
    "allocation":"1057",
    "remuneration2":"325,00$",
    "allocation2":"163,00$",
    "total":"3660",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":4933,
    "nom_corrige2":"Pascal Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"2436",
    "allocation":"1224",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":4934,
    "nom_corrige2":"Christine Charlebois",
    "nom_famille":"Charlebois",
    "titre_genre2":"Conseillère",
    "remuneration":"2436",
    "allocation":"1224",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":4935,
    "nom_corrige2":"Danny Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseiller",
    "remuneration":"2436",
    "allocation":"1224",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":4936,
    "nom_corrige2":"Jean Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"2436",
    "allocation":"1224",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":4937,
    "nom_corrige2":"Danny Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseiller",
    "remuneration":"2436",
    "allocation":"1224",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":4938,
    "nom_corrige2":"Sylvie Charette",
    "nom_famille":"Charette",
    "titre_genre2":"Conseillère",
    "remuneration":"2440",
    "allocation":"1220",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3660",
    "ville":"Berry",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"535"
  },
  {
    "ID":4939,
    "nom_corrige2":"Donatien Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"2270",
    "allocation":"1386",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3656",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":4940,
    "nom_corrige2":"Manon Thivierge",
    "nom_famille":"Thivierge",
    "titre_genre2":"Conseillère",
    "remuneration":"2431",
    "allocation":"1215",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3646",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":4941,
    "nom_corrige2":"Marc Champagne",
    "nom_famille":"Champagne",
    "titre_genre2":"Conseiller",
    "remuneration":"2439",
    "allocation":"1197",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3636",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":4942,
    "nom_corrige2":"Caroline Coulombe",
    "nom_famille":"Coulombe",
    "titre_genre2":"Conseillère",
    "remuneration":"2417",
    "allocation":"1211",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3628",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":4943,
    "nom_corrige2":"Guillaume Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseiller",
    "remuneration":"2417",
    "allocation":"1211",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3628",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":4944,
    "nom_corrige2":"Nicolas Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"2417",
    "allocation":"1211",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3628",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":4945,
    "nom_corrige2":"Pâquerette Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseillère",
    "remuneration":"2417",
    "allocation":"1211",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3628",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":4946,
    "nom_corrige2":"Renald Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2417",
    "allocation":"1211",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3628",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":4947,
    "nom_corrige2":"Manon Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Mairesse suppléante",
    "remuneration":"2255",
    "allocation":"1048",
    "remuneration2":"207,00$",
    "allocation2":"104,00$",
    "total":"3614",
    "ville":"Saint-Denis-De La Bouteillerie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"517"
  },
  {
    "ID":4948,
    "nom_corrige2":"Edith Cooke",
    "nom_famille":"Cooke",
    "titre_genre2":"Conseillère",
    "remuneration":"2409",
    "allocation":"1204",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3613",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":4949,
    "nom_corrige2":"Raphael Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseiller",
    "remuneration":"2409",
    "allocation":"1204",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3613",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":4950,
    "nom_corrige2":"Marie-Ève Moisan",
    "nom_famille":"Moisan",
    "titre_genre2":"Conseillère",
    "remuneration":"2409",
    "allocation":"1204",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3613",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":4951,
    "nom_corrige2":"Mathieu Fecteau",
    "nom_famille":"Fecteau",
    "titre_genre2":"Conseiller",
    "remuneration":"2409",
    "allocation":"1204",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3613",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":4952,
    "nom_corrige2":"Jean-René Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2409",
    "allocation":"1204",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3613",
    "ville":"Saint-Léonard-de-Portneuf",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1183"
  },
  {
    "ID":4953,
    "nom_corrige2":"Doris Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"2403",
    "allocation":"1202",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3605",
    "ville":"Sainte-Justine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1857"
  },
  {
    "ID":4954,
    "nom_corrige2":"Sylvain Jutras (#3)",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseiller",
    "remuneration":"1948",
    "allocation":"936,00$",
    "remuneration2":"480,00$",
    "allocation2":"240,00$",
    "total":"3604",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":4955,
    "nom_corrige2":"André Beauchemin",
    "nom_famille":"Beauchemin",
    "titre_genre2":"Conseiller",
    "remuneration":"2391",
    "allocation":"1196",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3587",
    "ville":"La Corne",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"830"
  },
  {
    "ID":4956,
    "nom_corrige2":"Louise Jacques",
    "nom_famille":"Jacuqes",
    "titre_genre2":"Conseillère",
    "remuneration":"2723",
    "allocation":"860,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3583",
    "ville":"Saint-Cuthbert",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1883"
  },
  {
    "ID":4957,
    "nom_corrige2":"Lucie Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3576",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":4958,
    "nom_corrige2":"Claudia Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3576",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":4959,
    "nom_corrige2":"Cynthia Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseillère",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3576",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":4960,
    "nom_corrige2":"Jérémy Robert",
    "nom_famille":"Robert",
    "titre_genre2":"Conseiller",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3576",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":4961,
    "nom_corrige2":"Émilie Belzile",
    "nom_famille":"Belzile",
    "titre_genre2":"Conseillère",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3576",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":4962,
    "nom_corrige2":"Michaël Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"2384",
    "allocation":"1192",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3576",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":4963,
    "nom_corrige2":"Éric Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Conseiller",
    "remuneration":"2381",
    "allocation":"1191",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3572",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4964,
    "nom_corrige2":"Jocelyn Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2381",
    "allocation":"1191",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3572",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4965,
    "nom_corrige2":"Roger Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"2381",
    "allocation":"1191",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3572",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4966,
    "nom_corrige2":"Samuel Sirois",
    "nom_famille":"Sirois",
    "titre_genre2":"Conseiller",
    "remuneration":"2381",
    "allocation":"1191",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3572",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":4967,
    "nom_corrige2":"Justine Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"2376",
    "allocation":"1188",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3564",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":4968,
    "nom_corrige2":"Éric Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseiller",
    "remuneration":"2374",
    "allocation":"1187",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3561",
    "ville":"Saints-Anges",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1369"
  },
  {
    "ID":4969,
    "nom_corrige2":"Paul Lafrenière",
    "nom_famille":"Lafrenière",
    "titre_genre2":"Conseiller",
    "remuneration":"2372",
    "allocation":"1186",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3558",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":4970,
    "nom_corrige2":"Danielle Jodoin",
    "nom_famille":"Jodoin",
    "titre_genre2":"Conseillère",
    "remuneration":"2711",
    "allocation":"831,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3542",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":4971,
    "nom_corrige2":"Marie V. Laporte",
    "nom_famille":"V. Laporte",
    "titre_genre2":"Conseillère",
    "remuneration":"2357",
    "allocation":"1179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3536",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":4972,
    "nom_corrige2":"Nicolas Paris-Lafrance",
    "nom_famille":"Paris-Lafrance",
    "titre_genre2":"Conseiller",
    "remuneration":"2357",
    "allocation":"1179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3536",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":4973,
    "nom_corrige2":"Catherine Belleau-Arsenault",
    "nom_famille":"Belleau-Arsenault",
    "titre_genre2":"Conseillère",
    "remuneration":"2357",
    "allocation":"1179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3536",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":4974,
    "nom_corrige2":"Julien Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"2357",
    "allocation":"1179",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3536",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":4975,
    "nom_corrige2":"Mélissa Brock",
    "nom_famille":"Brock",
    "titre_genre2":"Conseillère",
    "remuneration":"2490",
    "allocation":"1035",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3525",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":4976,
    "nom_corrige2":"Maryse Briand",
    "nom_famille":"Briand",
    "titre_genre2":"Conseillère",
    "remuneration":"2349",
    "allocation":"1174",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3523",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":4977,
    "nom_corrige2":"Monique Scholz",
    "nom_famille":"Scholz",
    "titre_genre2":"Conseillère",
    "remuneration":"2349",
    "allocation":"1174",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3523",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":4978,
    "nom_corrige2":"Sylvie Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"2349",
    "allocation":"1174",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3523",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":4979,
    "nom_corrige2":"Lisa Irving",
    "nom_famille":"Irving",
    "titre_genre2":"Conseillère",
    "remuneration":"2349",
    "allocation":"1174",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3523",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":4980,
    "nom_corrige2":"Chantal Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseillère",
    "remuneration":"2349",
    "allocation":"1174",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3523",
    "ville":"Hampden",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"204"
  },
  {
    "ID":4981,
    "nom_corrige2":"Yanick Larcroix",
    "nom_famille":"Larcroix",
    "titre_genre2":"Maire",
    "remuneration":"1897",
    "allocation":"949,00$",
    "remuneration2":"671,00$",
    "allocation2":"0",
    "total":"3517",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":4982,
    "nom_corrige2":"Marie-Line D'Astous",
    "nom_famille":"D'Astous",
    "titre_genre2":"Conseillère",
    "remuneration":"2341",
    "allocation":"1171",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3512",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":4983,
    "nom_corrige2":"Benoît Lussier",
    "nom_famille":"Lussier",
    "titre_genre2":"Conseiller",
    "remuneration":"2333",
    "allocation":"1167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3500",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":4984,
    "nom_corrige2":"Liliane St-Hilaire",
    "nom_famille":"St-Hilaire",
    "titre_genre2":"Conseillère",
    "remuneration":"2333",
    "allocation":"1167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3500",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":4985,
    "nom_corrige2":"Line Pellerin",
    "nom_famille":"Pellerin",
    "titre_genre2":"Conseillère",
    "remuneration":"2333",
    "allocation":"1167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3500",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":4986,
    "nom_corrige2":"René St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"2333",
    "allocation":"1167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3500",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":4987,
    "nom_corrige2":"Saul Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"2333",
    "allocation":"1167",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3500",
    "ville":"Aston-Jonction",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"460"
  },
  {
    "ID":4988,
    "nom_corrige2":"Gilles Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseiller",
    "remuneration":"2328",
    "allocation":"1164",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3492",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":4989,
    "nom_corrige2":"Julie Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"2326",
    "allocation":"1163",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3489",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":4990,
    "nom_corrige2":"Alain Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseiller",
    "remuneration":"2324",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3486",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":4991,
    "nom_corrige2":"Anne Harrisson",
    "nom_famille":"Harrisson",
    "titre_genre2":"Conseillère",
    "remuneration":"2324",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3486",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":4992,
    "nom_corrige2":"Frédéric Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseiller",
    "remuneration":"2324",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3486",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":4993,
    "nom_corrige2":"Glad'ys Aubé",
    "nom_famille":"Aubé",
    "titre_genre2":"Conseillère",
    "remuneration":"2324",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3486",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":4994,
    "nom_corrige2":"Laurie Bouffard",
    "nom_famille":"Bouffard",
    "titre_genre2":"Conseillère",
    "remuneration":"2324",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3486",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":4995,
    "nom_corrige2":"Marc Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"2324",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3486",
    "ville":"Saint-Vallier",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1042"
  },
  {
    "ID":4996,
    "nom_corrige2":"Christian Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"2330",
    "allocation":"1155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3485",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":4997,
    "nom_corrige2":"Alexandre Germain",
    "nom_famille":"Germain",
    "titre_genre2":"Conseiller",
    "remuneration":"2322",
    "allocation":"1161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3483",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":4998,
    "nom_corrige2":"Caroline Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseillère",
    "remuneration":"2322",
    "allocation":"1161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3483",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":4999,
    "nom_corrige2":"Ghislain Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseiller",
    "remuneration":"2322",
    "allocation":"1161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3483",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":5000,
    "nom_corrige2":"Jean-Philippe Villeneuve",
    "nom_famille":"Villeneuve",
    "titre_genre2":"Conseiller",
    "remuneration":"2322",
    "allocation":"1161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3483",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":5001,
    "nom_corrige2":"Raynald Pearson",
    "nom_famille":"Pearson",
    "titre_genre2":"Conseiller",
    "remuneration":"2322",
    "allocation":"1161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3483",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":5002,
    "nom_corrige2":"Stécy Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseiller",
    "remuneration":"2322",
    "allocation":"1161",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3483",
    "ville":"Bégin",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"895"
  },
  {
    "ID":5003,
    "nom_corrige2":"Patrick Boisselle",
    "nom_famille":"Boisselle",
    "titre_genre2":"Conseiller",
    "remuneration":"2319",
    "allocation":"1159",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3478",
    "ville":"Saint-Aimé",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"439"
  },
  {
    "ID":5004,
    "nom_corrige2":"Karine Racine-Boilard",
    "nom_famille":"Racine-Boilard",
    "titre_genre2":"Conseillère",
    "remuneration":"2440",
    "allocation":"1035",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3475",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":5005,
    "nom_corrige2":"Arnaud Caron-Daneault",
    "nom_famille":"Caron-Daneault",
    "titre_genre2":"Conseiller",
    "remuneration":"2315",
    "allocation":"1158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3473",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":5006,
    "nom_corrige2":"Alain Bois",
    "nom_famille":"Bois",
    "titre_genre2":"Conseiller",
    "remuneration":"2315",
    "allocation":"1158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3473",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":5007,
    "nom_corrige2":"Denis Boies",
    "nom_famille":"Boies",
    "titre_genre2":"Conseiller",
    "remuneration":"2315",
    "allocation":"1158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3473",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":5008,
    "nom_corrige2":"Marc-andré Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"2315",
    "allocation":"1158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3473",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":5009,
    "nom_corrige2":"Pierre Lizotte",
    "nom_famille":"Lizotte",
    "titre_genre2":"Conseiller",
    "remuneration":"2315",
    "allocation":"1158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3473",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":5010,
    "nom_corrige2":"René Castonguay",
    "nom_famille":"Castonguay",
    "titre_genre2":"Conseiller",
    "remuneration":"2315",
    "allocation":"1158",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3473",
    "ville":"Sainte-Louise",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"696"
  },
  {
    "ID":5011,
    "nom_corrige2":"Sylvain Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseiller",
    "remuneration":"2178",
    "allocation":"1089",
    "remuneration2":"135,00$",
    "allocation2":"68,00$",
    "total":"3470",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":5012,
    "nom_corrige2":"Pierre Sévegny",
    "nom_famille":"Sévegny",
    "titre_genre2":"Conseiller",
    "remuneration":"2270",
    "allocation":"1200",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3470",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":5013,
    "nom_corrige2":"Robert Rocheleau",
    "nom_famille":"Rocheleau",
    "titre_genre2":"Conseiller",
    "remuneration":"2636",
    "allocation":"831,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3467",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":5014,
    "nom_corrige2":"Jean-François Giguère",
    "nom_famille":"Giguère",
    "titre_genre2":"Conseiller",
    "remuneration":"2310",
    "allocation":"1155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3465",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":5015,
    "nom_corrige2":"Marc Lessard",
    "nom_famille":"Lessard",
    "titre_genre2":"Conseiller",
    "remuneration":"2310",
    "allocation":"1155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3465",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":5016,
    "nom_corrige2":"Mélanie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"2310",
    "allocation":"1155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3465",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":5017,
    "nom_corrige2":"Joannie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"2310",
    "allocation":"1155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3465",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":5018,
    "nom_corrige2":"Sylvain Lambert",
    "nom_famille":"Lambert",
    "titre_genre2":"Conseillère",
    "remuneration":"2310",
    "allocation":"1155",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3465",
    "ville":"Saint-Joseph-des-Érables",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"398"
  },
  {
    "ID":5019,
    "nom_corrige2":"Jacques Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseiller",
    "remuneration":"2298",
    "allocation":"1166",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3464",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":5020,
    "nom_corrige2":"Bertrand Béchard",
    "nom_famille":"Béchard",
    "titre_genre2":"Conseiller",
    "remuneration":"2298",
    "allocation":"1166",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3464",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":5021,
    "nom_corrige2":"Marcel Mainville",
    "nom_famille":"Mainville",
    "titre_genre2":"Conseiller",
    "remuneration":"2298",
    "allocation":"1166",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3464",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":5022,
    "nom_corrige2":"Sébastien Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseiller",
    "remuneration":"2298",
    "allocation":"1166",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3464",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":5023,
    "nom_corrige2":"Chantal Mainville",
    "nom_famille":"Mainville",
    "titre_genre2":"Conseillère",
    "remuneration":"2298",
    "allocation":"1166",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3464",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":5024,
    "nom_corrige2":"Josée Chrétien",
    "nom_famille":"Chrétien",
    "titre_genre2":"Conseillère",
    "remuneration":"2298",
    "allocation":"1166",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3464",
    "ville":"Roquemaure",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"381"
  },
  {
    "ID":5025,
    "nom_corrige2":"Hélène Rancourt",
    "nom_famille":"Rancourt",
    "titre_genre2":"Conseillère",
    "remuneration":"2307",
    "allocation":"1153",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3460",
    "ville":"Sainte-Rose-de-Watford",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"749"
  },
  {
    "ID":5026,
    "nom_corrige2":"Chantale Bilodeau",
    "nom_famille":"Bilodeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2331",
    "allocation":"1113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3444",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5027,
    "nom_corrige2":"Denise Houle",
    "nom_famille":"Houle",
    "titre_genre2":"Conseillère",
    "remuneration":"2331",
    "allocation":"1113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3444",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5028,
    "nom_corrige2":"Eve-Lyne Marcotte",
    "nom_famille":"Marcotte",
    "titre_genre2":"Conseillère",
    "remuneration":"2331",
    "allocation":"1113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3444",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5029,
    "nom_corrige2":"Gaétan Légaré",
    "nom_famille":"Légaré",
    "titre_genre2":"Conseiller",
    "remuneration":"2331",
    "allocation":"1113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3444",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5030,
    "nom_corrige2":"Bernard Philipps",
    "nom_famille":"Philipps",
    "titre_genre2":"Conseiller",
    "remuneration":"2331",
    "allocation":"1113",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3444",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5031,
    "nom_corrige2":"Nicholas Kaven Jean",
    "nom_famille":"Kaven Jean",
    "titre_genre2":"Conseiller",
    "remuneration":"2296",
    "allocation":"1148",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3444",
    "ville":"Sainte-Irène",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"400"
  },
  {
    "ID":5032,
    "nom_corrige2":"Yves Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"2270",
    "allocation":"1171",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3441",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":5033,
    "nom_corrige2":"Maurice Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"2434",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3434",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5034,
    "nom_corrige2":"Frédéric Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"2256",
    "allocation":"1162",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3418",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":5035,
    "nom_corrige2":"Manuel Paulin-Grosset",
    "nom_famille":"Paulin-Grosset",
    "titre_genre2":"Conseiller",
    "remuneration":"2365",
    "allocation":"1035",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3400",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":5036,
    "nom_corrige2":"Sophie-Catherine Chapleau",
    "nom_famille":"Chapleau",
    "titre_genre2":"Conseillère",
    "remuneration":"2365",
    "allocation":"1035",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3400",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":5037,
    "nom_corrige2":"Nathalie Vermette",
    "nom_famille":"Vermette",
    "titre_genre2":"Conseillère",
    "remuneration":"2365",
    "allocation":"1035",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3400",
    "ville":"East Farnham",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"701"
  },
  {
    "ID":5038,
    "nom_corrige2":"Lise Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"2265",
    "allocation":"1133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3398",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":5039,
    "nom_corrige2":"Claudia Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseillère",
    "remuneration":"2265",
    "allocation":"1133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3398",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":5040,
    "nom_corrige2":"Jérôme Boissonneault",
    "nom_famille":"Boissonneault",
    "titre_genre2":"Conseiller",
    "remuneration":"2265",
    "allocation":"1133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3398",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":5041,
    "nom_corrige2":"Mario Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"2265",
    "allocation":"1133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3398",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":5042,
    "nom_corrige2":"Richard Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseiller",
    "remuneration":"2265",
    "allocation":"1133",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3398",
    "ville":"Honfleur",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"877"
  },
  {
    "ID":5043,
    "nom_corrige2":"Christian Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"2270",
    "allocation":"1125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3395",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":5044,
    "nom_corrige2":"Michel Beauchesne",
    "nom_famille":"Beauchesne",
    "titre_genre2":"Conseiller",
    "remuneration":"2270",
    "allocation":"1125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3395",
    "ville":"Sainte-Marie-de-Blandford",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"488"
  },
  {
    "ID":5045,
    "nom_corrige2":"Léo Cossette",
    "nom_famille":"Cossette",
    "titre_genre2":"Conseiller",
    "remuneration":"2561",
    "allocation":"831,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3392",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":5046,
    "nom_corrige2":"Alice Lenoir",
    "nom_famille":"Lenoir",
    "titre_genre2":"Conseillère",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":5047,
    "nom_corrige2":"Gladys Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseillère",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":5048,
    "nom_corrige2":"Dominic Gonthier",
    "nom_famille":"Gonthier",
    "titre_genre2":"Conseiller",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":5049,
    "nom_corrige2":"Jean Doyon",
    "nom_famille":"Doyon",
    "titre_genre2":"Conseiller",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":5050,
    "nom_corrige2":"Stéphanie Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":5051,
    "nom_corrige2":"Michaël Mailhot",
    "nom_famille":"Mailhot",
    "titre_genre2":"Conseiller",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Saint-Fabien-de-Panet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"992"
  },
  {
    "ID":5052,
    "nom_corrige2":"Sylvain Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"2260",
    "allocation":"1130",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3390",
    "ville":"Authier-Nord",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"277"
  },
  {
    "ID":5053,
    "nom_corrige2":"Jennifer Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseillère",
    "remuneration":"2254",
    "allocation":"1127",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3381",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":5054,
    "nom_corrige2":"Donald Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2253",
    "allocation":"1127",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3380",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5055,
    "nom_corrige2":"Christian Routhier",
    "nom_famille":"Routhier",
    "titre_genre2":"Conseiller",
    "remuneration":"2251",
    "allocation":"1126",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3377",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":5056,
    "nom_corrige2":"François Chabot",
    "nom_famille":"Chabot",
    "titre_genre2":"Conseiller",
    "remuneration":"2250",
    "allocation":"1125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3375",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":5057,
    "nom_corrige2":"Jocelyn Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"2250",
    "allocation":"1125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3375",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":5058,
    "nom_corrige2":"Mireille Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"2250",
    "allocation":"1125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3375",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":5059,
    "nom_corrige2":"Mathieu B. Fillion",
    "nom_famille":"B. Fillion",
    "titre_genre2":"Conseiller",
    "remuneration":"2250",
    "allocation":"1125",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3375",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":5060,
    "nom_corrige2":"Chantal St-Cyr",
    "nom_famille":"St-Cyr",
    "titre_genre2":"Conseillère",
    "remuneration":"2167",
    "allocation":"1083",
    "remuneration2":"100,00$",
    "allocation2":"0",
    "total":"3350",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":5061,
    "nom_corrige2":"Annie Labbé",
    "nom_famille":"Labbé",
    "titre_genre2":"Conseillère",
    "remuneration":"2337",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3337",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5062,
    "nom_corrige2":"David Drummond",
    "nom_famille":"Drummond",
    "titre_genre2":"Conseiller",
    "remuneration":"2222",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3333",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":5063,
    "nom_corrige2":"Donald Bergevin",
    "nom_famille":"Bergevin",
    "titre_genre2":"Conseiller",
    "remuneration":"2222",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3333",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":5064,
    "nom_corrige2":"James Gaw",
    "nom_famille":"Gaw",
    "titre_genre2":"Conseiller",
    "remuneration":"2222",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3333",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":5065,
    "nom_corrige2":"Justin Moss",
    "nom_famille":"Moss",
    "titre_genre2":"Conseiller",
    "remuneration":"2222",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3333",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":5066,
    "nom_corrige2":"Markus Liebl",
    "nom_famille":"Liebl",
    "titre_genre2":"Conseiller",
    "remuneration":"2222",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3333",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":5067,
    "nom_corrige2":"Matthew Wallace",
    "nom_famille":"Wallace",
    "titre_genre2":"Conseiller",
    "remuneration":"2222",
    "allocation":"1111",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3333",
    "ville":"Elgin",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"396"
  },
  {
    "ID":5068,
    "nom_corrige2":"Vallier Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2216",
    "allocation":"1110",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3326",
    "ville":"Saint-Épiphane",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"828"
  },
  {
    "ID":5069,
    "nom_corrige2":"Mathieu Perreault-Soucy",
    "nom_famille":"Perreault-Soucy",
    "titre_genre2":"Conseiller",
    "remuneration":"2220",
    "allocation":"1100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3320",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":5070,
    "nom_corrige2":"Cathy Michel",
    "nom_famille":"Michel",
    "titre_genre2":"Conseillère",
    "remuneration":"2220",
    "allocation":"1 100,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3320",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":5071,
    "nom_corrige2":"Dany Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"2220",
    "allocation":"1100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3320",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":5072,
    "nom_corrige2":"Jason Tousignant",
    "nom_famille":"Tousignant",
    "titre_genre2":"Conseiller",
    "remuneration":"2220",
    "allocation":"1100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3320",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":5073,
    "nom_corrige2":"Jean-François Bienvenue",
    "nom_famille":"Bienvenue",
    "titre_genre2":"Conseiller",
    "remuneration":"2220",
    "allocation":"1100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3320",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":5074,
    "nom_corrige2":"Samuel Castonguay",
    "nom_famille":"Castonguay",
    "titre_genre2":"Conseiller",
    "remuneration":"2220",
    "allocation":"1100",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3320",
    "ville":"Parisville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"531"
  },
  {
    "ID":5075,
    "nom_corrige2":"Daniel Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"1988",
    "allocation":"994,00$",
    "remuneration2":"225,00$",
    "allocation2":"113,00$",
    "total":"3320",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5076,
    "nom_corrige2":"Gérald Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"2486",
    "allocation":"831,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3317",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":5077,
    "nom_corrige2":"Tommy Desrochers",
    "nom_famille":"Desrochers",
    "titre_genre2":"Conseiller",
    "remuneration":"2208",
    "allocation":"1104",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3312",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":5078,
    "nom_corrige2":"Mélanie Caron-Croisetière",
    "nom_famille":"Caron-Croisetière",
    "titre_genre2":"Conseillère",
    "remuneration":"2206",
    "allocation":"1103",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3309",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":5079,
    "nom_corrige2":"André Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseiller",
    "remuneration":"2255",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3303",
    "ville":"Saint-Denis-De La Bouteillerie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"517"
  },
  {
    "ID":5080,
    "nom_corrige2":"Rogé Francoeur",
    "nom_famille":"Francoeur",
    "titre_genre2":"Conseiller",
    "remuneration":"2255",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3303",
    "ville":"Saint-Denis-De La Bouteillerie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"517"
  },
  {
    "ID":5081,
    "nom_corrige2":"Charles Garon",
    "nom_famille":"Garon",
    "titre_genre2":"Conseiller",
    "remuneration":"2255",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3303",
    "ville":"Saint-Denis-De La Bouteillerie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"517"
  },
  {
    "ID":5082,
    "nom_corrige2":"Robert Ledoux",
    "nom_famille":"Ledoux",
    "titre_genre2":"Conseiller",
    "remuneration":"2297",
    "allocation":"999,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3296",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":5083,
    "nom_corrige2":"Stéphan Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2185",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3277",
    "ville":"Auclair",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"468"
  },
  {
    "ID":5084,
    "nom_corrige2":"Claude Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"2184",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3276",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":5085,
    "nom_corrige2":"Anthony Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Conseiller",
    "remuneration":"2184",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3276",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":5086,
    "nom_corrige2":"Ariane Sergerie",
    "nom_famille":"Sergerie",
    "titre_genre2":"Conseillère",
    "remuneration":"2184",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3276",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":5087,
    "nom_corrige2":"Étienne Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"2184",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3276",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":5088,
    "nom_corrige2":"Patrick Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"2184",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3276",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":5089,
    "nom_corrige2":"Simon Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"2184",
    "allocation":"1092",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3276",
    "ville":"Saint-Donat",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"904"
  },
  {
    "ID":5090,
    "nom_corrige2":"Alexandre Talbot",
    "nom_famille":"Talbot",
    "titre_genre2":"Conseiller",
    "remuneration":"2178",
    "allocation":"1089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3267",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":5091,
    "nom_corrige2":"Justin Allard",
    "nom_famille":"Allard",
    "titre_genre2":"Conseiller",
    "remuneration":"2178",
    "allocation":"1089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3267",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":5092,
    "nom_corrige2":"Nathalie Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"2178",
    "allocation":"1089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3267",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":5093,
    "nom_corrige2":"Sarah Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"2178",
    "allocation":"1089",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3267",
    "ville":"Sainte-Séraphine",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"442"
  },
  {
    "ID":5094,
    "nom_corrige2":"Mélanie Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"2176",
    "allocation":"1088",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3264",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":5095,
    "nom_corrige2":"Pierre Bourassa",
    "nom_famille":"Bourassa",
    "titre_genre2":"Conseiller",
    "remuneration":"2323",
    "allocation":"936,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3259",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":5096,
    "nom_corrige2":"Stéphane Morneau",
    "nom_famille":"Morneau",
    "titre_genre2":"Conseiller",
    "remuneration":"2171",
    "allocation":"1085",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3256",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":5097,
    "nom_corrige2":"Clément Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"2171",
    "allocation":"1085",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3256",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":5098,
    "nom_corrige2":"Gabriel Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"2171",
    "allocation":"1085",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3256",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":5099,
    "nom_corrige2":"Jacques Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"2171",
    "allocation":"1085",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3256",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":5100,
    "nom_corrige2":"Lorraine Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"2171",
    "allocation":"1085",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3256",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":5101,
    "nom_corrige2":"Réal Petitclerc",
    "nom_famille":"Petitclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"2171",
    "allocation":"1085",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3256",
    "ville":"Saint-Marcel",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"430"
  },
  {
    "ID":5102,
    "nom_corrige2":"Marc Vallières",
    "nom_famille":"Vallières",
    "titre_genre2":"Conseiller",
    "remuneration":"2166",
    "allocation":"1083",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3249",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":5103,
    "nom_corrige2":"André Thibodeau",
    "nom_famille":"Thibodeau",
    "titre_genre2":"Conseiller",
    "remuneration":"2161",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3241",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":5104,
    "nom_corrige2":"Donald Couture",
    "nom_famille":"Couture",
    "titre_genre2":"Conseiller",
    "remuneration":"2241",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3241",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5105,
    "nom_corrige2":"François Binet",
    "nom_famille":"Binet",
    "titre_genre2":"Conseiller",
    "remuneration":"2160",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3240",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5106,
    "nom_corrige2":"Johanne Rheault",
    "nom_famille":"Rheault",
    "titre_genre2":"Conseillère",
    "remuneration":"2160",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3240",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5107,
    "nom_corrige2":"Michel Rivard",
    "nom_famille":"Rivard",
    "titre_genre2":"Conseiller",
    "remuneration":"2160",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3240",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5108,
    "nom_corrige2":"Régis Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"2160",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3240",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5109,
    "nom_corrige2":"Yvan Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"2160",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3240",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5110,
    "nom_corrige2":"Dominik Mihcaud",
    "nom_famille":"Mihcaud",
    "titre_genre2":"Conseiller",
    "remuneration":"2160",
    "allocation":"1080",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3240",
    "ville":"Sainte-Gertrude-Manneville",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5111,
    "nom_corrige2":"Daniel Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Conseiller",
    "remuneration":"2156",
    "allocation":"1078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3234",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":5112,
    "nom_corrige2":"Francis Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"2156",
    "allocation":"1078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3234",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":5113,
    "nom_corrige2":"Lucien Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"2156",
    "allocation":"1078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3234",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":5114,
    "nom_corrige2":"Marie-Ève Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseillère",
    "remuneration":"2156",
    "allocation":"1078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3234",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":5115,
    "nom_corrige2":"Mélanie Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"2156",
    "allocation":"1078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3234",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":5116,
    "nom_corrige2":"Sabrina Landry Court",
    "nom_famille":"Landry Court",
    "titre_genre2":"Conseillère",
    "remuneration":"2156",
    "allocation":"1078",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3234",
    "ville":"Ristigouche-Sud-Est",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"174"
  },
  {
    "ID":5117,
    "nom_corrige2":"Christopher Sherrington",
    "nom_famille":"Sherrington",
    "titre_genre2":"Conseiller",
    "remuneration":"2153",
    "allocation":"1077",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3230",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":5118,
    "nom_corrige2":"Christiane Guillemette",
    "nom_famille":"Guillemette",
    "titre_genre2":"Conseillère",
    "remuneration":"2153",
    "allocation":"1077",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3230",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5119,
    "nom_corrige2":"Roger Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2153",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3229",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":5120,
    "nom_corrige2":"Gervais Morissette",
    "nom_famille":"Morissette",
    "titre_genre2":"Conseiller",
    "remuneration":"2153",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3229",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":5121,
    "nom_corrige2":"Francis Dompierre",
    "nom_famille":"Dompierre",
    "titre_genre2":"Conseiller",
    "remuneration":"2153",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3229",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":5122,
    "nom_corrige2":"Sylvain Claveau",
    "nom_famille":"Claveau",
    "titre_genre2":"Conseiller",
    "remuneration":"2153",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3229",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":5123,
    "nom_corrige2":"Ziv Przytyk",
    "nom_famille":"Przytyk",
    "titre_genre2":"Conseiller",
    "remuneration":"2151",
    "allocation":"1076",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3227",
    "ville":"Barnston-Ouest",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"574"
  },
  {
    "ID":5124,
    "nom_corrige2":"Carl Dorval",
    "nom_famille":"Dorval",
    "titre_genre2":"Conseiller",
    "remuneration":"2115",
    "allocation":"1057",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3172",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":5125,
    "nom_corrige2":"Hugette Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseillère",
    "remuneration":"2115",
    "allocation":"1057",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3172",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":5126,
    "nom_corrige2":"Denis Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"2115",
    "allocation":"1057",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3172",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":5127,
    "nom_corrige2":"Réjean Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"2115",
    "allocation":"1057",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3172",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":5128,
    "nom_corrige2":"Michel Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"2165",
    "allocation":"1007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3172",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5129,
    "nom_corrige2":"Rita Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"2336",
    "allocation":"831,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3167",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":5130,
    "nom_corrige2":"Matthew Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2106",
    "allocation":"1053",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3159",
    "ville":"Dudswell",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1807"
  },
  {
    "ID":5131,
    "nom_corrige2":"Michel Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"1766",
    "allocation":"883,00$",
    "remuneration2":"336,00$",
    "allocation2":"168,00$",
    "total":"3153",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5132,
    "nom_corrige2":"Éric Gallant",
    "nom_famille":"Gallant",
    "titre_genre2":"Conseiller",
    "remuneration":"2102",
    "allocation":"1 051,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3153",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":5133,
    "nom_corrige2":"François Grondin",
    "nom_famille":"Grondin",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3144",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":5134,
    "nom_corrige2":"Gino Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3144",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":5135,
    "nom_corrige2":"Katy Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseillère",
    "remuneration":"2096",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3144",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":5136,
    "nom_corrige2":"Linda Vachon",
    "nom_famille":"Vachon",
    "titre_genre2":"Conseillère",
    "remuneration":"2096",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3144",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":5137,
    "nom_corrige2":"Marcel Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3144",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":5138,
    "nom_corrige2":"Patrice Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1048",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3144",
    "ville":"Saint-Jules",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"545"
  },
  {
    "ID":5139,
    "nom_corrige2":"Denis Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseiller",
    "remuneration":"2085",
    "allocation":"1042",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3127",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":5140,
    "nom_corrige2":"Robert Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"2085",
    "allocation":"1042",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3127",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":5141,
    "nom_corrige2":"Roger Tessier",
    "nom_famille":"Tessier",
    "titre_genre2":"Conseiller",
    "remuneration":"2085",
    "allocation":"1042",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3127",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":5142,
    "nom_corrige2":"Sébastien Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"2085",
    "allocation":"1042",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3127",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":5143,
    "nom_corrige2":"Alexandre Geoffroy",
    "nom_famille":"Geoffroy",
    "titre_genre2":"Conseiller",
    "remuneration":"2085",
    "allocation":"1042",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3127",
    "ville":"Lefebvre",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"925"
  },
  {
    "ID":5144,
    "nom_corrige2":"Luc Sirois",
    "nom_famille":"Sirois",
    "titre_genre2":"Conseiller",
    "remuneration":"2082",
    "allocation":"1041",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3123",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":5145,
    "nom_corrige2":"Michel Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2082",
    "allocation":"1041",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3123",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":5146,
    "nom_corrige2":"Serge Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseiller",
    "remuneration":"2082",
    "allocation":"1041",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3123",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":5147,
    "nom_corrige2":"Simon Bois",
    "nom_famille":"Bois",
    "titre_genre2":"Conseiller",
    "remuneration":"2082",
    "allocation":"1041",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3123",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":5148,
    "nom_corrige2":"Vicky Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"2082",
    "allocation":"1041",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3123",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":5149,
    "nom_corrige2":"Sylvain Cameron",
    "nom_famille":"Cameron",
    "titre_genre2":"Conseiller",
    "remuneration":"2081",
    "allocation":"1040",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3121",
    "ville":"Taschereau",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"917"
  },
  {
    "ID":5150,
    "nom_corrige2":"Sylvain Jutras (#4)",
    "nom_famille":"Jutras",
    "titre_genre2":"Conseiller",
    "remuneration":"2173",
    "allocation":"936,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3109",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":5151,
    "nom_corrige2":"Isablle Collin",
    "nom_famille":"Collin",
    "titre_genre2":"Conseillère",
    "remuneration":"2073",
    "allocation":"1 036,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3109",
    "ville":"Saint-François-de-la-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1590"
  },
  {
    "ID":5152,
    "nom_corrige2":"Éric Chastenay",
    "nom_famille":"Chastenay",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3098",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":5153,
    "nom_corrige2":"Jean-Marie Dionne",
    "nom_famille":"Dionne",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3098",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":5154,
    "nom_corrige2":"Michel Deshaies",
    "nom_famille":"Deshaies",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3098",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":5155,
    "nom_corrige2":"Pierre-Luc Blanchet",
    "nom_famille":"Blanchet",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3098",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":5156,
    "nom_corrige2":"Sébastien Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"2096",
    "allocation":"1002",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3098",
    "ville":"Sainte-Cécile-de-Lévrard",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"355"
  },
  {
    "ID":5157,
    "nom_corrige2":"Benoît Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseiller",
    "remuneration":"2075",
    "allocation":"1020",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3095",
    "ville":"Saint-Juste-du-Lac",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"550"
  },
  {
    "ID":5158,
    "nom_corrige2":"Thomas Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseiller",
    "remuneration":"2063",
    "allocation":"1031",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3094",
    "ville":"Saint-Célestin",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"600"
  },
  {
    "ID":5159,
    "nom_corrige2":"Roy Catto",
    "nom_famille":"Catto",
    "titre_genre2":"Conseiller",
    "remuneration":"2107",
    "allocation":"978,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3085",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"920"
  },
  {
    "ID":5160,
    "nom_corrige2":"Yves Bourassa",
    "nom_famille":"Bourassa",
    "titre_genre2":"Conseiller",
    "remuneration":"2049",
    "allocation":"1024",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3073",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":5161,
    "nom_corrige2":"Michel Ayotte",
    "nom_famille":"Ayotte",
    "titre_genre2":"Conseiller",
    "remuneration":"2049",
    "allocation":"1024",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3073",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":5162,
    "nom_corrige2":"Yannick Pressé",
    "nom_famille":"Pressé",
    "titre_genre2":"Conseiller",
    "remuneration":"2065",
    "allocation":"1007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3072",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5163,
    "nom_corrige2":"Catherine Legault",
    "nom_famille":"Legault",
    "titre_genre2":"Conseillère",
    "remuneration":"2038",
    "allocation":"1019",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3057",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":5164,
    "nom_corrige2":"Francine Rodrigue",
    "nom_famille":"Rodrigue",
    "titre_genre2":"Conseillère",
    "remuneration":"2038",
    "allocation":"1019",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3057",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":5165,
    "nom_corrige2":"Julie Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"2038",
    "allocation":"1019",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3057",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":5166,
    "nom_corrige2":"Maxime Alexandre",
    "nom_famille":"Alexandre",
    "titre_genre2":"Conseiller",
    "remuneration":"2038",
    "allocation":"1019",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3057",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":5167,
    "nom_corrige2":"Jacinthe Thiboutot",
    "nom_famille":"Thiboutot",
    "titre_genre2":"Conseillère",
    "remuneration":"2038",
    "allocation":"1019",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3057",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":5168,
    "nom_corrige2":"Marie-Ève Michauville",
    "nom_famille":"Michauville",
    "titre_genre2":"Conseillère",
    "remuneration":"2038",
    "allocation":"1019",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3057",
    "ville":"Saint-Germain-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"304"
  },
  {
    "ID":5169,
    "nom_corrige2":"Émile Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"2030",
    "allocation":"1020",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3050",
    "ville":"Sainte-Rita",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"315"
  },
  {
    "ID":5170,
    "nom_corrige2":"Georgette Clairmont",
    "nom_famille":"Clairmont",
    "titre_genre2":"Conseillère",
    "remuneration":"2029",
    "allocation":"1014",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3043",
    "ville":"Saint-Elzéar",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"460"
  },
  {
    "ID":5171,
    "nom_corrige2":"Caroline Sanfaçon",
    "nom_famille":"Sanfaçon",
    "titre_genre2":"Conseillère",
    "remuneration":"2098",
    "allocation":"936,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3034",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":5172,
    "nom_corrige2":"Véronique Lemire",
    "nom_famille":"Lemire",
    "titre_genre2":"Conseillère",
    "remuneration":"2022",
    "allocation":"1012",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3034",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":5173,
    "nom_corrige2":"Éric Guillot",
    "nom_famille":"Guillot",
    "titre_genre2":"Conseiller",
    "remuneration":"2015",
    "allocation":"1007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3022",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5174,
    "nom_corrige2":"Marc Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseiller",
    "remuneration":"2015",
    "allocation":"1007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3022",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5175,
    "nom_corrige2":"Maxime Guillot",
    "nom_famille":"Guillot",
    "titre_genre2":"Conseiller",
    "remuneration":"2015",
    "allocation":"1007",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3022",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5176,
    "nom_corrige2":"Édouard Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"2237",
    "allocation":"768,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3005",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":5177,
    "nom_corrige2":"Michel André Émond",
    "nom_famille":"André Émond",
    "titre_genre2":"Conseiller",
    "remuneration":"2000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3000",
    "ville":"Ormstown",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"4226"
  },
  {
    "ID":5178,
    "nom_corrige2":"Nancy Benoit",
    "nom_famille":"Benoit",
    "titre_genre2":"Conseillère",
    "remuneration":"2000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3000",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":5179,
    "nom_corrige2":"Josée Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"2000",
    "allocation":"1000",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"3000",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5180,
    "nom_corrige2":"Luc Bernèche",
    "nom_famille":"Bernèche",
    "titre_genre2":"Conseiller",
    "remuneration":"1999",
    "allocation":"999,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2998",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":5181,
    "nom_corrige2":"Josiane Tremblay",
    "nom_famille":"Tremblay",
    "titre_genre2":"Conseillère",
    "remuneration":"1997",
    "allocation":"999,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2996",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":5182,
    "nom_corrige2":"Daniel Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Conseiller",
    "remuneration":"1488",
    "allocation":"744,00$",
    "remuneration2":"744,00$",
    "allocation2":"0",
    "total":"2976",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":5183,
    "nom_corrige2":"Marc Regaudie",
    "nom_famille":"Regaudie",
    "titre_genre2":"Conseiller",
    "remuneration":"1980",
    "allocation":"990,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2970",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5184,
    "nom_corrige2":"Michelle St-Laurent",
    "nom_famille":"St-Laurent",
    "titre_genre2":"Conseillère",
    "remuneration":"1980",
    "allocation":"990,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2970",
    "ville":"Saint-Dominique-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"456"
  },
  {
    "ID":5185,
    "nom_corrige2":"Pierrette Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"1980",
    "allocation":"990,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2970",
    "ville":"Saint-Dominique-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"456"
  },
  {
    "ID":5186,
    "nom_corrige2":"Christiane Vaillancourt",
    "nom_famille":"Vaillancourt",
    "titre_genre2":"Conseillère",
    "remuneration":"1980",
    "allocation":"990,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2970",
    "ville":"Saint-Dominique-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"456"
  },
  {
    "ID":5187,
    "nom_corrige2":"Gilles Audet",
    "nom_famille":"Audet",
    "titre_genre2":"Conseiller",
    "remuneration":"1980",
    "allocation":"990,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2970",
    "ville":"Saint-Dominique-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"456"
  },
  {
    "ID":5188,
    "nom_corrige2":"Nicholas Paradis-Naud",
    "nom_famille":"Paradis-Naud",
    "titre_genre2":"Conseiller",
    "remuneration":"1980",
    "allocation":"990,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2970",
    "ville":"Saint-Dominique-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"456"
  },
  {
    "ID":5189,
    "nom_corrige2":"Pierre Dénommé",
    "nom_famille":"Dénommé",
    "titre_genre2":"Conseiller",
    "remuneration":"1974",
    "allocation":"987,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2961",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":5190,
    "nom_corrige2":"Pierre Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"1966",
    "allocation":"983,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2949",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":5191,
    "nom_corrige2":"Urbain Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseillère",
    "remuneration":"1966",
    "allocation":"983,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2949",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":5192,
    "nom_corrige2":"Yvan Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"1966",
    "allocation":"983,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2949",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":5193,
    "nom_corrige2":"Réjean Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseiller",
    "remuneration":"1966",
    "allocation":"983,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2949",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":5194,
    "nom_corrige2":"Alfred D'Amours",
    "nom_famille":"D'Amours",
    "titre_genre2":"Conseiller",
    "remuneration":"1966",
    "allocation":"983,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2949",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":5195,
    "nom_corrige2":"Louis-Régis Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"1966",
    "allocation":"983,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2949",
    "ville":"Sainte-Paule",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"254"
  },
  {
    "ID":5196,
    "nom_corrige2":"Réal East",
    "nom_famille":"East",
    "titre_genre2":"Conseiller",
    "remuneration":"1805",
    "allocation":"1142",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2947",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":5197,
    "nom_corrige2":"Geneviève Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseillère",
    "remuneration":"1964",
    "allocation":"982,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2946",
    "ville":"Sainte-Hélène-de-Chester",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"409"
  },
  {
    "ID":5198,
    "nom_corrige2":"Julie Hébert",
    "nom_famille":"Hébert",
    "titre_genre2":"Conseillère",
    "remuneration":"1656",
    "allocation":"828,00$",
    "remuneration2":"305,00$",
    "allocation2":"153,00$",
    "total":"2942",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":5199,
    "nom_corrige2":"Serge Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"1935",
    "allocation":"967,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2902",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5200,
    "nom_corrige2":"Charles Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"1935",
    "allocation":"967,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2902",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5201,
    "nom_corrige2":"René Frappier",
    "nom_famille":"Frappier",
    "titre_genre2":"Conseiller",
    "remuneration":"1935",
    "allocation":"967,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2902",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5202,
    "nom_corrige2":"Yves Frappier",
    "nom_famille":"Frappier",
    "titre_genre2":"Conseiller",
    "remuneration":"1935",
    "allocation":"967,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2902",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5203,
    "nom_corrige2":"Réjean Veillette",
    "nom_famille":"Veillette",
    "titre_genre2":"Conseiller",
    "remuneration":"1935",
    "allocation":"967,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2902",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5204,
    "nom_corrige2":"Michel Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseiller",
    "remuneration":"1948",
    "allocation":"936,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2884",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":5205,
    "nom_corrige2":"Claudine Vouligny",
    "nom_famille":"Vouligny",
    "titre_genre2":"Conseillère",
    "remuneration":"1948",
    "allocation":"936,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2884",
    "ville":"La Visitation-de-Yamaska",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"296"
  },
  {
    "ID":5206,
    "nom_corrige2":"Sébastien Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseiller",
    "remuneration":"1914",
    "allocation":"957,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2871",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":5207,
    "nom_corrige2":"Chantal Séguin",
    "nom_famille":"Séguin",
    "titre_genre2":"Conseillère",
    "remuneration":"1914",
    "allocation":"957,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2871",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":5208,
    "nom_corrige2":"Louis Touchette",
    "nom_famille":"Touchette",
    "titre_genre2":"Conseiller",
    "remuneration":"1914",
    "allocation":"957,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2871",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":5209,
    "nom_corrige2":"Sylvain Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"1914",
    "allocation":"957,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2871",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":5210,
    "nom_corrige2":"Yvon Paulin",
    "nom_famille":"Paulin",
    "titre_genre2":"Conseiller",
    "remuneration":"1914",
    "allocation":"957,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2871",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":5211,
    "nom_corrige2":"Yoland Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseiller",
    "remuneration":"1914",
    "allocation":"957,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2871",
    "ville":"Sainte-Françoise",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"500"
  },
  {
    "ID":5212,
    "nom_corrige2":"Marie-Claude Saucier",
    "nom_famille":"Saucier",
    "titre_genre2":"Conseillère",
    "remuneration":"1912",
    "allocation":"956,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2868",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":5213,
    "nom_corrige2":"Joel Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"2036",
    "allocation":"831,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2867",
    "ville":"Moffet",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"211"
  },
  {
    "ID":5214,
    "nom_corrige2":"Réjean Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseiller",
    "remuneration":"1805",
    "allocation":"1062",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2867",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":5215,
    "nom_corrige2":"Pierre Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"1905",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2857",
    "ville":"Saint-Pie",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"6040"
  },
  {
    "ID":5216,
    "nom_corrige2":"Gabrielle Trigaux",
    "nom_famille":"Trigaux",
    "titre_genre2":"Conseillère",
    "remuneration":"1905",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2857",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":5217,
    "nom_corrige2":"Kate St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseillère",
    "remuneration":"1905",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2857",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":5218,
    "nom_corrige2":"Denis Forest",
    "nom_famille":"Forest",
    "titre_genre2":"Conseiller",
    "remuneration":"1905",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2857",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":5219,
    "nom_corrige2":"Nicole Marcheterre",
    "nom_famille":"Marcheterre",
    "titre_genre2":"Conseillère",
    "remuneration":"1905",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2857",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":5220,
    "nom_corrige2":"Christian CHaumont",
    "nom_famille":"CHaumont",
    "titre_genre2":"Conseiller",
    "remuneration":"1905",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2857",
    "ville":"Baie-des-Sables",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"625"
  },
  {
    "ID":5221,
    "nom_corrige2":"Franciska Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"1901",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2853",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":5222,
    "nom_corrige2":"Michel Hallé",
    "nom_famille":"Hallé",
    "titre_genre2":"Conseiller",
    "remuneration":"1901",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2853",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":5223,
    "nom_corrige2":"Micheline Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"1901",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2853",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":5224,
    "nom_corrige2":"Réjean Hudon",
    "nom_famille":"Hudon",
    "titre_genre2":"Conseiller",
    "remuneration":"1901",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2853",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":5225,
    "nom_corrige2":"Hélène Dumont",
    "nom_famille":"Dumont",
    "titre_genre2":"Préfète suppléante",
    "remuneration":"1901",
    "allocation":"952,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2853",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":5226,
    "nom_corrige2":"Linda Pomerleau",
    "nom_famille":"Pomerleau",
    "titre_genre2":"Conseillère",
    "remuneration":"1899",
    "allocation":"949,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2848",
    "ville":"Nédélec",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"365"
  },
  {
    "ID":5227,
    "nom_corrige2":"France Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"1896",
    "allocation":"948,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2844",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":5228,
    "nom_corrige2":"Jennifer Ruel",
    "nom_famille":"Ruel",
    "titre_genre2":"Conseillère",
    "remuneration":"1888",
    "allocation":"944,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2832",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":5229,
    "nom_corrige2":"Denise Desmarais",
    "nom_famille":"Desmarais",
    "titre_genre2":"Conseillère",
    "remuneration":"1888",
    "allocation":"944,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2832",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":5230,
    "nom_corrige2":"Géraldine Chrétien",
    "nom_famille":"Chrétien",
    "titre_genre2":"Conseillère",
    "remuneration":"1888",
    "allocation":"944,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2832",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":5231,
    "nom_corrige2":"Gilberte Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseillère",
    "remuneration":"1888",
    "allocation":"944,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2832",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":5232,
    "nom_corrige2":"Jacques Joncas",
    "nom_famille":"Joncas",
    "titre_genre2":"Conseiller",
    "remuneration":"1888",
    "allocation":"944,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2832",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":5233,
    "nom_corrige2":"Jean Dallaire",
    "nom_famille":"Dallaire",
    "titre_genre2":"Conseiller",
    "remuneration":"1548",
    "allocation":"1274",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2822",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":5234,
    "nom_corrige2":"Kevin Stoddard",
    "nom_famille":"Stoddard",
    "titre_genre2":"Conseiller",
    "remuneration":"1864",
    "allocation":"932,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2796",
    "ville":"Richmond",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"3431"
  },
  {
    "ID":5235,
    "nom_corrige2":"Réjean Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"1909",
    "allocation":"879,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2788",
    "ville":"Shannon",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"6996"
  },
  {
    "ID":5236,
    "nom_corrige2":"Ludvig Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"1847",
    "allocation":"924,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2771",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":5237,
    "nom_corrige2":"Serge Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"1847",
    "allocation":"924,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2771",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":5238,
    "nom_corrige2":"Brigitte Martin",
    "nom_famille":"Martin",
    "titre_genre2":"Conseillère",
    "remuneration":"1847",
    "allocation":"924,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2771",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":5239,
    "nom_corrige2":"Pierre Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"1847",
    "allocation":"924,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2771",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":5240,
    "nom_corrige2":"Philippe Gaboury",
    "nom_famille":"Gaboury",
    "titre_genre2":"Conseiller",
    "remuneration":"1844",
    "allocation":"922,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2766",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":5241,
    "nom_corrige2":"Marlène Maranda",
    "nom_famille":"Maranda",
    "titre_genre2":"Conseillère",
    "remuneration":"1831",
    "allocation":"917,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2748",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5242,
    "nom_corrige2":"Valérie Beaurivage Vincent",
    "nom_famille":"Beaurivage Vincent",
    "titre_genre2":"Conseillère",
    "remuneration":"1830",
    "allocation":"915,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2745",
    "ville":"Calixa-Lavallée",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"530"
  },
  {
    "ID":5243,
    "nom_corrige2":"Dominique Bernard",
    "nom_famille":"Bernard",
    "titre_genre2":"Conseillère",
    "remuneration":"1825",
    "allocation":"912,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2737",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":5244,
    "nom_corrige2":"Mathieu Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"1825",
    "allocation":"912,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2737",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":5245,
    "nom_corrige2":"Linda Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseillère",
    "remuneration":"1825",
    "allocation":"912,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2737",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":5246,
    "nom_corrige2":"Michel Desjardins",
    "nom_famille":"Desjardins",
    "titre_genre2":"Conseiller",
    "remuneration":"1825",
    "allocation":"912,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2737",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":5247,
    "nom_corrige2":"Éric Langlois",
    "nom_famille":"Langlois",
    "titre_genre2":"Conseiller",
    "remuneration":"1825",
    "allocation":"912,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2737",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":5248,
    "nom_corrige2":"Marjolaine Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseillère",
    "remuneration":"1818",
    "allocation":"909,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2727",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":5249,
    "nom_corrige2":"Jacques L'Heureux",
    "nom_famille":"L'Heureux",
    "titre_genre2":"Conseiller",
    "remuneration":"1818",
    "allocation":"909,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2727",
    "ville":"Sainte-Hénédine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1513"
  },
  {
    "ID":5250,
    "nom_corrige2":"Vicky Brunet",
    "nom_famille":"Brunet",
    "titre_genre2":"",
    "remuneration":"1884",
    "allocation":"842,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2726",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5251,
    "nom_corrige2":"Donald Belley",
    "nom_famille":"Belley",
    "titre_genre2":"Conseiller",
    "remuneration":"1810",
    "allocation":"915,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2725",
    "ville":"Notre-Dame-des-Monts",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"820"
  },
  {
    "ID":5252,
    "nom_corrige2":"Jason Charland",
    "nom_famille":"Charland",
    "titre_genre2":"Conseiller",
    "remuneration":"1848",
    "allocation":"874,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2722",
    "ville":"Maricourt",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"479"
  },
  {
    "ID":5253,
    "nom_corrige2":"Claude Kenty",
    "nom_famille":"Kenty",
    "titre_genre2":"Conseiller",
    "remuneration":"1815",
    "allocation":"907,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2722",
    "ville":"Sainte-Jeanne-d'Arc",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"1122"
  },
  {
    "ID":5254,
    "nom_corrige2":"Donatien Boucher",
    "nom_famille":"Boucher",
    "titre_genre2":"Conseiller",
    "remuneration":"1803",
    "allocation":"902,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":5255,
    "nom_corrige2":"Florent Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseiller",
    "remuneration":"1803",
    "allocation":"902,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":5256,
    "nom_corrige2":"Bernard Tardif",
    "nom_famille":"Tardif",
    "titre_genre2":"Conseiller",
    "remuneration":"1803",
    "allocation":"902,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":5257,
    "nom_corrige2":"Marie-Rose Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseillère",
    "remuneration":"1803",
    "allocation":"902,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":5258,
    "nom_corrige2":"Pierre Bérubé",
    "nom_famille":"Bérubé",
    "titre_genre2":"Conseiller",
    "remuneration":"1803",
    "allocation":"902,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":5259,
    "nom_corrige2":"Sony Sirois",
    "nom_famille":"Sirois",
    "titre_genre2":"Conseiller",
    "remuneration":"1803",
    "allocation":"902,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-François-Xavier-de-Viger",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"248"
  },
  {
    "ID":5260,
    "nom_corrige2":"Cathy Santerre",
    "nom_famille":"Santerre",
    "titre_genre2":"Conseillère",
    "remuneration":"1824",
    "allocation":"881,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":5261,
    "nom_corrige2":"Jean-Pierre Beaupré",
    "nom_famille":"Beaupré",
    "titre_genre2":"Conseiller",
    "remuneration":"1824",
    "allocation":"881,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":5262,
    "nom_corrige2":"Monique Blanchette",
    "nom_famille":"Blanchette",
    "titre_genre2":"Conseillère",
    "remuneration":"1824",
    "allocation":"881,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":5263,
    "nom_corrige2":"Guy Plourde",
    "nom_famille":"Plourde",
    "titre_genre2":"Conseiller",
    "remuneration":"1824",
    "allocation":"881,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":5264,
    "nom_corrige2":"Geneviève Verreault",
    "nom_famille":"Verreault",
    "titre_genre2":"Conseiller",
    "remuneration":"1824",
    "allocation":"881,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2705",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":5265,
    "nom_corrige2":"Jessica Aumond Beaupré",
    "nom_famille":"Aumond Beaupré",
    "titre_genre2":"Conseillère",
    "remuneration":"1800",
    "allocation":"900,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2700",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":5266,
    "nom_corrige2":"Joey Gaudet",
    "nom_famille":"Gaudet",
    "titre_genre2":"Conseiller",
    "remuneration":"1800",
    "allocation":"900,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2700",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":5267,
    "nom_corrige2":"Onil Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseiller",
    "remuneration":"1800",
    "allocation":"900,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2700",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":5268,
    "nom_corrige2":"Yvon Plante",
    "nom_famille":"Plante",
    "titre_genre2":"Conseiller",
    "remuneration":"1800",
    "allocation":"900,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2700",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":5269,
    "nom_corrige2":"Nadia Beaupré L'Heureux",
    "nom_famille":"Beaupré L'Heureux",
    "titre_genre2":"Conseillère",
    "remuneration":"1800",
    "allocation":"900,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2700",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":5270,
    "nom_corrige2":"Cynthia Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"1798",
    "allocation":"899,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2697",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":5271,
    "nom_corrige2":"Stéphane Lamarre",
    "nom_famille":"Lamarre",
    "titre_genre2":"Conseiller",
    "remuneration":"2032",
    "allocation":"664,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2696",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":5272,
    "nom_corrige2":"Lucie Grenier",
    "nom_famille":"Grenier",
    "titre_genre2":"Conseillère",
    "remuneration":"1789",
    "allocation":"894,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2683",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":5273,
    "nom_corrige2":"Dany Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"1781",
    "allocation":"891,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2672",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":5274,
    "nom_corrige2":"Denis Sansoucy",
    "nom_famille":"Sansoucy",
    "titre_genre2":"Conseiller",
    "remuneration":"1776",
    "allocation":"888,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2664",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":5275,
    "nom_corrige2":"Chelsea Sutton",
    "nom_famille":"Sutton",
    "titre_genre2":"Conseillère",
    "remuneration":"1775",
    "allocation":"888,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2663",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":5276,
    "nom_corrige2":"Chantal Godbout",
    "nom_famille":"Godbout",
    "titre_genre2":"Conseillère",
    "remuneration":"1641",
    "allocation":"1020",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2661",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":5277,
    "nom_corrige2":"Lucie Cantin",
    "nom_famille":"Cantin",
    "titre_genre2":"Conseillère",
    "remuneration":"1766",
    "allocation":"883,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2649",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5278,
    "nom_corrige2":"Mario Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"1766",
    "allocation":"883,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2649",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5279,
    "nom_corrige2":"Jules Blais",
    "nom_famille":"Blais",
    "titre_genre2":"Conseiller",
    "remuneration":"1766",
    "allocation":"883,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2649",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5280,
    "nom_corrige2":"Sylvain Proulx",
    "nom_famille":"Proulx",
    "titre_genre2":"Conseiller",
    "remuneration":"1747",
    "allocation":"874,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2621",
    "ville":"Dosquet",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"932"
  },
  {
    "ID":5281,
    "nom_corrige2":"Vanessa Gravel",
    "nom_famille":"Gravel",
    "titre_genre2":"Conseillère",
    "remuneration":"1743",
    "allocation":"871,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2614",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5282,
    "nom_corrige2":"Valérie Potvin",
    "nom_famille":"Potvin",
    "titre_genre2":"Conseillère",
    "remuneration":"1741",
    "allocation":"870,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2611",
    "ville":"Albertville",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"253"
  },
  {
    "ID":5283,
    "nom_corrige2":"Luc St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"1739",
    "allocation":"870,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2609",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":5284,
    "nom_corrige2":"Patrick Cyr",
    "nom_famille":"Cyr",
    "titre_genre2":"Conseiller",
    "remuneration":"1739",
    "allocation":"870,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2609",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":5285,
    "nom_corrige2":"Éric Laflamme",
    "nom_famille":"Laflamme",
    "titre_genre2":"Conseiller",
    "remuneration":"1717",
    "allocation":"859,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2576",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":5286,
    "nom_corrige2":"Geneviève Emery",
    "nom_famille":"Emery",
    "titre_genre2":"Conseillère",
    "remuneration":"1717",
    "allocation":"859,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2576",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":5287,
    "nom_corrige2":"Janick Fournier",
    "nom_famille":"Fournier",
    "titre_genre2":"Conseillère",
    "remuneration":"1716",
    "allocation":"858,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2574",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":5288,
    "nom_corrige2":"Hélène Larose",
    "nom_famille":"Larose",
    "titre_genre2":"Conseillère",
    "remuneration":"1716",
    "allocation":"858,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2574",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":5289,
    "nom_corrige2":"Jocelyn Marleau",
    "nom_famille":"Marleau",
    "titre_genre2":"Conseiller",
    "remuneration":"1716",
    "allocation":"858,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2574",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":5290,
    "nom_corrige2":"Joel Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"1716",
    "allocation":"858,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2574",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":5291,
    "nom_corrige2":"Michael Darveau",
    "nom_famille":"Darveau",
    "titre_genre2":"Conseiller",
    "remuneration":"1716",
    "allocation":"858,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2574",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":5292,
    "nom_corrige2":"Ambroise Lycke",
    "nom_famille":"Lycke",
    "titre_genre2":"Conseillère",
    "remuneration":"1716",
    "allocation":"858,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2574",
    "ville":"Saint-Eugène-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"467"
  },
  {
    "ID":5293,
    "nom_corrige2":"Germain Therriault",
    "nom_famille":"Therriault",
    "titre_genre2":"Conseiller",
    "remuneration":"1703",
    "allocation":"851,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2554",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":5294,
    "nom_corrige2":"Samanta Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Conseillère",
    "remuneration":"1701",
    "allocation":"850,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2551",
    "ville":"East Broughton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2349"
  },
  {
    "ID":5295,
    "nom_corrige2":"Marianne Morency-Landry",
    "nom_famille":"Morency-Landry",
    "titre_genre2":"Conseillère",
    "remuneration":"1784",
    "allocation":"765,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2549",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5296,
    "nom_corrige2":"Bruno Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"1613",
    "allocation":"928,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2541",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":5297,
    "nom_corrige2":"Cathy Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"1613",
    "allocation":"928,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2541",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":5298,
    "nom_corrige2":"Robert Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"1613",
    "allocation":"928,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2541",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":5299,
    "nom_corrige2":"Viky Goyette",
    "nom_famille":"Goyette",
    "titre_genre2":"Conseillère",
    "remuneration":"1613",
    "allocation":"928,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2541",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":5300,
    "nom_corrige2":"Michael Dupuis-Douligny",
    "nom_famille":"Dupuis-Douligny",
    "titre_genre2":"Conseiller",
    "remuneration":"1613",
    "allocation":"928,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2541",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":5301,
    "nom_corrige2":"Stéphanie Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseillère",
    "remuneration":"1613",
    "allocation":"928,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2541",
    "ville":"Clermont",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"477"
  },
  {
    "ID":5302,
    "nom_corrige2":"Jacques Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseiller",
    "remuneration":"1693",
    "allocation":"847,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2540",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":5303,
    "nom_corrige2":"Benjamin Brunet-Duclos",
    "nom_famille":"Brunet-Duclos",
    "titre_genre2":"Conseiller",
    "remuneration":"1684",
    "allocation":"842,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2526",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5304,
    "nom_corrige2":"Fanny Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseillère",
    "remuneration":"1684",
    "allocation":"842,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2526",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5305,
    "nom_corrige2":"Richard Moreau",
    "nom_famille":"Moreau",
    "titre_genre2":"Conseiller",
    "remuneration":"1684",
    "allocation":"842,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2526",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5306,
    "nom_corrige2":"Marcel Tringle",
    "nom_famille":"Tringle",
    "titre_genre2":"Conseiller",
    "remuneration":"1683",
    "allocation":"841,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2524",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":5307,
    "nom_corrige2":"André St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"1683",
    "allocation":"841,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2524",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":5308,
    "nom_corrige2":"Denis Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Conseiller",
    "remuneration":"1683",
    "allocation":"841,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2524",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":5309,
    "nom_corrige2":"Karole Thibault",
    "nom_famille":"Thibault",
    "titre_genre2":"Conseillère",
    "remuneration":"1683",
    "allocation":"841,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2524",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":5310,
    "nom_corrige2":"Claude Patry",
    "nom_famille":"Patry",
    "titre_genre2":"Conseiller",
    "remuneration":"1683",
    "allocation":"841,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2524",
    "ville":"Saint-Athanase",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"308"
  },
  {
    "ID":5311,
    "nom_corrige2":"Germain Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"1471",
    "allocation":"735,00$",
    "remuneration2":"203,00$",
    "allocation2":"101,00$",
    "total":"2510",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5312,
    "nom_corrige2":"Guy Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"1795",
    "allocation":"710,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2505",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":5313,
    "nom_corrige2":"Véronique Hince",
    "nom_famille":"Hince",
    "titre_genre2":"Conseillère",
    "remuneration":"1666",
    "allocation":"833,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2499",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":5314,
    "nom_corrige2":"François Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Conseiller",
    "remuneration":"1666",
    "allocation":"833,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2499",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":5315,
    "nom_corrige2":"Angèle Auger",
    "nom_famille":"Auger",
    "titre_genre2":"Conseillère",
    "remuneration":"1666",
    "allocation":"833,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2499",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":5316,
    "nom_corrige2":"Cindy Demers",
    "nom_famille":"Demers",
    "titre_genre2":"Conseillère",
    "remuneration":"1666",
    "allocation":"833,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2499",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":5317,
    "nom_corrige2":"Ghislain Desaulniers",
    "nom_famille":"Desaulniers",
    "titre_genre2":"Conseiller",
    "remuneration":"1666",
    "allocation":"833,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2499",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":5318,
    "nom_corrige2":"Nathalie Gaudette",
    "nom_famille":"Gaudette",
    "titre_genre2":"Conseillère",
    "remuneration":"1666",
    "allocation":"833,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2499",
    "ville":"Authier",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"287"
  },
  {
    "ID":5319,
    "nom_corrige2":"Jinny Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"1660",
    "allocation":"830,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2490",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":5320,
    "nom_corrige2":"Gilbert Leclerc",
    "nom_famille":"Leclerc",
    "titre_genre2":"Conseiller",
    "remuneration":"1660",
    "allocation":"830,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2490",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":5321,
    "nom_corrige2":"Marcel Pilote",
    "nom_famille":"Pilote",
    "titre_genre2":"Conseiller",
    "remuneration":"1660",
    "allocation":"830,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2490",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":5322,
    "nom_corrige2":"Rachid Aniss",
    "nom_famille":"Aniss",
    "titre_genre2":"Conseiller",
    "remuneration":"1660",
    "allocation":"830,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2490",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":5323,
    "nom_corrige2":"Réal Roy",
    "nom_famille":"Roy",
    "titre_genre2":"Préfet suppléant",
    "remuneration":"1660",
    "allocation":"830,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2490",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":5324,
    "nom_corrige2":"François Pilote",
    "nom_famille":"Pilote",
    "titre_genre2":"Conseiller",
    "remuneration":"1660",
    "allocation":"830,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2490",
    "ville":"Saint-Alexandre-des-Lacs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"306"
  },
  {
    "ID":5325,
    "nom_corrige2":"François Bégin",
    "nom_famille":"Bégin",
    "titre_genre2":"Conseiller",
    "remuneration":"1656",
    "allocation":"828,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2484",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":5326,
    "nom_corrige2":"Gilles Larivière",
    "nom_famille":"Larivière",
    "titre_genre2":"Conseiller",
    "remuneration":"1656",
    "allocation":"828,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2484",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":5327,
    "nom_corrige2":"Jean-Yves Busque",
    "nom_famille":"Busque",
    "titre_genre2":"Conseiller",
    "remuneration":"1656",
    "allocation":"828,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2484",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":5328,
    "nom_corrige2":"Katy Campeau",
    "nom_famille":"Campeau",
    "titre_genre2":"Conseillère",
    "remuneration":"1656",
    "allocation":"828,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2484",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":5329,
    "nom_corrige2":"Johanne Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseillère",
    "remuneration":"1770",
    "allocation":"710,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2480",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":5330,
    "nom_corrige2":"Robert Charest",
    "nom_famille":"Charest",
    "titre_genre2":"Conseiller",
    "remuneration":"1672",
    "allocation":"808,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2480",
    "ville":"Saint-Vianney",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"438"
  },
  {
    "ID":5331,
    "nom_corrige2":"Robert Staniforth",
    "nom_famille":"Staniforth",
    "titre_genre2":"Conseiller",
    "remuneration":"1649",
    "allocation":"824,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2473",
    "ville":"Saint-Sixte",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"551"
  },
  {
    "ID":5332,
    "nom_corrige2":"Alain Sasseville",
    "nom_famille":"Sasseville",
    "titre_genre2":"Conseiller",
    "remuneration":"1648",
    "allocation":"824,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2472",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":5333,
    "nom_corrige2":"Alexandre Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseiller",
    "remuneration":"1648",
    "allocation":"824,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2472",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":5334,
    "nom_corrige2":"Camille Sasseville",
    "nom_famille":"Sasseville",
    "titre_genre2":"Conseillère",
    "remuneration":"1648",
    "allocation":"824,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2472",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":5335,
    "nom_corrige2":"Dario Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseiller",
    "remuneration":"1648",
    "allocation":"824,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2472",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":5336,
    "nom_corrige2":"Véronique Belley",
    "nom_famille":"Belley",
    "titre_genre2":"Conseillère",
    "remuneration":"1648",
    "allocation":"824,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2472",
    "ville":"Saint-Eugène-d'Argentenay",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"482"
  },
  {
    "ID":5337,
    "nom_corrige2":"Benoit Paquette",
    "nom_famille":"Paquette",
    "titre_genre2":"Conseiller",
    "remuneration":"1643",
    "allocation":"822,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2465",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":5338,
    "nom_corrige2":"Stéphane Vincelette",
    "nom_famille":"Vincelette",
    "titre_genre2":"Conseiller",
    "remuneration":"1643",
    "allocation":"822,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2465",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":5339,
    "nom_corrige2":"Stefano Gianoli",
    "nom_famille":"Gianoli",
    "titre_genre2":"Conseiller",
    "remuneration":"1643",
    "allocation":"822,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2465",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":5340,
    "nom_corrige2":"Myriam Normandin",
    "nom_famille":"Normandin",
    "titre_genre2":"Conseillère",
    "remuneration":"1643",
    "allocation":"822,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2465",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":5341,
    "nom_corrige2":"Jean-François Veilleux",
    "nom_famille":"Veilleux",
    "titre_genre2":"Conseiller",
    "remuneration":"1643",
    "allocation":"822,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2465",
    "ville":"Saint-Elphège",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"255"
  },
  {
    "ID":5342,
    "nom_corrige2":"Gaétan Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"1745",
    "allocation":"710,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2455",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":5343,
    "nom_corrige2":"Cathy Perreault",
    "nom_famille":"Perreault",
    "titre_genre2":"Conseillère",
    "remuneration":"1745",
    "allocation":"710,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2455",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":5344,
    "nom_corrige2":"Styves Laprise",
    "nom_famille":"Laprise",
    "titre_genre2":"Conseiller",
    "remuneration":"1627",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2440",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5345,
    "nom_corrige2":"Eric Talbot",
    "nom_famille":"Talbot",
    "titre_genre2":"Conseiller",
    "remuneration":"1627",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2440",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5346,
    "nom_corrige2":"Denis Laprise",
    "nom_famille":"Laprise",
    "titre_genre2":"Conseiller",
    "remuneration":"1627",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2440",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5347,
    "nom_corrige2":"Jean-Claude Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseiller",
    "remuneration":"1627",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2440",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5348,
    "nom_corrige2":"André Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseiller",
    "remuneration":"1625",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2438",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":5349,
    "nom_corrige2":"Diane Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"1625",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2438",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":5350,
    "nom_corrige2":"Julie Paquin",
    "nom_famille":"Paquin",
    "titre_genre2":"Conseiller",
    "remuneration":"1625",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2438",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":5351,
    "nom_corrige2":"Pierrette Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"1625",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2438",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":5352,
    "nom_corrige2":"Cecile Pichette",
    "nom_famille":"Pichette",
    "titre_genre2":"Conseillère",
    "remuneration":"1625",
    "allocation":"813,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2438",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":5353,
    "nom_corrige2":"Charles Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"1610",
    "allocation":"804,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2414",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":5354,
    "nom_corrige2":"Philippe De Carufel",
    "nom_famille":"De Carufel",
    "titre_genre2":"Conseiller",
    "remuneration":"1610",
    "allocation":"804,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2414",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":5355,
    "nom_corrige2":"Martin Arguin",
    "nom_famille":"Arguin",
    "titre_genre2":"Conseiller",
    "remuneration":"1609",
    "allocation":"804,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2413",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":5356,
    "nom_corrige2":"Éric Lalonde",
    "nom_famille":"Lalonde",
    "titre_genre2":"Conseiller",
    "remuneration":"1604",
    "allocation":"802,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2406",
    "ville":"Béarn",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"772"
  },
  {
    "ID":5357,
    "nom_corrige2":"Yves Rainville",
    "nom_famille":"Rainville",
    "titre_genre2":"Conseiller",
    "remuneration":"1600",
    "allocation":"800,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2400",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":5358,
    "nom_corrige2":"Cindy Coderre",
    "nom_famille":"Coderre",
    "titre_genre2":"Conseillère",
    "remuneration":"1600",
    "allocation":"800,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2400",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":5359,
    "nom_corrige2":"Nicole Lefebvre",
    "nom_famille":"Lefebvre",
    "titre_genre2":"Conseillère",
    "remuneration":"1600",
    "allocation":"800,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2400",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":5360,
    "nom_corrige2":"Samantha Dufresne",
    "nom_famille":"Dufresne",
    "titre_genre2":"Conseillère",
    "remuneration":"1600",
    "allocation":"800,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2400",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":5361,
    "nom_corrige2":"André Laterreur",
    "nom_famille":"Laterreur",
    "titre_genre2":"Conseiller",
    "remuneration":"1592",
    "allocation":"796,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2388",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":5362,
    "nom_corrige2":"Marie-Pier Leblanc",
    "nom_famille":"Leblanc",
    "titre_genre2":"Conseillère",
    "remuneration":"1670",
    "allocation":"710,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2380",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":5363,
    "nom_corrige2":"Norman Rainville",
    "nom_famille":"Rainville",
    "titre_genre2":"Conseiller",
    "remuneration":"1586",
    "allocation":"793,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2379",
    "ville":"La Durantaye",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"817"
  },
  {
    "ID":5364,
    "nom_corrige2":"Benoît Dancause",
    "nom_famille":"Dancause",
    "titre_genre2":"Conseiller",
    "remuneration":"1575",
    "allocation":"",
    "remuneration2":"788,00$",
    "allocation2":"0",
    "total":"2363",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":5365,
    "nom_corrige2":"Pascal Vallée",
    "nom_famille":"Vallée",
    "titre_genre2":"Conseillère",
    "remuneration":"1575",
    "allocation":"",
    "remuneration2":"788,00$",
    "allocation2":"0",
    "total":"2363",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":5366,
    "nom_corrige2":"Anne Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseillère",
    "remuneration":"1575",
    "allocation":"",
    "remuneration2":"788,00$",
    "allocation2":"0",
    "total":"2363",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":5367,
    "nom_corrige2":"Linda Giroux",
    "nom_famille":"Giroux",
    "titre_genre2":"Conseillère",
    "remuneration":"1575",
    "allocation":"",
    "remuneration2":"788,00$",
    "allocation2":"0",
    "total":"2363",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":5368,
    "nom_corrige2":"Roch Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseiller",
    "remuneration":"1575",
    "allocation":"",
    "remuneration2":"788,00$",
    "allocation2":"0",
    "total":"2363",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":5369,
    "nom_corrige2":"Denis Lévesques",
    "nom_famille":"Lévesques",
    "titre_genre2":"Conseiller",
    "remuneration":"1575",
    "allocation":"",
    "remuneration2":"788,00$",
    "allocation2":"0",
    "total":"2363",
    "ville":"Lac-Poulin",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"176"
  },
  {
    "ID":5370,
    "nom_corrige2":"Jean-François Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"1573",
    "allocation":"787,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2360",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":5371,
    "nom_corrige2":"Caroline Gignac",
    "nom_famille":"Gignac",
    "titre_genre2":"Conseillère",
    "remuneration":"1561",
    "allocation":"780,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2341",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":5372,
    "nom_corrige2":"David Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"1561",
    "allocation":"780,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2341",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":5373,
    "nom_corrige2":"François Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"1561",
    "allocation":"780,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2341",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":5374,
    "nom_corrige2":"Huguette Chalifour",
    "nom_famille":"Chalifour",
    "titre_genre2":"Conseillère",
    "remuneration":"1561",
    "allocation":"780,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2341",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":5375,
    "nom_corrige2":"Luc Gignac",
    "nom_famille":"Gignac",
    "titre_genre2":"Conseiller",
    "remuneration":"1561",
    "allocation":"780,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2341",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":5376,
    "nom_corrige2":"Raymond Groleau",
    "nom_famille":"Groleau",
    "titre_genre2":"Conseiller",
    "remuneration":"1561",
    "allocation":"780,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2341",
    "ville":"Saint-Gilbert",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"296"
  },
  {
    "ID":5377,
    "nom_corrige2":"Hugues Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseiller",
    "remuneration":"1620",
    "allocation":"710,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2330",
    "ville":"Saint-Noël",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"372"
  },
  {
    "ID":5378,
    "nom_corrige2":"Tony Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"1548",
    "allocation":"774,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2322",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":5379,
    "nom_corrige2":"Vincent Nadeau",
    "nom_famille":"Nadeau",
    "titre_genre2":"Conseiller",
    "remuneration":"1548",
    "allocation":"774,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2322",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":5380,
    "nom_corrige2":"Marie-Jeanne Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"1548",
    "allocation":"774,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2322",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":5381,
    "nom_corrige2":"France Loignon",
    "nom_famille":"Loignon",
    "titre_genre2":"Conseillère",
    "remuneration":"1548",
    "allocation":"774,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2322",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":5382,
    "nom_corrige2":"René Drouin",
    "nom_famille":"Drouin",
    "titre_genre2":"Conseiller",
    "remuneration":"1548",
    "allocation":"774,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2322",
    "ville":"Saint-Philibert",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"365"
  },
  {
    "ID":5383,
    "nom_corrige2":"Christiane Blouin",
    "nom_famille":"Blouin",
    "titre_genre2":"Conseillère",
    "remuneration":"1534",
    "allocation":"767,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2301",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":5384,
    "nom_corrige2":"Francis Danis",
    "nom_famille":"Danis",
    "titre_genre2":"Conseiller",
    "remuneration":"1534",
    "allocation":"763,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2297",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":5385,
    "nom_corrige2":"Johanne Thibeault",
    "nom_famille":"Thibeault",
    "titre_genre2":"Conseillère",
    "remuneration":"1524",
    "allocation":"762,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2286",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":5386,
    "nom_corrige2":"Nathalie Pronovost",
    "nom_famille":"Pronovost",
    "titre_genre2":"Conseillère",
    "remuneration":"1524",
    "allocation":"762,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2286",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":5387,
    "nom_corrige2":"Catherine Bolduc",
    "nom_famille":"Bolduc",
    "titre_genre2":"Conseillère",
    "remuneration":"1524",
    "allocation":"762,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2286",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":5388,
    "nom_corrige2":"France Simard",
    "nom_famille":"Simard",
    "titre_genre2":"Conseillère",
    "remuneration":"1524",
    "allocation":"762,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2286",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":5389,
    "nom_corrige2":"Nancy Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseillère",
    "remuneration":"1524",
    "allocation":"762,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2286",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":5390,
    "nom_corrige2":"Yannick Charbonneau",
    "nom_famille":"Charbonneau",
    "titre_genre2":"Conseiller",
    "remuneration":"1524",
    "allocation":"762,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2286",
    "ville":"Saint-Stanislas",
    "arrondissement":"",
    "region_adm":"Saguenay–Lac-Saint-Jean",
    "population":"383"
  },
  {
    "ID":5391,
    "nom_corrige2":"Élise Lahaie",
    "nom_famille":"Lahaie",
    "titre_genre2":"Conseillère",
    "remuneration":"1518",
    "allocation":"759,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2277",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":5392,
    "nom_corrige2":"Claude Arsenault",
    "nom_famille":"Arsenault",
    "titre_genre2":"Conseiller",
    "remuneration":"1518",
    "allocation":"759,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2277",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":5393,
    "nom_corrige2":"Hedvika Brgles",
    "nom_famille":"Brgles",
    "titre_genre2":"Conseillère",
    "remuneration":"1518",
    "allocation":"759,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2277",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":5394,
    "nom_corrige2":"Marjolaine Paré",
    "nom_famille":"Paré",
    "titre_genre2":"Conseillère",
    "remuneration":"1518",
    "allocation":"759,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2277",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":5395,
    "nom_corrige2":"Martine Michaud",
    "nom_famille":"Michaud",
    "titre_genre2":"Conseillère",
    "remuneration":"1518",
    "allocation":"759,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2277",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":5396,
    "nom_corrige2":"Mario Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"1513",
    "allocation":"758,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2271",
    "ville":"Saint-Joseph-de-Lepage",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"577"
  },
  {
    "ID":5397,
    "nom_corrige2":"Jean-Marc Beauchemin",
    "nom_famille":"Beauchemin",
    "titre_genre2":"Conseiller",
    "remuneration":"1509",
    "allocation":"754,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2263",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":5398,
    "nom_corrige2":"Nicole Lafrance Dubord",
    "nom_famille":"Lafrance Dubord",
    "titre_genre2":"Conseillère",
    "remuneration":"1509",
    "allocation":"754,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2263",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":5399,
    "nom_corrige2":"Serge Hélie",
    "nom_famille":"Hélie",
    "titre_genre2":"Conseiller",
    "remuneration":"1509",
    "allocation":"754,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2263",
    "ville":"Saint-Wenceslas",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"1196"
  },
  {
    "ID":5400,
    "nom_corrige2":"Nathalie Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseillère",
    "remuneration":"1490",
    "allocation":"745,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2235",
    "ville":"Belleterre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"292"
  },
  {
    "ID":5401,
    "nom_corrige2":"Jessica Rousseau",
    "nom_famille":"Rousseau",
    "titre_genre2":"Conseillère",
    "remuneration":"1488",
    "allocation":"744,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2232",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":5402,
    "nom_corrige2":"Daniel Rioux",
    "nom_famille":"Rioux",
    "titre_genre2":"Conseiller",
    "remuneration":"1488",
    "allocation":"744,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2232",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":5403,
    "nom_corrige2":"Linda Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"1488",
    "allocation":"744,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2232",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":5404,
    "nom_corrige2":"Sébastien Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseiller",
    "remuneration":"1488",
    "allocation":"744,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2232",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":5405,
    "nom_corrige2":"Simon Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseiller",
    "remuneration":"1488",
    "allocation":"744,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2232",
    "ville":"Biencourt",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"425"
  },
  {
    "ID":5406,
    "nom_corrige2":"Gilles Goulet",
    "nom_famille":"Goulet",
    "titre_genre2":"Conseiller",
    "remuneration":"1492",
    "allocation":"718,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2210",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5407,
    "nom_corrige2":"Francis Fecteau",
    "nom_famille":"Fecteau",
    "titre_genre2":"Conseiller",
    "remuneration":"1472",
    "allocation":"736,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2208",
    "ville":"Saint-Victor",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2354"
  },
  {
    "ID":5408,
    "nom_corrige2":"Luc Trépanier",
    "nom_famille":"Trépanier",
    "titre_genre2":"Maire",
    "remuneration":"1470",
    "allocation":"735,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2205",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5409,
    "nom_corrige2":"Stéphane Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"1468",
    "allocation":"734,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2202",
    "ville":"Percé",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"3107"
  },
  {
    "ID":5410,
    "nom_corrige2":"Armande Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"1451",
    "allocation":"725,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2176",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5411,
    "nom_corrige2":"Stéphane Fillion",
    "nom_famille":"Fillion",
    "titre_genre2":"Conseiller",
    "remuneration":"1444",
    "allocation":"722,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2166",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5412,
    "nom_corrige2":"Denis Tanguay",
    "nom_famille":"Tanguay",
    "titre_genre2":"Conseiller",
    "remuneration":"1444",
    "allocation":"722,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2166",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5413,
    "nom_corrige2":"Francine Garneau",
    "nom_famille":"Garneau",
    "titre_genre2":"Conseillère",
    "remuneration":"1444",
    "allocation":"722,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2166",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5414,
    "nom_corrige2":"Luc Lachance",
    "nom_famille":"Lachance",
    "titre_genre2":"Conseiller",
    "remuneration":"1444",
    "allocation":"722,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2166",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5415,
    "nom_corrige2":"Étienne Prévost",
    "nom_famille":"Prévost",
    "titre_genre2":"Conseiller",
    "remuneration":"1438",
    "allocation":"718,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2156",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5416,
    "nom_corrige2":"Mélissa Perron",
    "nom_famille":"Perron",
    "titre_genre2":"Conseillère",
    "remuneration":"1423",
    "allocation":"712,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2135",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":5417,
    "nom_corrige2":"Claudette Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseillère",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":5418,
    "nom_corrige2":"Florent Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":5419,
    "nom_corrige2":"Ghislain Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":5420,
    "nom_corrige2":"Monia Cloutier",
    "nom_famille":"Cloutier",
    "titre_genre2":"Conseillère",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":5421,
    "nom_corrige2":"Raymonde Petitclerc",
    "nom_famille":"Petitclerc",
    "titre_genre2":"Conseillère",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":5422,
    "nom_corrige2":"Yvon Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseiller",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"Sainte-Hélène-de-Mancebourg",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"402"
  },
  {
    "ID":5423,
    "nom_corrige2":"France Massicotte",
    "nom_famille":"Massicotte",
    "titre_genre2":"Conseillère",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":5424,
    "nom_corrige2":"Louise Morin",
    "nom_famille":"Morin",
    "titre_genre2":"Conseillère",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":5425,
    "nom_corrige2":"Stéphanie Blouin Lacasse",
    "nom_famille":"Blouin Lacasse",
    "titre_genre2":"Conseillère",
    "remuneration":"1406",
    "allocation":"703,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2109",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":5426,
    "nom_corrige2":"Cynthia Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseillère",
    "remuneration":"1404",
    "allocation":"702,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2106",
    "ville":"Lebel-sur-Quévillon",
    "arrondissement":"",
    "region_adm":"Nord-du-Québec",
    "population":"2185"
  },
  {
    "ID":5427,
    "nom_corrige2":"Clermont Bossé",
    "nom_famille":"Bossé",
    "titre_genre2":"Conseiller",
    "remuneration":"1400",
    "allocation":"700,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2100",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":5428,
    "nom_corrige2":"Denyse Lacombe",
    "nom_famille":"Lacombe",
    "titre_genre2":"Conseillère",
    "remuneration":"1400",
    "allocation":"700,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2100",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":5429,
    "nom_corrige2":"Jimmy Samson",
    "nom_famille":"Samson",
    "titre_genre2":"Conseiller",
    "remuneration":"1400",
    "allocation":"700,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2100",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":5430,
    "nom_corrige2":"Marie-Anne Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseillère",
    "remuneration":"1400",
    "allocation":"700,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2100",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":5431,
    "nom_corrige2":"Rémi Gilbert",
    "nom_famille":"Gilbert",
    "titre_genre2":"Conseiller",
    "remuneration":"1400",
    "allocation":"700,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2100",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":5432,
    "nom_corrige2":"Laurier Fortin",
    "nom_famille":"Fortin",
    "titre_genre2":"Conseiller",
    "remuneration":"1400",
    "allocation":"700,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2100",
    "ville":"Launay",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"213"
  },
  {
    "ID":5433,
    "nom_corrige2":"Lisette Gosselin",
    "nom_famille":"Gosselin",
    "titre_genre2":"Conseillère",
    "remuneration":"1382",
    "allocation":"691,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2073",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":5434,
    "nom_corrige2":"François Décosse",
    "nom_famille":"Décosse",
    "titre_genre2":"Conseiller",
    "remuneration":"1380",
    "allocation":"690,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2070",
    "ville":"Coteau-du-Lac",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"7729"
  },
  {
    "ID":5435,
    "nom_corrige2":"Lorraine Dion",
    "nom_famille":"Dion",
    "titre_genre2":"Conseillère",
    "remuneration":"1379",
    "allocation":"689,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2068",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5436,
    "nom_corrige2":"Brandy Killeen",
    "nom_famille":"Killeen",
    "titre_genre2":"Conseillère",
    "remuneration":"1371",
    "allocation":"690,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Kazabazua",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"1093"
  },
  {
    "ID":5437,
    "nom_corrige2":"Chloé Roux",
    "nom_famille":"Roux",
    "titre_genre2":"Conseillère",
    "remuneration":"1374",
    "allocation":"687,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":5438,
    "nom_corrige2":"Jean-Marie Lavoie",
    "nom_famille":"Lavoie",
    "titre_genre2":"Conseiller",
    "remuneration":"1374",
    "allocation":"687,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":5439,
    "nom_corrige2":"Marianne Bergeron",
    "nom_famille":"Bergeron",
    "titre_genre2":"Conseillère",
    "remuneration":"1374",
    "allocation":"687,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":5440,
    "nom_corrige2":"Nancy Filiatrault",
    "nom_famille":"Filiatrault",
    "titre_genre2":"Conseillère",
    "remuneration":"1374",
    "allocation":"687,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":5441,
    "nom_corrige2":"Roger Paul",
    "nom_famille":"Paul",
    "titre_genre2":"Conseiller",
    "remuneration":"1374",
    "allocation":"687,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":5442,
    "nom_corrige2":"Réjean Dicaire",
    "nom_famille":"Dicaire",
    "titre_genre2":"Conseiller",
    "remuneration":"1374",
    "allocation":"687,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2061",
    "ville":"Val-Saint-Gilles",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"174"
  },
  {
    "ID":5443,
    "nom_corrige2":"Rémi Laprise",
    "nom_famille":"Laprise",
    "titre_genre2":"Conseiller",
    "remuneration":"1368",
    "allocation":"684,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2052",
    "ville":"Sainte-Apolline-de-Patton",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"532"
  },
  {
    "ID":5444,
    "nom_corrige2":"Michael Gagné",
    "nom_famille":"Gagné",
    "titre_genre2":"Conseiller",
    "remuneration":"1366",
    "allocation":"681,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2047",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":5445,
    "nom_corrige2":"Charles Méthé",
    "nom_famille":"Méthé",
    "titre_genre2":"Conseiller",
    "remuneration":"1362",
    "allocation":"681,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2043",
    "ville":"Notre-Dame-des-Sept-Douleurs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"72"
  },
  {
    "ID":5446,
    "nom_corrige2":"Joanie Harrison",
    "nom_famille":"Harrison",
    "titre_genre2":"Conseillère",
    "remuneration":"1362",
    "allocation":"681,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2043",
    "ville":"Notre-Dame-des-Sept-Douleurs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"72"
  },
  {
    "ID":5447,
    "nom_corrige2":"Luce Provencher",
    "nom_famille":"Provencher",
    "titre_genre2":"Conseillère",
    "remuneration":"1362",
    "allocation":"681,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2043",
    "ville":"Notre-Dame-des-Sept-Douleurs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"72"
  },
  {
    "ID":5448,
    "nom_corrige2":"André Contandriopoulos",
    "nom_famille":"Contandriopoulos",
    "titre_genre2":"Conseiller",
    "remuneration":"1362",
    "allocation":"681,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2043",
    "ville":"Notre-Dame-des-Sept-Douleurs",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"72"
  },
  {
    "ID":5449,
    "nom_corrige2":"Claude Marineau",
    "nom_famille":"Marineau",
    "titre_genre2":"Conseiller",
    "remuneration":"1350",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2025",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":5450,
    "nom_corrige2":"Gérard Mazerolle",
    "nom_famille":"Mazerolle",
    "titre_genre2":"Conseiller",
    "remuneration":"1350",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2025",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":5451,
    "nom_corrige2":"Gérard Richard",
    "nom_famille":"Richard",
    "titre_genre2":"Conseiller",
    "remuneration":"1350",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2025",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":5452,
    "nom_corrige2":"Gisèle Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseillère",
    "remuneration":"1350",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2025",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":5453,
    "nom_corrige2":"Nancy Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseillère",
    "remuneration":"1350",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2025",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":5454,
    "nom_corrige2":"Antoine Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Préfet suppléant",
    "remuneration":"1350",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2025",
    "ville":"Sainte-Florence",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"370"
  },
  {
    "ID":5455,
    "nom_corrige2":"Marc Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"1349",
    "allocation":"675,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2024",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":5456,
    "nom_corrige2":"Étienne Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"1855",
    "allocation":"166,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"2021",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":5457,
    "nom_corrige2":"Richard Bizier",
    "nom_famille":"Bizier",
    "titre_genre2":"Conseiller",
    "remuneration":"917,00$",
    "allocation":"429,00$",
    "remuneration2":"454,00$",
    "allocation2":"202,00$",
    "total":"2 002,00$",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5458,
    "nom_corrige2":"Jean-Marc Foster",
    "nom_famille":"Foster",
    "titre_genre2":"Conseiller",
    "remuneration":"1168",
    "allocation":"490,00$",
    "remuneration2":"300,00$",
    "allocation2":"0",
    "total":"1958",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5459,
    "nom_corrige2":"Jean-Yves D'Amboise",
    "nom_famille":"D'Amboise",
    "titre_genre2":"Conseiller",
    "remuneration":"1287",
    "allocation":"644,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1931",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":5460,
    "nom_corrige2":"Rodrigue Boudreault",
    "nom_famille":"Boudreault",
    "titre_genre2":"Conseiller",
    "remuneration":"1281",
    "allocation":"639,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1920",
    "ville":"L'Isle-aux-Coudres",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"1101"
  },
  {
    "ID":5461,
    "nom_corrige2":"Patrick Savard",
    "nom_famille":"Savard",
    "titre_genre2":"Conseiller",
    "remuneration":"1265",
    "allocation":"632,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1897",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":5462,
    "nom_corrige2":"Louis Baribeau",
    "nom_famille":"Baribeau",
    "titre_genre2":"Conseiller",
    "remuneration":"1265",
    "allocation":"632,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1897",
    "ville":"La Motte",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"510"
  },
  {
    "ID":5463,
    "nom_corrige2":"Thomas Daneau",
    "nom_famille":"Daneau",
    "titre_genre2":"Conseiller",
    "remuneration":"1262",
    "allocation":"631,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1893",
    "ville":"Havelock",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"742"
  },
  {
    "ID":5464,
    "nom_corrige2":"Jean-François Royer",
    "nom_famille":"Royer",
    "titre_genre2":"Conseiller",
    "remuneration":"1149",
    "allocation":"734,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1883",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":5465,
    "nom_corrige2":"Maude St-Hilaire",
    "nom_famille":"St-Hilaire",
    "titre_genre2":"Conseillère",
    "remuneration":"1267",
    "allocation":"613,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1880",
    "ville":"Hemmingford",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2180"
  },
  {
    "ID":5466,
    "nom_corrige2":"Michael Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"1252",
    "allocation":"626,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1878",
    "ville":"Wickham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"2777"
  },
  {
    "ID":5467,
    "nom_corrige2":"Valérie Lambert-Bélisle",
    "nom_famille":"Lambert-Bélisle",
    "titre_genre2":"Conseillère",
    "remuneration":"1251",
    "allocation":"625,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1876",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  },
  {
    "ID":5468,
    "nom_corrige2":"Josée Sirois",
    "nom_famille":"Sirois",
    "titre_genre2":"Conseillère",
    "remuneration":"1251",
    "allocation":"625,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1876",
    "ville":"Lac-des-Aigles",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"571"
  },
  {
    "ID":5469,
    "nom_corrige2":"Rosanne Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"1247",
    "allocation":"623,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1870",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":5470,
    "nom_corrige2":"Bernard Guibault",
    "nom_famille":"Guibault",
    "titre_genre2":"Conseiller",
    "remuneration":"1245",
    "allocation":"622,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1867",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":5471,
    "nom_corrige2":"Xavier Mantha",
    "nom_famille":"Mantha",
    "titre_genre2":"Conseiller",
    "remuneration":"1258",
    "allocation":"604,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1862",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5472,
    "nom_corrige2":"Micheline Beaulieu",
    "nom_famille":"Beaulieu",
    "titre_genre2":"Conseillère",
    "remuneration":"1236",
    "allocation":"618,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1854",
    "ville":"Saint-Zénon",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"1393"
  },
  {
    "ID":5473,
    "nom_corrige2":"Guillaume Poitras",
    "nom_famille":"Poitras",
    "titre_genre2":"Conseiller",
    "remuneration":"1202",
    "allocation":"652,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1854",
    "ville":"Baie-Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"164"
  },
  {
    "ID":5474,
    "nom_corrige2":"Manon Foster",
    "nom_famille":"Foster",
    "titre_genre2":"Conseillère",
    "remuneration":"1202",
    "allocation":"652,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1854",
    "ville":"Baie-Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"164"
  },
  {
    "ID":5475,
    "nom_corrige2":"Yvan Poitras",
    "nom_famille":"Poitras",
    "titre_genre2":"Conseiller",
    "remuneration":"1202",
    "allocation":"652,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1854",
    "ville":"Baie-Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"164"
  },
  {
    "ID":5476,
    "nom_corrige2":"Albert Dallaire",
    "nom_famille":"Dallaire",
    "titre_genre2":"Conseiller",
    "remuneration":"1202",
    "allocation":"652,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1854",
    "ville":"Baie-Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"164"
  },
  {
    "ID":5477,
    "nom_corrige2":"Odette Ouellet",
    "nom_famille":"Ouellet",
    "titre_genre2":"Conseillère",
    "remuneration":"1202",
    "allocation":"652,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1854",
    "ville":"Baie-Sainte-Catherine",
    "arrondissement":"",
    "region_adm":"Capitale-Nationale",
    "population":"164"
  },
  {
    "ID":5478,
    "nom_corrige2":"Claude Parent",
    "nom_famille":"Parent",
    "titre_genre2":"Conseiller",
    "remuneration":"1234",
    "allocation":"617,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1851",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5479,
    "nom_corrige2":"Sarto Pelletier",
    "nom_famille":"Pelletier",
    "titre_genre2":"Conseiller",
    "remuneration":"1231",
    "allocation":"616,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1847",
    "ville":"Lac-Frontière",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"172"
  },
  {
    "ID":5480,
    "nom_corrige2":"David Royer",
    "nom_famille":"Royer",
    "titre_genre2":"Conseiller",
    "remuneration":"1149",
    "allocation":"694,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1843",
    "ville":"La Reine",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"301"
  },
  {
    "ID":5481,
    "nom_corrige2":"Daniel Mercier",
    "nom_famille":"Mercier",
    "titre_genre2":"Conseiller",
    "remuneration":"1220",
    "allocation":"610,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1830",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5482,
    "nom_corrige2":"Johanne Cormier",
    "nom_famille":"Cormier",
    "titre_genre2":"Conseillère",
    "remuneration":"1201",
    "allocation":"601,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1802",
    "ville":"Aguanish",
    "arrondissement":"",
    "region_adm":"Côte-Nord",
    "population":"222"
  },
  {
    "ID":5483,
    "nom_corrige2":"Guy Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseiller",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Sainte-Anne-de-la-Pérade",
    "arrondissement":"",
    "region_adm":"Mauricie",
    "population":"2049"
  },
  {
    "ID":5484,
    "nom_corrige2":"Martin Brochu",
    "nom_famille":"Brochu",
    "titre_genre2":"Conseiller",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Guérin",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"326"
  },
  {
    "ID":5485,
    "nom_corrige2":"Jessy Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":5486,
    "nom_corrige2":"Jean-Claude Chouinard",
    "nom_famille":"Chouinard",
    "titre_genre2":"Conseiller",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":5487,
    "nom_corrige2":"Dany Thériault",
    "nom_famille":"Thériault",
    "titre_genre2":"Conseiller",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":5488,
    "nom_corrige2":"Line Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseillère",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":5489,
    "nom_corrige2":"Sylvain Carrier",
    "nom_famille":"Carrier",
    "titre_genre2":"Conseiller",
    "remuneration":"1200",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1800",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":5490,
    "nom_corrige2":"Caroline Lemieux",
    "nom_famille":"Lemieux",
    "titre_genre2":"Conseillère",
    "remuneration":"1199",
    "allocation":"600,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1799",
    "ville":"Saint-Gervais",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2213"
  },
  {
    "ID":5491,
    "nom_corrige2":"Jacinthe Fauvin",
    "nom_famille":"Fauvin",
    "titre_genre2":"Conseillère",
    "remuneration":"1194",
    "allocation":"598,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1792",
    "ville":"Saint-Cléophas",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"317"
  },
  {
    "ID":5492,
    "nom_corrige2":"Julie Lemay",
    "nom_famille":"Lemay",
    "titre_genre2":"Conseillère",
    "remuneration":"1175",
    "allocation":"588,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1763",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5493,
    "nom_corrige2":"Patrick Bernier",
    "nom_famille":"Bernier",
    "titre_genre2":"Conseiller",
    "remuneration":"1164",
    "allocation":"582,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1746",
    "ville":"Val-Joli",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1733"
  },
  {
    "ID":5494,
    "nom_corrige2":"Chantal Poulin",
    "nom_famille":"Poulin",
    "titre_genre2":"Conseillère",
    "remuneration":"1656",
    "allocation":"88,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1744",
    "ville":"Saint-Simon-les-Mines",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"643"
  },
  {
    "ID":5495,
    "nom_corrige2":"Marie-Ève Massé",
    "nom_famille":"Massé",
    "titre_genre2":"Conseillère",
    "remuneration":"1159",
    "allocation":"579,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1738",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":5496,
    "nom_corrige2":"Laurie Charrette Perreault",
    "nom_famille":"Charrette Perreault",
    "titre_genre2":"Conseillère",
    "remuneration":"1155",
    "allocation":"578,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1733",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":5497,
    "nom_corrige2":"Mélanie Bessette-Lambert",
    "nom_famille":"Bessette-Lambert",
    "titre_genre2":"Conseillère",
    "remuneration":"1733",
    "allocation":"",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1733",
    "ville":"Saint-François-d'Assise",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"668"
  },
  {
    "ID":5498,
    "nom_corrige2":"Odette Beaudoin",
    "nom_famille":"Beaudoin",
    "titre_genre2":"Conseillère",
    "remuneration":"1150",
    "allocation":"575,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1725",
    "ville":"La Morandière-Rochebaucourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"342"
  },
  {
    "ID":5499,
    "nom_corrige2":"Éric Girard",
    "nom_famille":"Girard",
    "titre_genre2":"Conseiller",
    "remuneration":"1166",
    "allocation":"556,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1722",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5500,
    "nom_corrige2":"Sylvain Falardeau",
    "nom_famille":"Falardeau",
    "titre_genre2":"Conseiller",
    "remuneration":"1139",
    "allocation":"570,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1709",
    "ville":"Belcourt",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"222"
  },
  {
    "ID":5501,
    "nom_corrige2":"Lyne Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseillère",
    "remuneration":"1138",
    "allocation":"569,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1707",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5502,
    "nom_corrige2":"Manon Beaudet",
    "nom_famille":"Beaudet",
    "titre_genre2":"Conseillère",
    "remuneration":"1138",
    "allocation":"569,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1707",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5503,
    "nom_corrige2":"Nancy Guénette",
    "nom_famille":"Guénette",
    "titre_genre2":"Conseillère",
    "remuneration":"1138",
    "allocation":"569,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1707",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5504,
    "nom_corrige2":"Stéphane Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"1138",
    "allocation":"569,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1707",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5505,
    "nom_corrige2":"Sonia Marcotte",
    "nom_famille":"Marcotte",
    "titre_genre2":"Conseillère",
    "remuneration":"1138",
    "allocation":"569,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1707",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5506,
    "nom_corrige2":"Laval Breton",
    "nom_famille":"Breton",
    "titre_genre2":"Conseiller",
    "remuneration":"1126",
    "allocation":"563,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1689",
    "ville":"Saint-Sylvestre",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1057"
  },
  {
    "ID":5507,
    "nom_corrige2":"André Longchamps",
    "nom_famille":"Longchamps",
    "titre_genre2":"Maire",
    "remuneration":"1119",
    "allocation":"560,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1679",
    "ville":"Saint-Éphrem-de-Beauce",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"2566"
  },
  {
    "ID":5508,
    "nom_corrige2":"Carla Brown",
    "nom_famille":"Brown",
    "titre_genre2":"Conseillère",
    "remuneration":"1107",
    "allocation":"554,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1661",
    "ville":"Rosemère",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"14205"
  },
  {
    "ID":5509,
    "nom_corrige2":"Vicky Gauvin",
    "nom_famille":"Gauvin",
    "titre_genre2":"Conseillère",
    "remuneration":"1100",
    "allocation":"550,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1650",
    "ville":"Sainte-Marguerite-Marie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"181"
  },
  {
    "ID":5510,
    "nom_corrige2":"Martial Bellay",
    "nom_famille":"Bellay",
    "titre_genre2":"Conseiller",
    "remuneration":"1219",
    "allocation":"398,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1617",
    "ville":"La Visitation-de-l'Île-Dupas",
    "arrondissement":"",
    "region_adm":"Lanaudière",
    "population":"707"
  },
  {
    "ID":5511,
    "nom_corrige2":"Robert Corriveau",
    "nom_famille":"Corriveau",
    "titre_genre2":"Conseiller",
    "remuneration":"1075",
    "allocation":"538,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1613",
    "ville":"Saint-Edmond-de-Grantham",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"832"
  },
  {
    "ID":5512,
    "nom_corrige2":"Allan Stanley",
    "nom_famille":"Stanley",
    "titre_genre2":"Conseiller",
    "remuneration":"1069",
    "allocation":"524,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1593",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":5513,
    "nom_corrige2":"Geneviève Dubuc",
    "nom_famille":"Dubuc",
    "titre_genre2":"Conseillère",
    "remuneration":"1031",
    "allocation":"516,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1547",
    "ville":"Saint-Sauveur",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"12130"
  },
  {
    "ID":5514,
    "nom_corrige2":"Gervais Landry",
    "nom_famille":"Landry",
    "titre_genre2":"Conseiller",
    "remuneration":"1030",
    "allocation":"515,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1545",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5515,
    "nom_corrige2":"Pascale-Sophie Bélanger",
    "nom_famille":"Bélanger",
    "titre_genre2":"Conseillère",
    "remuneration":"1009",
    "allocation":"500,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1509",
    "ville":"Denholm",
    "arrondissement":"",
    "region_adm":"Outaouais",
    "population":"581"
  },
  {
    "ID":5516,
    "nom_corrige2":"Steve Filteau",
    "nom_famille":"Filteau",
    "titre_genre2":"Conseillère",
    "remuneration":"989,00$",
    "allocation":"495,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 484,00$",
    "ville":"Rémigny",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"306"
  },
  {
    "ID":5517,
    "nom_corrige2":"Jacques Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseiller",
    "remuneration":"980,00$",
    "allocation":"490,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 470,00$",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5518,
    "nom_corrige2":"Hélène Cimon",
    "nom_famille":"Cimon",
    "titre_genre2":"Conseillère",
    "remuneration":"972,00$",
    "allocation":"486,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 458,00$",
    "ville":"Saint-Jean-de-Brébeuf",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"364"
  },
  {
    "ID":5519,
    "nom_corrige2":"Mélanie Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseillère",
    "remuneration":"965,00$",
    "allocation":"483,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 448,00$",
    "ville":"Notre-Dame-des-Neiges",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"1175"
  },
  {
    "ID":5520,
    "nom_corrige2":"Deave D'Astous",
    "nom_famille":"D'Astous",
    "titre_genre2":"Conseiller",
    "remuneration":"958,00$",
    "allocation":"479,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 437,00$",
    "ville":"Saint-Eugène-de-Ladrière",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"414"
  },
  {
    "ID":5521,
    "nom_corrige2":"Jacques Inkel",
    "nom_famille":"Inkel",
    "titre_genre2":"Conseiller",
    "remuneration":"936,00$",
    "allocation":"468,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 404,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5522,
    "nom_corrige2":"Nathalie Lacasse",
    "nom_famille":"Lacasse",
    "titre_genre2":"Conseillère",
    "remuneration":"936,00$",
    "allocation":"468,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 404,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5523,
    "nom_corrige2":"Claude Desbiens",
    "nom_famille":"Desbiens",
    "titre_genre2":"Conseiller",
    "remuneration":"936,00$",
    "allocation":"468,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 404,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5524,
    "nom_corrige2":"Amélie Croteau",
    "nom_famille":"Croteau",
    "titre_genre2":"Conseillère",
    "remuneration":"911,00$",
    "allocation":"455,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 366,00$",
    "ville":"Chesterville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"895"
  },
  {
    "ID":5525,
    "nom_corrige2":"Diane Boivin",
    "nom_famille":"Boivin",
    "titre_genre2":"Conseillère",
    "remuneration":"888,00$",
    "allocation":"444,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 332,00$",
    "ville":"Orford",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"5509"
  },
  {
    "ID":5526,
    "nom_corrige2":"Francis Gaudreau",
    "nom_famille":"Gaudreau",
    "titre_genre2":"Conseiller",
    "remuneration":"883,00$",
    "allocation":"441,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 324,00$",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5527,
    "nom_corrige2":"Jacques Pelchat",
    "nom_famille":"Pelchat",
    "titre_genre2":"Conseiller",
    "remuneration":"917,00$",
    "allocation":"399,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 316,00$",
    "ville":"Inverness",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"972"
  },
  {
    "ID":5528,
    "nom_corrige2":"Cynthia Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"415,00$",
    "allocation":"829,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 244,00$",
    "ville":"Saint-Léon-de-Standon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1039"
  },
  {
    "ID":5529,
    "nom_corrige2":"Manon Bourdages",
    "nom_famille":"Bourdages",
    "titre_genre2":"Conseillère",
    "remuneration":"826,00$",
    "allocation":"414,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 240,00$",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":5530,
    "nom_corrige2":"Maurice Chicoine",
    "nom_famille":"Chicoine",
    "titre_genre2":"Conseiller",
    "remuneration":"826,00$",
    "allocation":"413,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 239,00$",
    "ville":"Bonaventure",
    "arrondissement":"",
    "region_adm":"Gaspésie–Îles-de-la-Madeleine",
    "population":"2758"
  },
  {
    "ID":5531,
    "nom_corrige2":"Sylvain Archambault",
    "nom_famille":"Archambault",
    "titre_genre2":"Conseiller",
    "remuneration":"825,00$",
    "allocation":"412,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 237,00$",
    "ville":"Venise-en-Québec",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"2293"
  },
  {
    "ID":5532,
    "nom_corrige2":"Nathalie Picard",
    "nom_famille":"Picard",
    "titre_genre2":"Mairesse",
    "remuneration":"616,00$",
    "allocation":"308,00$",
    "remuneration2":"200,00$",
    "allocation2":"100,00$",
    "total":"1 224,00$",
    "ville":"Sainte-Hélène-de-Kamouraska",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"896"
  },
  {
    "ID":5533,
    "nom_corrige2":"Steeve Raby",
    "nom_famille":"Raby",
    "titre_genre2":"Conseiller",
    "remuneration":"813,00$",
    "allocation":"406,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 219,00$",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5534,
    "nom_corrige2":"Richard Labrecque",
    "nom_famille":"Labrecque",
    "titre_genre2":"Conseiller",
    "remuneration":"794,00$",
    "allocation":"397,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 191,00$",
    "ville":"Saint-Romain",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"722"
  },
  {
    "ID":5535,
    "nom_corrige2":"Marc-André Dubreuil",
    "nom_famille":"Dubreuil",
    "titre_genre2":"Conseiller",
    "remuneration":"773,00$",
    "allocation":"386,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 159,00$",
    "ville":"Roxton Falls",
    "arrondissement":"",
    "region_adm":"Montérégie",
    "population":"1377"
  },
  {
    "ID":5536,
    "nom_corrige2":"Steven R. Deshaies",
    "nom_famille":"R. Deshaies",
    "titre_genre2":"Conseiller",
    "remuneration":"777,00$",
    "allocation":"371,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 148,00$",
    "ville":"Maddington Falls",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"449"
  },
  {
    "ID":5537,
    "nom_corrige2":"Léopold Leduc",
    "nom_famille":"Leduc",
    "titre_genre2":"Conseiller",
    "remuneration":"759,00$",
    "allocation":"348,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 107,00$",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5538,
    "nom_corrige2":"Alexandre Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"711,00$",
    "allocation":"356,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 067,00$",
    "ville":"Saint-Éloi",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"327"
  },
  {
    "ID":5539,
    "nom_corrige2":"Gaétan Lavigne",
    "nom_famille":"Lavigne",
    "titre_genre2":"Conseiller",
    "remuneration":"702,00$",
    "allocation":"351,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 053,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5540,
    "nom_corrige2":"Marc Delorme",
    "nom_famille":"Delorme",
    "titre_genre2":"Conseiller",
    "remuneration":"702,00$",
    "allocation":"351,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 053,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5541,
    "nom_corrige2":"William Blue",
    "nom_famille":"Blue",
    "titre_genre2":"Conseiller",
    "remuneration":"702,00$",
    "allocation":"351,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 053,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5542,
    "nom_corrige2":"Caroline Bouchard",
    "nom_famille":"Bouchard",
    "titre_genre2":"Conseillère",
    "remuneration":"667,00$",
    "allocation":"333,00$",
    "remuneration2":"50,00$",
    "allocation2":"0",
    "total":"1 050,00$",
    "ville":"Saint-Zéphirin-de-Courval",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"716"
  },
  {
    "ID":5543,
    "nom_corrige2":"Hélène Vézina",
    "nom_famille":"Vézina",
    "titre_genre2":"Conseillère",
    "remuneration":"687,00$",
    "allocation":"344,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 031,00$",
    "ville":"Abercorn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"356"
  },
  {
    "ID":5544,
    "nom_corrige2":"René Godbout",
    "nom_famille":"Godbout",
    "titre_genre2":"Conseiller",
    "remuneration":"687,00$",
    "allocation":"344,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 031,00$",
    "ville":"Saint-Philémon",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"703"
  },
  {
    "ID":5545,
    "nom_corrige2":"Sandra Barrette",
    "nom_famille":"Barrette",
    "titre_genre2":"Conseillère",
    "remuneration":"679,00$",
    "allocation":"340,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"1 019,00$",
    "ville":"Saint-Bruno-de-Guigues",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1190"
  },
  {
    "ID":5546,
    "nom_corrige2":"Clémence Lapointe",
    "nom_famille":"Lapointe",
    "titre_genre2":"Conseillère",
    "remuneration":"761,00$",
    "allocation":"231,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"992,00$",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":5547,
    "nom_corrige2":"Denis Fortier",
    "nom_famille":"Fortier",
    "titre_genre2":"Conseiller",
    "remuneration":"659,00$",
    "allocation":"329,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"988,00$",
    "ville":"Saint-Malachie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"1755"
  },
  {
    "ID":5548,
    "nom_corrige2":"Germain Boutin",
    "nom_famille":"Boutin",
    "titre_genre2":"Conseiller",
    "remuneration":"640,00$",
    "allocation":"314,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"954,00$",
    "ville":"Newport",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"711"
  },
  {
    "ID":5549,
    "nom_corrige2":"Charles Therrien",
    "nom_famille":"Therrien",
    "titre_genre2":"Conseiller",
    "remuneration":"611,00$",
    "allocation":"231,00$",
    "remuneration2":"100,00$",
    "allocation2":"0",
    "total":"942,00$",
    "ville":"Saint-Cyprien",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"469"
  },
  {
    "ID":5550,
    "nom_corrige2":"Stéphane Marcoux",
    "nom_famille":"Marcoux",
    "titre_genre2":"Conseiller",
    "remuneration":"612,00$",
    "allocation":"306,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"918,00$",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":5551,
    "nom_corrige2":"Marie-Andrée Lapierre",
    "nom_famille":"Lapierre",
    "titre_genre2":"Conseillère",
    "remuneration":"602,00$",
    "allocation":"301,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"903,00$",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5552,
    "nom_corrige2":"Jacques Caron",
    "nom_famille":"Caron",
    "titre_genre2":"Conseiller",
    "remuneration":"589,00$",
    "allocation":"294,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"883,00$",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5553,
    "nom_corrige2":"Yves Laroche",
    "nom_famille":"Laroche",
    "titre_genre2":"Conseiller",
    "remuneration":"585,00$",
    "allocation":"293,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"878,00$",
    "ville":"Saint-Augustin-de-Woburn",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"679"
  },
  {
    "ID":5554,
    "nom_corrige2":"Francis Cliche",
    "nom_famille":"Cliche",
    "titre_genre2":"Conseiller",
    "remuneration":"572,00$",
    "allocation":"286,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"858,00$",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1135"
  },
  {
    "ID":5555,
    "nom_corrige2":"Joceline d'Amour",
    "nom_famille":"d'Amour",
    "titre_genre2":"Conseillère",
    "remuneration":"564,00$",
    "allocation":"262,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"826,00$",
    "ville":"Saint-Denis-De La Bouteillerie",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"517"
  },
  {
    "ID":5556,
    "nom_corrige2":"André Martineau",
    "nom_famille":"Martineau",
    "titre_genre2":"Conseiller",
    "remuneration":"609,00$",
    "allocation":"194,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"803,00$",
    "ville":"Bonsecours",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"657"
  },
  {
    "ID":5557,
    "nom_corrige2":"Gilles Lévesque",
    "nom_famille":"Lévesque",
    "titre_genre2":"Conseiller",
    "remuneration":"666,00$",
    "allocation":"137,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"803,00$",
    "ville":"Notre-Dame-des-Bois",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1165"
  },
  {
    "ID":5558,
    "nom_corrige2":"Marcel Lebel",
    "nom_famille":"Lebel",
    "titre_genre2":"Conseiller",
    "remuneration":"514,00$",
    "allocation":"257,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"771,00$",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5559,
    "nom_corrige2":"James Kingston",
    "nom_famille":"Kingston",
    "titre_genre2":"Conseiller",
    "remuneration":"504,00$",
    "allocation":"252,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"756,00$",
    "ville":"Fortierville",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"697"
  },
  {
    "ID":5560,
    "nom_corrige2":"François Gagnon",
    "nom_famille":"Gagnon",
    "titre_genre2":"Conseiller",
    "remuneration":"500,00$",
    "allocation":"250,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"750,00$",
    "ville":"Sainte-Aurélie",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"896"
  },
  {
    "ID":5561,
    "nom_corrige2":"Kenneth Mann",
    "nom_famille":"Mann",
    "titre_genre2":"Conseiller",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5562,
    "nom_corrige2":"Kimberly Lamoureux",
    "nom_famille":"Lamoureux",
    "titre_genre2":"Conseillère",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5563,
    "nom_corrige2":"Marc Frédette",
    "nom_famille":"Frédette",
    "titre_genre2":"Conseiller",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5564,
    "nom_corrige2":"Marie-Hélène LeMarbre",
    "nom_famille":"LeMarbre",
    "titre_genre2":"Conseillère",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5565,
    "nom_corrige2":"Michael Jake",
    "nom_famille":"Jake",
    "titre_genre2":"Conseiller",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5566,
    "nom_corrige2":"Stephen LLoyd",
    "nom_famille":"LLoyd",
    "titre_genre2":"Conseiller",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Barkmere",
    "arrondissement":"",
    "region_adm":"Laurentides",
    "population":"84"
  },
  {
    "ID":5567,
    "nom_corrige2":"Daniel St-Aurnaud",
    "nom_famille":"St-Aurnaud",
    "titre_genre2":"Conseiller",
    "remuneration":"490,00$",
    "allocation":"245,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"735,00$",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5568,
    "nom_corrige2":"Véronique Dubé",
    "nom_famille":"Dubé",
    "titre_genre2":"Conseillère",
    "remuneration":"397,00$",
    "allocation":"184,00$",
    "remuneration2":"101,00$",
    "allocation2":"51,00$",
    "total":"733,00$",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5569,
    "nom_corrige2":"Lorie Gosselin Côté",
    "nom_famille":"Gosselin Côté",
    "titre_genre2":"Conseillère",
    "remuneration":"481,00$",
    "allocation":"241,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"722,00$",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5570,
    "nom_corrige2":"Clément Fillion",
    "nom_famille":"Fillion",
    "titre_genre2":"Conseiller",
    "remuneration":"481,00$",
    "allocation":"241,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"722,00$",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5571,
    "nom_corrige2":"Jacques Bruneau",
    "nom_famille":"Bruneau",
    "titre_genre2":"Conseiller",
    "remuneration":"481,00$",
    "allocation":"241,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"722,00$",
    "ville":"Saint-Nazaire-de-Dorchester",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"332"
  },
  {
    "ID":5572,
    "nom_corrige2":"Valérie Dufour",
    "nom_famille":"Dufour",
    "titre_genre2":"Conseillère",
    "remuneration":"425,00$",
    "allocation":"213,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"638,00$",
    "ville":"Val-d'Or",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"33214"
  },
  {
    "ID":5573,
    "nom_corrige2":"Louise Bégin",
    "nom_famille":"Bégin",
    "titre_genre2":"Conseillère",
    "remuneration":"384,00$",
    "allocation":"192,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"576,00$",
    "ville":"Rapide-Danseur",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"380"
  },
  {
    "ID":5574,
    "nom_corrige2":"David Auclair",
    "nom_famille":"Auclair",
    "titre_genre2":"Maire",
    "remuneration":"358,00$",
    "allocation":"179,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"537,00$",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":5575,
    "nom_corrige2":"Marilyne Gendron",
    "nom_famille":"Gendron",
    "titre_genre2":"Conseillère",
    "remuneration":"335,00$",
    "allocation":"168,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"503,00$",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":5576,
    "nom_corrige2":"Jean Martel",
    "nom_famille":"Martel",
    "titre_genre2":"Conseiller",
    "remuneration":"335,00$",
    "allocation":"168,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"503,00$",
    "ville":"Westbury",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"1158"
  },
  {
    "ID":5577,
    "nom_corrige2":"Yannis Deschênes",
    "nom_famille":"Deschênes",
    "titre_genre2":"Conseiller",
    "remuneration":"306,00$",
    "allocation":"153,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"459,00$",
    "ville":"Villeroy",
    "arrondissement":"",
    "region_adm":"Centre-du-Québec",
    "population":"519"
  },
  {
    "ID":5578,
    "nom_corrige2":"Caroline Pelchat",
    "nom_famille":"Pelchat",
    "titre_genre2":"Conseillère",
    "remuneration":"294,00$",
    "allocation":"147,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"441,00$",
    "ville":"Notre-Dame-du-Rosaire",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"394"
  },
  {
    "ID":5579,
    "nom_corrige2":"Mylène Gill",
    "nom_famille":"Gill",
    "titre_genre2":"Conseillère",
    "remuneration":"271,00$",
    "allocation":"136,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"407,00$",
    "ville":"Sainte-Euphémie-sur-Rivière-du-Sud",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"360"
  },
  {
    "ID":5580,
    "nom_corrige2":"Guy Gignac",
    "nom_famille":"Gignac",
    "titre_genre2":"Conseiller",
    "remuneration":"256,00$",
    "allocation":"128,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"384,00$",
    "ville":"Barraute",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"1914"
  },
  {
    "ID":5581,
    "nom_corrige2":"Tania Rouillier",
    "nom_famille":"Rouillier",
    "titre_genre2":"Conseillère",
    "remuneration":"245,00$",
    "allocation":"123,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"368,00$",
    "ville":"Saint-Édouard-de-Fabre",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"674"
  },
  {
    "ID":5582,
    "nom_corrige2":"Christian St-Pierre",
    "nom_famille":"St-Pierre",
    "titre_genre2":"Conseiller",
    "remuneration":"237,00$",
    "allocation":"119,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"356,00$",
    "ville":"Saint-Valérien",
    "arrondissement":"",
    "region_adm":"Bas-Saint-Laurent",
    "population":"959"
  },
  {
    "ID":5583,
    "nom_corrige2":"Chantal Asselin",
    "nom_famille":"Asselin",
    "titre_genre2":"Conseillère",
    "remuneration":"190,00$",
    "allocation":"95,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"285,00$",
    "ville":"Champneuf",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"91"
  },
  {
    "ID":5584,
    "nom_corrige2":"Luc Bédard",
    "nom_famille":"Bédard",
    "titre_genre2":"Conseiller",
    "remuneration":"161,00$",
    "allocation":"81,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"242,00$",
    "ville":"Chazel",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"275"
  },
  {
    "ID":5585,
    "nom_corrige2":"Marie-Andrée Vanzeveren",
    "nom_famille":"Vanzeveren",
    "titre_genre2":"Conseillère",
    "remuneration":"156,00$",
    "allocation":"78,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"234,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5586,
    "nom_corrige2":"Luc Dallaire",
    "nom_famille":"Dallaire",
    "titre_genre2":"Conseiller",
    "remuneration":"156,00$",
    "allocation":"78,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"234,00$",
    "ville":"Saint-Venant-de-Paquette",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"78"
  },
  {
    "ID":5587,
    "nom_corrige2":"Nathaniel Côté",
    "nom_famille":"Côté",
    "titre_genre2":"Conseiller",
    "remuneration":"123,00$",
    "allocation":"61,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"184,00$",
    "ville":"Sainte-Sabine",
    "arrondissement":"",
    "region_adm":"Chaudière-Appalaches",
    "population":"369"
  },
  {
    "ID":5588,
    "nom_corrige2":"Nicolas Berger",
    "nom_famille":"Berger",
    "titre_genre2":"Conseiller",
    "remuneration":"106,00$",
    "allocation":"53,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"159,00$",
    "ville":"Saint-Étienne-de-Bolton",
    "arrondissement":"",
    "region_adm":"Estrie",
    "population":"892"
  },
  {
    "ID":5589,
    "nom_corrige2":"Annie Gauthier",
    "nom_famille":"Gauthier",
    "titre_genre2":"Conseillère",
    "remuneration":"51,00$",
    "allocation":"25,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"76,00$",
    "ville":"Latulipe-et-Gaboury",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"324"
  },
  {
    "ID":5590,
    "nom_corrige2":"Christine Doré",
    "nom_famille":"Doré",
    "titre_genre2":"Conseillère",
    "remuneration":"30,00$",
    "allocation":"10,00$",
    "remuneration2":"0",
    "allocation2":"0",
    "total":"40,00$",
    "ville":"Sainte-Germaine-Boulé",
    "arrondissement":"",
    "region_adm":"Abitibi-Témiscamingue",
    "population":"945"
  }
]